function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea9d4"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea9d4"] = parcelRequire;
}
parcelRequire.register("iDBKR", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d91927d2c860a1b9$export$ffb0004e005737fa; }, function (v) { return $d91927d2c860a1b9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d91927d2c860a1b9$export$34b9dba7ce09269b; }, function (v) { return $d91927d2c860a1b9$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d91927d2c860a1b9$export$25062201e9e25d76; }, function (v) { return $d91927d2c860a1b9$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d91927d2c860a1b9$export$ffb0004e005737fa;
var $d91927d2c860a1b9$export$34b9dba7ce09269b;
var $d91927d2c860a1b9$export$25062201e9e25d76;
"use strict";

var $6P6dz = parcelRequire("6P6dz");
var $d91927d2c860a1b9$var$k = Symbol.for("react.element"), $d91927d2c860a1b9$var$l = Symbol.for("react.fragment"), $d91927d2c860a1b9$var$m = Object.prototype.hasOwnProperty, $d91927d2c860a1b9$var$n = $6P6dz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d91927d2c860a1b9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d91927d2c860a1b9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d91927d2c860a1b9$var$m.call(a, b) && !$d91927d2c860a1b9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d91927d2c860a1b9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d91927d2c860a1b9$var$n.current
    };
}
$d91927d2c860a1b9$export$ffb0004e005737fa = $d91927d2c860a1b9$var$l;
$d91927d2c860a1b9$export$34b9dba7ce09269b = $d91927d2c860a1b9$var$q;
$d91927d2c860a1b9$export$25062201e9e25d76 = $d91927d2c860a1b9$var$q;

});
parcelRequire.register("6P6dz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7Etxw"));

});
parcelRequire.register("7Etxw", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $59232ec5f3cee43b$export$dca3b0875bd9a954; }, function (v) { return $59232ec5f3cee43b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $59232ec5f3cee43b$export$16fa2f45be04daa8; }, function (v) { return $59232ec5f3cee43b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $59232ec5f3cee43b$export$ffb0004e005737fa; }, function (v) { return $59232ec5f3cee43b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $59232ec5f3cee43b$export$e2c29f18771995cb; }, function (v) { return $59232ec5f3cee43b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $59232ec5f3cee43b$export$221d75b3f55bb0bd; }, function (v) { return $59232ec5f3cee43b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $59232ec5f3cee43b$export$5f8d39834fd61797; }, function (v) { return $59232ec5f3cee43b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $59232ec5f3cee43b$export$74bf444e3cd11ea5; }, function (v) { return $59232ec5f3cee43b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $59232ec5f3cee43b$export$ae55be85d98224ed; }, function (v) { return $59232ec5f3cee43b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $59232ec5f3cee43b$export$e530037191fcd5d7; }, function (v) { return $59232ec5f3cee43b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $59232ec5f3cee43b$export$fd42f52fd3ae1109; }, function (v) { return $59232ec5f3cee43b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $59232ec5f3cee43b$export$c8a8987d4410bf2d; }, function (v) { return $59232ec5f3cee43b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $59232ec5f3cee43b$export$d38cd72104c1f0e9; }, function (v) { return $59232ec5f3cee43b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $59232ec5f3cee43b$export$7d1e3a5e95ceca43; }, function (v) { return $59232ec5f3cee43b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $59232ec5f3cee43b$export$257a8862b851cb5b; }, function (v) { return $59232ec5f3cee43b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $59232ec5f3cee43b$export$a8257692ac88316c; }, function (v) { return $59232ec5f3cee43b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $59232ec5f3cee43b$export$488013bae63b21da; }, function (v) { return $59232ec5f3cee43b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $59232ec5f3cee43b$export$7c73462e0d25e514; }, function (v) { return $59232ec5f3cee43b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $59232ec5f3cee43b$export$7568632d0d33d16d; }, function (v) { return $59232ec5f3cee43b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $59232ec5f3cee43b$export$88948ce120ea2619; }, function (v) { return $59232ec5f3cee43b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $59232ec5f3cee43b$export$35808ee640e87ca7; }, function (v) { return $59232ec5f3cee43b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $59232ec5f3cee43b$export$fae74005e78b1a27; }, function (v) { return $59232ec5f3cee43b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $59232ec5f3cee43b$export$dc8fbce3eb94dc1e; }, function (v) { return $59232ec5f3cee43b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $59232ec5f3cee43b$export$6a7bc4e911dc01cf; }, function (v) { return $59232ec5f3cee43b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $59232ec5f3cee43b$export$6d9c69b0de29b591; }, function (v) { return $59232ec5f3cee43b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $59232ec5f3cee43b$export$f680877a34711e37; }, function (v) { return $59232ec5f3cee43b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $59232ec5f3cee43b$export$d5a552a76deda3c2; }, function (v) { return $59232ec5f3cee43b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $59232ec5f3cee43b$export$aaabe4eda9ed9969; }, function (v) { return $59232ec5f3cee43b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $59232ec5f3cee43b$export$e5c5a5f917a5871c; }, function (v) { return $59232ec5f3cee43b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $59232ec5f3cee43b$export$1538c33de8887b59; }, function (v) { return $59232ec5f3cee43b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $59232ec5f3cee43b$export$13e3392192263954; }, function (v) { return $59232ec5f3cee43b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $59232ec5f3cee43b$export$b8f5890fc79d6aca; }, function (v) { return $59232ec5f3cee43b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $59232ec5f3cee43b$export$60241385465d0a34; }, function (v) { return $59232ec5f3cee43b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $59232ec5f3cee43b$export$306c0aa65ff9ec16; }, function (v) { return $59232ec5f3cee43b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $59232ec5f3cee43b$export$7b286972b8d8ccbf; }, function (v) { return $59232ec5f3cee43b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $59232ec5f3cee43b$export$83d89fbfd8236492; }, function (v) { return $59232ec5f3cee43b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $59232ec5f3cee43b$export$dca3b0875bd9a954;
var $59232ec5f3cee43b$export$16fa2f45be04daa8;
var $59232ec5f3cee43b$export$ffb0004e005737fa;
var $59232ec5f3cee43b$export$e2c29f18771995cb;
var $59232ec5f3cee43b$export$221d75b3f55bb0bd;
var $59232ec5f3cee43b$export$5f8d39834fd61797;
var $59232ec5f3cee43b$export$74bf444e3cd11ea5;
var $59232ec5f3cee43b$export$ae55be85d98224ed;
var $59232ec5f3cee43b$export$e530037191fcd5d7;
var $59232ec5f3cee43b$export$fd42f52fd3ae1109;
var $59232ec5f3cee43b$export$c8a8987d4410bf2d;
var $59232ec5f3cee43b$export$d38cd72104c1f0e9;
var $59232ec5f3cee43b$export$7d1e3a5e95ceca43;
var $59232ec5f3cee43b$export$257a8862b851cb5b;
var $59232ec5f3cee43b$export$a8257692ac88316c;
var $59232ec5f3cee43b$export$488013bae63b21da;
var $59232ec5f3cee43b$export$7c73462e0d25e514;
var $59232ec5f3cee43b$export$7568632d0d33d16d;
var $59232ec5f3cee43b$export$88948ce120ea2619;
var $59232ec5f3cee43b$export$35808ee640e87ca7;
var $59232ec5f3cee43b$export$fae74005e78b1a27;
var $59232ec5f3cee43b$export$dc8fbce3eb94dc1e;
var $59232ec5f3cee43b$export$6a7bc4e911dc01cf;
var $59232ec5f3cee43b$export$6d9c69b0de29b591;
var $59232ec5f3cee43b$export$f680877a34711e37;
var $59232ec5f3cee43b$export$d5a552a76deda3c2;
var $59232ec5f3cee43b$export$aaabe4eda9ed9969;
var $59232ec5f3cee43b$export$e5c5a5f917a5871c;
var $59232ec5f3cee43b$export$1538c33de8887b59;
var $59232ec5f3cee43b$export$13e3392192263954;
var $59232ec5f3cee43b$export$b8f5890fc79d6aca;
var $59232ec5f3cee43b$export$60241385465d0a34;
var $59232ec5f3cee43b$export$306c0aa65ff9ec16;
var $59232ec5f3cee43b$export$7b286972b8d8ccbf;
var $59232ec5f3cee43b$export$83d89fbfd8236492;
"use strict";
var $59232ec5f3cee43b$var$l = Symbol.for("react.element"), $59232ec5f3cee43b$var$n = Symbol.for("react.portal"), $59232ec5f3cee43b$var$p = Symbol.for("react.fragment"), $59232ec5f3cee43b$var$q = Symbol.for("react.strict_mode"), $59232ec5f3cee43b$var$r = Symbol.for("react.profiler"), $59232ec5f3cee43b$var$t = Symbol.for("react.provider"), $59232ec5f3cee43b$var$u = Symbol.for("react.context"), $59232ec5f3cee43b$var$v = Symbol.for("react.forward_ref"), $59232ec5f3cee43b$var$w = Symbol.for("react.suspense"), $59232ec5f3cee43b$var$x = Symbol.for("react.memo"), $59232ec5f3cee43b$var$y = Symbol.for("react.lazy"), $59232ec5f3cee43b$var$z = Symbol.iterator;
function $59232ec5f3cee43b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $59232ec5f3cee43b$var$z && a[$59232ec5f3cee43b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $59232ec5f3cee43b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $59232ec5f3cee43b$var$C = Object.assign, $59232ec5f3cee43b$var$D = {};
function $59232ec5f3cee43b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $59232ec5f3cee43b$var$D;
    this.updater = e || $59232ec5f3cee43b$var$B;
}
$59232ec5f3cee43b$var$E.prototype.isReactComponent = {};
$59232ec5f3cee43b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$59232ec5f3cee43b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $59232ec5f3cee43b$var$F() {}
$59232ec5f3cee43b$var$F.prototype = $59232ec5f3cee43b$var$E.prototype;
function $59232ec5f3cee43b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $59232ec5f3cee43b$var$D;
    this.updater = e || $59232ec5f3cee43b$var$B;
}
var $59232ec5f3cee43b$var$H = $59232ec5f3cee43b$var$G.prototype = new $59232ec5f3cee43b$var$F;
$59232ec5f3cee43b$var$H.constructor = $59232ec5f3cee43b$var$G;
$59232ec5f3cee43b$var$C($59232ec5f3cee43b$var$H, $59232ec5f3cee43b$var$E.prototype);
$59232ec5f3cee43b$var$H.isPureReactComponent = !0;
var $59232ec5f3cee43b$var$I = Array.isArray, $59232ec5f3cee43b$var$J = Object.prototype.hasOwnProperty, $59232ec5f3cee43b$var$K = {
    current: null
}, $59232ec5f3cee43b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $59232ec5f3cee43b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$59232ec5f3cee43b$var$J.call(b, d) && !$59232ec5f3cee43b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $59232ec5f3cee43b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $59232ec5f3cee43b$var$K.current
    };
}
function $59232ec5f3cee43b$var$N(a, b) {
    return {
        $$typeof: $59232ec5f3cee43b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $59232ec5f3cee43b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $59232ec5f3cee43b$var$l;
}
function $59232ec5f3cee43b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $59232ec5f3cee43b$var$P = /\/+/g;
function $59232ec5f3cee43b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $59232ec5f3cee43b$var$escape("" + a.key) : b.toString(36);
}
function $59232ec5f3cee43b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $59232ec5f3cee43b$var$l:
                case $59232ec5f3cee43b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $59232ec5f3cee43b$var$Q(h, 0) : d, $59232ec5f3cee43b$var$I(c) ? (e = "", null != a && (e = a.replace($59232ec5f3cee43b$var$P, "$&/") + "/"), $59232ec5f3cee43b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($59232ec5f3cee43b$var$O(c) && (c = $59232ec5f3cee43b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($59232ec5f3cee43b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($59232ec5f3cee43b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $59232ec5f3cee43b$var$Q(k, g);
        h += $59232ec5f3cee43b$var$R(k, b, e, f, c);
    }
    else if (f = $59232ec5f3cee43b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $59232ec5f3cee43b$var$Q(k, g++), h += $59232ec5f3cee43b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $59232ec5f3cee43b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $59232ec5f3cee43b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $59232ec5f3cee43b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $59232ec5f3cee43b$var$U = {
    current: null
}, $59232ec5f3cee43b$var$V = {
    transition: null
}, $59232ec5f3cee43b$var$W = {
    ReactCurrentDispatcher: $59232ec5f3cee43b$var$U,
    ReactCurrentBatchConfig: $59232ec5f3cee43b$var$V,
    ReactCurrentOwner: $59232ec5f3cee43b$var$K
};
$59232ec5f3cee43b$export$dca3b0875bd9a954 = {
    map: $59232ec5f3cee43b$var$S,
    forEach: function(a, b, e) {
        $59232ec5f3cee43b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $59232ec5f3cee43b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $59232ec5f3cee43b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$59232ec5f3cee43b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$59232ec5f3cee43b$export$16fa2f45be04daa8 = $59232ec5f3cee43b$var$E;
$59232ec5f3cee43b$export$ffb0004e005737fa = $59232ec5f3cee43b$var$p;
$59232ec5f3cee43b$export$e2c29f18771995cb = $59232ec5f3cee43b$var$r;
$59232ec5f3cee43b$export$221d75b3f55bb0bd = $59232ec5f3cee43b$var$G;
$59232ec5f3cee43b$export$5f8d39834fd61797 = $59232ec5f3cee43b$var$q;
$59232ec5f3cee43b$export$74bf444e3cd11ea5 = $59232ec5f3cee43b$var$w;
$59232ec5f3cee43b$export$ae55be85d98224ed = $59232ec5f3cee43b$var$W;
$59232ec5f3cee43b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $59232ec5f3cee43b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $59232ec5f3cee43b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$59232ec5f3cee43b$var$J.call(b, f) && !$59232ec5f3cee43b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $59232ec5f3cee43b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$59232ec5f3cee43b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $59232ec5f3cee43b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $59232ec5f3cee43b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$59232ec5f3cee43b$export$c8a8987d4410bf2d = $59232ec5f3cee43b$var$M;
$59232ec5f3cee43b$export$d38cd72104c1f0e9 = function(a) {
    var b = $59232ec5f3cee43b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$59232ec5f3cee43b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$59232ec5f3cee43b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $59232ec5f3cee43b$var$v,
        render: a
    };
};
$59232ec5f3cee43b$export$a8257692ac88316c = $59232ec5f3cee43b$var$O;
$59232ec5f3cee43b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $59232ec5f3cee43b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $59232ec5f3cee43b$var$T
    };
};
$59232ec5f3cee43b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $59232ec5f3cee43b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$59232ec5f3cee43b$export$7568632d0d33d16d = function(a) {
    var b = $59232ec5f3cee43b$var$V.transition;
    $59232ec5f3cee43b$var$V.transition = {};
    try {
        a();
    } finally{
        $59232ec5f3cee43b$var$V.transition = b;
    }
};
$59232ec5f3cee43b$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$59232ec5f3cee43b$export$35808ee640e87ca7 = function(a, b) {
    return $59232ec5f3cee43b$var$U.current.useCallback(a, b);
};
$59232ec5f3cee43b$export$fae74005e78b1a27 = function(a) {
    return $59232ec5f3cee43b$var$U.current.useContext(a);
};
$59232ec5f3cee43b$export$dc8fbce3eb94dc1e = function() {};
$59232ec5f3cee43b$export$6a7bc4e911dc01cf = function(a) {
    return $59232ec5f3cee43b$var$U.current.useDeferredValue(a);
};
$59232ec5f3cee43b$export$6d9c69b0de29b591 = function(a, b) {
    return $59232ec5f3cee43b$var$U.current.useEffect(a, b);
};
$59232ec5f3cee43b$export$f680877a34711e37 = function() {
    return $59232ec5f3cee43b$var$U.current.useId();
};
$59232ec5f3cee43b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $59232ec5f3cee43b$var$U.current.useImperativeHandle(a, b, e);
};
$59232ec5f3cee43b$export$aaabe4eda9ed9969 = function(a, b) {
    return $59232ec5f3cee43b$var$U.current.useInsertionEffect(a, b);
};
$59232ec5f3cee43b$export$e5c5a5f917a5871c = function(a, b) {
    return $59232ec5f3cee43b$var$U.current.useLayoutEffect(a, b);
};
$59232ec5f3cee43b$export$1538c33de8887b59 = function(a, b) {
    return $59232ec5f3cee43b$var$U.current.useMemo(a, b);
};
$59232ec5f3cee43b$export$13e3392192263954 = function(a, b, e) {
    return $59232ec5f3cee43b$var$U.current.useReducer(a, b, e);
};
$59232ec5f3cee43b$export$b8f5890fc79d6aca = function(a) {
    return $59232ec5f3cee43b$var$U.current.useRef(a);
};
$59232ec5f3cee43b$export$60241385465d0a34 = function(a) {
    return $59232ec5f3cee43b$var$U.current.useState(a);
};
$59232ec5f3cee43b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $59232ec5f3cee43b$var$U.current.useSyncExternalStore(a, b, e);
};
$59232ec5f3cee43b$export$7b286972b8d8ccbf = function() {
    return $59232ec5f3cee43b$var$U.current.useTransition();
};
$59232ec5f3cee43b$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("e4MuM", function(module, exports) {
"use strict";
function $02a5045d334af58f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($02a5045d334af58f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$02a5045d334af58f$var$checkDCE();

module.exports = (parcelRequire("ju43H"));

});
parcelRequire.register("ju43H", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e2f3f7a5613b5dc0$export$ae55be85d98224ed; }, function (v) { return $e2f3f7a5613b5dc0$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e2f3f7a5613b5dc0$export$d39a5bbd09211389; }, function (v) { return $e2f3f7a5613b5dc0$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e2f3f7a5613b5dc0$export$882461b6382ed46c; }, function (v) { return $e2f3f7a5613b5dc0$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e2f3f7a5613b5dc0$export$466bfc07425424d5; }, function (v) { return $e2f3f7a5613b5dc0$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e2f3f7a5613b5dc0$export$cd75ccfd720a3cd4; }, function (v) { return $e2f3f7a5613b5dc0$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e2f3f7a5613b5dc0$export$fa8d919ba61d84db; }, function (v) { return $e2f3f7a5613b5dc0$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e2f3f7a5613b5dc0$export$757ceba2d55c277e; }, function (v) { return $e2f3f7a5613b5dc0$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e2f3f7a5613b5dc0$export$b3890eb0ae9dca99; }, function (v) { return $e2f3f7a5613b5dc0$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e2f3f7a5613b5dc0$export$502457920280e6be; }, function (v) { return $e2f3f7a5613b5dc0$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e2f3f7a5613b5dc0$export$c78a37762a8d58e1; }, function (v) { return $e2f3f7a5613b5dc0$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e2f3f7a5613b5dc0$export$dc54d992c10e8a18; }, function (v) { return $e2f3f7a5613b5dc0$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e2f3f7a5613b5dc0$export$83d89fbfd8236492; }, function (v) { return $e2f3f7a5613b5dc0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e2f3f7a5613b5dc0$export$ae55be85d98224ed;
var $e2f3f7a5613b5dc0$export$d39a5bbd09211389;
var $e2f3f7a5613b5dc0$export$882461b6382ed46c;
var $e2f3f7a5613b5dc0$export$466bfc07425424d5;
var $e2f3f7a5613b5dc0$export$cd75ccfd720a3cd4;
var $e2f3f7a5613b5dc0$export$fa8d919ba61d84db;
var $e2f3f7a5613b5dc0$export$757ceba2d55c277e;
var $e2f3f7a5613b5dc0$export$b3890eb0ae9dca99;
var $e2f3f7a5613b5dc0$export$502457920280e6be;
var $e2f3f7a5613b5dc0$export$c78a37762a8d58e1;
var $e2f3f7a5613b5dc0$export$dc54d992c10e8a18;
var $e2f3f7a5613b5dc0$export$83d89fbfd8236492;
"use strict";

var $6P6dz = parcelRequire("6P6dz");

var $io32K = parcelRequire("io32K");
function $e2f3f7a5613b5dc0$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e2f3f7a5613b5dc0$var$da = new Set, $e2f3f7a5613b5dc0$var$ea = {};
function $e2f3f7a5613b5dc0$var$fa(a, b) {
    $e2f3f7a5613b5dc0$var$ha(a, b);
    $e2f3f7a5613b5dc0$var$ha(a + "Capture", b);
}
function $e2f3f7a5613b5dc0$var$ha(a, b) {
    $e2f3f7a5613b5dc0$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e2f3f7a5613b5dc0$var$da.add(b[a]);
}
var $e2f3f7a5613b5dc0$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e2f3f7a5613b5dc0$var$ja = Object.prototype.hasOwnProperty, $e2f3f7a5613b5dc0$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e2f3f7a5613b5dc0$var$la = {}, $e2f3f7a5613b5dc0$var$ma = {};
function $e2f3f7a5613b5dc0$var$oa(a) {
    if ($e2f3f7a5613b5dc0$var$ja.call($e2f3f7a5613b5dc0$var$ma, a)) return !0;
    if ($e2f3f7a5613b5dc0$var$ja.call($e2f3f7a5613b5dc0$var$la, a)) return !1;
    if ($e2f3f7a5613b5dc0$var$ka.test(a)) return $e2f3f7a5613b5dc0$var$ma[a] = !0;
    $e2f3f7a5613b5dc0$var$la[a] = !0;
    return !1;
}
function $e2f3f7a5613b5dc0$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e2f3f7a5613b5dc0$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e2f3f7a5613b5dc0$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e2f3f7a5613b5dc0$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e2f3f7a5613b5dc0$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e2f3f7a5613b5dc0$var$z[b] = new $e2f3f7a5613b5dc0$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e2f3f7a5613b5dc0$var$ra = /[\-:]([a-z])/g;
function $e2f3f7a5613b5dc0$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e2f3f7a5613b5dc0$var$ra, $e2f3f7a5613b5dc0$var$sa);
    $e2f3f7a5613b5dc0$var$z[b] = new $e2f3f7a5613b5dc0$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e2f3f7a5613b5dc0$var$ra, $e2f3f7a5613b5dc0$var$sa);
    $e2f3f7a5613b5dc0$var$z[b] = new $e2f3f7a5613b5dc0$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e2f3f7a5613b5dc0$var$ra, $e2f3f7a5613b5dc0$var$sa);
    $e2f3f7a5613b5dc0$var$z[b] = new $e2f3f7a5613b5dc0$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e2f3f7a5613b5dc0$var$z.xlinkHref = new $e2f3f7a5613b5dc0$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e2f3f7a5613b5dc0$var$z[a] = new $e2f3f7a5613b5dc0$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e2f3f7a5613b5dc0$var$ta(a, b, c, d) {
    var e = $e2f3f7a5613b5dc0$var$z.hasOwnProperty(b) ? $e2f3f7a5613b5dc0$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e2f3f7a5613b5dc0$var$qa(b, c, e, d) && (c = null), d || null === e ? $e2f3f7a5613b5dc0$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e2f3f7a5613b5dc0$var$ua = $6P6dz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e2f3f7a5613b5dc0$var$va = Symbol.for("react.element"), $e2f3f7a5613b5dc0$var$wa = Symbol.for("react.portal"), $e2f3f7a5613b5dc0$var$ya = Symbol.for("react.fragment"), $e2f3f7a5613b5dc0$var$za = Symbol.for("react.strict_mode"), $e2f3f7a5613b5dc0$var$Aa = Symbol.for("react.profiler"), $e2f3f7a5613b5dc0$var$Ba = Symbol.for("react.provider"), $e2f3f7a5613b5dc0$var$Ca = Symbol.for("react.context"), $e2f3f7a5613b5dc0$var$Da = Symbol.for("react.forward_ref"), $e2f3f7a5613b5dc0$var$Ea = Symbol.for("react.suspense"), $e2f3f7a5613b5dc0$var$Fa = Symbol.for("react.suspense_list"), $e2f3f7a5613b5dc0$var$Ga = Symbol.for("react.memo"), $e2f3f7a5613b5dc0$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e2f3f7a5613b5dc0$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e2f3f7a5613b5dc0$var$Ja = Symbol.iterator;
function $e2f3f7a5613b5dc0$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e2f3f7a5613b5dc0$var$Ja && a[$e2f3f7a5613b5dc0$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e2f3f7a5613b5dc0$var$A = Object.assign, $e2f3f7a5613b5dc0$var$La;
function $e2f3f7a5613b5dc0$var$Ma(a) {
    if (void 0 === $e2f3f7a5613b5dc0$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e2f3f7a5613b5dc0$var$La = b && b[1] || "";
    }
    return "\n" + $e2f3f7a5613b5dc0$var$La + a;
}
var $e2f3f7a5613b5dc0$var$Na = !1;
function $e2f3f7a5613b5dc0$var$Oa(a, b) {
    if (!a || $e2f3f7a5613b5dc0$var$Na) return "";
    $e2f3f7a5613b5dc0$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e2f3f7a5613b5dc0$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e2f3f7a5613b5dc0$var$Ma(a) : "";
}
function $e2f3f7a5613b5dc0$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e2f3f7a5613b5dc0$var$Ma(a.type);
        case 16:
            return $e2f3f7a5613b5dc0$var$Ma("Lazy");
        case 13:
            return $e2f3f7a5613b5dc0$var$Ma("Suspense");
        case 19:
            return $e2f3f7a5613b5dc0$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e2f3f7a5613b5dc0$var$Oa(a.type, !1), a;
        case 11:
            return a = $e2f3f7a5613b5dc0$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e2f3f7a5613b5dc0$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e2f3f7a5613b5dc0$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e2f3f7a5613b5dc0$var$ya:
            return "Fragment";
        case $e2f3f7a5613b5dc0$var$wa:
            return "Portal";
        case $e2f3f7a5613b5dc0$var$Aa:
            return "Profiler";
        case $e2f3f7a5613b5dc0$var$za:
            return "StrictMode";
        case $e2f3f7a5613b5dc0$var$Ea:
            return "Suspense";
        case $e2f3f7a5613b5dc0$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e2f3f7a5613b5dc0$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e2f3f7a5613b5dc0$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e2f3f7a5613b5dc0$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e2f3f7a5613b5dc0$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e2f3f7a5613b5dc0$var$Qa(a.type) || "Memo";
        case $e2f3f7a5613b5dc0$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e2f3f7a5613b5dc0$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e2f3f7a5613b5dc0$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e2f3f7a5613b5dc0$var$Qa(b);
        case 8:
            return b === $e2f3f7a5613b5dc0$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e2f3f7a5613b5dc0$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e2f3f7a5613b5dc0$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e2f3f7a5613b5dc0$var$Ua(a) {
    var b = $e2f3f7a5613b5dc0$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e2f3f7a5613b5dc0$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e2f3f7a5613b5dc0$var$Ua(a));
}
function $e2f3f7a5613b5dc0$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e2f3f7a5613b5dc0$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e2f3f7a5613b5dc0$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e2f3f7a5613b5dc0$var$Ya(a, b) {
    var c = b.checked;
    return $e2f3f7a5613b5dc0$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e2f3f7a5613b5dc0$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e2f3f7a5613b5dc0$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e2f3f7a5613b5dc0$var$ab(a, b) {
    b = b.checked;
    null != b && $e2f3f7a5613b5dc0$var$ta(a, "checked", b, !1);
}
function $e2f3f7a5613b5dc0$var$bb(a, b) {
    $e2f3f7a5613b5dc0$var$ab(a, b);
    var c = $e2f3f7a5613b5dc0$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e2f3f7a5613b5dc0$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e2f3f7a5613b5dc0$var$cb(a, b.type, $e2f3f7a5613b5dc0$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e2f3f7a5613b5dc0$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e2f3f7a5613b5dc0$var$cb(a, b, c) {
    if ("number" !== b || $e2f3f7a5613b5dc0$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e2f3f7a5613b5dc0$var$eb = Array.isArray;
function $e2f3f7a5613b5dc0$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e2f3f7a5613b5dc0$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e2f3f7a5613b5dc0$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e2f3f7a5613b5dc0$var$p(91));
    return $e2f3f7a5613b5dc0$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e2f3f7a5613b5dc0$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e2f3f7a5613b5dc0$var$p(92));
            if ($e2f3f7a5613b5dc0$var$eb(c)) {
                if (1 < c.length) throw Error($e2f3f7a5613b5dc0$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e2f3f7a5613b5dc0$var$Sa(c)
    };
}
function $e2f3f7a5613b5dc0$var$ib(a, b) {
    var c = $e2f3f7a5613b5dc0$var$Sa(b.value), d = $e2f3f7a5613b5dc0$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e2f3f7a5613b5dc0$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e2f3f7a5613b5dc0$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e2f3f7a5613b5dc0$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e2f3f7a5613b5dc0$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e2f3f7a5613b5dc0$var$mb, $e2f3f7a5613b5dc0$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e2f3f7a5613b5dc0$var$mb = $e2f3f7a5613b5dc0$var$mb || document.createElement("div");
        $e2f3f7a5613b5dc0$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e2f3f7a5613b5dc0$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e2f3f7a5613b5dc0$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e2f3f7a5613b5dc0$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e2f3f7a5613b5dc0$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e2f3f7a5613b5dc0$var$pb).forEach(function(a) {
    $e2f3f7a5613b5dc0$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e2f3f7a5613b5dc0$var$pb[b] = $e2f3f7a5613b5dc0$var$pb[a];
    });
});
function $e2f3f7a5613b5dc0$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e2f3f7a5613b5dc0$var$pb.hasOwnProperty(a) && $e2f3f7a5613b5dc0$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e2f3f7a5613b5dc0$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e2f3f7a5613b5dc0$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e2f3f7a5613b5dc0$var$tb = $e2f3f7a5613b5dc0$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e2f3f7a5613b5dc0$var$ub(a, b) {
    if (b) {
        if ($e2f3f7a5613b5dc0$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e2f3f7a5613b5dc0$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e2f3f7a5613b5dc0$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e2f3f7a5613b5dc0$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e2f3f7a5613b5dc0$var$p(62));
    }
}
function $e2f3f7a5613b5dc0$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e2f3f7a5613b5dc0$var$wb = null;
function $e2f3f7a5613b5dc0$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e2f3f7a5613b5dc0$var$yb = null, $e2f3f7a5613b5dc0$var$zb = null, $e2f3f7a5613b5dc0$var$Ab = null;
function $e2f3f7a5613b5dc0$var$Bb(a) {
    if (a = $e2f3f7a5613b5dc0$var$Cb(a)) {
        if ("function" !== typeof $e2f3f7a5613b5dc0$var$yb) throw Error($e2f3f7a5613b5dc0$var$p(280));
        var b = a.stateNode;
        b && (b = $e2f3f7a5613b5dc0$var$Db(b), $e2f3f7a5613b5dc0$var$yb(a.stateNode, a.type, b));
    }
}
function $e2f3f7a5613b5dc0$var$Eb(a) {
    $e2f3f7a5613b5dc0$var$zb ? $e2f3f7a5613b5dc0$var$Ab ? $e2f3f7a5613b5dc0$var$Ab.push(a) : $e2f3f7a5613b5dc0$var$Ab = [
        a
    ] : $e2f3f7a5613b5dc0$var$zb = a;
}
function $e2f3f7a5613b5dc0$var$Fb() {
    if ($e2f3f7a5613b5dc0$var$zb) {
        var a = $e2f3f7a5613b5dc0$var$zb, b = $e2f3f7a5613b5dc0$var$Ab;
        $e2f3f7a5613b5dc0$var$Ab = $e2f3f7a5613b5dc0$var$zb = null;
        $e2f3f7a5613b5dc0$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e2f3f7a5613b5dc0$var$Bb(b[a]);
    }
}
function $e2f3f7a5613b5dc0$var$Gb(a, b) {
    return a(b);
}
function $e2f3f7a5613b5dc0$var$Hb() {}
var $e2f3f7a5613b5dc0$var$Ib = !1;
function $e2f3f7a5613b5dc0$var$Jb(a, b, c) {
    if ($e2f3f7a5613b5dc0$var$Ib) return a(b, c);
    $e2f3f7a5613b5dc0$var$Ib = !0;
    try {
        return $e2f3f7a5613b5dc0$var$Gb(a, b, c);
    } finally{
        if ($e2f3f7a5613b5dc0$var$Ib = !1, null !== $e2f3f7a5613b5dc0$var$zb || null !== $e2f3f7a5613b5dc0$var$Ab) $e2f3f7a5613b5dc0$var$Hb(), $e2f3f7a5613b5dc0$var$Fb();
    }
}
function $e2f3f7a5613b5dc0$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e2f3f7a5613b5dc0$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e2f3f7a5613b5dc0$var$p(231, b, typeof c));
    return c;
}
var $e2f3f7a5613b5dc0$var$Lb = !1;
if ($e2f3f7a5613b5dc0$var$ia) try {
    var $e2f3f7a5613b5dc0$var$Mb = {};
    Object.defineProperty($e2f3f7a5613b5dc0$var$Mb, "passive", {
        get: function() {
            $e2f3f7a5613b5dc0$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e2f3f7a5613b5dc0$var$Mb, $e2f3f7a5613b5dc0$var$Mb);
    window.removeEventListener("test", $e2f3f7a5613b5dc0$var$Mb, $e2f3f7a5613b5dc0$var$Mb);
} catch (a) {
    $e2f3f7a5613b5dc0$var$Lb = !1;
}
function $e2f3f7a5613b5dc0$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e2f3f7a5613b5dc0$var$Ob = !1, $e2f3f7a5613b5dc0$var$Pb = null, $e2f3f7a5613b5dc0$var$Qb = !1, $e2f3f7a5613b5dc0$var$Rb = null, $e2f3f7a5613b5dc0$var$Sb = {
    onError: function(a) {
        $e2f3f7a5613b5dc0$var$Ob = !0;
        $e2f3f7a5613b5dc0$var$Pb = a;
    }
};
function $e2f3f7a5613b5dc0$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e2f3f7a5613b5dc0$var$Ob = !1;
    $e2f3f7a5613b5dc0$var$Pb = null;
    $e2f3f7a5613b5dc0$var$Nb.apply($e2f3f7a5613b5dc0$var$Sb, arguments);
}
function $e2f3f7a5613b5dc0$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e2f3f7a5613b5dc0$var$Tb.apply(this, arguments);
    if ($e2f3f7a5613b5dc0$var$Ob) {
        if ($e2f3f7a5613b5dc0$var$Ob) {
            var l = $e2f3f7a5613b5dc0$var$Pb;
            $e2f3f7a5613b5dc0$var$Ob = !1;
            $e2f3f7a5613b5dc0$var$Pb = null;
        } else throw Error($e2f3f7a5613b5dc0$var$p(198));
        $e2f3f7a5613b5dc0$var$Qb || ($e2f3f7a5613b5dc0$var$Qb = !0, $e2f3f7a5613b5dc0$var$Rb = l);
    }
}
function $e2f3f7a5613b5dc0$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e2f3f7a5613b5dc0$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e2f3f7a5613b5dc0$var$Xb(a) {
    if ($e2f3f7a5613b5dc0$var$Vb(a) !== a) throw Error($e2f3f7a5613b5dc0$var$p(188));
}
function $e2f3f7a5613b5dc0$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e2f3f7a5613b5dc0$var$Vb(a);
        if (null === b) throw Error($e2f3f7a5613b5dc0$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e2f3f7a5613b5dc0$var$Xb(e), a;
                if (f === d) return $e2f3f7a5613b5dc0$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e2f3f7a5613b5dc0$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e2f3f7a5613b5dc0$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e2f3f7a5613b5dc0$var$p(190));
    }
    if (3 !== c.tag) throw Error($e2f3f7a5613b5dc0$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e2f3f7a5613b5dc0$var$Zb(a) {
    a = $e2f3f7a5613b5dc0$var$Yb(a);
    return null !== a ? $e2f3f7a5613b5dc0$var$$b(a) : null;
}
function $e2f3f7a5613b5dc0$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e2f3f7a5613b5dc0$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e2f3f7a5613b5dc0$var$ac = $io32K.unstable_scheduleCallback, $e2f3f7a5613b5dc0$var$bc = $io32K.unstable_cancelCallback, $e2f3f7a5613b5dc0$var$cc = $io32K.unstable_shouldYield, $e2f3f7a5613b5dc0$var$dc = $io32K.unstable_requestPaint, $e2f3f7a5613b5dc0$var$B = $io32K.unstable_now, $e2f3f7a5613b5dc0$var$ec = $io32K.unstable_getCurrentPriorityLevel, $e2f3f7a5613b5dc0$var$fc = $io32K.unstable_ImmediatePriority, $e2f3f7a5613b5dc0$var$gc = $io32K.unstable_UserBlockingPriority, $e2f3f7a5613b5dc0$var$hc = $io32K.unstable_NormalPriority, $e2f3f7a5613b5dc0$var$ic = $io32K.unstable_LowPriority, $e2f3f7a5613b5dc0$var$jc = $io32K.unstable_IdlePriority, $e2f3f7a5613b5dc0$var$kc = null, $e2f3f7a5613b5dc0$var$lc = null;
function $e2f3f7a5613b5dc0$var$mc(a) {
    if ($e2f3f7a5613b5dc0$var$lc && "function" === typeof $e2f3f7a5613b5dc0$var$lc.onCommitFiberRoot) try {
        $e2f3f7a5613b5dc0$var$lc.onCommitFiberRoot($e2f3f7a5613b5dc0$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e2f3f7a5613b5dc0$var$oc = Math.clz32 ? Math.clz32 : $e2f3f7a5613b5dc0$var$nc, $e2f3f7a5613b5dc0$var$pc = Math.log, $e2f3f7a5613b5dc0$var$qc = Math.LN2;
function $e2f3f7a5613b5dc0$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e2f3f7a5613b5dc0$var$pc(a) / $e2f3f7a5613b5dc0$var$qc | 0) | 0;
}
var $e2f3f7a5613b5dc0$var$rc = 64, $e2f3f7a5613b5dc0$var$sc = 4194304;
function $e2f3f7a5613b5dc0$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e2f3f7a5613b5dc0$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e2f3f7a5613b5dc0$var$tc(h) : (f &= g, 0 !== f && (d = $e2f3f7a5613b5dc0$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e2f3f7a5613b5dc0$var$tc(g) : 0 !== f && (d = $e2f3f7a5613b5dc0$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e2f3f7a5613b5dc0$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e2f3f7a5613b5dc0$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e2f3f7a5613b5dc0$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e2f3f7a5613b5dc0$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e2f3f7a5613b5dc0$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e2f3f7a5613b5dc0$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e2f3f7a5613b5dc0$var$yc() {
    var a = $e2f3f7a5613b5dc0$var$rc;
    $e2f3f7a5613b5dc0$var$rc <<= 1;
    0 === ($e2f3f7a5613b5dc0$var$rc & 4194240) && ($e2f3f7a5613b5dc0$var$rc = 64);
    return a;
}
function $e2f3f7a5613b5dc0$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e2f3f7a5613b5dc0$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e2f3f7a5613b5dc0$var$oc(b);
    a[b] = c;
}
function $e2f3f7a5613b5dc0$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e2f3f7a5613b5dc0$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e2f3f7a5613b5dc0$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e2f3f7a5613b5dc0$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e2f3f7a5613b5dc0$var$C = 0;
function $e2f3f7a5613b5dc0$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e2f3f7a5613b5dc0$var$Ec, $e2f3f7a5613b5dc0$var$Fc, $e2f3f7a5613b5dc0$var$Gc, $e2f3f7a5613b5dc0$var$Hc, $e2f3f7a5613b5dc0$var$Ic, $e2f3f7a5613b5dc0$var$Jc = !1, $e2f3f7a5613b5dc0$var$Kc = [], $e2f3f7a5613b5dc0$var$Lc = null, $e2f3f7a5613b5dc0$var$Mc = null, $e2f3f7a5613b5dc0$var$Nc = null, $e2f3f7a5613b5dc0$var$Oc = new Map, $e2f3f7a5613b5dc0$var$Pc = new Map, $e2f3f7a5613b5dc0$var$Qc = [], $e2f3f7a5613b5dc0$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e2f3f7a5613b5dc0$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e2f3f7a5613b5dc0$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e2f3f7a5613b5dc0$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e2f3f7a5613b5dc0$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e2f3f7a5613b5dc0$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e2f3f7a5613b5dc0$var$Pc.delete(b.pointerId);
    }
}
function $e2f3f7a5613b5dc0$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e2f3f7a5613b5dc0$var$Cb(b), null !== b && $e2f3f7a5613b5dc0$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e2f3f7a5613b5dc0$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e2f3f7a5613b5dc0$var$Lc = $e2f3f7a5613b5dc0$var$Tc($e2f3f7a5613b5dc0$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e2f3f7a5613b5dc0$var$Mc = $e2f3f7a5613b5dc0$var$Tc($e2f3f7a5613b5dc0$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e2f3f7a5613b5dc0$var$Nc = $e2f3f7a5613b5dc0$var$Tc($e2f3f7a5613b5dc0$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e2f3f7a5613b5dc0$var$Oc.set(f, $e2f3f7a5613b5dc0$var$Tc($e2f3f7a5613b5dc0$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e2f3f7a5613b5dc0$var$Pc.set(f, $e2f3f7a5613b5dc0$var$Tc($e2f3f7a5613b5dc0$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e2f3f7a5613b5dc0$var$Vc(a) {
    var b = $e2f3f7a5613b5dc0$var$Wc(a.target);
    if (null !== b) {
        var c = $e2f3f7a5613b5dc0$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e2f3f7a5613b5dc0$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e2f3f7a5613b5dc0$var$Ic(a.priority, function() {
                        $e2f3f7a5613b5dc0$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e2f3f7a5613b5dc0$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e2f3f7a5613b5dc0$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e2f3f7a5613b5dc0$var$wb = d;
            c.target.dispatchEvent(d);
            $e2f3f7a5613b5dc0$var$wb = null;
        } else return b = $e2f3f7a5613b5dc0$var$Cb(c), null !== b && $e2f3f7a5613b5dc0$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e2f3f7a5613b5dc0$var$Zc(a, b, c) {
    $e2f3f7a5613b5dc0$var$Xc(a) && c.delete(b);
}
function $e2f3f7a5613b5dc0$var$$c() {
    $e2f3f7a5613b5dc0$var$Jc = !1;
    null !== $e2f3f7a5613b5dc0$var$Lc && $e2f3f7a5613b5dc0$var$Xc($e2f3f7a5613b5dc0$var$Lc) && ($e2f3f7a5613b5dc0$var$Lc = null);
    null !== $e2f3f7a5613b5dc0$var$Mc && $e2f3f7a5613b5dc0$var$Xc($e2f3f7a5613b5dc0$var$Mc) && ($e2f3f7a5613b5dc0$var$Mc = null);
    null !== $e2f3f7a5613b5dc0$var$Nc && $e2f3f7a5613b5dc0$var$Xc($e2f3f7a5613b5dc0$var$Nc) && ($e2f3f7a5613b5dc0$var$Nc = null);
    $e2f3f7a5613b5dc0$var$Oc.forEach($e2f3f7a5613b5dc0$var$Zc);
    $e2f3f7a5613b5dc0$var$Pc.forEach($e2f3f7a5613b5dc0$var$Zc);
}
function $e2f3f7a5613b5dc0$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e2f3f7a5613b5dc0$var$Jc || ($e2f3f7a5613b5dc0$var$Jc = !0, $io32K.unstable_scheduleCallback($io32K.unstable_NormalPriority, $e2f3f7a5613b5dc0$var$$c)));
}
function $e2f3f7a5613b5dc0$var$bd(a) {
    function b(b) {
        return $e2f3f7a5613b5dc0$var$ad(b, a);
    }
    if (0 < $e2f3f7a5613b5dc0$var$Kc.length) {
        $e2f3f7a5613b5dc0$var$ad($e2f3f7a5613b5dc0$var$Kc[0], a);
        for(var c = 1; c < $e2f3f7a5613b5dc0$var$Kc.length; c++){
            var d = $e2f3f7a5613b5dc0$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e2f3f7a5613b5dc0$var$Lc && $e2f3f7a5613b5dc0$var$ad($e2f3f7a5613b5dc0$var$Lc, a);
    null !== $e2f3f7a5613b5dc0$var$Mc && $e2f3f7a5613b5dc0$var$ad($e2f3f7a5613b5dc0$var$Mc, a);
    null !== $e2f3f7a5613b5dc0$var$Nc && $e2f3f7a5613b5dc0$var$ad($e2f3f7a5613b5dc0$var$Nc, a);
    $e2f3f7a5613b5dc0$var$Oc.forEach(b);
    $e2f3f7a5613b5dc0$var$Pc.forEach(b);
    for(c = 0; c < $e2f3f7a5613b5dc0$var$Qc.length; c++)d = $e2f3f7a5613b5dc0$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e2f3f7a5613b5dc0$var$Qc.length && (c = $e2f3f7a5613b5dc0$var$Qc[0], null === c.blockedOn);)$e2f3f7a5613b5dc0$var$Vc(c), null === c.blockedOn && $e2f3f7a5613b5dc0$var$Qc.shift();
}
var $e2f3f7a5613b5dc0$var$cd = $e2f3f7a5613b5dc0$var$ua.ReactCurrentBatchConfig, $e2f3f7a5613b5dc0$var$dd = !0;
function $e2f3f7a5613b5dc0$var$ed(a, b, c, d) {
    var e = $e2f3f7a5613b5dc0$var$C, f = $e2f3f7a5613b5dc0$var$cd.transition;
    $e2f3f7a5613b5dc0$var$cd.transition = null;
    try {
        $e2f3f7a5613b5dc0$var$C = 1, $e2f3f7a5613b5dc0$var$fd(a, b, c, d);
    } finally{
        $e2f3f7a5613b5dc0$var$C = e, $e2f3f7a5613b5dc0$var$cd.transition = f;
    }
}
function $e2f3f7a5613b5dc0$var$gd(a, b, c, d) {
    var e = $e2f3f7a5613b5dc0$var$C, f = $e2f3f7a5613b5dc0$var$cd.transition;
    $e2f3f7a5613b5dc0$var$cd.transition = null;
    try {
        $e2f3f7a5613b5dc0$var$C = 4, $e2f3f7a5613b5dc0$var$fd(a, b, c, d);
    } finally{
        $e2f3f7a5613b5dc0$var$C = e, $e2f3f7a5613b5dc0$var$cd.transition = f;
    }
}
function $e2f3f7a5613b5dc0$var$fd(a, b, c, d) {
    if ($e2f3f7a5613b5dc0$var$dd) {
        var e = $e2f3f7a5613b5dc0$var$Yc(a, b, c, d);
        if (null === e) $e2f3f7a5613b5dc0$var$hd(a, b, d, $e2f3f7a5613b5dc0$var$id, c), $e2f3f7a5613b5dc0$var$Sc(a, d);
        else if ($e2f3f7a5613b5dc0$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e2f3f7a5613b5dc0$var$Sc(a, d), b & 4 && -1 < $e2f3f7a5613b5dc0$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e2f3f7a5613b5dc0$var$Cb(e);
                null !== f && $e2f3f7a5613b5dc0$var$Ec(f);
                f = $e2f3f7a5613b5dc0$var$Yc(a, b, c, d);
                null === f && $e2f3f7a5613b5dc0$var$hd(a, b, d, $e2f3f7a5613b5dc0$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e2f3f7a5613b5dc0$var$hd(a, b, d, null, c);
    }
}
var $e2f3f7a5613b5dc0$var$id = null;
function $e2f3f7a5613b5dc0$var$Yc(a, b, c, d) {
    $e2f3f7a5613b5dc0$var$id = null;
    a = $e2f3f7a5613b5dc0$var$xb(d);
    a = $e2f3f7a5613b5dc0$var$Wc(a);
    if (null !== a) {
        if (b = $e2f3f7a5613b5dc0$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e2f3f7a5613b5dc0$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e2f3f7a5613b5dc0$var$id = a;
    return null;
}
function $e2f3f7a5613b5dc0$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e2f3f7a5613b5dc0$var$ec()){
                case $e2f3f7a5613b5dc0$var$fc:
                    return 1;
                case $e2f3f7a5613b5dc0$var$gc:
                    return 4;
                case $e2f3f7a5613b5dc0$var$hc:
                case $e2f3f7a5613b5dc0$var$ic:
                    return 16;
                case $e2f3f7a5613b5dc0$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e2f3f7a5613b5dc0$var$kd = null, $e2f3f7a5613b5dc0$var$ld = null, $e2f3f7a5613b5dc0$var$md = null;
function $e2f3f7a5613b5dc0$var$nd() {
    if ($e2f3f7a5613b5dc0$var$md) return $e2f3f7a5613b5dc0$var$md;
    var a, b = $e2f3f7a5613b5dc0$var$ld, c = b.length, d, e = "value" in $e2f3f7a5613b5dc0$var$kd ? $e2f3f7a5613b5dc0$var$kd.value : $e2f3f7a5613b5dc0$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e2f3f7a5613b5dc0$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e2f3f7a5613b5dc0$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e2f3f7a5613b5dc0$var$pd() {
    return !0;
}
function $e2f3f7a5613b5dc0$var$qd() {
    return !1;
}
function $e2f3f7a5613b5dc0$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e2f3f7a5613b5dc0$var$pd : $e2f3f7a5613b5dc0$var$qd;
        this.isPropagationStopped = $e2f3f7a5613b5dc0$var$qd;
        return this;
    }
    $e2f3f7a5613b5dc0$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e2f3f7a5613b5dc0$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e2f3f7a5613b5dc0$var$pd);
        },
        persist: function() {},
        isPersistent: $e2f3f7a5613b5dc0$var$pd
    });
    return b;
}
var $e2f3f7a5613b5dc0$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e2f3f7a5613b5dc0$var$td = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$sd), $e2f3f7a5613b5dc0$var$ud = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$sd, {
    view: 0,
    detail: 0
}), $e2f3f7a5613b5dc0$var$vd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$ud), $e2f3f7a5613b5dc0$var$wd, $e2f3f7a5613b5dc0$var$xd, $e2f3f7a5613b5dc0$var$yd, $e2f3f7a5613b5dc0$var$Ad = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e2f3f7a5613b5dc0$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e2f3f7a5613b5dc0$var$yd && ($e2f3f7a5613b5dc0$var$yd && "mousemove" === a.type ? ($e2f3f7a5613b5dc0$var$wd = a.screenX - $e2f3f7a5613b5dc0$var$yd.screenX, $e2f3f7a5613b5dc0$var$xd = a.screenY - $e2f3f7a5613b5dc0$var$yd.screenY) : $e2f3f7a5613b5dc0$var$xd = $e2f3f7a5613b5dc0$var$wd = 0, $e2f3f7a5613b5dc0$var$yd = a);
        return $e2f3f7a5613b5dc0$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e2f3f7a5613b5dc0$var$xd;
    }
}), $e2f3f7a5613b5dc0$var$Bd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Ad), $e2f3f7a5613b5dc0$var$Cd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$Ad, {
    dataTransfer: 0
}), $e2f3f7a5613b5dc0$var$Dd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Cd), $e2f3f7a5613b5dc0$var$Ed = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$ud, {
    relatedTarget: 0
}), $e2f3f7a5613b5dc0$var$Fd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Ed), $e2f3f7a5613b5dc0$var$Gd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e2f3f7a5613b5dc0$var$Hd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Gd), $e2f3f7a5613b5dc0$var$Id = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e2f3f7a5613b5dc0$var$Jd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Id), $e2f3f7a5613b5dc0$var$Kd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$sd, {
    data: 0
}), $e2f3f7a5613b5dc0$var$Ld = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Kd), $e2f3f7a5613b5dc0$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e2f3f7a5613b5dc0$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e2f3f7a5613b5dc0$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e2f3f7a5613b5dc0$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e2f3f7a5613b5dc0$var$Od[a]) ? !!b[a] : !1;
}
function $e2f3f7a5613b5dc0$var$zd() {
    return $e2f3f7a5613b5dc0$var$Pd;
}
var $e2f3f7a5613b5dc0$var$Qd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e2f3f7a5613b5dc0$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e2f3f7a5613b5dc0$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e2f3f7a5613b5dc0$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e2f3f7a5613b5dc0$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e2f3f7a5613b5dc0$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e2f3f7a5613b5dc0$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e2f3f7a5613b5dc0$var$Rd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Qd), $e2f3f7a5613b5dc0$var$Sd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e2f3f7a5613b5dc0$var$Td = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Sd), $e2f3f7a5613b5dc0$var$Ud = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e2f3f7a5613b5dc0$var$zd
}), $e2f3f7a5613b5dc0$var$Vd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Ud), $e2f3f7a5613b5dc0$var$Wd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e2f3f7a5613b5dc0$var$Xd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Wd), $e2f3f7a5613b5dc0$var$Yd = $e2f3f7a5613b5dc0$var$A({}, $e2f3f7a5613b5dc0$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e2f3f7a5613b5dc0$var$Zd = $e2f3f7a5613b5dc0$var$rd($e2f3f7a5613b5dc0$var$Yd), $e2f3f7a5613b5dc0$var$$d = [
    9,
    13,
    27,
    32
], $e2f3f7a5613b5dc0$var$ae = $e2f3f7a5613b5dc0$var$ia && "CompositionEvent" in window, $e2f3f7a5613b5dc0$var$be = null;
$e2f3f7a5613b5dc0$var$ia && "documentMode" in document && ($e2f3f7a5613b5dc0$var$be = document.documentMode);
var $e2f3f7a5613b5dc0$var$ce = $e2f3f7a5613b5dc0$var$ia && "TextEvent" in window && !$e2f3f7a5613b5dc0$var$be, $e2f3f7a5613b5dc0$var$de = $e2f3f7a5613b5dc0$var$ia && (!$e2f3f7a5613b5dc0$var$ae || $e2f3f7a5613b5dc0$var$be && 8 < $e2f3f7a5613b5dc0$var$be && 11 >= $e2f3f7a5613b5dc0$var$be), $e2f3f7a5613b5dc0$var$ee = String.fromCharCode(32), $e2f3f7a5613b5dc0$var$fe = !1;
function $e2f3f7a5613b5dc0$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e2f3f7a5613b5dc0$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e2f3f7a5613b5dc0$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e2f3f7a5613b5dc0$var$ie = !1;
function $e2f3f7a5613b5dc0$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e2f3f7a5613b5dc0$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e2f3f7a5613b5dc0$var$fe = !0;
            return $e2f3f7a5613b5dc0$var$ee;
        case "textInput":
            return a = b.data, a === $e2f3f7a5613b5dc0$var$ee && $e2f3f7a5613b5dc0$var$fe ? null : a;
        default:
            return null;
    }
}
function $e2f3f7a5613b5dc0$var$ke(a, b) {
    if ($e2f3f7a5613b5dc0$var$ie) return "compositionend" === a || !$e2f3f7a5613b5dc0$var$ae && $e2f3f7a5613b5dc0$var$ge(a, b) ? (a = $e2f3f7a5613b5dc0$var$nd(), $e2f3f7a5613b5dc0$var$md = $e2f3f7a5613b5dc0$var$ld = $e2f3f7a5613b5dc0$var$kd = null, $e2f3f7a5613b5dc0$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e2f3f7a5613b5dc0$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e2f3f7a5613b5dc0$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e2f3f7a5613b5dc0$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e2f3f7a5613b5dc0$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e2f3f7a5613b5dc0$var$ne(a, b, c, d) {
    $e2f3f7a5613b5dc0$var$Eb(d);
    b = $e2f3f7a5613b5dc0$var$oe(b, "onChange");
    0 < b.length && (c = new $e2f3f7a5613b5dc0$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e2f3f7a5613b5dc0$var$pe = null, $e2f3f7a5613b5dc0$var$qe = null;
function $e2f3f7a5613b5dc0$var$re(a) {
    $e2f3f7a5613b5dc0$var$se(a, 0);
}
function $e2f3f7a5613b5dc0$var$te(a) {
    var b = $e2f3f7a5613b5dc0$var$ue(a);
    if ($e2f3f7a5613b5dc0$var$Wa(b)) return a;
}
function $e2f3f7a5613b5dc0$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e2f3f7a5613b5dc0$var$we = !1;
if ($e2f3f7a5613b5dc0$var$ia) {
    var $e2f3f7a5613b5dc0$var$xe;
    if ($e2f3f7a5613b5dc0$var$ia) {
        var $e2f3f7a5613b5dc0$var$ye = "oninput" in document;
        if (!$e2f3f7a5613b5dc0$var$ye) {
            var $e2f3f7a5613b5dc0$var$ze = document.createElement("div");
            $e2f3f7a5613b5dc0$var$ze.setAttribute("oninput", "return;");
            $e2f3f7a5613b5dc0$var$ye = "function" === typeof $e2f3f7a5613b5dc0$var$ze.oninput;
        }
        $e2f3f7a5613b5dc0$var$xe = $e2f3f7a5613b5dc0$var$ye;
    } else $e2f3f7a5613b5dc0$var$xe = !1;
    $e2f3f7a5613b5dc0$var$we = $e2f3f7a5613b5dc0$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e2f3f7a5613b5dc0$var$Ae() {
    $e2f3f7a5613b5dc0$var$pe && ($e2f3f7a5613b5dc0$var$pe.detachEvent("onpropertychange", $e2f3f7a5613b5dc0$var$Be), $e2f3f7a5613b5dc0$var$qe = $e2f3f7a5613b5dc0$var$pe = null);
}
function $e2f3f7a5613b5dc0$var$Be(a) {
    if ("value" === a.propertyName && $e2f3f7a5613b5dc0$var$te($e2f3f7a5613b5dc0$var$qe)) {
        var b = [];
        $e2f3f7a5613b5dc0$var$ne(b, $e2f3f7a5613b5dc0$var$qe, a, $e2f3f7a5613b5dc0$var$xb(a));
        $e2f3f7a5613b5dc0$var$Jb($e2f3f7a5613b5dc0$var$re, b);
    }
}
function $e2f3f7a5613b5dc0$var$Ce(a, b, c) {
    "focusin" === a ? ($e2f3f7a5613b5dc0$var$Ae(), $e2f3f7a5613b5dc0$var$pe = b, $e2f3f7a5613b5dc0$var$qe = c, $e2f3f7a5613b5dc0$var$pe.attachEvent("onpropertychange", $e2f3f7a5613b5dc0$var$Be)) : "focusout" === a && $e2f3f7a5613b5dc0$var$Ae();
}
function $e2f3f7a5613b5dc0$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e2f3f7a5613b5dc0$var$te($e2f3f7a5613b5dc0$var$qe);
}
function $e2f3f7a5613b5dc0$var$Ee(a, b) {
    if ("click" === a) return $e2f3f7a5613b5dc0$var$te(b);
}
function $e2f3f7a5613b5dc0$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e2f3f7a5613b5dc0$var$te(b);
}
function $e2f3f7a5613b5dc0$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e2f3f7a5613b5dc0$var$He = "function" === typeof Object.is ? Object.is : $e2f3f7a5613b5dc0$var$Ge;
function $e2f3f7a5613b5dc0$var$Ie(a, b) {
    if ($e2f3f7a5613b5dc0$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e2f3f7a5613b5dc0$var$ja.call(b, e) || !$e2f3f7a5613b5dc0$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e2f3f7a5613b5dc0$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e2f3f7a5613b5dc0$var$Ke(a, b) {
    var c = $e2f3f7a5613b5dc0$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e2f3f7a5613b5dc0$var$Je(c);
    }
}
function $e2f3f7a5613b5dc0$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e2f3f7a5613b5dc0$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e2f3f7a5613b5dc0$var$Me() {
    for(var a = window, b = $e2f3f7a5613b5dc0$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e2f3f7a5613b5dc0$var$Xa(a.document);
    }
    return b;
}
function $e2f3f7a5613b5dc0$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e2f3f7a5613b5dc0$var$Oe(a) {
    var b = $e2f3f7a5613b5dc0$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e2f3f7a5613b5dc0$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e2f3f7a5613b5dc0$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e2f3f7a5613b5dc0$var$Ke(c, f);
                var g = $e2f3f7a5613b5dc0$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e2f3f7a5613b5dc0$var$Pe = $e2f3f7a5613b5dc0$var$ia && "documentMode" in document && 11 >= document.documentMode, $e2f3f7a5613b5dc0$var$Qe = null, $e2f3f7a5613b5dc0$var$Re = null, $e2f3f7a5613b5dc0$var$Se = null, $e2f3f7a5613b5dc0$var$Te = !1;
function $e2f3f7a5613b5dc0$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e2f3f7a5613b5dc0$var$Te || null == $e2f3f7a5613b5dc0$var$Qe || $e2f3f7a5613b5dc0$var$Qe !== $e2f3f7a5613b5dc0$var$Xa(d) || (d = $e2f3f7a5613b5dc0$var$Qe, "selectionStart" in d && $e2f3f7a5613b5dc0$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e2f3f7a5613b5dc0$var$Se && $e2f3f7a5613b5dc0$var$Ie($e2f3f7a5613b5dc0$var$Se, d) || ($e2f3f7a5613b5dc0$var$Se = d, d = $e2f3f7a5613b5dc0$var$oe($e2f3f7a5613b5dc0$var$Re, "onSelect"), 0 < d.length && (b = new $e2f3f7a5613b5dc0$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e2f3f7a5613b5dc0$var$Qe)));
}
function $e2f3f7a5613b5dc0$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e2f3f7a5613b5dc0$var$We = {
    animationend: $e2f3f7a5613b5dc0$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e2f3f7a5613b5dc0$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e2f3f7a5613b5dc0$var$Ve("Animation", "AnimationStart"),
    transitionend: $e2f3f7a5613b5dc0$var$Ve("Transition", "TransitionEnd")
}, $e2f3f7a5613b5dc0$var$Xe = {}, $e2f3f7a5613b5dc0$var$Ye = {};
$e2f3f7a5613b5dc0$var$ia && ($e2f3f7a5613b5dc0$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e2f3f7a5613b5dc0$var$We.animationend.animation, delete $e2f3f7a5613b5dc0$var$We.animationiteration.animation, delete $e2f3f7a5613b5dc0$var$We.animationstart.animation), "TransitionEvent" in window || delete $e2f3f7a5613b5dc0$var$We.transitionend.transition);
function $e2f3f7a5613b5dc0$var$Ze(a) {
    if ($e2f3f7a5613b5dc0$var$Xe[a]) return $e2f3f7a5613b5dc0$var$Xe[a];
    if (!$e2f3f7a5613b5dc0$var$We[a]) return a;
    var b = $e2f3f7a5613b5dc0$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e2f3f7a5613b5dc0$var$Ye) return $e2f3f7a5613b5dc0$var$Xe[a] = b[c];
    return a;
}
var $e2f3f7a5613b5dc0$var$$e = $e2f3f7a5613b5dc0$var$Ze("animationend"), $e2f3f7a5613b5dc0$var$af = $e2f3f7a5613b5dc0$var$Ze("animationiteration"), $e2f3f7a5613b5dc0$var$bf = $e2f3f7a5613b5dc0$var$Ze("animationstart"), $e2f3f7a5613b5dc0$var$cf = $e2f3f7a5613b5dc0$var$Ze("transitionend"), $e2f3f7a5613b5dc0$var$df = new Map, $e2f3f7a5613b5dc0$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e2f3f7a5613b5dc0$var$ff(a, b) {
    $e2f3f7a5613b5dc0$var$df.set(a, b);
    $e2f3f7a5613b5dc0$var$fa(b, [
        a
    ]);
}
for(var $e2f3f7a5613b5dc0$var$gf = 0; $e2f3f7a5613b5dc0$var$gf < $e2f3f7a5613b5dc0$var$ef.length; $e2f3f7a5613b5dc0$var$gf++){
    var $e2f3f7a5613b5dc0$var$hf = $e2f3f7a5613b5dc0$var$ef[$e2f3f7a5613b5dc0$var$gf], $e2f3f7a5613b5dc0$var$jf = $e2f3f7a5613b5dc0$var$hf.toLowerCase(), $e2f3f7a5613b5dc0$var$kf = $e2f3f7a5613b5dc0$var$hf[0].toUpperCase() + $e2f3f7a5613b5dc0$var$hf.slice(1);
    $e2f3f7a5613b5dc0$var$ff($e2f3f7a5613b5dc0$var$jf, "on" + $e2f3f7a5613b5dc0$var$kf);
}
$e2f3f7a5613b5dc0$var$ff($e2f3f7a5613b5dc0$var$$e, "onAnimationEnd");
$e2f3f7a5613b5dc0$var$ff($e2f3f7a5613b5dc0$var$af, "onAnimationIteration");
$e2f3f7a5613b5dc0$var$ff($e2f3f7a5613b5dc0$var$bf, "onAnimationStart");
$e2f3f7a5613b5dc0$var$ff("dblclick", "onDoubleClick");
$e2f3f7a5613b5dc0$var$ff("focusin", "onFocus");
$e2f3f7a5613b5dc0$var$ff("focusout", "onBlur");
$e2f3f7a5613b5dc0$var$ff($e2f3f7a5613b5dc0$var$cf, "onTransitionEnd");
$e2f3f7a5613b5dc0$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e2f3f7a5613b5dc0$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e2f3f7a5613b5dc0$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e2f3f7a5613b5dc0$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e2f3f7a5613b5dc0$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e2f3f7a5613b5dc0$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e2f3f7a5613b5dc0$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e2f3f7a5613b5dc0$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e2f3f7a5613b5dc0$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e2f3f7a5613b5dc0$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e2f3f7a5613b5dc0$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e2f3f7a5613b5dc0$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e2f3f7a5613b5dc0$var$lf));
function $e2f3f7a5613b5dc0$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e2f3f7a5613b5dc0$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e2f3f7a5613b5dc0$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e2f3f7a5613b5dc0$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e2f3f7a5613b5dc0$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e2f3f7a5613b5dc0$var$Qb) throw a = $e2f3f7a5613b5dc0$var$Rb, $e2f3f7a5613b5dc0$var$Qb = !1, $e2f3f7a5613b5dc0$var$Rb = null, a;
}
function $e2f3f7a5613b5dc0$var$D(a, b) {
    var c = b[$e2f3f7a5613b5dc0$var$of];
    void 0 === c && (c = b[$e2f3f7a5613b5dc0$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e2f3f7a5613b5dc0$var$pf(b, a, 2, !1), c.add(d));
}
function $e2f3f7a5613b5dc0$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e2f3f7a5613b5dc0$var$pf(c, a, d, b);
}
var $e2f3f7a5613b5dc0$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e2f3f7a5613b5dc0$var$sf(a) {
    if (!a[$e2f3f7a5613b5dc0$var$rf]) {
        a[$e2f3f7a5613b5dc0$var$rf] = !0;
        $e2f3f7a5613b5dc0$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e2f3f7a5613b5dc0$var$mf.has(b) || $e2f3f7a5613b5dc0$var$qf(b, !1, a), $e2f3f7a5613b5dc0$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e2f3f7a5613b5dc0$var$rf] || (b[$e2f3f7a5613b5dc0$var$rf] = !0, $e2f3f7a5613b5dc0$var$qf("selectionchange", !1, b));
    }
}
function $e2f3f7a5613b5dc0$var$pf(a, b, c, d) {
    switch($e2f3f7a5613b5dc0$var$jd(b)){
        case 1:
            var e = $e2f3f7a5613b5dc0$var$ed;
            break;
        case 4:
            e = $e2f3f7a5613b5dc0$var$gd;
            break;
        default:
            e = $e2f3f7a5613b5dc0$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e2f3f7a5613b5dc0$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e2f3f7a5613b5dc0$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e2f3f7a5613b5dc0$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e2f3f7a5613b5dc0$var$Jb(function() {
        var d = f, e = $e2f3f7a5613b5dc0$var$xb(c), g = [];
        a: {
            var h = $e2f3f7a5613b5dc0$var$df.get(a);
            if (void 0 !== h) {
                var k = $e2f3f7a5613b5dc0$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e2f3f7a5613b5dc0$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e2f3f7a5613b5dc0$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e2f3f7a5613b5dc0$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e2f3f7a5613b5dc0$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e2f3f7a5613b5dc0$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e2f3f7a5613b5dc0$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e2f3f7a5613b5dc0$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e2f3f7a5613b5dc0$var$Vd;
                        break;
                    case $e2f3f7a5613b5dc0$var$$e:
                    case $e2f3f7a5613b5dc0$var$af:
                    case $e2f3f7a5613b5dc0$var$bf:
                        k = $e2f3f7a5613b5dc0$var$Hd;
                        break;
                    case $e2f3f7a5613b5dc0$var$cf:
                        k = $e2f3f7a5613b5dc0$var$Xd;
                        break;
                    case "scroll":
                        k = $e2f3f7a5613b5dc0$var$vd;
                        break;
                    case "wheel":
                        k = $e2f3f7a5613b5dc0$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e2f3f7a5613b5dc0$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e2f3f7a5613b5dc0$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e2f3f7a5613b5dc0$var$Kb(w, x), null != F && t.push($e2f3f7a5613b5dc0$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e2f3f7a5613b5dc0$var$wb && (n = c.relatedTarget || c.fromElement) && ($e2f3f7a5613b5dc0$var$Wc(n) || n[$e2f3f7a5613b5dc0$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e2f3f7a5613b5dc0$var$Wc(n) : null, null !== n && (J = $e2f3f7a5613b5dc0$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e2f3f7a5613b5dc0$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e2f3f7a5613b5dc0$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e2f3f7a5613b5dc0$var$ue(k);
                        u = null == n ? h : $e2f3f7a5613b5dc0$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e2f3f7a5613b5dc0$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e2f3f7a5613b5dc0$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e2f3f7a5613b5dc0$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e2f3f7a5613b5dc0$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e2f3f7a5613b5dc0$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e2f3f7a5613b5dc0$var$vf(t);
                                x = $e2f3f7a5613b5dc0$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e2f3f7a5613b5dc0$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e2f3f7a5613b5dc0$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e2f3f7a5613b5dc0$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e2f3f7a5613b5dc0$var$ve;
                else if ($e2f3f7a5613b5dc0$var$me(h)) {
                    if ($e2f3f7a5613b5dc0$var$we) na = $e2f3f7a5613b5dc0$var$Fe;
                    else {
                        na = $e2f3f7a5613b5dc0$var$De;
                        var xa = $e2f3f7a5613b5dc0$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e2f3f7a5613b5dc0$var$Ee);
                if (na && (na = na(a, d))) {
                    $e2f3f7a5613b5dc0$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e2f3f7a5613b5dc0$var$cb(h, "number", h.value);
            }
            xa = d ? $e2f3f7a5613b5dc0$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e2f3f7a5613b5dc0$var$me(xa) || "true" === xa.contentEditable) $e2f3f7a5613b5dc0$var$Qe = xa, $e2f3f7a5613b5dc0$var$Re = d, $e2f3f7a5613b5dc0$var$Se = null;
                    break;
                case "focusout":
                    $e2f3f7a5613b5dc0$var$Se = $e2f3f7a5613b5dc0$var$Re = $e2f3f7a5613b5dc0$var$Qe = null;
                    break;
                case "mousedown":
                    $e2f3f7a5613b5dc0$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e2f3f7a5613b5dc0$var$Te = !1;
                    $e2f3f7a5613b5dc0$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e2f3f7a5613b5dc0$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e2f3f7a5613b5dc0$var$Ue(g, c, e);
            }
            var $a;
            if ($e2f3f7a5613b5dc0$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e2f3f7a5613b5dc0$var$ie ? $e2f3f7a5613b5dc0$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e2f3f7a5613b5dc0$var$de && "ko" !== c.locale && ($e2f3f7a5613b5dc0$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e2f3f7a5613b5dc0$var$ie && ($a = $e2f3f7a5613b5dc0$var$nd()) : ($e2f3f7a5613b5dc0$var$kd = e, $e2f3f7a5613b5dc0$var$ld = "value" in $e2f3f7a5613b5dc0$var$kd ? $e2f3f7a5613b5dc0$var$kd.value : $e2f3f7a5613b5dc0$var$kd.textContent, $e2f3f7a5613b5dc0$var$ie = !0)), xa = $e2f3f7a5613b5dc0$var$oe(d, ba), 0 < xa.length && (ba = new $e2f3f7a5613b5dc0$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e2f3f7a5613b5dc0$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e2f3f7a5613b5dc0$var$ce ? $e2f3f7a5613b5dc0$var$je(a, c) : $e2f3f7a5613b5dc0$var$ke(a, c)) d = $e2f3f7a5613b5dc0$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e2f3f7a5613b5dc0$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e2f3f7a5613b5dc0$var$se(g, b);
    });
}
function $e2f3f7a5613b5dc0$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e2f3f7a5613b5dc0$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e2f3f7a5613b5dc0$var$Kb(a, c), null != f && d.unshift($e2f3f7a5613b5dc0$var$tf(a, f, e)), f = $e2f3f7a5613b5dc0$var$Kb(a, b), null != f && d.push($e2f3f7a5613b5dc0$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e2f3f7a5613b5dc0$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e2f3f7a5613b5dc0$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e2f3f7a5613b5dc0$var$Kb(c, f), null != k && g.unshift($e2f3f7a5613b5dc0$var$tf(c, k, h))) : e || (k = $e2f3f7a5613b5dc0$var$Kb(c, f), null != k && g.push($e2f3f7a5613b5dc0$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e2f3f7a5613b5dc0$var$xf = /\r\n?/g, $e2f3f7a5613b5dc0$var$yf = /\u0000|\uFFFD/g;
function $e2f3f7a5613b5dc0$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e2f3f7a5613b5dc0$var$xf, "\n").replace($e2f3f7a5613b5dc0$var$yf, "");
}
function $e2f3f7a5613b5dc0$var$Af(a, b, c) {
    b = $e2f3f7a5613b5dc0$var$zf(b);
    if ($e2f3f7a5613b5dc0$var$zf(a) !== b && c) throw Error($e2f3f7a5613b5dc0$var$p(425));
}
function $e2f3f7a5613b5dc0$var$Bf() {}
var $e2f3f7a5613b5dc0$var$Cf = null, $e2f3f7a5613b5dc0$var$Df = null;
function $e2f3f7a5613b5dc0$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e2f3f7a5613b5dc0$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e2f3f7a5613b5dc0$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e2f3f7a5613b5dc0$var$Hf = "function" === typeof Promise ? Promise : void 0, $e2f3f7a5613b5dc0$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e2f3f7a5613b5dc0$var$Hf ? function(a) {
    return $e2f3f7a5613b5dc0$var$Hf.resolve(null).then(a).catch($e2f3f7a5613b5dc0$var$If);
} : $e2f3f7a5613b5dc0$var$Ff;
function $e2f3f7a5613b5dc0$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e2f3f7a5613b5dc0$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e2f3f7a5613b5dc0$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e2f3f7a5613b5dc0$var$bd(b);
}
function $e2f3f7a5613b5dc0$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e2f3f7a5613b5dc0$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e2f3f7a5613b5dc0$var$Nf = Math.random().toString(36).slice(2), $e2f3f7a5613b5dc0$var$Of = "__reactFiber$" + $e2f3f7a5613b5dc0$var$Nf, $e2f3f7a5613b5dc0$var$Pf = "__reactProps$" + $e2f3f7a5613b5dc0$var$Nf, $e2f3f7a5613b5dc0$var$uf = "__reactContainer$" + $e2f3f7a5613b5dc0$var$Nf, $e2f3f7a5613b5dc0$var$of = "__reactEvents$" + $e2f3f7a5613b5dc0$var$Nf, $e2f3f7a5613b5dc0$var$Qf = "__reactListeners$" + $e2f3f7a5613b5dc0$var$Nf, $e2f3f7a5613b5dc0$var$Rf = "__reactHandles$" + $e2f3f7a5613b5dc0$var$Nf;
function $e2f3f7a5613b5dc0$var$Wc(a) {
    var b = a[$e2f3f7a5613b5dc0$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e2f3f7a5613b5dc0$var$uf] || c[$e2f3f7a5613b5dc0$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e2f3f7a5613b5dc0$var$Mf(a); null !== a;){
                if (c = a[$e2f3f7a5613b5dc0$var$Of]) return c;
                a = $e2f3f7a5613b5dc0$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e2f3f7a5613b5dc0$var$Cb(a) {
    a = a[$e2f3f7a5613b5dc0$var$Of] || a[$e2f3f7a5613b5dc0$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e2f3f7a5613b5dc0$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e2f3f7a5613b5dc0$var$p(33));
}
function $e2f3f7a5613b5dc0$var$Db(a) {
    return a[$e2f3f7a5613b5dc0$var$Pf] || null;
}
var $e2f3f7a5613b5dc0$var$Sf = [], $e2f3f7a5613b5dc0$var$Tf = -1;
function $e2f3f7a5613b5dc0$var$Uf(a) {
    return {
        current: a
    };
}
function $e2f3f7a5613b5dc0$var$E(a) {
    0 > $e2f3f7a5613b5dc0$var$Tf || (a.current = $e2f3f7a5613b5dc0$var$Sf[$e2f3f7a5613b5dc0$var$Tf], $e2f3f7a5613b5dc0$var$Sf[$e2f3f7a5613b5dc0$var$Tf] = null, $e2f3f7a5613b5dc0$var$Tf--);
}
function $e2f3f7a5613b5dc0$var$G(a, b) {
    $e2f3f7a5613b5dc0$var$Tf++;
    $e2f3f7a5613b5dc0$var$Sf[$e2f3f7a5613b5dc0$var$Tf] = a.current;
    a.current = b;
}
var $e2f3f7a5613b5dc0$var$Vf = {}, $e2f3f7a5613b5dc0$var$H = $e2f3f7a5613b5dc0$var$Uf($e2f3f7a5613b5dc0$var$Vf), $e2f3f7a5613b5dc0$var$Wf = $e2f3f7a5613b5dc0$var$Uf(!1), $e2f3f7a5613b5dc0$var$Xf = $e2f3f7a5613b5dc0$var$Vf;
function $e2f3f7a5613b5dc0$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e2f3f7a5613b5dc0$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e2f3f7a5613b5dc0$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e2f3f7a5613b5dc0$var$$f() {
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf);
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$H);
}
function $e2f3f7a5613b5dc0$var$ag(a, b, c) {
    if ($e2f3f7a5613b5dc0$var$H.current !== $e2f3f7a5613b5dc0$var$Vf) throw Error($e2f3f7a5613b5dc0$var$p(168));
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$H, b);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Wf, c);
}
function $e2f3f7a5613b5dc0$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e2f3f7a5613b5dc0$var$p(108, $e2f3f7a5613b5dc0$var$Ra(a) || "Unknown", e));
    return $e2f3f7a5613b5dc0$var$A({}, c, d);
}
function $e2f3f7a5613b5dc0$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e2f3f7a5613b5dc0$var$Vf;
    $e2f3f7a5613b5dc0$var$Xf = $e2f3f7a5613b5dc0$var$H.current;
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$H, a);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Wf, $e2f3f7a5613b5dc0$var$Wf.current);
    return !0;
}
function $e2f3f7a5613b5dc0$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e2f3f7a5613b5dc0$var$p(169));
    c ? (a = $e2f3f7a5613b5dc0$var$bg(a, b, $e2f3f7a5613b5dc0$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf), $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$H), $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$H, a)) : $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Wf, c);
}
var $e2f3f7a5613b5dc0$var$eg = null, $e2f3f7a5613b5dc0$var$fg = !1, $e2f3f7a5613b5dc0$var$gg = !1;
function $e2f3f7a5613b5dc0$var$hg(a) {
    null === $e2f3f7a5613b5dc0$var$eg ? $e2f3f7a5613b5dc0$var$eg = [
        a
    ] : $e2f3f7a5613b5dc0$var$eg.push(a);
}
function $e2f3f7a5613b5dc0$var$ig(a) {
    $e2f3f7a5613b5dc0$var$fg = !0;
    $e2f3f7a5613b5dc0$var$hg(a);
}
function $e2f3f7a5613b5dc0$var$jg() {
    if (!$e2f3f7a5613b5dc0$var$gg && null !== $e2f3f7a5613b5dc0$var$eg) {
        $e2f3f7a5613b5dc0$var$gg = !0;
        var a = 0, b = $e2f3f7a5613b5dc0$var$C;
        try {
            var c = $e2f3f7a5613b5dc0$var$eg;
            for($e2f3f7a5613b5dc0$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e2f3f7a5613b5dc0$var$eg = null;
            $e2f3f7a5613b5dc0$var$fg = !1;
        } catch (e) {
            throw null !== $e2f3f7a5613b5dc0$var$eg && ($e2f3f7a5613b5dc0$var$eg = $e2f3f7a5613b5dc0$var$eg.slice(a + 1)), $e2f3f7a5613b5dc0$var$ac($e2f3f7a5613b5dc0$var$fc, $e2f3f7a5613b5dc0$var$jg), e;
        } finally{
            $e2f3f7a5613b5dc0$var$C = b, $e2f3f7a5613b5dc0$var$gg = !1;
        }
    }
    return null;
}
var $e2f3f7a5613b5dc0$var$kg = [], $e2f3f7a5613b5dc0$var$lg = 0, $e2f3f7a5613b5dc0$var$mg = null, $e2f3f7a5613b5dc0$var$ng = 0, $e2f3f7a5613b5dc0$var$og = [], $e2f3f7a5613b5dc0$var$pg = 0, $e2f3f7a5613b5dc0$var$qg = null, $e2f3f7a5613b5dc0$var$rg = 1, $e2f3f7a5613b5dc0$var$sg = "";
function $e2f3f7a5613b5dc0$var$tg(a, b) {
    $e2f3f7a5613b5dc0$var$kg[$e2f3f7a5613b5dc0$var$lg++] = $e2f3f7a5613b5dc0$var$ng;
    $e2f3f7a5613b5dc0$var$kg[$e2f3f7a5613b5dc0$var$lg++] = $e2f3f7a5613b5dc0$var$mg;
    $e2f3f7a5613b5dc0$var$mg = a;
    $e2f3f7a5613b5dc0$var$ng = b;
}
function $e2f3f7a5613b5dc0$var$ug(a, b, c) {
    $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$rg;
    $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$sg;
    $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$qg;
    $e2f3f7a5613b5dc0$var$qg = a;
    var d = $e2f3f7a5613b5dc0$var$rg;
    a = $e2f3f7a5613b5dc0$var$sg;
    var e = 32 - $e2f3f7a5613b5dc0$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e2f3f7a5613b5dc0$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e2f3f7a5613b5dc0$var$rg = 1 << 32 - $e2f3f7a5613b5dc0$var$oc(b) + e | c << e | d;
        $e2f3f7a5613b5dc0$var$sg = f + a;
    } else $e2f3f7a5613b5dc0$var$rg = 1 << f | c << e | d, $e2f3f7a5613b5dc0$var$sg = a;
}
function $e2f3f7a5613b5dc0$var$vg(a) {
    null !== a.return && ($e2f3f7a5613b5dc0$var$tg(a, 1), $e2f3f7a5613b5dc0$var$ug(a, 1, 0));
}
function $e2f3f7a5613b5dc0$var$wg(a) {
    for(; a === $e2f3f7a5613b5dc0$var$mg;)$e2f3f7a5613b5dc0$var$mg = $e2f3f7a5613b5dc0$var$kg[--$e2f3f7a5613b5dc0$var$lg], $e2f3f7a5613b5dc0$var$kg[$e2f3f7a5613b5dc0$var$lg] = null, $e2f3f7a5613b5dc0$var$ng = $e2f3f7a5613b5dc0$var$kg[--$e2f3f7a5613b5dc0$var$lg], $e2f3f7a5613b5dc0$var$kg[$e2f3f7a5613b5dc0$var$lg] = null;
    for(; a === $e2f3f7a5613b5dc0$var$qg;)$e2f3f7a5613b5dc0$var$qg = $e2f3f7a5613b5dc0$var$og[--$e2f3f7a5613b5dc0$var$pg], $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg] = null, $e2f3f7a5613b5dc0$var$sg = $e2f3f7a5613b5dc0$var$og[--$e2f3f7a5613b5dc0$var$pg], $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg] = null, $e2f3f7a5613b5dc0$var$rg = $e2f3f7a5613b5dc0$var$og[--$e2f3f7a5613b5dc0$var$pg], $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg] = null;
}
var $e2f3f7a5613b5dc0$var$xg = null, $e2f3f7a5613b5dc0$var$yg = null, $e2f3f7a5613b5dc0$var$I = !1, $e2f3f7a5613b5dc0$var$zg = null;
function $e2f3f7a5613b5dc0$var$Ag(a, b) {
    var c = $e2f3f7a5613b5dc0$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e2f3f7a5613b5dc0$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e2f3f7a5613b5dc0$var$xg = a, $e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e2f3f7a5613b5dc0$var$xg = a, $e2f3f7a5613b5dc0$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e2f3f7a5613b5dc0$var$qg ? {
                id: $e2f3f7a5613b5dc0$var$rg,
                overflow: $e2f3f7a5613b5dc0$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e2f3f7a5613b5dc0$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e2f3f7a5613b5dc0$var$xg = a, $e2f3f7a5613b5dc0$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e2f3f7a5613b5dc0$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e2f3f7a5613b5dc0$var$Eg(a) {
    if ($e2f3f7a5613b5dc0$var$I) {
        var b = $e2f3f7a5613b5dc0$var$yg;
        if (b) {
            var c = b;
            if (!$e2f3f7a5613b5dc0$var$Cg(a, b)) {
                if ($e2f3f7a5613b5dc0$var$Dg(a)) throw Error($e2f3f7a5613b5dc0$var$p(418));
                b = $e2f3f7a5613b5dc0$var$Lf(c.nextSibling);
                var d = $e2f3f7a5613b5dc0$var$xg;
                b && $e2f3f7a5613b5dc0$var$Cg(a, b) ? $e2f3f7a5613b5dc0$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e2f3f7a5613b5dc0$var$I = !1, $e2f3f7a5613b5dc0$var$xg = a);
            }
        } else {
            if ($e2f3f7a5613b5dc0$var$Dg(a)) throw Error($e2f3f7a5613b5dc0$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e2f3f7a5613b5dc0$var$I = !1;
            $e2f3f7a5613b5dc0$var$xg = a;
        }
    }
}
function $e2f3f7a5613b5dc0$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e2f3f7a5613b5dc0$var$xg = a;
}
function $e2f3f7a5613b5dc0$var$Gg(a) {
    if (a !== $e2f3f7a5613b5dc0$var$xg) return !1;
    if (!$e2f3f7a5613b5dc0$var$I) return $e2f3f7a5613b5dc0$var$Fg(a), $e2f3f7a5613b5dc0$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e2f3f7a5613b5dc0$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e2f3f7a5613b5dc0$var$yg)) {
        if ($e2f3f7a5613b5dc0$var$Dg(a)) throw $e2f3f7a5613b5dc0$var$Hg(), Error($e2f3f7a5613b5dc0$var$p(418));
        for(; b;)$e2f3f7a5613b5dc0$var$Ag(a, b), b = $e2f3f7a5613b5dc0$var$Lf(b.nextSibling);
    }
    $e2f3f7a5613b5dc0$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e2f3f7a5613b5dc0$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e2f3f7a5613b5dc0$var$yg = null;
        }
    } else $e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$xg ? $e2f3f7a5613b5dc0$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e2f3f7a5613b5dc0$var$Hg() {
    for(var a = $e2f3f7a5613b5dc0$var$yg; a;)a = $e2f3f7a5613b5dc0$var$Lf(a.nextSibling);
}
function $e2f3f7a5613b5dc0$var$Ig() {
    $e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$xg = null;
    $e2f3f7a5613b5dc0$var$I = !1;
}
function $e2f3f7a5613b5dc0$var$Jg(a) {
    null === $e2f3f7a5613b5dc0$var$zg ? $e2f3f7a5613b5dc0$var$zg = [
        a
    ] : $e2f3f7a5613b5dc0$var$zg.push(a);
}
var $e2f3f7a5613b5dc0$var$Kg = $e2f3f7a5613b5dc0$var$ua.ReactCurrentBatchConfig;
function $e2f3f7a5613b5dc0$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e2f3f7a5613b5dc0$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e2f3f7a5613b5dc0$var$Mg = $e2f3f7a5613b5dc0$var$Uf(null), $e2f3f7a5613b5dc0$var$Ng = null, $e2f3f7a5613b5dc0$var$Og = null, $e2f3f7a5613b5dc0$var$Pg = null;
function $e2f3f7a5613b5dc0$var$Qg() {
    $e2f3f7a5613b5dc0$var$Pg = $e2f3f7a5613b5dc0$var$Og = $e2f3f7a5613b5dc0$var$Ng = null;
}
function $e2f3f7a5613b5dc0$var$Rg(a) {
    var b = $e2f3f7a5613b5dc0$var$Mg.current;
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Mg);
    a._currentValue = b;
}
function $e2f3f7a5613b5dc0$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e2f3f7a5613b5dc0$var$Tg(a, b) {
    $e2f3f7a5613b5dc0$var$Ng = a;
    $e2f3f7a5613b5dc0$var$Pg = $e2f3f7a5613b5dc0$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e2f3f7a5613b5dc0$var$Ug = !0), a.firstContext = null);
}
function $e2f3f7a5613b5dc0$var$Vg(a) {
    var b = a._currentValue;
    if ($e2f3f7a5613b5dc0$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e2f3f7a5613b5dc0$var$Og) {
            if (null === $e2f3f7a5613b5dc0$var$Ng) throw Error($e2f3f7a5613b5dc0$var$p(308));
            $e2f3f7a5613b5dc0$var$Og = a;
            $e2f3f7a5613b5dc0$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e2f3f7a5613b5dc0$var$Og = $e2f3f7a5613b5dc0$var$Og.next = a;
    }
    return b;
}
var $e2f3f7a5613b5dc0$var$Wg = null;
function $e2f3f7a5613b5dc0$var$Xg(a) {
    null === $e2f3f7a5613b5dc0$var$Wg ? $e2f3f7a5613b5dc0$var$Wg = [
        a
    ] : $e2f3f7a5613b5dc0$var$Wg.push(a);
}
function $e2f3f7a5613b5dc0$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e2f3f7a5613b5dc0$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e2f3f7a5613b5dc0$var$Zg(a, d);
}
function $e2f3f7a5613b5dc0$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e2f3f7a5613b5dc0$var$$g = !1;
function $e2f3f7a5613b5dc0$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e2f3f7a5613b5dc0$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e2f3f7a5613b5dc0$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e2f3f7a5613b5dc0$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e2f3f7a5613b5dc0$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e2f3f7a5613b5dc0$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e2f3f7a5613b5dc0$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e2f3f7a5613b5dc0$var$Zg(a, c);
}
function $e2f3f7a5613b5dc0$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e2f3f7a5613b5dc0$var$Cc(a, c);
    }
}
function $e2f3f7a5613b5dc0$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e2f3f7a5613b5dc0$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e2f3f7a5613b5dc0$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e2f3f7a5613b5dc0$var$A({}, q, r);
                            break a;
                        case 2:
                            $e2f3f7a5613b5dc0$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e2f3f7a5613b5dc0$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e2f3f7a5613b5dc0$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e2f3f7a5613b5dc0$var$p(191, e));
            e.call(d);
        }
    }
}
var $e2f3f7a5613b5dc0$var$jh = (new $6P6dz.Component).refs;
function $e2f3f7a5613b5dc0$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e2f3f7a5613b5dc0$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e2f3f7a5613b5dc0$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e2f3f7a5613b5dc0$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e2f3f7a5613b5dc0$var$L(), e = $e2f3f7a5613b5dc0$var$lh(a), f = $e2f3f7a5613b5dc0$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e2f3f7a5613b5dc0$var$dh(a, f, e);
        null !== b && ($e2f3f7a5613b5dc0$var$mh(b, a, e, d), $e2f3f7a5613b5dc0$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e2f3f7a5613b5dc0$var$L(), e = $e2f3f7a5613b5dc0$var$lh(a), f = $e2f3f7a5613b5dc0$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e2f3f7a5613b5dc0$var$dh(a, f, e);
        null !== b && ($e2f3f7a5613b5dc0$var$mh(b, a, e, d), $e2f3f7a5613b5dc0$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e2f3f7a5613b5dc0$var$L(), d = $e2f3f7a5613b5dc0$var$lh(a), e = $e2f3f7a5613b5dc0$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e2f3f7a5613b5dc0$var$dh(a, e, d);
        null !== b && ($e2f3f7a5613b5dc0$var$mh(b, a, d, c), $e2f3f7a5613b5dc0$var$eh(b, a, d));
    }
};
function $e2f3f7a5613b5dc0$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e2f3f7a5613b5dc0$var$Ie(c, d) || !$e2f3f7a5613b5dc0$var$Ie(e, f) : !0;
}
function $e2f3f7a5613b5dc0$var$ph(a, b, c) {
    var d = !1, e = $e2f3f7a5613b5dc0$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e2f3f7a5613b5dc0$var$Vg(f) : (e = $e2f3f7a5613b5dc0$var$Zf(b) ? $e2f3f7a5613b5dc0$var$Xf : $e2f3f7a5613b5dc0$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e2f3f7a5613b5dc0$var$Yf(a, e) : $e2f3f7a5613b5dc0$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e2f3f7a5613b5dc0$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e2f3f7a5613b5dc0$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e2f3f7a5613b5dc0$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e2f3f7a5613b5dc0$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e2f3f7a5613b5dc0$var$jh;
    $e2f3f7a5613b5dc0$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e2f3f7a5613b5dc0$var$Vg(f) : (f = $e2f3f7a5613b5dc0$var$Zf(b) ? $e2f3f7a5613b5dc0$var$Xf : $e2f3f7a5613b5dc0$var$H.current, e.context = $e2f3f7a5613b5dc0$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e2f3f7a5613b5dc0$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e2f3f7a5613b5dc0$var$nh.enqueueReplaceState(e, e.state, null), $e2f3f7a5613b5dc0$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e2f3f7a5613b5dc0$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e2f3f7a5613b5dc0$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e2f3f7a5613b5dc0$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e2f3f7a5613b5dc0$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e2f3f7a5613b5dc0$var$p(284));
        if (!c._owner) throw Error($e2f3f7a5613b5dc0$var$p(290, a));
    }
    return a;
}
function $e2f3f7a5613b5dc0$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e2f3f7a5613b5dc0$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e2f3f7a5613b5dc0$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e2f3f7a5613b5dc0$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e2f3f7a5613b5dc0$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e2f3f7a5613b5dc0$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e2f3f7a5613b5dc0$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e2f3f7a5613b5dc0$var$Ha && $e2f3f7a5613b5dc0$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e2f3f7a5613b5dc0$var$sh(a, b, c), d.return = a, d;
        d = $e2f3f7a5613b5dc0$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e2f3f7a5613b5dc0$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e2f3f7a5613b5dc0$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e2f3f7a5613b5dc0$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e2f3f7a5613b5dc0$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e2f3f7a5613b5dc0$var$va:
                    return c = $e2f3f7a5613b5dc0$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e2f3f7a5613b5dc0$var$sh(a, null, b), c.return = a, c;
                case $e2f3f7a5613b5dc0$var$wa:
                    return b = $e2f3f7a5613b5dc0$var$zh(b, a.mode, c), b.return = a, b;
                case $e2f3f7a5613b5dc0$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e2f3f7a5613b5dc0$var$eb(b) || $e2f3f7a5613b5dc0$var$Ka(b)) return b = $e2f3f7a5613b5dc0$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e2f3f7a5613b5dc0$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e2f3f7a5613b5dc0$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e2f3f7a5613b5dc0$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e2f3f7a5613b5dc0$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e2f3f7a5613b5dc0$var$eb(c) || $e2f3f7a5613b5dc0$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e2f3f7a5613b5dc0$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e2f3f7a5613b5dc0$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e2f3f7a5613b5dc0$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e2f3f7a5613b5dc0$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e2f3f7a5613b5dc0$var$eb(d) || $e2f3f7a5613b5dc0$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e2f3f7a5613b5dc0$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e2f3f7a5613b5dc0$var$Ka(h);
        if ("function" !== typeof l) throw Error($e2f3f7a5613b5dc0$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e2f3f7a5613b5dc0$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e2f3f7a5613b5dc0$var$I && $e2f3f7a5613b5dc0$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e2f3f7a5613b5dc0$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e2f3f7a5613b5dc0$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e2f3f7a5613b5dc0$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e2f3f7a5613b5dc0$var$Ha && $e2f3f7a5613b5dc0$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e2f3f7a5613b5dc0$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e2f3f7a5613b5dc0$var$ya ? (d = $e2f3f7a5613b5dc0$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e2f3f7a5613b5dc0$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e2f3f7a5613b5dc0$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e2f3f7a5613b5dc0$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e2f3f7a5613b5dc0$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e2f3f7a5613b5dc0$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e2f3f7a5613b5dc0$var$eb(f)) return n(a, d, f, h);
            if ($e2f3f7a5613b5dc0$var$Ka(f)) return t(a, d, f, h);
            $e2f3f7a5613b5dc0$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e2f3f7a5613b5dc0$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e2f3f7a5613b5dc0$var$Bh = $e2f3f7a5613b5dc0$var$vh(!0), $e2f3f7a5613b5dc0$var$Ch = $e2f3f7a5613b5dc0$var$vh(!1), $e2f3f7a5613b5dc0$var$Dh = {}, $e2f3f7a5613b5dc0$var$Eh = $e2f3f7a5613b5dc0$var$Uf($e2f3f7a5613b5dc0$var$Dh), $e2f3f7a5613b5dc0$var$Fh = $e2f3f7a5613b5dc0$var$Uf($e2f3f7a5613b5dc0$var$Dh), $e2f3f7a5613b5dc0$var$Gh = $e2f3f7a5613b5dc0$var$Uf($e2f3f7a5613b5dc0$var$Dh);
function $e2f3f7a5613b5dc0$var$Hh(a) {
    if (a === $e2f3f7a5613b5dc0$var$Dh) throw Error($e2f3f7a5613b5dc0$var$p(174));
    return a;
}
function $e2f3f7a5613b5dc0$var$Ih(a, b) {
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Gh, b);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Fh, a);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Eh, $e2f3f7a5613b5dc0$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e2f3f7a5613b5dc0$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e2f3f7a5613b5dc0$var$lb(b, a);
    }
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Eh);
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Eh, b);
}
function $e2f3f7a5613b5dc0$var$Jh() {
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Eh);
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Fh);
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Gh);
}
function $e2f3f7a5613b5dc0$var$Kh(a) {
    $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Gh.current);
    var b = $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Eh.current);
    var c = $e2f3f7a5613b5dc0$var$lb(b, a.type);
    b !== c && ($e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Fh, a), $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Eh, c));
}
function $e2f3f7a5613b5dc0$var$Lh(a) {
    $e2f3f7a5613b5dc0$var$Fh.current === a && ($e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Eh), $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Fh));
}
var $e2f3f7a5613b5dc0$var$M = $e2f3f7a5613b5dc0$var$Uf(0);
function $e2f3f7a5613b5dc0$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e2f3f7a5613b5dc0$var$Nh = [];
function $e2f3f7a5613b5dc0$var$Oh() {
    for(var a = 0; a < $e2f3f7a5613b5dc0$var$Nh.length; a++)$e2f3f7a5613b5dc0$var$Nh[a]._workInProgressVersionPrimary = null;
    $e2f3f7a5613b5dc0$var$Nh.length = 0;
}
var $e2f3f7a5613b5dc0$var$Ph = $e2f3f7a5613b5dc0$var$ua.ReactCurrentDispatcher, $e2f3f7a5613b5dc0$var$Qh = $e2f3f7a5613b5dc0$var$ua.ReactCurrentBatchConfig, $e2f3f7a5613b5dc0$var$Rh = 0, $e2f3f7a5613b5dc0$var$N = null, $e2f3f7a5613b5dc0$var$O = null, $e2f3f7a5613b5dc0$var$P = null, $e2f3f7a5613b5dc0$var$Sh = !1, $e2f3f7a5613b5dc0$var$Th = !1, $e2f3f7a5613b5dc0$var$Uh = 0, $e2f3f7a5613b5dc0$var$Vh = 0;
function $e2f3f7a5613b5dc0$var$Q() {
    throw Error($e2f3f7a5613b5dc0$var$p(321));
}
function $e2f3f7a5613b5dc0$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e2f3f7a5613b5dc0$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e2f3f7a5613b5dc0$var$Xh(a, b, c, d, e, f) {
    $e2f3f7a5613b5dc0$var$Rh = f;
    $e2f3f7a5613b5dc0$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e2f3f7a5613b5dc0$var$Ph.current = null === a || null === a.memoizedState ? $e2f3f7a5613b5dc0$var$Yh : $e2f3f7a5613b5dc0$var$Zh;
    a = c(d, e);
    if ($e2f3f7a5613b5dc0$var$Th) {
        f = 0;
        do {
            $e2f3f7a5613b5dc0$var$Th = !1;
            $e2f3f7a5613b5dc0$var$Uh = 0;
            if (25 <= f) throw Error($e2f3f7a5613b5dc0$var$p(301));
            f += 1;
            $e2f3f7a5613b5dc0$var$P = $e2f3f7a5613b5dc0$var$O = null;
            b.updateQueue = null;
            $e2f3f7a5613b5dc0$var$Ph.current = $e2f3f7a5613b5dc0$var$$h;
            a = c(d, e);
        }while ($e2f3f7a5613b5dc0$var$Th);
    }
    $e2f3f7a5613b5dc0$var$Ph.current = $e2f3f7a5613b5dc0$var$ai;
    b = null !== $e2f3f7a5613b5dc0$var$O && null !== $e2f3f7a5613b5dc0$var$O.next;
    $e2f3f7a5613b5dc0$var$Rh = 0;
    $e2f3f7a5613b5dc0$var$P = $e2f3f7a5613b5dc0$var$O = $e2f3f7a5613b5dc0$var$N = null;
    $e2f3f7a5613b5dc0$var$Sh = !1;
    if (b) throw Error($e2f3f7a5613b5dc0$var$p(300));
    return a;
}
function $e2f3f7a5613b5dc0$var$bi() {
    var a = 0 !== $e2f3f7a5613b5dc0$var$Uh;
    $e2f3f7a5613b5dc0$var$Uh = 0;
    return a;
}
function $e2f3f7a5613b5dc0$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e2f3f7a5613b5dc0$var$P ? $e2f3f7a5613b5dc0$var$N.memoizedState = $e2f3f7a5613b5dc0$var$P = a : $e2f3f7a5613b5dc0$var$P = $e2f3f7a5613b5dc0$var$P.next = a;
    return $e2f3f7a5613b5dc0$var$P;
}
function $e2f3f7a5613b5dc0$var$di() {
    if (null === $e2f3f7a5613b5dc0$var$O) {
        var a = $e2f3f7a5613b5dc0$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e2f3f7a5613b5dc0$var$O.next;
    var b = null === $e2f3f7a5613b5dc0$var$P ? $e2f3f7a5613b5dc0$var$N.memoizedState : $e2f3f7a5613b5dc0$var$P.next;
    if (null !== b) $e2f3f7a5613b5dc0$var$P = b, $e2f3f7a5613b5dc0$var$O = a;
    else {
        if (null === a) throw Error($e2f3f7a5613b5dc0$var$p(310));
        $e2f3f7a5613b5dc0$var$O = a;
        a = {
            memoizedState: $e2f3f7a5613b5dc0$var$O.memoizedState,
            baseState: $e2f3f7a5613b5dc0$var$O.baseState,
            baseQueue: $e2f3f7a5613b5dc0$var$O.baseQueue,
            queue: $e2f3f7a5613b5dc0$var$O.queue,
            next: null
        };
        null === $e2f3f7a5613b5dc0$var$P ? $e2f3f7a5613b5dc0$var$N.memoizedState = $e2f3f7a5613b5dc0$var$P = a : $e2f3f7a5613b5dc0$var$P = $e2f3f7a5613b5dc0$var$P.next = a;
    }
    return $e2f3f7a5613b5dc0$var$P;
}
function $e2f3f7a5613b5dc0$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e2f3f7a5613b5dc0$var$fi(a) {
    var b = $e2f3f7a5613b5dc0$var$di(), c = b.queue;
    if (null === c) throw Error($e2f3f7a5613b5dc0$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e2f3f7a5613b5dc0$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e2f3f7a5613b5dc0$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e2f3f7a5613b5dc0$var$N.lanes |= m;
                $e2f3f7a5613b5dc0$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e2f3f7a5613b5dc0$var$He(d, b.memoizedState) || ($e2f3f7a5613b5dc0$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e2f3f7a5613b5dc0$var$N.lanes |= f, $e2f3f7a5613b5dc0$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e2f3f7a5613b5dc0$var$gi(a) {
    var b = $e2f3f7a5613b5dc0$var$di(), c = b.queue;
    if (null === c) throw Error($e2f3f7a5613b5dc0$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e2f3f7a5613b5dc0$var$He(f, b.memoizedState) || ($e2f3f7a5613b5dc0$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e2f3f7a5613b5dc0$var$hi() {}
function $e2f3f7a5613b5dc0$var$ii(a, b) {
    var c = $e2f3f7a5613b5dc0$var$N, d = $e2f3f7a5613b5dc0$var$di(), e = b(), f = !$e2f3f7a5613b5dc0$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e2f3f7a5613b5dc0$var$Ug = !0);
    d = d.queue;
    $e2f3f7a5613b5dc0$var$ji($e2f3f7a5613b5dc0$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e2f3f7a5613b5dc0$var$P && $e2f3f7a5613b5dc0$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e2f3f7a5613b5dc0$var$li(9, $e2f3f7a5613b5dc0$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e2f3f7a5613b5dc0$var$R) throw Error($e2f3f7a5613b5dc0$var$p(349));
        0 !== ($e2f3f7a5613b5dc0$var$Rh & 30) || $e2f3f7a5613b5dc0$var$ni(c, b, e);
    }
    return e;
}
function $e2f3f7a5613b5dc0$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e2f3f7a5613b5dc0$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e2f3f7a5613b5dc0$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e2f3f7a5613b5dc0$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e2f3f7a5613b5dc0$var$oi(b) && $e2f3f7a5613b5dc0$var$pi(a);
}
function $e2f3f7a5613b5dc0$var$ki(a, b, c) {
    return c(function() {
        $e2f3f7a5613b5dc0$var$oi(b) && $e2f3f7a5613b5dc0$var$pi(a);
    });
}
function $e2f3f7a5613b5dc0$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e2f3f7a5613b5dc0$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e2f3f7a5613b5dc0$var$pi(a) {
    var b = $e2f3f7a5613b5dc0$var$Zg(a, 1);
    null !== b && $e2f3f7a5613b5dc0$var$mh(b, a, 1, -1);
}
function $e2f3f7a5613b5dc0$var$qi(a) {
    var b = $e2f3f7a5613b5dc0$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e2f3f7a5613b5dc0$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e2f3f7a5613b5dc0$var$ri.bind(null, $e2f3f7a5613b5dc0$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e2f3f7a5613b5dc0$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e2f3f7a5613b5dc0$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e2f3f7a5613b5dc0$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e2f3f7a5613b5dc0$var$si() {
    return $e2f3f7a5613b5dc0$var$di().memoizedState;
}
function $e2f3f7a5613b5dc0$var$ti(a, b, c, d) {
    var e = $e2f3f7a5613b5dc0$var$ci();
    $e2f3f7a5613b5dc0$var$N.flags |= a;
    e.memoizedState = $e2f3f7a5613b5dc0$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e2f3f7a5613b5dc0$var$ui(a, b, c, d) {
    var e = $e2f3f7a5613b5dc0$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e2f3f7a5613b5dc0$var$O) {
        var g = $e2f3f7a5613b5dc0$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e2f3f7a5613b5dc0$var$Wh(d, g.deps)) {
            e.memoizedState = $e2f3f7a5613b5dc0$var$li(b, c, f, d);
            return;
        }
    }
    $e2f3f7a5613b5dc0$var$N.flags |= a;
    e.memoizedState = $e2f3f7a5613b5dc0$var$li(1 | b, c, f, d);
}
function $e2f3f7a5613b5dc0$var$vi(a, b) {
    return $e2f3f7a5613b5dc0$var$ti(8390656, 8, a, b);
}
function $e2f3f7a5613b5dc0$var$ji(a, b) {
    return $e2f3f7a5613b5dc0$var$ui(2048, 8, a, b);
}
function $e2f3f7a5613b5dc0$var$wi(a, b) {
    return $e2f3f7a5613b5dc0$var$ui(4, 2, a, b);
}
function $e2f3f7a5613b5dc0$var$xi(a, b) {
    return $e2f3f7a5613b5dc0$var$ui(4, 4, a, b);
}
function $e2f3f7a5613b5dc0$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e2f3f7a5613b5dc0$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e2f3f7a5613b5dc0$var$ui(4, 4, $e2f3f7a5613b5dc0$var$yi.bind(null, b, a), c);
}
function $e2f3f7a5613b5dc0$var$Ai() {}
function $e2f3f7a5613b5dc0$var$Bi(a, b) {
    var c = $e2f3f7a5613b5dc0$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e2f3f7a5613b5dc0$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e2f3f7a5613b5dc0$var$Ci(a, b) {
    var c = $e2f3f7a5613b5dc0$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e2f3f7a5613b5dc0$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e2f3f7a5613b5dc0$var$Di(a, b, c) {
    if (0 === ($e2f3f7a5613b5dc0$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e2f3f7a5613b5dc0$var$Ug = !0), a.memoizedState = c;
    $e2f3f7a5613b5dc0$var$He(c, b) || (c = $e2f3f7a5613b5dc0$var$yc(), $e2f3f7a5613b5dc0$var$N.lanes |= c, $e2f3f7a5613b5dc0$var$hh |= c, a.baseState = !0);
    return b;
}
function $e2f3f7a5613b5dc0$var$Ei(a, b) {
    var c = $e2f3f7a5613b5dc0$var$C;
    $e2f3f7a5613b5dc0$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e2f3f7a5613b5dc0$var$Qh.transition;
    $e2f3f7a5613b5dc0$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e2f3f7a5613b5dc0$var$C = c, $e2f3f7a5613b5dc0$var$Qh.transition = d;
    }
}
function $e2f3f7a5613b5dc0$var$Fi() {
    return $e2f3f7a5613b5dc0$var$di().memoizedState;
}
function $e2f3f7a5613b5dc0$var$Gi(a, b, c) {
    var d = $e2f3f7a5613b5dc0$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e2f3f7a5613b5dc0$var$Hi(a)) $e2f3f7a5613b5dc0$var$Ii(b, c);
    else if (c = $e2f3f7a5613b5dc0$var$Yg(a, b, c, d), null !== c) {
        var e = $e2f3f7a5613b5dc0$var$L();
        $e2f3f7a5613b5dc0$var$mh(c, a, d, e);
        $e2f3f7a5613b5dc0$var$Ji(c, b, d);
    }
}
function $e2f3f7a5613b5dc0$var$ri(a, b, c) {
    var d = $e2f3f7a5613b5dc0$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e2f3f7a5613b5dc0$var$Hi(a)) $e2f3f7a5613b5dc0$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e2f3f7a5613b5dc0$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e2f3f7a5613b5dc0$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e2f3f7a5613b5dc0$var$Yg(a, b, e, d);
        null !== c && (e = $e2f3f7a5613b5dc0$var$L(), $e2f3f7a5613b5dc0$var$mh(c, a, d, e), $e2f3f7a5613b5dc0$var$Ji(c, b, d));
    }
}
function $e2f3f7a5613b5dc0$var$Hi(a) {
    var b = a.alternate;
    return a === $e2f3f7a5613b5dc0$var$N || null !== b && b === $e2f3f7a5613b5dc0$var$N;
}
function $e2f3f7a5613b5dc0$var$Ii(a, b) {
    $e2f3f7a5613b5dc0$var$Th = $e2f3f7a5613b5dc0$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e2f3f7a5613b5dc0$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e2f3f7a5613b5dc0$var$Cc(a, c);
    }
}
var $e2f3f7a5613b5dc0$var$ai = {
    readContext: $e2f3f7a5613b5dc0$var$Vg,
    useCallback: $e2f3f7a5613b5dc0$var$Q,
    useContext: $e2f3f7a5613b5dc0$var$Q,
    useEffect: $e2f3f7a5613b5dc0$var$Q,
    useImperativeHandle: $e2f3f7a5613b5dc0$var$Q,
    useInsertionEffect: $e2f3f7a5613b5dc0$var$Q,
    useLayoutEffect: $e2f3f7a5613b5dc0$var$Q,
    useMemo: $e2f3f7a5613b5dc0$var$Q,
    useReducer: $e2f3f7a5613b5dc0$var$Q,
    useRef: $e2f3f7a5613b5dc0$var$Q,
    useState: $e2f3f7a5613b5dc0$var$Q,
    useDebugValue: $e2f3f7a5613b5dc0$var$Q,
    useDeferredValue: $e2f3f7a5613b5dc0$var$Q,
    useTransition: $e2f3f7a5613b5dc0$var$Q,
    useMutableSource: $e2f3f7a5613b5dc0$var$Q,
    useSyncExternalStore: $e2f3f7a5613b5dc0$var$Q,
    useId: $e2f3f7a5613b5dc0$var$Q,
    unstable_isNewReconciler: !1
}, $e2f3f7a5613b5dc0$var$Yh = {
    readContext: $e2f3f7a5613b5dc0$var$Vg,
    useCallback: function(a, b) {
        $e2f3f7a5613b5dc0$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e2f3f7a5613b5dc0$var$Vg,
    useEffect: $e2f3f7a5613b5dc0$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e2f3f7a5613b5dc0$var$ti(4194308, 4, $e2f3f7a5613b5dc0$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e2f3f7a5613b5dc0$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e2f3f7a5613b5dc0$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e2f3f7a5613b5dc0$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e2f3f7a5613b5dc0$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e2f3f7a5613b5dc0$var$Gi.bind(null, $e2f3f7a5613b5dc0$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e2f3f7a5613b5dc0$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e2f3f7a5613b5dc0$var$qi,
    useDebugValue: $e2f3f7a5613b5dc0$var$Ai,
    useDeferredValue: function(a) {
        return $e2f3f7a5613b5dc0$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e2f3f7a5613b5dc0$var$qi(!1), b = a[0];
        a = $e2f3f7a5613b5dc0$var$Ei.bind(null, a[1]);
        $e2f3f7a5613b5dc0$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e2f3f7a5613b5dc0$var$N, e = $e2f3f7a5613b5dc0$var$ci();
        if ($e2f3f7a5613b5dc0$var$I) {
            if (void 0 === c) throw Error($e2f3f7a5613b5dc0$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e2f3f7a5613b5dc0$var$R) throw Error($e2f3f7a5613b5dc0$var$p(349));
            0 !== ($e2f3f7a5613b5dc0$var$Rh & 30) || $e2f3f7a5613b5dc0$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e2f3f7a5613b5dc0$var$vi($e2f3f7a5613b5dc0$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e2f3f7a5613b5dc0$var$li(9, $e2f3f7a5613b5dc0$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e2f3f7a5613b5dc0$var$ci(), b = $e2f3f7a5613b5dc0$var$R.identifierPrefix;
        if ($e2f3f7a5613b5dc0$var$I) {
            var c = $e2f3f7a5613b5dc0$var$sg;
            var d = $e2f3f7a5613b5dc0$var$rg;
            c = (d & ~(1 << 32 - $e2f3f7a5613b5dc0$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e2f3f7a5613b5dc0$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e2f3f7a5613b5dc0$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e2f3f7a5613b5dc0$var$Zh = {
    readContext: $e2f3f7a5613b5dc0$var$Vg,
    useCallback: $e2f3f7a5613b5dc0$var$Bi,
    useContext: $e2f3f7a5613b5dc0$var$Vg,
    useEffect: $e2f3f7a5613b5dc0$var$ji,
    useImperativeHandle: $e2f3f7a5613b5dc0$var$zi,
    useInsertionEffect: $e2f3f7a5613b5dc0$var$wi,
    useLayoutEffect: $e2f3f7a5613b5dc0$var$xi,
    useMemo: $e2f3f7a5613b5dc0$var$Ci,
    useReducer: $e2f3f7a5613b5dc0$var$fi,
    useRef: $e2f3f7a5613b5dc0$var$si,
    useState: function() {
        return $e2f3f7a5613b5dc0$var$fi($e2f3f7a5613b5dc0$var$ei);
    },
    useDebugValue: $e2f3f7a5613b5dc0$var$Ai,
    useDeferredValue: function(a) {
        var b = $e2f3f7a5613b5dc0$var$di();
        return $e2f3f7a5613b5dc0$var$Di(b, $e2f3f7a5613b5dc0$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e2f3f7a5613b5dc0$var$fi($e2f3f7a5613b5dc0$var$ei)[0], b = $e2f3f7a5613b5dc0$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e2f3f7a5613b5dc0$var$hi,
    useSyncExternalStore: $e2f3f7a5613b5dc0$var$ii,
    useId: $e2f3f7a5613b5dc0$var$Fi,
    unstable_isNewReconciler: !1
}, $e2f3f7a5613b5dc0$var$$h = {
    readContext: $e2f3f7a5613b5dc0$var$Vg,
    useCallback: $e2f3f7a5613b5dc0$var$Bi,
    useContext: $e2f3f7a5613b5dc0$var$Vg,
    useEffect: $e2f3f7a5613b5dc0$var$ji,
    useImperativeHandle: $e2f3f7a5613b5dc0$var$zi,
    useInsertionEffect: $e2f3f7a5613b5dc0$var$wi,
    useLayoutEffect: $e2f3f7a5613b5dc0$var$xi,
    useMemo: $e2f3f7a5613b5dc0$var$Ci,
    useReducer: $e2f3f7a5613b5dc0$var$gi,
    useRef: $e2f3f7a5613b5dc0$var$si,
    useState: function() {
        return $e2f3f7a5613b5dc0$var$gi($e2f3f7a5613b5dc0$var$ei);
    },
    useDebugValue: $e2f3f7a5613b5dc0$var$Ai,
    useDeferredValue: function(a) {
        var b = $e2f3f7a5613b5dc0$var$di();
        return null === $e2f3f7a5613b5dc0$var$O ? b.memoizedState = a : $e2f3f7a5613b5dc0$var$Di(b, $e2f3f7a5613b5dc0$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e2f3f7a5613b5dc0$var$gi($e2f3f7a5613b5dc0$var$ei)[0], b = $e2f3f7a5613b5dc0$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e2f3f7a5613b5dc0$var$hi,
    useSyncExternalStore: $e2f3f7a5613b5dc0$var$ii,
    useId: $e2f3f7a5613b5dc0$var$Fi,
    unstable_isNewReconciler: !1
};
function $e2f3f7a5613b5dc0$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e2f3f7a5613b5dc0$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e2f3f7a5613b5dc0$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e2f3f7a5613b5dc0$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e2f3f7a5613b5dc0$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e2f3f7a5613b5dc0$var$Oi(a, b, c) {
    c = $e2f3f7a5613b5dc0$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e2f3f7a5613b5dc0$var$Pi || ($e2f3f7a5613b5dc0$var$Pi = !0, $e2f3f7a5613b5dc0$var$Qi = d);
        $e2f3f7a5613b5dc0$var$Mi(a, b);
    };
    return c;
}
function $e2f3f7a5613b5dc0$var$Ri(a, b, c) {
    c = $e2f3f7a5613b5dc0$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e2f3f7a5613b5dc0$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e2f3f7a5613b5dc0$var$Mi(a, b);
        "function" !== typeof d && (null === $e2f3f7a5613b5dc0$var$Si ? $e2f3f7a5613b5dc0$var$Si = new Set([
            this
        ]) : $e2f3f7a5613b5dc0$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e2f3f7a5613b5dc0$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e2f3f7a5613b5dc0$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e2f3f7a5613b5dc0$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e2f3f7a5613b5dc0$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e2f3f7a5613b5dc0$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e2f3f7a5613b5dc0$var$ch(-1, 1), b.tag = 2, $e2f3f7a5613b5dc0$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e2f3f7a5613b5dc0$var$Xi = $e2f3f7a5613b5dc0$var$ua.ReactCurrentOwner, $e2f3f7a5613b5dc0$var$Ug = !1;
function $e2f3f7a5613b5dc0$var$Yi(a, b, c, d) {
    b.child = null === a ? $e2f3f7a5613b5dc0$var$Ch(b, null, c, d) : $e2f3f7a5613b5dc0$var$Bh(b, a.child, c, d);
}
function $e2f3f7a5613b5dc0$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e2f3f7a5613b5dc0$var$Tg(b, e);
    d = $e2f3f7a5613b5dc0$var$Xh(a, b, c, d, f, e);
    c = $e2f3f7a5613b5dc0$var$bi();
    if (null !== a && !$e2f3f7a5613b5dc0$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e2f3f7a5613b5dc0$var$$i(a, b, e);
    $e2f3f7a5613b5dc0$var$I && c && $e2f3f7a5613b5dc0$var$vg(b);
    b.flags |= 1;
    $e2f3f7a5613b5dc0$var$Yi(a, b, d, e);
    return b.child;
}
function $e2f3f7a5613b5dc0$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e2f3f7a5613b5dc0$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e2f3f7a5613b5dc0$var$cj(a, b, f, d, e);
        a = $e2f3f7a5613b5dc0$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e2f3f7a5613b5dc0$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e2f3f7a5613b5dc0$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e2f3f7a5613b5dc0$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e2f3f7a5613b5dc0$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e2f3f7a5613b5dc0$var$Ie(f, d) && a.ref === b.ref) {
            if ($e2f3f7a5613b5dc0$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e2f3f7a5613b5dc0$var$Ug = !0);
            else return b.lanes = a.lanes, $e2f3f7a5613b5dc0$var$$i(a, b, e);
        }
    }
    return $e2f3f7a5613b5dc0$var$dj(a, b, c, d, e);
}
function $e2f3f7a5613b5dc0$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$fj, $e2f3f7a5613b5dc0$var$gj), $e2f3f7a5613b5dc0$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$fj, $e2f3f7a5613b5dc0$var$gj), $e2f3f7a5613b5dc0$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$fj, $e2f3f7a5613b5dc0$var$gj);
            $e2f3f7a5613b5dc0$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$fj, $e2f3f7a5613b5dc0$var$gj), $e2f3f7a5613b5dc0$var$gj |= d;
    $e2f3f7a5613b5dc0$var$Yi(a, b, e, c);
    return b.child;
}
function $e2f3f7a5613b5dc0$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e2f3f7a5613b5dc0$var$dj(a, b, c, d, e) {
    var f = $e2f3f7a5613b5dc0$var$Zf(c) ? $e2f3f7a5613b5dc0$var$Xf : $e2f3f7a5613b5dc0$var$H.current;
    f = $e2f3f7a5613b5dc0$var$Yf(b, f);
    $e2f3f7a5613b5dc0$var$Tg(b, e);
    c = $e2f3f7a5613b5dc0$var$Xh(a, b, c, d, f, e);
    d = $e2f3f7a5613b5dc0$var$bi();
    if (null !== a && !$e2f3f7a5613b5dc0$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e2f3f7a5613b5dc0$var$$i(a, b, e);
    $e2f3f7a5613b5dc0$var$I && d && $e2f3f7a5613b5dc0$var$vg(b);
    b.flags |= 1;
    $e2f3f7a5613b5dc0$var$Yi(a, b, c, e);
    return b.child;
}
function $e2f3f7a5613b5dc0$var$ij(a, b, c, d, e) {
    if ($e2f3f7a5613b5dc0$var$Zf(c)) {
        var f = !0;
        $e2f3f7a5613b5dc0$var$cg(b);
    } else f = !1;
    $e2f3f7a5613b5dc0$var$Tg(b, e);
    if (null === b.stateNode) $e2f3f7a5613b5dc0$var$jj(a, b), $e2f3f7a5613b5dc0$var$ph(b, c, d), $e2f3f7a5613b5dc0$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e2f3f7a5613b5dc0$var$Vg(l) : (l = $e2f3f7a5613b5dc0$var$Zf(c) ? $e2f3f7a5613b5dc0$var$Xf : $e2f3f7a5613b5dc0$var$H.current, l = $e2f3f7a5613b5dc0$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e2f3f7a5613b5dc0$var$qh(b, g, d, l);
        $e2f3f7a5613b5dc0$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e2f3f7a5613b5dc0$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e2f3f7a5613b5dc0$var$Wf.current || $e2f3f7a5613b5dc0$var$$g ? ("function" === typeof m && ($e2f3f7a5613b5dc0$var$kh(b, c, m, d), k = b.memoizedState), (h = $e2f3f7a5613b5dc0$var$$g || $e2f3f7a5613b5dc0$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e2f3f7a5613b5dc0$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e2f3f7a5613b5dc0$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e2f3f7a5613b5dc0$var$Vg(k) : (k = $e2f3f7a5613b5dc0$var$Zf(c) ? $e2f3f7a5613b5dc0$var$Xf : $e2f3f7a5613b5dc0$var$H.current, k = $e2f3f7a5613b5dc0$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e2f3f7a5613b5dc0$var$qh(b, g, d, k);
        $e2f3f7a5613b5dc0$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e2f3f7a5613b5dc0$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e2f3f7a5613b5dc0$var$Wf.current || $e2f3f7a5613b5dc0$var$$g ? ("function" === typeof y && ($e2f3f7a5613b5dc0$var$kh(b, c, y, d), n = b.memoizedState), (l = $e2f3f7a5613b5dc0$var$$g || $e2f3f7a5613b5dc0$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e2f3f7a5613b5dc0$var$kj(a, b, c, d, f, e);
}
function $e2f3f7a5613b5dc0$var$kj(a, b, c, d, e, f) {
    $e2f3f7a5613b5dc0$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e2f3f7a5613b5dc0$var$dg(b, c, !1), $e2f3f7a5613b5dc0$var$$i(a, b, f);
    d = b.stateNode;
    $e2f3f7a5613b5dc0$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e2f3f7a5613b5dc0$var$Bh(b, a.child, null, f), b.child = $e2f3f7a5613b5dc0$var$Bh(b, null, h, f)) : $e2f3f7a5613b5dc0$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e2f3f7a5613b5dc0$var$dg(b, c, !0);
    return b.child;
}
function $e2f3f7a5613b5dc0$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e2f3f7a5613b5dc0$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e2f3f7a5613b5dc0$var$ag(a, b.context, !1);
    $e2f3f7a5613b5dc0$var$Ih(a, b.containerInfo);
}
function $e2f3f7a5613b5dc0$var$mj(a, b, c, d, e) {
    $e2f3f7a5613b5dc0$var$Ig();
    $e2f3f7a5613b5dc0$var$Jg(e);
    b.flags |= 256;
    $e2f3f7a5613b5dc0$var$Yi(a, b, c, d);
    return b.child;
}
var $e2f3f7a5613b5dc0$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e2f3f7a5613b5dc0$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e2f3f7a5613b5dc0$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e2f3f7a5613b5dc0$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, e & 1);
    if (null === a) {
        $e2f3f7a5613b5dc0$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e2f3f7a5613b5dc0$var$qj(g, d, 0, null), a = $e2f3f7a5613b5dc0$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e2f3f7a5613b5dc0$var$oj(c), b.memoizedState = $e2f3f7a5613b5dc0$var$nj, a) : $e2f3f7a5613b5dc0$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e2f3f7a5613b5dc0$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e2f3f7a5613b5dc0$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e2f3f7a5613b5dc0$var$wh(h, f) : (f = $e2f3f7a5613b5dc0$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e2f3f7a5613b5dc0$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e2f3f7a5613b5dc0$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e2f3f7a5613b5dc0$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e2f3f7a5613b5dc0$var$rj(a, b) {
    b = $e2f3f7a5613b5dc0$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e2f3f7a5613b5dc0$var$tj(a, b, c, d) {
    null !== d && $e2f3f7a5613b5dc0$var$Jg(d);
    $e2f3f7a5613b5dc0$var$Bh(b, a.child, null, c);
    a = $e2f3f7a5613b5dc0$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e2f3f7a5613b5dc0$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e2f3f7a5613b5dc0$var$Li(Error($e2f3f7a5613b5dc0$var$p(422))), $e2f3f7a5613b5dc0$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e2f3f7a5613b5dc0$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e2f3f7a5613b5dc0$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e2f3f7a5613b5dc0$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e2f3f7a5613b5dc0$var$oj(g);
        b.memoizedState = $e2f3f7a5613b5dc0$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e2f3f7a5613b5dc0$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e2f3f7a5613b5dc0$var$p(419));
        d = $e2f3f7a5613b5dc0$var$Li(f, d, void 0);
        return $e2f3f7a5613b5dc0$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e2f3f7a5613b5dc0$var$Ug || h) {
        d = $e2f3f7a5613b5dc0$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e2f3f7a5613b5dc0$var$Zg(a, e), $e2f3f7a5613b5dc0$var$mh(d, a, e, -1));
        }
        $e2f3f7a5613b5dc0$var$uj();
        d = $e2f3f7a5613b5dc0$var$Li(Error($e2f3f7a5613b5dc0$var$p(421)));
        return $e2f3f7a5613b5dc0$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e2f3f7a5613b5dc0$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$Lf(e.nextSibling);
    $e2f3f7a5613b5dc0$var$xg = b;
    $e2f3f7a5613b5dc0$var$I = !0;
    $e2f3f7a5613b5dc0$var$zg = null;
    null !== a && ($e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$rg, $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$sg, $e2f3f7a5613b5dc0$var$og[$e2f3f7a5613b5dc0$var$pg++] = $e2f3f7a5613b5dc0$var$qg, $e2f3f7a5613b5dc0$var$rg = a.id, $e2f3f7a5613b5dc0$var$sg = a.overflow, $e2f3f7a5613b5dc0$var$qg = b);
    b = $e2f3f7a5613b5dc0$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e2f3f7a5613b5dc0$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e2f3f7a5613b5dc0$var$Sg(a.return, b, c);
}
function $e2f3f7a5613b5dc0$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e2f3f7a5613b5dc0$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e2f3f7a5613b5dc0$var$Yi(a, b, d.children, c);
    d = $e2f3f7a5613b5dc0$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e2f3f7a5613b5dc0$var$wj(a, c, b);
            else if (19 === a.tag) $e2f3f7a5613b5dc0$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e2f3f7a5613b5dc0$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e2f3f7a5613b5dc0$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e2f3f7a5613b5dc0$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e2f3f7a5613b5dc0$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e2f3f7a5613b5dc0$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e2f3f7a5613b5dc0$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e2f3f7a5613b5dc0$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e2f3f7a5613b5dc0$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e2f3f7a5613b5dc0$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e2f3f7a5613b5dc0$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e2f3f7a5613b5dc0$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e2f3f7a5613b5dc0$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e2f3f7a5613b5dc0$var$lj(b);
            $e2f3f7a5613b5dc0$var$Ig();
            break;
        case 5:
            $e2f3f7a5613b5dc0$var$Kh(b);
            break;
        case 1:
            $e2f3f7a5613b5dc0$var$Zf(b.type) && $e2f3f7a5613b5dc0$var$cg(b);
            break;
        case 4:
            $e2f3f7a5613b5dc0$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, $e2f3f7a5613b5dc0$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e2f3f7a5613b5dc0$var$pj(a, b, c);
                $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, $e2f3f7a5613b5dc0$var$M.current & 1);
                a = $e2f3f7a5613b5dc0$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, $e2f3f7a5613b5dc0$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e2f3f7a5613b5dc0$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, $e2f3f7a5613b5dc0$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e2f3f7a5613b5dc0$var$ej(a, b, c);
    }
    return $e2f3f7a5613b5dc0$var$$i(a, b, c);
}
var $e2f3f7a5613b5dc0$var$Aj, $e2f3f7a5613b5dc0$var$Bj, $e2f3f7a5613b5dc0$var$Cj, $e2f3f7a5613b5dc0$var$Dj;
$e2f3f7a5613b5dc0$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e2f3f7a5613b5dc0$var$Bj = function() {};
$e2f3f7a5613b5dc0$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e2f3f7a5613b5dc0$var$Ya(a, e);
                d = $e2f3f7a5613b5dc0$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e2f3f7a5613b5dc0$var$A({}, e, {
                    value: void 0
                });
                d = $e2f3f7a5613b5dc0$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e2f3f7a5613b5dc0$var$gb(a, e);
                d = $e2f3f7a5613b5dc0$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e2f3f7a5613b5dc0$var$Bf);
        }
        $e2f3f7a5613b5dc0$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e2f3f7a5613b5dc0$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e2f3f7a5613b5dc0$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e2f3f7a5613b5dc0$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e2f3f7a5613b5dc0$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e2f3f7a5613b5dc0$var$Ej(a, b) {
    if (!$e2f3f7a5613b5dc0$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e2f3f7a5613b5dc0$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e2f3f7a5613b5dc0$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e2f3f7a5613b5dc0$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e2f3f7a5613b5dc0$var$S(b), null;
        case 1:
            return $e2f3f7a5613b5dc0$var$Zf(b.type) && $e2f3f7a5613b5dc0$var$$f(), $e2f3f7a5613b5dc0$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e2f3f7a5613b5dc0$var$Jh();
            $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf);
            $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$H);
            $e2f3f7a5613b5dc0$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e2f3f7a5613b5dc0$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e2f3f7a5613b5dc0$var$zg && ($e2f3f7a5613b5dc0$var$Gj($e2f3f7a5613b5dc0$var$zg), $e2f3f7a5613b5dc0$var$zg = null));
            $e2f3f7a5613b5dc0$var$Bj(a, b);
            $e2f3f7a5613b5dc0$var$S(b);
            return null;
        case 5:
            $e2f3f7a5613b5dc0$var$Lh(b);
            var e = $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e2f3f7a5613b5dc0$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e2f3f7a5613b5dc0$var$p(166));
                    $e2f3f7a5613b5dc0$var$S(b);
                    return null;
                }
                a = $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Eh.current);
                if ($e2f3f7a5613b5dc0$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e2f3f7a5613b5dc0$var$Of] = b;
                    d[$e2f3f7a5613b5dc0$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e2f3f7a5613b5dc0$var$D("cancel", d);
                            $e2f3f7a5613b5dc0$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e2f3f7a5613b5dc0$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e2f3f7a5613b5dc0$var$lf.length; e++)$e2f3f7a5613b5dc0$var$D($e2f3f7a5613b5dc0$var$lf[e], d);
                            break;
                        case "source":
                            $e2f3f7a5613b5dc0$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e2f3f7a5613b5dc0$var$D("error", d);
                            $e2f3f7a5613b5dc0$var$D("load", d);
                            break;
                        case "details":
                            $e2f3f7a5613b5dc0$var$D("toggle", d);
                            break;
                        case "input":
                            $e2f3f7a5613b5dc0$var$Za(d, f);
                            $e2f3f7a5613b5dc0$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e2f3f7a5613b5dc0$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e2f3f7a5613b5dc0$var$hb(d, f), $e2f3f7a5613b5dc0$var$D("invalid", d);
                    }
                    $e2f3f7a5613b5dc0$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e2f3f7a5613b5dc0$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e2f3f7a5613b5dc0$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e2f3f7a5613b5dc0$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e2f3f7a5613b5dc0$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e2f3f7a5613b5dc0$var$Va(d);
                            $e2f3f7a5613b5dc0$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e2f3f7a5613b5dc0$var$Va(d);
                            $e2f3f7a5613b5dc0$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e2f3f7a5613b5dc0$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e2f3f7a5613b5dc0$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e2f3f7a5613b5dc0$var$Of] = b;
                    a[$e2f3f7a5613b5dc0$var$Pf] = d;
                    $e2f3f7a5613b5dc0$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e2f3f7a5613b5dc0$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e2f3f7a5613b5dc0$var$D("cancel", a);
                                $e2f3f7a5613b5dc0$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e2f3f7a5613b5dc0$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e2f3f7a5613b5dc0$var$lf.length; e++)$e2f3f7a5613b5dc0$var$D($e2f3f7a5613b5dc0$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e2f3f7a5613b5dc0$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e2f3f7a5613b5dc0$var$D("error", a);
                                $e2f3f7a5613b5dc0$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e2f3f7a5613b5dc0$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e2f3f7a5613b5dc0$var$Za(a, d);
                                e = $e2f3f7a5613b5dc0$var$Ya(a, d);
                                $e2f3f7a5613b5dc0$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e2f3f7a5613b5dc0$var$A({}, d, {
                                    value: void 0
                                });
                                $e2f3f7a5613b5dc0$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e2f3f7a5613b5dc0$var$hb(a, d);
                                e = $e2f3f7a5613b5dc0$var$gb(a, d);
                                $e2f3f7a5613b5dc0$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e2f3f7a5613b5dc0$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e2f3f7a5613b5dc0$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e2f3f7a5613b5dc0$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e2f3f7a5613b5dc0$var$ob(a, k) : "number" === typeof k && $e2f3f7a5613b5dc0$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e2f3f7a5613b5dc0$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e2f3f7a5613b5dc0$var$D("scroll", a) : null != k && $e2f3f7a5613b5dc0$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e2f3f7a5613b5dc0$var$Va(a);
                                $e2f3f7a5613b5dc0$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e2f3f7a5613b5dc0$var$Va(a);
                                $e2f3f7a5613b5dc0$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e2f3f7a5613b5dc0$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e2f3f7a5613b5dc0$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e2f3f7a5613b5dc0$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e2f3f7a5613b5dc0$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e2f3f7a5613b5dc0$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e2f3f7a5613b5dc0$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e2f3f7a5613b5dc0$var$p(166));
                c = $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Gh.current);
                $e2f3f7a5613b5dc0$var$Hh($e2f3f7a5613b5dc0$var$Eh.current);
                if ($e2f3f7a5613b5dc0$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e2f3f7a5613b5dc0$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e2f3f7a5613b5dc0$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e2f3f7a5613b5dc0$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e2f3f7a5613b5dc0$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e2f3f7a5613b5dc0$var$Of] = b, b.stateNode = d;
            }
            $e2f3f7a5613b5dc0$var$S(b);
            return null;
        case 13:
            $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e2f3f7a5613b5dc0$var$I && null !== $e2f3f7a5613b5dc0$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e2f3f7a5613b5dc0$var$Hg(), $e2f3f7a5613b5dc0$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e2f3f7a5613b5dc0$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e2f3f7a5613b5dc0$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e2f3f7a5613b5dc0$var$p(317));
                        f[$e2f3f7a5613b5dc0$var$Of] = b;
                    } else $e2f3f7a5613b5dc0$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e2f3f7a5613b5dc0$var$S(b);
                    f = !1;
                } else null !== $e2f3f7a5613b5dc0$var$zg && ($e2f3f7a5613b5dc0$var$Gj($e2f3f7a5613b5dc0$var$zg), $e2f3f7a5613b5dc0$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e2f3f7a5613b5dc0$var$M.current & 1) ? 0 === $e2f3f7a5613b5dc0$var$T && ($e2f3f7a5613b5dc0$var$T = 3) : $e2f3f7a5613b5dc0$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e2f3f7a5613b5dc0$var$S(b);
            return null;
        case 4:
            return $e2f3f7a5613b5dc0$var$Jh(), $e2f3f7a5613b5dc0$var$Bj(a, b), null === a && $e2f3f7a5613b5dc0$var$sf(b.stateNode.containerInfo), $e2f3f7a5613b5dc0$var$S(b), null;
        case 10:
            return $e2f3f7a5613b5dc0$var$Rg(b.type._context), $e2f3f7a5613b5dc0$var$S(b), null;
        case 17:
            return $e2f3f7a5613b5dc0$var$Zf(b.type) && $e2f3f7a5613b5dc0$var$$f(), $e2f3f7a5613b5dc0$var$S(b), null;
        case 19:
            $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M);
            f = b.memoizedState;
            if (null === f) return $e2f3f7a5613b5dc0$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e2f3f7a5613b5dc0$var$Ej(f, !1);
                else {
                    if (0 !== $e2f3f7a5613b5dc0$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e2f3f7a5613b5dc0$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e2f3f7a5613b5dc0$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, $e2f3f7a5613b5dc0$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e2f3f7a5613b5dc0$var$B() > $e2f3f7a5613b5dc0$var$Hj && (b.flags |= 128, d = !0, $e2f3f7a5613b5dc0$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e2f3f7a5613b5dc0$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e2f3f7a5613b5dc0$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e2f3f7a5613b5dc0$var$I) return $e2f3f7a5613b5dc0$var$S(b), null;
                    } else 2 * $e2f3f7a5613b5dc0$var$B() - f.renderingStartTime > $e2f3f7a5613b5dc0$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e2f3f7a5613b5dc0$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e2f3f7a5613b5dc0$var$B(), b.sibling = null, c = $e2f3f7a5613b5dc0$var$M.current, $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$M, d ? c & 1 | 2 : c & 1), b;
            $e2f3f7a5613b5dc0$var$S(b);
            return null;
        case 22:
        case 23:
            return $e2f3f7a5613b5dc0$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e2f3f7a5613b5dc0$var$gj & 1073741824) && ($e2f3f7a5613b5dc0$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e2f3f7a5613b5dc0$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e2f3f7a5613b5dc0$var$p(156, b.tag));
}
function $e2f3f7a5613b5dc0$var$Jj(a, b) {
    $e2f3f7a5613b5dc0$var$wg(b);
    switch(b.tag){
        case 1:
            return $e2f3f7a5613b5dc0$var$Zf(b.type) && $e2f3f7a5613b5dc0$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e2f3f7a5613b5dc0$var$Jh(), $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf), $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$H), $e2f3f7a5613b5dc0$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e2f3f7a5613b5dc0$var$Lh(b), null;
        case 13:
            $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e2f3f7a5613b5dc0$var$p(340));
                $e2f3f7a5613b5dc0$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M), null;
        case 4:
            return $e2f3f7a5613b5dc0$var$Jh(), null;
        case 10:
            return $e2f3f7a5613b5dc0$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e2f3f7a5613b5dc0$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e2f3f7a5613b5dc0$var$Kj = !1, $e2f3f7a5613b5dc0$var$U = !1, $e2f3f7a5613b5dc0$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e2f3f7a5613b5dc0$var$V = null;
function $e2f3f7a5613b5dc0$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e2f3f7a5613b5dc0$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e2f3f7a5613b5dc0$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e2f3f7a5613b5dc0$var$W(a, b, d);
    }
}
var $e2f3f7a5613b5dc0$var$Oj = !1;
function $e2f3f7a5613b5dc0$var$Pj(a, b) {
    $e2f3f7a5613b5dc0$var$Cf = $e2f3f7a5613b5dc0$var$dd;
    a = $e2f3f7a5613b5dc0$var$Me();
    if ($e2f3f7a5613b5dc0$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e2f3f7a5613b5dc0$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e2f3f7a5613b5dc0$var$dd = !1;
    for($e2f3f7a5613b5dc0$var$V = b; null !== $e2f3f7a5613b5dc0$var$V;)if (b = $e2f3f7a5613b5dc0$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e2f3f7a5613b5dc0$var$V = a;
    else for(; null !== $e2f3f7a5613b5dc0$var$V;){
        b = $e2f3f7a5613b5dc0$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e2f3f7a5613b5dc0$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e2f3f7a5613b5dc0$var$p(163));
            }
        } catch (F) {
            $e2f3f7a5613b5dc0$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e2f3f7a5613b5dc0$var$V = a;
            break;
        }
        $e2f3f7a5613b5dc0$var$V = b.return;
    }
    n = $e2f3f7a5613b5dc0$var$Oj;
    $e2f3f7a5613b5dc0$var$Oj = !1;
    return n;
}
function $e2f3f7a5613b5dc0$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e2f3f7a5613b5dc0$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e2f3f7a5613b5dc0$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e2f3f7a5613b5dc0$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e2f3f7a5613b5dc0$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e2f3f7a5613b5dc0$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e2f3f7a5613b5dc0$var$Of], delete b[$e2f3f7a5613b5dc0$var$Pf], delete b[$e2f3f7a5613b5dc0$var$of], delete b[$e2f3f7a5613b5dc0$var$Qf], delete b[$e2f3f7a5613b5dc0$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e2f3f7a5613b5dc0$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e2f3f7a5613b5dc0$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e2f3f7a5613b5dc0$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e2f3f7a5613b5dc0$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e2f3f7a5613b5dc0$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e2f3f7a5613b5dc0$var$Wj(a, b, c), a = a.sibling; null !== a;)$e2f3f7a5613b5dc0$var$Wj(a, b, c), a = a.sibling;
}
function $e2f3f7a5613b5dc0$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e2f3f7a5613b5dc0$var$Xj(a, b, c), a = a.sibling; null !== a;)$e2f3f7a5613b5dc0$var$Xj(a, b, c), a = a.sibling;
}
var $e2f3f7a5613b5dc0$var$X = null, $e2f3f7a5613b5dc0$var$Yj = !1;
function $e2f3f7a5613b5dc0$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e2f3f7a5613b5dc0$var$ak(a, b, c), c = c.sibling;
}
function $e2f3f7a5613b5dc0$var$ak(a, b, c) {
    if ($e2f3f7a5613b5dc0$var$lc && "function" === typeof $e2f3f7a5613b5dc0$var$lc.onCommitFiberUnmount) try {
        $e2f3f7a5613b5dc0$var$lc.onCommitFiberUnmount($e2f3f7a5613b5dc0$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e2f3f7a5613b5dc0$var$U || $e2f3f7a5613b5dc0$var$Mj(c, b);
        case 6:
            var d = $e2f3f7a5613b5dc0$var$X, e = $e2f3f7a5613b5dc0$var$Yj;
            $e2f3f7a5613b5dc0$var$X = null;
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            $e2f3f7a5613b5dc0$var$X = d;
            $e2f3f7a5613b5dc0$var$Yj = e;
            null !== $e2f3f7a5613b5dc0$var$X && ($e2f3f7a5613b5dc0$var$Yj ? (a = $e2f3f7a5613b5dc0$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e2f3f7a5613b5dc0$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e2f3f7a5613b5dc0$var$X && ($e2f3f7a5613b5dc0$var$Yj ? (a = $e2f3f7a5613b5dc0$var$X, c = c.stateNode, 8 === a.nodeType ? $e2f3f7a5613b5dc0$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e2f3f7a5613b5dc0$var$Kf(a, c), $e2f3f7a5613b5dc0$var$bd(a)) : $e2f3f7a5613b5dc0$var$Kf($e2f3f7a5613b5dc0$var$X, c.stateNode));
            break;
        case 4:
            d = $e2f3f7a5613b5dc0$var$X;
            e = $e2f3f7a5613b5dc0$var$Yj;
            $e2f3f7a5613b5dc0$var$X = c.stateNode.containerInfo;
            $e2f3f7a5613b5dc0$var$Yj = !0;
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            $e2f3f7a5613b5dc0$var$X = d;
            $e2f3f7a5613b5dc0$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e2f3f7a5613b5dc0$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e2f3f7a5613b5dc0$var$Nj(c, b, g) : 0 !== (f & 4) && $e2f3f7a5613b5dc0$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e2f3f7a5613b5dc0$var$U && ($e2f3f7a5613b5dc0$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e2f3f7a5613b5dc0$var$W(c, b, h);
            }
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            break;
        case 21:
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e2f3f7a5613b5dc0$var$U = (d = $e2f3f7a5613b5dc0$var$U) || null !== c.memoizedState, $e2f3f7a5613b5dc0$var$Zj(a, b, c), $e2f3f7a5613b5dc0$var$U = d) : $e2f3f7a5613b5dc0$var$Zj(a, b, c);
            break;
        default:
            $e2f3f7a5613b5dc0$var$Zj(a, b, c);
    }
}
function $e2f3f7a5613b5dc0$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e2f3f7a5613b5dc0$var$Lj);
        b.forEach(function(b) {
            var d = $e2f3f7a5613b5dc0$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e2f3f7a5613b5dc0$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e2f3f7a5613b5dc0$var$X = h.stateNode;
                        $e2f3f7a5613b5dc0$var$Yj = !1;
                        break a;
                    case 3:
                        $e2f3f7a5613b5dc0$var$X = h.stateNode.containerInfo;
                        $e2f3f7a5613b5dc0$var$Yj = !0;
                        break a;
                    case 4:
                        $e2f3f7a5613b5dc0$var$X = h.stateNode.containerInfo;
                        $e2f3f7a5613b5dc0$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e2f3f7a5613b5dc0$var$X) throw Error($e2f3f7a5613b5dc0$var$p(160));
            $e2f3f7a5613b5dc0$var$ak(f, g, e);
            $e2f3f7a5613b5dc0$var$X = null;
            $e2f3f7a5613b5dc0$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e2f3f7a5613b5dc0$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e2f3f7a5613b5dc0$var$ek(b, a), b = b.sibling;
}
function $e2f3f7a5613b5dc0$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            if (d & 4) {
                try {
                    $e2f3f7a5613b5dc0$var$Qj(3, a, a.return), $e2f3f7a5613b5dc0$var$Rj(3, a);
                } catch (t) {
                    $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                }
                try {
                    $e2f3f7a5613b5dc0$var$Qj(5, a, a.return);
                } catch (t) {
                    $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            d & 512 && null !== c && $e2f3f7a5613b5dc0$var$Mj(c, c.return);
            break;
        case 5:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            d & 512 && null !== c && $e2f3f7a5613b5dc0$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e2f3f7a5613b5dc0$var$ob(e, "");
                } catch (t) {
                    $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e2f3f7a5613b5dc0$var$ab(e, f);
                    $e2f3f7a5613b5dc0$var$vb(h, g);
                    var l = $e2f3f7a5613b5dc0$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e2f3f7a5613b5dc0$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e2f3f7a5613b5dc0$var$nb(e, q) : "children" === m ? $e2f3f7a5613b5dc0$var$ob(e, q) : $e2f3f7a5613b5dc0$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e2f3f7a5613b5dc0$var$bb(e, f);
                            break;
                        case "textarea":
                            $e2f3f7a5613b5dc0$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e2f3f7a5613b5dc0$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e2f3f7a5613b5dc0$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e2f3f7a5613b5dc0$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e2f3f7a5613b5dc0$var$Pf] = f;
                } catch (t) {
                    $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e2f3f7a5613b5dc0$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e2f3f7a5613b5dc0$var$bd(b.containerInfo);
            } catch (t) {
                $e2f3f7a5613b5dc0$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            break;
        case 13:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e2f3f7a5613b5dc0$var$gk = $e2f3f7a5613b5dc0$var$B()));
            d & 4 && $e2f3f7a5613b5dc0$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e2f3f7a5613b5dc0$var$U = (l = $e2f3f7a5613b5dc0$var$U) || m, $e2f3f7a5613b5dc0$var$dk(b, a), $e2f3f7a5613b5dc0$var$U = l) : $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e2f3f7a5613b5dc0$var$V = a, m = a.child; null !== m;){
                    for(q = $e2f3f7a5613b5dc0$var$V = m; null !== $e2f3f7a5613b5dc0$var$V;){
                        r = $e2f3f7a5613b5dc0$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e2f3f7a5613b5dc0$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e2f3f7a5613b5dc0$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e2f3f7a5613b5dc0$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e2f3f7a5613b5dc0$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e2f3f7a5613b5dc0$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e2f3f7a5613b5dc0$var$V = y) : $e2f3f7a5613b5dc0$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e2f3f7a5613b5dc0$var$rb("display", g));
                            } catch (t) {
                                $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e2f3f7a5613b5dc0$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e2f3f7a5613b5dc0$var$dk(b, a);
            $e2f3f7a5613b5dc0$var$fk(a);
            d & 4 && $e2f3f7a5613b5dc0$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e2f3f7a5613b5dc0$var$dk(b, a), $e2f3f7a5613b5dc0$var$fk(a);
    }
}
function $e2f3f7a5613b5dc0$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e2f3f7a5613b5dc0$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e2f3f7a5613b5dc0$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e2f3f7a5613b5dc0$var$ob(e, ""), d.flags &= -33);
                    var f = $e2f3f7a5613b5dc0$var$Vj(a);
                    $e2f3f7a5613b5dc0$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e2f3f7a5613b5dc0$var$Vj(a);
                    $e2f3f7a5613b5dc0$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e2f3f7a5613b5dc0$var$p(161));
            }
        } catch (k) {
            $e2f3f7a5613b5dc0$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e2f3f7a5613b5dc0$var$ik(a, b, c) {
    $e2f3f7a5613b5dc0$var$V = a;
    $e2f3f7a5613b5dc0$var$jk(a, b, c);
}
function $e2f3f7a5613b5dc0$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e2f3f7a5613b5dc0$var$V;){
        var e = $e2f3f7a5613b5dc0$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e2f3f7a5613b5dc0$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e2f3f7a5613b5dc0$var$U;
                h = $e2f3f7a5613b5dc0$var$Kj;
                var l = $e2f3f7a5613b5dc0$var$U;
                $e2f3f7a5613b5dc0$var$Kj = g;
                if (($e2f3f7a5613b5dc0$var$U = k) && !l) for($e2f3f7a5613b5dc0$var$V = e; null !== $e2f3f7a5613b5dc0$var$V;)g = $e2f3f7a5613b5dc0$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e2f3f7a5613b5dc0$var$kk(e) : null !== k ? (k.return = g, $e2f3f7a5613b5dc0$var$V = k) : $e2f3f7a5613b5dc0$var$kk(e);
                for(; null !== f;)$e2f3f7a5613b5dc0$var$V = f, $e2f3f7a5613b5dc0$var$jk(f, b, c), f = f.sibling;
                $e2f3f7a5613b5dc0$var$V = e;
                $e2f3f7a5613b5dc0$var$Kj = h;
                $e2f3f7a5613b5dc0$var$U = l;
            }
            $e2f3f7a5613b5dc0$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e2f3f7a5613b5dc0$var$V = f) : $e2f3f7a5613b5dc0$var$lk(a, b, c);
    }
}
function $e2f3f7a5613b5dc0$var$lk(a) {
    for(; null !== $e2f3f7a5613b5dc0$var$V;){
        var b = $e2f3f7a5613b5dc0$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e2f3f7a5613b5dc0$var$U || $e2f3f7a5613b5dc0$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e2f3f7a5613b5dc0$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e2f3f7a5613b5dc0$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e2f3f7a5613b5dc0$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e2f3f7a5613b5dc0$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e2f3f7a5613b5dc0$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e2f3f7a5613b5dc0$var$p(163));
                }
                $e2f3f7a5613b5dc0$var$U || b.flags & 512 && $e2f3f7a5613b5dc0$var$Sj(b);
            } catch (r) {
                $e2f3f7a5613b5dc0$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e2f3f7a5613b5dc0$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e2f3f7a5613b5dc0$var$V = c;
            break;
        }
        $e2f3f7a5613b5dc0$var$V = b.return;
    }
}
function $e2f3f7a5613b5dc0$var$hk(a) {
    for(; null !== $e2f3f7a5613b5dc0$var$V;){
        var b = $e2f3f7a5613b5dc0$var$V;
        if (b === a) {
            $e2f3f7a5613b5dc0$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e2f3f7a5613b5dc0$var$V = c;
            break;
        }
        $e2f3f7a5613b5dc0$var$V = b.return;
    }
}
function $e2f3f7a5613b5dc0$var$kk(a) {
    for(; null !== $e2f3f7a5613b5dc0$var$V;){
        var b = $e2f3f7a5613b5dc0$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e2f3f7a5613b5dc0$var$Rj(4, b);
                    } catch (k) {
                        $e2f3f7a5613b5dc0$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e2f3f7a5613b5dc0$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e2f3f7a5613b5dc0$var$Sj(b);
                    } catch (k) {
                        $e2f3f7a5613b5dc0$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e2f3f7a5613b5dc0$var$Sj(b);
                    } catch (k) {
                        $e2f3f7a5613b5dc0$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e2f3f7a5613b5dc0$var$W(b, b.return, k);
        }
        if (b === a) {
            $e2f3f7a5613b5dc0$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e2f3f7a5613b5dc0$var$V = h;
            break;
        }
        $e2f3f7a5613b5dc0$var$V = b.return;
    }
}
var $e2f3f7a5613b5dc0$var$mk = Math.ceil, $e2f3f7a5613b5dc0$var$nk = $e2f3f7a5613b5dc0$var$ua.ReactCurrentDispatcher, $e2f3f7a5613b5dc0$var$ok = $e2f3f7a5613b5dc0$var$ua.ReactCurrentOwner, $e2f3f7a5613b5dc0$var$pk = $e2f3f7a5613b5dc0$var$ua.ReactCurrentBatchConfig, $e2f3f7a5613b5dc0$var$K = 0, $e2f3f7a5613b5dc0$var$R = null, $e2f3f7a5613b5dc0$var$Y = null, $e2f3f7a5613b5dc0$var$Z = 0, $e2f3f7a5613b5dc0$var$gj = 0, $e2f3f7a5613b5dc0$var$fj = $e2f3f7a5613b5dc0$var$Uf(0), $e2f3f7a5613b5dc0$var$T = 0, $e2f3f7a5613b5dc0$var$qk = null, $e2f3f7a5613b5dc0$var$hh = 0, $e2f3f7a5613b5dc0$var$rk = 0, $e2f3f7a5613b5dc0$var$sk = 0, $e2f3f7a5613b5dc0$var$tk = null, $e2f3f7a5613b5dc0$var$uk = null, $e2f3f7a5613b5dc0$var$gk = 0, $e2f3f7a5613b5dc0$var$Hj = Infinity, $e2f3f7a5613b5dc0$var$vk = null, $e2f3f7a5613b5dc0$var$Pi = !1, $e2f3f7a5613b5dc0$var$Qi = null, $e2f3f7a5613b5dc0$var$Si = null, $e2f3f7a5613b5dc0$var$wk = !1, $e2f3f7a5613b5dc0$var$xk = null, $e2f3f7a5613b5dc0$var$yk = 0, $e2f3f7a5613b5dc0$var$zk = 0, $e2f3f7a5613b5dc0$var$Ak = null, $e2f3f7a5613b5dc0$var$Bk = -1, $e2f3f7a5613b5dc0$var$Ck = 0;
function $e2f3f7a5613b5dc0$var$L() {
    return 0 !== ($e2f3f7a5613b5dc0$var$K & 6) ? $e2f3f7a5613b5dc0$var$B() : -1 !== $e2f3f7a5613b5dc0$var$Bk ? $e2f3f7a5613b5dc0$var$Bk : $e2f3f7a5613b5dc0$var$Bk = $e2f3f7a5613b5dc0$var$B();
}
function $e2f3f7a5613b5dc0$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e2f3f7a5613b5dc0$var$K & 2) && 0 !== $e2f3f7a5613b5dc0$var$Z) return $e2f3f7a5613b5dc0$var$Z & -$e2f3f7a5613b5dc0$var$Z;
    if (null !== $e2f3f7a5613b5dc0$var$Kg.transition) return 0 === $e2f3f7a5613b5dc0$var$Ck && ($e2f3f7a5613b5dc0$var$Ck = $e2f3f7a5613b5dc0$var$yc()), $e2f3f7a5613b5dc0$var$Ck;
    a = $e2f3f7a5613b5dc0$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e2f3f7a5613b5dc0$var$jd(a.type);
    return a;
}
function $e2f3f7a5613b5dc0$var$mh(a, b, c, d) {
    if (50 < $e2f3f7a5613b5dc0$var$zk) throw $e2f3f7a5613b5dc0$var$zk = 0, $e2f3f7a5613b5dc0$var$Ak = null, Error($e2f3f7a5613b5dc0$var$p(185));
    $e2f3f7a5613b5dc0$var$Ac(a, c, d);
    if (0 === ($e2f3f7a5613b5dc0$var$K & 2) || a !== $e2f3f7a5613b5dc0$var$R) a === $e2f3f7a5613b5dc0$var$R && (0 === ($e2f3f7a5613b5dc0$var$K & 2) && ($e2f3f7a5613b5dc0$var$rk |= c), 4 === $e2f3f7a5613b5dc0$var$T && $e2f3f7a5613b5dc0$var$Dk(a, $e2f3f7a5613b5dc0$var$Z)), $e2f3f7a5613b5dc0$var$Ek(a, d), 1 === c && 0 === $e2f3f7a5613b5dc0$var$K && 0 === (b.mode & 1) && ($e2f3f7a5613b5dc0$var$Hj = $e2f3f7a5613b5dc0$var$B() + 500, $e2f3f7a5613b5dc0$var$fg && $e2f3f7a5613b5dc0$var$jg());
}
function $e2f3f7a5613b5dc0$var$Ek(a, b) {
    var c = a.callbackNode;
    $e2f3f7a5613b5dc0$var$wc(a, b);
    var d = $e2f3f7a5613b5dc0$var$uc(a, a === $e2f3f7a5613b5dc0$var$R ? $e2f3f7a5613b5dc0$var$Z : 0);
    if (0 === d) null !== c && $e2f3f7a5613b5dc0$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e2f3f7a5613b5dc0$var$bc(c);
        if (1 === b) 0 === a.tag ? $e2f3f7a5613b5dc0$var$ig($e2f3f7a5613b5dc0$var$Fk.bind(null, a)) : $e2f3f7a5613b5dc0$var$hg($e2f3f7a5613b5dc0$var$Fk.bind(null, a)), $e2f3f7a5613b5dc0$var$Jf(function() {
            0 === ($e2f3f7a5613b5dc0$var$K & 6) && $e2f3f7a5613b5dc0$var$jg();
        }), c = null;
        else {
            switch($e2f3f7a5613b5dc0$var$Dc(d)){
                case 1:
                    c = $e2f3f7a5613b5dc0$var$fc;
                    break;
                case 4:
                    c = $e2f3f7a5613b5dc0$var$gc;
                    break;
                case 16:
                    c = $e2f3f7a5613b5dc0$var$hc;
                    break;
                case 536870912:
                    c = $e2f3f7a5613b5dc0$var$jc;
                    break;
                default:
                    c = $e2f3f7a5613b5dc0$var$hc;
            }
            c = $e2f3f7a5613b5dc0$var$Gk(c, $e2f3f7a5613b5dc0$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e2f3f7a5613b5dc0$var$Hk(a, b) {
    $e2f3f7a5613b5dc0$var$Bk = -1;
    $e2f3f7a5613b5dc0$var$Ck = 0;
    if (0 !== ($e2f3f7a5613b5dc0$var$K & 6)) throw Error($e2f3f7a5613b5dc0$var$p(327));
    var c = a.callbackNode;
    if ($e2f3f7a5613b5dc0$var$Ik() && a.callbackNode !== c) return null;
    var d = $e2f3f7a5613b5dc0$var$uc(a, a === $e2f3f7a5613b5dc0$var$R ? $e2f3f7a5613b5dc0$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e2f3f7a5613b5dc0$var$Jk(a, d);
    else {
        b = d;
        var e = $e2f3f7a5613b5dc0$var$K;
        $e2f3f7a5613b5dc0$var$K |= 2;
        var f = $e2f3f7a5613b5dc0$var$Kk();
        if ($e2f3f7a5613b5dc0$var$R !== a || $e2f3f7a5613b5dc0$var$Z !== b) $e2f3f7a5613b5dc0$var$vk = null, $e2f3f7a5613b5dc0$var$Hj = $e2f3f7a5613b5dc0$var$B() + 500, $e2f3f7a5613b5dc0$var$Lk(a, b);
        for(;;)try {
            $e2f3f7a5613b5dc0$var$Mk();
            break;
        } catch (h) {
            $e2f3f7a5613b5dc0$var$Nk(a, h);
        }
        $e2f3f7a5613b5dc0$var$Qg();
        $e2f3f7a5613b5dc0$var$nk.current = f;
        $e2f3f7a5613b5dc0$var$K = e;
        null !== $e2f3f7a5613b5dc0$var$Y ? b = 0 : ($e2f3f7a5613b5dc0$var$R = null, $e2f3f7a5613b5dc0$var$Z = 0, b = $e2f3f7a5613b5dc0$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e2f3f7a5613b5dc0$var$xc(a), 0 !== e && (d = e, b = $e2f3f7a5613b5dc0$var$Ok(a, e)));
        if (1 === b) throw c = $e2f3f7a5613b5dc0$var$qk, $e2f3f7a5613b5dc0$var$Lk(a, 0), $e2f3f7a5613b5dc0$var$Dk(a, d), $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B()), c;
        if (6 === b) $e2f3f7a5613b5dc0$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e2f3f7a5613b5dc0$var$Pk(e) && (b = $e2f3f7a5613b5dc0$var$Jk(a, d), 2 === b && (f = $e2f3f7a5613b5dc0$var$xc(a), 0 !== f && (d = f, b = $e2f3f7a5613b5dc0$var$Ok(a, f))), 1 === b)) throw c = $e2f3f7a5613b5dc0$var$qk, $e2f3f7a5613b5dc0$var$Lk(a, 0), $e2f3f7a5613b5dc0$var$Dk(a, d), $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e2f3f7a5613b5dc0$var$p(345));
                case 2:
                    $e2f3f7a5613b5dc0$var$Qk(a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk);
                    break;
                case 3:
                    $e2f3f7a5613b5dc0$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e2f3f7a5613b5dc0$var$gk + 500 - $e2f3f7a5613b5dc0$var$B(), 10 < b)) {
                        if (0 !== $e2f3f7a5613b5dc0$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e2f3f7a5613b5dc0$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e2f3f7a5613b5dc0$var$Ff($e2f3f7a5613b5dc0$var$Qk.bind(null, a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk), b);
                        break;
                    }
                    $e2f3f7a5613b5dc0$var$Qk(a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk);
                    break;
                case 4:
                    $e2f3f7a5613b5dc0$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e2f3f7a5613b5dc0$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e2f3f7a5613b5dc0$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e2f3f7a5613b5dc0$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e2f3f7a5613b5dc0$var$Ff($e2f3f7a5613b5dc0$var$Qk.bind(null, a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk), d);
                        break;
                    }
                    $e2f3f7a5613b5dc0$var$Qk(a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk);
                    break;
                case 5:
                    $e2f3f7a5613b5dc0$var$Qk(a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk);
                    break;
                default:
                    throw Error($e2f3f7a5613b5dc0$var$p(329));
            }
        }
    }
    $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B());
    return a.callbackNode === c ? $e2f3f7a5613b5dc0$var$Hk.bind(null, a) : null;
}
function $e2f3f7a5613b5dc0$var$Ok(a, b) {
    var c = $e2f3f7a5613b5dc0$var$tk;
    a.current.memoizedState.isDehydrated && ($e2f3f7a5613b5dc0$var$Lk(a, b).flags |= 256);
    a = $e2f3f7a5613b5dc0$var$Jk(a, b);
    2 !== a && (b = $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$uk = c, null !== b && $e2f3f7a5613b5dc0$var$Gj(b));
    return a;
}
function $e2f3f7a5613b5dc0$var$Gj(a) {
    null === $e2f3f7a5613b5dc0$var$uk ? $e2f3f7a5613b5dc0$var$uk = a : $e2f3f7a5613b5dc0$var$uk.push.apply($e2f3f7a5613b5dc0$var$uk, a);
}
function $e2f3f7a5613b5dc0$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e2f3f7a5613b5dc0$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e2f3f7a5613b5dc0$var$Dk(a, b) {
    b &= ~$e2f3f7a5613b5dc0$var$sk;
    b &= ~$e2f3f7a5613b5dc0$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e2f3f7a5613b5dc0$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e2f3f7a5613b5dc0$var$Fk(a) {
    if (0 !== ($e2f3f7a5613b5dc0$var$K & 6)) throw Error($e2f3f7a5613b5dc0$var$p(327));
    $e2f3f7a5613b5dc0$var$Ik();
    var b = $e2f3f7a5613b5dc0$var$uc(a, 0);
    if (0 === (b & 1)) return $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B()), null;
    var c = $e2f3f7a5613b5dc0$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e2f3f7a5613b5dc0$var$xc(a);
        0 !== d && (b = d, c = $e2f3f7a5613b5dc0$var$Ok(a, d));
    }
    if (1 === c) throw c = $e2f3f7a5613b5dc0$var$qk, $e2f3f7a5613b5dc0$var$Lk(a, 0), $e2f3f7a5613b5dc0$var$Dk(a, b), $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B()), c;
    if (6 === c) throw Error($e2f3f7a5613b5dc0$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e2f3f7a5613b5dc0$var$Qk(a, $e2f3f7a5613b5dc0$var$uk, $e2f3f7a5613b5dc0$var$vk);
    $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B());
    return null;
}
function $e2f3f7a5613b5dc0$var$Rk(a, b) {
    var c = $e2f3f7a5613b5dc0$var$K;
    $e2f3f7a5613b5dc0$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e2f3f7a5613b5dc0$var$K = c, 0 === $e2f3f7a5613b5dc0$var$K && ($e2f3f7a5613b5dc0$var$Hj = $e2f3f7a5613b5dc0$var$B() + 500, $e2f3f7a5613b5dc0$var$fg && $e2f3f7a5613b5dc0$var$jg());
    }
}
function $e2f3f7a5613b5dc0$var$Sk(a) {
    null !== $e2f3f7a5613b5dc0$var$xk && 0 === $e2f3f7a5613b5dc0$var$xk.tag && 0 === ($e2f3f7a5613b5dc0$var$K & 6) && $e2f3f7a5613b5dc0$var$Ik();
    var b = $e2f3f7a5613b5dc0$var$K;
    $e2f3f7a5613b5dc0$var$K |= 1;
    var c = $e2f3f7a5613b5dc0$var$pk.transition, d = $e2f3f7a5613b5dc0$var$C;
    try {
        if ($e2f3f7a5613b5dc0$var$pk.transition = null, $e2f3f7a5613b5dc0$var$C = 1, a) return a();
    } finally{
        $e2f3f7a5613b5dc0$var$C = d, $e2f3f7a5613b5dc0$var$pk.transition = c, $e2f3f7a5613b5dc0$var$K = b, 0 === ($e2f3f7a5613b5dc0$var$K & 6) && $e2f3f7a5613b5dc0$var$jg();
    }
}
function $e2f3f7a5613b5dc0$var$Ij() {
    $e2f3f7a5613b5dc0$var$gj = $e2f3f7a5613b5dc0$var$fj.current;
    $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$fj);
}
function $e2f3f7a5613b5dc0$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e2f3f7a5613b5dc0$var$Gf(c));
    if (null !== $e2f3f7a5613b5dc0$var$Y) for(c = $e2f3f7a5613b5dc0$var$Y.return; null !== c;){
        var d = c;
        $e2f3f7a5613b5dc0$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e2f3f7a5613b5dc0$var$$f();
                break;
            case 3:
                $e2f3f7a5613b5dc0$var$Jh();
                $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$Wf);
                $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$H);
                $e2f3f7a5613b5dc0$var$Oh();
                break;
            case 5:
                $e2f3f7a5613b5dc0$var$Lh(d);
                break;
            case 4:
                $e2f3f7a5613b5dc0$var$Jh();
                break;
            case 13:
                $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M);
                break;
            case 19:
                $e2f3f7a5613b5dc0$var$E($e2f3f7a5613b5dc0$var$M);
                break;
            case 10:
                $e2f3f7a5613b5dc0$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e2f3f7a5613b5dc0$var$Ij();
        }
        c = c.return;
    }
    $e2f3f7a5613b5dc0$var$R = a;
    $e2f3f7a5613b5dc0$var$Y = a = $e2f3f7a5613b5dc0$var$wh(a.current, null);
    $e2f3f7a5613b5dc0$var$Z = $e2f3f7a5613b5dc0$var$gj = b;
    $e2f3f7a5613b5dc0$var$T = 0;
    $e2f3f7a5613b5dc0$var$qk = null;
    $e2f3f7a5613b5dc0$var$sk = $e2f3f7a5613b5dc0$var$rk = $e2f3f7a5613b5dc0$var$hh = 0;
    $e2f3f7a5613b5dc0$var$uk = $e2f3f7a5613b5dc0$var$tk = null;
    if (null !== $e2f3f7a5613b5dc0$var$Wg) {
        for(b = 0; b < $e2f3f7a5613b5dc0$var$Wg.length; b++)if (c = $e2f3f7a5613b5dc0$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e2f3f7a5613b5dc0$var$Wg = null;
    }
    return a;
}
function $e2f3f7a5613b5dc0$var$Nk(a, b) {
    do {
        var c = $e2f3f7a5613b5dc0$var$Y;
        try {
            $e2f3f7a5613b5dc0$var$Qg();
            $e2f3f7a5613b5dc0$var$Ph.current = $e2f3f7a5613b5dc0$var$ai;
            if ($e2f3f7a5613b5dc0$var$Sh) {
                for(var d = $e2f3f7a5613b5dc0$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e2f3f7a5613b5dc0$var$Sh = !1;
            }
            $e2f3f7a5613b5dc0$var$Rh = 0;
            $e2f3f7a5613b5dc0$var$P = $e2f3f7a5613b5dc0$var$O = $e2f3f7a5613b5dc0$var$N = null;
            $e2f3f7a5613b5dc0$var$Th = !1;
            $e2f3f7a5613b5dc0$var$Uh = 0;
            $e2f3f7a5613b5dc0$var$ok.current = null;
            if (null === c || null === c.return) {
                $e2f3f7a5613b5dc0$var$T = 1;
                $e2f3f7a5613b5dc0$var$qk = b;
                $e2f3f7a5613b5dc0$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e2f3f7a5613b5dc0$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e2f3f7a5613b5dc0$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e2f3f7a5613b5dc0$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e2f3f7a5613b5dc0$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e2f3f7a5613b5dc0$var$Ti(f, l, b);
                            $e2f3f7a5613b5dc0$var$uj();
                            break a;
                        }
                        k = Error($e2f3f7a5613b5dc0$var$p(426));
                    }
                } else if ($e2f3f7a5613b5dc0$var$I && h.mode & 1) {
                    var J = $e2f3f7a5613b5dc0$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e2f3f7a5613b5dc0$var$Wi(J, g, h, f, b);
                        $e2f3f7a5613b5dc0$var$Jg($e2f3f7a5613b5dc0$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e2f3f7a5613b5dc0$var$Ki(k, h);
                4 !== $e2f3f7a5613b5dc0$var$T && ($e2f3f7a5613b5dc0$var$T = 2);
                null === $e2f3f7a5613b5dc0$var$tk ? $e2f3f7a5613b5dc0$var$tk = [
                    f
                ] : $e2f3f7a5613b5dc0$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e2f3f7a5613b5dc0$var$Oi(f, k, b);
                            $e2f3f7a5613b5dc0$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e2f3f7a5613b5dc0$var$Si || !$e2f3f7a5613b5dc0$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e2f3f7a5613b5dc0$var$Ri(f, h, b);
                                $e2f3f7a5613b5dc0$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e2f3f7a5613b5dc0$var$Tk(c);
        } catch (na) {
            b = na;
            $e2f3f7a5613b5dc0$var$Y === c && null !== c && ($e2f3f7a5613b5dc0$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e2f3f7a5613b5dc0$var$Kk() {
    var a = $e2f3f7a5613b5dc0$var$nk.current;
    $e2f3f7a5613b5dc0$var$nk.current = $e2f3f7a5613b5dc0$var$ai;
    return null === a ? $e2f3f7a5613b5dc0$var$ai : a;
}
function $e2f3f7a5613b5dc0$var$uj() {
    if (0 === $e2f3f7a5613b5dc0$var$T || 3 === $e2f3f7a5613b5dc0$var$T || 2 === $e2f3f7a5613b5dc0$var$T) $e2f3f7a5613b5dc0$var$T = 4;
    null === $e2f3f7a5613b5dc0$var$R || 0 === ($e2f3f7a5613b5dc0$var$hh & 268435455) && 0 === ($e2f3f7a5613b5dc0$var$rk & 268435455) || $e2f3f7a5613b5dc0$var$Dk($e2f3f7a5613b5dc0$var$R, $e2f3f7a5613b5dc0$var$Z);
}
function $e2f3f7a5613b5dc0$var$Jk(a, b) {
    var c = $e2f3f7a5613b5dc0$var$K;
    $e2f3f7a5613b5dc0$var$K |= 2;
    var d = $e2f3f7a5613b5dc0$var$Kk();
    if ($e2f3f7a5613b5dc0$var$R !== a || $e2f3f7a5613b5dc0$var$Z !== b) $e2f3f7a5613b5dc0$var$vk = null, $e2f3f7a5613b5dc0$var$Lk(a, b);
    for(;;)try {
        $e2f3f7a5613b5dc0$var$Uk();
        break;
    } catch (e) {
        $e2f3f7a5613b5dc0$var$Nk(a, e);
    }
    $e2f3f7a5613b5dc0$var$Qg();
    $e2f3f7a5613b5dc0$var$K = c;
    $e2f3f7a5613b5dc0$var$nk.current = d;
    if (null !== $e2f3f7a5613b5dc0$var$Y) throw Error($e2f3f7a5613b5dc0$var$p(261));
    $e2f3f7a5613b5dc0$var$R = null;
    $e2f3f7a5613b5dc0$var$Z = 0;
    return $e2f3f7a5613b5dc0$var$T;
}
function $e2f3f7a5613b5dc0$var$Uk() {
    for(; null !== $e2f3f7a5613b5dc0$var$Y;)$e2f3f7a5613b5dc0$var$Vk($e2f3f7a5613b5dc0$var$Y);
}
function $e2f3f7a5613b5dc0$var$Mk() {
    for(; null !== $e2f3f7a5613b5dc0$var$Y && !$e2f3f7a5613b5dc0$var$cc();)$e2f3f7a5613b5dc0$var$Vk($e2f3f7a5613b5dc0$var$Y);
}
function $e2f3f7a5613b5dc0$var$Vk(a) {
    var b = $e2f3f7a5613b5dc0$var$Wk(a.alternate, a, $e2f3f7a5613b5dc0$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e2f3f7a5613b5dc0$var$Tk(a) : $e2f3f7a5613b5dc0$var$Y = b;
    $e2f3f7a5613b5dc0$var$ok.current = null;
}
function $e2f3f7a5613b5dc0$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e2f3f7a5613b5dc0$var$Fj(c, b, $e2f3f7a5613b5dc0$var$gj), null !== c) {
                $e2f3f7a5613b5dc0$var$Y = c;
                return;
            }
        } else {
            c = $e2f3f7a5613b5dc0$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e2f3f7a5613b5dc0$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e2f3f7a5613b5dc0$var$T = 6;
                $e2f3f7a5613b5dc0$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e2f3f7a5613b5dc0$var$Y = b;
            return;
        }
        $e2f3f7a5613b5dc0$var$Y = b = a;
    }while (null !== b);
    0 === $e2f3f7a5613b5dc0$var$T && ($e2f3f7a5613b5dc0$var$T = 5);
}
function $e2f3f7a5613b5dc0$var$Qk(a, b, c) {
    var d = $e2f3f7a5613b5dc0$var$C, e = $e2f3f7a5613b5dc0$var$pk.transition;
    try {
        $e2f3f7a5613b5dc0$var$pk.transition = null, $e2f3f7a5613b5dc0$var$C = 1, $e2f3f7a5613b5dc0$var$Xk(a, b, c, d);
    } finally{
        $e2f3f7a5613b5dc0$var$pk.transition = e, $e2f3f7a5613b5dc0$var$C = d;
    }
    return null;
}
function $e2f3f7a5613b5dc0$var$Xk(a, b, c, d) {
    do $e2f3f7a5613b5dc0$var$Ik();
    while (null !== $e2f3f7a5613b5dc0$var$xk);
    if (0 !== ($e2f3f7a5613b5dc0$var$K & 6)) throw Error($e2f3f7a5613b5dc0$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e2f3f7a5613b5dc0$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e2f3f7a5613b5dc0$var$Bc(a, f);
    a === $e2f3f7a5613b5dc0$var$R && ($e2f3f7a5613b5dc0$var$Y = $e2f3f7a5613b5dc0$var$R = null, $e2f3f7a5613b5dc0$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e2f3f7a5613b5dc0$var$wk || ($e2f3f7a5613b5dc0$var$wk = !0, $e2f3f7a5613b5dc0$var$Gk($e2f3f7a5613b5dc0$var$hc, function() {
        $e2f3f7a5613b5dc0$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e2f3f7a5613b5dc0$var$pk.transition;
        $e2f3f7a5613b5dc0$var$pk.transition = null;
        var g = $e2f3f7a5613b5dc0$var$C;
        $e2f3f7a5613b5dc0$var$C = 1;
        var h = $e2f3f7a5613b5dc0$var$K;
        $e2f3f7a5613b5dc0$var$K |= 4;
        $e2f3f7a5613b5dc0$var$ok.current = null;
        $e2f3f7a5613b5dc0$var$Pj(a, c);
        $e2f3f7a5613b5dc0$var$ek(c, a);
        $e2f3f7a5613b5dc0$var$Oe($e2f3f7a5613b5dc0$var$Df);
        $e2f3f7a5613b5dc0$var$dd = !!$e2f3f7a5613b5dc0$var$Cf;
        $e2f3f7a5613b5dc0$var$Df = $e2f3f7a5613b5dc0$var$Cf = null;
        a.current = c;
        $e2f3f7a5613b5dc0$var$ik(c, a, e);
        $e2f3f7a5613b5dc0$var$dc();
        $e2f3f7a5613b5dc0$var$K = h;
        $e2f3f7a5613b5dc0$var$C = g;
        $e2f3f7a5613b5dc0$var$pk.transition = f;
    } else a.current = c;
    $e2f3f7a5613b5dc0$var$wk && ($e2f3f7a5613b5dc0$var$wk = !1, $e2f3f7a5613b5dc0$var$xk = a, $e2f3f7a5613b5dc0$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e2f3f7a5613b5dc0$var$Si = null);
    $e2f3f7a5613b5dc0$var$mc(c.stateNode, d);
    $e2f3f7a5613b5dc0$var$Ek(a, $e2f3f7a5613b5dc0$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e2f3f7a5613b5dc0$var$Pi) throw $e2f3f7a5613b5dc0$var$Pi = !1, a = $e2f3f7a5613b5dc0$var$Qi, $e2f3f7a5613b5dc0$var$Qi = null, a;
    0 !== ($e2f3f7a5613b5dc0$var$yk & 1) && 0 !== a.tag && $e2f3f7a5613b5dc0$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e2f3f7a5613b5dc0$var$Ak ? $e2f3f7a5613b5dc0$var$zk++ : ($e2f3f7a5613b5dc0$var$zk = 0, $e2f3f7a5613b5dc0$var$Ak = a) : $e2f3f7a5613b5dc0$var$zk = 0;
    $e2f3f7a5613b5dc0$var$jg();
    return null;
}
function $e2f3f7a5613b5dc0$var$Ik() {
    if (null !== $e2f3f7a5613b5dc0$var$xk) {
        var a = $e2f3f7a5613b5dc0$var$Dc($e2f3f7a5613b5dc0$var$yk), b = $e2f3f7a5613b5dc0$var$pk.transition, c = $e2f3f7a5613b5dc0$var$C;
        try {
            $e2f3f7a5613b5dc0$var$pk.transition = null;
            $e2f3f7a5613b5dc0$var$C = 16 > a ? 16 : a;
            if (null === $e2f3f7a5613b5dc0$var$xk) var d = !1;
            else {
                a = $e2f3f7a5613b5dc0$var$xk;
                $e2f3f7a5613b5dc0$var$xk = null;
                $e2f3f7a5613b5dc0$var$yk = 0;
                if (0 !== ($e2f3f7a5613b5dc0$var$K & 6)) throw Error($e2f3f7a5613b5dc0$var$p(331));
                var e = $e2f3f7a5613b5dc0$var$K;
                $e2f3f7a5613b5dc0$var$K |= 4;
                for($e2f3f7a5613b5dc0$var$V = a.current; null !== $e2f3f7a5613b5dc0$var$V;){
                    var f = $e2f3f7a5613b5dc0$var$V, g = f.child;
                    if (0 !== ($e2f3f7a5613b5dc0$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e2f3f7a5613b5dc0$var$V = l; null !== $e2f3f7a5613b5dc0$var$V;){
                                    var m = $e2f3f7a5613b5dc0$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e2f3f7a5613b5dc0$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e2f3f7a5613b5dc0$var$V = q;
                                    else for(; null !== $e2f3f7a5613b5dc0$var$V;){
                                        m = $e2f3f7a5613b5dc0$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e2f3f7a5613b5dc0$var$Tj(m);
                                        if (m === l) {
                                            $e2f3f7a5613b5dc0$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e2f3f7a5613b5dc0$var$V = r;
                                            break;
                                        }
                                        $e2f3f7a5613b5dc0$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e2f3f7a5613b5dc0$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e2f3f7a5613b5dc0$var$V = g;
                    else b: for(; null !== $e2f3f7a5613b5dc0$var$V;){
                        f = $e2f3f7a5613b5dc0$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e2f3f7a5613b5dc0$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e2f3f7a5613b5dc0$var$V = x;
                            break b;
                        }
                        $e2f3f7a5613b5dc0$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e2f3f7a5613b5dc0$var$V = w; null !== $e2f3f7a5613b5dc0$var$V;){
                    g = $e2f3f7a5613b5dc0$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e2f3f7a5613b5dc0$var$V = u;
                    else b: for(g = w; null !== $e2f3f7a5613b5dc0$var$V;){
                        h = $e2f3f7a5613b5dc0$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e2f3f7a5613b5dc0$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e2f3f7a5613b5dc0$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e2f3f7a5613b5dc0$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e2f3f7a5613b5dc0$var$V = F;
                            break b;
                        }
                        $e2f3f7a5613b5dc0$var$V = h.return;
                    }
                }
                $e2f3f7a5613b5dc0$var$K = e;
                $e2f3f7a5613b5dc0$var$jg();
                if ($e2f3f7a5613b5dc0$var$lc && "function" === typeof $e2f3f7a5613b5dc0$var$lc.onPostCommitFiberRoot) try {
                    $e2f3f7a5613b5dc0$var$lc.onPostCommitFiberRoot($e2f3f7a5613b5dc0$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e2f3f7a5613b5dc0$var$C = c, $e2f3f7a5613b5dc0$var$pk.transition = b;
        }
    }
    return !1;
}
function $e2f3f7a5613b5dc0$var$Yk(a, b, c) {
    b = $e2f3f7a5613b5dc0$var$Ki(c, b);
    b = $e2f3f7a5613b5dc0$var$Oi(a, b, 1);
    a = $e2f3f7a5613b5dc0$var$dh(a, b, 1);
    b = $e2f3f7a5613b5dc0$var$L();
    null !== a && ($e2f3f7a5613b5dc0$var$Ac(a, 1, b), $e2f3f7a5613b5dc0$var$Ek(a, b));
}
function $e2f3f7a5613b5dc0$var$W(a, b, c) {
    if (3 === a.tag) $e2f3f7a5613b5dc0$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e2f3f7a5613b5dc0$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e2f3f7a5613b5dc0$var$Si || !$e2f3f7a5613b5dc0$var$Si.has(d))) {
                a = $e2f3f7a5613b5dc0$var$Ki(c, a);
                a = $e2f3f7a5613b5dc0$var$Ri(b, a, 1);
                b = $e2f3f7a5613b5dc0$var$dh(b, a, 1);
                a = $e2f3f7a5613b5dc0$var$L();
                null !== b && ($e2f3f7a5613b5dc0$var$Ac(b, 1, a), $e2f3f7a5613b5dc0$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e2f3f7a5613b5dc0$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e2f3f7a5613b5dc0$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e2f3f7a5613b5dc0$var$R === a && ($e2f3f7a5613b5dc0$var$Z & c) === c && (4 === $e2f3f7a5613b5dc0$var$T || 3 === $e2f3f7a5613b5dc0$var$T && ($e2f3f7a5613b5dc0$var$Z & 130023424) === $e2f3f7a5613b5dc0$var$Z && 500 > $e2f3f7a5613b5dc0$var$B() - $e2f3f7a5613b5dc0$var$gk ? $e2f3f7a5613b5dc0$var$Lk(a, 0) : $e2f3f7a5613b5dc0$var$sk |= c);
    $e2f3f7a5613b5dc0$var$Ek(a, b);
}
function $e2f3f7a5613b5dc0$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e2f3f7a5613b5dc0$var$sc, $e2f3f7a5613b5dc0$var$sc <<= 1, 0 === ($e2f3f7a5613b5dc0$var$sc & 130023424) && ($e2f3f7a5613b5dc0$var$sc = 4194304)));
    var c = $e2f3f7a5613b5dc0$var$L();
    a = $e2f3f7a5613b5dc0$var$Zg(a, b);
    null !== a && ($e2f3f7a5613b5dc0$var$Ac(a, b, c), $e2f3f7a5613b5dc0$var$Ek(a, c));
}
function $e2f3f7a5613b5dc0$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e2f3f7a5613b5dc0$var$Zk(a, c);
}
function $e2f3f7a5613b5dc0$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e2f3f7a5613b5dc0$var$p(314));
    }
    null !== d && d.delete(b);
    $e2f3f7a5613b5dc0$var$Zk(a, c);
}
var $e2f3f7a5613b5dc0$var$Wk;
$e2f3f7a5613b5dc0$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e2f3f7a5613b5dc0$var$Wf.current) $e2f3f7a5613b5dc0$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e2f3f7a5613b5dc0$var$Ug = !1, $e2f3f7a5613b5dc0$var$zj(a, b, c);
            $e2f3f7a5613b5dc0$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e2f3f7a5613b5dc0$var$Ug = !1, $e2f3f7a5613b5dc0$var$I && 0 !== (b.flags & 1048576) && $e2f3f7a5613b5dc0$var$ug(b, $e2f3f7a5613b5dc0$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e2f3f7a5613b5dc0$var$jj(a, b);
            a = b.pendingProps;
            var e = $e2f3f7a5613b5dc0$var$Yf(b, $e2f3f7a5613b5dc0$var$H.current);
            $e2f3f7a5613b5dc0$var$Tg(b, c);
            e = $e2f3f7a5613b5dc0$var$Xh(null, b, d, a, e, c);
            var f = $e2f3f7a5613b5dc0$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e2f3f7a5613b5dc0$var$Zf(d) ? (f = !0, $e2f3f7a5613b5dc0$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e2f3f7a5613b5dc0$var$ah(b), e.updater = $e2f3f7a5613b5dc0$var$nh, b.stateNode = e, e._reactInternals = b, $e2f3f7a5613b5dc0$var$rh(b, d, a, c), b = $e2f3f7a5613b5dc0$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e2f3f7a5613b5dc0$var$I && f && $e2f3f7a5613b5dc0$var$vg(b), $e2f3f7a5613b5dc0$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e2f3f7a5613b5dc0$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e2f3f7a5613b5dc0$var$$k(d);
                a = $e2f3f7a5613b5dc0$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e2f3f7a5613b5dc0$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e2f3f7a5613b5dc0$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e2f3f7a5613b5dc0$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e2f3f7a5613b5dc0$var$aj(null, b, d, $e2f3f7a5613b5dc0$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e2f3f7a5613b5dc0$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e2f3f7a5613b5dc0$var$Lg(d, e), $e2f3f7a5613b5dc0$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e2f3f7a5613b5dc0$var$Lg(d, e), $e2f3f7a5613b5dc0$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e2f3f7a5613b5dc0$var$lj(b);
                if (null === a) throw Error($e2f3f7a5613b5dc0$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e2f3f7a5613b5dc0$var$bh(a, b);
                $e2f3f7a5613b5dc0$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e2f3f7a5613b5dc0$var$Ki(Error($e2f3f7a5613b5dc0$var$p(423)), b);
                        b = $e2f3f7a5613b5dc0$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e2f3f7a5613b5dc0$var$Ki(Error($e2f3f7a5613b5dc0$var$p(424)), b);
                        b = $e2f3f7a5613b5dc0$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e2f3f7a5613b5dc0$var$yg = $e2f3f7a5613b5dc0$var$Lf(b.stateNode.containerInfo.firstChild), $e2f3f7a5613b5dc0$var$xg = b, $e2f3f7a5613b5dc0$var$I = !0, $e2f3f7a5613b5dc0$var$zg = null, c = $e2f3f7a5613b5dc0$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e2f3f7a5613b5dc0$var$Ig();
                    if (d === e) {
                        b = $e2f3f7a5613b5dc0$var$$i(a, b, c);
                        break a;
                    }
                    $e2f3f7a5613b5dc0$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e2f3f7a5613b5dc0$var$Kh(b), null === a && $e2f3f7a5613b5dc0$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e2f3f7a5613b5dc0$var$Ef(d, e) ? g = null : null !== f && $e2f3f7a5613b5dc0$var$Ef(d, f) && (b.flags |= 32), $e2f3f7a5613b5dc0$var$hj(a, b), $e2f3f7a5613b5dc0$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e2f3f7a5613b5dc0$var$Eg(b), null;
        case 13:
            return $e2f3f7a5613b5dc0$var$pj(a, b, c);
        case 4:
            return $e2f3f7a5613b5dc0$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e2f3f7a5613b5dc0$var$Bh(b, null, d, c) : $e2f3f7a5613b5dc0$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e2f3f7a5613b5dc0$var$Lg(d, e), $e2f3f7a5613b5dc0$var$Zi(a, b, d, e, c);
        case 7:
            return $e2f3f7a5613b5dc0$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e2f3f7a5613b5dc0$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e2f3f7a5613b5dc0$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e2f3f7a5613b5dc0$var$G($e2f3f7a5613b5dc0$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e2f3f7a5613b5dc0$var$He(f.value, g)) {
                        if (f.children === e.children && !$e2f3f7a5613b5dc0$var$Wf.current) {
                            b = $e2f3f7a5613b5dc0$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e2f3f7a5613b5dc0$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e2f3f7a5613b5dc0$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e2f3f7a5613b5dc0$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e2f3f7a5613b5dc0$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e2f3f7a5613b5dc0$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e2f3f7a5613b5dc0$var$Tg(b, c), e = $e2f3f7a5613b5dc0$var$Vg(e), d = d(e), b.flags |= 1, $e2f3f7a5613b5dc0$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e2f3f7a5613b5dc0$var$Lg(d, b.pendingProps), e = $e2f3f7a5613b5dc0$var$Lg(d.type, e), $e2f3f7a5613b5dc0$var$aj(a, b, d, e, c);
        case 15:
            return $e2f3f7a5613b5dc0$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e2f3f7a5613b5dc0$var$Lg(d, e), $e2f3f7a5613b5dc0$var$jj(a, b), b.tag = 1, $e2f3f7a5613b5dc0$var$Zf(d) ? (a = !0, $e2f3f7a5613b5dc0$var$cg(b)) : a = !1, $e2f3f7a5613b5dc0$var$Tg(b, c), $e2f3f7a5613b5dc0$var$ph(b, d, e), $e2f3f7a5613b5dc0$var$rh(b, d, e, c), $e2f3f7a5613b5dc0$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e2f3f7a5613b5dc0$var$yj(a, b, c);
        case 22:
            return $e2f3f7a5613b5dc0$var$ej(a, b, c);
    }
    throw Error($e2f3f7a5613b5dc0$var$p(156, b.tag));
};
function $e2f3f7a5613b5dc0$var$Gk(a, b) {
    return $e2f3f7a5613b5dc0$var$ac(a, b);
}
function $e2f3f7a5613b5dc0$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e2f3f7a5613b5dc0$var$Bg(a, b, c, d) {
    return new $e2f3f7a5613b5dc0$var$al(a, b, c, d);
}
function $e2f3f7a5613b5dc0$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e2f3f7a5613b5dc0$var$$k(a) {
    if ("function" === typeof a) return $e2f3f7a5613b5dc0$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e2f3f7a5613b5dc0$var$Da) return 11;
        if (a === $e2f3f7a5613b5dc0$var$Ga) return 14;
    }
    return 2;
}
function $e2f3f7a5613b5dc0$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e2f3f7a5613b5dc0$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e2f3f7a5613b5dc0$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e2f3f7a5613b5dc0$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e2f3f7a5613b5dc0$var$ya:
            return $e2f3f7a5613b5dc0$var$Ah(c.children, e, f, b);
        case $e2f3f7a5613b5dc0$var$za:
            g = 8;
            e |= 8;
            break;
        case $e2f3f7a5613b5dc0$var$Aa:
            return a = $e2f3f7a5613b5dc0$var$Bg(12, c, b, e | 2), a.elementType = $e2f3f7a5613b5dc0$var$Aa, a.lanes = f, a;
        case $e2f3f7a5613b5dc0$var$Ea:
            return a = $e2f3f7a5613b5dc0$var$Bg(13, c, b, e), a.elementType = $e2f3f7a5613b5dc0$var$Ea, a.lanes = f, a;
        case $e2f3f7a5613b5dc0$var$Fa:
            return a = $e2f3f7a5613b5dc0$var$Bg(19, c, b, e), a.elementType = $e2f3f7a5613b5dc0$var$Fa, a.lanes = f, a;
        case $e2f3f7a5613b5dc0$var$Ia:
            return $e2f3f7a5613b5dc0$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e2f3f7a5613b5dc0$var$Ba:
                    g = 10;
                    break a;
                case $e2f3f7a5613b5dc0$var$Ca:
                    g = 9;
                    break a;
                case $e2f3f7a5613b5dc0$var$Da:
                    g = 11;
                    break a;
                case $e2f3f7a5613b5dc0$var$Ga:
                    g = 14;
                    break a;
                case $e2f3f7a5613b5dc0$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e2f3f7a5613b5dc0$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e2f3f7a5613b5dc0$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e2f3f7a5613b5dc0$var$Ah(a, b, c, d) {
    a = $e2f3f7a5613b5dc0$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e2f3f7a5613b5dc0$var$qj(a, b, c, d) {
    a = $e2f3f7a5613b5dc0$var$Bg(22, a, d, b);
    a.elementType = $e2f3f7a5613b5dc0$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e2f3f7a5613b5dc0$var$xh(a, b, c) {
    a = $e2f3f7a5613b5dc0$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e2f3f7a5613b5dc0$var$zh(a, b, c) {
    b = $e2f3f7a5613b5dc0$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e2f3f7a5613b5dc0$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e2f3f7a5613b5dc0$var$zc(0);
    this.expirationTimes = $e2f3f7a5613b5dc0$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e2f3f7a5613b5dc0$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e2f3f7a5613b5dc0$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e2f3f7a5613b5dc0$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e2f3f7a5613b5dc0$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e2f3f7a5613b5dc0$var$ah(f);
    return a;
}
function $e2f3f7a5613b5dc0$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e2f3f7a5613b5dc0$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e2f3f7a5613b5dc0$var$el(a) {
    if (!a) return $e2f3f7a5613b5dc0$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e2f3f7a5613b5dc0$var$Vb(a) !== a || 1 !== a.tag) throw Error($e2f3f7a5613b5dc0$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e2f3f7a5613b5dc0$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e2f3f7a5613b5dc0$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e2f3f7a5613b5dc0$var$Zf(c)) return $e2f3f7a5613b5dc0$var$bg(a, c, b);
    }
    return b;
}
function $e2f3f7a5613b5dc0$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e2f3f7a5613b5dc0$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e2f3f7a5613b5dc0$var$el(null);
    c = a.current;
    d = $e2f3f7a5613b5dc0$var$L();
    e = $e2f3f7a5613b5dc0$var$lh(c);
    f = $e2f3f7a5613b5dc0$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e2f3f7a5613b5dc0$var$dh(c, f, e);
    a.current.lanes = e;
    $e2f3f7a5613b5dc0$var$Ac(a, e, d);
    $e2f3f7a5613b5dc0$var$Ek(a, d);
    return a;
}
function $e2f3f7a5613b5dc0$var$gl(a, b, c, d) {
    var e = b.current, f = $e2f3f7a5613b5dc0$var$L(), g = $e2f3f7a5613b5dc0$var$lh(e);
    c = $e2f3f7a5613b5dc0$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e2f3f7a5613b5dc0$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e2f3f7a5613b5dc0$var$dh(e, b, g);
    null !== a && ($e2f3f7a5613b5dc0$var$mh(a, e, g, f), $e2f3f7a5613b5dc0$var$eh(a, e, g));
    return g;
}
function $e2f3f7a5613b5dc0$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e2f3f7a5613b5dc0$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e2f3f7a5613b5dc0$var$jl(a, b) {
    $e2f3f7a5613b5dc0$var$il(a, b);
    (a = a.alternate) && $e2f3f7a5613b5dc0$var$il(a, b);
}
function $e2f3f7a5613b5dc0$var$kl() {
    return null;
}
var $e2f3f7a5613b5dc0$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e2f3f7a5613b5dc0$var$ml(a) {
    this._internalRoot = a;
}
$e2f3f7a5613b5dc0$var$nl.prototype.render = $e2f3f7a5613b5dc0$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e2f3f7a5613b5dc0$var$p(409));
    $e2f3f7a5613b5dc0$var$gl(a, b, null, null);
};
$e2f3f7a5613b5dc0$var$nl.prototype.unmount = $e2f3f7a5613b5dc0$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e2f3f7a5613b5dc0$var$Sk(function() {
            $e2f3f7a5613b5dc0$var$gl(null, a, null, null);
        });
        b[$e2f3f7a5613b5dc0$var$uf] = null;
    }
};
function $e2f3f7a5613b5dc0$var$nl(a) {
    this._internalRoot = a;
}
$e2f3f7a5613b5dc0$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e2f3f7a5613b5dc0$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e2f3f7a5613b5dc0$var$Qc.length && 0 !== b && b < $e2f3f7a5613b5dc0$var$Qc[c].priority; c++);
        $e2f3f7a5613b5dc0$var$Qc.splice(c, 0, a);
        0 === c && $e2f3f7a5613b5dc0$var$Vc(a);
    }
};
function $e2f3f7a5613b5dc0$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e2f3f7a5613b5dc0$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e2f3f7a5613b5dc0$var$ql() {}
function $e2f3f7a5613b5dc0$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e2f3f7a5613b5dc0$var$hl(g);
                f.call(a);
            };
        }
        var g = $e2f3f7a5613b5dc0$var$fl(b, d, a, 0, null, !1, !1, "", $e2f3f7a5613b5dc0$var$ql);
        a._reactRootContainer = g;
        a[$e2f3f7a5613b5dc0$var$uf] = g.current;
        $e2f3f7a5613b5dc0$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e2f3f7a5613b5dc0$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e2f3f7a5613b5dc0$var$hl(k);
            h.call(a);
        };
    }
    var k = $e2f3f7a5613b5dc0$var$cl(a, 0, !1, null, null, !1, !1, "", $e2f3f7a5613b5dc0$var$ql);
    a._reactRootContainer = k;
    a[$e2f3f7a5613b5dc0$var$uf] = k.current;
    $e2f3f7a5613b5dc0$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e2f3f7a5613b5dc0$var$Sk(function() {
        $e2f3f7a5613b5dc0$var$gl(b, k, c, d);
    });
    return k;
}
function $e2f3f7a5613b5dc0$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e2f3f7a5613b5dc0$var$hl(g);
                h.call(a);
            };
        }
        $e2f3f7a5613b5dc0$var$gl(b, g, a, e);
    } else g = $e2f3f7a5613b5dc0$var$rl(c, b, a, e, d);
    return $e2f3f7a5613b5dc0$var$hl(g);
}
$e2f3f7a5613b5dc0$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e2f3f7a5613b5dc0$var$tc(b.pendingLanes);
                0 !== c && ($e2f3f7a5613b5dc0$var$Cc(b, c | 1), $e2f3f7a5613b5dc0$var$Ek(b, $e2f3f7a5613b5dc0$var$B()), 0 === ($e2f3f7a5613b5dc0$var$K & 6) && ($e2f3f7a5613b5dc0$var$Hj = $e2f3f7a5613b5dc0$var$B() + 500, $e2f3f7a5613b5dc0$var$jg()));
            }
            break;
        case 13:
            $e2f3f7a5613b5dc0$var$Sk(function() {
                var b = $e2f3f7a5613b5dc0$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e2f3f7a5613b5dc0$var$L();
                    $e2f3f7a5613b5dc0$var$mh(b, a, 1, c);
                }
            }), $e2f3f7a5613b5dc0$var$jl(a, 1);
    }
};
$e2f3f7a5613b5dc0$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e2f3f7a5613b5dc0$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e2f3f7a5613b5dc0$var$L();
            $e2f3f7a5613b5dc0$var$mh(b, a, 134217728, c);
        }
        $e2f3f7a5613b5dc0$var$jl(a, 134217728);
    }
};
$e2f3f7a5613b5dc0$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e2f3f7a5613b5dc0$var$lh(a), c = $e2f3f7a5613b5dc0$var$Zg(a, b);
        if (null !== c) {
            var d = $e2f3f7a5613b5dc0$var$L();
            $e2f3f7a5613b5dc0$var$mh(c, a, b, d);
        }
        $e2f3f7a5613b5dc0$var$jl(a, b);
    }
};
$e2f3f7a5613b5dc0$var$Hc = function() {
    return $e2f3f7a5613b5dc0$var$C;
};
$e2f3f7a5613b5dc0$var$Ic = function(a, b) {
    var c = $e2f3f7a5613b5dc0$var$C;
    try {
        return $e2f3f7a5613b5dc0$var$C = a, b();
    } finally{
        $e2f3f7a5613b5dc0$var$C = c;
    }
};
$e2f3f7a5613b5dc0$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e2f3f7a5613b5dc0$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e2f3f7a5613b5dc0$var$Db(d);
                        if (!e) throw Error($e2f3f7a5613b5dc0$var$p(90));
                        $e2f3f7a5613b5dc0$var$Wa(d);
                        $e2f3f7a5613b5dc0$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e2f3f7a5613b5dc0$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e2f3f7a5613b5dc0$var$fb(a, !!c.multiple, b, !1);
    }
};
$e2f3f7a5613b5dc0$var$Gb = $e2f3f7a5613b5dc0$var$Rk;
$e2f3f7a5613b5dc0$var$Hb = $e2f3f7a5613b5dc0$var$Sk;
var $e2f3f7a5613b5dc0$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e2f3f7a5613b5dc0$var$Cb,
        $e2f3f7a5613b5dc0$var$ue,
        $e2f3f7a5613b5dc0$var$Db,
        $e2f3f7a5613b5dc0$var$Eb,
        $e2f3f7a5613b5dc0$var$Fb,
        $e2f3f7a5613b5dc0$var$Rk
    ]
}, $e2f3f7a5613b5dc0$var$ul = {
    findFiberByHostInstance: $e2f3f7a5613b5dc0$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e2f3f7a5613b5dc0$var$vl = {
    bundleType: $e2f3f7a5613b5dc0$var$ul.bundleType,
    version: $e2f3f7a5613b5dc0$var$ul.version,
    rendererPackageName: $e2f3f7a5613b5dc0$var$ul.rendererPackageName,
    rendererConfig: $e2f3f7a5613b5dc0$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e2f3f7a5613b5dc0$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e2f3f7a5613b5dc0$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e2f3f7a5613b5dc0$var$ul.findFiberByHostInstance || $e2f3f7a5613b5dc0$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e2f3f7a5613b5dc0$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e2f3f7a5613b5dc0$var$wl.isDisabled && $e2f3f7a5613b5dc0$var$wl.supportsFiber) try {
        $e2f3f7a5613b5dc0$var$kc = $e2f3f7a5613b5dc0$var$wl.inject($e2f3f7a5613b5dc0$var$vl), $e2f3f7a5613b5dc0$var$lc = $e2f3f7a5613b5dc0$var$wl;
    } catch (a) {}
}
$e2f3f7a5613b5dc0$export$ae55be85d98224ed = $e2f3f7a5613b5dc0$var$tl;
$e2f3f7a5613b5dc0$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e2f3f7a5613b5dc0$var$ol(b)) throw Error($e2f3f7a5613b5dc0$var$p(200));
    return $e2f3f7a5613b5dc0$var$dl(a, b, null, c);
};
$e2f3f7a5613b5dc0$export$882461b6382ed46c = function(a, b) {
    if (!$e2f3f7a5613b5dc0$var$ol(a)) throw Error($e2f3f7a5613b5dc0$var$p(299));
    var c = !1, d = "", e = $e2f3f7a5613b5dc0$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e2f3f7a5613b5dc0$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e2f3f7a5613b5dc0$var$uf] = b.current;
    $e2f3f7a5613b5dc0$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e2f3f7a5613b5dc0$var$ml(b);
};
$e2f3f7a5613b5dc0$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e2f3f7a5613b5dc0$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e2f3f7a5613b5dc0$var$p(268, a));
    }
    a = $e2f3f7a5613b5dc0$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e2f3f7a5613b5dc0$export$cd75ccfd720a3cd4 = function(a) {
    return $e2f3f7a5613b5dc0$var$Sk(a);
};
$e2f3f7a5613b5dc0$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e2f3f7a5613b5dc0$var$pl(b)) throw Error($e2f3f7a5613b5dc0$var$p(200));
    return $e2f3f7a5613b5dc0$var$sl(null, a, b, !0, c);
};
$e2f3f7a5613b5dc0$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e2f3f7a5613b5dc0$var$ol(a)) throw Error($e2f3f7a5613b5dc0$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e2f3f7a5613b5dc0$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e2f3f7a5613b5dc0$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e2f3f7a5613b5dc0$var$uf] = b.current;
    $e2f3f7a5613b5dc0$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e2f3f7a5613b5dc0$var$nl(b);
};
$e2f3f7a5613b5dc0$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e2f3f7a5613b5dc0$var$pl(b)) throw Error($e2f3f7a5613b5dc0$var$p(200));
    return $e2f3f7a5613b5dc0$var$sl(null, a, b, !1, c);
};
$e2f3f7a5613b5dc0$export$502457920280e6be = function(a) {
    if (!$e2f3f7a5613b5dc0$var$pl(a)) throw Error($e2f3f7a5613b5dc0$var$p(40));
    return a._reactRootContainer ? ($e2f3f7a5613b5dc0$var$Sk(function() {
        $e2f3f7a5613b5dc0$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e2f3f7a5613b5dc0$var$uf] = null;
        });
    }), !0) : !1;
};
$e2f3f7a5613b5dc0$export$c78a37762a8d58e1 = $e2f3f7a5613b5dc0$var$Rk;
$e2f3f7a5613b5dc0$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e2f3f7a5613b5dc0$var$pl(c)) throw Error($e2f3f7a5613b5dc0$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e2f3f7a5613b5dc0$var$p(38));
    return $e2f3f7a5613b5dc0$var$sl(a, b, c, !1, d);
};
$e2f3f7a5613b5dc0$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("io32K", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l2i9W"));

});
parcelRequire.register("l2i9W", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f507deec5a3e6174$export$c4744153514ff05d; }, function (v) { return $f507deec5a3e6174$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f507deec5a3e6174$export$3e506c1ccc9cc1a7; }, function (v) { return $f507deec5a3e6174$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f507deec5a3e6174$export$e26fe2ed2fa76875; }, function (v) { return $f507deec5a3e6174$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f507deec5a3e6174$export$502329bbf4b505b1; }, function (v) { return $f507deec5a3e6174$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f507deec5a3e6174$export$6e3807111c4874c4; }, function (v) { return $f507deec5a3e6174$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f507deec5a3e6174$export$c27134553091fb3a; }, function (v) { return $f507deec5a3e6174$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f507deec5a3e6174$export$33ee1acdc04fd2a2; }, function (v) { return $f507deec5a3e6174$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f507deec5a3e6174$export$b00a404bbd5edef2; }, function (v) { return $f507deec5a3e6174$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f507deec5a3e6174$export$8352ce38b91d0c62; }, function (v) { return $f507deec5a3e6174$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f507deec5a3e6174$export$d66a1c1c77bd778b; }, function (v) { return $f507deec5a3e6174$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f507deec5a3e6174$export$d3dfb8e4810cb555; }, function (v) { return $f507deec5a3e6174$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f507deec5a3e6174$export$839f9183b0465a69; }, function (v) { return $f507deec5a3e6174$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f507deec5a3e6174$export$72fdf0e06517287b; }, function (v) { return $f507deec5a3e6174$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f507deec5a3e6174$export$4b844e58a3e414b4; }, function (v) { return $f507deec5a3e6174$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f507deec5a3e6174$export$816d2913ae6b83b1; }, function (v) { return $f507deec5a3e6174$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f507deec5a3e6174$export$61bcfe829111a1d0; }, function (v) { return $f507deec5a3e6174$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f507deec5a3e6174$export$7ee8c9beb337bc3f; }, function (v) { return $f507deec5a3e6174$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f507deec5a3e6174$export$b5836b71941fa3ed; }, function (v) { return $f507deec5a3e6174$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f507deec5a3e6174$export$cf845f2c119da08a; }, function (v) { return $f507deec5a3e6174$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f507deec5a3e6174$export$c4744153514ff05d;
var $f507deec5a3e6174$export$3e506c1ccc9cc1a7;
var $f507deec5a3e6174$export$e26fe2ed2fa76875;
var $f507deec5a3e6174$export$502329bbf4b505b1;
var $f507deec5a3e6174$export$6e3807111c4874c4;
var $f507deec5a3e6174$export$c27134553091fb3a;
var $f507deec5a3e6174$export$33ee1acdc04fd2a2;
var $f507deec5a3e6174$export$b00a404bbd5edef2;
var $f507deec5a3e6174$export$8352ce38b91d0c62;
var $f507deec5a3e6174$export$d66a1c1c77bd778b;
var $f507deec5a3e6174$export$d3dfb8e4810cb555;
var $f507deec5a3e6174$export$839f9183b0465a69;
var $f507deec5a3e6174$export$72fdf0e06517287b;
var $f507deec5a3e6174$export$4b844e58a3e414b4;
var $f507deec5a3e6174$export$816d2913ae6b83b1;
var $f507deec5a3e6174$export$61bcfe829111a1d0;
var $f507deec5a3e6174$export$7ee8c9beb337bc3f;
var $f507deec5a3e6174$export$b5836b71941fa3ed;
var $f507deec5a3e6174$export$cf845f2c119da08a;
"use strict";
function $f507deec5a3e6174$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f507deec5a3e6174$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f507deec5a3e6174$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f507deec5a3e6174$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f507deec5a3e6174$var$g(C, c)) n < e && 0 > $f507deec5a3e6174$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f507deec5a3e6174$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f507deec5a3e6174$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f507deec5a3e6174$var$l = performance;
    $f507deec5a3e6174$export$c4744153514ff05d = function() {
        return $f507deec5a3e6174$var$l.now();
    };
} else {
    var $f507deec5a3e6174$var$p = Date, $f507deec5a3e6174$var$q = $f507deec5a3e6174$var$p.now();
    $f507deec5a3e6174$export$c4744153514ff05d = function() {
        return $f507deec5a3e6174$var$p.now() - $f507deec5a3e6174$var$q;
    };
}
var $f507deec5a3e6174$var$r = [], $f507deec5a3e6174$var$t = [], $f507deec5a3e6174$var$u = 1, $f507deec5a3e6174$var$v = null, $f507deec5a3e6174$var$y = 3, $f507deec5a3e6174$var$z = !1, $f507deec5a3e6174$var$A = !1, $f507deec5a3e6174$var$B = !1, $f507deec5a3e6174$var$D = "function" === typeof setTimeout ? setTimeout : null, $f507deec5a3e6174$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f507deec5a3e6174$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f507deec5a3e6174$var$G(a) {
    for(var b = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$t); null !== b;){
        if (null === b.callback) $f507deec5a3e6174$var$k($f507deec5a3e6174$var$t);
        else if (b.startTime <= a) $f507deec5a3e6174$var$k($f507deec5a3e6174$var$t), b.sortIndex = b.expirationTime, $f507deec5a3e6174$var$f($f507deec5a3e6174$var$r, b);
        else break;
        b = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$t);
    }
}
function $f507deec5a3e6174$var$H(a) {
    $f507deec5a3e6174$var$B = !1;
    $f507deec5a3e6174$var$G(a);
    if (!$f507deec5a3e6174$var$A) {
        if (null !== $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r)) $f507deec5a3e6174$var$A = !0, $f507deec5a3e6174$var$I($f507deec5a3e6174$var$J);
        else {
            var b = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$t);
            null !== b && $f507deec5a3e6174$var$K($f507deec5a3e6174$var$H, b.startTime - a);
        }
    }
}
function $f507deec5a3e6174$var$J(a, b) {
    $f507deec5a3e6174$var$A = !1;
    $f507deec5a3e6174$var$B && ($f507deec5a3e6174$var$B = !1, $f507deec5a3e6174$var$E($f507deec5a3e6174$var$L), $f507deec5a3e6174$var$L = -1);
    $f507deec5a3e6174$var$z = !0;
    var c = $f507deec5a3e6174$var$y;
    try {
        $f507deec5a3e6174$var$G(b);
        for($f507deec5a3e6174$var$v = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r); null !== $f507deec5a3e6174$var$v && (!($f507deec5a3e6174$var$v.expirationTime > b) || a && !$f507deec5a3e6174$var$M());){
            var d = $f507deec5a3e6174$var$v.callback;
            if ("function" === typeof d) {
                $f507deec5a3e6174$var$v.callback = null;
                $f507deec5a3e6174$var$y = $f507deec5a3e6174$var$v.priorityLevel;
                var e = d($f507deec5a3e6174$var$v.expirationTime <= b);
                b = $f507deec5a3e6174$export$c4744153514ff05d();
                "function" === typeof e ? $f507deec5a3e6174$var$v.callback = e : $f507deec5a3e6174$var$v === $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r) && $f507deec5a3e6174$var$k($f507deec5a3e6174$var$r);
                $f507deec5a3e6174$var$G(b);
            } else $f507deec5a3e6174$var$k($f507deec5a3e6174$var$r);
            $f507deec5a3e6174$var$v = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r);
        }
        if (null !== $f507deec5a3e6174$var$v) var w = !0;
        else {
            var m = $f507deec5a3e6174$var$h($f507deec5a3e6174$var$t);
            null !== m && $f507deec5a3e6174$var$K($f507deec5a3e6174$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f507deec5a3e6174$var$v = null, $f507deec5a3e6174$var$y = c, $f507deec5a3e6174$var$z = !1;
    }
}
var $f507deec5a3e6174$var$N = !1, $f507deec5a3e6174$var$O = null, $f507deec5a3e6174$var$L = -1, $f507deec5a3e6174$var$P = 5, $f507deec5a3e6174$var$Q = -1;
function $f507deec5a3e6174$var$M() {
    return $f507deec5a3e6174$export$c4744153514ff05d() - $f507deec5a3e6174$var$Q < $f507deec5a3e6174$var$P ? !1 : !0;
}
function $f507deec5a3e6174$var$R() {
    if (null !== $f507deec5a3e6174$var$O) {
        var a = $f507deec5a3e6174$export$c4744153514ff05d();
        $f507deec5a3e6174$var$Q = a;
        var b = !0;
        try {
            b = $f507deec5a3e6174$var$O(!0, a);
        } finally{
            b ? $f507deec5a3e6174$var$S() : ($f507deec5a3e6174$var$N = !1, $f507deec5a3e6174$var$O = null);
        }
    } else $f507deec5a3e6174$var$N = !1;
}
var $f507deec5a3e6174$var$S;
if ("function" === typeof $f507deec5a3e6174$var$F) $f507deec5a3e6174$var$S = function() {
    $f507deec5a3e6174$var$F($f507deec5a3e6174$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f507deec5a3e6174$var$T = new MessageChannel, $f507deec5a3e6174$var$U = $f507deec5a3e6174$var$T.port2;
    $f507deec5a3e6174$var$T.port1.onmessage = $f507deec5a3e6174$var$R;
    $f507deec5a3e6174$var$S = function() {
        $f507deec5a3e6174$var$U.postMessage(null);
    };
} else $f507deec5a3e6174$var$S = function() {
    $f507deec5a3e6174$var$D($f507deec5a3e6174$var$R, 0);
};
function $f507deec5a3e6174$var$I(a) {
    $f507deec5a3e6174$var$O = a;
    $f507deec5a3e6174$var$N || ($f507deec5a3e6174$var$N = !0, $f507deec5a3e6174$var$S());
}
function $f507deec5a3e6174$var$K(a, b) {
    $f507deec5a3e6174$var$L = $f507deec5a3e6174$var$D(function() {
        a($f507deec5a3e6174$export$c4744153514ff05d());
    }, b);
}
$f507deec5a3e6174$export$3e506c1ccc9cc1a7 = 5;
$f507deec5a3e6174$export$e26fe2ed2fa76875 = 1;
$f507deec5a3e6174$export$502329bbf4b505b1 = 4;
$f507deec5a3e6174$export$6e3807111c4874c4 = 3;
$f507deec5a3e6174$export$c27134553091fb3a = null;
$f507deec5a3e6174$export$33ee1acdc04fd2a2 = 2;
$f507deec5a3e6174$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f507deec5a3e6174$export$8352ce38b91d0c62 = function() {
    $f507deec5a3e6174$var$A || $f507deec5a3e6174$var$z || ($f507deec5a3e6174$var$A = !0, $f507deec5a3e6174$var$I($f507deec5a3e6174$var$J));
};
$f507deec5a3e6174$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f507deec5a3e6174$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f507deec5a3e6174$export$d3dfb8e4810cb555 = function() {
    return $f507deec5a3e6174$var$y;
};
$f507deec5a3e6174$export$839f9183b0465a69 = function() {
    return $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r);
};
$f507deec5a3e6174$export$72fdf0e06517287b = function(a) {
    switch($f507deec5a3e6174$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f507deec5a3e6174$var$y;
    }
    var c = $f507deec5a3e6174$var$y;
    $f507deec5a3e6174$var$y = b;
    try {
        return a();
    } finally{
        $f507deec5a3e6174$var$y = c;
    }
};
$f507deec5a3e6174$export$4b844e58a3e414b4 = function() {};
$f507deec5a3e6174$export$816d2913ae6b83b1 = function() {};
$f507deec5a3e6174$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f507deec5a3e6174$var$y;
    $f507deec5a3e6174$var$y = a;
    try {
        return b();
    } finally{
        $f507deec5a3e6174$var$y = c;
    }
};
$f507deec5a3e6174$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f507deec5a3e6174$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f507deec5a3e6174$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f507deec5a3e6174$var$f($f507deec5a3e6174$var$t, a), null === $f507deec5a3e6174$var$h($f507deec5a3e6174$var$r) && a === $f507deec5a3e6174$var$h($f507deec5a3e6174$var$t) && ($f507deec5a3e6174$var$B ? ($f507deec5a3e6174$var$E($f507deec5a3e6174$var$L), $f507deec5a3e6174$var$L = -1) : $f507deec5a3e6174$var$B = !0, $f507deec5a3e6174$var$K($f507deec5a3e6174$var$H, c - d))) : (a.sortIndex = e, $f507deec5a3e6174$var$f($f507deec5a3e6174$var$r, a), $f507deec5a3e6174$var$A || $f507deec5a3e6174$var$z || ($f507deec5a3e6174$var$A = !0, $f507deec5a3e6174$var$I($f507deec5a3e6174$var$J)));
    return a;
};
$f507deec5a3e6174$export$b5836b71941fa3ed = $f507deec5a3e6174$var$M;
$f507deec5a3e6174$export$cf845f2c119da08a = function(a) {
    var b = $f507deec5a3e6174$var$y;
    return function() {
        var c = $f507deec5a3e6174$var$y;
        $f507deec5a3e6174$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f507deec5a3e6174$var$y = c;
        }
    };
};

});




parcelRequire.register("fmtXm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2f025ca8816ba3a$var$ReactIs, $b2f025ca8816ba3a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("59HCq"))();

});
parcelRequire.register("59HCq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $83Xs2 = parcelRequire("83Xs2");
function $3c0fa0d02faee464$var$emptyFunction() {}
function $3c0fa0d02faee464$var$emptyFunctionWithReset() {}
$3c0fa0d02faee464$var$emptyFunctionWithReset.resetWarningCache = $3c0fa0d02faee464$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $83Xs2) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3c0fa0d02faee464$var$emptyFunctionWithReset,
        resetWarningCache: $3c0fa0d02faee464$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("83Xs2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $5decb84b1713621a$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $5decb84b1713621a$var$ReactPropTypesSecret;

});



parcelRequire.register("hqFJi", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cb053bfc01ca535f$export$2b8d127b894957b9; }, function (v) { return $cb053bfc01ca535f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cb053bfc01ca535f$export$cea3a54a6425200c; }, function (v) { return $cb053bfc01ca535f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cb053bfc01ca535f$export$a7c73072b1a182ae; }, function (v) { return $cb053bfc01ca535f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cb053bfc01ca535f$export$9f27bc3417b4524d; }, function (v) { return $cb053bfc01ca535f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cb053bfc01ca535f$export$db77ccec0bb4ccac; }, function (v) { return $cb053bfc01ca535f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cb053bfc01ca535f$export$8392c0c9d3dcbd35; }, function (v) { return $cb053bfc01ca535f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cb053bfc01ca535f$export$ffb0004e005737fa; }, function (v) { return $cb053bfc01ca535f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cb053bfc01ca535f$export$b624eff549462981; }, function (v) { return $cb053bfc01ca535f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cb053bfc01ca535f$export$7897aa7841a5380c; }, function (v) { return $cb053bfc01ca535f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cb053bfc01ca535f$export$602eac185826482c; }, function (v) { return $cb053bfc01ca535f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cb053bfc01ca535f$export$e2c29f18771995cb; }, function (v) { return $cb053bfc01ca535f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cb053bfc01ca535f$export$5f8d39834fd61797; }, function (v) { return $cb053bfc01ca535f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cb053bfc01ca535f$export$74bf444e3cd11ea5; }, function (v) { return $cb053bfc01ca535f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cb053bfc01ca535f$export$92387174baf9b227; }, function (v) { return $cb053bfc01ca535f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cb053bfc01ca535f$export$ec112efeb987d9c6; }, function (v) { return $cb053bfc01ca535f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cb053bfc01ca535f$export$b706b080d889d2c9; }, function (v) { return $cb053bfc01ca535f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cb053bfc01ca535f$export$5be5a87408f70ddc; }, function (v) { return $cb053bfc01ca535f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cb053bfc01ca535f$export$45a5e7f76e0caa8d; }, function (v) { return $cb053bfc01ca535f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cb053bfc01ca535f$export$455c2e768291efa6; }, function (v) { return $cb053bfc01ca535f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cb053bfc01ca535f$export$9522e17588c12572; }, function (v) { return $cb053bfc01ca535f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cb053bfc01ca535f$export$2110ac352bb060b9; }, function (v) { return $cb053bfc01ca535f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cb053bfc01ca535f$export$56885ab8b9c456ab; }, function (v) { return $cb053bfc01ca535f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cb053bfc01ca535f$export$d927fcb6adf8f9de; }, function (v) { return $cb053bfc01ca535f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cb053bfc01ca535f$export$b82d16f27459e05a; }, function (v) { return $cb053bfc01ca535f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cb053bfc01ca535f$export$522c17b4f5e123e8; }, function (v) { return $cb053bfc01ca535f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cb053bfc01ca535f$export$1aabd8a0274ecfd6; }, function (v) { return $cb053bfc01ca535f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cb053bfc01ca535f$export$9b621391a187a31a; }, function (v) { return $cb053bfc01ca535f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cb053bfc01ca535f$export$f5bbd400c2f4426f; }, function (v) { return $cb053bfc01ca535f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cb053bfc01ca535f$export$2b8d127b894957b9;
var $cb053bfc01ca535f$export$cea3a54a6425200c;
var $cb053bfc01ca535f$export$a7c73072b1a182ae;
var $cb053bfc01ca535f$export$9f27bc3417b4524d;
var $cb053bfc01ca535f$export$db77ccec0bb4ccac;
var $cb053bfc01ca535f$export$8392c0c9d3dcbd35;
var $cb053bfc01ca535f$export$ffb0004e005737fa;
var $cb053bfc01ca535f$export$b624eff549462981;
var $cb053bfc01ca535f$export$7897aa7841a5380c;
var $cb053bfc01ca535f$export$602eac185826482c;
var $cb053bfc01ca535f$export$e2c29f18771995cb;
var $cb053bfc01ca535f$export$5f8d39834fd61797;
var $cb053bfc01ca535f$export$74bf444e3cd11ea5;
var $cb053bfc01ca535f$export$92387174baf9b227;
var $cb053bfc01ca535f$export$ec112efeb987d9c6;
var $cb053bfc01ca535f$export$b706b080d889d2c9;
var $cb053bfc01ca535f$export$5be5a87408f70ddc;
var $cb053bfc01ca535f$export$45a5e7f76e0caa8d;
var $cb053bfc01ca535f$export$455c2e768291efa6;
var $cb053bfc01ca535f$export$9522e17588c12572;
var $cb053bfc01ca535f$export$2110ac352bb060b9;
var $cb053bfc01ca535f$export$56885ab8b9c456ab;
var $cb053bfc01ca535f$export$d927fcb6adf8f9de;
var $cb053bfc01ca535f$export$b82d16f27459e05a;
var $cb053bfc01ca535f$export$522c17b4f5e123e8;
var $cb053bfc01ca535f$export$1aabd8a0274ecfd6;
var $cb053bfc01ca535f$export$9b621391a187a31a;
var $cb053bfc01ca535f$export$f5bbd400c2f4426f;
"use strict";
var $cb053bfc01ca535f$var$b = "function" === typeof Symbol && Symbol.for, $cb053bfc01ca535f$var$c = $cb053bfc01ca535f$var$b ? Symbol.for("react.element") : 60103, $cb053bfc01ca535f$var$d = $cb053bfc01ca535f$var$b ? Symbol.for("react.portal") : 60106, $cb053bfc01ca535f$var$e = $cb053bfc01ca535f$var$b ? Symbol.for("react.fragment") : 60107, $cb053bfc01ca535f$var$f = $cb053bfc01ca535f$var$b ? Symbol.for("react.strict_mode") : 60108, $cb053bfc01ca535f$var$g = $cb053bfc01ca535f$var$b ? Symbol.for("react.profiler") : 60114, $cb053bfc01ca535f$var$h = $cb053bfc01ca535f$var$b ? Symbol.for("react.provider") : 60109, $cb053bfc01ca535f$var$k = $cb053bfc01ca535f$var$b ? Symbol.for("react.context") : 60110, $cb053bfc01ca535f$var$l = $cb053bfc01ca535f$var$b ? Symbol.for("react.async_mode") : 60111, $cb053bfc01ca535f$var$m = $cb053bfc01ca535f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cb053bfc01ca535f$var$n = $cb053bfc01ca535f$var$b ? Symbol.for("react.forward_ref") : 60112, $cb053bfc01ca535f$var$p = $cb053bfc01ca535f$var$b ? Symbol.for("react.suspense") : 60113, $cb053bfc01ca535f$var$q = $cb053bfc01ca535f$var$b ? Symbol.for("react.suspense_list") : 60120, $cb053bfc01ca535f$var$r = $cb053bfc01ca535f$var$b ? Symbol.for("react.memo") : 60115, $cb053bfc01ca535f$var$t = $cb053bfc01ca535f$var$b ? Symbol.for("react.lazy") : 60116, $cb053bfc01ca535f$var$v = $cb053bfc01ca535f$var$b ? Symbol.for("react.block") : 60121, $cb053bfc01ca535f$var$w = $cb053bfc01ca535f$var$b ? Symbol.for("react.fundamental") : 60117, $cb053bfc01ca535f$var$x = $cb053bfc01ca535f$var$b ? Symbol.for("react.responder") : 60118, $cb053bfc01ca535f$var$y = $cb053bfc01ca535f$var$b ? Symbol.for("react.scope") : 60119;
function $cb053bfc01ca535f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cb053bfc01ca535f$var$c:
                switch(a = a.type, a){
                    case $cb053bfc01ca535f$var$l:
                    case $cb053bfc01ca535f$var$m:
                    case $cb053bfc01ca535f$var$e:
                    case $cb053bfc01ca535f$var$g:
                    case $cb053bfc01ca535f$var$f:
                    case $cb053bfc01ca535f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cb053bfc01ca535f$var$k:
                            case $cb053bfc01ca535f$var$n:
                            case $cb053bfc01ca535f$var$t:
                            case $cb053bfc01ca535f$var$r:
                            case $cb053bfc01ca535f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cb053bfc01ca535f$var$d:
                return u;
        }
    }
}
function $cb053bfc01ca535f$var$A(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$m;
}
$cb053bfc01ca535f$export$2b8d127b894957b9 = $cb053bfc01ca535f$var$l;
$cb053bfc01ca535f$export$cea3a54a6425200c = $cb053bfc01ca535f$var$m;
$cb053bfc01ca535f$export$a7c73072b1a182ae = $cb053bfc01ca535f$var$k;
$cb053bfc01ca535f$export$9f27bc3417b4524d = $cb053bfc01ca535f$var$h;
$cb053bfc01ca535f$export$db77ccec0bb4ccac = $cb053bfc01ca535f$var$c;
$cb053bfc01ca535f$export$8392c0c9d3dcbd35 = $cb053bfc01ca535f$var$n;
$cb053bfc01ca535f$export$ffb0004e005737fa = $cb053bfc01ca535f$var$e;
$cb053bfc01ca535f$export$b624eff549462981 = $cb053bfc01ca535f$var$t;
$cb053bfc01ca535f$export$7897aa7841a5380c = $cb053bfc01ca535f$var$r;
$cb053bfc01ca535f$export$602eac185826482c = $cb053bfc01ca535f$var$d;
$cb053bfc01ca535f$export$e2c29f18771995cb = $cb053bfc01ca535f$var$g;
$cb053bfc01ca535f$export$5f8d39834fd61797 = $cb053bfc01ca535f$var$f;
$cb053bfc01ca535f$export$74bf444e3cd11ea5 = $cb053bfc01ca535f$var$p;
$cb053bfc01ca535f$export$92387174baf9b227 = function(a) {
    return $cb053bfc01ca535f$var$A(a) || $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$l;
};
$cb053bfc01ca535f$export$ec112efeb987d9c6 = $cb053bfc01ca535f$var$A;
$cb053bfc01ca535f$export$b706b080d889d2c9 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$k;
};
$cb053bfc01ca535f$export$5be5a87408f70ddc = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$h;
};
$cb053bfc01ca535f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cb053bfc01ca535f$var$c;
};
$cb053bfc01ca535f$export$455c2e768291efa6 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$n;
};
$cb053bfc01ca535f$export$9522e17588c12572 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$e;
};
$cb053bfc01ca535f$export$2110ac352bb060b9 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$t;
};
$cb053bfc01ca535f$export$56885ab8b9c456ab = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$r;
};
$cb053bfc01ca535f$export$d927fcb6adf8f9de = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$d;
};
$cb053bfc01ca535f$export$b82d16f27459e05a = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$g;
};
$cb053bfc01ca535f$export$522c17b4f5e123e8 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$f;
};
$cb053bfc01ca535f$export$1aabd8a0274ecfd6 = function(a) {
    return $cb053bfc01ca535f$var$z(a) === $cb053bfc01ca535f$var$p;
};
$cb053bfc01ca535f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cb053bfc01ca535f$var$e || a === $cb053bfc01ca535f$var$m || a === $cb053bfc01ca535f$var$g || a === $cb053bfc01ca535f$var$f || a === $cb053bfc01ca535f$var$p || a === $cb053bfc01ca535f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cb053bfc01ca535f$var$t || a.$$typeof === $cb053bfc01ca535f$var$r || a.$$typeof === $cb053bfc01ca535f$var$h || a.$$typeof === $cb053bfc01ca535f$var$k || a.$$typeof === $cb053bfc01ca535f$var$n || a.$$typeof === $cb053bfc01ca535f$var$w || a.$$typeof === $cb053bfc01ca535f$var$x || a.$$typeof === $cb053bfc01ca535f$var$y || a.$$typeof === $cb053bfc01ca535f$var$v);
};
$cb053bfc01ca535f$export$f5bbd400c2f4426f = $cb053bfc01ca535f$var$z;

});

parcelRequire.register("6NaXQ", function(module, exports) {

var $lb3R3 = parcelRequire("lb3R3");

var $a7s2x = parcelRequire("a7s2x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $lb3R3.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $a7s2x;
module.exports = isBuffer;

});
parcelRequire.register("lb3R3", function(module, exports) {

var $1gj5C = parcelRequire("1gj5C");
/** Detect free variable `self`. */ var $f6ad9d849dbc624f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f6ad9d849dbc624f$var$root = $1gj5C || $f6ad9d849dbc624f$var$freeSelf || Function("return this")();
module.exports = $f6ad9d849dbc624f$var$root;

});
parcelRequire.register("1gj5C", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $0eb617ddbaeb35fa$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $0eb617ddbaeb35fa$var$freeGlobal;

});


parcelRequire.register("a7s2x", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $01e6b6f39549b05c$var$stubFalse() {
    return false;
}
module.exports = $01e6b6f39549b05c$var$stubFalse;

});


parcelRequire.register("8WXKx", function(module, exports) {

var $1gj5C = parcelRequire("1gj5C");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $1gj5C.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("gwXx2", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("kIXB3"));

});
parcelRequire.register("kIXB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $8isHX.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $8isHX.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $lftQy.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $lftQy.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $7xbyJ.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $7xbyJ.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $7xbyJ.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $7xbyJ.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $f166256324f3a9e5$var$_symbol.symbolsStroke;
    }
});

var $f166256324f3a9e5$var$_arc = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("92Xml")));

var $f166256324f3a9e5$var$_area = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("hvnzq")));

var $f166256324f3a9e5$var$_line = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("lhQfJ")));

var $f166256324f3a9e5$var$_pie = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("gMRYG")));

var $f166256324f3a9e5$var$_areaRadial = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("bXPS7")));

var $f166256324f3a9e5$var$_lineRadial = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("5F5Qu")));

var $f166256324f3a9e5$var$_pointRadial = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("alx5i")));

var $7xbyJ = parcelRequire("7xbyJ");

var $f166256324f3a9e5$var$_symbol = $f166256324f3a9e5$var$_interopRequireWildcard((parcelRequire("jgOrY")));

var $f166256324f3a9e5$var$_asterisk = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("7TP20")));

var $f166256324f3a9e5$var$_circle = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("a2QRp")));

var $f166256324f3a9e5$var$_cross = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("T1lZv")));

var $f166256324f3a9e5$var$_diamond = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("4s39P")));

var $f166256324f3a9e5$var$_diamond2 = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("gjuiU")));

var $f166256324f3a9e5$var$_plus = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("33UrB")));

var $f166256324f3a9e5$var$_square = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("775oq")));

var $f166256324f3a9e5$var$_square2 = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("gYiCQ")));

var $f166256324f3a9e5$var$_star = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("fykyn")));

var $f166256324f3a9e5$var$_triangle = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("6d1QZ")));

var $f166256324f3a9e5$var$_triangle2 = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("7Eqr3")));

var $f166256324f3a9e5$var$_wye = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("hamVV")));

var $f166256324f3a9e5$var$_x = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("hxYSe")));

var $f166256324f3a9e5$var$_basisClosed = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("a5Abc")));

var $f166256324f3a9e5$var$_basisOpen = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("5wR0v")));

var $f166256324f3a9e5$var$_basis = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("84a7S")));

var $8isHX = parcelRequire("8isHX");

var $f166256324f3a9e5$var$_bundle = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("3kI0d")));

var $f166256324f3a9e5$var$_cardinalClosed = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("eL52l")));

var $f166256324f3a9e5$var$_cardinalOpen = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("a6vIH")));

var $f166256324f3a9e5$var$_cardinal = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("1zXMY")));

var $f166256324f3a9e5$var$_catmullRomClosed = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("goRNH")));

var $f166256324f3a9e5$var$_catmullRomOpen = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("bmtEc")));

var $f166256324f3a9e5$var$_catmullRom = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("4L7EM")));

var $f166256324f3a9e5$var$_linearClosed = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("8MiZd")));

var $f166256324f3a9e5$var$_linear = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("d53iG")));

var $lftQy = parcelRequire("lftQy");

var $f166256324f3a9e5$var$_natural = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("fQJxS")));

var $f166256324f3a9e5$var$_step = $f166256324f3a9e5$var$_interopRequireWildcard((parcelRequire("2CwUo")));

var $f166256324f3a9e5$var$_stack = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("83cea")));

var $f166256324f3a9e5$var$_expand = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("1T46e")));

var $f166256324f3a9e5$var$_diverging = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("44gAL")));

var $f166256324f3a9e5$var$_none = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("skUZe")));

var $f166256324f3a9e5$var$_silhouette = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("Fnzfq")));

var $f166256324f3a9e5$var$_wiggle = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("2omGA")));

var $f166256324f3a9e5$var$_appearance = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("elZe8")));

var $f166256324f3a9e5$var$_ascending = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("jEiiI")));

var $f166256324f3a9e5$var$_descending = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("cZTZL")));

var $f166256324f3a9e5$var$_insideOut = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("6ocfg")));

var $f166256324f3a9e5$var$_none2 = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("4p89w")));

var $f166256324f3a9e5$var$_reverse = $f166256324f3a9e5$var$_interopRequireDefault((parcelRequire("9Dw7q")));
function $f166256324f3a9e5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f166256324f3a9e5$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f166256324f3a9e5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f166256324f3a9e5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f166256324f3a9e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("92Xml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6962587b187fa807$var$_default;

var $gd0nN = parcelRequire("gd0nN");

var $6962587b187fa807$var$_constant = $6962587b187fa807$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $en7S8 = parcelRequire("en7S8");
function $6962587b187fa807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6962587b187fa807$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $6962587b187fa807$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $6962587b187fa807$var$arcStartAngle(d) {
    return d.startAngle;
}
function $6962587b187fa807$var$arcEndAngle(d) {
    return d.endAngle;
}
function $6962587b187fa807$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $6962587b187fa807$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $en7S8.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $6962587b187fa807$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $en7S8.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $en7S8.sqrt)((0, $en7S8.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $6962587b187fa807$var$_default() {
    var innerRadius = $6962587b187fa807$var$arcInnerRadius, outerRadius = $6962587b187fa807$var$arcOuterRadius, cornerRadius = (0, $6962587b187fa807$var$_constant.default)(0), padRadius = null, startAngle = $6962587b187fa807$var$arcStartAngle, endAngle = $6962587b187fa807$var$arcEndAngle, padAngle = $6962587b187fa807$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $en7S8.halfPi, a1 = endAngle.apply(this, arguments) - $en7S8.halfPi, da = (0, $en7S8.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $gd0nN.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $en7S8.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $en7S8.tau - $en7S8.epsilon) {
            context.moveTo(r1 * (0, $en7S8.cos)(a0), r1 * (0, $en7S8.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $en7S8.epsilon) {
                context.moveTo(r0 * (0, $en7S8.cos)(a1), r0 * (0, $en7S8.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $en7S8.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $en7S8.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $en7S8.min)((0, $en7S8.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $en7S8.epsilon) {
                var p0 = (0, $en7S8.asin)(rp / r0 * (0, $en7S8.sin)(ap)), p1 = (0, $en7S8.asin)(rp / r1 * (0, $en7S8.sin)(ap));
                if ((da0 -= p0 * 2) > $en7S8.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $en7S8.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $en7S8.cos)(a01), y01 = r1 * (0, $en7S8.sin)(a01), x10 = r0 * (0, $en7S8.cos)(a10), y10 = r0 * (0, $en7S8.sin)(a10); // Apply rounded corners?
            if (rc > $en7S8.epsilon) {
                var x11 = r1 * (0, $en7S8.cos)(a11), y11 = r1 * (0, $en7S8.sin)(a11), x00 = r0 * (0, $en7S8.cos)(a00), y00 = r0 * (0, $en7S8.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $en7S8.pi && (oc = $6962587b187fa807$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $en7S8.sin)((0, $en7S8.acos)((ax * bx + ay * by) / ((0, $en7S8.sqrt)(ax * ax + ay * ay) * (0, $en7S8.sqrt)(bx * bx + by * by))) / 2), lc = (0, $en7S8.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $en7S8.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $en7S8.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $en7S8.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $en7S8.epsilon) {
                t0 = $6962587b187fa807$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $6962587b187fa807$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $en7S8.atan2)(t0.y01, t0.x01), (0, $en7S8.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $en7S8.atan2)(t0.y01, t0.x01), (0, $en7S8.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $en7S8.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $en7S8.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $en7S8.atan2)(t1.y11, t1.x11), (0, $en7S8.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $en7S8.epsilon) || !(da0 > $en7S8.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $en7S8.epsilon) {
                t0 = $6962587b187fa807$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $6962587b187fa807$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $en7S8.atan2)(t0.y01, t0.x01), (0, $en7S8.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $en7S8.atan2)(t0.y01, t0.x01), (0, $en7S8.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $en7S8.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $en7S8.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $en7S8.atan2)(t1.y11, t1.x11), (0, $en7S8.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $en7S8.pi / 2;
        return [
            (0, $en7S8.cos)(a) * r,
            (0, $en7S8.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $6962587b187fa807$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRequire.register("gd0nN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $bcce2844fff75039$var$_path.default;
    }
});

var $bcce2844fff75039$var$_path = $bcce2844fff75039$var$_interopRequireDefault((parcelRequire("aqIIG")));
function $bcce2844fff75039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("aqIIG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $797f057bf35432a0$var$pi = Math.PI, $797f057bf35432a0$var$tau = 2 * $797f057bf35432a0$var$pi, $797f057bf35432a0$var$epsilon = 1e-6, $797f057bf35432a0$var$tauEpsilon = $797f057bf35432a0$var$tau - $797f057bf35432a0$var$epsilon;
function $797f057bf35432a0$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $797f057bf35432a0$var$path() {
    return new $797f057bf35432a0$var$Path();
}
$797f057bf35432a0$var$Path.prototype = $797f057bf35432a0$var$path.prototype = {
    constructor: $797f057bf35432a0$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $797f057bf35432a0$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $797f057bf35432a0$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($797f057bf35432a0$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $797f057bf35432a0$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $797f057bf35432a0$var$epsilon || Math.abs(this._y1 - y0) > $797f057bf35432a0$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $797f057bf35432a0$var$tau + $797f057bf35432a0$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $797f057bf35432a0$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $797f057bf35432a0$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $797f057bf35432a0$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $797f057bf35432a0$var$_default = $797f057bf35432a0$var$path;
module.exports.default = $797f057bf35432a0$var$_default;

});


parcelRequire.register("6QWWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fd5513329390591$var$_default;
function $4fd5513329390591$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRequire.register("en7S8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $a76951e94fe6ed87$var$acos;
module.exports.asin = $a76951e94fe6ed87$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $a76951e94fe6ed87$var$abs = Math.abs;
module.exports.abs = $a76951e94fe6ed87$var$abs;
const $a76951e94fe6ed87$var$atan2 = Math.atan2;
module.exports.atan2 = $a76951e94fe6ed87$var$atan2;
const $a76951e94fe6ed87$var$cos = Math.cos;
module.exports.cos = $a76951e94fe6ed87$var$cos;
const $a76951e94fe6ed87$var$max = Math.max;
module.exports.max = $a76951e94fe6ed87$var$max;
const $a76951e94fe6ed87$var$min = Math.min;
module.exports.min = $a76951e94fe6ed87$var$min;
const $a76951e94fe6ed87$var$sin = Math.sin;
module.exports.sin = $a76951e94fe6ed87$var$sin;
const $a76951e94fe6ed87$var$sqrt = Math.sqrt;
module.exports.sqrt = $a76951e94fe6ed87$var$sqrt;
const $a76951e94fe6ed87$var$epsilon = 1e-12;
module.exports.epsilon = $a76951e94fe6ed87$var$epsilon;
const $a76951e94fe6ed87$var$pi = Math.PI;
module.exports.pi = $a76951e94fe6ed87$var$pi;
const $a76951e94fe6ed87$var$halfPi = $a76951e94fe6ed87$var$pi / 2;
module.exports.halfPi = $a76951e94fe6ed87$var$halfPi;
const $a76951e94fe6ed87$var$tau = 2 * $a76951e94fe6ed87$var$pi;
module.exports.tau = $a76951e94fe6ed87$var$tau;
function $a76951e94fe6ed87$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $a76951e94fe6ed87$var$pi : Math.acos(x);
}
function $a76951e94fe6ed87$var$asin(x) {
    return x >= 1 ? $a76951e94fe6ed87$var$halfPi : x <= -1 ? -$a76951e94fe6ed87$var$halfPi : Math.asin(x);
}

});


parcelRequire.register("hvnzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbe79d80351cb9d4$var$_default;

var $gd0nN = parcelRequire("gd0nN");

var $cbe79d80351cb9d4$var$_array = $cbe79d80351cb9d4$var$_interopRequireDefault((parcelRequire("7uvMs")));

var $cbe79d80351cb9d4$var$_constant = $cbe79d80351cb9d4$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $cbe79d80351cb9d4$var$_linear = $cbe79d80351cb9d4$var$_interopRequireDefault((parcelRequire("d53iG")));

var $cbe79d80351cb9d4$var$_line = $cbe79d80351cb9d4$var$_interopRequireDefault((parcelRequire("lhQfJ")));

var $lbrur = parcelRequire("lbrur");
function $cbe79d80351cb9d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbe79d80351cb9d4$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $cbe79d80351cb9d4$var$_constant.default)(true), context = null, curve = $cbe79d80351cb9d4$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $lbrur.x : (0, $cbe79d80351cb9d4$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $cbe79d80351cb9d4$var$_constant.default)(0) : (0, $cbe79d80351cb9d4$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $lbrur.y : (0, $cbe79d80351cb9d4$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $cbe79d80351cb9d4$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $gd0nN.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $cbe79d80351cb9d4$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $cbe79d80351cb9d4$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRequire.register("7uvMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5743fcafa9279f17$var$_default;
module.exports.slice = void 0;
var $5743fcafa9279f17$var$slice = Array.prototype.slice;
module.exports.slice = $5743fcafa9279f17$var$slice;
function $5743fcafa9279f17$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRequire.register("d53iG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $985e4d6154681985$var$_default;
function $985e4d6154681985$var$Linear(context) {
    this._context = context;
}
$985e4d6154681985$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $985e4d6154681985$var$_default(context) {
    return new $985e4d6154681985$var$Linear(context);
}

});

parcelRequire.register("lhQfJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7f3b7d0fb4c82f8$var$_default;

var $gd0nN = parcelRequire("gd0nN");

var $f7f3b7d0fb4c82f8$var$_array = $f7f3b7d0fb4c82f8$var$_interopRequireDefault((parcelRequire("7uvMs")));

var $f7f3b7d0fb4c82f8$var$_constant = $f7f3b7d0fb4c82f8$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $f7f3b7d0fb4c82f8$var$_linear = $f7f3b7d0fb4c82f8$var$_interopRequireDefault((parcelRequire("d53iG")));

var $lbrur = parcelRequire("lbrur");
function $f7f3b7d0fb4c82f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7f3b7d0fb4c82f8$var$_default(x, y) {
    var defined = (0, $f7f3b7d0fb4c82f8$var$_constant.default)(true), context = null, curve = $f7f3b7d0fb4c82f8$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $lbrur.x : (0, $f7f3b7d0fb4c82f8$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $lbrur.y : (0, $f7f3b7d0fb4c82f8$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $f7f3b7d0fb4c82f8$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $gd0nN.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $f7f3b7d0fb4c82f8$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $f7f3b7d0fb4c82f8$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $f7f3b7d0fb4c82f8$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRequire.register("lbrur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $f6bff2f94e05da4a$var$x;
module.exports.y = $f6bff2f94e05da4a$var$y;
function $f6bff2f94e05da4a$var$x(p) {
    return p[0];
}
function $f6bff2f94e05da4a$var$y(p) {
    return p[1];
}

});



parcelRequire.register("gMRYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c38affe13d52c2a8$var$_default;

var $c38affe13d52c2a8$var$_array = $c38affe13d52c2a8$var$_interopRequireDefault((parcelRequire("7uvMs")));

var $c38affe13d52c2a8$var$_constant = $c38affe13d52c2a8$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $c38affe13d52c2a8$var$_descending = $c38affe13d52c2a8$var$_interopRequireDefault((parcelRequire("AfdsU")));

var $c38affe13d52c2a8$var$_identity = $c38affe13d52c2a8$var$_interopRequireDefault((parcelRequire("9fjl0")));

var $en7S8 = parcelRequire("en7S8");
function $c38affe13d52c2a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c38affe13d52c2a8$var$_default() {
    var value = $c38affe13d52c2a8$var$_identity.default, sortValues = $c38affe13d52c2a8$var$_descending.default, sort = null, startAngle = (0, $c38affe13d52c2a8$var$_constant.default)(0), endAngle = (0, $c38affe13d52c2a8$var$_constant.default)($en7S8.tau), padAngle = (0, $c38affe13d52c2a8$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $c38affe13d52c2a8$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($en7S8.tau, Math.max(-$en7S8.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $c38affe13d52c2a8$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c38affe13d52c2a8$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c38affe13d52c2a8$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c38affe13d52c2a8$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRequire.register("AfdsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06cf2a86409827ac$var$_default;
function $06cf2a86409827ac$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRequire.register("9fjl0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bb483d4a2c430fa$var$_default;
function $6bb483d4a2c430fa$var$_default(d) {
    return d;
}

});


parcelRequire.register("bXPS7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b5d710ffd2e0fba$var$_default;

var $8b5d710ffd2e0fba$var$_radial = $8b5d710ffd2e0fba$var$_interopRequireWildcard((parcelRequire("iaBAU")));

var $8b5d710ffd2e0fba$var$_area = $8b5d710ffd2e0fba$var$_interopRequireDefault((parcelRequire("hvnzq")));

var $5F5Qu = parcelRequire("5F5Qu");
function $8b5d710ffd2e0fba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b5d710ffd2e0fba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8b5d710ffd2e0fba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8b5d710ffd2e0fba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8b5d710ffd2e0fba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8b5d710ffd2e0fba$var$_default() {
    var a = (0, $8b5d710ffd2e0fba$var$_area.default)().curve($8b5d710ffd2e0fba$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $5F5Qu.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $5F5Qu.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $5F5Qu.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $5F5Qu.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $8b5d710ffd2e0fba$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRequire.register("iaBAU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $d3a6529970ed4eed$var$curveRadial;

var $d3a6529970ed4eed$var$_linear = $d3a6529970ed4eed$var$_interopRequireDefault((parcelRequire("d53iG")));
function $d3a6529970ed4eed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d3a6529970ed4eed$var$curveRadialLinear = $d3a6529970ed4eed$var$curveRadial($d3a6529970ed4eed$var$_linear.default);
module.exports.curveRadialLinear = $d3a6529970ed4eed$var$curveRadialLinear;
function $d3a6529970ed4eed$var$Radial(curve) {
    this._curve = curve;
}
$d3a6529970ed4eed$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $d3a6529970ed4eed$var$curveRadial(curve) {
    function radial(context) {
        return new $d3a6529970ed4eed$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRequire.register("5F5Qu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41f550e247d88230$var$_default;
module.exports.lineRadial = $41f550e247d88230$var$lineRadial;

var $41f550e247d88230$var$_radial = $41f550e247d88230$var$_interopRequireWildcard((parcelRequire("iaBAU")));

var $41f550e247d88230$var$_line = $41f550e247d88230$var$_interopRequireDefault((parcelRequire("lhQfJ")));
function $41f550e247d88230$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41f550e247d88230$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($41f550e247d88230$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $41f550e247d88230$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $41f550e247d88230$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $41f550e247d88230$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $41f550e247d88230$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $41f550e247d88230$var$_default() {
    return $41f550e247d88230$var$lineRadial((0, $41f550e247d88230$var$_line.default)().curve($41f550e247d88230$var$_radial.curveRadialLinear));
}

});


parcelRequire.register("alx5i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $788587671b691c97$var$_default;
function $788587671b691c97$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRequire.register("7xbyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $57c494decd59b022$var$link;
module.exports.linkHorizontal = $57c494decd59b022$var$linkHorizontal;
module.exports.linkRadial = $57c494decd59b022$var$linkRadial;
module.exports.linkVertical = $57c494decd59b022$var$linkVertical;

var $gd0nN = parcelRequire("gd0nN");

var $7uvMs = parcelRequire("7uvMs");

var $57c494decd59b022$var$_constant = $57c494decd59b022$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $8isHX = parcelRequire("8isHX");

var $lbrur = parcelRequire("lbrur");
function $57c494decd59b022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57c494decd59b022$var$linkSource(d) {
    return d.source;
}
function $57c494decd59b022$var$linkTarget(d) {
    return d.target;
}
function $57c494decd59b022$var$link(curve) {
    let source = $57c494decd59b022$var$linkSource;
    let target = $57c494decd59b022$var$linkTarget;
    let x = $lbrur.x;
    let y = $lbrur.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $7uvMs.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $gd0nN.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $57c494decd59b022$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $57c494decd59b022$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $57c494decd59b022$var$linkHorizontal() {
    return $57c494decd59b022$var$link($8isHX.bumpX);
}
function $57c494decd59b022$var$linkVertical() {
    return $57c494decd59b022$var$link($8isHX.bumpY);
}
function $57c494decd59b022$var$linkRadial() {
    const l = $57c494decd59b022$var$link($8isHX.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRequire.register("8isHX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $60a645f6e735e973$var$bumpRadial;
module.exports.bumpX = $60a645f6e735e973$var$bumpX;
module.exports.bumpY = $60a645f6e735e973$var$bumpY;

var $60a645f6e735e973$var$_pointRadial = $60a645f6e735e973$var$_interopRequireDefault((parcelRequire("alx5i")));
function $60a645f6e735e973$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $60a645f6e735e973$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $60a645f6e735e973$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $60a645f6e735e973$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $60a645f6e735e973$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $60a645f6e735e973$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $60a645f6e735e973$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $60a645f6e735e973$var$bumpX(context) {
    return new $60a645f6e735e973$var$Bump(context, true);
}
function $60a645f6e735e973$var$bumpY(context) {
    return new $60a645f6e735e973$var$Bump(context, false);
}
function $60a645f6e735e973$var$bumpRadial(context) {
    return new $60a645f6e735e973$var$BumpRadial(context);
}

});


parcelRequire.register("jgOrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e076a550deb91dd9$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $gd0nN = parcelRequire("gd0nN");

var $e076a550deb91dd9$var$_constant = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $e076a550deb91dd9$var$_asterisk = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("7TP20")));

var $e076a550deb91dd9$var$_circle = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("a2QRp")));

var $e076a550deb91dd9$var$_cross = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("T1lZv")));

var $e076a550deb91dd9$var$_diamond = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("4s39P")));

var $e076a550deb91dd9$var$_diamond2 = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("gjuiU")));

var $e076a550deb91dd9$var$_plus = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("33UrB")));

var $e076a550deb91dd9$var$_square = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("775oq")));

var $e076a550deb91dd9$var$_square2 = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("gYiCQ")));

var $e076a550deb91dd9$var$_star = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("fykyn")));

var $e076a550deb91dd9$var$_triangle = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("6d1QZ")));

var $e076a550deb91dd9$var$_triangle2 = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("7Eqr3")));

var $e076a550deb91dd9$var$_wye = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("hamVV")));

var $e076a550deb91dd9$var$_x = $e076a550deb91dd9$var$_interopRequireDefault((parcelRequire("hxYSe")));
function $e076a550deb91dd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $e076a550deb91dd9$var$symbolsFill = [
    $e076a550deb91dd9$var$_circle.default,
    $e076a550deb91dd9$var$_cross.default,
    $e076a550deb91dd9$var$_diamond.default,
    $e076a550deb91dd9$var$_square.default,
    $e076a550deb91dd9$var$_star.default,
    $e076a550deb91dd9$var$_triangle.default,
    $e076a550deb91dd9$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $e076a550deb91dd9$var$symbolsFill;
const $e076a550deb91dd9$var$symbolsStroke = [
    $e076a550deb91dd9$var$_circle.default,
    $e076a550deb91dd9$var$_plus.default,
    $e076a550deb91dd9$var$_x.default,
    $e076a550deb91dd9$var$_triangle2.default,
    $e076a550deb91dd9$var$_asterisk.default,
    $e076a550deb91dd9$var$_square2.default,
    $e076a550deb91dd9$var$_diamond2.default
];
module.exports.symbolsStroke = $e076a550deb91dd9$var$symbolsStroke;
function $e076a550deb91dd9$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $e076a550deb91dd9$var$_constant.default)(type || $e076a550deb91dd9$var$_circle.default);
    size = typeof size === "function" ? size : (0, $e076a550deb91dd9$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $gd0nN.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $e076a550deb91dd9$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $e076a550deb91dd9$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRequire.register("7TP20", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $5c054136ef1b65a7$var$sqrt3 = (0, $en7S8.sqrt)(3);
var $5c054136ef1b65a7$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size + (0, $en7S8.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $5c054136ef1b65a7$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $5c054136ef1b65a7$var$_default;

});

parcelRequire.register("a2QRp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $75031844052bf823$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size / $en7S8.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $en7S8.tau);
    }
};
module.exports.default = $75031844052bf823$var$_default;

});

parcelRequire.register("T1lZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $0a562ffc0be489b9$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $0a562ffc0be489b9$var$_default;

});

parcelRequire.register("4s39P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $33dc39f5aa8b9370$var$tan30 = (0, $en7S8.sqrt)(1 / 3);
const $33dc39f5aa8b9370$var$tan30_2 = $33dc39f5aa8b9370$var$tan30 * 2;
var $33dc39f5aa8b9370$var$_default = {
    draw (context, size) {
        const y = (0, $en7S8.sqrt)(size / $33dc39f5aa8b9370$var$tan30_2);
        const x = y * $33dc39f5aa8b9370$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $33dc39f5aa8b9370$var$_default;

});

parcelRequire.register("gjuiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $be05ed722d04611f$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $be05ed722d04611f$var$_default;

});

parcelRequire.register("33UrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $23ad6f87f03372ad$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size - (0, $en7S8.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $23ad6f87f03372ad$var$_default;

});

parcelRequire.register("775oq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $52dd5ec89473c9f8$var$_default = {
    draw (context, size) {
        const w = (0, $en7S8.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $52dd5ec89473c9f8$var$_default;

});

parcelRequire.register("gYiCQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $c5b0b29ac41650ee$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c5b0b29ac41650ee$var$_default;

});

parcelRequire.register("fykyn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $b529f97f85afe350$var$ka = 0.89081309152928522810;
const $b529f97f85afe350$var$kr = (0, $en7S8.sin)($en7S8.pi / 10) / (0, $en7S8.sin)(7 * $en7S8.pi / 10);
const $b529f97f85afe350$var$kx = (0, $en7S8.sin)($en7S8.tau / 10) * $b529f97f85afe350$var$kr;
const $b529f97f85afe350$var$ky = -(0, $en7S8.cos)($en7S8.tau / 10) * $b529f97f85afe350$var$kr;
var $b529f97f85afe350$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size * $b529f97f85afe350$var$ka);
        const x = $b529f97f85afe350$var$kx * r;
        const y = $b529f97f85afe350$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $en7S8.tau * i / 5;
            const c = (0, $en7S8.cos)(a);
            const s = (0, $en7S8.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $b529f97f85afe350$var$_default;

});

parcelRequire.register("6d1QZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $485565131016bcfa$var$sqrt3 = (0, $en7S8.sqrt)(3);
var $485565131016bcfa$var$_default = {
    draw (context, size) {
        const y = -(0, $en7S8.sqrt)(size / ($485565131016bcfa$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$485565131016bcfa$var$sqrt3 * y, -y);
        context.lineTo($485565131016bcfa$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $485565131016bcfa$var$_default;

});

parcelRequire.register("7Eqr3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $5920c654710c69a3$var$sqrt3 = (0, $en7S8.sqrt)(3);
var $5920c654710c69a3$var$_default = {
    draw (context, size) {
        const s = (0, $en7S8.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $5920c654710c69a3$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $5920c654710c69a3$var$_default;

});

parcelRequire.register("hamVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
const $c7f528eb3864381d$var$c = -0.5;
const $c7f528eb3864381d$var$s = (0, $en7S8.sqrt)(3) / 2;
const $c7f528eb3864381d$var$k = 1 / (0, $en7S8.sqrt)(12);
const $c7f528eb3864381d$var$a = ($c7f528eb3864381d$var$k / 2 + 1) * 3;
var $c7f528eb3864381d$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size / $c7f528eb3864381d$var$a);
        const x0 = r / 2, y0 = r * $c7f528eb3864381d$var$k;
        const x1 = x0, y1 = r * $c7f528eb3864381d$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($c7f528eb3864381d$var$c * x0 - $c7f528eb3864381d$var$s * y0, $c7f528eb3864381d$var$s * x0 + $c7f528eb3864381d$var$c * y0);
        context.lineTo($c7f528eb3864381d$var$c * x1 - $c7f528eb3864381d$var$s * y1, $c7f528eb3864381d$var$s * x1 + $c7f528eb3864381d$var$c * y1);
        context.lineTo($c7f528eb3864381d$var$c * x2 - $c7f528eb3864381d$var$s * y2, $c7f528eb3864381d$var$s * x2 + $c7f528eb3864381d$var$c * y2);
        context.lineTo($c7f528eb3864381d$var$c * x0 + $c7f528eb3864381d$var$s * y0, $c7f528eb3864381d$var$c * y0 - $c7f528eb3864381d$var$s * x0);
        context.lineTo($c7f528eb3864381d$var$c * x1 + $c7f528eb3864381d$var$s * y1, $c7f528eb3864381d$var$c * y1 - $c7f528eb3864381d$var$s * x1);
        context.lineTo($c7f528eb3864381d$var$c * x2 + $c7f528eb3864381d$var$s * y2, $c7f528eb3864381d$var$c * y2 - $c7f528eb3864381d$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $c7f528eb3864381d$var$_default;

});

parcelRequire.register("hxYSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $en7S8 = parcelRequire("en7S8");
var $cc64bcffb828296d$var$_default = {
    draw (context, size) {
        const r = (0, $en7S8.sqrt)(size - (0, $en7S8.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $cc64bcffb828296d$var$_default;

});


parcelRequire.register("a5Abc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75866f8da65e5f7d$var$_default;

var $75866f8da65e5f7d$var$_noop = $75866f8da65e5f7d$var$_interopRequireDefault((parcelRequire("gLSVl")));

var $84a7S = parcelRequire("84a7S");
function $75866f8da65e5f7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $75866f8da65e5f7d$var$BasisClosed(context) {
    this._context = context;
}
$75866f8da65e5f7d$var$BasisClosed.prototype = {
    areaStart: $75866f8da65e5f7d$var$_noop.default,
    areaEnd: $75866f8da65e5f7d$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $84a7S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $75866f8da65e5f7d$var$_default(context) {
    return new $75866f8da65e5f7d$var$BasisClosed(context);
}

});
parcelRequire.register("gLSVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c35ba3e4f2597763$var$_default;
function $c35ba3e4f2597763$var$_default() {}

});

parcelRequire.register("84a7S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $5df68d4686366d1a$var$Basis;
module.exports.default = $5df68d4686366d1a$var$_default;
module.exports.point = $5df68d4686366d1a$var$point;
function $5df68d4686366d1a$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $5df68d4686366d1a$var$Basis(context) {
    this._context = context;
}
$5df68d4686366d1a$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $5df68d4686366d1a$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $5df68d4686366d1a$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5df68d4686366d1a$var$_default(context) {
    return new $5df68d4686366d1a$var$Basis(context);
}

});


parcelRequire.register("5wR0v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40690f0ab2a8213b$var$_default;

var $84a7S = parcelRequire("84a7S");
function $40690f0ab2a8213b$var$BasisOpen(context) {
    this._context = context;
}
$40690f0ab2a8213b$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $84a7S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $40690f0ab2a8213b$var$_default(context) {
    return new $40690f0ab2a8213b$var$BasisOpen(context);
}

});

parcelRequire.register("3kI0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84a7S = parcelRequire("84a7S");
function $26d55f588b5ebca3$var$Bundle(context, beta) {
    this._basis = new $84a7S.Basis(context);
    this._beta = beta;
}
$26d55f588b5ebca3$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $26d55f588b5ebca3$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $84a7S.Basis(context) : new $26d55f588b5ebca3$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $26d55f588b5ebca3$var$_default;

});

parcelRequire.register("eL52l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $abe95cac252936dd$var$CardinalClosed;
module.exports.default = void 0;

var $abe95cac252936dd$var$_noop = $abe95cac252936dd$var$_interopRequireDefault((parcelRequire("gLSVl")));

var $1zXMY = parcelRequire("1zXMY");
function $abe95cac252936dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $abe95cac252936dd$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$abe95cac252936dd$var$CardinalClosed.prototype = {
    areaStart: $abe95cac252936dd$var$_noop.default,
    areaEnd: $abe95cac252936dd$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $1zXMY.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $abe95cac252936dd$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $abe95cac252936dd$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $abe95cac252936dd$var$_default;

});
parcelRequire.register("1zXMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $126770228d9f60b1$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $126770228d9f60b1$var$point;
function $126770228d9f60b1$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $126770228d9f60b1$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$126770228d9f60b1$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $126770228d9f60b1$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $126770228d9f60b1$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $126770228d9f60b1$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $126770228d9f60b1$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $126770228d9f60b1$var$_default;

});


parcelRequire.register("a6vIH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $75b311dab57f7cdb$var$CardinalOpen;
module.exports.default = void 0;

var $1zXMY = parcelRequire("1zXMY");
function $75b311dab57f7cdb$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$75b311dab57f7cdb$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $1zXMY.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $75b311dab57f7cdb$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $75b311dab57f7cdb$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $75b311dab57f7cdb$var$_default;

});

parcelRequire.register("goRNH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eL52l = parcelRequire("eL52l");

var $0314c8c1c5ad0047$var$_noop = $0314c8c1c5ad0047$var$_interopRequireDefault((parcelRequire("gLSVl")));

var $4L7EM = parcelRequire("4L7EM");
function $0314c8c1c5ad0047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0314c8c1c5ad0047$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$0314c8c1c5ad0047$var$CatmullRomClosed.prototype = {
    areaStart: $0314c8c1c5ad0047$var$_noop.default,
    areaEnd: $0314c8c1c5ad0047$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $4L7EM.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0314c8c1c5ad0047$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $0314c8c1c5ad0047$var$CatmullRomClosed(context, alpha) : new $eL52l.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $0314c8c1c5ad0047$var$_default;

});
parcelRequire.register("4L7EM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.point = $37717db04f50054f$var$point;

var $en7S8 = parcelRequire("en7S8");

var $1zXMY = parcelRequire("1zXMY");
function $37717db04f50054f$var$point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $en7S8.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $en7S8.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function $37717db04f50054f$var$CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$37717db04f50054f$var$CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $37717db04f50054f$var$point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $37717db04f50054f$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $37717db04f50054f$var$CatmullRom(context, alpha) : new $1zXMY.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $37717db04f50054f$var$_default;

});


parcelRequire.register("bmtEc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6vIH = parcelRequire("a6vIH");

var $4L7EM = parcelRequire("4L7EM");
function $8458bf2097a96945$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$8458bf2097a96945$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $4L7EM.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $8458bf2097a96945$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $8458bf2097a96945$var$CatmullRomOpen(context, alpha) : new $a6vIH.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $8458bf2097a96945$var$_default;

});

parcelRequire.register("8MiZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $664188b954dabf36$var$_default;

var $664188b954dabf36$var$_noop = $664188b954dabf36$var$_interopRequireDefault((parcelRequire("gLSVl")));
function $664188b954dabf36$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $664188b954dabf36$var$LinearClosed(context) {
    this._context = context;
}
$664188b954dabf36$var$LinearClosed.prototype = {
    areaStart: $664188b954dabf36$var$_noop.default,
    areaEnd: $664188b954dabf36$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $664188b954dabf36$var$_default(context) {
    return new $664188b954dabf36$var$LinearClosed(context);
}

});

parcelRequire.register("lftQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $f782269ccb1f9520$var$monotoneX;
module.exports.monotoneY = $f782269ccb1f9520$var$monotoneY;
function $f782269ccb1f9520$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $f782269ccb1f9520$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($f782269ccb1f9520$var$sign(s0) + $f782269ccb1f9520$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $f782269ccb1f9520$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $f782269ccb1f9520$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $f782269ccb1f9520$var$MonotoneX(context) {
    this._context = context;
}
$f782269ccb1f9520$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $f782269ccb1f9520$var$point(this, this._t0, $f782269ccb1f9520$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $f782269ccb1f9520$var$point(this, $f782269ccb1f9520$var$slope2(this, t1 = $f782269ccb1f9520$var$slope3(this, x, y)), t1);
                break;
            default:
                $f782269ccb1f9520$var$point(this, this._t0, t1 = $f782269ccb1f9520$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $f782269ccb1f9520$var$MonotoneY(context) {
    this._context = new $f782269ccb1f9520$var$ReflectContext(context);
}
($f782269ccb1f9520$var$MonotoneY.prototype = Object.create($f782269ccb1f9520$var$MonotoneX.prototype)).point = function(x, y) {
    $f782269ccb1f9520$var$MonotoneX.prototype.point.call(this, y, x);
};
function $f782269ccb1f9520$var$ReflectContext(context) {
    this._context = context;
}
$f782269ccb1f9520$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $f782269ccb1f9520$var$monotoneX(context) {
    return new $f782269ccb1f9520$var$MonotoneX(context);
}
function $f782269ccb1f9520$var$monotoneY(context) {
    return new $f782269ccb1f9520$var$MonotoneY(context);
}

});

parcelRequire.register("fQJxS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b89f0aafb540614c$var$_default;
function $b89f0aafb540614c$var$Natural(context) {
    this._context = context;
}
$b89f0aafb540614c$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $b89f0aafb540614c$var$controlPoints(x), py = $b89f0aafb540614c$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $b89f0aafb540614c$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $b89f0aafb540614c$var$_default(context) {
    return new $b89f0aafb540614c$var$Natural(context);
}

});

parcelRequire.register("2CwUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e88a85a145d4fb1$var$_default;
module.exports.stepAfter = $1e88a85a145d4fb1$var$stepAfter;
module.exports.stepBefore = $1e88a85a145d4fb1$var$stepBefore;
function $1e88a85a145d4fb1$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1e88a85a145d4fb1$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1e88a85a145d4fb1$var$_default(context) {
    return new $1e88a85a145d4fb1$var$Step(context, 0.5);
}
function $1e88a85a145d4fb1$var$stepBefore(context) {
    return new $1e88a85a145d4fb1$var$Step(context, 0);
}
function $1e88a85a145d4fb1$var$stepAfter(context) {
    return new $1e88a85a145d4fb1$var$Step(context, 1);
}

});

parcelRequire.register("83cea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5dc816ae45102195$var$_default;

var $5dc816ae45102195$var$_array = $5dc816ae45102195$var$_interopRequireDefault((parcelRequire("7uvMs")));

var $5dc816ae45102195$var$_constant = $5dc816ae45102195$var$_interopRequireDefault((parcelRequire("6QWWc")));

var $5dc816ae45102195$var$_none = $5dc816ae45102195$var$_interopRequireDefault((parcelRequire("skUZe")));

var $5dc816ae45102195$var$_none2 = $5dc816ae45102195$var$_interopRequireDefault((parcelRequire("4p89w")));
function $5dc816ae45102195$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dc816ae45102195$var$stackValue(d, key) {
    return d[key];
}
function $5dc816ae45102195$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $5dc816ae45102195$var$_default() {
    var keys = (0, $5dc816ae45102195$var$_constant.default)([]), order = $5dc816ae45102195$var$_none2.default, offset = $5dc816ae45102195$var$_none.default, value = $5dc816ae45102195$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $5dc816ae45102195$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $5dc816ae45102195$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $5dc816ae45102195$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5dc816ae45102195$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $5dc816ae45102195$var$_none2.default : typeof _ === "function" ? _ : (0, $5dc816ae45102195$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $5dc816ae45102195$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRequire.register("skUZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0552d78bd373a1f7$var$_default;
function $0552d78bd373a1f7$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRequire.register("4p89w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $334fd2292b495900$var$_default;
function $334fd2292b495900$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRequire.register("1T46e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15fe1b9101236eeb$var$_default;

var $15fe1b9101236eeb$var$_none = $15fe1b9101236eeb$var$_interopRequireDefault((parcelRequire("skUZe")));
function $15fe1b9101236eeb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15fe1b9101236eeb$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $15fe1b9101236eeb$var$_none.default)(series, order);
}

});

parcelRequire.register("44gAL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f6467fa3246d7b0$var$_default;
function $2f6467fa3246d7b0$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRequire.register("Fnzfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07c61c777e33cbc6$var$_default;

var $07c61c777e33cbc6$var$_none = $07c61c777e33cbc6$var$_interopRequireDefault((parcelRequire("skUZe")));
function $07c61c777e33cbc6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $07c61c777e33cbc6$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $07c61c777e33cbc6$var$_none.default)(series, order);
}

});

parcelRequire.register("2omGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bdf6ba03b4d451c$var$_default;

var $1bdf6ba03b4d451c$var$_none = $1bdf6ba03b4d451c$var$_interopRequireDefault((parcelRequire("skUZe")));
function $1bdf6ba03b4d451c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1bdf6ba03b4d451c$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $1bdf6ba03b4d451c$var$_none.default)(series, order);
}

});

parcelRequire.register("elZe8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a732853f43efb8ea$var$_default;

var $a732853f43efb8ea$var$_none = $a732853f43efb8ea$var$_interopRequireDefault((parcelRequire("4p89w")));
function $a732853f43efb8ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a732853f43efb8ea$var$_default(series) {
    var peaks = series.map($a732853f43efb8ea$var$peak);
    return (0, $a732853f43efb8ea$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $a732853f43efb8ea$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRequire.register("jEiiI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4dff2e8ea0656c4$var$_default;
module.exports.sum = $e4dff2e8ea0656c4$var$sum;

var $e4dff2e8ea0656c4$var$_none = $e4dff2e8ea0656c4$var$_interopRequireDefault((parcelRequire("4p89w")));
function $e4dff2e8ea0656c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e4dff2e8ea0656c4$var$_default(series) {
    var sums = series.map($e4dff2e8ea0656c4$var$sum);
    return (0, $e4dff2e8ea0656c4$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $e4dff2e8ea0656c4$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRequire.register("cZTZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97669e0a79fc979e$var$_default;

var $97669e0a79fc979e$var$_ascending = $97669e0a79fc979e$var$_interopRequireDefault((parcelRequire("jEiiI")));
function $97669e0a79fc979e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97669e0a79fc979e$var$_default(series) {
    return (0, $97669e0a79fc979e$var$_ascending.default)(series).reverse();
}

});

parcelRequire.register("6ocfg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a6e7b981eb47cb2$var$_default;

var $4a6e7b981eb47cb2$var$_appearance = $4a6e7b981eb47cb2$var$_interopRequireDefault((parcelRequire("elZe8")));

var $jEiiI = parcelRequire("jEiiI");
function $4a6e7b981eb47cb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a6e7b981eb47cb2$var$_default(series) {
    var n = series.length, i, j, sums = series.map($jEiiI.sum), order = (0, $4a6e7b981eb47cb2$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRequire.register("9Dw7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7040abb323add72b$var$_default;

var $7040abb323add72b$var$_none = $7040abb323add72b$var$_interopRequireDefault((parcelRequire("4p89w")));
function $7040abb323add72b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7040abb323add72b$var$_default(series) {
    return (0, $7040abb323add72b$var$_none.default)(series).reverse();
}

});



parcelRequire.register("5rB9n", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $3f6c4aa42cda2685$var$PropTypes = $3f6c4aa42cda2685$var$_interopRequireWildcard((parcelRequire("fmtXm")));

var $3f6c4aa42cda2685$var$_addClass = $3f6c4aa42cda2685$var$_interopRequireDefault((parcelRequire("dtJU5")));

var $3f6c4aa42cda2685$var$_removeClass = $3f6c4aa42cda2685$var$_interopRequireDefault((parcelRequire("eE4Ix")));

var $3f6c4aa42cda2685$var$_react = $3f6c4aa42cda2685$var$_interopRequireDefault((parcelRequire("6P6dz")));

var $3f6c4aa42cda2685$var$_Transition = $3f6c4aa42cda2685$var$_interopRequireDefault((parcelRequire("9eSsp")));

function $3f6c4aa42cda2685$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f6c4aa42cda2685$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $3f6c4aa42cda2685$var$_extends() {
    $3f6c4aa42cda2685$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f6c4aa42cda2685$var$_extends.apply(this, arguments);
}
function $3f6c4aa42cda2685$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3f6c4aa42cda2685$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $3f6c4aa42cda2685$var$_addClass.default)(node, c);
    });
};
var $3f6c4aa42cda2685$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $3f6c4aa42cda2685$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $3f6c4aa42cda2685$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $3f6c4aa42cda2685$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $3f6c4aa42cda2685$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $3f6c4aa42cda2685$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $3f6c4aa42cda2685$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $3f6c4aa42cda2685$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $3f6c4aa42cda2685$var$removeClass(node, className);
        activeClassName && $3f6c4aa42cda2685$var$removeClass(node, activeClassName);
        doneClassName && $3f6c4aa42cda2685$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $3f6c4aa42cda2685$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $3f6c4aa42cda2685$var$_extends({}, this.props);
        delete props.classNames;
        return $3f6c4aa42cda2685$var$_react.default.createElement($3f6c4aa42cda2685$var$_Transition.default, $3f6c4aa42cda2685$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($3f6c4aa42cda2685$var$_react.default.Component);
$3f6c4aa42cda2685$var$CSSTransition.defaultProps = {
    classNames: ""
};
$3f6c4aa42cda2685$var$CSSTransition.propTypes = {};
var $3f6c4aa42cda2685$var$_default = $3f6c4aa42cda2685$var$CSSTransition;
module.exports.default = $3f6c4aa42cda2685$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("dtJU5", function(module, exports) {
"use strict";

var $k5aDF = parcelRequire("k5aDF");
module.exports.__esModule = true;
module.exports.default = $9d0197498b96e746$var$addClass;

var $9d0197498b96e746$var$_hasClass = $k5aDF((parcelRequire("c4KI0")));
function $9d0197498b96e746$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9d0197498b96e746$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRequire.register("k5aDF", function(module, exports) {
function $e9ec86ecff728823$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $e9ec86ecff728823$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("c4KI0", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $8caa172971282228$var$hasClass;
function $8caa172971282228$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRequire.register("eE4Ix", function(module, exports) {
"use strict";
function $aa9875dda0360f27$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $aa9875dda0360f27$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $aa9875dda0360f27$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRequire.register("9eSsp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $6b9fa9f2b98a9505$export$1e511d4a378977f5; }, function (v) { return $6b9fa9f2b98a9505$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $6b9fa9f2b98a9505$export$2e2bcd8739ae039; }, function (v) { return $6b9fa9f2b98a9505$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $6b9fa9f2b98a9505$export$4aacc83d4d59139f; }, function (v) { return $6b9fa9f2b98a9505$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $6b9fa9f2b98a9505$export$78e9e6e3e014d60a; }, function (v) { return $6b9fa9f2b98a9505$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $6b9fa9f2b98a9505$export$df38205c966be359; }, function (v) { return $6b9fa9f2b98a9505$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $6b9fa9f2b98a9505$export$84cbff306f539230; }, function (v) { return $6b9fa9f2b98a9505$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $6b9fa9f2b98a9505$export$bb38bb9a1161268; }, function (v) { return $6b9fa9f2b98a9505$export$bb38bb9a1161268 = v; });
var $6b9fa9f2b98a9505$export$1e511d4a378977f5;
var $6b9fa9f2b98a9505$export$2e2bcd8739ae039;
var $6b9fa9f2b98a9505$export$4aacc83d4d59139f;
var $6b9fa9f2b98a9505$export$78e9e6e3e014d60a;
var $6b9fa9f2b98a9505$export$df38205c966be359;
var $6b9fa9f2b98a9505$export$84cbff306f539230;
var $6b9fa9f2b98a9505$export$bb38bb9a1161268;
"use strict";
$6b9fa9f2b98a9505$export$1e511d4a378977f5 = true;
$6b9fa9f2b98a9505$export$2e2bcd8739ae039 = $6b9fa9f2b98a9505$export$4aacc83d4d59139f = $6b9fa9f2b98a9505$export$78e9e6e3e014d60a = $6b9fa9f2b98a9505$export$df38205c966be359 = $6b9fa9f2b98a9505$export$84cbff306f539230 = $6b9fa9f2b98a9505$export$bb38bb9a1161268 = void 0;

var $6b9fa9f2b98a9505$var$PropTypes = $6b9fa9f2b98a9505$var$_interopRequireWildcard((parcelRequire("fmtXm")));

var $6b9fa9f2b98a9505$var$_react = $6b9fa9f2b98a9505$var$_interopRequireDefault((parcelRequire("6P6dz")));

var $6b9fa9f2b98a9505$var$_reactDom = $6b9fa9f2b98a9505$var$_interopRequireDefault((parcelRequire("e4MuM")));

var $dHUpZ = parcelRequire("dHUpZ");

function $6b9fa9f2b98a9505$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b9fa9f2b98a9505$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $6b9fa9f2b98a9505$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b9fa9f2b98a9505$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $6b9fa9f2b98a9505$var$UNMOUNTED = "unmounted";
$6b9fa9f2b98a9505$export$bb38bb9a1161268 = $6b9fa9f2b98a9505$var$UNMOUNTED;
var $6b9fa9f2b98a9505$var$EXITED = "exited";
$6b9fa9f2b98a9505$export$84cbff306f539230 = $6b9fa9f2b98a9505$var$EXITED;
var $6b9fa9f2b98a9505$var$ENTERING = "entering";
$6b9fa9f2b98a9505$export$df38205c966be359 = $6b9fa9f2b98a9505$var$ENTERING;
var $6b9fa9f2b98a9505$var$ENTERED = "entered";
$6b9fa9f2b98a9505$export$78e9e6e3e014d60a = $6b9fa9f2b98a9505$var$ENTERED;
var $6b9fa9f2b98a9505$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $6b9fa9f2b98a9505$export$4aacc83d4d59139f = $6b9fa9f2b98a9505$var$EXITING;
var $6b9fa9f2b98a9505$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $6b9fa9f2b98a9505$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $6b9fa9f2b98a9505$var$EXITED;
                _this.appearStatus = $6b9fa9f2b98a9505$var$ENTERING;
            } else initialStatus = $6b9fa9f2b98a9505$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $6b9fa9f2b98a9505$var$UNMOUNTED;
        else initialStatus = $6b9fa9f2b98a9505$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $6b9fa9f2b98a9505$var$UNMOUNTED) return {
            status: $6b9fa9f2b98a9505$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $6b9fa9f2b98a9505$var$ENTERING && status !== $6b9fa9f2b98a9505$var$ENTERED) nextStatus = $6b9fa9f2b98a9505$var$ENTERING;
            } else if (status === $6b9fa9f2b98a9505$var$ENTERING || status === $6b9fa9f2b98a9505$var$ENTERED) nextStatus = $6b9fa9f2b98a9505$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $6b9fa9f2b98a9505$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $6b9fa9f2b98a9505$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $6b9fa9f2b98a9505$var$EXITED) this.setState({
            status: $6b9fa9f2b98a9505$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $6b9fa9f2b98a9505$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $6b9fa9f2b98a9505$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $6b9fa9f2b98a9505$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $6b9fa9f2b98a9505$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $6b9fa9f2b98a9505$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $6b9fa9f2b98a9505$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $6b9fa9f2b98a9505$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $6b9fa9f2b98a9505$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $6b9fa9f2b98a9505$var$_react.default.Children.only(children);
        return $6b9fa9f2b98a9505$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($6b9fa9f2b98a9505$var$_react.default.Component);
$6b9fa9f2b98a9505$var$Transition.contextTypes = {
    transitionGroup: $6b9fa9f2b98a9505$var$PropTypes.object
};
$6b9fa9f2b98a9505$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$6b9fa9f2b98a9505$var$Transition.propTypes = {};
function $6b9fa9f2b98a9505$var$noop() {}
$6b9fa9f2b98a9505$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $6b9fa9f2b98a9505$var$noop,
    onEntering: $6b9fa9f2b98a9505$var$noop,
    onEntered: $6b9fa9f2b98a9505$var$noop,
    onExit: $6b9fa9f2b98a9505$var$noop,
    onExiting: $6b9fa9f2b98a9505$var$noop,
    onExited: $6b9fa9f2b98a9505$var$noop
};
$6b9fa9f2b98a9505$var$Transition.UNMOUNTED = 0;
$6b9fa9f2b98a9505$var$Transition.EXITED = 1;
$6b9fa9f2b98a9505$var$Transition.ENTERING = 2;
$6b9fa9f2b98a9505$var$Transition.ENTERED = 3;
$6b9fa9f2b98a9505$var$Transition.EXITING = 4;
var $6b9fa9f2b98a9505$var$_default = (0, $dHUpZ.polyfill)($6b9fa9f2b98a9505$var$Transition);
$6b9fa9f2b98a9505$export$2e2bcd8739ae039 = $6b9fa9f2b98a9505$var$_default;

});
parcelRequire.register("dHUpZ", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $9fab0e03170f66c7$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $9fab0e03170f66c7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $9fab0e03170f66c7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $9fab0e03170f66c7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$9fab0e03170f66c7$var$componentWillMount.__suppressDeprecationWarning = true;
$9fab0e03170f66c7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$9fab0e03170f66c7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $9fab0e03170f66c7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $9fab0e03170f66c7$var$componentWillMount;
        prototype.componentWillReceiveProps = $9fab0e03170f66c7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $9fab0e03170f66c7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRequire.register("9Uas9", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $736173ca3fb0e5ba$var$_propTypes = $736173ca3fb0e5ba$var$_interopRequireDefault((parcelRequire("fmtXm")));

var $736173ca3fb0e5ba$var$_react = $736173ca3fb0e5ba$var$_interopRequireDefault((parcelRequire("6P6dz")));

var $e4MuM = parcelRequire("e4MuM");

var $736173ca3fb0e5ba$var$_TransitionGroup = $736173ca3fb0e5ba$var$_interopRequireDefault((parcelRequire("3VdpA")));
function $736173ca3fb0e5ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $736173ca3fb0e5ba$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $736173ca3fb0e5ba$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $736173ca3fb0e5ba$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $736173ca3fb0e5ba$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $736173ca3fb0e5ba$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $e4MuM.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $736173ca3fb0e5ba$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $736173ca3fb0e5ba$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $736173ca3fb0e5ba$var$_react.default.createElement($736173ca3fb0e5ba$var$_TransitionGroup.default, props, inProp ? $736173ca3fb0e5ba$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $736173ca3fb0e5ba$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($736173ca3fb0e5ba$var$_react.default.Component);
$736173ca3fb0e5ba$var$ReplaceTransition.propTypes = {};
var $736173ca3fb0e5ba$var$_default = $736173ca3fb0e5ba$var$ReplaceTransition;
module.exports.default = $736173ca3fb0e5ba$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("3VdpA", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $2db1194100751ea8$var$_propTypes = $2db1194100751ea8$var$_interopRequireDefault((parcelRequire("fmtXm")));

var $2db1194100751ea8$var$_react = $2db1194100751ea8$var$_interopRequireDefault((parcelRequire("6P6dz")));

var $dHUpZ = parcelRequire("dHUpZ");

var $42Y1u = parcelRequire("42Y1u");
function $2db1194100751ea8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2db1194100751ea8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2db1194100751ea8$var$_extends() {
    $2db1194100751ea8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2db1194100751ea8$var$_extends.apply(this, arguments);
}
function $2db1194100751ea8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $2db1194100751ea8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $2db1194100751ea8$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $2db1194100751ea8$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $2db1194100751ea8$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $2db1194100751ea8$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($2db1194100751ea8$var$_assertThisInitialized($2db1194100751ea8$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $42Y1u.getInitialChildMapping)(nextProps, handleExited) : (0, $42Y1u.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $42Y1u.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $2db1194100751ea8$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $2db1194100751ea8$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $2db1194100751ea8$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $2db1194100751ea8$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($2db1194100751ea8$var$_react.default.Component);
$2db1194100751ea8$var$TransitionGroup.childContextTypes = {
    transitionGroup: $2db1194100751ea8$var$_propTypes.default.object.isRequired
};
$2db1194100751ea8$var$TransitionGroup.propTypes = {};
$2db1194100751ea8$var$TransitionGroup.defaultProps = $2db1194100751ea8$var$defaultProps;
var $2db1194100751ea8$var$_default = (0, $dHUpZ.polyfill)($2db1194100751ea8$var$TransitionGroup);
module.exports.default = $2db1194100751ea8$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("42Y1u", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $2f25e8a793d6747e$export$bbc8a025727ea824; }, function (v) { return $2f25e8a793d6747e$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $2f25e8a793d6747e$export$fa71e2345c31d7a2; }, function (v) { return $2f25e8a793d6747e$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $2f25e8a793d6747e$export$36fd1af28d383ec0; }, function (v) { return $2f25e8a793d6747e$export$36fd1af28d383ec0 = v; });
var $2f25e8a793d6747e$export$1e511d4a378977f5;
var $2f25e8a793d6747e$export$bbc8a025727ea824;
var $2f25e8a793d6747e$export$7a874f95ccf533dd;
var $2f25e8a793d6747e$export$fa71e2345c31d7a2;
var $2f25e8a793d6747e$export$36fd1af28d383ec0;
"use strict";
$2f25e8a793d6747e$export$1e511d4a378977f5 = true;
$2f25e8a793d6747e$export$bbc8a025727ea824 = $2f25e8a793d6747e$var$getChildMapping;
$2f25e8a793d6747e$export$7a874f95ccf533dd = $2f25e8a793d6747e$var$mergeChildMappings;
$2f25e8a793d6747e$export$fa71e2345c31d7a2 = $2f25e8a793d6747e$var$getInitialChildMapping;
$2f25e8a793d6747e$export$36fd1af28d383ec0 = $2f25e8a793d6747e$var$getNextChildMapping;

var $6P6dz = parcelRequire("6P6dz");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $2f25e8a793d6747e$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $6P6dz.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $6P6dz.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $2f25e8a793d6747e$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2f25e8a793d6747e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2f25e8a793d6747e$var$getInitialChildMapping(props, onExited) {
    return $2f25e8a793d6747e$var$getChildMapping(props.children, function(child) {
        return (0, $6P6dz.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2f25e8a793d6747e$var$getProp(child, "appear", props),
            enter: $2f25e8a793d6747e$var$getProp(child, "enter", props),
            exit: $2f25e8a793d6747e$var$getProp(child, "exit", props)
        });
    });
}
function $2f25e8a793d6747e$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2f25e8a793d6747e$var$getChildMapping(nextProps.children);
    var children = $2f25e8a793d6747e$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $6P6dz.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $6P6dz.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $6P6dz.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2f25e8a793d6747e$var$getProp(child, "exit", nextProps),
            enter: $2f25e8a793d6747e$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $6P6dz.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $6P6dz.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $6P6dz.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2f25e8a793d6747e$var$getProp(child, "exit", nextProps),
            enter: $2f25e8a793d6747e$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRequire.register("2FCkW", function(module, exports) {
var $1f1d26024e57f8ae$var$minus = "-".charCodeAt(0);
var $1f1d26024e57f8ae$var$plus = "+".charCodeAt(0);
var $1f1d26024e57f8ae$var$dot = ".".charCodeAt(0);
var $1f1d26024e57f8ae$var$exp = "e".charCodeAt(0);
var $1f1d26024e57f8ae$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $1f1d26024e57f8ae$var$exp || code === $1f1d26024e57f8ae$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $1f1d26024e57f8ae$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $1f1d26024e57f8ae$var$plus || code === $1f1d26024e57f8ae$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRequire.register("5JyUU", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("cFwm3"));

});
parcelRequire.register("cFwm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $939269527822357b$var$_tickFormat.default;
    }
});

var $939269527822357b$var$_band = $939269527822357b$var$_interopRequireWildcard((parcelRequire("ekYSn")));

var $939269527822357b$var$_identity = $939269527822357b$var$_interopRequireDefault((parcelRequire("49XKm")));

var $939269527822357b$var$_linear = $939269527822357b$var$_interopRequireDefault((parcelRequire("xqA60")));

var $939269527822357b$var$_log = $939269527822357b$var$_interopRequireDefault((parcelRequire("fCfGa")));

var $939269527822357b$var$_symlog = $939269527822357b$var$_interopRequireDefault((parcelRequire("l8UWd")));

var $939269527822357b$var$_ordinal = $939269527822357b$var$_interopRequireWildcard((parcelRequire("kOPgG")));

var $939269527822357b$var$_pow = $939269527822357b$var$_interopRequireWildcard((parcelRequire("6SM9G")));

var $939269527822357b$var$_radial = $939269527822357b$var$_interopRequireDefault((parcelRequire("71kO1")));

var $939269527822357b$var$_quantile = $939269527822357b$var$_interopRequireDefault((parcelRequire("gkQyY")));

var $939269527822357b$var$_quantize = $939269527822357b$var$_interopRequireDefault((parcelRequire("90cS7")));

var $939269527822357b$var$_threshold = $939269527822357b$var$_interopRequireDefault((parcelRequire("e7ZsJ")));

var $939269527822357b$var$_time = $939269527822357b$var$_interopRequireDefault((parcelRequire("gioGx")));

var $939269527822357b$var$_utcTime = $939269527822357b$var$_interopRequireDefault((parcelRequire("jPEQ8")));

var $939269527822357b$var$_sequential = $939269527822357b$var$_interopRequireWildcard((parcelRequire("iBTM9")));

var $939269527822357b$var$_sequentialQuantile = $939269527822357b$var$_interopRequireDefault((parcelRequire("2gaCe")));

var $939269527822357b$var$_diverging = $939269527822357b$var$_interopRequireWildcard((parcelRequire("25S8T")));

var $939269527822357b$var$_tickFormat = $939269527822357b$var$_interopRequireDefault((parcelRequire("aYr1Q")));
function $939269527822357b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $939269527822357b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($939269527822357b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $939269527822357b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $939269527822357b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("ekYSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a70227a3f74d1223$var$band;
module.exports.point = $a70227a3f74d1223$var$point;

var $cyl8F = parcelRequire("cyl8F");

var $55VNs = parcelRequire("55VNs");

var $a70227a3f74d1223$var$_ordinal = $a70227a3f74d1223$var$_interopRequireDefault((parcelRequire("kOPgG")));
function $a70227a3f74d1223$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a70227a3f74d1223$var$band() {
    var scale = (0, $a70227a3f74d1223$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $cyl8F.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $a70227a3f74d1223$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $55VNs.initRange.apply(rescale(), arguments);
}
function $a70227a3f74d1223$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $a70227a3f74d1223$var$pointish(copy());
    };
    return scale;
}
function $a70227a3f74d1223$var$point() {
    return $a70227a3f74d1223$var$pointish($a70227a3f74d1223$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRequire.register("cyl8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $eLjDG.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $aoh0y.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $aoh0y.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $eLjDG.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $eLjDG.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $92390ec0a52b3843$var$_zip.default;
    }
});

var $92390ec0a52b3843$var$_bisect = $92390ec0a52b3843$var$_interopRequireWildcard((parcelRequire("bkkUF")));

var $92390ec0a52b3843$var$_ascending = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $92390ec0a52b3843$var$_bisector = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("cygYN")));

var $92390ec0a52b3843$var$_count = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("9znWO")));

var $92390ec0a52b3843$var$_cross = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("bK0Ff")));

var $92390ec0a52b3843$var$_cumsum = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("2IJ41")));

var $92390ec0a52b3843$var$_descending = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("YRqdN")));

var $92390ec0a52b3843$var$_deviation = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("bQfOm")));

var $92390ec0a52b3843$var$_extent = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("1Hw2p")));

var $eLjDG = parcelRequire("eLjDG");

var $92390ec0a52b3843$var$_group = $92390ec0a52b3843$var$_interopRequireWildcard((parcelRequire("dGMyT")));

var $92390ec0a52b3843$var$_groupSort = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("ieINb")));

var $92390ec0a52b3843$var$_bin = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("gR5ZK")));

var $92390ec0a52b3843$var$_freedmanDiaconis = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("3GtBm")));

var $92390ec0a52b3843$var$_scott = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("7s2GF")));

var $92390ec0a52b3843$var$_sturges = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("Ajgh0")));

var $92390ec0a52b3843$var$_max = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("1h4Pn")));

var $92390ec0a52b3843$var$_maxIndex = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("aVps4")));

var $92390ec0a52b3843$var$_mean = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("1PKBy")));

var $92390ec0a52b3843$var$_median = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("1Ixdo")));

var $92390ec0a52b3843$var$_merge = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("7bvwk")));

var $92390ec0a52b3843$var$_min = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("9dwaR")));

var $92390ec0a52b3843$var$_minIndex = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("kOp7i")));

var $92390ec0a52b3843$var$_mode = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("bZrSN")));

var $92390ec0a52b3843$var$_nice = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("8sEoJ")));

var $92390ec0a52b3843$var$_pairs = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("8F5po")));

var $92390ec0a52b3843$var$_permute = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("ckRcP")));

var $92390ec0a52b3843$var$_quantile = $92390ec0a52b3843$var$_interopRequireWildcard((parcelRequire("f18Of")));

var $92390ec0a52b3843$var$_quickselect = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("4jH9N")));

var $92390ec0a52b3843$var$_range = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("4aFIZ")));

var $92390ec0a52b3843$var$_rank = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("7IIxw")));

var $92390ec0a52b3843$var$_least = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("ap4TB")));

var $92390ec0a52b3843$var$_leastIndex = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("3cXVp")));

var $92390ec0a52b3843$var$_greatest = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("a1dnF")));

var $92390ec0a52b3843$var$_greatestIndex = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("6eDsU")));

var $92390ec0a52b3843$var$_scan = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("k2yRI")));

var $92390ec0a52b3843$var$_shuffle = $92390ec0a52b3843$var$_interopRequireWildcard((parcelRequire("c9LRc")));

var $92390ec0a52b3843$var$_sum = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("hPM27")));

var $92390ec0a52b3843$var$_ticks = $92390ec0a52b3843$var$_interopRequireWildcard((parcelRequire("3tY6Y")));

var $92390ec0a52b3843$var$_transpose = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("3L5Sz")));

var $92390ec0a52b3843$var$_variance = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("dr45T")));

var $92390ec0a52b3843$var$_zip = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("7rGoC")));

var $92390ec0a52b3843$var$_every = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("k5lZo")));

var $92390ec0a52b3843$var$_some = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("kKTmO")));

var $92390ec0a52b3843$var$_filter = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("637H8")));

var $92390ec0a52b3843$var$_map = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("jumWf")));

var $92390ec0a52b3843$var$_reduce = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("De0eU")));

var $92390ec0a52b3843$var$_reverse = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("1suIn")));

var $92390ec0a52b3843$var$_sort = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("adjLE")));

var $92390ec0a52b3843$var$_difference = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("k3vOV")));

var $92390ec0a52b3843$var$_disjoint = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("fqFXM")));

var $92390ec0a52b3843$var$_intersection = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("hyIKK")));

var $92390ec0a52b3843$var$_subset = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("irupZ")));

var $92390ec0a52b3843$var$_superset = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("dNUtG")));

var $92390ec0a52b3843$var$_union = $92390ec0a52b3843$var$_interopRequireDefault((parcelRequire("hUqBY")));

var $aoh0y = parcelRequire("aoh0y");
function $92390ec0a52b3843$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $92390ec0a52b3843$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($92390ec0a52b3843$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $92390ec0a52b3843$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $92390ec0a52b3843$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("bkkUF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $83f1c8d6600fc326$var$_ascending = $83f1c8d6600fc326$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $83f1c8d6600fc326$var$_bisector = $83f1c8d6600fc326$var$_interopRequireDefault((parcelRequire("cygYN")));

var $83f1c8d6600fc326$var$_number = $83f1c8d6600fc326$var$_interopRequireDefault((parcelRequire("dLuOx")));
function $83f1c8d6600fc326$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $83f1c8d6600fc326$var$ascendingBisect = (0, $83f1c8d6600fc326$var$_bisector.default)($83f1c8d6600fc326$var$_ascending.default);
const $83f1c8d6600fc326$var$bisectRight = $83f1c8d6600fc326$var$ascendingBisect.right;
module.exports.bisectRight = $83f1c8d6600fc326$var$bisectRight;
const $83f1c8d6600fc326$var$bisectLeft = $83f1c8d6600fc326$var$ascendingBisect.left;
module.exports.bisectLeft = $83f1c8d6600fc326$var$bisectLeft;
const $83f1c8d6600fc326$var$bisectCenter = (0, $83f1c8d6600fc326$var$_bisector.default)($83f1c8d6600fc326$var$_number.default).center;
module.exports.bisectCenter = $83f1c8d6600fc326$var$bisectCenter;
var $83f1c8d6600fc326$var$_default = $83f1c8d6600fc326$var$bisectRight;
module.exports.default = $83f1c8d6600fc326$var$_default;

});
parcelRequire.register("3HQXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b2e78eaaa1502cd$var$ascending;
function $2b2e78eaaa1502cd$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRequire.register("cygYN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9235d4cbe4414811$var$bisector;

var $9235d4cbe4414811$var$_ascending = $9235d4cbe4414811$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $9235d4cbe4414811$var$_descending = $9235d4cbe4414811$var$_interopRequireDefault((parcelRequire("YRqdN")));
function $9235d4cbe4414811$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9235d4cbe4414811$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $9235d4cbe4414811$var$_ascending.default;
        compare2 = (d, x)=>(0, $9235d4cbe4414811$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $9235d4cbe4414811$var$_ascending.default || f === $9235d4cbe4414811$var$_descending.default ? f : $9235d4cbe4414811$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $9235d4cbe4414811$var$zero() {
    return 0;
}

});
parcelRequire.register("YRqdN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b6f0b317b9f62ce$var$descending;
function $0b6f0b317b9f62ce$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRequire.register("dLuOx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a057912ecc7c19d9$var$number;
module.exports.numbers = $a057912ecc7c19d9$var$numbers;
function $a057912ecc7c19d9$var$number(x) {
    return x === null ? NaN : +x;
}
function* $a057912ecc7c19d9$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRequire.register("9znWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f79f572e8ba9100$var$count;
function $6f79f572e8ba9100$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRequire.register("bK0Ff", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88c481802e6d7178$var$cross;
function $88c481802e6d7178$var$length(array) {
    return array.length | 0;
}
function $88c481802e6d7178$var$empty(length) {
    return !(length > 0);
}
function $88c481802e6d7178$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $88c481802e6d7178$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $88c481802e6d7178$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $88c481802e6d7178$var$reducer(values.pop());
    values = values.map($88c481802e6d7178$var$arrayify);
    const lengths = values.map($88c481802e6d7178$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($88c481802e6d7178$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRequire.register("2IJ41", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fb2a59784d5cc47$var$cumsum;
function $1fb2a59784d5cc47$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRequire.register("bQfOm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f0d0d70418341c$var$deviation;

var $89f0d0d70418341c$var$_variance = $89f0d0d70418341c$var$_interopRequireDefault((parcelRequire("dr45T")));
function $89f0d0d70418341c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89f0d0d70418341c$var$deviation(values, valueof) {
    const v = (0, $89f0d0d70418341c$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRequire.register("dr45T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c80f8fe0b2cb18a$var$variance;
function $9c80f8fe0b2cb18a$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRequire.register("1Hw2p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $13d2a8a7617cda0b$var$extent;
function $13d2a8a7617cda0b$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRequire.register("eLjDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $abf4b0649ec54839$var$fcumsum;
module.exports.fsum = $abf4b0649ec54839$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $abf4b0649ec54839$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $abf4b0649ec54839$var$Adder;
function $abf4b0649ec54839$var$fsum(values, valueof) {
    const adder = new $abf4b0649ec54839$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $abf4b0649ec54839$var$fcumsum(values, valueof) {
    const adder = new $abf4b0649ec54839$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRequire.register("dGMyT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f74ddfb9a78ac8a$var$group;
module.exports.flatGroup = $9f74ddfb9a78ac8a$var$flatGroup;
module.exports.flatRollup = $9f74ddfb9a78ac8a$var$flatRollup;
module.exports.groups = $9f74ddfb9a78ac8a$var$groups;
module.exports.index = $9f74ddfb9a78ac8a$var$index;
module.exports.indexes = $9f74ddfb9a78ac8a$var$indexes;
module.exports.rollup = $9f74ddfb9a78ac8a$var$rollup;
module.exports.rollups = $9f74ddfb9a78ac8a$var$rollups;

var $aoh0y = parcelRequire("aoh0y");

var $9f74ddfb9a78ac8a$var$_identity = $9f74ddfb9a78ac8a$var$_interopRequireDefault((parcelRequire("2PZ1l")));
function $9f74ddfb9a78ac8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f74ddfb9a78ac8a$var$group(values, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, $9f74ddfb9a78ac8a$var$_identity.default, $9f74ddfb9a78ac8a$var$_identity.default, keys);
}
function $9f74ddfb9a78ac8a$var$groups(values, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, Array.from, $9f74ddfb9a78ac8a$var$_identity.default, keys);
}
function $9f74ddfb9a78ac8a$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $9f74ddfb9a78ac8a$var$flatGroup(values, ...keys) {
    return $9f74ddfb9a78ac8a$var$flatten($9f74ddfb9a78ac8a$var$groups(values, ...keys), keys);
}
function $9f74ddfb9a78ac8a$var$flatRollup(values, reduce, ...keys) {
    return $9f74ddfb9a78ac8a$var$flatten($9f74ddfb9a78ac8a$var$rollups(values, reduce, ...keys), keys);
}
function $9f74ddfb9a78ac8a$var$rollup(values, reduce, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, $9f74ddfb9a78ac8a$var$_identity.default, reduce, keys);
}
function $9f74ddfb9a78ac8a$var$rollups(values, reduce, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, Array.from, reduce, keys);
}
function $9f74ddfb9a78ac8a$var$index(values, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, $9f74ddfb9a78ac8a$var$_identity.default, $9f74ddfb9a78ac8a$var$unique, keys);
}
function $9f74ddfb9a78ac8a$var$indexes(values, ...keys) {
    return $9f74ddfb9a78ac8a$var$nest(values, Array.from, $9f74ddfb9a78ac8a$var$unique, keys);
}
function $9f74ddfb9a78ac8a$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $9f74ddfb9a78ac8a$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $aoh0y.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRequire.register("aoh0y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $790956b2005457d6$var$InternMap extends Map {
    constructor(entries, key = $790956b2005457d6$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($790956b2005457d6$var$intern_get(this, key));
    }
    has(key) {
        return super.has($790956b2005457d6$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($790956b2005457d6$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($790956b2005457d6$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $790956b2005457d6$var$InternMap;
class $790956b2005457d6$var$InternSet extends Set {
    constructor(values, key = $790956b2005457d6$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($790956b2005457d6$var$intern_get(this, value));
    }
    add(value) {
        return super.add($790956b2005457d6$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($790956b2005457d6$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $790956b2005457d6$var$InternSet;
function $790956b2005457d6$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $790956b2005457d6$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $790956b2005457d6$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $790956b2005457d6$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRequire.register("2PZ1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $210fada233b60996$var$identity;
function $210fada233b60996$var$identity(x) {
    return x;
}

});


parcelRequire.register("ieINb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d46c47a267567354$var$groupSort;

var $d46c47a267567354$var$_ascending = $d46c47a267567354$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $d46c47a267567354$var$_group = $d46c47a267567354$var$_interopRequireWildcard((parcelRequire("dGMyT")));

var $d46c47a267567354$var$_sort = $d46c47a267567354$var$_interopRequireDefault((parcelRequire("adjLE")));
function $d46c47a267567354$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d46c47a267567354$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d46c47a267567354$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d46c47a267567354$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d46c47a267567354$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d46c47a267567354$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $d46c47a267567354$var$_sort.default)((0, $d46c47a267567354$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $d46c47a267567354$var$_ascending.default)(av, bv) || (0, $d46c47a267567354$var$_ascending.default)(ak, bk)) : (0, $d46c47a267567354$var$_sort.default)((0, $d46c47a267567354$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $d46c47a267567354$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRequire.register("adjLE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $76fa73b8d3c3c08c$var$ascendingDefined;
module.exports.compareDefined = $76fa73b8d3c3c08c$var$compareDefined;
module.exports.default = $76fa73b8d3c3c08c$var$sort;

var $76fa73b8d3c3c08c$var$_ascending = $76fa73b8d3c3c08c$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $76fa73b8d3c3c08c$var$_permute = $76fa73b8d3c3c08c$var$_interopRequireDefault((parcelRequire("ckRcP")));
function $76fa73b8d3c3c08c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76fa73b8d3c3c08c$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $76fa73b8d3c3c08c$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$76fa73b8d3c3c08c$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $76fa73b8d3c3c08c$var$_permute.default)(values, index);
    }
    return values.sort($76fa73b8d3c3c08c$var$compareDefined(f));
}
function $76fa73b8d3c3c08c$var$compareDefined(compare = $76fa73b8d3c3c08c$var$_ascending.default) {
    if (compare === $76fa73b8d3c3c08c$var$_ascending.default) return $76fa73b8d3c3c08c$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $76fa73b8d3c3c08c$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRequire.register("ckRcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fb09fdca58316f3$var$permute;
function $8fb09fdca58316f3$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRequire.register("gR5ZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4563f08069f5b55$var$bin;

var $j1v7k = parcelRequire("j1v7k");

var $c4563f08069f5b55$var$_bisect = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("bkkUF")));

var $c4563f08069f5b55$var$_constant = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("1BXkS")));

var $c4563f08069f5b55$var$_extent = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("1Hw2p")));

var $c4563f08069f5b55$var$_identity = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("2PZ1l")));

var $c4563f08069f5b55$var$_nice = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("8sEoJ")));

var $c4563f08069f5b55$var$_ticks = $c4563f08069f5b55$var$_interopRequireWildcard((parcelRequire("3tY6Y")));

var $c4563f08069f5b55$var$_sturges = $c4563f08069f5b55$var$_interopRequireDefault((parcelRequire("Ajgh0")));
function $c4563f08069f5b55$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c4563f08069f5b55$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c4563f08069f5b55$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c4563f08069f5b55$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c4563f08069f5b55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4563f08069f5b55$var$bin() {
    var value = $c4563f08069f5b55$var$_identity.default, domain = $c4563f08069f5b55$var$_extent.default, threshold = $c4563f08069f5b55$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $c4563f08069f5b55$var$_extent.default) [x0, x1] = (0, $c4563f08069f5b55$var$_nice.default)(x0, x1, tn);
            tz = (0, $c4563f08069f5b55$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $c4563f08069f5b55$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $c4563f08069f5b55$var$_extent.default) {
                    const step = (0, $c4563f08069f5b55$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $c4563f08069f5b55$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $c4563f08069f5b55$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $c4563f08069f5b55$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $c4563f08069f5b55$var$_constant.default)($j1v7k.slice.call(_)) : (0, $c4563f08069f5b55$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRequire.register("j1v7k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $dd963f8c0be8060e$var$array = Array.prototype;
var $dd963f8c0be8060e$var$slice = $dd963f8c0be8060e$var$array.slice;
module.exports.slice = $dd963f8c0be8060e$var$slice;
var $dd963f8c0be8060e$var$map = $dd963f8c0be8060e$var$array.map;
module.exports.map = $dd963f8c0be8060e$var$map;

});

parcelRequire.register("1BXkS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12c745f9e577662d$var$constant;
function $12c745f9e577662d$var$constant(x) {
    return ()=>x;
}

});

parcelRequire.register("8sEoJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6290467500462574$var$nice;

var $3tY6Y = parcelRequire("3tY6Y");
function $6290467500462574$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $3tY6Y.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRequire.register("3tY6Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2892b565341b3922$var$ticks;
module.exports.tickIncrement = $2892b565341b3922$var$tickIncrement;
module.exports.tickStep = $2892b565341b3922$var$tickStep;
var $2892b565341b3922$var$e10 = Math.sqrt(50), $2892b565341b3922$var$e5 = Math.sqrt(10), $2892b565341b3922$var$e2 = Math.sqrt(2);
function $2892b565341b3922$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $2892b565341b3922$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $2892b565341b3922$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $2892b565341b3922$var$e10 ? 10 : error >= $2892b565341b3922$var$e5 ? 5 : error >= $2892b565341b3922$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $2892b565341b3922$var$e10 ? 10 : error >= $2892b565341b3922$var$e5 ? 5 : error >= $2892b565341b3922$var$e2 ? 2 : 1);
}
function $2892b565341b3922$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $2892b565341b3922$var$e10) step1 *= 10;
    else if (error >= $2892b565341b3922$var$e5) step1 *= 5;
    else if (error >= $2892b565341b3922$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRequire.register("Ajgh0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06d24dd5c6e1dc2d$var$thresholdSturges;

var $06d24dd5c6e1dc2d$var$_count = $06d24dd5c6e1dc2d$var$_interopRequireDefault((parcelRequire("9znWO")));
function $06d24dd5c6e1dc2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06d24dd5c6e1dc2d$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $06d24dd5c6e1dc2d$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRequire.register("3GtBm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2aec419b2f1848ac$var$thresholdFreedmanDiaconis;

var $2aec419b2f1848ac$var$_count = $2aec419b2f1848ac$var$_interopRequireDefault((parcelRequire("9znWO")));

var $2aec419b2f1848ac$var$_quantile = $2aec419b2f1848ac$var$_interopRequireDefault((parcelRequire("f18Of")));
function $2aec419b2f1848ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2aec419b2f1848ac$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $2aec419b2f1848ac$var$_quantile.default)(values, 0.75) - (0, $2aec419b2f1848ac$var$_quantile.default)(values, 0.25)) * Math.pow((0, $2aec419b2f1848ac$var$_count.default)(values), -1 / 3)));
}

});
parcelRequire.register("f18Of", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aeedc86669d15209$var$quantile;
module.exports.quantileSorted = $aeedc86669d15209$var$quantileSorted;

var $aeedc86669d15209$var$_max = $aeedc86669d15209$var$_interopRequireDefault((parcelRequire("1h4Pn")));

var $aeedc86669d15209$var$_min = $aeedc86669d15209$var$_interopRequireDefault((parcelRequire("9dwaR")));

var $aeedc86669d15209$var$_quickselect = $aeedc86669d15209$var$_interopRequireDefault((parcelRequire("4jH9N")));

var $aeedc86669d15209$var$_number = $aeedc86669d15209$var$_interopRequireWildcard((parcelRequire("dLuOx")));
function $aeedc86669d15209$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aeedc86669d15209$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aeedc86669d15209$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aeedc86669d15209$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $aeedc86669d15209$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aeedc86669d15209$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $aeedc86669d15209$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $aeedc86669d15209$var$_min.default)(values);
    if (p >= 1) return (0, $aeedc86669d15209$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $aeedc86669d15209$var$_max.default)((0, $aeedc86669d15209$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $aeedc86669d15209$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $aeedc86669d15209$var$quantileSorted(values, p, valueof = $aeedc86669d15209$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRequire.register("1h4Pn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0edb1fa93758a444$var$max;
function $0edb1fa93758a444$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRequire.register("9dwaR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b5e490d43a8d534$var$min;
function $6b5e490d43a8d534$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRequire.register("4jH9N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $324a69dc26459772$var$quickselect;

var $adjLE = parcelRequire("adjLE");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $324a69dc26459772$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $adjLE.ascendingDefined : (0, $adjLE.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $324a69dc26459772$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $324a69dc26459772$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $324a69dc26459772$var$swap(array, left, right);
        while(i < j){
            $324a69dc26459772$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $324a69dc26459772$var$swap(array, left, j);
        else ++j, $324a69dc26459772$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $324a69dc26459772$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRequire.register("7s2GF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56cd3b9157d874df$var$thresholdScott;

var $56cd3b9157d874df$var$_count = $56cd3b9157d874df$var$_interopRequireDefault((parcelRequire("9znWO")));

var $56cd3b9157d874df$var$_deviation = $56cd3b9157d874df$var$_interopRequireDefault((parcelRequire("bQfOm")));
function $56cd3b9157d874df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56cd3b9157d874df$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $56cd3b9157d874df$var$_count.default)(values)) / (3.49 * (0, $56cd3b9157d874df$var$_deviation.default)(values)));
}

});

parcelRequire.register("aVps4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f42f8735d2e67fd$var$maxIndex;
function $7f42f8735d2e67fd$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRequire.register("1PKBy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $155eb49735d4da5e$var$mean;
function $155eb49735d4da5e$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRequire.register("1Ixdo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1403aa4bbee245df$var$median;

var $1403aa4bbee245df$var$_quantile = $1403aa4bbee245df$var$_interopRequireDefault((parcelRequire("f18Of")));
function $1403aa4bbee245df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1403aa4bbee245df$var$median(values, valueof) {
    return (0, $1403aa4bbee245df$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRequire.register("7bvwk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53b202ce1593a654$var$merge;
function* $53b202ce1593a654$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $53b202ce1593a654$var$merge(arrays) {
    return Array.from($53b202ce1593a654$var$flatten(arrays));
}

});

parcelRequire.register("kOp7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f26bf5c897c7f5f2$var$minIndex;
function $f26bf5c897c7f5f2$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRequire.register("bZrSN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bab052f6d544ee9$var$mode;

var $aoh0y = parcelRequire("aoh0y");
function $8bab052f6d544ee9$var$mode(values, valueof) {
    const counts = new $aoh0y.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRequire.register("8F5po", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64e6591de1301c7c$var$pairs;
module.exports.pair = $64e6591de1301c7c$var$pair;
function $64e6591de1301c7c$var$pairs(values, pairof = $64e6591de1301c7c$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $64e6591de1301c7c$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRequire.register("4aFIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30987641b1f51576$var$range;
function $30987641b1f51576$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRequire.register("7IIxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59ef3122fd1e27f3$var$rank;

var $59ef3122fd1e27f3$var$_ascending = $59ef3122fd1e27f3$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $adjLE = parcelRequire("adjLE");
function $59ef3122fd1e27f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59ef3122fd1e27f3$var$rank(values, valueof = $59ef3122fd1e27f3$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $59ef3122fd1e27f3$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $59ef3122fd1e27f3$var$_ascending.default ? (i, j)=>(0, $adjLE.ascendingDefined)(V[i], V[j]) : (0, $adjLE.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRequire.register("ap4TB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79300968dd9157c3$var$least;

var $79300968dd9157c3$var$_ascending = $79300968dd9157c3$var$_interopRequireDefault((parcelRequire("3HQXR")));
function $79300968dd9157c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79300968dd9157c3$var$least(values, compare = $79300968dd9157c3$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $79300968dd9157c3$var$_ascending.default)(value, minValue) < 0 : (0, $79300968dd9157c3$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRequire.register("3cXVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2560f9ef13410021$var$leastIndex;

var $2560f9ef13410021$var$_ascending = $2560f9ef13410021$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $2560f9ef13410021$var$_minIndex = $2560f9ef13410021$var$_interopRequireDefault((parcelRequire("kOp7i")));
function $2560f9ef13410021$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2560f9ef13410021$var$leastIndex(values, compare = $2560f9ef13410021$var$_ascending.default) {
    if (compare.length === 1) return (0, $2560f9ef13410021$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRequire.register("a1dnF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74b4607ce60e6f2f$var$greatest;

var $74b4607ce60e6f2f$var$_ascending = $74b4607ce60e6f2f$var$_interopRequireDefault((parcelRequire("3HQXR")));
function $74b4607ce60e6f2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $74b4607ce60e6f2f$var$greatest(values, compare = $74b4607ce60e6f2f$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $74b4607ce60e6f2f$var$_ascending.default)(value, maxValue) > 0 : (0, $74b4607ce60e6f2f$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRequire.register("6eDsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a2a9dda8860bbb$var$greatestIndex;

var $48a2a9dda8860bbb$var$_ascending = $48a2a9dda8860bbb$var$_interopRequireDefault((parcelRequire("3HQXR")));

var $48a2a9dda8860bbb$var$_maxIndex = $48a2a9dda8860bbb$var$_interopRequireDefault((parcelRequire("aVps4")));
function $48a2a9dda8860bbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $48a2a9dda8860bbb$var$greatestIndex(values, compare = $48a2a9dda8860bbb$var$_ascending.default) {
    if (compare.length === 1) return (0, $48a2a9dda8860bbb$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRequire.register("k2yRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e96f0a1c6daa4e78$var$scan;

var $e96f0a1c6daa4e78$var$_leastIndex = $e96f0a1c6daa4e78$var$_interopRequireDefault((parcelRequire("3cXVp")));
function $e96f0a1c6daa4e78$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e96f0a1c6daa4e78$var$scan(values, compare) {
    const index = (0, $e96f0a1c6daa4e78$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRequire.register("c9LRc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $8d9b72b4bf461f64$var$shuffler;
var $8d9b72b4bf461f64$var$_default = $8d9b72b4bf461f64$var$shuffler(Math.random);
module.exports.default = $8d9b72b4bf461f64$var$_default;
function $8d9b72b4bf461f64$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRequire.register("hPM27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfbc757c8675bf71$var$sum;
function $cfbc757c8675bf71$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRequire.register("3L5Sz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bca525b63a9a18b$var$transpose;

var $2bca525b63a9a18b$var$_min = $2bca525b63a9a18b$var$_interopRequireDefault((parcelRequire("9dwaR")));
function $2bca525b63a9a18b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2bca525b63a9a18b$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $2bca525b63a9a18b$var$_min.default)(matrix, $2bca525b63a9a18b$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $2bca525b63a9a18b$var$length(d) {
    return d.length;
}

});

parcelRequire.register("7rGoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56bbf1000034d7ef$var$zip;

var $56bbf1000034d7ef$var$_transpose = $56bbf1000034d7ef$var$_interopRequireDefault((parcelRequire("3L5Sz")));
function $56bbf1000034d7ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56bbf1000034d7ef$var$zip() {
    return (0, $56bbf1000034d7ef$var$_transpose.default)(arguments);
}

});

parcelRequire.register("k5lZo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9f554e0ce9095d8$var$every;
function $e9f554e0ce9095d8$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRequire.register("kKTmO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1c30d3ac2b775d1$var$some;
function $f1c30d3ac2b775d1$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRequire.register("637H8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4678fde51ff79d68$var$filter;
function $4678fde51ff79d68$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRequire.register("jumWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3029cc4f7837704$var$map;
function $e3029cc4f7837704$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRequire.register("De0eU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $075e814f5f7aa2e3$var$reduce;
function $075e814f5f7aa2e3$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRequire.register("1suIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11003b4e4ab1298a$var$reverse;
function $11003b4e4ab1298a$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRequire.register("k3vOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e99cc54ed462cd60$var$difference;

var $aoh0y = parcelRequire("aoh0y");
function $e99cc54ed462cd60$var$difference(values, ...others) {
    values = new $aoh0y.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRequire.register("fqFXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3b9d5c3e807eaea$var$disjoint;

var $aoh0y = parcelRequire("aoh0y");
function $b3b9d5c3e807eaea$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $aoh0y.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRequire.register("hyIKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc8853a3fd4ac3a0$var$intersection;

var $aoh0y = parcelRequire("aoh0y");
function $cc8853a3fd4ac3a0$var$intersection(values, ...others) {
    values = new $aoh0y.InternSet(values);
    others = others.map($cc8853a3fd4ac3a0$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $cc8853a3fd4ac3a0$var$set(values) {
    return values instanceof $aoh0y.InternSet ? values : new $aoh0y.InternSet(values);
}

});

parcelRequire.register("irupZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6d258027c9229bc$var$subset;

var $d6d258027c9229bc$var$_superset = $d6d258027c9229bc$var$_interopRequireDefault((parcelRequire("dNUtG")));
function $d6d258027c9229bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d6d258027c9229bc$var$subset(values, other) {
    return (0, $d6d258027c9229bc$var$_superset.default)(other, values);
}

});
parcelRequire.register("dNUtG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0cba949cd56201d$var$superset;
function $a0cba949cd56201d$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $a0cba949cd56201d$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $a0cba949cd56201d$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $a0cba949cd56201d$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRequire.register("hUqBY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d09c4f220ad87c7e$var$union;

var $aoh0y = parcelRequire("aoh0y");
function $d09c4f220ad87c7e$var$union(...others) {
    const set = new $aoh0y.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRequire.register("55VNs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $3b5a4098fd5f72ca$var$initInterpolator;
module.exports.initRange = $3b5a4098fd5f72ca$var$initRange;
function $3b5a4098fd5f72ca$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $3b5a4098fd5f72ca$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRequire.register("kOPgG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2803ef1bccac647$var$ordinal;
module.exports.implicit = void 0;

var $cyl8F = parcelRequire("cyl8F");

var $55VNs = parcelRequire("55VNs");
const $f2803ef1bccac647$var$implicit = Symbol("implicit");
module.exports.implicit = $f2803ef1bccac647$var$implicit;
function $f2803ef1bccac647$var$ordinal() {
    var index = new $cyl8F.InternMap(), domain = [], range = [], unknown = $f2803ef1bccac647$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $f2803ef1bccac647$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $cyl8F.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f2803ef1bccac647$var$ordinal(domain, range).unknown(unknown);
    };
    $55VNs.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRequire.register("49XKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3076592722e13def$var$identity;

var $xqA60 = parcelRequire("xqA60");

var $3076592722e13def$var$_number = $3076592722e13def$var$_interopRequireDefault((parcelRequire("28fNo")));
function $3076592722e13def$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3076592722e13def$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $3076592722e13def$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3076592722e13def$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $3076592722e13def$var$_number.default) : [
        0,
        1
    ];
    return (0, $xqA60.linearish)(scale);
}

});
parcelRequire.register("xqA60", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0647b3a7158ae6a9$var$linear;
module.exports.linearish = $0647b3a7158ae6a9$var$linearish;

var $cyl8F = parcelRequire("cyl8F");

var $0647b3a7158ae6a9$var$_continuous = $0647b3a7158ae6a9$var$_interopRequireWildcard((parcelRequire("lJpuv")));

var $55VNs = parcelRequire("55VNs");

var $0647b3a7158ae6a9$var$_tickFormat = $0647b3a7158ae6a9$var$_interopRequireDefault((parcelRequire("aYr1Q")));
function $0647b3a7158ae6a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0647b3a7158ae6a9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0647b3a7158ae6a9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0647b3a7158ae6a9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0647b3a7158ae6a9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0647b3a7158ae6a9$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $cyl8F.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $0647b3a7158ae6a9$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $cyl8F.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $0647b3a7158ae6a9$var$linear() {
    var scale = (0, $0647b3a7158ae6a9$var$_continuous.default)();
    scale.copy = function() {
        return (0, $0647b3a7158ae6a9$var$_continuous.copy)(scale, $0647b3a7158ae6a9$var$linear());
    };
    $55VNs.initRange.apply(scale, arguments);
    return $0647b3a7158ae6a9$var$linearish(scale);
}

});
parcelRequire.register("lJpuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $fd2192f08de676a2$var$copy;
module.exports.default = $fd2192f08de676a2$var$continuous;
module.exports.identity = $fd2192f08de676a2$var$identity;
module.exports.transformer = $fd2192f08de676a2$var$transformer;

var $cyl8F = parcelRequire("cyl8F");

var $kaKDa = parcelRequire("kaKDa");

var $fd2192f08de676a2$var$_constant = $fd2192f08de676a2$var$_interopRequireDefault((parcelRequire("fJVM5")));

var $fd2192f08de676a2$var$_number = $fd2192f08de676a2$var$_interopRequireDefault((parcelRequire("28fNo")));
function $fd2192f08de676a2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fd2192f08de676a2$var$unit = [
    0,
    1
];
function $fd2192f08de676a2$var$identity(x) {
    return x;
}
function $fd2192f08de676a2$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $fd2192f08de676a2$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $fd2192f08de676a2$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $fd2192f08de676a2$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $fd2192f08de676a2$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $fd2192f08de676a2$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $fd2192f08de676a2$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $fd2192f08de676a2$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $cyl8F.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $fd2192f08de676a2$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $fd2192f08de676a2$var$transformer() {
    var domain = $fd2192f08de676a2$var$unit, range = $fd2192f08de676a2$var$unit, interpolate = $kaKDa.interpolate, transform, untransform, unknown, clamp = $fd2192f08de676a2$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $fd2192f08de676a2$var$identity) clamp = $fd2192f08de676a2$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $fd2192f08de676a2$var$polymap : $fd2192f08de676a2$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $kaKDa.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $fd2192f08de676a2$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $kaKDa.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $fd2192f08de676a2$var$identity, rescale()) : clamp !== $fd2192f08de676a2$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $fd2192f08de676a2$var$continuous() {
    return $fd2192f08de676a2$var$transformer()($fd2192f08de676a2$var$identity, $fd2192f08de676a2$var$identity);
}

});
parcelRequire.register("kaKDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $4ZIvq.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $4ZIvq.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $eaf8e9afc0b2ee61$var$_quantize.default;
    }
});

var $eaf8e9afc0b2ee61$var$_value = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("3wF31")));

var $eaf8e9afc0b2ee61$var$_array = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("iDw4q")));

var $eaf8e9afc0b2ee61$var$_basis = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("8ltte")));

var $eaf8e9afc0b2ee61$var$_basisClosed = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("2R1Lg")));

var $eaf8e9afc0b2ee61$var$_date = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("ZaNLF")));

var $eaf8e9afc0b2ee61$var$_discrete = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("j8zPP")));

var $eaf8e9afc0b2ee61$var$_hue = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("1mlkr")));

var $eaf8e9afc0b2ee61$var$_number = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("bhQnT")));

var $eaf8e9afc0b2ee61$var$_numberArray = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("18jdf")));

var $eaf8e9afc0b2ee61$var$_object = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("7FX0k")));

var $eaf8e9afc0b2ee61$var$_round = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("i99nx")));

var $eaf8e9afc0b2ee61$var$_string = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("kic5g")));

var $4ZIvq = parcelRequire("4ZIvq");

var $eaf8e9afc0b2ee61$var$_zoom = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("6FZPs")));

var $eaf8e9afc0b2ee61$var$_rgb = $eaf8e9afc0b2ee61$var$_interopRequireWildcard((parcelRequire("3pltb")));

var $eaf8e9afc0b2ee61$var$_hsl = $eaf8e9afc0b2ee61$var$_interopRequireWildcard((parcelRequire("h92pt")));

var $eaf8e9afc0b2ee61$var$_lab = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("ki3I3")));

var $eaf8e9afc0b2ee61$var$_hcl = $eaf8e9afc0b2ee61$var$_interopRequireWildcard((parcelRequire("4ot0y")));

var $eaf8e9afc0b2ee61$var$_cubehelix = $eaf8e9afc0b2ee61$var$_interopRequireWildcard((parcelRequire("cAUZx")));

var $eaf8e9afc0b2ee61$var$_piecewise = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("5PAoB")));

var $eaf8e9afc0b2ee61$var$_quantize = $eaf8e9afc0b2ee61$var$_interopRequireDefault((parcelRequire("fAMoC")));
function $eaf8e9afc0b2ee61$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($eaf8e9afc0b2ee61$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $eaf8e9afc0b2ee61$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $eaf8e9afc0b2ee61$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $eaf8e9afc0b2ee61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("3wF31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2914337a0b1457d9$var$_default;

var $aZQp8 = parcelRequire("aZQp8");

var $2914337a0b1457d9$var$_rgb = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("3pltb")));

var $iDw4q = parcelRequire("iDw4q");

var $2914337a0b1457d9$var$_date = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("ZaNLF")));

var $2914337a0b1457d9$var$_number = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("bhQnT")));

var $2914337a0b1457d9$var$_object = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("7FX0k")));

var $2914337a0b1457d9$var$_string = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("kic5g")));

var $2914337a0b1457d9$var$_constant = $2914337a0b1457d9$var$_interopRequireDefault((parcelRequire("3Nxhi")));

var $2914337a0b1457d9$var$_numberArray = $2914337a0b1457d9$var$_interopRequireWildcard((parcelRequire("18jdf")));
function $2914337a0b1457d9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2914337a0b1457d9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2914337a0b1457d9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2914337a0b1457d9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2914337a0b1457d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2914337a0b1457d9$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $2914337a0b1457d9$var$_constant.default)(b) : (t === "number" ? $2914337a0b1457d9$var$_number.default : t === "string" ? (c = (0, $aZQp8.color)(b)) ? (b = c, $2914337a0b1457d9$var$_rgb.default) : $2914337a0b1457d9$var$_string.default : b instanceof $aZQp8.color ? $2914337a0b1457d9$var$_rgb.default : b instanceof Date ? $2914337a0b1457d9$var$_date.default : (0, $2914337a0b1457d9$var$_numberArray.isNumberArray)(b) ? $2914337a0b1457d9$var$_numberArray.default : Array.isArray(b) ? $iDw4q.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $2914337a0b1457d9$var$_object.default : $2914337a0b1457d9$var$_number.default)(a, b);
}

});
parcelRequire.register("aZQp8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $8018404c269bf44b$var$_color.rgb;
    }
});

var $8018404c269bf44b$var$_color = $8018404c269bf44b$var$_interopRequireWildcard((parcelRequire("2jdxL")));

var $8018404c269bf44b$var$_lab = $8018404c269bf44b$var$_interopRequireWildcard((parcelRequire("gi4dZ")));

var $8018404c269bf44b$var$_cubehelix = $8018404c269bf44b$var$_interopRequireDefault((parcelRequire("kDwoo")));
function $8018404c269bf44b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8018404c269bf44b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8018404c269bf44b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8018404c269bf44b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8018404c269bf44b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("2jdxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = $1ae7dc91aa3b62fc$var$Color;
module.exports.Rgb = $1ae7dc91aa3b62fc$var$Rgb;
module.exports.darker = module.exports.brighter = void 0;
module.exports.default = $1ae7dc91aa3b62fc$var$color;
module.exports.hsl = $1ae7dc91aa3b62fc$var$hsl;
module.exports.hslConvert = $1ae7dc91aa3b62fc$var$hslConvert;
module.exports.rgb = $1ae7dc91aa3b62fc$var$rgb;
module.exports.rgbConvert = $1ae7dc91aa3b62fc$var$rgbConvert;

var $1ae7dc91aa3b62fc$var$_define = $1ae7dc91aa3b62fc$var$_interopRequireWildcard((parcelRequire("i8zV6")));
function $1ae7dc91aa3b62fc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1ae7dc91aa3b62fc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1ae7dc91aa3b62fc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1ae7dc91aa3b62fc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1ae7dc91aa3b62fc$var$Color() {}
var $1ae7dc91aa3b62fc$var$darker = 0.7;
module.exports.darker = $1ae7dc91aa3b62fc$var$darker;
var $1ae7dc91aa3b62fc$var$brighter = 1 / $1ae7dc91aa3b62fc$var$darker;
module.exports.brighter = $1ae7dc91aa3b62fc$var$brighter;
var $1ae7dc91aa3b62fc$var$reI = "\\s*([+-]?\\d+)\\s*", $1ae7dc91aa3b62fc$var$reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $1ae7dc91aa3b62fc$var$reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $1ae7dc91aa3b62fc$var$reHex = /^#([0-9a-f]{3,8})$/, $1ae7dc91aa3b62fc$var$reRgbInteger = new RegExp(`^rgb\\(${$1ae7dc91aa3b62fc$var$reI},${$1ae7dc91aa3b62fc$var$reI},${$1ae7dc91aa3b62fc$var$reI}\\)$`), $1ae7dc91aa3b62fc$var$reRgbPercent = new RegExp(`^rgb\\(${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP}\\)$`), $1ae7dc91aa3b62fc$var$reRgbaInteger = new RegExp(`^rgba\\(${$1ae7dc91aa3b62fc$var$reI},${$1ae7dc91aa3b62fc$var$reI},${$1ae7dc91aa3b62fc$var$reI},${$1ae7dc91aa3b62fc$var$reN}\\)$`), $1ae7dc91aa3b62fc$var$reRgbaPercent = new RegExp(`^rgba\\(${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reN}\\)$`), $1ae7dc91aa3b62fc$var$reHslPercent = new RegExp(`^hsl\\(${$1ae7dc91aa3b62fc$var$reN},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP}\\)$`), $1ae7dc91aa3b62fc$var$reHslaPercent = new RegExp(`^hsla\\(${$1ae7dc91aa3b62fc$var$reN},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reP},${$1ae7dc91aa3b62fc$var$reN}\\)$`);
var $1ae7dc91aa3b62fc$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $1ae7dc91aa3b62fc$var$_define.default)($1ae7dc91aa3b62fc$var$Color, $1ae7dc91aa3b62fc$var$color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $1ae7dc91aa3b62fc$var$color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $1ae7dc91aa3b62fc$var$color_formatHex,
    formatHex8: $1ae7dc91aa3b62fc$var$color_formatHex8,
    formatHsl: $1ae7dc91aa3b62fc$var$color_formatHsl,
    formatRgb: $1ae7dc91aa3b62fc$var$color_formatRgb,
    toString: $1ae7dc91aa3b62fc$var$color_formatRgb
});
function $1ae7dc91aa3b62fc$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $1ae7dc91aa3b62fc$var$color_formatHex8() {
    return this.rgb().formatHex8();
}
function $1ae7dc91aa3b62fc$var$color_formatHsl() {
    return $1ae7dc91aa3b62fc$var$hslConvert(this).formatHsl();
}
function $1ae7dc91aa3b62fc$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $1ae7dc91aa3b62fc$var$color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $1ae7dc91aa3b62fc$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $1ae7dc91aa3b62fc$var$rgbn(m) // #ff0000
     : l === 3 ? new $1ae7dc91aa3b62fc$var$Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $1ae7dc91aa3b62fc$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $1ae7dc91aa3b62fc$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $1ae7dc91aa3b62fc$var$reRgbInteger.exec(format)) ? new $1ae7dc91aa3b62fc$var$Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $1ae7dc91aa3b62fc$var$reRgbPercent.exec(format)) ? new $1ae7dc91aa3b62fc$var$Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $1ae7dc91aa3b62fc$var$reRgbaInteger.exec(format)) ? $1ae7dc91aa3b62fc$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $1ae7dc91aa3b62fc$var$reRgbaPercent.exec(format)) ? $1ae7dc91aa3b62fc$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $1ae7dc91aa3b62fc$var$reHslPercent.exec(format)) ? $1ae7dc91aa3b62fc$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $1ae7dc91aa3b62fc$var$reHslaPercent.exec(format)) ? $1ae7dc91aa3b62fc$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $1ae7dc91aa3b62fc$var$named.hasOwnProperty(format) ? $1ae7dc91aa3b62fc$var$rgbn($1ae7dc91aa3b62fc$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $1ae7dc91aa3b62fc$var$Rgb(NaN, NaN, NaN, 0) : null;
}
function $1ae7dc91aa3b62fc$var$rgbn(n) {
    return new $1ae7dc91aa3b62fc$var$Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $1ae7dc91aa3b62fc$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $1ae7dc91aa3b62fc$var$Rgb(r, g, b, a);
}
function $1ae7dc91aa3b62fc$var$rgbConvert(o) {
    if (!(o instanceof $1ae7dc91aa3b62fc$var$Color)) o = $1ae7dc91aa3b62fc$var$color(o);
    if (!o) return new $1ae7dc91aa3b62fc$var$Rgb();
    o = o.rgb();
    return new $1ae7dc91aa3b62fc$var$Rgb(o.r, o.g, o.b, o.opacity);
}
function $1ae7dc91aa3b62fc$var$rgb(r, g, b, opacity) {
    return arguments.length === 1 ? $1ae7dc91aa3b62fc$var$rgbConvert(r) : new $1ae7dc91aa3b62fc$var$Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function $1ae7dc91aa3b62fc$var$Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $1ae7dc91aa3b62fc$var$_define.default)($1ae7dc91aa3b62fc$var$Rgb, $1ae7dc91aa3b62fc$var$rgb, (0, $1ae7dc91aa3b62fc$var$_define.extend)($1ae7dc91aa3b62fc$var$Color, {
    brighter (k) {
        k = k == null ? $1ae7dc91aa3b62fc$var$brighter : Math.pow($1ae7dc91aa3b62fc$var$brighter, k);
        return new $1ae7dc91aa3b62fc$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $1ae7dc91aa3b62fc$var$darker : Math.pow($1ae7dc91aa3b62fc$var$darker, k);
        return new $1ae7dc91aa3b62fc$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $1ae7dc91aa3b62fc$var$Rgb($1ae7dc91aa3b62fc$var$clampi(this.r), $1ae7dc91aa3b62fc$var$clampi(this.g), $1ae7dc91aa3b62fc$var$clampi(this.b), $1ae7dc91aa3b62fc$var$clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $1ae7dc91aa3b62fc$var$rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $1ae7dc91aa3b62fc$var$rgb_formatHex,
    formatHex8: $1ae7dc91aa3b62fc$var$rgb_formatHex8,
    formatRgb: $1ae7dc91aa3b62fc$var$rgb_formatRgb,
    toString: $1ae7dc91aa3b62fc$var$rgb_formatRgb
}));
function $1ae7dc91aa3b62fc$var$rgb_formatHex() {
    return `#${$1ae7dc91aa3b62fc$var$hex(this.r)}${$1ae7dc91aa3b62fc$var$hex(this.g)}${$1ae7dc91aa3b62fc$var$hex(this.b)}`;
}
function $1ae7dc91aa3b62fc$var$rgb_formatHex8() {
    return `#${$1ae7dc91aa3b62fc$var$hex(this.r)}${$1ae7dc91aa3b62fc$var$hex(this.g)}${$1ae7dc91aa3b62fc$var$hex(this.b)}${$1ae7dc91aa3b62fc$var$hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $1ae7dc91aa3b62fc$var$rgb_formatRgb() {
    const a = $1ae7dc91aa3b62fc$var$clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${$1ae7dc91aa3b62fc$var$clampi(this.r)}, ${$1ae7dc91aa3b62fc$var$clampi(this.g)}, ${$1ae7dc91aa3b62fc$var$clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function $1ae7dc91aa3b62fc$var$clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function $1ae7dc91aa3b62fc$var$clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function $1ae7dc91aa3b62fc$var$hex(value) {
    value = $1ae7dc91aa3b62fc$var$clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $1ae7dc91aa3b62fc$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $1ae7dc91aa3b62fc$var$Hsl(h, s, l, a);
}
function $1ae7dc91aa3b62fc$var$hslConvert(o) {
    if (o instanceof $1ae7dc91aa3b62fc$var$Hsl) return new $1ae7dc91aa3b62fc$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $1ae7dc91aa3b62fc$var$Color)) o = $1ae7dc91aa3b62fc$var$color(o);
    if (!o) return new $1ae7dc91aa3b62fc$var$Hsl();
    if (o instanceof $1ae7dc91aa3b62fc$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $1ae7dc91aa3b62fc$var$Hsl(h, s, l, o.opacity);
}
function $1ae7dc91aa3b62fc$var$hsl(h, s, l, opacity) {
    return arguments.length === 1 ? $1ae7dc91aa3b62fc$var$hslConvert(h) : new $1ae7dc91aa3b62fc$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $1ae7dc91aa3b62fc$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $1ae7dc91aa3b62fc$var$_define.default)($1ae7dc91aa3b62fc$var$Hsl, $1ae7dc91aa3b62fc$var$hsl, (0, $1ae7dc91aa3b62fc$var$_define.extend)($1ae7dc91aa3b62fc$var$Color, {
    brighter (k) {
        k = k == null ? $1ae7dc91aa3b62fc$var$brighter : Math.pow($1ae7dc91aa3b62fc$var$brighter, k);
        return new $1ae7dc91aa3b62fc$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $1ae7dc91aa3b62fc$var$darker : Math.pow($1ae7dc91aa3b62fc$var$darker, k);
        return new $1ae7dc91aa3b62fc$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $1ae7dc91aa3b62fc$var$Rgb($1ae7dc91aa3b62fc$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $1ae7dc91aa3b62fc$var$hsl2rgb(h, m1, m2), $1ae7dc91aa3b62fc$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new $1ae7dc91aa3b62fc$var$Hsl($1ae7dc91aa3b62fc$var$clamph(this.h), $1ae7dc91aa3b62fc$var$clampt(this.s), $1ae7dc91aa3b62fc$var$clampt(this.l), $1ae7dc91aa3b62fc$var$clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = $1ae7dc91aa3b62fc$var$clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${$1ae7dc91aa3b62fc$var$clamph(this.h)}, ${$1ae7dc91aa3b62fc$var$clampt(this.s) * 100}%, ${$1ae7dc91aa3b62fc$var$clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function $1ae7dc91aa3b62fc$var$clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function $1ae7dc91aa3b62fc$var$clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function $1ae7dc91aa3b62fc$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRequire.register("i8zV6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d344d64dedd4d47c$var$_default;
module.exports.extend = $d344d64dedd4d47c$var$extend;
function $d344d64dedd4d47c$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $d344d64dedd4d47c$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRequire.register("gi4dZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $bdc19ab0bf814811$var$Hcl;
module.exports.Lab = $bdc19ab0bf814811$var$Lab;
module.exports.default = $bdc19ab0bf814811$var$lab;
module.exports.gray = $bdc19ab0bf814811$var$gray;
module.exports.hcl = $bdc19ab0bf814811$var$hcl;
module.exports.lch = $bdc19ab0bf814811$var$lch;

var $bdc19ab0bf814811$var$_define = $bdc19ab0bf814811$var$_interopRequireWildcard((parcelRequire("i8zV6")));

var $2jdxL = parcelRequire("2jdxL");

var $gH9hs = parcelRequire("gH9hs");
function $bdc19ab0bf814811$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bdc19ab0bf814811$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bdc19ab0bf814811$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bdc19ab0bf814811$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $bdc19ab0bf814811$var$K = 18, $bdc19ab0bf814811$var$Xn = 0.96422, $bdc19ab0bf814811$var$Yn = 1, $bdc19ab0bf814811$var$Zn = 0.82521, $bdc19ab0bf814811$var$t0 = 4 / 29, $bdc19ab0bf814811$var$t1 = 6 / 29, $bdc19ab0bf814811$var$t2 = 3 * $bdc19ab0bf814811$var$t1 * $bdc19ab0bf814811$var$t1, $bdc19ab0bf814811$var$t3 = $bdc19ab0bf814811$var$t1 * $bdc19ab0bf814811$var$t1 * $bdc19ab0bf814811$var$t1;
function $bdc19ab0bf814811$var$labConvert(o) {
    if (o instanceof $bdc19ab0bf814811$var$Lab) return new $bdc19ab0bf814811$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $bdc19ab0bf814811$var$Hcl) return $bdc19ab0bf814811$var$hcl2lab(o);
    if (!(o instanceof $2jdxL.Rgb)) o = (0, $2jdxL.rgbConvert)(o);
    var r = $bdc19ab0bf814811$var$rgb2lrgb(o.r), g = $bdc19ab0bf814811$var$rgb2lrgb(o.g), b = $bdc19ab0bf814811$var$rgb2lrgb(o.b), y = $bdc19ab0bf814811$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $bdc19ab0bf814811$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $bdc19ab0bf814811$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $bdc19ab0bf814811$var$Xn);
        z = $bdc19ab0bf814811$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $bdc19ab0bf814811$var$Zn);
    }
    return new $bdc19ab0bf814811$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $bdc19ab0bf814811$var$gray(l, opacity) {
    return new $bdc19ab0bf814811$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $bdc19ab0bf814811$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $bdc19ab0bf814811$var$labConvert(l) : new $bdc19ab0bf814811$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $bdc19ab0bf814811$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bdc19ab0bf814811$var$_define.default)($bdc19ab0bf814811$var$Lab, $bdc19ab0bf814811$var$lab, (0, $bdc19ab0bf814811$var$_define.extend)($2jdxL.Color, {
    brighter (k) {
        return new $bdc19ab0bf814811$var$Lab(this.l + $bdc19ab0bf814811$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $bdc19ab0bf814811$var$Lab(this.l - $bdc19ab0bf814811$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $bdc19ab0bf814811$var$Xn * $bdc19ab0bf814811$var$lab2xyz(x);
        y = $bdc19ab0bf814811$var$Yn * $bdc19ab0bf814811$var$lab2xyz(y);
        z = $bdc19ab0bf814811$var$Zn * $bdc19ab0bf814811$var$lab2xyz(z);
        return new $2jdxL.Rgb($bdc19ab0bf814811$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $bdc19ab0bf814811$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $bdc19ab0bf814811$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $bdc19ab0bf814811$var$xyz2lab(t) {
    return t > $bdc19ab0bf814811$var$t3 ? Math.pow(t, 1 / 3) : t / $bdc19ab0bf814811$var$t2 + $bdc19ab0bf814811$var$t0;
}
function $bdc19ab0bf814811$var$lab2xyz(t) {
    return t > $bdc19ab0bf814811$var$t1 ? t * t * t : $bdc19ab0bf814811$var$t2 * (t - $bdc19ab0bf814811$var$t0);
}
function $bdc19ab0bf814811$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $bdc19ab0bf814811$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $bdc19ab0bf814811$var$hclConvert(o) {
    if (o instanceof $bdc19ab0bf814811$var$Hcl) return new $bdc19ab0bf814811$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $bdc19ab0bf814811$var$Lab)) o = $bdc19ab0bf814811$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $bdc19ab0bf814811$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $gH9hs.degrees;
    return new $bdc19ab0bf814811$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $bdc19ab0bf814811$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $bdc19ab0bf814811$var$hclConvert(l) : new $bdc19ab0bf814811$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $bdc19ab0bf814811$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $bdc19ab0bf814811$var$hclConvert(h) : new $bdc19ab0bf814811$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $bdc19ab0bf814811$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $bdc19ab0bf814811$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $bdc19ab0bf814811$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $gH9hs.radians;
    return new $bdc19ab0bf814811$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bdc19ab0bf814811$var$_define.default)($bdc19ab0bf814811$var$Hcl, $bdc19ab0bf814811$var$hcl, (0, $bdc19ab0bf814811$var$_define.extend)($2jdxL.Color, {
    brighter (k) {
        return new $bdc19ab0bf814811$var$Hcl(this.h, this.c, this.l + $bdc19ab0bf814811$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $bdc19ab0bf814811$var$Hcl(this.h, this.c, this.l - $bdc19ab0bf814811$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $bdc19ab0bf814811$var$hcl2lab(this).rgb();
    }
}));

});
parcelRequire.register("gH9hs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $c277dc6ab42175e9$var$radians = Math.PI / 180;
module.exports.radians = $c277dc6ab42175e9$var$radians;
const $c277dc6ab42175e9$var$degrees = 180 / Math.PI;
module.exports.degrees = $c277dc6ab42175e9$var$degrees;

});


parcelRequire.register("kDwoo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $f06093a04e13ae3d$var$Cubehelix;
module.exports.default = $f06093a04e13ae3d$var$cubehelix;

var $f06093a04e13ae3d$var$_define = $f06093a04e13ae3d$var$_interopRequireWildcard((parcelRequire("i8zV6")));

var $2jdxL = parcelRequire("2jdxL");

var $gH9hs = parcelRequire("gH9hs");
function $f06093a04e13ae3d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f06093a04e13ae3d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f06093a04e13ae3d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f06093a04e13ae3d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $f06093a04e13ae3d$var$A = -0.14861, $f06093a04e13ae3d$var$B = 1.78277, $f06093a04e13ae3d$var$C = -0.29227, $f06093a04e13ae3d$var$D = -0.90649, $f06093a04e13ae3d$var$E = 1.97294, $f06093a04e13ae3d$var$ED = $f06093a04e13ae3d$var$E * $f06093a04e13ae3d$var$D, $f06093a04e13ae3d$var$EB = $f06093a04e13ae3d$var$E * $f06093a04e13ae3d$var$B, $f06093a04e13ae3d$var$BC_DA = $f06093a04e13ae3d$var$B * $f06093a04e13ae3d$var$C - $f06093a04e13ae3d$var$D * $f06093a04e13ae3d$var$A;
function $f06093a04e13ae3d$var$cubehelixConvert(o) {
    if (o instanceof $f06093a04e13ae3d$var$Cubehelix) return new $f06093a04e13ae3d$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $2jdxL.Rgb)) o = (0, $2jdxL.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($f06093a04e13ae3d$var$BC_DA * b + $f06093a04e13ae3d$var$ED * r - $f06093a04e13ae3d$var$EB * g) / ($f06093a04e13ae3d$var$BC_DA + $f06093a04e13ae3d$var$ED - $f06093a04e13ae3d$var$EB), bl = b - l, k = ($f06093a04e13ae3d$var$E * (g - l) - $f06093a04e13ae3d$var$C * bl) / $f06093a04e13ae3d$var$D, s = Math.sqrt(k * k + bl * bl) / ($f06093a04e13ae3d$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $gH9hs.degrees - 120 : NaN;
    return new $f06093a04e13ae3d$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $f06093a04e13ae3d$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $f06093a04e13ae3d$var$cubehelixConvert(h) : new $f06093a04e13ae3d$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $f06093a04e13ae3d$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $f06093a04e13ae3d$var$_define.default)($f06093a04e13ae3d$var$Cubehelix, $f06093a04e13ae3d$var$cubehelix, (0, $f06093a04e13ae3d$var$_define.extend)($2jdxL.Color, {
    brighter (k) {
        k = k == null ? $2jdxL.brighter : Math.pow($2jdxL.brighter, k);
        return new $f06093a04e13ae3d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $2jdxL.darker : Math.pow($2jdxL.darker, k);
        return new $f06093a04e13ae3d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $gH9hs.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $2jdxL.Rgb(255 * (l + a * ($f06093a04e13ae3d$var$A * cosh + $f06093a04e13ae3d$var$B * sinh)), 255 * (l + a * ($f06093a04e13ae3d$var$C * cosh + $f06093a04e13ae3d$var$D * sinh)), 255 * (l + a * ($f06093a04e13ae3d$var$E * cosh)), this.opacity);
    }
}));

});


parcelRequire.register("3pltb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $aZQp8 = parcelRequire("aZQp8");

var $27b45c53992aad2d$var$_basis = $27b45c53992aad2d$var$_interopRequireDefault((parcelRequire("8ltte")));

var $27b45c53992aad2d$var$_basisClosed = $27b45c53992aad2d$var$_interopRequireDefault((parcelRequire("2R1Lg")));

var $27b45c53992aad2d$var$_color = $27b45c53992aad2d$var$_interopRequireWildcard((parcelRequire("k0Dyl")));
function $27b45c53992aad2d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($27b45c53992aad2d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $27b45c53992aad2d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $27b45c53992aad2d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $27b45c53992aad2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $27b45c53992aad2d$var$_default = function rgbGamma(y) {
    var color = (0, $27b45c53992aad2d$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $aZQp8.rgb)(start)).r, (end = (0, $aZQp8.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $27b45c53992aad2d$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $27b45c53992aad2d$var$_default;
function $27b45c53992aad2d$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $aZQp8.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $27b45c53992aad2d$var$rgbBasis = $27b45c53992aad2d$var$rgbSpline($27b45c53992aad2d$var$_basis.default);
module.exports.rgbBasis = $27b45c53992aad2d$var$rgbBasis;
var $27b45c53992aad2d$var$rgbBasisClosed = $27b45c53992aad2d$var$rgbSpline($27b45c53992aad2d$var$_basisClosed.default);
module.exports.rgbBasisClosed = $27b45c53992aad2d$var$rgbBasisClosed;

});
parcelRequire.register("8ltte", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $6137251eafc4cd69$var$basis;
module.exports.default = $6137251eafc4cd69$var$_default;
function $6137251eafc4cd69$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $6137251eafc4cd69$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $6137251eafc4cd69$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("2R1Lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2141e5c614a0af4a$var$_default;

var $8ltte = parcelRequire("8ltte");
function $2141e5c614a0af4a$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $8ltte.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("k0Dyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9127d1e289cc735$var$nogamma;
module.exports.gamma = $e9127d1e289cc735$var$gamma;
module.exports.hue = $e9127d1e289cc735$var$hue;

var $e9127d1e289cc735$var$_constant = $e9127d1e289cc735$var$_interopRequireDefault((parcelRequire("3Nxhi")));
function $e9127d1e289cc735$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9127d1e289cc735$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $e9127d1e289cc735$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $e9127d1e289cc735$var$hue(a, b) {
    var d = b - a;
    return d ? $e9127d1e289cc735$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $e9127d1e289cc735$var$_constant.default)(isNaN(a) ? b : a);
}
function $e9127d1e289cc735$var$gamma(y) {
    return (y = +y) === 1 ? $e9127d1e289cc735$var$nogamma : function(a, b) {
        return b - a ? $e9127d1e289cc735$var$exponential(a, b, y) : (0, $e9127d1e289cc735$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $e9127d1e289cc735$var$nogamma(a, b) {
    var d = b - a;
    return d ? $e9127d1e289cc735$var$linear(a, d) : (0, $e9127d1e289cc735$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRequire.register("3Nxhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2c3fc304d05f5df9$var$_default = (x)=>()=>x;
module.exports.default = $2c3fc304d05f5df9$var$_default;

});



parcelRequire.register("iDw4q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d914beff610d33c7$var$_default;
module.exports.genericArray = $d914beff610d33c7$var$genericArray;

var $d914beff610d33c7$var$_value = $d914beff610d33c7$var$_interopRequireDefault((parcelRequire("3wF31")));

var $d914beff610d33c7$var$_numberArray = $d914beff610d33c7$var$_interopRequireWildcard((parcelRequire("18jdf")));
function $d914beff610d33c7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d914beff610d33c7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d914beff610d33c7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d914beff610d33c7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d914beff610d33c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d914beff610d33c7$var$_default(a, b) {
    return ((0, $d914beff610d33c7$var$_numberArray.isNumberArray)(b) ? $d914beff610d33c7$var$_numberArray.default : $d914beff610d33c7$var$genericArray)(a, b);
}
function $d914beff610d33c7$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $d914beff610d33c7$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRequire.register("18jdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d35710d6c0d4f21$var$_default;
module.exports.isNumberArray = $0d35710d6c0d4f21$var$isNumberArray;
function $0d35710d6c0d4f21$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $0d35710d6c0d4f21$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRequire.register("ZaNLF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b7e139d308b9ac3$var$_default;
function $0b7e139d308b9ac3$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRequire.register("bhQnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8379eaafc89421ae$var$_default;
function $8379eaafc89421ae$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRequire.register("7FX0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $596a21c61cff6495$var$_default;

var $596a21c61cff6495$var$_value = $596a21c61cff6495$var$_interopRequireDefault((parcelRequire("3wF31")));
function $596a21c61cff6495$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $596a21c61cff6495$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $596a21c61cff6495$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRequire.register("kic5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec5edcae4bf3201f$var$_default;

var $ec5edcae4bf3201f$var$_number = $ec5edcae4bf3201f$var$_interopRequireDefault((parcelRequire("bhQnT")));
function $ec5edcae4bf3201f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ec5edcae4bf3201f$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ec5edcae4bf3201f$var$reB = new RegExp($ec5edcae4bf3201f$var$reA.source, "g");
function $ec5edcae4bf3201f$var$zero(b) {
    return function() {
        return b;
    };
}
function $ec5edcae4bf3201f$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ec5edcae4bf3201f$var$_default(a, b) {
    var bi = $ec5edcae4bf3201f$var$reA.lastIndex = $ec5edcae4bf3201f$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $ec5edcae4bf3201f$var$reA.exec(a)) && (bm = $ec5edcae4bf3201f$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ec5edcae4bf3201f$var$_number.default)(am, bm)
            });
        }
        bi = $ec5edcae4bf3201f$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ec5edcae4bf3201f$var$one(q[0].x) : $ec5edcae4bf3201f$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRequire.register("j8zPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $deea8fc54675bdc7$var$_default;
function $deea8fc54675bdc7$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRequire.register("1mlkr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0fd863f4cc59eb67$var$_default;

var $k0Dyl = parcelRequire("k0Dyl");
function $0fd863f4cc59eb67$var$_default(a, b) {
    var i = (0, $k0Dyl.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRequire.register("i99nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d36057a4372030c9$var$_default;
function $d36057a4372030c9$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRequire.register("4ZIvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $3a2f61e19fc59080$var$_number = $3a2f61e19fc59080$var$_interopRequireDefault((parcelRequire("bhQnT")));

var $cfrGc = parcelRequire("cfrGc");
function $3a2f61e19fc59080$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3a2f61e19fc59080$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $3a2f61e19fc59080$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $3a2f61e19fc59080$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $3a2f61e19fc59080$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $3a2f61e19fc59080$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $3a2f61e19fc59080$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $3a2f61e19fc59080$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $3a2f61e19fc59080$var$interpolateTransformCss = $3a2f61e19fc59080$var$interpolateTransform($cfrGc.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $3a2f61e19fc59080$var$interpolateTransformCss;
var $3a2f61e19fc59080$var$interpolateTransformSvg = $3a2f61e19fc59080$var$interpolateTransform($cfrGc.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $3a2f61e19fc59080$var$interpolateTransformSvg;

});
parcelRequire.register("cfrGc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $8eac5b59db5a8ff7$var$parseCss;
module.exports.parseSvg = $8eac5b59db5a8ff7$var$parseSvg;

var $8eac5b59db5a8ff7$var$_decompose = $8eac5b59db5a8ff7$var$_interopRequireWildcard((parcelRequire("hCWef")));
function $8eac5b59db5a8ff7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8eac5b59db5a8ff7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8eac5b59db5a8ff7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8eac5b59db5a8ff7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $8eac5b59db5a8ff7$var$svgNode;
/* eslint-disable no-undef */ function $8eac5b59db5a8ff7$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $8eac5b59db5a8ff7$var$_decompose.identity : (0, $8eac5b59db5a8ff7$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $8eac5b59db5a8ff7$var$parseSvg(value) {
    if (value == null) return $8eac5b59db5a8ff7$var$_decompose.identity;
    if (!$8eac5b59db5a8ff7$var$svgNode) $8eac5b59db5a8ff7$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $8eac5b59db5a8ff7$var$svgNode.setAttribute("transform", value);
    if (!(value = $8eac5b59db5a8ff7$var$svgNode.transform.baseVal.consolidate())) return $8eac5b59db5a8ff7$var$_decompose.identity;
    value = value.matrix;
    return (0, $8eac5b59db5a8ff7$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRequire.register("hCWef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd53274cda14023e$var$_default;
module.exports.identity = void 0;
var $cd53274cda14023e$var$degrees = 180 / Math.PI;
var $cd53274cda14023e$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $cd53274cda14023e$var$identity;
function $cd53274cda14023e$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $cd53274cda14023e$var$degrees,
        skewX: Math.atan(skewX) * $cd53274cda14023e$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRequire.register("6FZPs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4dc6885fd299c87d$var$epsilon2 = 1e-12;
function $4dc6885fd299c87d$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $4dc6885fd299c87d$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $4dc6885fd299c87d$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $4dc6885fd299c87d$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $4dc6885fd299c87d$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $4dc6885fd299c87d$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $4dc6885fd299c87d$var$tanh(rho * s + r0) - $4dc6885fd299c87d$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $4dc6885fd299c87d$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $4dc6885fd299c87d$var$_default;

});

parcelRequire.register("h92pt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $aZQp8 = parcelRequire("aZQp8");

var $c7b52577f5a62854$var$_color = $c7b52577f5a62854$var$_interopRequireWildcard((parcelRequire("k0Dyl")));
function $c7b52577f5a62854$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c7b52577f5a62854$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c7b52577f5a62854$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c7b52577f5a62854$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c7b52577f5a62854$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $aZQp8.hsl)(start)).h, (end = (0, $aZQp8.hsl)(end)).h), s = (0, $c7b52577f5a62854$var$_color.default)(start.s, end.s), l = (0, $c7b52577f5a62854$var$_color.default)(start.l, end.l), opacity = (0, $c7b52577f5a62854$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $c7b52577f5a62854$var$_default = $c7b52577f5a62854$var$hsl($c7b52577f5a62854$var$_color.hue);
module.exports.default = $c7b52577f5a62854$var$_default;
var $c7b52577f5a62854$var$hslLong = $c7b52577f5a62854$var$hsl($c7b52577f5a62854$var$_color.default);
module.exports.hslLong = $c7b52577f5a62854$var$hslLong;

});

parcelRequire.register("ki3I3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec585db44ce6fac9$var$lab;

var $aZQp8 = parcelRequire("aZQp8");

var $ec585db44ce6fac9$var$_color = $ec585db44ce6fac9$var$_interopRequireDefault((parcelRequire("k0Dyl")));
function $ec585db44ce6fac9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ec585db44ce6fac9$var$lab(start, end) {
    var l = (0, $ec585db44ce6fac9$var$_color.default)((start = (0, $aZQp8.lab)(start)).l, (end = (0, $aZQp8.lab)(end)).l), a = (0, $ec585db44ce6fac9$var$_color.default)(start.a, end.a), b = (0, $ec585db44ce6fac9$var$_color.default)(start.b, end.b), opacity = (0, $ec585db44ce6fac9$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRequire.register("4ot0y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $aZQp8 = parcelRequire("aZQp8");

var $332fe7b04fb5111f$var$_color = $332fe7b04fb5111f$var$_interopRequireWildcard((parcelRequire("k0Dyl")));
function $332fe7b04fb5111f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($332fe7b04fb5111f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $332fe7b04fb5111f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $332fe7b04fb5111f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $332fe7b04fb5111f$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $aZQp8.hcl)(start)).h, (end = (0, $aZQp8.hcl)(end)).h), c = (0, $332fe7b04fb5111f$var$_color.default)(start.c, end.c), l = (0, $332fe7b04fb5111f$var$_color.default)(start.l, end.l), opacity = (0, $332fe7b04fb5111f$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $332fe7b04fb5111f$var$_default = $332fe7b04fb5111f$var$hcl($332fe7b04fb5111f$var$_color.hue);
module.exports.default = $332fe7b04fb5111f$var$_default;
var $332fe7b04fb5111f$var$hclLong = $332fe7b04fb5111f$var$hcl($332fe7b04fb5111f$var$_color.default);
module.exports.hclLong = $332fe7b04fb5111f$var$hclLong;

});

parcelRequire.register("cAUZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $aZQp8 = parcelRequire("aZQp8");

var $92b50e2c83a1606d$var$_color = $92b50e2c83a1606d$var$_interopRequireWildcard((parcelRequire("k0Dyl")));
function $92b50e2c83a1606d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($92b50e2c83a1606d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $92b50e2c83a1606d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $92b50e2c83a1606d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $92b50e2c83a1606d$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $aZQp8.cubehelix)(start)).h, (end = (0, $aZQp8.cubehelix)(end)).h), s = (0, $92b50e2c83a1606d$var$_color.default)(start.s, end.s), l = (0, $92b50e2c83a1606d$var$_color.default)(start.l, end.l), opacity = (0, $92b50e2c83a1606d$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $92b50e2c83a1606d$var$_default = $92b50e2c83a1606d$var$cubehelix($92b50e2c83a1606d$var$_color.hue);
module.exports.default = $92b50e2c83a1606d$var$_default;
var $92b50e2c83a1606d$var$cubehelixLong = $92b50e2c83a1606d$var$cubehelix($92b50e2c83a1606d$var$_color.default);
module.exports.cubehelixLong = $92b50e2c83a1606d$var$cubehelixLong;

});

parcelRequire.register("5PAoB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $43edf2a35be6cc41$var$piecewise;

var $43edf2a35be6cc41$var$_value = $43edf2a35be6cc41$var$_interopRequireDefault((parcelRequire("3wF31")));
function $43edf2a35be6cc41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43edf2a35be6cc41$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $43edf2a35be6cc41$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRequire.register("fAMoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b59fc2492b821af1$var$_default;
function $b59fc2492b821af1$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRequire.register("fJVM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b757dfcdf9be3845$var$constants;
function $b757dfcdf9be3845$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRequire.register("28fNo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18d894d6c994dbb9$var$number;
function $18d894d6c994dbb9$var$number(x) {
    return +x;
}

});


parcelRequire.register("aYr1Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7fd47953096bbfcc$var$tickFormat;

var $cyl8F = parcelRequire("cyl8F");

var $hfUXV = parcelRequire("hfUXV");
function $7fd47953096bbfcc$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $cyl8F.tickStep)(start, stop, count), precision;
    specifier = (0, $hfUXV.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $hfUXV.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $hfUXV.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $hfUXV.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $hfUXV.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $hfUXV.format)(specifier);
}

});
parcelRequire.register("hfUXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $c9000687e0679f15$var$_precisionRound.default;
    }
});

var $c9000687e0679f15$var$_defaultLocale = $c9000687e0679f15$var$_interopRequireWildcard((parcelRequire("eAr12")));

var $c9000687e0679f15$var$_locale = $c9000687e0679f15$var$_interopRequireDefault((parcelRequire("92kaM")));

var $c9000687e0679f15$var$_formatSpecifier = $c9000687e0679f15$var$_interopRequireWildcard((parcelRequire("lsyA4")));

var $c9000687e0679f15$var$_precisionFixed = $c9000687e0679f15$var$_interopRequireDefault((parcelRequire("atGwd")));

var $c9000687e0679f15$var$_precisionPrefix = $c9000687e0679f15$var$_interopRequireDefault((parcelRequire("1u8OJ")));

var $c9000687e0679f15$var$_precisionRound = $c9000687e0679f15$var$_interopRequireDefault((parcelRequire("6mCjd")));
function $c9000687e0679f15$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9000687e0679f15$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c9000687e0679f15$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c9000687e0679f15$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c9000687e0679f15$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("eAr12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a9e96243450b8fcc$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $a9e96243450b8fcc$var$_locale = $a9e96243450b8fcc$var$_interopRequireDefault((parcelRequire("92kaM")));
function $a9e96243450b8fcc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a9e96243450b8fcc$var$locale;
var $a9e96243450b8fcc$var$format;
module.exports.format = $a9e96243450b8fcc$var$format;
var $a9e96243450b8fcc$var$formatPrefix;
module.exports.formatPrefix = $a9e96243450b8fcc$var$formatPrefix;
$a9e96243450b8fcc$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $a9e96243450b8fcc$var$defaultLocale(definition) {
    $a9e96243450b8fcc$var$locale = (0, $a9e96243450b8fcc$var$_locale.default)(definition);
    module.exports.format = $a9e96243450b8fcc$var$format = $a9e96243450b8fcc$var$locale.format;
    module.exports.formatPrefix = $a9e96243450b8fcc$var$formatPrefix = $a9e96243450b8fcc$var$locale.formatPrefix;
    return $a9e96243450b8fcc$var$locale;
}

});
parcelRequire.register("92kaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6943f2e5ef8affdd$var$_default;

var $6943f2e5ef8affdd$var$_exponent = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("byEXk")));

var $6943f2e5ef8affdd$var$_formatGroup = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("jx7Dv")));

var $6943f2e5ef8affdd$var$_formatNumerals = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("8CS2B")));

var $6943f2e5ef8affdd$var$_formatSpecifier = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("lsyA4")));

var $6943f2e5ef8affdd$var$_formatTrim = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("3fIV5")));

var $6943f2e5ef8affdd$var$_formatTypes = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("5ICaT")));

var $dLwBt = parcelRequire("dLwBt");

var $6943f2e5ef8affdd$var$_identity = $6943f2e5ef8affdd$var$_interopRequireDefault((parcelRequire("bwSvL")));
function $6943f2e5ef8affdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6943f2e5ef8affdd$var$map = Array.prototype.map, $6943f2e5ef8affdd$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $6943f2e5ef8affdd$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $6943f2e5ef8affdd$var$_identity.default : (0, $6943f2e5ef8affdd$var$_formatGroup.default)($6943f2e5ef8affdd$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $6943f2e5ef8affdd$var$_identity.default : (0, $6943f2e5ef8affdd$var$_formatNumerals.default)($6943f2e5ef8affdd$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $6943f2e5ef8affdd$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$6943f2e5ef8affdd$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $6943f2e5ef8affdd$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $6943f2e5ef8affdd$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $6943f2e5ef8affdd$var$prefixes[8 + $dLwBt.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $6943f2e5ef8affdd$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $6943f2e5ef8affdd$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $6943f2e5ef8affdd$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRequire.register("byEXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86a2a3acaf04b556$var$_default;

var $dPMaT = parcelRequire("dPMaT");
function $86a2a3acaf04b556$var$_default(x) {
    return x = (0, $dPMaT.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRequire.register("dPMaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a125684c81d44715$var$_default;
module.exports.formatDecimalParts = $a125684c81d44715$var$formatDecimalParts;
function $a125684c81d44715$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $a125684c81d44715$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRequire.register("jx7Dv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e38705cc385ef62e$var$_default;
function $e38705cc385ef62e$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRequire.register("8CS2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $647bcabefb573a60$var$_default;
function $647bcabefb573a60$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRequire.register("lsyA4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $f9f70981979c544b$var$FormatSpecifier;
module.exports.default = $f9f70981979c544b$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f9f70981979c544b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f9f70981979c544b$var$formatSpecifier(specifier) {
    if (!(match = $f9f70981979c544b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f9f70981979c544b$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f9f70981979c544b$var$formatSpecifier.prototype = $f9f70981979c544b$var$FormatSpecifier.prototype; // instanceof
function $f9f70981979c544b$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f9f70981979c544b$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRequire.register("3fIV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25e59df09e954bd2$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $25e59df09e954bd2$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRequire.register("5ICaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $429eac828f0c3480$var$_formatDecimal = $429eac828f0c3480$var$_interopRequireDefault((parcelRequire("dPMaT")));

var $429eac828f0c3480$var$_formatPrefixAuto = $429eac828f0c3480$var$_interopRequireDefault((parcelRequire("dLwBt")));

var $429eac828f0c3480$var$_formatRounded = $429eac828f0c3480$var$_interopRequireDefault((parcelRequire("fHMzC")));
function $429eac828f0c3480$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $429eac828f0c3480$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $429eac828f0c3480$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $429eac828f0c3480$var$_formatRounded.default)(x * 100, p),
    "r": $429eac828f0c3480$var$_formatRounded.default,
    "s": $429eac828f0c3480$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $429eac828f0c3480$var$_default;

});
parcelRequire.register("dLwBt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a058f482525dfe5b$var$_default;
module.exports.prefixExponent = void 0;

var $dPMaT = parcelRequire("dPMaT");
var $a058f482525dfe5b$var$prefixExponent;
module.exports.prefixExponent = $a058f482525dfe5b$var$prefixExponent;
function $a058f482525dfe5b$var$_default(x, p) {
    var d = (0, $dPMaT.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $a058f482525dfe5b$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $dPMaT.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRequire.register("fHMzC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6f08cdef8e09977$var$_default;

var $dPMaT = parcelRequire("dPMaT");
function $b6f08cdef8e09977$var$_default(x, p) {
    var d = (0, $dPMaT.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRequire.register("bwSvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $864cf7ad1d1832ed$var$_default;
function $864cf7ad1d1832ed$var$_default(x) {
    return x;
}

});



parcelRequire.register("atGwd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a0d98269b96f3fd$var$_default;

var $7a0d98269b96f3fd$var$_exponent = $7a0d98269b96f3fd$var$_interopRequireDefault((parcelRequire("byEXk")));
function $7a0d98269b96f3fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a0d98269b96f3fd$var$_default(step) {
    return Math.max(0, -(0, $7a0d98269b96f3fd$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("1u8OJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $114f6eb696e178e7$var$_default;

var $114f6eb696e178e7$var$_exponent = $114f6eb696e178e7$var$_interopRequireDefault((parcelRequire("byEXk")));
function $114f6eb696e178e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $114f6eb696e178e7$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $114f6eb696e178e7$var$_exponent.default)(value) / 3))) * 3 - (0, $114f6eb696e178e7$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("6mCjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a228387982a509d$var$_default;

var $4a228387982a509d$var$_exponent = $4a228387982a509d$var$_interopRequireDefault((parcelRequire("byEXk")));
function $4a228387982a509d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a228387982a509d$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $4a228387982a509d$var$_exponent.default)(max) - (0, $4a228387982a509d$var$_exponent.default)(step)) + 1;
}

});





parcelRequire.register("fCfGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5e691302219e56d$var$log;
module.exports.loggish = $b5e691302219e56d$var$loggish;

var $cyl8F = parcelRequire("cyl8F");

var $hfUXV = parcelRequire("hfUXV");

var $b5e691302219e56d$var$_nice = $b5e691302219e56d$var$_interopRequireDefault((parcelRequire("UVWRB")));

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");
function $b5e691302219e56d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5e691302219e56d$var$transformLog(x) {
    return Math.log(x);
}
function $b5e691302219e56d$var$transformExp(x) {
    return Math.exp(x);
}
function $b5e691302219e56d$var$transformLogn(x) {
    return -Math.log(-x);
}
function $b5e691302219e56d$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $b5e691302219e56d$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $b5e691302219e56d$var$powp(base) {
    return base === 10 ? $b5e691302219e56d$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $b5e691302219e56d$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $b5e691302219e56d$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $b5e691302219e56d$var$loggish(transform) {
    const scale = transform($b5e691302219e56d$var$transformLog, $b5e691302219e56d$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $b5e691302219e56d$var$logp(base), pows = $b5e691302219e56d$var$powp(base);
        if (domain()[0] < 0) {
            logs = $b5e691302219e56d$var$reflect(logs), pows = $b5e691302219e56d$var$reflect(pows);
            transform($b5e691302219e56d$var$transformLogn, $b5e691302219e56d$var$transformExpn);
        } else transform($b5e691302219e56d$var$transformLog, $b5e691302219e56d$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $cyl8F.ticks)(u, v, n);
        } else z = (0, $cyl8F.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $hfUXV.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $hfUXV.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $b5e691302219e56d$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $b5e691302219e56d$var$log() {
    const scale = $b5e691302219e56d$var$loggish((0, $lJpuv.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $lJpuv.copy)(scale, $b5e691302219e56d$var$log()).base(scale.base());
    $55VNs.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRequire.register("UVWRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ab22e6cbb782d9c$var$nice;
function $0ab22e6cbb782d9c$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRequire.register("l8UWd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f646830381f907c9$var$symlog;
module.exports.symlogish = $f646830381f907c9$var$symlogish;

var $xqA60 = parcelRequire("xqA60");

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");
function $f646830381f907c9$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $f646830381f907c9$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $f646830381f907c9$var$symlogish(transform) {
    var c = 1, scale = transform($f646830381f907c9$var$transformSymlog(c), $f646830381f907c9$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($f646830381f907c9$var$transformSymlog(c = +_), $f646830381f907c9$var$transformSymexp(c)) : c;
    };
    return (0, $xqA60.linearish)(scale);
}
function $f646830381f907c9$var$symlog() {
    var scale = $f646830381f907c9$var$symlogish((0, $lJpuv.transformer)());
    scale.copy = function() {
        return (0, $lJpuv.copy)(scale, $f646830381f907c9$var$symlog()).constant(scale.constant());
    };
    return $55VNs.initRange.apply(scale, arguments);
}

});

parcelRequire.register("6SM9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $502d23d4bf706925$var$pow;
module.exports.powish = $502d23d4bf706925$var$powish;
module.exports.sqrt = $502d23d4bf706925$var$sqrt;

var $xqA60 = parcelRequire("xqA60");

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");
function $502d23d4bf706925$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $502d23d4bf706925$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $502d23d4bf706925$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $502d23d4bf706925$var$powish(transform) {
    var scale = transform($lJpuv.identity, $lJpuv.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($lJpuv.identity, $lJpuv.identity) : exponent === 0.5 ? transform($502d23d4bf706925$var$transformSqrt, $502d23d4bf706925$var$transformSquare) : transform($502d23d4bf706925$var$transformPow(exponent), $502d23d4bf706925$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $xqA60.linearish)(scale);
}
function $502d23d4bf706925$var$pow() {
    var scale = $502d23d4bf706925$var$powish((0, $lJpuv.transformer)());
    scale.copy = function() {
        return (0, $lJpuv.copy)(scale, $502d23d4bf706925$var$pow()).exponent(scale.exponent());
    };
    $55VNs.initRange.apply(scale, arguments);
    return scale;
}
function $502d23d4bf706925$var$sqrt() {
    return $502d23d4bf706925$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("71kO1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51c8c40466c28380$var$radial;

var $51c8c40466c28380$var$_continuous = $51c8c40466c28380$var$_interopRequireDefault((parcelRequire("lJpuv")));

var $55VNs = parcelRequire("55VNs");

var $xqA60 = parcelRequire("xqA60");

var $51c8c40466c28380$var$_number = $51c8c40466c28380$var$_interopRequireDefault((parcelRequire("28fNo")));
function $51c8c40466c28380$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $51c8c40466c28380$var$square(x) {
    return Math.sign(x) * x * x;
}
function $51c8c40466c28380$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $51c8c40466c28380$var$radial() {
    var squared = (0, $51c8c40466c28380$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $51c8c40466c28380$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($51c8c40466c28380$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $51c8c40466c28380$var$_number.default)).map($51c8c40466c28380$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $51c8c40466c28380$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $55VNs.initRange.apply(scale, arguments);
    return (0, $xqA60.linearish)(scale);
}

});

parcelRequire.register("gkQyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be47498e229bc553$var$quantile;

var $cyl8F = parcelRequire("cyl8F");

var $55VNs = parcelRequire("55VNs");
function $be47498e229bc553$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $cyl8F.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $cyl8F.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($cyl8F.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $be47498e229bc553$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $55VNs.initRange.apply(scale, arguments);
}

});

parcelRequire.register("90cS7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68de19370d41b567$var$quantize;

var $cyl8F = parcelRequire("cyl8F");

var $xqA60 = parcelRequire("xqA60");

var $55VNs = parcelRequire("55VNs");
function $68de19370d41b567$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cyl8F.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $68de19370d41b567$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $55VNs.initRange.apply((0, $xqA60.linearish)(scale), arguments);
}

});

parcelRequire.register("e7ZsJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a491654ea89ec8f3$var$threshold;

var $cyl8F = parcelRequire("cyl8F");

var $55VNs = parcelRequire("55VNs");
function $a491654ea89ec8f3$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cyl8F.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $a491654ea89ec8f3$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $55VNs.initRange.apply(scale, arguments);
}

});

parcelRequire.register("gioGx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $bdd179c0b85c34d7$var$calendar;
module.exports.default = $bdd179c0b85c34d7$var$time;

var $6odr9 = parcelRequire("6odr9");

var $4zL1C = parcelRequire("4zL1C");

var $bdd179c0b85c34d7$var$_continuous = $bdd179c0b85c34d7$var$_interopRequireWildcard((parcelRequire("lJpuv")));

var $55VNs = parcelRequire("55VNs");

var $bdd179c0b85c34d7$var$_nice = $bdd179c0b85c34d7$var$_interopRequireDefault((parcelRequire("UVWRB")));
function $bdd179c0b85c34d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bdd179c0b85c34d7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bdd179c0b85c34d7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bdd179c0b85c34d7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bdd179c0b85c34d7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bdd179c0b85c34d7$var$date(t) {
    return new Date(t);
}
function $bdd179c0b85c34d7$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $bdd179c0b85c34d7$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $bdd179c0b85c34d7$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $bdd179c0b85c34d7$var$number)) : domain().map($bdd179c0b85c34d7$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $bdd179c0b85c34d7$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $bdd179c0b85c34d7$var$_continuous.copy)(scale, $bdd179c0b85c34d7$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $bdd179c0b85c34d7$var$time() {
    return $55VNs.initRange.apply($bdd179c0b85c34d7$var$calendar($6odr9.timeTicks, $6odr9.timeTickInterval, $6odr9.timeYear, $6odr9.timeMonth, $6odr9.timeWeek, $6odr9.timeDay, $6odr9.timeHour, $6odr9.timeMinute, $6odr9.timeSecond, $4zL1C.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRequire.register("6odr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $atxEU.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $atxEU.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $atxEU.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $atxEU.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $atxEU.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $atxEU.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $atxEU.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $atxEU.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $atxEU.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $atxEU.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $2tUps.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $2tUps.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $atxEU.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $atxEU.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $atxEU.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $atxEU.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $atxEU.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $atxEU.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $2tUps.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $2tUps.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $b4y2o.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $4a6f6842cbff4a4a$var$_utcYear.utcYears;
    }
});

var $4a6f6842cbff4a4a$var$_interval = $4a6f6842cbff4a4a$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $4a6f6842cbff4a4a$var$_millisecond = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("6jIRO")));

var $4a6f6842cbff4a4a$var$_second = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("fNHqo")));

var $4a6f6842cbff4a4a$var$_minute = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("9e9tg")));

var $4a6f6842cbff4a4a$var$_hour = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("aioYY")));

var $4a6f6842cbff4a4a$var$_day = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("41FtU")));

var $atxEU = parcelRequire("atxEU");

var $4a6f6842cbff4a4a$var$_month = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("66EdU")));

var $4a6f6842cbff4a4a$var$_year = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("ijTAm")));

var $4a6f6842cbff4a4a$var$_utcMinute = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("3HbGR")));

var $4a6f6842cbff4a4a$var$_utcHour = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("6z8Pp")));

var $4a6f6842cbff4a4a$var$_utcDay = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("b553U")));

var $b4y2o = parcelRequire("b4y2o");

var $4a6f6842cbff4a4a$var$_utcMonth = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("ejWIQ")));

var $4a6f6842cbff4a4a$var$_utcYear = $4a6f6842cbff4a4a$var$_interopRequireWildcard((parcelRequire("2ZmjZ")));

var $2tUps = parcelRequire("2tUps");
function $4a6f6842cbff4a4a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4a6f6842cbff4a4a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4a6f6842cbff4a4a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4a6f6842cbff4a4a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4a6f6842cbff4a4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("eV3KW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adc94d6f7f464266$var$newInterval;
var $adc94d6f7f464266$var$t0 = new Date(), $adc94d6f7f464266$var$t1 = new Date();
function $adc94d6f7f464266$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $adc94d6f7f464266$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $adc94d6f7f464266$var$t0.setTime(+start), $adc94d6f7f464266$var$t1.setTime(+end);
            floori($adc94d6f7f464266$var$t0), floori($adc94d6f7f464266$var$t1);
            return Math.floor(count($adc94d6f7f464266$var$t0, $adc94d6f7f464266$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRequire.register("6jIRO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $4997520b96b7e745$var$_interval = $4997520b96b7e745$var$_interopRequireDefault((parcelRequire("eV3KW")));
function $4997520b96b7e745$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4997520b96b7e745$var$millisecond = (0, $4997520b96b7e745$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$4997520b96b7e745$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $4997520b96b7e745$var$millisecond;
    return (0, $4997520b96b7e745$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $4997520b96b7e745$var$_default = $4997520b96b7e745$var$millisecond;
module.exports.default = $4997520b96b7e745$var$_default;
var $4997520b96b7e745$var$milliseconds = $4997520b96b7e745$var$millisecond.range;
module.exports.milliseconds = $4997520b96b7e745$var$milliseconds;

});

parcelRequire.register("fNHqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $b80d1dda8a38e379$var$_interval = $b80d1dda8a38e379$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $b80d1dda8a38e379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b80d1dda8a38e379$var$second = (0, $b80d1dda8a38e379$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $jBUDN.durationSecond);
}, function(start, end) {
    return (end - start) / $jBUDN.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $b80d1dda8a38e379$var$_default = $b80d1dda8a38e379$var$second;
module.exports.default = $b80d1dda8a38e379$var$_default;
var $b80d1dda8a38e379$var$seconds = $b80d1dda8a38e379$var$second.range;
module.exports.seconds = $b80d1dda8a38e379$var$seconds;

});
parcelRequire.register("jBUDN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $e46d68b27600ebe9$var$durationSecond = 1000;
module.exports.durationSecond = $e46d68b27600ebe9$var$durationSecond;
const $e46d68b27600ebe9$var$durationMinute = $e46d68b27600ebe9$var$durationSecond * 60;
module.exports.durationMinute = $e46d68b27600ebe9$var$durationMinute;
const $e46d68b27600ebe9$var$durationHour = $e46d68b27600ebe9$var$durationMinute * 60;
module.exports.durationHour = $e46d68b27600ebe9$var$durationHour;
const $e46d68b27600ebe9$var$durationDay = $e46d68b27600ebe9$var$durationHour * 24;
module.exports.durationDay = $e46d68b27600ebe9$var$durationDay;
const $e46d68b27600ebe9$var$durationWeek = $e46d68b27600ebe9$var$durationDay * 7;
module.exports.durationWeek = $e46d68b27600ebe9$var$durationWeek;
const $e46d68b27600ebe9$var$durationMonth = $e46d68b27600ebe9$var$durationDay * 30;
module.exports.durationMonth = $e46d68b27600ebe9$var$durationMonth;
const $e46d68b27600ebe9$var$durationYear = $e46d68b27600ebe9$var$durationDay * 365;
module.exports.durationYear = $e46d68b27600ebe9$var$durationYear;

});


parcelRequire.register("9e9tg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $6b7cc495da1a84f2$var$_interval = $6b7cc495da1a84f2$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $6b7cc495da1a84f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6b7cc495da1a84f2$var$minute = (0, $6b7cc495da1a84f2$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $jBUDN.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $jBUDN.durationMinute);
}, function(start, end) {
    return (end - start) / $jBUDN.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $6b7cc495da1a84f2$var$_default = $6b7cc495da1a84f2$var$minute;
module.exports.default = $6b7cc495da1a84f2$var$_default;
var $6b7cc495da1a84f2$var$minutes = $6b7cc495da1a84f2$var$minute.range;
module.exports.minutes = $6b7cc495da1a84f2$var$minutes;

});

parcelRequire.register("aioYY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $77eef6d07b67214d$var$_interval = $77eef6d07b67214d$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $77eef6d07b67214d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $77eef6d07b67214d$var$hour = (0, $77eef6d07b67214d$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $jBUDN.durationSecond - date.getMinutes() * $jBUDN.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $jBUDN.durationHour);
}, function(start, end) {
    return (end - start) / $jBUDN.durationHour;
}, function(date) {
    return date.getHours();
});
var $77eef6d07b67214d$var$_default = $77eef6d07b67214d$var$hour;
module.exports.default = $77eef6d07b67214d$var$_default;
var $77eef6d07b67214d$var$hours = $77eef6d07b67214d$var$hour.range;
module.exports.hours = $77eef6d07b67214d$var$hours;

});

parcelRequire.register("41FtU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $2ee76ec230b94ccc$var$_interval = $2ee76ec230b94ccc$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $2ee76ec230b94ccc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2ee76ec230b94ccc$var$day = (0, $2ee76ec230b94ccc$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $jBUDN.durationMinute) / $jBUDN.durationDay, (date)=>date.getDate() - 1);
var $2ee76ec230b94ccc$var$_default = $2ee76ec230b94ccc$var$day;
module.exports.default = $2ee76ec230b94ccc$var$_default;
var $2ee76ec230b94ccc$var$days = $2ee76ec230b94ccc$var$day.range;
module.exports.days = $2ee76ec230b94ccc$var$days;

});

parcelRequire.register("atxEU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $7a06b8c37fd2102b$var$_interval = $7a06b8c37fd2102b$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $7a06b8c37fd2102b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a06b8c37fd2102b$var$weekday(i) {
    return (0, $7a06b8c37fd2102b$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $jBUDN.durationMinute) / $jBUDN.durationWeek;
    });
}
var $7a06b8c37fd2102b$var$sunday = $7a06b8c37fd2102b$var$weekday(0);
module.exports.sunday = $7a06b8c37fd2102b$var$sunday;
var $7a06b8c37fd2102b$var$monday = $7a06b8c37fd2102b$var$weekday(1);
module.exports.monday = $7a06b8c37fd2102b$var$monday;
var $7a06b8c37fd2102b$var$tuesday = $7a06b8c37fd2102b$var$weekday(2);
module.exports.tuesday = $7a06b8c37fd2102b$var$tuesday;
var $7a06b8c37fd2102b$var$wednesday = $7a06b8c37fd2102b$var$weekday(3);
module.exports.wednesday = $7a06b8c37fd2102b$var$wednesday;
var $7a06b8c37fd2102b$var$thursday = $7a06b8c37fd2102b$var$weekday(4);
module.exports.thursday = $7a06b8c37fd2102b$var$thursday;
var $7a06b8c37fd2102b$var$friday = $7a06b8c37fd2102b$var$weekday(5);
module.exports.friday = $7a06b8c37fd2102b$var$friday;
var $7a06b8c37fd2102b$var$saturday = $7a06b8c37fd2102b$var$weekday(6);
module.exports.saturday = $7a06b8c37fd2102b$var$saturday;
var $7a06b8c37fd2102b$var$sundays = $7a06b8c37fd2102b$var$sunday.range;
module.exports.sundays = $7a06b8c37fd2102b$var$sundays;
var $7a06b8c37fd2102b$var$mondays = $7a06b8c37fd2102b$var$monday.range;
module.exports.mondays = $7a06b8c37fd2102b$var$mondays;
var $7a06b8c37fd2102b$var$tuesdays = $7a06b8c37fd2102b$var$tuesday.range;
module.exports.tuesdays = $7a06b8c37fd2102b$var$tuesdays;
var $7a06b8c37fd2102b$var$wednesdays = $7a06b8c37fd2102b$var$wednesday.range;
module.exports.wednesdays = $7a06b8c37fd2102b$var$wednesdays;
var $7a06b8c37fd2102b$var$thursdays = $7a06b8c37fd2102b$var$thursday.range;
module.exports.thursdays = $7a06b8c37fd2102b$var$thursdays;
var $7a06b8c37fd2102b$var$fridays = $7a06b8c37fd2102b$var$friday.range;
module.exports.fridays = $7a06b8c37fd2102b$var$fridays;
var $7a06b8c37fd2102b$var$saturdays = $7a06b8c37fd2102b$var$saturday.range;
module.exports.saturdays = $7a06b8c37fd2102b$var$saturdays;

});

parcelRequire.register("66EdU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $47228122ea1d0d63$var$_interval = $47228122ea1d0d63$var$_interopRequireDefault((parcelRequire("eV3KW")));
function $47228122ea1d0d63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $47228122ea1d0d63$var$month = (0, $47228122ea1d0d63$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $47228122ea1d0d63$var$_default = $47228122ea1d0d63$var$month;
module.exports.default = $47228122ea1d0d63$var$_default;
var $47228122ea1d0d63$var$months = $47228122ea1d0d63$var$month.range;
module.exports.months = $47228122ea1d0d63$var$months;

});

parcelRequire.register("ijTAm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $d5651e7af051bb07$var$_interval = $d5651e7af051bb07$var$_interopRequireDefault((parcelRequire("eV3KW")));
function $d5651e7af051bb07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d5651e7af051bb07$var$year = (0, $d5651e7af051bb07$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$d5651e7af051bb07$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d5651e7af051bb07$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $d5651e7af051bb07$var$_default = $d5651e7af051bb07$var$year;
module.exports.default = $d5651e7af051bb07$var$_default;
var $d5651e7af051bb07$var$years = $d5651e7af051bb07$var$year.range;
module.exports.years = $d5651e7af051bb07$var$years;

});

parcelRequire.register("3HbGR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $2b0e74b511eda022$var$_interval = $2b0e74b511eda022$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $2b0e74b511eda022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2b0e74b511eda022$var$utcMinute = (0, $2b0e74b511eda022$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $jBUDN.durationMinute);
}, function(start, end) {
    return (end - start) / $jBUDN.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $2b0e74b511eda022$var$_default = $2b0e74b511eda022$var$utcMinute;
module.exports.default = $2b0e74b511eda022$var$_default;
var $2b0e74b511eda022$var$utcMinutes = $2b0e74b511eda022$var$utcMinute.range;
module.exports.utcMinutes = $2b0e74b511eda022$var$utcMinutes;

});

parcelRequire.register("6z8Pp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $4c7cdc1202c04680$var$_interval = $4c7cdc1202c04680$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $4c7cdc1202c04680$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c7cdc1202c04680$var$utcHour = (0, $4c7cdc1202c04680$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $jBUDN.durationHour);
}, function(start, end) {
    return (end - start) / $jBUDN.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $4c7cdc1202c04680$var$_default = $4c7cdc1202c04680$var$utcHour;
module.exports.default = $4c7cdc1202c04680$var$_default;
var $4c7cdc1202c04680$var$utcHours = $4c7cdc1202c04680$var$utcHour.range;
module.exports.utcHours = $4c7cdc1202c04680$var$utcHours;

});

parcelRequire.register("b553U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $8114168b48051544$var$_interval = $8114168b48051544$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $8114168b48051544$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8114168b48051544$var$utcDay = (0, $8114168b48051544$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $jBUDN.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $8114168b48051544$var$_default = $8114168b48051544$var$utcDay;
module.exports.default = $8114168b48051544$var$_default;
var $8114168b48051544$var$utcDays = $8114168b48051544$var$utcDay.range;
module.exports.utcDays = $8114168b48051544$var$utcDays;

});

parcelRequire.register("b4y2o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $80fa789798738d2e$var$_interval = $80fa789798738d2e$var$_interopRequireDefault((parcelRequire("eV3KW")));

var $jBUDN = parcelRequire("jBUDN");
function $80fa789798738d2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80fa789798738d2e$var$utcWeekday(i) {
    return (0, $80fa789798738d2e$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $jBUDN.durationWeek;
    });
}
var $80fa789798738d2e$var$utcSunday = $80fa789798738d2e$var$utcWeekday(0);
module.exports.utcSunday = $80fa789798738d2e$var$utcSunday;
var $80fa789798738d2e$var$utcMonday = $80fa789798738d2e$var$utcWeekday(1);
module.exports.utcMonday = $80fa789798738d2e$var$utcMonday;
var $80fa789798738d2e$var$utcTuesday = $80fa789798738d2e$var$utcWeekday(2);
module.exports.utcTuesday = $80fa789798738d2e$var$utcTuesday;
var $80fa789798738d2e$var$utcWednesday = $80fa789798738d2e$var$utcWeekday(3);
module.exports.utcWednesday = $80fa789798738d2e$var$utcWednesday;
var $80fa789798738d2e$var$utcThursday = $80fa789798738d2e$var$utcWeekday(4);
module.exports.utcThursday = $80fa789798738d2e$var$utcThursday;
var $80fa789798738d2e$var$utcFriday = $80fa789798738d2e$var$utcWeekday(5);
module.exports.utcFriday = $80fa789798738d2e$var$utcFriday;
var $80fa789798738d2e$var$utcSaturday = $80fa789798738d2e$var$utcWeekday(6);
module.exports.utcSaturday = $80fa789798738d2e$var$utcSaturday;
var $80fa789798738d2e$var$utcSundays = $80fa789798738d2e$var$utcSunday.range;
module.exports.utcSundays = $80fa789798738d2e$var$utcSundays;
var $80fa789798738d2e$var$utcMondays = $80fa789798738d2e$var$utcMonday.range;
module.exports.utcMondays = $80fa789798738d2e$var$utcMondays;
var $80fa789798738d2e$var$utcTuesdays = $80fa789798738d2e$var$utcTuesday.range;
module.exports.utcTuesdays = $80fa789798738d2e$var$utcTuesdays;
var $80fa789798738d2e$var$utcWednesdays = $80fa789798738d2e$var$utcWednesday.range;
module.exports.utcWednesdays = $80fa789798738d2e$var$utcWednesdays;
var $80fa789798738d2e$var$utcThursdays = $80fa789798738d2e$var$utcThursday.range;
module.exports.utcThursdays = $80fa789798738d2e$var$utcThursdays;
var $80fa789798738d2e$var$utcFridays = $80fa789798738d2e$var$utcFriday.range;
module.exports.utcFridays = $80fa789798738d2e$var$utcFridays;
var $80fa789798738d2e$var$utcSaturdays = $80fa789798738d2e$var$utcSaturday.range;
module.exports.utcSaturdays = $80fa789798738d2e$var$utcSaturdays;

});

parcelRequire.register("ejWIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $a6d0640da4a8c531$var$_interval = $a6d0640da4a8c531$var$_interopRequireDefault((parcelRequire("eV3KW")));
function $a6d0640da4a8c531$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a6d0640da4a8c531$var$utcMonth = (0, $a6d0640da4a8c531$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $a6d0640da4a8c531$var$_default = $a6d0640da4a8c531$var$utcMonth;
module.exports.default = $a6d0640da4a8c531$var$_default;
var $a6d0640da4a8c531$var$utcMonths = $a6d0640da4a8c531$var$utcMonth.range;
module.exports.utcMonths = $a6d0640da4a8c531$var$utcMonths;

});

parcelRequire.register("2ZmjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $22d297d920666285$var$_interval = $22d297d920666285$var$_interopRequireDefault((parcelRequire("eV3KW")));
function $22d297d920666285$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $22d297d920666285$var$utcYear = (0, $22d297d920666285$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$22d297d920666285$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $22d297d920666285$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $22d297d920666285$var$_default = $22d297d920666285$var$utcYear;
module.exports.default = $22d297d920666285$var$_default;
var $22d297d920666285$var$utcYears = $22d297d920666285$var$utcYear.range;
module.exports.utcYears = $22d297d920666285$var$utcYears;

});

parcelRequire.register("2tUps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $cyl8F = parcelRequire("cyl8F");

var $jBUDN = parcelRequire("jBUDN");

var $1cea0bf8d7945286$var$_millisecond = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("6jIRO")));

var $1cea0bf8d7945286$var$_second = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("fNHqo")));

var $1cea0bf8d7945286$var$_minute = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("9e9tg")));

var $1cea0bf8d7945286$var$_hour = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("aioYY")));

var $1cea0bf8d7945286$var$_day = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("41FtU")));

var $atxEU = parcelRequire("atxEU");

var $1cea0bf8d7945286$var$_month = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("66EdU")));

var $1cea0bf8d7945286$var$_year = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("ijTAm")));

var $1cea0bf8d7945286$var$_utcMinute = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("3HbGR")));

var $1cea0bf8d7945286$var$_utcHour = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("6z8Pp")));

var $1cea0bf8d7945286$var$_utcDay = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("b553U")));

var $b4y2o = parcelRequire("b4y2o");

var $1cea0bf8d7945286$var$_utcMonth = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("ejWIQ")));

var $1cea0bf8d7945286$var$_utcYear = $1cea0bf8d7945286$var$_interopRequireDefault((parcelRequire("2ZmjZ")));
function $1cea0bf8d7945286$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1cea0bf8d7945286$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $1cea0bf8d7945286$var$_second.default,
            1,
            $jBUDN.durationSecond
        ],
        [
            $1cea0bf8d7945286$var$_second.default,
            5,
            5 * $jBUDN.durationSecond
        ],
        [
            $1cea0bf8d7945286$var$_second.default,
            15,
            15 * $jBUDN.durationSecond
        ],
        [
            $1cea0bf8d7945286$var$_second.default,
            30,
            30 * $jBUDN.durationSecond
        ],
        [
            minute,
            1,
            $jBUDN.durationMinute
        ],
        [
            minute,
            5,
            5 * $jBUDN.durationMinute
        ],
        [
            minute,
            15,
            15 * $jBUDN.durationMinute
        ],
        [
            minute,
            30,
            30 * $jBUDN.durationMinute
        ],
        [
            hour,
            1,
            $jBUDN.durationHour
        ],
        [
            hour,
            3,
            3 * $jBUDN.durationHour
        ],
        [
            hour,
            6,
            6 * $jBUDN.durationHour
        ],
        [
            hour,
            12,
            12 * $jBUDN.durationHour
        ],
        [
            day,
            1,
            $jBUDN.durationDay
        ],
        [
            day,
            2,
            2 * $jBUDN.durationDay
        ],
        [
            week,
            1,
            $jBUDN.durationWeek
        ],
        [
            month,
            1,
            $jBUDN.durationMonth
        ],
        [
            month,
            3,
            3 * $jBUDN.durationMonth
        ],
        [
            year,
            1,
            $jBUDN.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $cyl8F.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $cyl8F.tickStep)(start / $jBUDN.durationYear, stop / $jBUDN.durationYear, count));
        if (i === 0) return $1cea0bf8d7945286$var$_millisecond.default.every(Math.max((0, $cyl8F.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$1cea0bf8d7945286$var$utcTicks, $1cea0bf8d7945286$var$utcTickInterval] = $1cea0bf8d7945286$var$ticker($1cea0bf8d7945286$var$_utcYear.default, $1cea0bf8d7945286$var$_utcMonth.default, $b4y2o.utcSunday, $1cea0bf8d7945286$var$_utcDay.default, $1cea0bf8d7945286$var$_utcHour.default, $1cea0bf8d7945286$var$_utcMinute.default);
module.exports.utcTickInterval = $1cea0bf8d7945286$var$utcTickInterval;
module.exports.utcTicks = $1cea0bf8d7945286$var$utcTicks;
const [$1cea0bf8d7945286$var$timeTicks, $1cea0bf8d7945286$var$timeTickInterval] = $1cea0bf8d7945286$var$ticker($1cea0bf8d7945286$var$_year.default, $1cea0bf8d7945286$var$_month.default, $atxEU.sunday, $1cea0bf8d7945286$var$_day.default, $1cea0bf8d7945286$var$_hour.default, $1cea0bf8d7945286$var$_minute.default);
module.exports.timeTickInterval = $1cea0bf8d7945286$var$timeTickInterval;
module.exports.timeTicks = $1cea0bf8d7945286$var$timeTicks;

});


parcelRequire.register("4zL1C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $354ee8844611e8ef$var$_defaultLocale.utcParse;
    }
});

var $354ee8844611e8ef$var$_defaultLocale = $354ee8844611e8ef$var$_interopRequireWildcard((parcelRequire("5A99V")));

var $354ee8844611e8ef$var$_locale = $354ee8844611e8ef$var$_interopRequireDefault((parcelRequire("gQrCu")));

var $354ee8844611e8ef$var$_isoFormat = $354ee8844611e8ef$var$_interopRequireDefault((parcelRequire("htJCn")));

var $354ee8844611e8ef$var$_isoParse = $354ee8844611e8ef$var$_interopRequireDefault((parcelRequire("6lvox")));
function $354ee8844611e8ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $354ee8844611e8ef$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($354ee8844611e8ef$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $354ee8844611e8ef$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $354ee8844611e8ef$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("5A99V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41076b5a2b63d6a5$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $41076b5a2b63d6a5$var$_locale = $41076b5a2b63d6a5$var$_interopRequireDefault((parcelRequire("gQrCu")));
function $41076b5a2b63d6a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $41076b5a2b63d6a5$var$locale;
var $41076b5a2b63d6a5$var$timeFormat;
module.exports.timeFormat = $41076b5a2b63d6a5$var$timeFormat;
var $41076b5a2b63d6a5$var$timeParse;
module.exports.timeParse = $41076b5a2b63d6a5$var$timeParse;
var $41076b5a2b63d6a5$var$utcFormat;
module.exports.utcFormat = $41076b5a2b63d6a5$var$utcFormat;
var $41076b5a2b63d6a5$var$utcParse;
module.exports.utcParse = $41076b5a2b63d6a5$var$utcParse;
$41076b5a2b63d6a5$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $41076b5a2b63d6a5$var$defaultLocale(definition) {
    $41076b5a2b63d6a5$var$locale = (0, $41076b5a2b63d6a5$var$_locale.default)(definition);
    module.exports.timeFormat = $41076b5a2b63d6a5$var$timeFormat = $41076b5a2b63d6a5$var$locale.format;
    module.exports.timeParse = $41076b5a2b63d6a5$var$timeParse = $41076b5a2b63d6a5$var$locale.parse;
    module.exports.utcFormat = $41076b5a2b63d6a5$var$utcFormat = $41076b5a2b63d6a5$var$locale.utcFormat;
    module.exports.utcParse = $41076b5a2b63d6a5$var$utcParse = $41076b5a2b63d6a5$var$locale.utcParse;
    return $41076b5a2b63d6a5$var$locale;
}

});
parcelRequire.register("gQrCu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c436ed67962bcc1a$var$formatLocale;

var $6odr9 = parcelRequire("6odr9");
function $c436ed67962bcc1a$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $c436ed67962bcc1a$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $c436ed67962bcc1a$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $c436ed67962bcc1a$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $c436ed67962bcc1a$var$formatRe(locale_periods), periodLookup = $c436ed67962bcc1a$var$formatLookup(locale_periods), weekdayRe = $c436ed67962bcc1a$var$formatRe(locale_weekdays), weekdayLookup = $c436ed67962bcc1a$var$formatLookup(locale_weekdays), shortWeekdayRe = $c436ed67962bcc1a$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $c436ed67962bcc1a$var$formatLookup(locale_shortWeekdays), monthRe = $c436ed67962bcc1a$var$formatRe(locale_months), monthLookup = $c436ed67962bcc1a$var$formatLookup(locale_months), shortMonthRe = $c436ed67962bcc1a$var$formatRe(locale_shortMonths), shortMonthLookup = $c436ed67962bcc1a$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $c436ed67962bcc1a$var$formatDayOfMonth,
        "e": $c436ed67962bcc1a$var$formatDayOfMonth,
        "f": $c436ed67962bcc1a$var$formatMicroseconds,
        "g": $c436ed67962bcc1a$var$formatYearISO,
        "G": $c436ed67962bcc1a$var$formatFullYearISO,
        "H": $c436ed67962bcc1a$var$formatHour24,
        "I": $c436ed67962bcc1a$var$formatHour12,
        "j": $c436ed67962bcc1a$var$formatDayOfYear,
        "L": $c436ed67962bcc1a$var$formatMilliseconds,
        "m": $c436ed67962bcc1a$var$formatMonthNumber,
        "M": $c436ed67962bcc1a$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $c436ed67962bcc1a$var$formatUnixTimestamp,
        "s": $c436ed67962bcc1a$var$formatUnixTimestampSeconds,
        "S": $c436ed67962bcc1a$var$formatSeconds,
        "u": $c436ed67962bcc1a$var$formatWeekdayNumberMonday,
        "U": $c436ed67962bcc1a$var$formatWeekNumberSunday,
        "V": $c436ed67962bcc1a$var$formatWeekNumberISO,
        "w": $c436ed67962bcc1a$var$formatWeekdayNumberSunday,
        "W": $c436ed67962bcc1a$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c436ed67962bcc1a$var$formatYear,
        "Y": $c436ed67962bcc1a$var$formatFullYear,
        "Z": $c436ed67962bcc1a$var$formatZone,
        "%": $c436ed67962bcc1a$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $c436ed67962bcc1a$var$formatUTCDayOfMonth,
        "e": $c436ed67962bcc1a$var$formatUTCDayOfMonth,
        "f": $c436ed67962bcc1a$var$formatUTCMicroseconds,
        "g": $c436ed67962bcc1a$var$formatUTCYearISO,
        "G": $c436ed67962bcc1a$var$formatUTCFullYearISO,
        "H": $c436ed67962bcc1a$var$formatUTCHour24,
        "I": $c436ed67962bcc1a$var$formatUTCHour12,
        "j": $c436ed67962bcc1a$var$formatUTCDayOfYear,
        "L": $c436ed67962bcc1a$var$formatUTCMilliseconds,
        "m": $c436ed67962bcc1a$var$formatUTCMonthNumber,
        "M": $c436ed67962bcc1a$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $c436ed67962bcc1a$var$formatUnixTimestamp,
        "s": $c436ed67962bcc1a$var$formatUnixTimestampSeconds,
        "S": $c436ed67962bcc1a$var$formatUTCSeconds,
        "u": $c436ed67962bcc1a$var$formatUTCWeekdayNumberMonday,
        "U": $c436ed67962bcc1a$var$formatUTCWeekNumberSunday,
        "V": $c436ed67962bcc1a$var$formatUTCWeekNumberISO,
        "w": $c436ed67962bcc1a$var$formatUTCWeekdayNumberSunday,
        "W": $c436ed67962bcc1a$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c436ed67962bcc1a$var$formatUTCYear,
        "Y": $c436ed67962bcc1a$var$formatUTCFullYear,
        "Z": $c436ed67962bcc1a$var$formatUTCZone,
        "%": $c436ed67962bcc1a$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $c436ed67962bcc1a$var$parseDayOfMonth,
        "e": $c436ed67962bcc1a$var$parseDayOfMonth,
        "f": $c436ed67962bcc1a$var$parseMicroseconds,
        "g": $c436ed67962bcc1a$var$parseYear,
        "G": $c436ed67962bcc1a$var$parseFullYear,
        "H": $c436ed67962bcc1a$var$parseHour24,
        "I": $c436ed67962bcc1a$var$parseHour24,
        "j": $c436ed67962bcc1a$var$parseDayOfYear,
        "L": $c436ed67962bcc1a$var$parseMilliseconds,
        "m": $c436ed67962bcc1a$var$parseMonthNumber,
        "M": $c436ed67962bcc1a$var$parseMinutes,
        "p": parsePeriod,
        "q": $c436ed67962bcc1a$var$parseQuarter,
        "Q": $c436ed67962bcc1a$var$parseUnixTimestamp,
        "s": $c436ed67962bcc1a$var$parseUnixTimestampSeconds,
        "S": $c436ed67962bcc1a$var$parseSeconds,
        "u": $c436ed67962bcc1a$var$parseWeekdayNumberMonday,
        "U": $c436ed67962bcc1a$var$parseWeekNumberSunday,
        "V": $c436ed67962bcc1a$var$parseWeekNumberISO,
        "w": $c436ed67962bcc1a$var$parseWeekdayNumberSunday,
        "W": $c436ed67962bcc1a$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $c436ed67962bcc1a$var$parseYear,
        "Y": $c436ed67962bcc1a$var$parseFullYear,
        "Z": $c436ed67962bcc1a$var$parseZone,
        "%": $c436ed67962bcc1a$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $c436ed67962bcc1a$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $c436ed67962bcc1a$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $c436ed67962bcc1a$var$utcDate($c436ed67962bcc1a$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $6odr9.utcMonday.ceil(week) : (0, $6odr9.utcMonday)(week);
                    week = $6odr9.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $c436ed67962bcc1a$var$localDate($c436ed67962bcc1a$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $6odr9.timeMonday.ceil(week) : (0, $6odr9.timeMonday)(week);
                    week = $6odr9.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $c436ed67962bcc1a$var$utcDate($c436ed67962bcc1a$var$newDate(d.y, 0, 1)).getUTCDay() : $c436ed67962bcc1a$var$localDate($c436ed67962bcc1a$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $c436ed67962bcc1a$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $c436ed67962bcc1a$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $c436ed67962bcc1a$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $c436ed67962bcc1a$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $c436ed67962bcc1a$var$numberRe = /^\s*\d+/, // note: ignores next directive
$c436ed67962bcc1a$var$percentRe = /^%/, $c436ed67962bcc1a$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $c436ed67962bcc1a$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $c436ed67962bcc1a$var$requote(s) {
    return s.replace($c436ed67962bcc1a$var$requoteRe, "\\$&");
}
function $c436ed67962bcc1a$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($c436ed67962bcc1a$var$requote).join("|") + ")", "i");
}
function $c436ed67962bcc1a$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $c436ed67962bcc1a$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseWeekNumberSunday(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseWeekNumberISO(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseWeekNumberMonday(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseFullYear(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseYear(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseQuarter(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseMonthNumber(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseDayOfMonth(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseDayOfYear(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseHour24(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseMinutes(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseSeconds(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseMilliseconds(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseMicroseconds(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseLiteralPercent(d, string, i) {
    var n = $c436ed67962bcc1a$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $c436ed67962bcc1a$var$parseUnixTimestamp(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $c436ed67962bcc1a$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $c436ed67962bcc1a$var$formatDayOfMonth(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getDate(), p, 2);
}
function $c436ed67962bcc1a$var$formatHour24(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getHours(), p, 2);
}
function $c436ed67962bcc1a$var$formatHour12(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $c436ed67962bcc1a$var$formatDayOfYear(d, p) {
    return $c436ed67962bcc1a$var$pad(1 + $6odr9.timeDay.count((0, $6odr9.timeYear)(d), d), p, 3);
}
function $c436ed67962bcc1a$var$formatMilliseconds(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getMilliseconds(), p, 3);
}
function $c436ed67962bcc1a$var$formatMicroseconds(d, p) {
    return $c436ed67962bcc1a$var$formatMilliseconds(d, p) + "000";
}
function $c436ed67962bcc1a$var$formatMonthNumber(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getMonth() + 1, p, 2);
}
function $c436ed67962bcc1a$var$formatMinutes(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getMinutes(), p, 2);
}
function $c436ed67962bcc1a$var$formatSeconds(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getSeconds(), p, 2);
}
function $c436ed67962bcc1a$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $c436ed67962bcc1a$var$formatWeekNumberSunday(d, p) {
    return $c436ed67962bcc1a$var$pad($6odr9.timeSunday.count((0, $6odr9.timeYear)(d) - 1, d), p, 2);
}
function $c436ed67962bcc1a$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $6odr9.timeThursday)(d) : $6odr9.timeThursday.ceil(d);
}
function $c436ed67962bcc1a$var$formatWeekNumberISO(d, p) {
    d = $c436ed67962bcc1a$var$dISO(d);
    return $c436ed67962bcc1a$var$pad($6odr9.timeThursday.count((0, $6odr9.timeYear)(d), d) + ((0, $6odr9.timeYear)(d).getDay() === 4), p, 2);
}
function $c436ed67962bcc1a$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $c436ed67962bcc1a$var$formatWeekNumberMonday(d, p) {
    return $c436ed67962bcc1a$var$pad($6odr9.timeMonday.count((0, $6odr9.timeYear)(d) - 1, d), p, 2);
}
function $c436ed67962bcc1a$var$formatYear(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getFullYear() % 100, p, 2);
}
function $c436ed67962bcc1a$var$formatYearISO(d, p) {
    d = $c436ed67962bcc1a$var$dISO(d);
    return $c436ed67962bcc1a$var$pad(d.getFullYear() % 100, p, 2);
}
function $c436ed67962bcc1a$var$formatFullYear(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c436ed67962bcc1a$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $6odr9.timeThursday)(d) : $6odr9.timeThursday.ceil(d);
    return $c436ed67962bcc1a$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c436ed67962bcc1a$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $c436ed67962bcc1a$var$pad(z / 60 | 0, "0", 2) + $c436ed67962bcc1a$var$pad(z % 60, "0", 2);
}
function $c436ed67962bcc1a$var$formatUTCDayOfMonth(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCDate(), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCHour24(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCHours(), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCHour12(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $c436ed67962bcc1a$var$formatUTCDayOfYear(d, p) {
    return $c436ed67962bcc1a$var$pad(1 + $6odr9.utcDay.count((0, $6odr9.utcYear)(d), d), p, 3);
}
function $c436ed67962bcc1a$var$formatUTCMilliseconds(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $c436ed67962bcc1a$var$formatUTCMicroseconds(d, p) {
    return $c436ed67962bcc1a$var$formatUTCMilliseconds(d, p) + "000";
}
function $c436ed67962bcc1a$var$formatUTCMonthNumber(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $c436ed67962bcc1a$var$formatUTCMinutes(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCMinutes(), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCSeconds(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCSeconds(), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $c436ed67962bcc1a$var$formatUTCWeekNumberSunday(d, p) {
    return $c436ed67962bcc1a$var$pad($6odr9.utcSunday.count((0, $6odr9.utcYear)(d) - 1, d), p, 2);
}
function $c436ed67962bcc1a$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $6odr9.utcThursday)(d) : $6odr9.utcThursday.ceil(d);
}
function $c436ed67962bcc1a$var$formatUTCWeekNumberISO(d, p) {
    d = $c436ed67962bcc1a$var$UTCdISO(d);
    return $c436ed67962bcc1a$var$pad($6odr9.utcThursday.count((0, $6odr9.utcYear)(d), d) + ((0, $6odr9.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $c436ed67962bcc1a$var$formatUTCWeekNumberMonday(d, p) {
    return $c436ed67962bcc1a$var$pad($6odr9.utcMonday.count((0, $6odr9.utcYear)(d) - 1, d), p, 2);
}
function $c436ed67962bcc1a$var$formatUTCYear(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c436ed67962bcc1a$var$formatUTCYearISO(d, p) {
    d = $c436ed67962bcc1a$var$UTCdISO(d);
    return $c436ed67962bcc1a$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c436ed67962bcc1a$var$formatUTCFullYear(d, p) {
    return $c436ed67962bcc1a$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c436ed67962bcc1a$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $6odr9.utcThursday)(d) : $6odr9.utcThursday.ceil(d);
    return $c436ed67962bcc1a$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c436ed67962bcc1a$var$formatUTCZone() {
    return "+0000";
}
function $c436ed67962bcc1a$var$formatLiteralPercent() {
    return "%";
}
function $c436ed67962bcc1a$var$formatUnixTimestamp(d) {
    return +d;
}
function $c436ed67962bcc1a$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRequire.register("htJCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $5A99V = parcelRequire("5A99V");
var $cb9887dbe4ab8fd5$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $cb9887dbe4ab8fd5$var$isoSpecifier;
function $cb9887dbe4ab8fd5$var$formatIsoNative(date) {
    return date.toISOString();
}
var $cb9887dbe4ab8fd5$var$formatIso = Date.prototype.toISOString ? $cb9887dbe4ab8fd5$var$formatIsoNative : (0, $5A99V.utcFormat)($cb9887dbe4ab8fd5$var$isoSpecifier);
var $cb9887dbe4ab8fd5$var$_default = $cb9887dbe4ab8fd5$var$formatIso;
module.exports.default = $cb9887dbe4ab8fd5$var$_default;

});

parcelRequire.register("6lvox", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $htJCn = parcelRequire("htJCn");

var $5A99V = parcelRequire("5A99V");
function $49ed0e9319a25be0$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $49ed0e9319a25be0$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $49ed0e9319a25be0$var$parseIsoNative : (0, $5A99V.utcParse)($htJCn.isoSpecifier);
var $49ed0e9319a25be0$var$_default = $49ed0e9319a25be0$var$parseIso;
module.exports.default = $49ed0e9319a25be0$var$_default;

});



parcelRequire.register("jPEQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e70275ae7724e43e$var$utcTime;

var $6odr9 = parcelRequire("6odr9");

var $4zL1C = parcelRequire("4zL1C");

var $gioGx = parcelRequire("gioGx");

var $55VNs = parcelRequire("55VNs");
function $e70275ae7724e43e$var$utcTime() {
    return $55VNs.initRange.apply((0, $gioGx.calendar)($6odr9.utcTicks, $6odr9.utcTickInterval, $6odr9.utcYear, $6odr9.utcMonth, $6odr9.utcWeek, $6odr9.utcDay, $6odr9.utcHour, $6odr9.utcMinute, $6odr9.utcSecond, $4zL1C.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRequire.register("iBTM9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $d8c6f28f8ef8fc2c$var$copy;
module.exports.default = $d8c6f28f8ef8fc2c$var$sequential;
module.exports.sequentialLog = $d8c6f28f8ef8fc2c$var$sequentialLog;
module.exports.sequentialPow = $d8c6f28f8ef8fc2c$var$sequentialPow;
module.exports.sequentialSqrt = $d8c6f28f8ef8fc2c$var$sequentialSqrt;
module.exports.sequentialSymlog = $d8c6f28f8ef8fc2c$var$sequentialSymlog;

var $kaKDa = parcelRequire("kaKDa");

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");

var $xqA60 = parcelRequire("xqA60");

var $fCfGa = parcelRequire("fCfGa");

var $l8UWd = parcelRequire("l8UWd");

var $6SM9G = parcelRequire("6SM9G");
function $d8c6f28f8ef8fc2c$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $lJpuv.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($kaKDa.interpolate);
    scale.rangeRound = range($kaKDa.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $d8c6f28f8ef8fc2c$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $d8c6f28f8ef8fc2c$var$sequential() {
    var scale = (0, $xqA60.linearish)($d8c6f28f8ef8fc2c$var$transformer()($lJpuv.identity));
    scale.copy = function() {
        return $d8c6f28f8ef8fc2c$var$copy(scale, $d8c6f28f8ef8fc2c$var$sequential());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $d8c6f28f8ef8fc2c$var$sequentialLog() {
    var scale = (0, $fCfGa.loggish)($d8c6f28f8ef8fc2c$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $d8c6f28f8ef8fc2c$var$copy(scale, $d8c6f28f8ef8fc2c$var$sequentialLog()).base(scale.base());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $d8c6f28f8ef8fc2c$var$sequentialSymlog() {
    var scale = (0, $l8UWd.symlogish)($d8c6f28f8ef8fc2c$var$transformer());
    scale.copy = function() {
        return $d8c6f28f8ef8fc2c$var$copy(scale, $d8c6f28f8ef8fc2c$var$sequentialSymlog()).constant(scale.constant());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $d8c6f28f8ef8fc2c$var$sequentialPow() {
    var scale = (0, $6SM9G.powish)($d8c6f28f8ef8fc2c$var$transformer());
    scale.copy = function() {
        return $d8c6f28f8ef8fc2c$var$copy(scale, $d8c6f28f8ef8fc2c$var$sequentialPow()).exponent(scale.exponent());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $d8c6f28f8ef8fc2c$var$sequentialSqrt() {
    return $d8c6f28f8ef8fc2c$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("2gaCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a554f69f2938c45$var$sequentialQuantile;

var $cyl8F = parcelRequire("cyl8F");

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");
function $1a554f69f2938c45$var$sequentialQuantile() {
    var domain = [], interpolator = $lJpuv.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $cyl8F.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($cyl8F.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $cyl8F.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $1a554f69f2938c45$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}

});

parcelRequire.register("25S8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18660bf13e4fe56d$var$diverging;
module.exports.divergingLog = $18660bf13e4fe56d$var$divergingLog;
module.exports.divergingPow = $18660bf13e4fe56d$var$divergingPow;
module.exports.divergingSqrt = $18660bf13e4fe56d$var$divergingSqrt;
module.exports.divergingSymlog = $18660bf13e4fe56d$var$divergingSymlog;

var $kaKDa = parcelRequire("kaKDa");

var $lJpuv = parcelRequire("lJpuv");

var $55VNs = parcelRequire("55VNs");

var $xqA60 = parcelRequire("xqA60");

var $fCfGa = parcelRequire("fCfGa");

var $iBTM9 = parcelRequire("iBTM9");

var $l8UWd = parcelRequire("l8UWd");

var $6SM9G = parcelRequire("6SM9G");
function $18660bf13e4fe56d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $lJpuv.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $kaKDa.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($kaKDa.interpolate);
    scale.rangeRound = range($kaKDa.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $18660bf13e4fe56d$var$diverging() {
    var scale = (0, $xqA60.linearish)($18660bf13e4fe56d$var$transformer()($lJpuv.identity));
    scale.copy = function() {
        return (0, $iBTM9.copy)(scale, $18660bf13e4fe56d$var$diverging());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $18660bf13e4fe56d$var$divergingLog() {
    var scale = (0, $fCfGa.loggish)($18660bf13e4fe56d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $iBTM9.copy)(scale, $18660bf13e4fe56d$var$divergingLog()).base(scale.base());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $18660bf13e4fe56d$var$divergingSymlog() {
    var scale = (0, $l8UWd.symlogish)($18660bf13e4fe56d$var$transformer());
    scale.copy = function() {
        return (0, $iBTM9.copy)(scale, $18660bf13e4fe56d$var$divergingSymlog()).constant(scale.constant());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $18660bf13e4fe56d$var$divergingPow() {
    var scale = (0, $6SM9G.powish)($18660bf13e4fe56d$var$transformer());
    scale.copy = function() {
        return (0, $iBTM9.copy)(scale, $18660bf13e4fe56d$var$divergingPow()).exponent(scale.exponent());
    };
    return $55VNs.initInterpolator.apply(scale, arguments);
}
function $18660bf13e4fe56d$var$divergingSqrt() {
    return $18660bf13e4fe56d$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



/* @leny/bowlstats
 *
 * /src/app.tsx
 */ var $ff8694b5d09eadad$exports = {};
"use strict";

$ff8694b5d09eadad$exports = (parcelRequire("iDBKR"));






var $08e8df0f66738cf4$export$882461b6382ed46c;
var $08e8df0f66738cf4$export$757ceba2d55c277e;
"use strict";

var $e4MuM = parcelRequire("e4MuM");
var $08e8df0f66738cf4$var$i;
$08e8df0f66738cf4$export$882461b6382ed46c = $e4MuM.createRoot;
$08e8df0f66738cf4$export$757ceba2d55c277e = $e4MuM.hydrateRoot;


/* @leny/bowlstats
 *
 * /src/containers/root.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");
var $c2acff49efc73e03$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $c2acff49efc73e03$exports) {
        classNames.default = classNames;
        $c2acff49efc73e03$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


/* @leny/bowlstats
 *
 * /src/components/header.tsx
 */ 

var $d3298d1f5bb4b7c6$exports = {};
$d3298d1f5bb4b7c6$exports = JSON.parse('{"title":"@leny/bowlstats","subtitle":"A small bowling stats tracker","goals":{"avgScorePerGame":120,"avgFirstBallPinfall":6}}');



var $fmtXm = parcelRequire("fmtXm");
var $48aeca3be9c7a936$exports = {};
"use strict";
function $48aeca3be9c7a936$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $6P6dz = parcelRequire("6P6dz");
var $48aeca3be9c7a936$var$React__default = $48aeca3be9c7a936$var$_interopDefault($6P6dz);
function $48aeca3be9c7a936$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $48aeca3be9c7a936$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $48aeca3be9c7a936$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $48aeca3be9c7a936$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $48aeca3be9c7a936$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $48aeca3be9c7a936$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($6P6dz.PureComponent);
        $48aeca3be9c7a936$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $48aeca3be9c7a936$var$_defineProperty(SideEffect, "canUseDOM", $48aeca3be9c7a936$var$canUseDOM);
        return SideEffect;
    };
}
$48aeca3be9c7a936$exports = $48aeca3be9c7a936$var$withSideEffect;


var $e0f30fdd5f4a61e6$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $e0f30fdd5f4a61e6$var$hasElementType = typeof Element !== "undefined";
var $e0f30fdd5f4a61e6$var$hasMap = typeof Map === "function";
var $e0f30fdd5f4a61e6$var$hasSet = typeof Set === "function";
var $e0f30fdd5f4a61e6$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $e0f30fdd5f4a61e6$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$e0f30fdd5f4a61e6$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($e0f30fdd5f4a61e6$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$e0f30fdd5f4a61e6$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($e0f30fdd5f4a61e6$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($e0f30fdd5f4a61e6$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($e0f30fdd5f4a61e6$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$e0f30fdd5f4a61e6$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$e0f30fdd5f4a61e6$exports = function isEqual(a, b) {
    try {
        return $e0f30fdd5f4a61e6$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $6P6dz = parcelRequire("6P6dz");
var $44af3687709a67cd$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $44af3687709a67cd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $44af3687709a67cd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $44af3687709a67cd$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $44af3687709a67cd$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $44af3687709a67cd$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$44af3687709a67cd$exports = $44af3687709a67cd$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $44af3687709a67cd$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($44af3687709a67cd$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($44af3687709a67cd$var$getOwnPropertySymbols) {
            symbols = $44af3687709a67cd$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($44af3687709a67cd$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $96d7405955789fbc$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $96d7405955789fbc$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $96d7405955789fbc$var$VALID_TAG_NAMES = Object.keys($96d7405955789fbc$var$TAG_NAMES).map(function(name) {
    return $96d7405955789fbc$var$TAG_NAMES[name];
});
var $96d7405955789fbc$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $96d7405955789fbc$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $96d7405955789fbc$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $96d7405955789fbc$var$HTML_TAG_MAP = Object.keys($96d7405955789fbc$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$96d7405955789fbc$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $96d7405955789fbc$var$SELF_CLOSING_TAGS = [
    $96d7405955789fbc$var$TAG_NAMES.NOSCRIPT,
    $96d7405955789fbc$var$TAG_NAMES.SCRIPT,
    $96d7405955789fbc$var$TAG_NAMES.STYLE
];
var $96d7405955789fbc$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $96d7405955789fbc$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $96d7405955789fbc$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $96d7405955789fbc$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $96d7405955789fbc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $96d7405955789fbc$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $96d7405955789fbc$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $96d7405955789fbc$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $96d7405955789fbc$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $96d7405955789fbc$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$TAG_NAMES.TITLE);
    var innermostTemplate = $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $96d7405955789fbc$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $96d7405955789fbc$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $96d7405955789fbc$var$_extends({}, tagAttrs, current);
    }, {});
};
var $96d7405955789fbc$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$96d7405955789fbc$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$96d7405955789fbc$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $96d7405955789fbc$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $96d7405955789fbc$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $96d7405955789fbc$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $96d7405955789fbc$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $96d7405955789fbc$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $96d7405955789fbc$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $96d7405955789fbc$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($44af3687709a67cd$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $96d7405955789fbc$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $96d7405955789fbc$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $96d7405955789fbc$var$getBaseTagFromPropsList([
            $96d7405955789fbc$var$TAG_PROPERTIES.HREF,
            $96d7405955789fbc$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $96d7405955789fbc$var$getAttributesFromPropsList($96d7405955789fbc$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$HELMET_PROPS.DEFER),
        encode: $96d7405955789fbc$var$getInnermostProperty(propsList, $96d7405955789fbc$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $96d7405955789fbc$var$getAttributesFromPropsList($96d7405955789fbc$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $96d7405955789fbc$var$getTagsFromPropsList($96d7405955789fbc$var$TAG_NAMES.LINK, [
            $96d7405955789fbc$var$TAG_PROPERTIES.REL,
            $96d7405955789fbc$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $96d7405955789fbc$var$getTagsFromPropsList($96d7405955789fbc$var$TAG_NAMES.META, [
            $96d7405955789fbc$var$TAG_PROPERTIES.NAME,
            $96d7405955789fbc$var$TAG_PROPERTIES.CHARSET,
            $96d7405955789fbc$var$TAG_PROPERTIES.HTTPEQUIV,
            $96d7405955789fbc$var$TAG_PROPERTIES.PROPERTY,
            $96d7405955789fbc$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $96d7405955789fbc$var$getTagsFromPropsList($96d7405955789fbc$var$TAG_NAMES.NOSCRIPT, [
            $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $96d7405955789fbc$var$getOnChangeClientState(propsList),
        scriptTags: $96d7405955789fbc$var$getTagsFromPropsList($96d7405955789fbc$var$TAG_NAMES.SCRIPT, [
            $96d7405955789fbc$var$TAG_PROPERTIES.SRC,
            $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $96d7405955789fbc$var$getTagsFromPropsList($96d7405955789fbc$var$TAG_NAMES.STYLE, [
            $96d7405955789fbc$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $96d7405955789fbc$var$getTitleFromPropsList(propsList),
        titleAttributes: $96d7405955789fbc$var$getAttributesFromPropsList($96d7405955789fbc$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $96d7405955789fbc$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $96d7405955789fbc$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $96d7405955789fbc$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $96d7405955789fbc$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $96d7405955789fbc$var$rafPolyfill : $parcel$global.requestAnimationFrame || $96d7405955789fbc$var$rafPolyfill;
var $96d7405955789fbc$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $96d7405955789fbc$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $96d7405955789fbc$var$cafPolyfill;
var $96d7405955789fbc$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $96d7405955789fbc$var$_helmetCallback = null;
var $96d7405955789fbc$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($96d7405955789fbc$var$_helmetCallback) $96d7405955789fbc$var$cancelAnimationFrame($96d7405955789fbc$var$_helmetCallback);
    if (newState.defer) $96d7405955789fbc$var$_helmetCallback = $96d7405955789fbc$var$requestAnimationFrame(function() {
        $96d7405955789fbc$var$commitTagChanges(newState, function() {
            $96d7405955789fbc$var$_helmetCallback = null;
        });
    });
    else {
        $96d7405955789fbc$var$commitTagChanges(newState);
        $96d7405955789fbc$var$_helmetCallback = null;
    }
};
var $96d7405955789fbc$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $96d7405955789fbc$var$updateAttributes($96d7405955789fbc$var$TAG_NAMES.BODY, bodyAttributes);
    $96d7405955789fbc$var$updateAttributes($96d7405955789fbc$var$TAG_NAMES.HTML, htmlAttributes);
    $96d7405955789fbc$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.BASE, baseTag),
        linkTags: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.LINK, linkTags),
        metaTags: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.META, metaTags),
        noscriptTags: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $96d7405955789fbc$var$updateTags($96d7405955789fbc$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $96d7405955789fbc$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $96d7405955789fbc$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $96d7405955789fbc$var$flattenArray(title);
    $96d7405955789fbc$var$updateAttributes($96d7405955789fbc$var$TAG_NAMES.TITLE, attributes);
};
var $96d7405955789fbc$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($96d7405955789fbc$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($96d7405955789fbc$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($96d7405955789fbc$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($96d7405955789fbc$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $96d7405955789fbc$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($96d7405955789fbc$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $96d7405955789fbc$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $96d7405955789fbc$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($96d7405955789fbc$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $96d7405955789fbc$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $96d7405955789fbc$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $96d7405955789fbc$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $96d7405955789fbc$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $96d7405955789fbc$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $96d7405955789fbc$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $96d7405955789fbc$var$HELMET_ATTRIBUTE + '="true">' + $96d7405955789fbc$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $96d7405955789fbc$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML || attribute === $96d7405955789fbc$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $96d7405955789fbc$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $96d7405955789fbc$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $96d7405955789fbc$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $96d7405955789fbc$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$96d7405955789fbc$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $96d7405955789fbc$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$96d7405955789fbc$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $96d7405955789fbc$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$96d7405955789fbc$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $96d7405955789fbc$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($96d7405955789fbc$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $96d7405955789fbc$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$96d7405955789fbc$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $96d7405955789fbc$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $96d7405955789fbc$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $96d7405955789fbc$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(type, mappedTag);
    });
};
var $96d7405955789fbc$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $96d7405955789fbc$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $96d7405955789fbc$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $96d7405955789fbc$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $96d7405955789fbc$var$ATTRIBUTE_NAMES.BODY:
        case $96d7405955789fbc$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $96d7405955789fbc$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $96d7405955789fbc$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $96d7405955789fbc$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $96d7405955789fbc$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $96d7405955789fbc$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.META, metaTags, encode),
        noscript: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $96d7405955789fbc$var$getMethodsForTag($96d7405955789fbc$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $96d7405955789fbc$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $96d7405955789fbc$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $96d7405955789fbc$var$classCallCheck(this, HelmetWrapper);
            return $96d7405955789fbc$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($e0f30fdd5f4a61e6$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $96d7405955789fbc$var$TAG_NAMES.SCRIPT:
                case $96d7405955789fbc$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $96d7405955789fbc$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $96d7405955789fbc$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $96d7405955789fbc$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $96d7405955789fbc$var$TAG_NAMES.TITLE:
                    return $96d7405955789fbc$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $96d7405955789fbc$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $96d7405955789fbc$var$TAG_NAMES.BODY:
                    return $96d7405955789fbc$var$_extends({}, newProps, {
                        bodyAttributes: $96d7405955789fbc$var$_extends({}, newChildProps)
                    });
                case $96d7405955789fbc$var$TAG_NAMES.HTML:
                    return $96d7405955789fbc$var$_extends({}, newProps, {
                        htmlAttributes: $96d7405955789fbc$var$_extends({}, newChildProps)
                    });
            }
            return $96d7405955789fbc$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $96d7405955789fbc$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $96d7405955789fbc$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $96d7405955789fbc$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $96d7405955789fbc$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $96d7405955789fbc$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $96d7405955789fbc$var$TAG_NAMES.LINK:
                    case $96d7405955789fbc$var$TAG_NAMES.META:
                    case $96d7405955789fbc$var$TAG_NAMES.NOSCRIPT:
                    case $96d7405955789fbc$var$TAG_NAMES.SCRIPT:
                    case $96d7405955789fbc$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $96d7405955789fbc$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $96d7405955789fbc$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(Component, newProps);
        };
        $96d7405955789fbc$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $96d7405955789fbc$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $96d7405955789fbc$var$NullComponent = function NullComponent() {
    return null;
};
var $96d7405955789fbc$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($48aeca3be9c7a936$exports)))($96d7405955789fbc$var$reducePropsToState, $96d7405955789fbc$var$handleClientStateChange, $96d7405955789fbc$var$mapStateOnServer)($96d7405955789fbc$var$NullComponent);
var $96d7405955789fbc$export$dcef8f9bb9a41431 = $96d7405955789fbc$var$Helmet($96d7405955789fbc$var$HelmetSideEffects);
$96d7405955789fbc$export$dcef8f9bb9a41431.renderStatic = $96d7405955789fbc$export$dcef8f9bb9a41431.rewind;
var $96d7405955789fbc$export$2e2bcd8739ae039 = $96d7405955789fbc$export$dcef8f9bb9a41431;


const $a59ed6e022fedf74$var$Header = ({ mode: mode, onChangeMode: onChangeMode })=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $96d7405955789fbc$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("title", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).title
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("meta", {
                        name: "description",
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("header", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero", "is-small", "is-primary"),
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero-body", "is-flex", "is-justify-content-space-between", "is-align-items-end"),
                    children: [
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex-1"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h1", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("title"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).title
                                }),
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h2", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex-1", "is-flex", "is-justify-content-center"),
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("field", "has-addons"),
                                children: [
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("control"),
                                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("button", {
                                            type: "button",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("button", "is-light", "is-small", mode !== "games" && "is-outlined", mode === "games" && "is-active"),
                                            onClick: ()=>{
                                                onChangeMode("games");
                                            },
                                            children: "Games"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("control"),
                                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("button", {
                                            type: "button",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("button", "is-light", "is-small", mode !== "leagues" && "is-outlined", mode === "leagues" && "is-active"),
                                            onClick: ()=>{
                                                onChangeMode("leagues");
                                            },
                                            children: "Leagues"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex-1")
                        })
                    ]
                })
            })
        ]
    });
var $a59ed6e022fedf74$export$2e2bcd8739ae039 = $a59ed6e022fedf74$var$Header;


/* @leny/bowlstats
 *
 * /src/containers/games.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");

/* @leny/bowlstats
 *
 * /src/components/numbers.tsx
 */ 

/* @leny/bowlstats
 *
 * /src/core/hooks/use-data.js
 */ 
var $6P6dz = parcelRequire("6P6dz");
/* @leny/bowlstats
 *
 * /src/core/data-store.ts
 */ // NOTE: this is a "static" store, as the data will not change during the app lifecycle.

var $6P6dz = parcelRequire("6P6dz");
var $b9927f3a23cabf27$exports = {};
$b9927f3a23cabf27$exports = JSON.parse('{"games":[{"id":"2023-01-17:1","date":{"year":2023,"month":1,"day":17},"ball":"H10","oilPattern":false,"frames":[{"outcome":["-",8],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",9],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":89,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":107,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":115,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":115,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-01-26:1","date":{"year":2023,"month":1,"day":26},"ball":"H10","oilPattern":false,"frames":[{"outcome":["-",9],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":26,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":33,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":59,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":59,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[1,2],"cumulative":62,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":71,"pins":64,"perfect":false,"stats":{"avgFirstBallPinfall":4.8,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":8,"fouls":0}},{"id":"2023-02-02:1","date":{"year":2023,"month":2,"day":2},"ball":"H10","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":12,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":19,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":27,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[4,"-"],"cumulative":39,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":54,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":70,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",7],"cumulative":87,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":87,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":4.7,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-02-09:1","date":{"year":2023,"month":2,"day":9},"ball":"H10","oilPattern":false,"frames":[{"outcome":["-",8],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":40,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":49,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":78,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":97,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":106,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":126,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/","-"],"cumulative":136,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"score":136,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":4,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-02-16:1","date":{"year":2023,"month":2,"day":16},"ball":"H10","oilPattern":false,"frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":23,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":32,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":61,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":80,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":98,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":118,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X",9,"/"],"cumulative":138,"score":20,"pins":10,"split":false,"spare":"single","open":false}],"score":138,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-02-27:1","date":{"year":2023,"month":2,"day":27},"ball":"H12","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",1],"cumulative":17,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":23,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":29,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":48,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":65,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":72,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":89,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"First game with 12lbs ball","score":97,"pins":74,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-03-02:1","date":{"year":2023,"month":3,"day":2},"ball":"H12","oilPattern":false,"frames":[{"outcome":[5,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":37,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":44,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":89,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":98,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":115,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":122,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":122,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-03-02:2","date":{"year":2023,"month":3,"day":2},"ball":"H12","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":37,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":55,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":83,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":101,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":109,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":115,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":122,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":125,"score":3,"pins":3,"split":false,"spare":false,"open":true}],"score":125,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":5.5,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":7,"fouls":0}},{"id":"2023-03-04:1","date":{"year":2023,"month":3,"day":4},"ball":"H12","oilPattern":false,"frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":9,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":49,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":56,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":74,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":83,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":90,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Slight leg pain","score":90,"pins":75,"perfect":false,"stats":{"avgFirstBallPinfall":5.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-04:2","date":{"year":2023,"month":3,"day":4},"ball":"H12","oilPattern":false,"frames":[{"outcome":[4,4],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":13,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":21,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":29,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":44,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":51,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":60,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":68,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/",4],"cumulative":82,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"note":"Slight leg pain","score":82,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":4.6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-06:1","date":{"year":2023,"month":3,"day":6},"ball":"H12","oilPattern":false,"frames":[{"outcome":[1,1],"cumulative":2,"score":2,"pins":2,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":9,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,5],"cumulative":22,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":37,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":42,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":49,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":65,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/"],"cumulative":79,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":87,"pins":72,"perfect":false,"stats":{"avgFirstBallPinfall":4.5,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-03-06:2","date":{"year":2023,"month":3,"day":6},"ball":"H12","oilPattern":false,"frames":[{"outcome":[3,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-","-"],"cumulative":10,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":17,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":33,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":39,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":66,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":76,"score":10,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","-"],"cumulative":76,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[1,1],"cumulative":78,"score":2,"pins":2,"split":false,"spare":false,"open":true}],"note":"First try to hook","score":78,"pins":62,"perfect":false,"stats":{"avgFirstBallPinfall":4.3,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":7,"fouls":0}},{"id":"2023-03-06:3","date":{"year":2023,"month":3,"day":6},"ball":"H12","oilPattern":false,"frames":[{"outcome":[3,"-"],"cumulative":3,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":6,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":13,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":19,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[2,6],"cumulative":27,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",1],"cumulative":28,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":34,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":34,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","/","-"],"cumulative":51,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"Second try to hook","score":51,"pins":51,"perfect":false,"stats":{"avgFirstBallPinfall":1.6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":10,"fouls":0}},{"id":"2023-03-08:1","date":{"year":2023,"month":3,"day":8},"ball":"H14","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":16,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":21,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":26,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":44,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":58,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":67,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"First training, perfect ball weight, layout too large","score":75,"pins":67,"perfect":false,"stats":{"avgFirstBallPinfall":4.7,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":9,"fouls":0}},{"id":"2023-03-08:2","date":{"year":2023,"month":3,"day":8},"ball":"H14","oilPattern":false,"frames":[{"outcome":[9,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[4,"/"],"cumulative":43,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":51,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":67,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":84,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":94,"score":1,"pins":1,"split":false,"spare":false,"open":true}],"note":"First training, perfect ball weight, layout too large","score":94,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":3,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-08:3","date":{"year":2023,"month":3,"day":8},"ball":"H14","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":29,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"/"],"cumulative":46,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":53,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":61,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":69,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[4,4],"cumulative":77,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":93,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":101,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"First training, perfect ball weight, layout too large","score":101,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-03-12:1","date":{"year":2023,"month":3,"day":12},"ball":"H14","oilPattern":false,"frames":[{"outcome":["-","/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":19,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":34,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,1],"cumulative":39,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":65,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":72,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,1],"cumulative":85,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":92,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Perfect ball weight (house ball), layout too large","score":92,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-03-12:2","date":{"year":2023,"month":3,"day":12},"ball":"H14","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":15,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":23,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":37,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,"-"],"cumulative":41,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":42,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":48,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":51,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":60,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/",9],"cumulative":79,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"note":"Perfect ball weight (house ball), layout too large","score":79,"pins":75,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":7,"fouls":0}},{"id":"2023-03-12:3","date":{"year":2023,"month":3,"day":12},"ball":"H14","oilPattern":false,"frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":37,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":56,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",7],"cumulative":63,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":72,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":79,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":86,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,"/",6],"cumulative":102,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"note":"Perfect ball weight (house ball), layout too large","score":102,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-15:1","date":{"year":2023,"month":3,"day":15},"ball":"H13","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,1],"cumulative":33,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":51,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":68,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,"-"],"cumulative":74,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":81,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",9,"-"],"cumulative":109,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"note":"Ball slightly light (house ball), good layout","score":109,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-15:2","date":{"year":2023,"month":3,"day":15},"ball":"H13","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,2],"cumulative":39,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":40,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":57,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":64,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":79,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":84,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"note":"Ball slightly light (house ball), good layout","score":84,"pins":72,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-03-15:3","date":{"year":2023,"month":3,"day":15},"ball":"H13","oilPattern":false,"frames":[{"outcome":[1,7],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":18,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[3,2],"cumulative":23,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":30,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":33,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":53,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":71,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Ball slightly light (house ball), good layout","score":88,"pins":70,"perfect":false,"stats":{"avgFirstBallPinfall":4.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-03-15:4","date":{"year":2023,"month":3,"day":15},"ball":"H13","oilPattern":false,"frames":[{"outcome":[4,3],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":10,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":19,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":24,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":43,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":61,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":66,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Ball slightly light (house ball), good layout","score":94,"pins":76,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-03-18:1","date":{"year":2023,"month":3,"day":18},"ball":"H13","oilPattern":false,"frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,1],"cumulative":10,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":17,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":48,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":63,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":71,"pins":71,"perfect":false,"stats":{"avgFirstBallPinfall":3.8,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":0,"single":0,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-03-18:2","date":{"year":2023,"month":3,"day":18},"ball":"H13","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":35,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,"/"],"cumulative":55,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":68,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"-"],"cumulative":71,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":78,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":95,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":102,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":111,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":120,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-03-18:3","date":{"year":2023,"month":3,"day":18},"ball":"H13","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":13,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":30,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,1],"cumulative":37,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":43,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":59,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":65,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":79,"score":14,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,"-"],"cumulative":83,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["-","/",6],"cumulative":99,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"score":99,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-03-18:4","date":{"year":2023,"month":3,"day":18},"ball":"H13","oilPattern":false,"frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":14,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,"/"],"cumulative":32,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":41,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"/"],"cumulative":57,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":65,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":82,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":89,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":98,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":105,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":105,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-03-20:1","date":{"year":2023,"month":3,"day":20},"ball":"H13","oilPattern":false,"frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":15,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[6,"/"],"cumulative":33,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":60,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-","/"],"cumulative":79,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":107,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":116,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":116,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":7,"fouls":0}},{"id":"2023-03-20:2","date":{"year":2023,"month":3,"day":20},"ball":"H13","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":47,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-",1],"cumulative":48,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":56,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":63,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":83,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":112,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":131,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":140,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":140,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-03-22:1","date":{"year":2023,"month":3,"day":22},"ball":"H13","oilPattern":false,"frames":[{"outcome":[1,6],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":23,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":40,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":103,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-03-22:2","date":{"year":2023,"month":3,"day":22},"ball":"H13","oilPattern":false,"frames":[{"outcome":["-",9],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":25,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":61,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,"/"],"cumulative":77,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":104,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":113,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":122,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":125,"score":3,"pins":3,"split":false,"spare":false,"open":true}],"score":125,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":5.7,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-03-22:3","date":{"year":2023,"month":3,"day":22},"ball":"H13","oilPattern":false,"frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":15,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":21,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":24,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":28,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":45,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",7,1],"cumulative":81,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":81,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-03-22:4","date":{"year":2023,"month":3,"day":22},"ball":"H13","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":22,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,4],"cumulative":29,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":57,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":73,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":79,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":99,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":115,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,3],"cumulative":124,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":124,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-03-22:5","date":{"year":2023,"month":3,"day":22},"ball":"H13","oilPattern":false,"frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":13,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":29,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":35,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,3],"cumulative":42,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":54,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",1],"cumulative":55,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":66,"score":11,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"-"],"cumulative":67,"score":1,"pins":1,"split":false,"spare":false,"open":true}],"score":67,"pins":60,"perfect":false,"stats":{"avgFirstBallPinfall":4.7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-03-24:1","date":{"year":2023,"month":3,"day":24},"ball":"H13","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",9],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":38,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",9],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":75,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":84,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":103,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":112,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":121,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":121,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-03-24:2","date":{"year":2023,"month":3,"day":24},"ball":"H13","oilPattern":false,"frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":34,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":40,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":49,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":84,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":101,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":110,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":110,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-03-24:3","date":{"year":2023,"month":3,"day":24},"ball":"H13","oilPattern":false,"frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":23,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":30,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":39,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":45,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,3],"cumulative":52,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":59,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[3,"-"],"cumulative":62,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":69,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Out of focus, loudy players on next lane (need to focus on my focus)","score":69,"pins":69,"perfect":false,"stats":{"avgFirstBallPinfall":4.8,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":0,"single":0,"multiple":0},"misses":8,"fouls":0}},{"id":"2023-03-24:4","date":{"year":2023,"month":3,"day":24},"ball":"H13","oilPattern":false,"frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":9,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":45,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":65,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":82,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":89,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":105,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-03-29:1","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":15,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":16,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":49,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":64,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/","X"],"cumulative":84,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"note":"First games with new balls","score":84,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-03-29:2","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":38,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",7],"cumulative":45,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":62,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":91,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"/","X"],"cumulative":111,"score":20,"pins":20,"split":false,"spare":"single","open":false}],"note":"First games with new balls","score":111,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2023-03-29:3","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":21,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,3],"cumulative":27,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":43,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":88,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":106,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":115,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"First games with new balls","score":115,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-03-29:4","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":18,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":31,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":40,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":76,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":83,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"First games with new balls","score":83,"pins":74,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":7,"fouls":0}},{"id":"2023-03-29:5","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":14,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":23,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":42,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":67,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,1],"cumulative":74,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"First games with new balls","score":99,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-03-29:6","date":{"year":2023,"month":3,"day":29},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[4,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":88,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":95,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"First games with new balls","score":104,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":8,"fouls":0}},{"id":"2023-04-01:1","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":15,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":28,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,5],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":46,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",3],"cumulative":49,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":65,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":72,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Long series of games in crowded lines","score":81,"pins":78,"perfect":false,"stats":{"avgFirstBallPinfall":3.9,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-04-01:2","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,3],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":25,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":75,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,1],"cumulative":81,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":86,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":93,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":111,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":119,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Long series of games in crowded lines","score":119,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-04-01:3","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[3,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":63,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":80,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":87,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":104,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":111,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",7,"/"],"cumulative":140,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"Long series of games in crowded lines","score":140,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":4,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-04-01:4","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[1,1],"cumulative":2,"score":2,"pins":2,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":18,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":24,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":40,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[5,1],"cumulative":46,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":53,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":73,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":84,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,8],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Long series of games in crowded lines","score":93,"pins":76,"perfect":false,"stats":{"avgFirstBallPinfall":4.8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-04-01:5","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":27,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":63,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":82,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":91,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":95,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":103,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":111,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Long series of games in crowded lines","score":111,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":3,"single":2,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-01:6","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":26,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-","/"],"cumulative":44,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":89,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":106,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":114,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":123,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",9],"cumulative":142,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"note":"Long series of games in crowded lines","score":142,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":5,"single":2,"multiple":3},"misses":1,"fouls":0}},{"id":"2023-04-01:7","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,1],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":13,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":21,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":40,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":49,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":59,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":65,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":82,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,1],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Long series of games in crowded lines","score":98,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-04-01:8","date":{"year":2023,"month":4,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",7],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":44,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,4],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":88,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":97,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/",4],"cumulative":119,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"note":"Long series of games in crowded lines","score":119,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-05:1","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":42,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":49,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":57,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":12,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[2,4],"cumulative":84,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":84,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-04-05:2","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":27,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":61,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":68,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":76,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":96,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"/",6],"cumulative":112,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"score":112,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-04-05:3","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":34,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":40,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":77,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"/"],"cumulative":87,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",7],"cumulative":94,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":102,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-04-05:4","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":19,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":25,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":41,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":47,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":64,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":73,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":81,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,"-"],"cumulative":86,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"score":86,"pins":73,"perfect":false,"stats":{"avgFirstBallPinfall":5,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-04-05:5","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":48,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":66,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",8],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":88,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":107,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":116,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",8],"cumulative":134,"score":18,"pins":18,"split":false,"spare":"single","open":false}],"score":134,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-05:6","date":{"year":2023,"month":4,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,"-"],"cumulative":3,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":11,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":24,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"-"],"cumulative":27,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":27,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"/"],"cumulative":64,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":76,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":79,"score":3,"pins":3,"split":false,"spare":false,"open":true}],"score":79,"pins":59,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":7,"fouls":0}},{"id":"2023-04-12:1","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":24,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":43,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":57,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,2],"cumulative":63,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":69,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":87,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":97,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":106,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":113,"score":7,"pins":7,"split":"yes","spare":false,"open":true}],"score":113,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":5,"single":2,"multiple":3},"misses":4,"fouls":0}},{"id":"2023-04-12:2","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,"/"],"cumulative":19,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,6],"cumulative":26,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":35,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":64,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":75,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,"/"],"cumulative":89,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,"-"],"cumulative":93,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"/",9],"cumulative":112,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"score":112,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":4,"single":2,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-04-12:3","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,4],"cumulative":32,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":45,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,6],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":73,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":91,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":95,"score":4,"pins":4,"split":false,"spare":false,"open":true}],"score":95,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-12:4","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[1,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":38,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,7],"cumulative":46,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":55,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":75,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":93,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":101,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":110,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":119,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":119,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-04-12:5","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":32,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,2],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":53,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":60,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":79,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/",3],"cumulative":109,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":109,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":4,"fouls":0}},{"id":"2023-04-12:6","date":{"year":2023,"month":4,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":32,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":49,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,4],"cumulative":56,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":95,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":123,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":132,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":140,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":140,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-04-15:1","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":[1,"/"],"cumulative":15,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,3],"cumulative":23,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":29,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":36,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":64,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":80,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,5],"cumulative":86,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":103,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":103,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":5.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-04-15:2","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":36,"score":16,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":42,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":76,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":84,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,1],"cumulative":90,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":99,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,4],"cumulative":104,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"note":"First converted split!","score":104,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":3,"converted":1},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-15:3","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":[1,6],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":25,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":34,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":53,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":69,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":82,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,3],"cumulative":88,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",8,1],"cumulative":115,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":115,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-04-15:4","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",9],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":29,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":49,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":75,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":91,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":97,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":112,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,2],"cumulative":118,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":119,"score":1,"pins":1,"split":false,"spare":false,"open":true}],"note":"It started so well… then I panicked.","score":119,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-04-15:5","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":69,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,"/"],"cumulative":89,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":109,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":127,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":144,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":151,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":151,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":8.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":5,"single":3,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-04-15:6","date":{"year":2023,"month":4,"day":15},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":14,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":34,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":51,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":87,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":95,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/",4],"cumulative":118,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"score":118,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-04-19:1","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":14,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":23,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":32,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":48,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":68,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":87,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":104,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":104,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-04-19:2","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":29,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":55,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":72,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":83,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,"-"],"cumulative":84,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["X",3,2],"cumulative":99,"score":15,"pins":15,"split":false,"spare":false,"open":false}],"score":99,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":5,"fouls":0}},{"id":"2023-04-19:3","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[5,2],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":49,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":55,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":75,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":94,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":106,"score":3,"pins":3,"split":false,"spare":false,"open":true}],"score":106,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-19:4","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":29,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"/"],"cumulative":40,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,2],"cumulative":43,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":51,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":67,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/"],"cumulative":84,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":92,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":101,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",9,"/"],"cumulative":121,"score":20,"pins":10,"split":false,"spare":"single","open":false}],"score":121,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-04-19:5","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,4],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":27,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":56,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":96,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":115,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":124,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":132,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-",7],"cumulative":139,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,3],"cumulative":143,"score":4,"pins":4,"split":false,"spare":false,"open":true}],"score":143,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":1,"fouls":0}},{"id":"2023-04-19:6","date":{"year":2023,"month":4,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":49,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,5],"cumulative":57,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":80,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":97,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/","-"],"cumulative":107,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"score":107,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-04-22:1","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":25,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":34,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":34,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":34,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":67,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Worst oil condition ever. Wasn\'t able to figure how to properly hook. Still a lot to learn…","score":76,"pins":59,"perfect":false,"stats":{"avgFirstBallPinfall":4.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":9,"fouls":0}},{"id":"2023-04-22:2","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"/"],"cumulative":15,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,2],"cumulative":22,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":31,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":40,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":71,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X","X",1],"cumulative":109,"score":21,"pins":21,"split":false,"spare":false,"open":false}],"score":109,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-04-22:3","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,4],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":31,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":39,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":52,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"-"],"cumulative":55,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":75,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":92,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":111,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":120,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-04-22:4","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":37,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":57,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":74,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":90,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":106,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":117,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,8],"cumulative":126,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":134,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":134,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-04-22:5","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":13,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":22,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":30,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":37,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":45,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[1,"/"],"cumulative":63,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":72,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,6],"cumulative":79,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":88,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":88,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":3,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-22:6","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",8],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":52,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":61,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":70,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":103,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",1],"cumulative":114,"score":11,"pins":11,"split":false,"spare":"multiple","open":false}],"score":114,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":4,"single":1,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-04-22:7","date":{"year":2023,"month":4,"day":22},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":22,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",3],"cumulative":25,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,5],"cumulative":57,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":64,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":71,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":78,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"The \\"I should have stopped before\\". I need to listen to my body.","score":78,"pins":75,"perfect":false,"stats":{"avgFirstBallPinfall":5.4,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-04-26:1","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":40,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":77,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,"/"],"cumulative":97,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":117,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/",7],"cumulative":134,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":134,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":3,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-04-26:2","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":55,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":73,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":105,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[3,"/",9],"cumulative":124,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":124,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":5.7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-04-26:3","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,1],"cumulative":33,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":59,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":67,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":84,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":104,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/",5],"cumulative":119,"score":15,"pins":15,"split":false,"spare":"multiple","open":false}],"score":119,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-04-26:4","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":37,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":65,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":74,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"/"],"cumulative":93,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":102,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":118,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,2],"cumulative":126,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":134,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":134,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":3,"multiple":1},"misses":1,"fouls":0}},{"id":"2023-04-26:5","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":63,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":72,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,2],"cumulative":80,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":96,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-04-26:6","date":{"year":2023,"month":4,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":55,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":73,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":82,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,1],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":97,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":113,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",8],"cumulative":131,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":131,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":1,"fouls":0}},{"id":"2023-05-01:1","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":["-","/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,1],"cumulative":30,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":45,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":64,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,6],"cumulative":73,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":88,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-","/",1],"cumulative":99,"score":11,"pins":11,"split":false,"spare":"multiple","open":false}],"note":"Bad oil (nearly dry lane) condition. Time to train position and form.","score":99,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":4.8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":7,"fouls":0}},{"id":"2023-05-01:2","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":45,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[5,3],"cumulative":53,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":59,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":87,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":105,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":113,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,"/",7],"cumulative":130,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"note":"Bad oil (nearly dry lane) condition. Time to train position and form.","score":130,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-05-01:3","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":21,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"-"],"cumulative":24,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,6],"cumulative":48,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":76,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":85,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Played only straight, with spare ball.","score":102,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-01:4","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Played only straight, with spare ball.","score":94,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.9,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":7,"fouls":0}},{"id":"2023-05-01:5","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",7],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":34,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":47,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/"],"cumulative":66,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":102,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":119,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":132,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/",5],"cumulative":147,"score":15,"pins":15,"split":false,"spare":"multiple","open":false}],"note":"Very proud of my closing, here. :)","score":147,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":5.4,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":8,"single":2,"multiple":6},"misses":2,"fouls":0}},{"id":"2023-05-01:6","date":{"year":2023,"month":5,"day":1},"ball":"14","oilPattern":false,"frames":[{"outcome":[4,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":30,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"-"],"cumulative":33,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":48,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":55,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":64,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":89,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/",6],"cumulative":105,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"note":"Slight pain at the end.","score":105,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":3.7,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":4,"single":0,"multiple":4},"misses":5,"fouls":0}},{"id":"2023-05-03:1","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-","-"],"cumulative":0,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":89,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/",4],"cumulative":103,"score":14,"pins":14,"split":false,"spare":"single","open":false}],"score":103,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-03:2","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":15,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":19,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":46,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":54,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":60,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":67,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":74,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[5,4],"cumulative":83,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.","score":83,"pins":75,"perfect":false,"stats":{"avgFirstBallPinfall":5.3,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":8,"fouls":0}},{"id":"2023-05-03:3","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,2],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":13,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":21,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":29,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":38,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":55,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":64,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":80,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",7],"cumulative":97,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"note":"Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.","score":97,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-05-03:4","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":23,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":39,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,3],"cumulative":45,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":64,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":73,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":78,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":98,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":118,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":135,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/","-"],"cumulative":145,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.","score":145,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":4,"single":1,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-05-03:5","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,1],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":32,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":41,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,"-"],"cumulative":44,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":47,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":55,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":78,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.","score":78,"pins":70,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-05-03:6","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[1,8],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":43,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":61,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":69,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":76,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":79,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":85,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Big family with kids running everywhere and on the lines. Hard to focus while watching to not kill people running in my legs.","score":94,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-05-03:7","date":{"year":2023,"month":5,"day":3},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":45,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[5,4],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":83,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":102,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":111,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/",9],"cumulative":130,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":130,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-05-07:1","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-","/"],"cumulative":24,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,4],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":40,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":47,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":47,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":50,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":75,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":75,"pins":70,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":9,"fouls":0}},{"id":"2023-05-07:2","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,5],"cumulative":33,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":66,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":72,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":81,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-05-07:3","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":46,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":79,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":86,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/",3],"cumulative":108,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":108,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-05-07:4","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,4],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":51,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":57,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":60,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":79,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",1],"cumulative":89,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":96,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":96,"pins":73,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-05-07:5","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[3,6],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":24,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"/"],"cumulative":41,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":67,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":76,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":83,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":99,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",7],"cumulative":116,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":116,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":5,"single":0,"multiple":5},"misses":4,"fouls":0}},{"id":"2023-05-07:6","date":{"year":2023,"month":5,"day":7},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,4],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":64,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":81,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":89,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":96,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":125,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/",3],"cumulative":138,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":138,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-05-10:1","date":{"year":2023,"month":5,"day":10},"ball":"14","oilPattern":false,"frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":10,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":17,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":17,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":20,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":29,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":38,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,2],"cumulative":41,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":49,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X","X",9],"cumulative":78,"score":29,"pins":29,"split":false,"spare":false,"open":false}],"note":"Really casual games, on kids\' day, with the son. Not really focused.","score":78,"pins":78,"perfect":false,"stats":{"avgFirstBallPinfall":3.8,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-05-10:2","date":{"year":2023,"month":5,"day":10},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":34,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":49,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":67,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":84,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":93,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":102,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Really casual games, on kids\' day, with the son. Not really focused.","score":102,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-05-10:3","date":{"year":2023,"month":5,"day":10},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":21,"score":15,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":26,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":43,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":61,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":79,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":91,"score":4,"pins":4,"split":false,"spare":false,"open":true}],"note":"Really casual games, on kids\' day, with the son. Not really focused.","score":91,"pins":78,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":1,"converted":1},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-05-10:4","date":{"year":2023,"month":5,"day":10},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,3],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":31,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":49,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":57,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":76,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,6],"cumulative":85,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":111,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":119,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Really casual games, on kids\' day, with the son. Not really focused.","score":119,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-05-10:5","date":{"year":2023,"month":5,"day":10},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":15,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":33,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":70,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":83,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,"-"],"cumulative":86,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[2,6],"cumulative":94,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Really casual games, on kids\' day, with the son. Not really focused.","score":103,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":5.7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-05-17:1","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",5],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":12,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":18,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,5],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":42,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":87,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":87,"pins":78,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-17:2","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":14,"score":14,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,1],"cumulative":18,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":37,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":66,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":81,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"/"],"cumulative":94,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/"],"cumulative":112,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":121,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":129,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"note":"First usage of a \\"grip glove\\" I bought","score":129,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":2,"converted":0},"strikes":3,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-05-17:3","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":32,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/"],"cumulative":43,"score":11,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[1,8],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":71,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":94,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"note":"First usage of a \\"grip glove\\" I bought","score":102,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":3,"converted":1},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-05-17:4","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":44,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":72,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":100,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/",8],"cumulative":127,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"note":"First usage of a \\"grip glove\\" I bought","score":127,"pins":100,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-05-17:5","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":63,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,2],"cumulative":72,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":91,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":100,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"First usage of a \\"grip glove\\" I bought","score":118,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8.8,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-05-17:6","date":{"year":2023,"month":5,"day":17},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",4],"cumulative":40,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":58,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":66,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"First usage of a \\"grip glove\\" I bought","score":102,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-05-21:1","date":{"year":2023,"month":5,"day":21},"ball":"14","oilPattern":false,"frames":[{"outcome":[4,4],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":14,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":15,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":24,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-",9],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":51,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":69,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",8],"cumulative":77,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":85,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":85,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-05-21:2","date":{"year":2023,"month":5,"day":21},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",9],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":51,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,3],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":84,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":100,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":106,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":115,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":115,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-05-21:3","date":{"year":2023,"month":5,"day":21},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":15,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":32,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":40,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":49,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,2],"cumulative":54,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":67,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"-"],"cumulative":70,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":89,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/","X"],"cumulative":109,"score":20,"pins":20,"split":false,"spare":"single","open":false}],"score":109,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-05-21:4","date":{"year":2023,"month":5,"day":21},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":25,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":82,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":101,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":110,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":118,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":118,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-21:5","date":{"year":2023,"month":5,"day":21},"ball":"14","oilPattern":false,"frames":[{"outcome":[7,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":36,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":43,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":63,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":86,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":104,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":112,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":132,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":161,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X",9,"/"],"cumulative":181,"score":20,"pins":10,"split":false,"spare":"single","open":false}],"score":181,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":4,"spares":{"total":5,"single":3,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-05-24:1","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,1],"cumulative":34,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":51,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":71,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":106,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X",7,"-"],"cumulative":123,"score":17,"pins":17,"split":false,"spare":false,"open":false}],"score":123,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-05-24:2","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":13,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"-"],"cumulative":16,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":43,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":71,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":89,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":98,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":98,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-05-24:3","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[3,3],"cumulative":14,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":31,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":38,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":53,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,2],"cumulative":60,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":67,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":86,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/",6],"cumulative":111,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"score":111,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-05-24:4","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":24,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":30,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":33,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":69,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":77,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":94,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":94,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-24:5","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":33,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",3],"cumulative":36,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":44,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":60,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":66,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":104,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":113,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":121,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":121,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-05-24:6","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":48,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":75,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":92,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":99,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":107,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":116,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":125,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":134,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":134,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":2,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-05-24:7","date":{"year":2023,"month":5,"day":24},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":55,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":72,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":91,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":100,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":117,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":117,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-05-28:1","date":{"year":2023,"month":5,"day":28},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":15,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":34,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":43,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":63,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":76,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/"],"cumulative":95,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":118,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,2],"cumulative":124,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":124,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-05-28:2","date":{"year":2023,"month":5,"day":28},"ball":"14","oilPattern":false,"frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":12,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":19,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":43,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,1],"cumulative":48,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":65,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":83,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/","X"],"cumulative":103,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"score":103,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-06-14:1","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":57,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":67,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":73,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":90,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":97,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["-",1],"cumulative":98,"score":1,"pins":1,"split":false,"spare":false,"open":true}],"score":98,"pins":76,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":6,"fouls":0}},{"id":"2023-06-14:2","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":22,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":42,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":59,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":66,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":10,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","-"],"cumulative":84,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":91,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/",9],"cumulative":110,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"score":110,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-06-14:3","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":23,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":30,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":34,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":42,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":79,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":97,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":105,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-06-14:4","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-","/"],"cumulative":25,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"/"],"cumulative":44,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":85,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":92,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":100,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-06-14:5","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":96,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":115,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":124,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":133,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":141,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":141,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-06-14:6","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,"/"],"cumulative":36,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":42,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":90,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":118,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":127,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":136,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":145,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":145,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":2,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-06-14:7","date":{"year":2023,"month":6,"day":14},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[5,4],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":34,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,1],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":76,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":93,"score":17,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":109,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,1],"cumulative":116,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":116,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":1,"converted":1},"strikes":0,"spares":{"total":4,"single":0,"multiple":4},"misses":2,"fouls":0}},{"id":"2023-06-21:1","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":17,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-","-"],"cumulative":17,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":22,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":29,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":36,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":71,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/","-"],"cumulative":81,"score":10,"pins":10,"split":false,"spare":"single","open":false}],"score":81,"pins":73,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":2,"single":2,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-06-21:2","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",5],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":11,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":18,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":23,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":26,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":33,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":58,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":77,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":86,"pins":71,"perfect":false,"stats":{"avgFirstBallPinfall":4.6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":7,"fouls":0}},{"id":"2023-06-21:3","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,3],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":15,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":21,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":27,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":43,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,2],"cumulative":51,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":65,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":93,"pins":78,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-06-21:4","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":50,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":80,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":108,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":127,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":136,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":137,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":144,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":153,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":153,"score":0,"pins":0,"split":false,"spare":false,"open":true}],"score":153,"pins":76,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":4,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-06-21:5","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":22,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":29,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":63,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":70,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":76,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":91,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,2],"cumulative":98,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":98,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-06-21:6","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":49,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":68,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":87,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":105,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":114,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":122,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":130,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":130,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":3,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-06-21:7","date":{"year":2023,"month":6,"day":21},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[1,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":39,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":58,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":85,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":93,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-",6],"cumulative":99,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/",8],"cumulative":117,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":117,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-06-28:1","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-","-"],"cumulative":0,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":51,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":70,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,6],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":103,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":108,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"/",5],"cumulative":123,"score":15,"pins":15,"split":false,"spare":"single","open":false}],"score":123,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-06-28:2","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":43,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":91,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":100,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":109,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[5,2],"cumulative":116,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":116,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-06-28:3","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":19,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":31,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":51,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":70,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":79,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":105,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":5.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-06-28:4","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":26,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":81,"score":17,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[7,2],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":97,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":105,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":1},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-06-28:5","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":26,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":72,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":81,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":90,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":100,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["X",9,"-"],"cumulative":119,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":119,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-06-28:6","date":{"year":2023,"month":6,"day":28},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":30,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":56,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":74,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":106,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,3],"cumulative":115,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":134,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,5],"cumulative":143,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X","X",6],"cumulative":169,"score":26,"pins":26,"split":false,"spare":false,"open":false}],"score":169,"pins":110,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":0,"converted":0},"strikes":6,"spares":{"total":1,"single":1,"multiple":0},"misses":1,"fouls":0}},{"id":"2023-07-01:1","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":55,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":64,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":84,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":113,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":132,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":141,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":150,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":159,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":159,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":8.9,"splits":{"total":0,"converted":0},"strikes":4,"spares":{"total":1,"single":1,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-07-01:2","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,4],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"/"],"cumulative":45,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":83,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":103,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":121,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":129,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":134,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"score":134,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-07-01:3","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":24,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":32,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":57,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":65,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":77,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":96,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,8],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":105,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-07-01:4","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,2],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":50,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":79,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,3],"cumulative":83,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":102,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":111,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":111,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-07-01:5","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[1,7],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":14,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":33,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":81,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":126,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":133,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":133,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-07-01:6","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":37,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":54,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":61,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":69,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":78,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":87,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":105,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":114,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":114,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-07-01:7","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,4],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":52,"score":24,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":69,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,3],"cumulative":76,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":85,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":112,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":120,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",8],"cumulative":138,"score":18,"pins":18,"split":false,"spare":"single","open":false}],"score":138,"pins":100,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":2,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-07-01:8","date":{"year":2023,"month":7,"day":1},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":14,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":33,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":51,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":60,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":87,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-",9],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":114,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":114,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-07-05:1","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":34,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":49,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":65,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":71,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":78,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/","X"],"cumulative":106,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"score":106,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-07-05:2","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,1],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":52,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":71,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":91,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":106,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",5],"cumulative":111,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":129,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":129,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-07-05:3","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":38,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":65,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,7],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":101,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":110,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":117,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":126,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":126,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-07-05:4","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":63,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":71,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[3,"/"],"cumulative":90,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":108,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":126,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":134,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/",8],"cumulative":152,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":152,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":7,"single":1,"multiple":6},"misses":2,"fouls":0}},{"id":"2023-07-05:5","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,6],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":65,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":73,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-","-"],"cumulative":73,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":96,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,1],"cumulative":101,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"score":101,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-07-05:6","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":26,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":65,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":74,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":82,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":100,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":119,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/",3],"cumulative":132,"score":13,"pins":13,"split":false,"spare":"single","open":false}],"score":132,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8.5,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":4,"single":3,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-07-05:7","date":{"year":2023,"month":7,"day":5},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":20,"score":13,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[3,5],"cumulative":28,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":36,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":53,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":60,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":67,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"/","X"],"cumulative":115,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"score":115,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":3,"converted":1},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-07-11:1","date":{"year":2023,"month":7,"day":11},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":16,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",7],"cumulative":23,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":41,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":60,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":70,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",3],"cumulative":73,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":91,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":99,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":104,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"note":"New main ball. Very hard to tame.","score":104,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":4.9,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":5,"single":1,"multiple":4},"misses":5,"fouls":0}},{"id":"2023-07-11:2","date":{"year":2023,"month":7,"day":11},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":60,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":78,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":93,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":98,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":105,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"New main ball. Very hard to tame.","score":105,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-07-12:1","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[4,"-"],"cumulative":4,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":10,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":20,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",7],"cumulative":27,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":54,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":72,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":80,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":109,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/","-"],"cumulative":119,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":119,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-07-12:2","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":31,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":39,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":45,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":62,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":82,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":100,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":108,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":108,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":4.7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-07-12:3","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",7],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":40,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,4],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":76,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":84,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":101,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":108,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":108,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-07-12:4","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,1],"cumulative":15,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":28,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,4],"cumulative":35,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":74,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":94,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":110,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":116,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":124,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":124,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":1,"single":1,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-07-12:5","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,1],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":29,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":36,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":58,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"-"],"cumulative":61,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":70,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":77,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":77,"pins":74,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":7,"fouls":0}},{"id":"2023-07-12:6","date":{"year":2023,"month":7,"day":12},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[1,"-"],"cumulative":1,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":8,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":42,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-","/"],"cumulative":59,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,1],"cumulative":90,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"note":"Still learning (hardly) to tame new main ball. Very hard to find my way.","score":90,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":4.7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-07-17:1","date":{"year":2023,"month":7,"day":17},"ball":"14","oilPattern":false,"frames":[{"outcome":["-",4],"cumulative":4,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":12,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":21,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":32,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,8],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":44,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":77,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":82,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"note":"Dry lane, trying new Turbo switchable thumb system.","score":82,"pins":73,"perfect":false,"stats":{"avgFirstBallPinfall":4.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-07-17:2","date":{"year":2023,"month":7,"day":17},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":11,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":19,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",1],"cumulative":20,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":28,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":51,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":68,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":76,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"note":"Dry lane, trying new Turbo switchable thumb system.","score":76,"pins":69,"perfect":false,"stats":{"avgFirstBallPinfall":5.7,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":9,"fouls":0}},{"id":"2023-07-17:3","date":{"year":2023,"month":7,"day":17},"ball":"14","oilPattern":false,"frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,7],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":48,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":63,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,"/"],"cumulative":78,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,3],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Dry lane, trying new Turbo switchable thumb system.","score":95,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-07-19:1","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",6],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":14,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-","/"],"cumulative":24,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-","-"],"cumulative":24,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":27,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":53,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Taming the new Turbo switchable thumb system. Swollen thumb, had a bit of a bad start.","score":80,"pins":72,"perfect":false,"stats":{"avgFirstBallPinfall":4.2,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":2,"single":0,"multiple":2},"misses":9,"fouls":0}},{"id":"2023-07-19:2","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":17,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["-","/"],"cumulative":36,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":73,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":118,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":3,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-07-19:3","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":66,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":86,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":100,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":108,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":117,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":125,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":125,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-07-19:4","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",7],"cumulative":17,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":30,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":57,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":85,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/",8],"cumulative":112,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":112,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2023-07-19:5","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":66,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":75,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":84,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":100,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/"],"cumulative":120,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":140,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/",6],"cumulative":156,"score":16,"pins":16,"split":false,"spare":"single","open":false}],"score":156,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":5,"single":2,"multiple":3},"misses":1,"fouls":0}},{"id":"2023-07-19:6","date":{"year":2023,"month":7,"day":19},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":46,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":54,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":90,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,4],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":108,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/",4],"cumulative":122,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"score":122,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-07-26:1","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":17,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":43,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":61,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":79,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,4],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":106,"score":19,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":115,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":115,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.4,"splits":{"total":2,"converted":1},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-07-26:2","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":34,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":43,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":56,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":65,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":93,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":102,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":102,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-07-26:3","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":24,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":51,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":66,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":83,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":90,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":107,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":107,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-07-26:4","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":63,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":92,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":111,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":129,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":138,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":138,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":8.4,"splits":{"total":1,"converted":0},"strikes":4,"spares":{"total":0,"single":0,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-07-26:5","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":39,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":57,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":65,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":80,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":89,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":105,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":111,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":120,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":120,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":2,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-07-26:6","date":{"year":2023,"month":7,"day":26},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":81,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",7,2],"cumulative":118,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":118,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-08-02:1","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",8],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,3],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":40,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":76,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":85,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",8,"-"],"cumulative":112,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":112,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-08-02:2","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":15,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":25,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",7],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":40,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":49,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":57,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":82,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":5.1,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":8,"fouls":0}},{"id":"2023-08-02:3","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":19,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,8],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":56,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":65,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":85,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":104,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":113,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",9],"cumulative":132,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"score":132,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":4,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-08-02:4","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":42,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,5],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":67,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":85,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":101,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":101,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-08-02:5","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":64,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":89,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":105,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":114,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":123,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":123,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-08-02:6","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":67,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":85,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":93,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":113,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":131,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":148,"score":17,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[7,2],"cumulative":157,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":157,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8.8,"splits":{"total":1,"converted":1},"strikes":3,"spares":{"total":4,"single":3,"multiple":1},"misses":1,"fouls":0}},{"id":"2023-08-02:7","date":{"year":2023,"month":8,"day":2},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":19,"score":10,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","-"],"cumulative":19,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":38,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":55,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":71,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":88,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":95,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[6,"/",3],"cumulative":108,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":108,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2023-08-09:1","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":48,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":58,"score":10,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","-"],"cumulative":58,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",8],"cumulative":92,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X","X",3],"cumulative":123,"score":23,"pins":23,"split":false,"spare":false,"open":false}],"score":123,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":0,"converted":0},"strikes":5,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-08-09:2","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-",9],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":83,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,6],"cumulative":90,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":99,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",4,5],"cumulative":118,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":118,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-08-09:3","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,"-"],"cumulative":3,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":12,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":19,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":37,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":54,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":62,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":85,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,5],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":102,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-08-09:4","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[5,"/"],"cumulative":71,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":78,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":97,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":106,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":114,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":114,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-08-09:5","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[5,4],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":15,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":24,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":40,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":50,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",3],"cumulative":53,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":72,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/",4],"cumulative":104,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"score":104,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2023-08-09:6","date":{"year":2023,"month":8,"day":9},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[3,6],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,6],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":53,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":73,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":92,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":101,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",4],"cumulative":105,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":112,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":112,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-08-16:1","date":{"year":2023,"month":8,"day":16},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":["-",7],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":17,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":30,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,5],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":58,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":75,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":94,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":109,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":109,"pins":80,"perfect":false,"stats":{"avgFirstBallPinfall":5.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-08-16:2","date":{"year":2023,"month":8,"day":16},"ball":"14","oilPattern":"Typical House Shot","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":19,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,6],"cumulative":26,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":34,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":51,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,2],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":64,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":73,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/",8],"cumulative":100,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":100,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-08-16:3","date":{"year":2023,"month":8,"day":16},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":22,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[7,1],"cumulative":30,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":64,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":71,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/",6],"cumulative":104,"score":16,"pins":16,"split":false,"spare":"multiple","open":false}],"note":"New oil pattern, trying to find my marks.","score":104,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-08-16:4","date":{"year":2023,"month":8,"day":16},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":14,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,2],"cumulative":20,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":67,"score":10,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["-",7],"cumulative":74,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":81,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":88,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":95,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":95,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-08-16:5","date":{"year":2023,"month":8,"day":16},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":25,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,8],"cumulative":43,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":51,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":65,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":93,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-08-22:1","date":{"year":2023,"month":8,"day":22},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,"/"],"cumulative":14,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,5],"cumulative":23,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":43,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":62,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":96,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":112,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":118,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":127,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":127,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-08-22:2","date":{"year":2023,"month":8,"day":22},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":16,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":24,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,1],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":14,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,3],"cumulative":50,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":69,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,6],"cumulative":78,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":95,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.1,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-08-22:3","date":{"year":2023,"month":8,"day":22},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":46,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":65,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":74,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":83,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,2],"cumulative":91,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":100,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":118,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-08-22:4","date":{"year":2023,"month":8,"day":22},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":14,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":22,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":31,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":45,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,"-"],"cumulative":49,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":68,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":77,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":93,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/",3],"cumulative":106,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":106,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":4,"single":0,"multiple":4},"misses":6,"fouls":0}},{"id":"2023-08-29:1","date":{"year":2023,"month":8,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":50,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,"/"],"cumulative":63,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/"],"cumulative":79,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":87,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":95,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/",7],"cumulative":121,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":121,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":5.4,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":0,"multiple":4},"misses":1,"fouls":0}},{"id":"2023-08-29:2","date":{"year":2023,"month":8,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,4],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":44,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":61,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":68,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":77,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":95,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":103,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":111,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":111,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-08-29:3","date":{"year":2023,"month":8,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":25,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":43,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":54,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,7],"cumulative":62,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":82,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":100,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":108,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":108,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-08-29:4","date":{"year":2023,"month":8,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,1],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":14,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[4,4],"cumulative":22,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,3],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":53,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":88,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":108,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/",8],"cumulative":126,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":126,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-08-29:5","date":{"year":2023,"month":8,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",3],"cumulative":13,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":33,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":53,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":68,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,4],"cumulative":77,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":97,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":116,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":125,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":132,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":132,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":0,"multiple":4},"misses":2,"fouls":0}},{"id":"2023-09-05:1","date":{"year":2023,"month":9,"day":5},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":35,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":52,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":59,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":89,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":116,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":136,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":156,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":176,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/",3],"cumulative":189,"score":13,"pins":13,"split":false,"spare":"multiple","open":false}],"score":189,"pins":100,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":4,"spares":{"total":5,"single":0,"multiple":5},"misses":1,"fouls":0}},{"id":"2023-09-05:2","date":{"year":2023,"month":9,"day":5},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":14,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":58,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":65,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":81,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":90,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,"/"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":118,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-09-05:3","date":{"year":2023,"month":9,"day":5},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":44,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":50,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":64,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":92,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":112,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":131,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":140,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":140,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":1,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-09-05:4","date":{"year":2023,"month":9,"day":5},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":37,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":55,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":75,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":92,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,6],"cumulative":99,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":119,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":138,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":147,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":147,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.9,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":0,"multiple":3},"misses":1,"fouls":0}},{"id":"2023-09-06:1","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":17,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":40,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":58,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":92,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":101,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":101,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":3,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-09-06:2","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":39,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":56,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":63,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"/"],"cumulative":77,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":122,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/",5],"cumulative":137,"score":15,"pins":15,"split":false,"spare":"multiple","open":false}],"score":137,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":4,"single":1,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-09-06:3","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":59,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":75,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":111,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":117,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":117,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0}},{"id":"2023-09-12:1","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":48,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":68,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":84,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":92,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":108,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,1],"cumulative":115,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":133,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":141,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":141,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":0,"multiple":4},"misses":1,"fouls":0}},{"id":"2023-09-12:2","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[1,6],"cumulative":15,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":32,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,2],"cumulative":39,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":73,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":98,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":98,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-09-12:3","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":11,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":29,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,4],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":45,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":62,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":69,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":78,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[3,3],"cumulative":84,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":92,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":92,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-09-12:4","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,6],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":34,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":54,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":73,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":82,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":106,"score":24,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":120,"score":14,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,"-"],"cumulative":124,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":132,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":132,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-09-12:5","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,5],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":63,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":79,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":88,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"/",9],"cumulative":115,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":115,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-09-12:6","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,3],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":27,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":43,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":69,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,1],"cumulative":77,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":96,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":112,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":112,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-09-12:7","date":{"year":2023,"month":9,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":24,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/"],"cumulative":42,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":80,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":113,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[3,6],"cumulative":122,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":122,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-09-19:1","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":26,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":65,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":81,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":87,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":94,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":112,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",7,"/"],"cumulative":132,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"score":132,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":3,"multiple":1},"misses":2,"fouls":0}},{"id":"2023-09-19:2","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":35,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":43,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"/"],"cumulative":91,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":109,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":117,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":126,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":126,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-09-19:3","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":48,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":68,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":85,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":92,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[6,"/"],"cumulative":108,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":117,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":134,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":154,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X",9,"/"],"cumulative":174,"score":20,"pins":10,"split":false,"spare":"single","open":false}],"score":174,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":6,"single":2,"multiple":4},"misses":1,"fouls":0}},{"id":"2023-09-19:4","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":45,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":73,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":91,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":99,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":108,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":108,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":7.9,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-09-19:5","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":25,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":78,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":84,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":102,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":102,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-09-19:6","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,3],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":34,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,1],"cumulative":42,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":49,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":66,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":80,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",8,"/"],"cumulative":116,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"score":116,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-09-19:7","date":{"year":2023,"month":9,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,6],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":20,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,6],"cumulative":27,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":53,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":73,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":88,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":93,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":100,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":118,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-09-20:1","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,"-"],"cumulative":24,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":49,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":66,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":83,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":103,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":120,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":127,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":127,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":0,"multiple":4},"misses":2,"fouls":0}},{"id":"2023-09-20:2","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":24,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,1],"cumulative":31,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":40,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":64,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/",1],"cumulative":109,"score":11,"pins":11,"split":false,"spare":"single","open":false}],"score":109,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-09-20:3","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["-","/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":40,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":58,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":75,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,"-"],"cumulative":80,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":98,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":107,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":124,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":124,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-10-10:1","date":{"year":2023,"month":10,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,4],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"-"],"cumulative":11,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":20,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":29,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":45,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":51,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":81,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":111,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":134,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X",3,6],"cumulative":153,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"note":"First games after health issues & recovery","score":153,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":1,"converted":0},"strikes":4,"spares":{"total":1,"single":1,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-10-10:2","date":{"year":2023,"month":10,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":46,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,"/"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":99,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,2],"cumulative":107,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":125,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":133,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"First games after health issues & recovery","score":133,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2023-10-10:3","date":{"year":2023,"month":10,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":44,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":50,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":65,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":82,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":102,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":119,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,2],"cumulative":126,"score":7,"pins":7,"split":"yes","spare":false,"open":true}],"note":"First games after health issues & recovery","score":126,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-10-10:4","date":{"year":2023,"month":10,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":33,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":40,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":49,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":64,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,2],"cumulative":69,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":76,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":96,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":113,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":120,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"note":"First games after health issues & recovery","score":120,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":4,"fouls":0}},{"id":"2023-10-10:5","date":{"year":2023,"month":10,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":36,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":54,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":65,"score":11,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[1,7],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":92,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":101,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":110,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":127,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/","-"],"cumulative":137,"score":10,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"First games after health issues & recovery","score":137,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":1,"converted":1},"strikes":0,"spares":{"total":7,"single":2,"multiple":5},"misses":2,"fouls":0}},{"id":"2023-10-11:1","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":25,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":59,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":67,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":94,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":121,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":130,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":130,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-10-11:2","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":29,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":58,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":77,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":94,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[6,"/"],"cumulative":120,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":128,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":128,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-10-11:3","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":19,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,5],"cumulative":25,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":61,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,2],"cumulative":69,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":89,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":107,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",8],"cumulative":115,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":123,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":123,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-10-18:1","date":{"year":2023,"month":10,"day":18},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":52,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":60,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":78,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":105,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":114,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":114,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-10-18:2","date":{"year":2023,"month":10,"day":18},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":52,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["-",8],"cumulative":60,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":67,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":85,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":105,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":125,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","/",7],"cumulative":142,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":142,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":6.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":0,"multiple":3},"misses":4,"fouls":0}},{"id":"2023-10-18:3","date":{"year":2023,"month":10,"day":18},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":54,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":108,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/",9],"cumulative":127,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":127,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-10-18:4","date":{"year":2023,"month":10,"day":18},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":25,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,8],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":70,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,1],"cumulative":78,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":84,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":100,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":106,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":106,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2023-11-07:1","date":{"year":2023,"month":11,"day":7},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":55,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":73,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",8],"cumulative":81,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":118,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":118,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-11-07:2","date":{"year":2023,"month":11,"day":7},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":46,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":64,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":80,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":96,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":104,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":104,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-11-07:3","date":{"year":2023,"month":11,"day":7},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":33,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,3],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":60,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":68,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":83,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,4],"cumulative":92,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":110,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/",9],"cumulative":129,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":129,"pins":102,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":5,"single":1,"multiple":4},"misses":3,"fouls":0}},{"id":"2023-11-07:4","date":{"year":2023,"month":11,"day":7},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":56,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":65,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":83,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,7],"cumulative":91,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":91,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":110,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":119,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":119,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2023-11-28:1","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["-","/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":39,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":56,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":63,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":21,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":97,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,2],"cumulative":100,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":107,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":125,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":134,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":134,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.4,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-11-28:2","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":42,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":59,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":75,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":94,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":110,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X",6,"-"],"cumulative":126,"score":16,"pins":16,"split":false,"spare":false,"open":false}],"score":126,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-11-28:3","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":49,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":69,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":84,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,"-"],"cumulative":89,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":96,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":114,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":122,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":127,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":136,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":136,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2023-11-28:4","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":26,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":34,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":42,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":71,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":89,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":106,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":125,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":134,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":134,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":4,"fouls":0}},{"id":"2023-11-28:5","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":46,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":66,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":83,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,2],"cumulative":92,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":99,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":108,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":117,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":124,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":124,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":2,"multiple":0},"misses":2,"fouls":0}},{"id":"2023-11-28:6","date":{"year":2023,"month":11,"day":28},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":33,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":77,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":96,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":113,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":113,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":3,"converted":0},"strikes":0,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-11-29:1","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,2],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":12,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":21,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":28,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":43,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",5],"cumulative":48,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":64,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":70,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":88,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":96,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":96,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0}},{"id":"2023-11-29:2","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":56,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":95,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":111,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":117,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":126,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":126,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-11-29:3","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":53,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":62,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":76,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,"-"],"cumulative":80,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":100,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X",7,"/"],"cumulative":120,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"score":120,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-12-12:1","date":{"year":2023,"month":12,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":80,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",7,2],"cumulative":116,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":116,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2023-12-12:2","date":{"year":2023,"month":12,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":11,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":31,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":50,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":68,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,"/"],"cumulative":78,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",8],"cumulative":86,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":104,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-12-12:3","date":{"year":2023,"month":12,"day":12},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"-"],"cumulative":20,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":30,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":36,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":54,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":73,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":82,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":89,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":94,"score":5,"pins":5,"split":false,"spare":false,"open":true}],"score":94,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2023-12-13:1","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":29,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":48,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":75,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":83,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":90,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":127,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/",7],"cumulative":144,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":144,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2023-12-13:2","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":63,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":72,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":88,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":113,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":120,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[5,"/",7],"cumulative":137,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":137,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":1,"fouls":0}},{"id":"2023-12-13:3","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[1,4],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":12,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":30,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":55,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":91,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X",1,7],"cumulative":109,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":109,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2023-12-19:1","date":{"year":2023,"month":12,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":37,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":45,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":51,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":68,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":75,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":94,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":112,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",5],"cumulative":127,"score":15,"pins":15,"split":false,"spare":"single","open":false}],"score":127,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":0}},{"id":"2023-12-19:2","date":{"year":2023,"month":12,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,4],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":33,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":58,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":84,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":100,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":106,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":115,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":115,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":4,"single":1,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-12-19:3","date":{"year":2023,"month":12,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":46,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":55,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,"/"],"cumulative":71,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":89,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":117,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":136,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/",9],"cumulative":155,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"score":155,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":5,"single":2,"multiple":3},"misses":3,"fouls":0}},{"id":"2023-12-19:4","date":{"year":2023,"month":12,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":27,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":44,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":51,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":65,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":83,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":91,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":100,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",8,"-"],"cumulative":118,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":118,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":3,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":5,"fouls":0}},{"id":"2023-12-29:1","date":{"year":2023,"month":12,"day":29},"ball":"14","oilPattern":false,"frames":[{"outcome":["-","-"],"cumulative":0,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":44,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[4,1],"cumulative":49,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[2,1],"cumulative":52,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":["-",6],"cumulative":58,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Really casual games, with the kid, on completely dry lane","score":76,"pins":67,"perfect":false,"stats":{"avgFirstBallPinfall":3.9,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":0,"single":0,"multiple":0},"misses":3,"fouls":0}},{"id":"2023-12-29:2","date":{"year":2023,"month":12,"day":29},"ball":"14","oilPattern":false,"frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":["-",9],"cumulative":15,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":35,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":51,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":57,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":65,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":74,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":83,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":92,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Really casual games, with the kid, on completely dry lane","score":100,"pins":84,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":6,"fouls":0}},{"id":"2023-12-29:3","date":{"year":2023,"month":12,"day":29},"ball":"14","oilPattern":false,"frames":[{"outcome":[9,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":50,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":75,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",7],"cumulative":82,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":90,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,1],"cumulative":96,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/",8],"cumulative":114,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"note":"Really casual games, with the kid, on completely dry lane","score":114,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":5,"fouls":0}},{"id":"2024-01-10:1","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":33,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":39,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":58,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":113,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":122,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":122,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-01-10:2","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":44,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":50,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[3,5],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":83,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":89,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/",1],"cumulative":108,"score":11,"pins":11,"split":false,"spare":"single","open":false}],"score":108,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-01-10:3","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":36,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":42,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":80,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":98,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":106,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"F"],"cumulative":114,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":123,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",8],"cumulative":141,"score":18,"pins":18,"split":false,"spare":"single","open":false}],"score":141,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":3,"converted":0},"strikes":2,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":1}},{"id":"2024-01-25:1","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,5],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":44,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":89,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":98,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",6],"cumulative":114,"score":16,"pins":16,"split":false,"spare":"single","open":false}],"score":114,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2024-01-25:2","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":73,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":93,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":112,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":121,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":130,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":139,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":148,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":148,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8.9,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2024-01-25:3","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":15,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,"/"],"cumulative":34,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":51,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":67,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":85,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":94,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":121,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/",9],"cumulative":140,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":140,"pins":102,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":6,"single":1,"multiple":5},"misses":1,"fouls":0}},{"id":"2024-01-30:1","date":{"year":2024,"month":1,"day":30},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":38,"score":18,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[8,1],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":53,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":91,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":110,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":119,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"/",7],"cumulative":136,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":136,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":2,"converted":1},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2024-01-30:2","date":{"year":2024,"month":1,"day":30},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":67,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":87,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":107,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":122,"score":15,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[5,4],"cumulative":131,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":140,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[5,4],"cumulative":149,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":149,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":1,"multiple":2},"misses":0,"fouls":0}},{"id":"2024-01-30:3","date":{"year":2024,"month":1,"day":30},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":48,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":68,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":86,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":95,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":111,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":130,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":139,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"score":139,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2024-01-30:4","date":{"year":2024,"month":1,"day":30},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":34,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":50,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":56,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":75,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":84,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":102,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":111,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/",9],"cumulative":130,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":130,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":2,"multiple":2},"misses":4,"fouls":0}},{"id":"2024-02-06:1","date":{"year":2024,"month":2,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"/"],"cumulative":45,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":70,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,1],"cumulative":77,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":96,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,8],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":123,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":131,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":131,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":1,"fouls":0}},{"id":"2024-02-06:2","date":{"year":2024,"month":2,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":26,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":45,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",3],"cumulative":66,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":75,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":115,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/","X"],"cumulative":135,"score":20,"pins":20,"split":"converted","spare":"multiple","open":false}],"score":135,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":1,"converted":1},"strikes":2,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2024-02-06:3","date":{"year":2024,"month":2,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,3],"cumulative":25,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,3],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":61,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":81,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":92,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,"/"],"cumulative":112,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":132,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/",8],"cumulative":150,"score":18,"pins":18,"split":false,"spare":"multiple","open":false}],"score":150,"pins":103,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":5,"single":2,"multiple":3},"misses":1,"fouls":0}},{"id":"2024-02-06:4","date":{"year":2024,"month":2,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":13,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,"/"],"cumulative":33,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":51,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":59,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":77,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":104,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":113,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":121,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":128,"score":7,"pins":7,"split":"yes","spare":false,"open":true}],"score":128,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2024-02-06:5","date":{"year":2024,"month":2,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":41,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":61,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":79,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":87,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":94,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":110,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":110,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0}},{"id":"2024-03-19:1","date":{"year":2024,"month":3,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[1,5],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":14,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":32,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,7],"cumulative":40,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":56,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":86,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":95,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":104,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Back to training after a few weeks, after a crooked ankle.","score":104,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":5.8,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-03-19:2","date":{"year":2024,"month":3,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":25,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":33,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":48,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":65,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":85,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":104,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":113,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Back to training after a few weeks, after a crooked ankle.","score":113,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":6,"fouls":0}},{"id":"2024-03-19:3","date":{"year":2024,"month":3,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":65,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":74,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":93,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":110,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":129,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":148,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":157,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Back to training after a few weeks, after a crooked ankle.","score":157,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":0}},{"id":"2024-03-19:4","date":{"year":2024,"month":3,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":22,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":30,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":39,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":65,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":85,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":102,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":111,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":130,"score":19,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[9,"/",9],"cumulative":149,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"note":"Back to training after a few weeks, after a crooked ankle.","score":149,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":2,"converted":1},"strikes":3,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2024-03-19:5","date":{"year":2024,"month":3,"day":19},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":38,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":57,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":86,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":104,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":112,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":131,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":140,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":149,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Back to training after a few weeks, after a crooked ankle.","score":149,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":8.8,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-03-26:1","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"/"],"cumulative":10,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":16,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":23,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":42,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":51,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":58,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":104,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":123,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/",7],"cumulative":140,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":140,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-03-26:2","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":27,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":55,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":73,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":93,"score":20,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":["X"],"cumulative":112,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":121,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":141,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/","X"],"cumulative":161,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"score":161,"pins":106,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":2,"converted":1},"strikes":4,"spares":{"total":4,"single":0,"multiple":4},"misses":1,"fouls":0}},{"id":"2024-03-26:3","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":27,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":35,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":70,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":78,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":96,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":104,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":112,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":112,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":1,"multiple":0},"misses":4,"fouls":0}},{"id":"2024-03-26:4","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":26,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":44,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":60,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":69,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":78,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":97,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":106,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":114,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":114,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-03-26:5","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":34,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":52,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":72,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":114,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,1],"cumulative":120,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":120,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-03-26:6","date":{"year":2024,"month":3,"day":26},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":26,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":33,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":50,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":57,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":73,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":79,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":98,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":107,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X",8,"-"],"cumulative":125,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":125,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":4,"single":4,"multiple":0},"misses":5,"fouls":0}},{"id":"2024-04-10:1","date":{"year":2024,"month":4,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":26,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":35,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":52,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,3],"cumulative":59,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":70,"score":11,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"-"],"cumulative":71,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":80,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",1,2],"cumulative":101,"score":13,"pins":13,"split":false,"spare":false,"open":false}],"score":101,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-04-10:2","date":{"year":2024,"month":4,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":38,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":58,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":77,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":97,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,"/"],"cumulative":117,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":136,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":145,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":145,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":3,"single":0,"multiple":3},"misses":4,"fouls":0}},{"id":"2024-04-10:3","date":{"year":2024,"month":4,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":46,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":61,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,3],"cumulative":69,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":87,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":95,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":111,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"/",9],"cumulative":130,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":130,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-04-10:4","date":{"year":2024,"month":4,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":26,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":35,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":54,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":74,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":92,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":107,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X",6,"-"],"cumulative":123,"score":16,"pins":16,"split":false,"spare":false,"open":false}],"score":123,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":2,"multiple":0},"misses":3,"fouls":0}},{"id":"2024-04-17:1","date":{"year":2024,"month":4,"day":17},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":26,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":34,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[1,6],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":52,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,4],"cumulative":57,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":90,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":90,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":2,"fouls":0}},{"id":"2024-04-17:2","date":{"year":2024,"month":4,"day":17},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":53,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":91,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":121,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X","X",9],"cumulative":150,"score":29,"pins":29,"split":false,"spare":false,"open":false}],"score":150,"pins":111,"perfect":false,"stats":{"avgFirstBallPinfall":9,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":2,"multiple":0},"misses":6,"fouls":0}},{"id":"2024-04-17:3","date":{"year":2024,"month":4,"day":17},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":25,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":43,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":51,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":70,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":79,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":99,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-","/"],"cumulative":119,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X","X",9],"cumulative":148,"score":29,"pins":29,"split":false,"spare":false,"open":false}],"score":148,"pins":111,"perfect":false,"stats":{"avgFirstBallPinfall":7.2,"splits":{"total":2,"converted":0},"strikes":5,"spares":{"total":1,"single":0,"multiple":1},"misses":1,"fouls":0}},{"id":"2024-04-17:4","date":{"year":2024,"month":4,"day":17},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":21,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,"/"],"cumulative":40,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":49,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":63,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":80,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":87,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":107,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X",1,8],"cumulative":126,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"score":126,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":4,"single":2,"multiple":2},"misses":4,"fouls":0}},{"id":"2024-04-17:5","date":{"year":2024,"month":4,"day":17},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"/"],"cumulative":18,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,"/"],"cumulative":43,"score":16,"pins":10,"split":"converted","spare":"multiple","open":false},{"outcome":[6,3],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":68,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":74,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":94,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,"/"],"cumulative":109,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,"-"],"cumulative":114,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":123,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":123,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":2,"converted":1},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":2,"fouls":0}},{"id":"2024-04-23:1","date":{"year":2024,"month":4,"day":23},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":33,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":50,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":58,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[1,7],"cumulative":66,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":75,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":81,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":90,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/","X"],"cumulative":110,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"score":110,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2024-04-23:2","date":{"year":2024,"month":4,"day":23},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":48,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":68,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":87,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":113,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":121,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":128,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X",9,"/"],"cumulative":148,"score":20,"pins":10,"split":false,"spare":"single","open":false}],"score":148,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":8.6,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":4,"single":3,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-04-23:3","date":{"year":2024,"month":4,"day":23},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":15,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":23,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":41,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":49,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":74,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":80,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":88,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",5,3],"cumulative":106,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":106,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.3,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2024-04-23:4","date":{"year":2024,"month":4,"day":23},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":16,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":22,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":39,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"-"],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":54,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":63,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":83,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":101,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":109,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":118,"pins":87,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":4,"fouls":0}},{"id":"2024-05-14:1","date":{"year":2024,"month":5,"day":14},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[3,6],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":9,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,3],"cumulative":22,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":40,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":57,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",5],"cumulative":77,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":84,"score":7,"pins":7,"split":"yes","spare":false,"open":true}],"score":84,"pins":71,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}},{"id":"2024-05-14:2","date":{"year":2024,"month":5,"day":14},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,"-"],"cumulative":4,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":23,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":41,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":49,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"/"],"cumulative":74,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":91,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":111,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":130,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":139,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":139,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":5,"single":2,"multiple":3},"misses":4,"fouls":0}},{"id":"2024-05-14:3","date":{"year":2024,"month":5,"day":14},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":51,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":57,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":74,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":82,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":97,"score":15,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[5,3],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":112,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":129,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":129,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0}},{"id":"2024-05-14:4","date":{"year":2024,"month":5,"day":14},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,2],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":25,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,2],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":39,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":48,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":64,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":77,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,4],"cumulative":84,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/",9],"cumulative":103,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":103,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":1,"converted":0},"strikes":0,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-05-21:1","date":{"year":2024,"month":5,"day":21},"ball":"14","oilPattern":"Ratio 3 / 42ft","frames":[{"outcome":["-",8],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":26,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":46,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":72,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":92,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":110,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/"],"cumulative":128,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":136,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":145,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":154,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, new urethane ball","score":154,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":4,"single":0,"multiple":4},"misses":3,"fouls":0}},{"id":"2024-05-21:2","date":{"year":2024,"month":5,"day":21},"ball":"14","oilPattern":"Ratio 3 / 42ft","frames":[{"outcome":["X"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":36,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":63,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":71,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[3,"-"],"cumulative":74,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":92,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":117,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"note":"New oil pattern, new urethane ball","score":117,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":7.8,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2024-05-21:3","date":{"year":2024,"month":5,"day":21},"ball":"14","oilPattern":"Ratio 3 / 42ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,"-"],"cumulative":14,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":20,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":27,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":45,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":61,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[1,"-"],"cumulative":62,"score":1,"pins":1,"split":false,"spare":false,"open":true},{"outcome":["-",9],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"Slight left leg pain","score":71,"pins":71,"perfect":false,"stats":{"avgFirstBallPinfall":5.5,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":0,"single":0,"multiple":0},"misses":8,"fouls":0}},{"id":"2024-06-12:1","date":{"year":2024,"month":6,"day":12},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[4,3],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,1],"cumulative":30,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":45,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":61,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,1],"cumulative":68,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":75,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":98,"score":23,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X",3,"/"],"cumulative":118,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"note":"New oil pattern, challenging to find my spot","score":118,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":2,"fouls":0}},{"id":"2024-06-12:2","date":{"year":2024,"month":6,"day":12},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":[7,"/"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":49,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":55,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":73,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":81,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","-"],"cumulative":81,"score":0,"pins":0,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":100,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, challenging to find my spot","score":109,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":6,"fouls":0}},{"id":"2024-06-12:3","date":{"year":2024,"month":6,"day":12},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":34,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,1],"cumulative":41,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":48,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":65,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":71,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,2],"cumulative":77,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"New oil pattern, challenging to find my spot","score":85,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":5.2,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-06-12:4","date":{"year":2024,"month":6,"day":12},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":14,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[4,3],"cumulative":21,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":29,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":37,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":44,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":28,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":107,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, challenging to find my spot","score":107,"pins":81,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":5,"fouls":0}},{"id":"2024-06-12:5","date":{"year":2024,"month":6,"day":12},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":24,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":33,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":42,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":59,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":66,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":75,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":84,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":93,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/","X"],"cumulative":113,"score":20,"pins":20,"split":false,"spare":"single","open":false}],"note":"New oil pattern, challenging to find my spot","score":113,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":8.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":7,"fouls":0}},{"id":"2024-06-26:1","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":65,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":83,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",6],"cumulative":89,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":105,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/","X"],"cumulative":125,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"note":"New oil pattern, next year league pattern","score":125,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":4,"single":1,"multiple":3},"misses":5,"fouls":0}},{"id":"2024-06-26:2","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":29,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":47,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":55,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":74,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":83,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":101,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":109,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":126,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,2],"cumulative":135,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, next year league pattern","score":135,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":1,"multiple":3},"misses":4,"fouls":0}},{"id":"2024-06-26:3","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":65,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":73,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,"/"],"cumulative":92,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":108,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":114,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":123,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":140,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"note":"New oil pattern, next year league pattern","score":140,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":6,"single":5,"multiple":1},"misses":4,"fouls":0}},{"id":"2024-06-26:4","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":37,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":45,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":54,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":74,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":94,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":114,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":143,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":162,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":171,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, next year league pattern","score":171,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":9,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":4,"single":3,"multiple":1},"misses":3,"fouls":0}},{"id":"2024-06-26:5","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":22,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,"/"],"cumulative":32,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",9],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":50,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":59,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":87,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":96,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":105,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"New oil pattern, next year league pattern","score":105,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2024-06-26:6","date":{"year":2024,"month":6,"day":26},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":39,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/"],"cumulative":58,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":84,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,1],"cumulative":92,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":109,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":116,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X",8,"-"],"cumulative":134,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"note":"New oil pattern, next year league pattern","score":134,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":4,"fouls":0}},{"id":"2024-07-09:1","date":{"year":2024,"month":7,"day":9},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[1,6],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":13,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":21,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,5],"cumulative":30,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":49,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":58,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":78,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":98,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":128,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X","X","X"],"cumulative":158,"score":30,"pins":30,"split":false,"spare":false,"open":false}],"note":"Still need to tame this pattern","score":158,"pins":109,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":0,"converted":0},"strikes":5,"spares":{"total":2,"single":2,"multiple":0},"misses":3,"fouls":0}},{"id":"2024-07-09:2","date":{"year":2024,"month":7,"day":9},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"-"],"cumulative":53,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":69,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":86,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":102,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":110,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":118,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X",9,"-"],"cumulative":137,"score":19,"pins":19,"split":false,"spare":false,"open":false}],"note":"Still need to tame this pattern","score":137,"pins":100,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":4,"single":0,"multiple":4},"misses":2,"fouls":0}},{"id":"2024-07-09:3","date":{"year":2024,"month":7,"day":9},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":14,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":21,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":37,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":43,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[5,1],"cumulative":49,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":57,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":77,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":90,"score":13,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[3,3],"cumulative":96,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"note":"Still need to tame this pattern","score":96,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0}},{"id":"2024-07-09:4","date":{"year":2024,"month":7,"day":9},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[7,1],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":16,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":25,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":32,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":41,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":54,"score":13,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,2],"cumulative":57,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":66,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":82,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,1],"cumulative":88,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"note":"Still need to tame this pattern","score":88,"pins":79,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":0,"single":0,"multiple":0},"misses":1,"fouls":0}},{"id":"2024-08-13:1","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[1,5],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":15,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":24,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":43,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":52,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":59,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":66,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[3,5],"cumulative":74,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":81,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/","X"],"cumulative":101,"score":20,"pins":20,"split":false,"spare":"multiple","open":false}],"note":"Back to training after a lot of pro work","score":101,"pins":92,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":2,"single":1,"multiple":1},"misses":5,"fouls":0}},{"id":"2024-08-13:2","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":64,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":83,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":92,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,2],"cumulative":99,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":108,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"/",4],"cumulative":122,"score":14,"pins":14,"split":false,"spare":"multiple","open":false}],"note":"Back to training after a lot of pro work","score":122,"pins":95,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":0,"multiple":3},"misses":2,"fouls":0}},{"id":"2024-08-13:3","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":35,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"-"],"cumulative":42,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":60,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":68,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":77,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[1,7],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":103,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":111,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Back to training after a lot of pro work","score":111,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":3,"single":0,"multiple":3},"misses":6,"fouls":0}},{"id":"2024-08-13:4","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":38,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,1],"cumulative":46,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":65,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":74,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":92,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":120,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":139,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,1],"cumulative":148,"score":9,"pins":9,"split":"yes","spare":false,"open":true}],"note":"Back to training after a lot of pro work","score":148,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":8.9,"splits":{"total":2,"converted":0},"strikes":4,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0}},{"id":"2024-08-13:5","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":40,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":60,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":78,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":87,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":107,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":125,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":133,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":142,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",9],"cumulative":161,"score":19,"pins":19,"split":false,"spare":"single","open":false}],"note":"Back to training after a lot of pro work","score":161,"pins":105,"perfect":false,"stats":{"avgFirstBallPinfall":9,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":4,"single":3,"multiple":1},"misses":2,"fouls":0}},{"id":"2024-08-13:6","date":{"year":2024,"month":8,"day":13},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[9,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"-"],"cumulative":28,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":56,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[4,5],"cumulative":65,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":74,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":82,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":102,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":119,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":126,"score":7,"pins":7,"split":"yes","spare":false,"open":true}],"note":"Back to training after a lot of pro work","score":126,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":3,"converted":0},"strikes":2,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0}},{"id":"2024-09-12:1","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":55,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":64,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":93,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":112,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":121,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":140,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/",7],"cumulative":157,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"note":"Fist match of the new league season","score":157,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0}},{"id":"2024-09-12:2","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":40,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":60,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":80,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":109,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":128,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":137,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":146,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":154,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":162,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Fist match of the new league season","score":162,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":8.8,"splits":{"total":1,"converted":0},"strikes":4,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0}},{"id":"2024-09-12:3","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,7],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":81,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,2],"cumulative":84,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":92,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Fist match of the new league season","score":100,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":3,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":3,"fouls":0}},{"id":"2024-09-24:1","date":{"year":2024,"month":9,"day":24},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[5,"-"],"cumulative":5,"score":5,"pins":5,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":25,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":35,"score":10,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["-",8],"cumulative":43,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":72,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":92,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":109,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":127,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":135,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":143,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":143,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":1,"multiple":2},"misses":4,"fouls":0}},{"id":"2024-09-24:2","date":{"year":2024,"month":9,"day":24},"ball":"14","oilPattern":"42\\"","frames":[{"outcome":["-",9],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",8],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":30,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,6],"cumulative":39,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":46,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":55,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":74,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":83,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":92,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"note":"I\'m really bad at adapting to never-saw oiling patterns","score":92,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":3.6,"splits":{"total":0,"converted":0},"strikes":0,"spares":{"total":1,"single":0,"multiple":1},"misses":5,"fouls":0}},{"id":"2024-09-24:3","date":{"year":2024,"month":9,"day":24},"ball":"14","oilPattern":"Bourbon","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":25,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":34,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":39,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":46,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":59,"score":13,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[3,6],"cumulative":68,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":77,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":85,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"note":"Yep, really bad at adapting to oiling patterns","score":85,"pins":82,"perfect":false,"stats":{"avgFirstBallPinfall":6.5,"splits":{"total":3,"converted":0},"strikes":0,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0}}],"leagues":[{"name":"ILB Trio League 2024-2025","days":[{"dayIndex":2,"date":{"year":2024,"month":9,"day":12},"bye":false,"team":"2B1P","vs":"Terrassements Charlier","avg":123,"handicap":87,"oilPatterns":["Stone Street","Stone Street"],"games":[{"id":"2024-09-12:1","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,1],"cumulative":16,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":36,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"/"],"cumulative":55,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":64,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":93,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":112,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":121,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":140,"score":19,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[9,"/",7],"cumulative":157,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"note":"Fist match of the new league season","score":244,"pins":101,"perfect":false,"stats":{"avgFirstBallPinfall":8.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":3,"single":2,"multiple":1},"misses":2,"fouls":0},"handicap":87,"scratch":157},{"id":"2024-09-12:2","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":40,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":60,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":80,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":109,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":128,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":137,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":146,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":154,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":162,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Fist match of the new league season","score":249,"pins":94,"perfect":false,"stats":{"avgFirstBallPinfall":8.8,"splits":{"total":1,"converted":0},"strikes":4,"spares":{"total":2,"single":1,"multiple":1},"misses":2,"fouls":0},"handicap":87,"scratch":162},{"id":"2024-09-12:3","date":{"year":2024,"month":9,"day":12},"ball":"14","oilPattern":"Stone Street","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":36,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":44,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[1,7],"cumulative":70,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":81,"score":11,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[1,2],"cumulative":84,"score":3,"pins":3,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":92,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":100,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"note":"Fist match of the new league season","score":187,"pins":83,"perfect":false,"stats":{"avgFirstBallPinfall":6.9,"splits":{"total":3,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":3,"fouls":0},"handicap":87,"scratch":100}]}]},{"name":"ILB Trio League 2023-2024","days":[{"dayIndex":1,"date":{"year":2023,"month":9,"day":6},"bye":false,"team":"The Barlos","vs":"Plastidor","avg":160,"handicap":40,"note":"Avg is fixed to 160 as it\'s my first league participation.","oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2023-09-06:1","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":17,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"-"],"cumulative":25,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":32,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":40,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":58,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"-"],"cumulative":66,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":84,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":92,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":101,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":141,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":3,"converted":0},"strikes":1,"spares":{"total":1,"single":1,"multiple":0},"misses":5,"fouls":0},"handicap":40,"scratch":101},{"id":"2023-09-06:2","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[5,"/"],"cumulative":19,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":39,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":56,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":63,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[7,"/"],"cumulative":77,"score":14,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[4,4],"cumulative":85,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":94,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":122,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/",5],"cumulative":137,"score":15,"pins":15,"split":false,"spare":"multiple","open":false}],"score":177,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":7.4,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":4,"single":1,"multiple":3},"misses":2,"fouls":0},"handicap":40,"scratch":137},{"id":"2023-09-06:3","date":{"year":2023,"month":9,"day":6},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":16,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":35,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":44,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[5,3],"cumulative":52,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-",7],"cumulative":59,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":75,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":111,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",6],"cumulative":117,"score":6,"pins":6,"split":false,"spare":false,"open":true}],"score":157,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.2,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":5,"fouls":0},"handicap":40,"scratch":117}]},{"dayIndex":2,"date":{"year":2023,"month":9,"day":13},"bye":true,"team":"The Barlos","vs":"Atelier du charpentier","note":"Player rotation, didn\'t play that match.","games":[]},{"dayIndex":3,"date":{"year":2023,"month":9,"day":20},"bye":false,"team":"The Barlos","vs":"Lambdas","avg":150.4,"handicap":59,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2023-09-20:1","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,1],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":18,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,"-"],"cumulative":24,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":32,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":49,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":66,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":83,"score":17,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[7,"/"],"cumulative":103,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":120,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":127,"score":7,"pins":7,"split":false,"spare":false,"open":true}],"score":186,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":4,"single":0,"multiple":4},"misses":2,"fouls":0},"handicap":59,"scratch":127},{"id":"2023-09-20:2","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,"-"],"cumulative":7,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":24,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,1],"cumulative":31,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":40,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":48,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":64,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":72,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":90,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[3,5],"cumulative":98,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/",1],"cumulative":109,"score":11,"pins":11,"split":false,"spare":"single","open":false}],"score":168,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7.5,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0},"handicap":59,"scratch":109},{"id":"2023-09-20:3","date":{"year":2023,"month":9,"day":20},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["-","/"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":40,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":58,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":75,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[5,"-"],"cumulative":80,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":89,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":98,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[6,3],"cumulative":107,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/",7],"cumulative":124,"score":17,"pins":17,"split":false,"spare":"single","open":false}],"score":183,"pins":96,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0},"handicap":59,"scratch":124}]},{"dayIndex":3,"date":{"year":2023,"month":9,"day":27},"bye":true,"team":"The Barlos","vs":"Le Beau Vivier","note":"Player rotation, didn\'t play that match.","games":[]},{"dayIndex":4,"date":{"year":2023,"month":10,"day":4},"bye":true,"team":"The Barlos","vs":"Terrassements Charlier","note":"Health issue, on recovery.","games":[]},{"dayIndex":5,"date":{"year":2023,"month":10,"day":11},"bye":false,"team":"The Barlos","vs":"C. Sauvage infirmi\xe8re","avg":144.7,"handicap":65,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2023-10-11:1","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[7,2],"cumulative":9,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,"-"],"cumulative":16,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":41,"score":25,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":59,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[5,3],"cumulative":67,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":76,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":94,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,"/"],"cumulative":121,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":130,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":195,"pins":90,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0},"handicap":65,"scratch":130},{"id":"2023-10-11:2","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":17,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":24,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["-",5],"cumulative":29,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":58,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":77,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":86,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":94,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":102,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[6,"/"],"cumulative":120,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":128,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":193,"pins":85,"perfect":false,"stats":{"avgFirstBallPinfall":7.6,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0},"handicap":65,"scratch":128},{"id":"2023-10-11:3","date":{"year":2023,"month":10,"day":11},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":19,"score":11,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[1,5],"cumulative":25,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":61,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,2],"cumulative":69,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":89,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":107,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",8],"cumulative":115,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"-"],"cumulative":123,"score":8,"pins":8,"split":false,"spare":false,"open":true}],"score":188,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":7,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":1,"multiple":1},"misses":3,"fouls":0},"handicap":65,"scratch":123}]},{"dayIndex":11,"date":{"year":2023,"month":11,"day":29},"bye":false,"team":"The Barlos","vs":"Atelier du Charpentier","avg":141.9,"handicap":68,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2023-11-29:1","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,2],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[3,3],"cumulative":12,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":21,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,4],"cumulative":28,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":43,"score":15,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["-",5],"cumulative":48,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":64,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":70,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":88,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":96,"score":8,"pins":8,"split":"yes","spare":false,"open":true}],"score":164,"pins":77,"perfect":false,"stats":{"avgFirstBallPinfall":5.6,"splits":{"total":1,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":4,"fouls":0},"handicap":68,"scratch":96},{"id":"2023-11-29:2","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":27,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":36,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":56,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X"],"cumulative":76,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":95,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":111,"score":16,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[6,"-"],"cumulative":117,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":126,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":194,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":0,"converted":0},"strikes":1,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0},"handicap":68,"scratch":126},{"id":"2023-11-29:3","date":{"year":2023,"month":11,"day":29},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[9,"-"],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":18,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":27,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":["X"],"cumulative":45,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":53,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,2],"cumulative":62,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/"],"cumulative":76,"score":14,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[4,"-"],"cumulative":80,"score":4,"pins":4,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":100,"score":20,"pins":10,"split":false,"spare":"single","open":false},{"outcome":["X",7,"/"],"cumulative":120,"score":20,"pins":10,"split":false,"spare":"multiple","open":false}],"score":188,"pins":88,"perfect":false,"stats":{"avgFirstBallPinfall":8.2,"splits":{"total":2,"converted":0},"strikes":2,"spares":{"total":3,"single":2,"multiple":1},"misses":3,"fouls":0},"handicap":68,"scratch":120}]},{"dayIndex":13,"date":{"year":2023,"month":12,"day":13},"bye":false,"team":"The Barlos","vs":"Le Beau Vivier","avg":136.8,"handicap":73,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2023-12-13:1","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":29,"score":29,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":48,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":57,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":75,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,2],"cumulative":83,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":90,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":109,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":118,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":127,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,"/",7],"cumulative":144,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":217,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.3,"splits":{"total":0,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":4,"fouls":0},"handicap":73,"scratch":144},{"id":"2023-12-13:2","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,3],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":17,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":44,"score":27,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":63,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,2],"cumulative":72,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":88,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,2],"cumulative":96,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":113,"score":17,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"-"],"cumulative":120,"score":7,"pins":7,"split":"yes","spare":false,"open":true},{"outcome":[5,"/",7],"cumulative":137,"score":17,"pins":17,"split":false,"spare":"multiple","open":false}],"score":210,"pins":98,"perfect":false,"stats":{"avgFirstBallPinfall":7.1,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":2,"single":0,"multiple":2},"misses":1,"fouls":0},"handicap":73,"scratch":137},{"id":"2023-12-13:3","date":{"year":2023,"month":12,"day":13},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[1,4],"cumulative":5,"score":5,"pins":5,"split":false,"spare":false,"open":true},{"outcome":[1,6],"cumulative":12,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":30,"score":18,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[8,"-"],"cumulative":38,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":47,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":55,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":63,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,2],"cumulative":71,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["-","/"],"cumulative":91,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X",1,7],"cumulative":109,"score":18,"pins":18,"split":false,"spare":false,"open":false}],"score":182,"pins":91,"perfect":false,"stats":{"avgFirstBallPinfall":5.9,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":1,"single":0,"multiple":1},"misses":3,"fouls":0},"handicap":73,"scratch":109}]},{"dayIndex":15,"date":{"year":2024,"month":1,"day":10},"bye":false,"team":"The Barlos","vs":"C. Sauvage infirmi\xe8re","avg":136.8,"handicap":73,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2024-01-10:1","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[5,4],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":33,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":39,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[7,"/"],"cumulative":58,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,1],"cumulative":75,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":95,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[7,"/"],"cumulative":113,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":122,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":195,"pins":89,"perfect":false,"stats":{"avgFirstBallPinfall":7.7,"splits":{"total":0,"converted":0},"strikes":2,"spares":{"total":2,"single":0,"multiple":2},"misses":3,"fouls":0},"handicap":73,"scratch":122},{"id":"2024-01-10:2","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":28,"score":20,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":["X"],"cumulative":44,"score":16,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"-"],"cumulative":50,"score":6,"pins":6,"split":"yes","spare":false,"open":true},{"outcome":[3,5],"cumulative":58,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":67,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[3,"/"],"cumulative":83,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":89,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[4,4],"cumulative":97,"score":8,"pins":8,"split":false,"spare":false,"open":true},{"outcome":[9,"/",1],"cumulative":108,"score":11,"pins":11,"split":false,"spare":"single","open":false}],"score":181,"pins":86,"perfect":false,"stats":{"avgFirstBallPinfall":6.3,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":3,"single":1,"multiple":2},"misses":3,"fouls":0},"handicap":73,"scratch":108},{"id":"2024-01-10:3","date":{"year":2024,"month":1,"day":10},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":["X"],"cumulative":20,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":36,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"-"],"cumulative":42,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":62,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"/"],"cumulative":80,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,"/"],"cumulative":98,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"-"],"cumulative":106,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[8,"F"],"cumulative":114,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":123,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",8],"cumulative":141,"score":18,"pins":18,"split":false,"spare":"single","open":false}],"score":214,"pins":99,"perfect":false,"stats":{"avgFirstBallPinfall":8.1,"splits":{"total":3,"converted":0},"strikes":2,"spares":{"total":4,"single":2,"multiple":2},"misses":2,"fouls":1},"handicap":73,"scratch":141}]},{"dayIndex":17,"date":{"year":2024,"month":1,"day":25},"bye":false,"team":"The Barlos","vs":"Lessimat","avg":135.4,"handicap":74,"oilPatterns":["Ratio 5 / 43ft","Ratio 5 / 43ft"],"games":[{"id":"2024-01-25:1","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[4,5],"cumulative":9,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":28,"score":19,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[9,"-"],"cumulative":37,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[7,"-"],"cumulative":44,"score":7,"pins":7,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":53,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[6,3],"cumulative":62,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":71,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"/"],"cumulative":89,"score":18,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[8,1],"cumulative":98,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[9,"/",6],"cumulative":114,"score":16,"pins":16,"split":false,"spare":"single","open":false}],"score":188,"pins":97,"perfect":false,"stats":{"avgFirstBallPinfall":8,"splits":{"total":1,"converted":0},"strikes":1,"spares":{"total":2,"single":2,"multiple":0},"misses":4,"fouls":0},"handicap":74,"scratch":114},{"id":"2024-01-25:2","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[8,"-"],"cumulative":8,"score":8,"pins":8,"split":"yes","spare":false,"open":true},{"outcome":[9,"-"],"cumulative":17,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":["X"],"cumulative":47,"score":30,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":73,"score":26,"pins":10,"split":false,"spare":false,"open":false},{"outcome":["X"],"cumulative":93,"score":20,"pins":10,"split":false,"spare":false,"open":false},{"outcome":[6,"/"],"cumulative":112,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"-"],"cumulative":121,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":130,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":139,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[9,"-"],"cumulative":148,"score":9,"pins":9,"split":false,"spare":false,"open":true}],"score":222,"pins":93,"perfect":false,"stats":{"avgFirstBallPinfall":8.9,"splits":{"total":1,"converted":0},"strikes":3,"spares":{"total":1,"single":0,"multiple":1},"misses":6,"fouls":0},"handicap":74,"scratch":148},{"id":"2024-01-25:3","date":{"year":2024,"month":1,"day":25},"ball":"14","oilPattern":"Ratio 5 / 43ft","frames":[{"outcome":[6,"-"],"cumulative":6,"score":6,"pins":6,"split":false,"spare":false,"open":true},{"outcome":[8,1],"cumulative":15,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[1,"/"],"cumulative":34,"score":19,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[9,"/"],"cumulative":51,"score":17,"pins":10,"split":false,"spare":"single","open":false},{"outcome":[7,"/"],"cumulative":67,"score":16,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[6,"/"],"cumulative":85,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,1],"cumulative":94,"score":9,"pins":9,"split":"yes","spare":false,"open":true},{"outcome":[7,2],"cumulative":103,"score":9,"pins":9,"split":false,"spare":false,"open":true},{"outcome":[8,"/"],"cumulative":121,"score":18,"pins":10,"split":false,"spare":"multiple","open":false},{"outcome":[8,"/",9],"cumulative":140,"score":19,"pins":19,"split":false,"spare":"multiple","open":false}],"score":214,"pins":102,"perfect":false,"stats":{"avgFirstBallPinfall":6.8,"splits":{"total":2,"converted":0},"strikes":0,"spares":{"total":6,"single":1,"multiple":5},"misses":1,"fouls":0},"handicap":74,"scratch":140}]}]}]}');


const $7b5212127b697ff5$var$allGames = (0, (/*@__PURE__*/$parcel$interopDefault($b9927f3a23cabf27$exports))).games;
const $7b5212127b697ff5$var$avgReducer = (acc, game)=>acc + game.score;
const $7b5212127b697ff5$var$pinsReducer = (acc, game)=>acc + game.pins;
const $7b5212127b697ff5$var$absDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg);
const $7b5212127b697ff5$var$stdDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg) ** 2;
const $7b5212127b697ff5$var$bestReducer = (acc, game)=>Math.max(acc, game.score);
const $7b5212127b697ff5$var$worstReducer = (acc, game)=>Math.min(acc, game.score);
const $7b5212127b697ff5$var$strikesReducer = (acc, game)=>acc + game.stats.strikes;
const $7b5212127b697ff5$var$sparesReducer = (acc, game)=>acc + game.stats.spares.total;
const $7b5212127b697ff5$var$avgFBPReducer = (acc, game)=>acc + game.stats.avgFirstBallPinfall;
const $7b5212127b697ff5$export$431f78a03a8ddc84 = (year = null, month = null, day = null, withHouseBallGames = true, withDryLaneGames = true)=>{
    const filteredGames = $7b5212127b697ff5$var$allGames.filter((game)=>withHouseBallGames ? true : !game.ball.startsWith("H")).filter((game)=>withDryLaneGames ? true : !!game.oilPattern);
    const games = filteredGames.filter((game)=>year === null ? true : game.date.year === year && (month === null ? true : game.date.month === month && (day === null ? true : game.date.day === day)));
    const avg = Math.round(games.reduce($7b5212127b697ff5$var$avgReducer, 0) / games.length);
    return {
        games: games,
        leagues: (0, (/*@__PURE__*/$parcel$interopDefault($b9927f3a23cabf27$exports))).leagues,
        filters: {
            year: year,
            month: month,
            day: day,
            lists: {
                years: filteredGames.reduce((acc, game)=>{
                    const set = new Set(acc);
                    set.add(game.date.year);
                    return Array.from(set);
                }, []),
                months: Array.from(new Array(12).keys()).filter((mnth)=>!!filteredGames.find((game)=>game.date.year === year && game.date.month === mnth + 1)),
                days: filteredGames.filter((game)=>game.date.year === year && game.date.month === month).reduce((acc, game)=>Array.from(new Set(acc).add(game.date.day)), [])
            },
            withHouseBallGames: withHouseBallGames,
            withDryLaneGames: withDryLaneGames
        },
        stats: {
            games: games.length,
            pins: games.reduce($7b5212127b697ff5$var$pinsReducer, 0),
            avg: {
                value: avg,
                best: games.reduce($7b5212127b697ff5$var$bestReducer, 0),
                worst: games.reduce($7b5212127b697ff5$var$worstReducer, 300),
                stdDeviation: +Math.sqrt(games.reduce($7b5212127b697ff5$var$stdDeviationReducer(avg), 0) / games.length).toFixed(2),
                absDeviation: +(games.reduce($7b5212127b697ff5$var$absDeviationReducer(avg), 0) / avg).toFixed(2)
            },
            strikes: {
                value: +(games.reduce($7b5212127b697ff5$var$strikesReducer, 0) / (games.length * 12) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.strikes)) / 12 * 100).toFixed(2)
            },
            spares: {
                value: +(games.reduce($7b5212127b697ff5$var$sparesReducer, 0) / (games.length * 10) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.spares.total)) / 10 * 100).toFixed(2)
            },
            avgFirstBallPinfall: {
                value: +(games.reduce($7b5212127b697ff5$var$avgFBPReducer, 0) / games.length).toFixed(2),
                best: +Math.max(...games.map((game)=>game.stats.avgFirstBallPinfall)).toFixed(2)
            }
        }
    };
};
const $7b5212127b697ff5$export$129055f0840a203c = (0, $6P6dz.createContext)($7b5212127b697ff5$export$431f78a03a8ddc84(true));
const $7b5212127b697ff5$export$b514f4c5cf6dd8e6 = $7b5212127b697ff5$export$129055f0840a203c.Provider;


const $2cbc9a738009361c$export$c1cf1cf4c5d51937 = ()=>(0, $6P6dz.useContext)((0, $7b5212127b697ff5$export$129055f0840a203c));



const $d1d8966ef2294ff3$var$BSP = " ";
const $d1d8966ef2294ff3$var$Numbers = ()=>{
    const { stats: stats } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("level", "is-align-items-start"),
        children: [
            [
                "Games",
                stats.games
            ],
            [
                "Avg Score",
                stats.avg.value,
                stats.avg.best,
                stats.avg.stdDeviation,
                (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgScorePerGame
            ],
            [
                "Avg First Ball Pinfall",
                stats.avgFirstBallPinfall.value,
                stats.avgFirstBallPinfall.best,
                null,
                (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgFirstBallPinfall
            ],
            [
                "Strikes",
                `${stats.strikes.value}%`,
                `${stats.strikes.best}%`
            ],
            [
                "Spares",
                `${stats.spares.value}%`,
                `${stats.spares.best}%`
            ],
            [
                "Pins",
                stats.pins
            ]
        ].map(([label, value, best, stdDeviation, goal])=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("level-item", "has-text-centered"),
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("p", {
                            className: "heading",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("p", {
                            className: "title",
                            children: value
                        }),
                        !!(goal && value) && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-6"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "goal:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                    className: value >= goal ? "has-text-success" : "has-text-danger",
                                    children: goal
                                })
                            ]
                        }),
                        !!stdDeviation && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "std. deviation:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                    className: "has-text-info",
                                    children: stdDeviation
                                })
                            ]
                        }),
                        !!best && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "best:"
                                }),
                                $d1d8966ef2294ff3$var$BSP,
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("strong", {
                                    className: "has-text-success",
                                    children: [
                                        " ",
                                        best,
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, label))
    });
};
var $d1d8966ef2294ff3$export$2e2bcd8739ae039 = $d1d8966ef2294ff3$var$Numbers;


/* @leny/bowlstats
 *
 * /src/components/filters.tsx
 */ 



var $6P6dz = parcelRequire("6P6dz");
/* @leny/bowlstats
 *
 * /src/core/utils.ts
 */ /* eslint-disable @typescript-eslint/no-unused-expressions */ const $a6962441c258f009$export$2fc09de897439556 = (outcome, isLastFrame = false)=>{
    if (!isLastFrame) {
        if (outcome.includes("X") || outcome.includes("/")) return 10;
        return outcome.reduce((acc, ball)=>acc + (typeof ball === "number" ? ball : 0), 0);
    }
    let pinsCount = 0;
    const [one, two, three] = outcome;
    if (one === "X") pinsCount += 10;
    else if (typeof one === "number" && two !== "/" && three !== "/") pinsCount += one;
    if (two === "/" || two === "X") pinsCount += 10;
    else if (typeof two === "number" && three !== "/") pinsCount += two;
    if (three === "/" || three === "X") pinsCount += 10;
    else if (typeof three === "number") pinsCount += three;
    return pinsCount;
};
const $a6962441c258f009$export$fa3b29edae795ef4 = (handler, stopPropagation = false)=>(e)=>{
        e.preventDefault();
        stopPropagation && e.stopPropagation();
        handler(e);
    };


var $6ba96707cbb0ec33$exports = {};
!function(t, e) {
    $6ba96707cbb0ec33$exports = e();
}($6ba96707cbb0ec33$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof b;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new b(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var b = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, f = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(f), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return O.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return O.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return O.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = O.p(d), m = w(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return O.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : O.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), _ = b.prototype;
    return w.prototype = _, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        _[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});


const $af6a744d86cd9c4a$var$currentYear = new Date().getFullYear();
const $af6a744d86cd9c4a$var$currentMonth = new Date().getMonth();
const $af6a744d86cd9c4a$var$NBSP = "\xa0";
const $af6a744d86cd9c4a$var$Filters = ({ year: year, month: month, day: day, withHouseBallGames: withHouseBallGames, withDryLaneGames: withDryLaneGames, onYearChange: onYearChange, onMonthChange: onMonthChange, onDayChange: onDayChange, toggleHouseBallGames: toggleHouseBallGames, toggleDryLaneGames: toggleDryLaneGames })=>{
    const { filters: filters } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const years = (0, $6P6dz.useMemo)(()=>[
            "All",
            ...filters.lists.years.reverse()
        ], [
        filters
    ]);
    const months = (0, $6P6dz.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.months
        ];
    }, [
        year,
        filters
    ]);
    const days = (0, $6P6dz.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.days
        ];
    }, [
        year,
        filters
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("columns"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-four-fifths"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("tabs", "is-large"),
                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                            children: years.map((yr)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("li", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))((year === null && yr === "All" || year === yr) && "is-active"),
                                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                                        href: "#",
                                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                            onYearChange(yr === "All" ? null : yr);
                                            onMonthChange(null);
                                            onDayChange(null);
                                        }),
                                        children: yr
                                    })
                                }, yr))
                        })
                    }),
                    year !== null && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("tabs"),
                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                            children: months.map((i)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("li", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))((i === "All" && month === null || i + 1 === month) && "is-active"),
                                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("px-3"),
                                        href: "#",
                                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                            onMonthChange(i === "All" ? null : i + 1);
                                            onDayChange(null);
                                        }),
                                        children: i === "All" ? "All" : (0, (/*@__PURE__*/$parcel$interopDefault($6ba96707cbb0ec33$exports)))().set("month", i).format("MMM")
                                    })
                                }, i))
                        })
                    }),
                    year !== null && month !== null && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("tabs", "is-small"),
                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                            children: days.map((i)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("li", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))((i === "All" && day === null || i === day) && "is-active"),
                                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("px-1"),
                                        href: "#",
                                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                            onDayChange(i === "All" ? null : i);
                                        }),
                                        children: i === "All" ? "All" : `${i}`.padStart(2, "0")
                                    })
                                }, i))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("form", {
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("pt-4"),
                    children: [
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("field", "mb-0", "is-flex", "is-flex-direction-row", "is-justify-content-flex-start", "is-align-items-center"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("input", {
                                    type: "checkbox",
                                    id: "withHouseBallGames",
                                    name: "withHouseBallGames",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("switch", "is-small", "is-rounded"),
                                    checked: withHouseBallGames,
                                    onChange: ()=>toggleHouseBallGames(!withHouseBallGames)
                                }),
                                $af6a744d86cd9c4a$var$NBSP,
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("label", {
                                    htmlFor: "withHouseBallGames",
                                    children: "Include House Ball Games"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("field", "mb-0", "is-flex", "is-flex-direction-row", "is-justify-content-flex-start", "is-align-items-center"),
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("input", {
                                    type: "checkbox",
                                    id: "withDryLaneGames",
                                    name: "withDryLaneGames",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("switch", "is-small", "is-rounded"),
                                    checked: withDryLaneGames,
                                    onChange: ()=>{
                                        toggleDryLaneGames(!withDryLaneGames);
                                    }
                                }),
                                $af6a744d86cd9c4a$var$NBSP,
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("label", {
                                    htmlFor: "withDryLaneGames",
                                    children: "Include Dry Lanes Games"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $af6a744d86cd9c4a$export$2e2bcd8739ae039 = $af6a744d86cd9c4a$var$Filters;


/* @leny/bowlstats
 *
 * /src/components/games.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $6P6dz = parcelRequire("6P6dz");


/* @leny/bowlstats
 *
 * /src/components/game.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");

/* @leny/bowlstats
 *
 * /src/components/game-frames.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.

/* @leny/bowlstats
 *
 * /src/components/game-frame-outcome.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $6P6dz = parcelRequire("6P6dz");

const $2df78ca71bd51dd2$var$NBSP = "\xa0";
const $2df78ca71bd51dd2$var$ballStyles = {
    marginTop: -1,
    marginRight: -1,
    marginLeft: "auto"
};
const $2df78ca71bd51dd2$var$GameFrameOutcome = ({ frame: frame, lastFrame: lastFrame, compact: compact = false })=>{
    // convert the outcome tuple to an array of strings
    const frameOutcome = (0, $6P6dz.useMemo)(()=>{
        let outcome = frame.outcome;
        if (lastFrame) {
            if (outcome.length === 2) outcome.push($2df78ca71bd51dd2$var$NBSP);
        } else if (outcome.length === 1 && outcome[0] === "X") outcome = [
            $2df78ca71bd51dd2$var$NBSP,
            "X"
        ];
        return outcome;
    }, [
        frame
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("table", {
        style: $2df78ca71bd51dd2$var$ballStyles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("table", "is-bordered"),
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("tr", {
                children: frameOutcome.map((outcome, index)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-family-monospace", "is-size-7", "py-1", "px-1", outcome === "X" && "has-text-success", outcome === "/" && "has-text-info", outcome === "F" && "has-text-danger", outcome === "-" && "has-text-danger", frame.split && index === 0 && "is-split-frame"),
                        children: outcome
                    }, index))
            })
        })
    });
};
var $2df78ca71bd51dd2$export$2e2bcd8739ae039 = $2df78ca71bd51dd2$var$GameFrameOutcome;



const $9ea79497e4749eac$var$GameFrames = ({ frames: frames, scratch: scratch, handicap: handicap, score: score, compact: compact = false, hideHeader: hideHeader = false })=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("table", "is-bordered", "is-fullwidth", `mb-${compact ? 0 : 4}`),
        children: [
            !hideHeader && (compact || /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("tr", {
                    children: [
                        Array.from(new Array(10).keys()).map((i)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("th", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                                width: i === 9 ? "11.25%" : "8.6%",
                                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                    children: i + 1
                                })
                            }, i)),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("th", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                            width: "11.2%",
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                children: scratch ? "Result" : ""
                            })
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("tr", {
                    children: [
                        frames.map((frame, index)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("td", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("p-0", "pb-1"),
                                width: index === 9 ? "11.25%" : "8.6%",
                                children: [
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-right", "mb-2"),
                                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $2df78ca71bd51dd2$export$2e2bcd8739ae039), {
                                            frame: frame,
                                            lastFrame: index === 9,
                                            compact: compact
                                        })
                                    }),
                                    compact || /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-centered", "is-block", "has-text-grey"),
                                        children: frame.cumulative
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-vcentered", "is-size-5", "has-text-centered", "has-text-weight-medium", scratch ? [
                                "pb-1",
                                "pt-0",
                                "pr-0",
                                "pl-2"
                            ] : compact && [
                                "py-1",
                                "px-2"
                            ]),
                            width: "11.2%",
                            children: [
                                scratch && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-right", "mb-2"),
                                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $2df78ca71bd51dd2$export$2e2bcd8739ae039), {
                                        frame: {
                                            outcome: [
                                                scratch,
                                                handicap || 0
                                            ]
                                        },
                                        compact: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))(scratch && "pr-2"),
                                    children: score
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
var $9ea79497e4749eac$export$2e2bcd8739ae039 = $9ea79497e4749eac$var$GameFrames;


/* @leny/bowlstats
 *
 * /src/components/game-stats.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");

var $781ef3fa3ce926da$exports = {};
var $51a3f16199173b7d$exports = {};
var $f2f45a50d52ee367$exports = {};

var $lb3R3 = parcelRequire("lb3R3");
/** Built-in value references. */ var $f2f45a50d52ee367$var$Symbol = $lb3R3.Symbol;
$f2f45a50d52ee367$exports = $f2f45a50d52ee367$var$Symbol;


var $8d4bc2b01feb0f32$exports = {};

/** Used for built-in method references. */ var $8d4bc2b01feb0f32$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d4bc2b01feb0f32$var$hasOwnProperty = $8d4bc2b01feb0f32$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8d4bc2b01feb0f32$var$nativeObjectToString = $8d4bc2b01feb0f32$var$objectProto.toString;
/** Built-in value references. */ var $8d4bc2b01feb0f32$var$symToStringTag = $f2f45a50d52ee367$exports ? $f2f45a50d52ee367$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8d4bc2b01feb0f32$var$getRawTag(value) {
    var isOwn = $8d4bc2b01feb0f32$var$hasOwnProperty.call(value, $8d4bc2b01feb0f32$var$symToStringTag), tag = value[$8d4bc2b01feb0f32$var$symToStringTag];
    try {
        value[$8d4bc2b01feb0f32$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8d4bc2b01feb0f32$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8d4bc2b01feb0f32$var$symToStringTag] = tag;
        else delete value[$8d4bc2b01feb0f32$var$symToStringTag];
    }
    return result;
}
$8d4bc2b01feb0f32$exports = $8d4bc2b01feb0f32$var$getRawTag;


var $88d79c0db2366142$exports = {};
/** Used for built-in method references. */ var $88d79c0db2366142$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $88d79c0db2366142$var$nativeObjectToString = $88d79c0db2366142$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $88d79c0db2366142$var$objectToString(value) {
    return $88d79c0db2366142$var$nativeObjectToString.call(value);
}
$88d79c0db2366142$exports = $88d79c0db2366142$var$objectToString;


/** `Object#toString` result references. */ var $51a3f16199173b7d$var$nullTag = "[object Null]", $51a3f16199173b7d$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $51a3f16199173b7d$var$symToStringTag = $f2f45a50d52ee367$exports ? $f2f45a50d52ee367$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $51a3f16199173b7d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $51a3f16199173b7d$var$undefinedTag : $51a3f16199173b7d$var$nullTag;
    return $51a3f16199173b7d$var$symToStringTag && $51a3f16199173b7d$var$symToStringTag in Object(value) ? $8d4bc2b01feb0f32$exports(value) : $88d79c0db2366142$exports(value);
}
$51a3f16199173b7d$exports = $51a3f16199173b7d$var$baseGetTag;


var $3175370e2388d115$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3175370e2388d115$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$3175370e2388d115$exports = $3175370e2388d115$var$isObject;


/** `Object#toString` result references. */ var $781ef3fa3ce926da$var$asyncTag = "[object AsyncFunction]", $781ef3fa3ce926da$var$funcTag = "[object Function]", $781ef3fa3ce926da$var$genTag = "[object GeneratorFunction]", $781ef3fa3ce926da$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $781ef3fa3ce926da$var$isFunction(value) {
    if (!$3175370e2388d115$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $51a3f16199173b7d$exports(value);
    return tag == $781ef3fa3ce926da$var$funcTag || tag == $781ef3fa3ce926da$var$genTag || tag == $781ef3fa3ce926da$var$asyncTag || tag == $781ef3fa3ce926da$var$proxyTag;
}
$781ef3fa3ce926da$exports = $781ef3fa3ce926da$var$isFunction;



var $6P6dz = parcelRequire("6P6dz");
var $2b6f98500218915a$exports = {};
var $2be2112412b330f0$exports = {};
var $faaad180bcffbb94$exports = {};
var $d14e2831379630a0$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d14e2831379630a0$var$isArray = Array.isArray;
$d14e2831379630a0$exports = $d14e2831379630a0$var$isArray;


var $855700b3ec0cc0da$exports = {};

var $1712c8f0589f33db$exports = {};

var $864b381dc394d8fc$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $864b381dc394d8fc$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$864b381dc394d8fc$exports = $864b381dc394d8fc$var$isObjectLike;


/** `Object#toString` result references. */ var $1712c8f0589f33db$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1712c8f0589f33db$var$isSymbol(value) {
    return typeof value == "symbol" || $864b381dc394d8fc$exports(value) && $51a3f16199173b7d$exports(value) == $1712c8f0589f33db$var$symbolTag;
}
$1712c8f0589f33db$exports = $1712c8f0589f33db$var$isSymbol;


/** Used to match property names within property paths. */ var $855700b3ec0cc0da$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $855700b3ec0cc0da$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $855700b3ec0cc0da$var$isKey(value, object) {
    if ($d14e2831379630a0$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $1712c8f0589f33db$exports(value)) return true;
    return $855700b3ec0cc0da$var$reIsPlainProp.test(value) || !$855700b3ec0cc0da$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$855700b3ec0cc0da$exports = $855700b3ec0cc0da$var$isKey;


var $7ad993f95b1df932$exports = {};
var $68740536b926c30f$exports = {};
var $47b64bcb5add1954$exports = {};
var $c7af525217175af0$exports = {};
var $3863b3fc3d474373$exports = {};
var $878f7ccd75645410$exports = {};
var $32002cdf575e59f3$exports = {};
var $088af4a0c3ec4d9d$exports = {};
var $c2a6a30872aedb5f$exports = {};
var $29671f13d5d4299c$exports = {};

var $5ff90a4753efaf75$exports = {};
var $24d11534c8af1e2c$exports = {};

var $lb3R3 = parcelRequire("lb3R3");
/** Used to detect overreaching core-js shims. */ var $24d11534c8af1e2c$var$coreJsData = $lb3R3["__core-js_shared__"];
$24d11534c8af1e2c$exports = $24d11534c8af1e2c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5ff90a4753efaf75$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($24d11534c8af1e2c$exports && $24d11534c8af1e2c$exports.keys && $24d11534c8af1e2c$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5ff90a4753efaf75$var$isMasked(func) {
    return !!$5ff90a4753efaf75$var$maskSrcKey && $5ff90a4753efaf75$var$maskSrcKey in func;
}
$5ff90a4753efaf75$exports = $5ff90a4753efaf75$var$isMasked;



var $e2cfdd33dd863869$exports = {};
/** Used for built-in method references. */ var $e2cfdd33dd863869$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e2cfdd33dd863869$var$funcToString = $e2cfdd33dd863869$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e2cfdd33dd863869$var$toSource(func) {
    if (func != null) {
        try {
            return $e2cfdd33dd863869$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$e2cfdd33dd863869$exports = $e2cfdd33dd863869$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $29671f13d5d4299c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $29671f13d5d4299c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $29671f13d5d4299c$var$funcProto = Function.prototype, $29671f13d5d4299c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $29671f13d5d4299c$var$funcToString = $29671f13d5d4299c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $29671f13d5d4299c$var$hasOwnProperty = $29671f13d5d4299c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $29671f13d5d4299c$var$reIsNative = RegExp("^" + $29671f13d5d4299c$var$funcToString.call($29671f13d5d4299c$var$hasOwnProperty).replace($29671f13d5d4299c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $29671f13d5d4299c$var$baseIsNative(value) {
    if (!$3175370e2388d115$exports(value) || $5ff90a4753efaf75$exports(value)) return false;
    var pattern = $781ef3fa3ce926da$exports(value) ? $29671f13d5d4299c$var$reIsNative : $29671f13d5d4299c$var$reIsHostCtor;
    return pattern.test($e2cfdd33dd863869$exports(value));
}
$29671f13d5d4299c$exports = $29671f13d5d4299c$var$baseIsNative;


var $d024716aeb9c678a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d024716aeb9c678a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d024716aeb9c678a$exports = $d024716aeb9c678a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $c2a6a30872aedb5f$var$getNative(object, key) {
    var value = $d024716aeb9c678a$exports(object, key);
    return $29671f13d5d4299c$exports(value) ? value : undefined;
}
$c2a6a30872aedb5f$exports = $c2a6a30872aedb5f$var$getNative;


/* Built-in method references that are verified to be native. */ var $088af4a0c3ec4d9d$var$nativeCreate = $c2a6a30872aedb5f$exports(Object, "create");
$088af4a0c3ec4d9d$exports = $088af4a0c3ec4d9d$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $32002cdf575e59f3$var$hashClear() {
    this.__data__ = $088af4a0c3ec4d9d$exports ? $088af4a0c3ec4d9d$exports(null) : {};
    this.size = 0;
}
$32002cdf575e59f3$exports = $32002cdf575e59f3$var$hashClear;


var $01a77176dccf8212$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $01a77176dccf8212$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$01a77176dccf8212$exports = $01a77176dccf8212$var$hashDelete;


var $8fc596437de75fb5$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $8fc596437de75fb5$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $8fc596437de75fb5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8fc596437de75fb5$var$hasOwnProperty = $8fc596437de75fb5$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8fc596437de75fb5$var$hashGet(key) {
    var data = this.__data__;
    if ($088af4a0c3ec4d9d$exports) {
        var result = data[key];
        return result === $8fc596437de75fb5$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8fc596437de75fb5$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$8fc596437de75fb5$exports = $8fc596437de75fb5$var$hashGet;


var $5ac04ecb963181db$exports = {};

/** Used for built-in method references. */ var $5ac04ecb963181db$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5ac04ecb963181db$var$hasOwnProperty = $5ac04ecb963181db$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5ac04ecb963181db$var$hashHas(key) {
    var data = this.__data__;
    return $088af4a0c3ec4d9d$exports ? data[key] !== undefined : $5ac04ecb963181db$var$hasOwnProperty.call(data, key);
}
$5ac04ecb963181db$exports = $5ac04ecb963181db$var$hashHas;


var $f4b59143952680b1$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $f4b59143952680b1$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f4b59143952680b1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $088af4a0c3ec4d9d$exports && value === undefined ? $f4b59143952680b1$var$HASH_UNDEFINED : value;
    return this;
}
$f4b59143952680b1$exports = $f4b59143952680b1$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $878f7ccd75645410$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$878f7ccd75645410$var$Hash.prototype.clear = $32002cdf575e59f3$exports;
$878f7ccd75645410$var$Hash.prototype["delete"] = $01a77176dccf8212$exports;
$878f7ccd75645410$var$Hash.prototype.get = $8fc596437de75fb5$exports;
$878f7ccd75645410$var$Hash.prototype.has = $5ac04ecb963181db$exports;
$878f7ccd75645410$var$Hash.prototype.set = $f4b59143952680b1$exports;
$878f7ccd75645410$exports = $878f7ccd75645410$var$Hash;


var $224175e0487ed9d9$exports = {};
var $00a7cece054fbee4$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $00a7cece054fbee4$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$00a7cece054fbee4$exports = $00a7cece054fbee4$var$listCacheClear;


var $d0fe61a34eb148b6$exports = {};
var $093df9540e5b5f44$exports = {};
var $e76c039d34e4ae95$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e76c039d34e4ae95$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$e76c039d34e4ae95$exports = $e76c039d34e4ae95$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $093df9540e5b5f44$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e76c039d34e4ae95$exports(array[length][0], key)) return length;
    }
    return -1;
}
$093df9540e5b5f44$exports = $093df9540e5b5f44$var$assocIndexOf;


/** Used for built-in method references. */ var $d0fe61a34eb148b6$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d0fe61a34eb148b6$var$splice = $d0fe61a34eb148b6$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0fe61a34eb148b6$var$listCacheDelete(key) {
    var data = this.__data__, index = $093df9540e5b5f44$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d0fe61a34eb148b6$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d0fe61a34eb148b6$exports = $d0fe61a34eb148b6$var$listCacheDelete;


var $da9d1f11773cfcd5$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $da9d1f11773cfcd5$var$listCacheGet(key) {
    var data = this.__data__, index = $093df9540e5b5f44$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$da9d1f11773cfcd5$exports = $da9d1f11773cfcd5$var$listCacheGet;


var $2b191fcd6bc03a9e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2b191fcd6bc03a9e$var$listCacheHas(key) {
    return $093df9540e5b5f44$exports(this.__data__, key) > -1;
}
$2b191fcd6bc03a9e$exports = $2b191fcd6bc03a9e$var$listCacheHas;


var $a986bd86ee56ac7e$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $a986bd86ee56ac7e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $093df9540e5b5f44$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$a986bd86ee56ac7e$exports = $a986bd86ee56ac7e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $224175e0487ed9d9$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$224175e0487ed9d9$var$ListCache.prototype.clear = $00a7cece054fbee4$exports;
$224175e0487ed9d9$var$ListCache.prototype["delete"] = $d0fe61a34eb148b6$exports;
$224175e0487ed9d9$var$ListCache.prototype.get = $da9d1f11773cfcd5$exports;
$224175e0487ed9d9$var$ListCache.prototype.has = $2b191fcd6bc03a9e$exports;
$224175e0487ed9d9$var$ListCache.prototype.set = $a986bd86ee56ac7e$exports;
$224175e0487ed9d9$exports = $224175e0487ed9d9$var$ListCache;


var $ad37d4b8d896738d$exports = {};


var $lb3R3 = parcelRequire("lb3R3");
/* Built-in method references that are verified to be native. */ var $ad37d4b8d896738d$var$Map = $c2a6a30872aedb5f$exports($lb3R3, "Map");
$ad37d4b8d896738d$exports = $ad37d4b8d896738d$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3863b3fc3d474373$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $878f7ccd75645410$exports,
        "map": new ($ad37d4b8d896738d$exports || $224175e0487ed9d9$exports),
        "string": new $878f7ccd75645410$exports
    };
}
$3863b3fc3d474373$exports = $3863b3fc3d474373$var$mapCacheClear;


var $e29de265c8d15a42$exports = {};
var $c3a6039f0333d556$exports = {};
var $d87b7a0e980f2401$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d87b7a0e980f2401$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$d87b7a0e980f2401$exports = $d87b7a0e980f2401$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c3a6039f0333d556$var$getMapData(map, key) {
    var data = map.__data__;
    return $d87b7a0e980f2401$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c3a6039f0333d556$exports = $c3a6039f0333d556$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e29de265c8d15a42$var$mapCacheDelete(key) {
    var result = $c3a6039f0333d556$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$e29de265c8d15a42$exports = $e29de265c8d15a42$var$mapCacheDelete;


var $78a929932a6c26c6$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $78a929932a6c26c6$var$mapCacheGet(key) {
    return $c3a6039f0333d556$exports(this, key).get(key);
}
$78a929932a6c26c6$exports = $78a929932a6c26c6$var$mapCacheGet;


var $9bdf97d0ac2f3c5e$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9bdf97d0ac2f3c5e$var$mapCacheHas(key) {
    return $c3a6039f0333d556$exports(this, key).has(key);
}
$9bdf97d0ac2f3c5e$exports = $9bdf97d0ac2f3c5e$var$mapCacheHas;


var $df89b79561888ebb$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $df89b79561888ebb$var$mapCacheSet(key, value) {
    var data = $c3a6039f0333d556$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$df89b79561888ebb$exports = $df89b79561888ebb$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c7af525217175af0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c7af525217175af0$var$MapCache.prototype.clear = $3863b3fc3d474373$exports;
$c7af525217175af0$var$MapCache.prototype["delete"] = $e29de265c8d15a42$exports;
$c7af525217175af0$var$MapCache.prototype.get = $78a929932a6c26c6$exports;
$c7af525217175af0$var$MapCache.prototype.has = $9bdf97d0ac2f3c5e$exports;
$c7af525217175af0$var$MapCache.prototype.set = $df89b79561888ebb$exports;
$c7af525217175af0$exports = $c7af525217175af0$var$MapCache;


/** Error message constants. */ var $47b64bcb5add1954$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $47b64bcb5add1954$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($47b64bcb5add1954$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($47b64bcb5add1954$var$memoize.Cache || $c7af525217175af0$exports);
    return memoized;
}
// Expose `MapCache`.
$47b64bcb5add1954$var$memoize.Cache = $c7af525217175af0$exports;
$47b64bcb5add1954$exports = $47b64bcb5add1954$var$memoize;


/** Used as the maximum memoize cache size. */ var $68740536b926c30f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $68740536b926c30f$var$memoizeCapped(func) {
    var result = $47b64bcb5add1954$exports(func, function(key) {
        if (cache.size === $68740536b926c30f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$68740536b926c30f$exports = $68740536b926c30f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $7ad993f95b1df932$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $7ad993f95b1df932$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7ad993f95b1df932$var$stringToPath = $68740536b926c30f$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($7ad993f95b1df932$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($7ad993f95b1df932$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$7ad993f95b1df932$exports = $7ad993f95b1df932$var$stringToPath;


var $8d8bbe35eef48fb5$exports = {};
var $d4fdedabf761a15f$exports = {};

var $59ba51b67bc4c797$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $59ba51b67bc4c797$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$59ba51b67bc4c797$exports = $59ba51b67bc4c797$var$arrayMap;




/** Used as references for various `Number` constants. */ var $d4fdedabf761a15f$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $d4fdedabf761a15f$var$symbolProto = $f2f45a50d52ee367$exports ? $f2f45a50d52ee367$exports.prototype : undefined, $d4fdedabf761a15f$var$symbolToString = $d4fdedabf761a15f$var$symbolProto ? $d4fdedabf761a15f$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d4fdedabf761a15f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($d14e2831379630a0$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $59ba51b67bc4c797$exports(value, $d4fdedabf761a15f$var$baseToString) + "";
    if ($1712c8f0589f33db$exports(value)) return $d4fdedabf761a15f$var$symbolToString ? $d4fdedabf761a15f$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$d4fdedabf761a15f$var$INFINITY ? "-0" : result;
}
$d4fdedabf761a15f$exports = $d4fdedabf761a15f$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $8d8bbe35eef48fb5$var$toString(value) {
    return value == null ? "" : $d4fdedabf761a15f$exports(value);
}
$8d8bbe35eef48fb5$exports = $8d8bbe35eef48fb5$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $faaad180bcffbb94$var$castPath(value, object) {
    if ($d14e2831379630a0$exports(value)) return value;
    return $855700b3ec0cc0da$exports(value, object) ? [
        value
    ] : $7ad993f95b1df932$exports($8d8bbe35eef48fb5$exports(value));
}
$faaad180bcffbb94$exports = $faaad180bcffbb94$var$castPath;


var $d1613325077e406f$exports = {};

/** Used as references for various `Number` constants. */ var $d1613325077e406f$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d1613325077e406f$var$toKey(value) {
    if (typeof value == "string" || $1712c8f0589f33db$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$d1613325077e406f$var$INFINITY ? "-0" : result;
}
$d1613325077e406f$exports = $d1613325077e406f$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $2be2112412b330f0$var$baseGet(object, path) {
    path = $faaad180bcffbb94$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$d1613325077e406f$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$2be2112412b330f0$exports = $2be2112412b330f0$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $2b6f98500218915a$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $2be2112412b330f0$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$2b6f98500218915a$exports = $2b6f98500218915a$var$get;



var $5f1f16daeeac326f$exports = {};
var $916729050ec79d55$exports = {};


/** `Object#toString` result references. */ var $916729050ec79d55$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $916729050ec79d55$var$isNumber(value) {
    return typeof value == "number" || $864b381dc394d8fc$exports(value) && $51a3f16199173b7d$exports(value) == $916729050ec79d55$var$numberTag;
}
$916729050ec79d55$exports = $916729050ec79d55$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $5f1f16daeeac326f$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $916729050ec79d55$exports(value) && value != +value;
}
$5f1f16daeeac326f$exports = $5f1f16daeeac326f$var$isNaN;



var $175b703c5efe5194$exports = {};



/** `Object#toString` result references. */ var $175b703c5efe5194$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $175b703c5efe5194$var$isString(value) {
    return typeof value == "string" || !$d14e2831379630a0$exports(value) && $864b381dc394d8fc$exports(value) && $51a3f16199173b7d$exports(value) == $175b703c5efe5194$var$stringTag;
}
$175b703c5efe5194$exports = $175b703c5efe5194$var$isString;


var $19512e2323c12caf$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $19512e2323c12caf$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($175b703c5efe5194$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $19512e2323c12caf$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($916729050ec79d55$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(value);
};
var $19512e2323c12caf$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $19512e2323c12caf$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($175b703c5efe5194$exports)))(value);
};
var $19512e2323c12caf$var$idCounter = 0;
var $19512e2323c12caf$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$19512e2323c12caf$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $19512e2323c12caf$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$19512e2323c12caf$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($175b703c5efe5194$exports)))(percent)) return defaultValue;
    var value;
    if ($19512e2323c12caf$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $19512e2323c12caf$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $19512e2323c12caf$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $19512e2323c12caf$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($19512e2323c12caf$export$7e4aa119212bc614(numberA) && $19512e2323c12caf$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $19512e2323c12caf$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $19512e2323c12caf$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};






var $20cbac382dae119e$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $20cbac382dae119e$var$isNil(value) {
    return value == null;
}
$20cbac382dae119e$exports = $20cbac382dae119e$var$isNil;




var $6P6dz = parcelRequire("6P6dz");
var $18e2187d98d74526$exports = {};
"use strict";

$18e2187d98d74526$exports = (parcelRequire("hqFJi"));



function $c9e23242a30afedc$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}




var $6P6dz = parcelRequire("6P6dz");
function $f237646aefb1d4cb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f237646aefb1d4cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f237646aefb1d4cb$var$_typeof(obj);
}
//
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $f237646aefb1d4cb$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $f237646aefb1d4cb$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $f237646aefb1d4cb$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $f237646aefb1d4cb$export$2b22758266a6fa48 = {
    svg: $f237646aefb1d4cb$var$SVGContainerPropKeys,
    polygon: $f237646aefb1d4cb$var$PolyElementKeys,
    polyline: $f237646aefb1d4cb$var$PolyElementKeys
};
var $f237646aefb1d4cb$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $f237646aefb1d4cb$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($f237646aefb1d4cb$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $f237646aefb1d4cb$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $f237646aefb1d4cb$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(props) || $f237646aefb1d4cb$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($f237646aefb1d4cb$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $f237646aefb1d4cb$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $57ab65d6d53325f9$var$_excluded = [
    "children"
], $57ab65d6d53325f9$var$_excluded2 = [
    "children"
];
function $57ab65d6d53325f9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $57ab65d6d53325f9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $57ab65d6d53325f9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $57ab65d6d53325f9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $57ab65d6d53325f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $57ab65d6d53325f9$var$_typeof(obj);
}
var $57ab65d6d53325f9$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $57ab65d6d53325f9$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $57ab65d6d53325f9$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $57ab65d6d53325f9$export$59a4d7d024cf1025 = [
    "none"
];
var $57ab65d6d53325f9$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $57ab65d6d53325f9$var$lastChildren = null;
var $57ab65d6d53325f9$var$lastResult = null;
var $57ab65d6d53325f9$export$45b10814cc054894 = function toArray(children) {
    if (children === $57ab65d6d53325f9$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))($57ab65d6d53325f9$var$lastResult)) return $57ab65d6d53325f9$var$lastResult;
    var result = [];
    (0, $6P6dz.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(child)) return;
        if ((0, $18e2187d98d74526$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $57ab65d6d53325f9$var$lastResult = result;
    $57ab65d6d53325f9$var$lastChildren = children;
    return result;
};
function $57ab65d6d53325f9$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(type)) types = type.map(function(t) {
        return $57ab65d6d53325f9$export$be63e0664592e141(t);
    });
    else types = [
        $57ab65d6d53325f9$export$be63e0664592e141(type)
    ];
    $57ab65d6d53325f9$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $57ab65d6d53325f9$export$64c61536a2b72e0f(children, type) {
    var result = $57ab65d6d53325f9$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $57ab65d6d53325f9$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(type)) types = type.map(function(t) {
        return $57ab65d6d53325f9$export$be63e0664592e141(t);
    });
    else types = [
        $57ab65d6d53325f9$export$be63e0664592e141(type)
    ];
    $57ab65d6d53325f9$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $57ab65d6d53325f9$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $19512e2323c12caf$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $57ab65d6d53325f9$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $57ab65d6d53325f9$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($175b703c5efe5194$exports)))(child.type) && $57ab65d6d53325f9$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $57ab65d6d53325f9$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $57ab65d6d53325f9$var$_typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var $57ab65d6d53325f9$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $f237646aefb1d4cb$export$2b22758266a6fa48) === null || (0, $f237646aefb1d4cb$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $f237646aefb1d4cb$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $f237646aefb1d4cb$export$190f430946f96110).includes(key)) || includeEvents && (0, $f237646aefb1d4cb$export$f30789245f2c4d11).includes(key);
};
var $57ab65d6d53325f9$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $57ab65d6d53325f9$export$45b10814cc054894(children).forEach(function(entry) {
        if ($57ab65d6d53325f9$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $57ab65d6d53325f9$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($57ab65d6d53325f9$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $57ab65d6d53325f9$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $6P6dz.Children).count(nextChildren);
    if (count !== (0, $6P6dz.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $57ab65d6d53325f9$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$57ab65d6d53325f9$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $57ab65d6d53325f9$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $57ab65d6d53325f9$var$_objectWithoutProperties(_ref, $57ab65d6d53325f9$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $57ab65d6d53325f9$var$_objectWithoutProperties(_ref2, $57ab65d6d53325f9$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $c9e23242a30afedc$export$d36bdfa510afb180)(nextProps, prevProps) && $57ab65d6d53325f9$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $c9e23242a30afedc$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $57ab65d6d53325f9$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $57ab65d6d53325f9$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($57ab65d6d53325f9$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $57ab65d6d53325f9$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $57ab65d6d53325f9$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $57ab65d6d53325f9$var$REACT_BROWSER_EVENT_MAP[type]) return $57ab65d6d53325f9$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $57ab65d6d53325f9$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $57ab65d6d53325f9$export$45b10814cc054894(children).indexOf(child);
};


var $b99054ee1c8100f4$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
];
function $b99054ee1c8100f4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b99054ee1c8100f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b99054ee1c8100f4$var$_typeof(obj);
}
function $b99054ee1c8100f4$var$_extends() {
    $b99054ee1c8100f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b99054ee1c8100f4$var$_extends.apply(this, arguments);
}
function $b99054ee1c8100f4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b99054ee1c8100f4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b99054ee1c8100f4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b99054ee1c8100f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b99054ee1c8100f4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b99054ee1c8100f4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b99054ee1c8100f4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b99054ee1c8100f4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b99054ee1c8100f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b99054ee1c8100f4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b99054ee1c8100f4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b99054ee1c8100f4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b99054ee1c8100f4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b99054ee1c8100f4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b99054ee1c8100f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b99054ee1c8100f4$var$_setPrototypeOf(subClass, superClass);
}
function $b99054ee1c8100f4$var$_setPrototypeOf(o, p) {
    $b99054ee1c8100f4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b99054ee1c8100f4$var$_setPrototypeOf(o, p);
}
function $b99054ee1c8100f4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b99054ee1c8100f4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b99054ee1c8100f4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b99054ee1c8100f4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b99054ee1c8100f4$var$_possibleConstructorReturn(this, result);
    };
}
function $b99054ee1c8100f4$var$_possibleConstructorReturn(self, call) {
    if (call && ($b99054ee1c8100f4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b99054ee1c8100f4$var$_assertThisInitialized(self);
}
function $b99054ee1c8100f4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b99054ee1c8100f4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b99054ee1c8100f4$var$_getPrototypeOf(o) {
    $b99054ee1c8100f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b99054ee1c8100f4$var$_getPrototypeOf(o);
}
function $b99054ee1c8100f4$var$_defineProperty(obj, key, value) {
    key = $b99054ee1c8100f4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b99054ee1c8100f4$var$_toPropertyKey(arg) {
    var key = $b99054ee1c8100f4$var$_toPrimitive(arg, "string");
    return $b99054ee1c8100f4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b99054ee1c8100f4$var$_toPrimitive(input, hint) {
    if ($b99054ee1c8100f4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b99054ee1c8100f4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b99054ee1c8100f4$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $b99054ee1c8100f4$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $b99054ee1c8100f4$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $b99054ee1c8100f4$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $b99054ee1c8100f4$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $b99054ee1c8100f4$var$_objectSpread($b99054ee1c8100f4$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $b99054ee1c8100f4$var$_objectSpread($b99054ee1c8100f4$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $19512e2323c12caf$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(x) || x !== +x || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $b99054ee1c8100f4$var$_objectWithoutProperties(props, $b99054ee1c8100f4$var$_excluded);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", $b99054ee1c8100f4$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $6P6dz.PureComponent));
$b99054ee1c8100f4$var$_defineProperty($b99054ee1c8100f4$export$6440e27b9f186856, "displayName", "CartesianGrid");
$b99054ee1c8100f4$var$_defineProperty($b99054ee1c8100f4$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});


var $7df642e092a5d65c$exports = {};
var $b835b507318041f7$exports = {};
var $af7cbb6bc266aaf1$exports = {};
var $17a72edd98f4e7b9$exports = {};
var $3ae9e46733b8de29$exports = {};

var $679f9f37fab1836d$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $679f9f37fab1836d$var$stackClear() {
    this.__data__ = new $224175e0487ed9d9$exports;
    this.size = 0;
}
$679f9f37fab1836d$exports = $679f9f37fab1836d$var$stackClear;


var $2464190e28a52b39$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2464190e28a52b39$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$2464190e28a52b39$exports = $2464190e28a52b39$var$stackDelete;


var $8aff8aa42f620bb2$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8aff8aa42f620bb2$var$stackGet(key) {
    return this.__data__.get(key);
}
$8aff8aa42f620bb2$exports = $8aff8aa42f620bb2$var$stackGet;


var $ce4c253dea5f96aa$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ce4c253dea5f96aa$var$stackHas(key) {
    return this.__data__.has(key);
}
$ce4c253dea5f96aa$exports = $ce4c253dea5f96aa$var$stackHas;


var $aaa231e272e45b8a$exports = {};



/** Used as the size to enable large array optimizations. */ var $aaa231e272e45b8a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $aaa231e272e45b8a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $224175e0487ed9d9$exports) {
        var pairs = data.__data__;
        if (!$ad37d4b8d896738d$exports || pairs.length < $aaa231e272e45b8a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $c7af525217175af0$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$aaa231e272e45b8a$exports = $aaa231e272e45b8a$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3ae9e46733b8de29$var$Stack(entries) {
    var data = this.__data__ = new $224175e0487ed9d9$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$3ae9e46733b8de29$var$Stack.prototype.clear = $679f9f37fab1836d$exports;
$3ae9e46733b8de29$var$Stack.prototype["delete"] = $2464190e28a52b39$exports;
$3ae9e46733b8de29$var$Stack.prototype.get = $8aff8aa42f620bb2$exports;
$3ae9e46733b8de29$var$Stack.prototype.has = $ce4c253dea5f96aa$exports;
$3ae9e46733b8de29$var$Stack.prototype.set = $aaa231e272e45b8a$exports;
$3ae9e46733b8de29$exports = $3ae9e46733b8de29$var$Stack;


var $02f753f6c05b5819$exports = {};
var $7f08510d8d2fca1f$exports = {};

var $0514b169d18406a7$exports = {};
var $6bf866da645ac0e6$exports = {};

var $702479ed51a74806$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $702479ed51a74806$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $702479ed51a74806$var$setCacheAdd(value) {
    this.__data__.set(value, $702479ed51a74806$var$HASH_UNDEFINED);
    return this;
}
$702479ed51a74806$exports = $702479ed51a74806$var$setCacheAdd;


var $0b0df4bd46889d3f$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0b0df4bd46889d3f$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$0b0df4bd46889d3f$exports = $0b0df4bd46889d3f$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $6bf866da645ac0e6$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $c7af525217175af0$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$6bf866da645ac0e6$var$SetCache.prototype.add = $6bf866da645ac0e6$var$SetCache.prototype.push = $702479ed51a74806$exports;
$6bf866da645ac0e6$var$SetCache.prototype.has = $0b0df4bd46889d3f$exports;
$6bf866da645ac0e6$exports = $6bf866da645ac0e6$var$SetCache;


var $6e4174481de3f6e1$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6e4174481de3f6e1$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$6e4174481de3f6e1$exports = $6e4174481de3f6e1$var$arraySome;


var $bcbecafa3b02b944$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bcbecafa3b02b944$var$cacheHas(cache, key) {
    return cache.has(key);
}
$bcbecafa3b02b944$exports = $bcbecafa3b02b944$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0514b169d18406a7$var$COMPARE_PARTIAL_FLAG = 1, $0514b169d18406a7$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0514b169d18406a7$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0514b169d18406a7$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0514b169d18406a7$var$COMPARE_UNORDERED_FLAG ? new $6bf866da645ac0e6$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$6e4174481de3f6e1$exports(other, function(othValue, othIndex) {
                if (!$bcbecafa3b02b944$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$0514b169d18406a7$exports = $0514b169d18406a7$var$equalArrays;


var $21fd445c8fd38daa$exports = {};

var $82e5f1aa45793226$exports = {};

var $lb3R3 = parcelRequire("lb3R3");
/** Built-in value references. */ var $82e5f1aa45793226$var$Uint8Array = $lb3R3.Uint8Array;
$82e5f1aa45793226$exports = $82e5f1aa45793226$var$Uint8Array;




var $496beb9708841075$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $496beb9708841075$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$496beb9708841075$exports = $496beb9708841075$var$mapToArray;


var $5df5e4704d71548c$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5df5e4704d71548c$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$5df5e4704d71548c$exports = $5df5e4704d71548c$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $21fd445c8fd38daa$var$COMPARE_PARTIAL_FLAG = 1, $21fd445c8fd38daa$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $21fd445c8fd38daa$var$boolTag = "[object Boolean]", $21fd445c8fd38daa$var$dateTag = "[object Date]", $21fd445c8fd38daa$var$errorTag = "[object Error]", $21fd445c8fd38daa$var$mapTag = "[object Map]", $21fd445c8fd38daa$var$numberTag = "[object Number]", $21fd445c8fd38daa$var$regexpTag = "[object RegExp]", $21fd445c8fd38daa$var$setTag = "[object Set]", $21fd445c8fd38daa$var$stringTag = "[object String]", $21fd445c8fd38daa$var$symbolTag = "[object Symbol]";
var $21fd445c8fd38daa$var$arrayBufferTag = "[object ArrayBuffer]", $21fd445c8fd38daa$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $21fd445c8fd38daa$var$symbolProto = $f2f45a50d52ee367$exports ? $f2f45a50d52ee367$exports.prototype : undefined, $21fd445c8fd38daa$var$symbolValueOf = $21fd445c8fd38daa$var$symbolProto ? $21fd445c8fd38daa$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $21fd445c8fd38daa$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $21fd445c8fd38daa$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $21fd445c8fd38daa$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $82e5f1aa45793226$exports(object), new $82e5f1aa45793226$exports(other))) return false;
            return true;
        case $21fd445c8fd38daa$var$boolTag:
        case $21fd445c8fd38daa$var$dateTag:
        case $21fd445c8fd38daa$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $e76c039d34e4ae95$exports(+object, +other);
        case $21fd445c8fd38daa$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $21fd445c8fd38daa$var$regexpTag:
        case $21fd445c8fd38daa$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $21fd445c8fd38daa$var$mapTag:
            var convert = $496beb9708841075$exports;
        case $21fd445c8fd38daa$var$setTag:
            var isPartial = bitmask & $21fd445c8fd38daa$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $5df5e4704d71548c$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $21fd445c8fd38daa$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0514b169d18406a7$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $21fd445c8fd38daa$var$symbolTag:
            if ($21fd445c8fd38daa$var$symbolValueOf) return $21fd445c8fd38daa$var$symbolValueOf.call(object) == $21fd445c8fd38daa$var$symbolValueOf.call(other);
    }
    return false;
}
$21fd445c8fd38daa$exports = $21fd445c8fd38daa$var$equalByTag;


var $4111f459285e9e77$exports = {};
var $a592f8095702d46e$exports = {};
var $2971f5d619947f8a$exports = {};
var $821c039cd134d3ce$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $821c039cd134d3ce$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$821c039cd134d3ce$exports = $821c039cd134d3ce$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2971f5d619947f8a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $d14e2831379630a0$exports(object) ? result : $821c039cd134d3ce$exports(result, symbolsFunc(object));
}
$2971f5d619947f8a$exports = $2971f5d619947f8a$var$baseGetAllKeys;


var $b712054e61772688$exports = {};
var $cb766754fb821305$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cb766754fb821305$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$cb766754fb821305$exports = $cb766754fb821305$var$arrayFilter;


var $05752ed4b541f93a$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $05752ed4b541f93a$var$stubArray() {
    return [];
}
$05752ed4b541f93a$exports = $05752ed4b541f93a$var$stubArray;


/** Used for built-in method references. */ var $b712054e61772688$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b712054e61772688$var$propertyIsEnumerable = $b712054e61772688$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b712054e61772688$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b712054e61772688$var$getSymbols = !$b712054e61772688$var$nativeGetSymbols ? $05752ed4b541f93a$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $cb766754fb821305$exports($b712054e61772688$var$nativeGetSymbols(object), function(symbol) {
        return $b712054e61772688$var$propertyIsEnumerable.call(object, symbol);
    });
};
$b712054e61772688$exports = $b712054e61772688$var$getSymbols;


var $b5bd9c92554c187b$exports = {};
var $32a15bda48ba55f6$exports = {};
var $2b2d30e52836c806$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2b2d30e52836c806$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$2b2d30e52836c806$exports = $2b2d30e52836c806$var$baseTimes;


var $4caa1bfd4c747bb9$exports = {};
var $db6b5536cc6c966b$exports = {};


/** `Object#toString` result references. */ var $db6b5536cc6c966b$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $db6b5536cc6c966b$var$baseIsArguments(value) {
    return $864b381dc394d8fc$exports(value) && $51a3f16199173b7d$exports(value) == $db6b5536cc6c966b$var$argsTag;
}
$db6b5536cc6c966b$exports = $db6b5536cc6c966b$var$baseIsArguments;



/** Used for built-in method references. */ var $4caa1bfd4c747bb9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caa1bfd4c747bb9$var$hasOwnProperty = $4caa1bfd4c747bb9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4caa1bfd4c747bb9$var$propertyIsEnumerable = $4caa1bfd4c747bb9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4caa1bfd4c747bb9$var$isArguments = $db6b5536cc6c966b$exports(function() {
    return arguments;
}()) ? $db6b5536cc6c966b$exports : function(value) {
    return $864b381dc394d8fc$exports(value) && $4caa1bfd4c747bb9$var$hasOwnProperty.call(value, "callee") && !$4caa1bfd4c747bb9$var$propertyIsEnumerable.call(value, "callee");
};
$4caa1bfd4c747bb9$exports = $4caa1bfd4c747bb9$var$isArguments;




var $6NaXQ = parcelRequire("6NaXQ");
var $34618795349fb081$exports = {};
/** Used as references for various `Number` constants. */ var $34618795349fb081$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $34618795349fb081$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $34618795349fb081$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $34618795349fb081$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $34618795349fb081$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$34618795349fb081$exports = $34618795349fb081$var$isIndex;


var $b5622197112b3ae8$exports = {};
var $de9458ad6203c5af$exports = {};

var $b2f848d36de53bae$exports = {};
/** Used as references for various `Number` constants. */ var $b2f848d36de53bae$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b2f848d36de53bae$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $b2f848d36de53bae$var$MAX_SAFE_INTEGER;
}
$b2f848d36de53bae$exports = $b2f848d36de53bae$var$isLength;



/** `Object#toString` result references. */ var $de9458ad6203c5af$var$argsTag = "[object Arguments]", $de9458ad6203c5af$var$arrayTag = "[object Array]", $de9458ad6203c5af$var$boolTag = "[object Boolean]", $de9458ad6203c5af$var$dateTag = "[object Date]", $de9458ad6203c5af$var$errorTag = "[object Error]", $de9458ad6203c5af$var$funcTag = "[object Function]", $de9458ad6203c5af$var$mapTag = "[object Map]", $de9458ad6203c5af$var$numberTag = "[object Number]", $de9458ad6203c5af$var$objectTag = "[object Object]", $de9458ad6203c5af$var$regexpTag = "[object RegExp]", $de9458ad6203c5af$var$setTag = "[object Set]", $de9458ad6203c5af$var$stringTag = "[object String]", $de9458ad6203c5af$var$weakMapTag = "[object WeakMap]";
var $de9458ad6203c5af$var$arrayBufferTag = "[object ArrayBuffer]", $de9458ad6203c5af$var$dataViewTag = "[object DataView]", $de9458ad6203c5af$var$float32Tag = "[object Float32Array]", $de9458ad6203c5af$var$float64Tag = "[object Float64Array]", $de9458ad6203c5af$var$int8Tag = "[object Int8Array]", $de9458ad6203c5af$var$int16Tag = "[object Int16Array]", $de9458ad6203c5af$var$int32Tag = "[object Int32Array]", $de9458ad6203c5af$var$uint8Tag = "[object Uint8Array]", $de9458ad6203c5af$var$uint8ClampedTag = "[object Uint8ClampedArray]", $de9458ad6203c5af$var$uint16Tag = "[object Uint16Array]", $de9458ad6203c5af$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $de9458ad6203c5af$var$typedArrayTags = {};
$de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$float32Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$float64Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$int8Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$int16Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$int32Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$uint8Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$uint8ClampedTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$uint16Tag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$uint32Tag] = true;
$de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$argsTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$arrayTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$arrayBufferTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$boolTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$dataViewTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$dateTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$errorTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$funcTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$mapTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$numberTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$objectTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$regexpTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$setTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$stringTag] = $de9458ad6203c5af$var$typedArrayTags[$de9458ad6203c5af$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $de9458ad6203c5af$var$baseIsTypedArray(value) {
    return $864b381dc394d8fc$exports(value) && $b2f848d36de53bae$exports(value.length) && !!$de9458ad6203c5af$var$typedArrayTags[$51a3f16199173b7d$exports(value)];
}
$de9458ad6203c5af$exports = $de9458ad6203c5af$var$baseIsTypedArray;


var $4f8937dd9e7c910b$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4f8937dd9e7c910b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$4f8937dd9e7c910b$exports = $4f8937dd9e7c910b$var$baseUnary;



var $8WXKx = parcelRequire("8WXKx");
/* Node.js helper references. */ var $b5622197112b3ae8$var$nodeIsTypedArray = $8WXKx && $8WXKx.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b5622197112b3ae8$var$isTypedArray = $b5622197112b3ae8$var$nodeIsTypedArray ? $4f8937dd9e7c910b$exports($b5622197112b3ae8$var$nodeIsTypedArray) : $de9458ad6203c5af$exports;
$b5622197112b3ae8$exports = $b5622197112b3ae8$var$isTypedArray;


/** Used for built-in method references. */ var $32a15bda48ba55f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32a15bda48ba55f6$var$hasOwnProperty = $32a15bda48ba55f6$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $32a15bda48ba55f6$var$arrayLikeKeys(value, inherited) {
    var isArr = $d14e2831379630a0$exports(value), isArg = !isArr && $4caa1bfd4c747bb9$exports(value), isBuff = !isArr && !isArg && $6NaXQ(value), isType = !isArr && !isArg && !isBuff && $b5622197112b3ae8$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $2b2d30e52836c806$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $32a15bda48ba55f6$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $34618795349fb081$exports(key, length)))) result.push(key);
    return result;
}
$32a15bda48ba55f6$exports = $32a15bda48ba55f6$var$arrayLikeKeys;


var $a2437042d944f6fa$exports = {};
var $14dce8a393af1b26$exports = {};
/** Used for built-in method references. */ var $14dce8a393af1b26$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $14dce8a393af1b26$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $14dce8a393af1b26$var$objectProto;
    return value === proto;
}
$14dce8a393af1b26$exports = $14dce8a393af1b26$var$isPrototype;


var $1be7132a7fd378ed$exports = {};
var $e7392189e68df3c2$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e7392189e68df3c2$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$e7392189e68df3c2$exports = $e7392189e68df3c2$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $1be7132a7fd378ed$var$nativeKeys = $e7392189e68df3c2$exports(Object.keys, Object);
$1be7132a7fd378ed$exports = $1be7132a7fd378ed$var$nativeKeys;


/** Used for built-in method references. */ var $a2437042d944f6fa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a2437042d944f6fa$var$hasOwnProperty = $a2437042d944f6fa$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a2437042d944f6fa$var$baseKeys(object) {
    if (!$14dce8a393af1b26$exports(object)) return $1be7132a7fd378ed$exports(object);
    var result = [];
    for(var key in Object(object))if ($a2437042d944f6fa$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$a2437042d944f6fa$exports = $a2437042d944f6fa$var$baseKeys;


var $940b538c55f91a86$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $940b538c55f91a86$var$isArrayLike(value) {
    return value != null && $b2f848d36de53bae$exports(value.length) && !$781ef3fa3ce926da$exports(value);
}
$940b538c55f91a86$exports = $940b538c55f91a86$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b5bd9c92554c187b$var$keys(object) {
    return $940b538c55f91a86$exports(object) ? $32a15bda48ba55f6$exports(object) : $a2437042d944f6fa$exports(object);
}
$b5bd9c92554c187b$exports = $b5bd9c92554c187b$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a592f8095702d46e$var$getAllKeys(object) {
    return $2971f5d619947f8a$exports(object, $b5bd9c92554c187b$exports, $b712054e61772688$exports);
}
$a592f8095702d46e$exports = $a592f8095702d46e$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $4111f459285e9e77$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $4111f459285e9e77$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4111f459285e9e77$var$hasOwnProperty = $4111f459285e9e77$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $4111f459285e9e77$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $4111f459285e9e77$var$COMPARE_PARTIAL_FLAG, objProps = $a592f8095702d46e$exports(object), objLength = objProps.length, othProps = $a592f8095702d46e$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $4111f459285e9e77$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$4111f459285e9e77$exports = $4111f459285e9e77$var$equalObjects;


var $b9b3bb2df02ed7a3$exports = {};
var $e8c0691609a8ca89$exports = {};


var $lb3R3 = parcelRequire("lb3R3");
/* Built-in method references that are verified to be native. */ var $e8c0691609a8ca89$var$DataView = $c2a6a30872aedb5f$exports($lb3R3, "DataView");
$e8c0691609a8ca89$exports = $e8c0691609a8ca89$var$DataView;



var $77b9c80ce18b15a8$exports = {};


var $lb3R3 = parcelRequire("lb3R3");
/* Built-in method references that are verified to be native. */ var $77b9c80ce18b15a8$var$Promise = $c2a6a30872aedb5f$exports($lb3R3, "Promise");
$77b9c80ce18b15a8$exports = $77b9c80ce18b15a8$var$Promise;


var $c0f46bc0b614f748$exports = {};


var $lb3R3 = parcelRequire("lb3R3");
/* Built-in method references that are verified to be native. */ var $c0f46bc0b614f748$var$Set = $c2a6a30872aedb5f$exports($lb3R3, "Set");
$c0f46bc0b614f748$exports = $c0f46bc0b614f748$var$Set;


var $201dd0ae5f076789$exports = {};


var $lb3R3 = parcelRequire("lb3R3");
/* Built-in method references that are verified to be native. */ var $201dd0ae5f076789$var$WeakMap = $c2a6a30872aedb5f$exports($lb3R3, "WeakMap");
$201dd0ae5f076789$exports = $201dd0ae5f076789$var$WeakMap;




/** `Object#toString` result references. */ var $b9b3bb2df02ed7a3$var$mapTag = "[object Map]", $b9b3bb2df02ed7a3$var$objectTag = "[object Object]", $b9b3bb2df02ed7a3$var$promiseTag = "[object Promise]", $b9b3bb2df02ed7a3$var$setTag = "[object Set]", $b9b3bb2df02ed7a3$var$weakMapTag = "[object WeakMap]";
var $b9b3bb2df02ed7a3$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $b9b3bb2df02ed7a3$var$dataViewCtorString = $e2cfdd33dd863869$exports($e8c0691609a8ca89$exports), $b9b3bb2df02ed7a3$var$mapCtorString = $e2cfdd33dd863869$exports($ad37d4b8d896738d$exports), $b9b3bb2df02ed7a3$var$promiseCtorString = $e2cfdd33dd863869$exports($77b9c80ce18b15a8$exports), $b9b3bb2df02ed7a3$var$setCtorString = $e2cfdd33dd863869$exports($c0f46bc0b614f748$exports), $b9b3bb2df02ed7a3$var$weakMapCtorString = $e2cfdd33dd863869$exports($201dd0ae5f076789$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b9b3bb2df02ed7a3$var$getTag = $51a3f16199173b7d$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($e8c0691609a8ca89$exports && $b9b3bb2df02ed7a3$var$getTag(new $e8c0691609a8ca89$exports(new ArrayBuffer(1))) != $b9b3bb2df02ed7a3$var$dataViewTag || $ad37d4b8d896738d$exports && $b9b3bb2df02ed7a3$var$getTag(new $ad37d4b8d896738d$exports) != $b9b3bb2df02ed7a3$var$mapTag || $77b9c80ce18b15a8$exports && $b9b3bb2df02ed7a3$var$getTag($77b9c80ce18b15a8$exports.resolve()) != $b9b3bb2df02ed7a3$var$promiseTag || $c0f46bc0b614f748$exports && $b9b3bb2df02ed7a3$var$getTag(new $c0f46bc0b614f748$exports) != $b9b3bb2df02ed7a3$var$setTag || $201dd0ae5f076789$exports && $b9b3bb2df02ed7a3$var$getTag(new $201dd0ae5f076789$exports) != $b9b3bb2df02ed7a3$var$weakMapTag) $b9b3bb2df02ed7a3$var$getTag = function(value) {
    var result = $51a3f16199173b7d$exports(value), Ctor = result == $b9b3bb2df02ed7a3$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $e2cfdd33dd863869$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $b9b3bb2df02ed7a3$var$dataViewCtorString:
            return $b9b3bb2df02ed7a3$var$dataViewTag;
        case $b9b3bb2df02ed7a3$var$mapCtorString:
            return $b9b3bb2df02ed7a3$var$mapTag;
        case $b9b3bb2df02ed7a3$var$promiseCtorString:
            return $b9b3bb2df02ed7a3$var$promiseTag;
        case $b9b3bb2df02ed7a3$var$setCtorString:
            return $b9b3bb2df02ed7a3$var$setTag;
        case $b9b3bb2df02ed7a3$var$weakMapCtorString:
            return $b9b3bb2df02ed7a3$var$weakMapTag;
    }
    return result;
};
$b9b3bb2df02ed7a3$exports = $b9b3bb2df02ed7a3$var$getTag;




var $6NaXQ = parcelRequire("6NaXQ");

/** Used to compose bitmasks for value comparisons. */ var $7f08510d8d2fca1f$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7f08510d8d2fca1f$var$argsTag = "[object Arguments]", $7f08510d8d2fca1f$var$arrayTag = "[object Array]", $7f08510d8d2fca1f$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $7f08510d8d2fca1f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f08510d8d2fca1f$var$hasOwnProperty = $7f08510d8d2fca1f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7f08510d8d2fca1f$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $d14e2831379630a0$exports(object), othIsArr = $d14e2831379630a0$exports(other), objTag = objIsArr ? $7f08510d8d2fca1f$var$arrayTag : $b9b3bb2df02ed7a3$exports(object), othTag = othIsArr ? $7f08510d8d2fca1f$var$arrayTag : $b9b3bb2df02ed7a3$exports(other);
    objTag = objTag == $7f08510d8d2fca1f$var$argsTag ? $7f08510d8d2fca1f$var$objectTag : objTag;
    othTag = othTag == $7f08510d8d2fca1f$var$argsTag ? $7f08510d8d2fca1f$var$objectTag : othTag;
    var objIsObj = objTag == $7f08510d8d2fca1f$var$objectTag, othIsObj = othTag == $7f08510d8d2fca1f$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $6NaXQ(object)) {
        if (!$6NaXQ(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $3ae9e46733b8de29$exports);
        return objIsArr || $b5622197112b3ae8$exports(object) ? $0514b169d18406a7$exports(object, other, bitmask, customizer, equalFunc, stack) : $21fd445c8fd38daa$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7f08510d8d2fca1f$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7f08510d8d2fca1f$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $7f08510d8d2fca1f$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $3ae9e46733b8de29$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $3ae9e46733b8de29$exports);
    return $4111f459285e9e77$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$7f08510d8d2fca1f$exports = $7f08510d8d2fca1f$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $02f753f6c05b5819$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$864b381dc394d8fc$exports(value) && !$864b381dc394d8fc$exports(other)) return value !== value && other !== other;
    return $7f08510d8d2fca1f$exports(value, other, bitmask, customizer, $02f753f6c05b5819$var$baseIsEqual, stack);
}
$02f753f6c05b5819$exports = $02f753f6c05b5819$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $17a72edd98f4e7b9$var$COMPARE_PARTIAL_FLAG = 1, $17a72edd98f4e7b9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $17a72edd98f4e7b9$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $3ae9e46733b8de29$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $02f753f6c05b5819$exports(srcValue, objValue, $17a72edd98f4e7b9$var$COMPARE_PARTIAL_FLAG | $17a72edd98f4e7b9$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$17a72edd98f4e7b9$exports = $17a72edd98f4e7b9$var$baseIsMatch;


var $62fa42df2736202b$exports = {};
var $69d34dbf45f7b40a$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $69d34dbf45f7b40a$var$isStrictComparable(value) {
    return value === value && !$3175370e2388d115$exports(value);
}
$69d34dbf45f7b40a$exports = $69d34dbf45f7b40a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $62fa42df2736202b$var$getMatchData(object) {
    var result = $b5bd9c92554c187b$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $69d34dbf45f7b40a$exports(value)
        ];
    }
    return result;
}
$62fa42df2736202b$exports = $62fa42df2736202b$var$getMatchData;


var $829b33ddd7972301$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $829b33ddd7972301$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$829b33ddd7972301$exports = $829b33ddd7972301$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $af7cbb6bc266aaf1$var$baseMatches(source) {
    var matchData = $62fa42df2736202b$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $829b33ddd7972301$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $17a72edd98f4e7b9$exports(object, source, matchData);
    };
}
$af7cbb6bc266aaf1$exports = $af7cbb6bc266aaf1$var$baseMatches;


var $98d577a3e0133935$exports = {};


var $afe4771fa88b4ffe$exports = {};
var $e17ea784acb0a59b$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $e17ea784acb0a59b$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$e17ea784acb0a59b$exports = $e17ea784acb0a59b$var$baseHasIn;


var $d544b0902cc414ea$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $d544b0902cc414ea$var$hasPath(object, path, hasFunc) {
    path = $faaad180bcffbb94$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $d1613325077e406f$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $b2f848d36de53bae$exports(length) && $34618795349fb081$exports(key, length) && ($d14e2831379630a0$exports(object) || $4caa1bfd4c747bb9$exports(object));
}
$d544b0902cc414ea$exports = $d544b0902cc414ea$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $afe4771fa88b4ffe$var$hasIn(object, path) {
    return object != null && $d544b0902cc414ea$exports(object, path, $e17ea784acb0a59b$exports);
}
$afe4771fa88b4ffe$exports = $afe4771fa88b4ffe$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $98d577a3e0133935$var$COMPARE_PARTIAL_FLAG = 1, $98d577a3e0133935$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $98d577a3e0133935$var$baseMatchesProperty(path, srcValue) {
    if ($855700b3ec0cc0da$exports(path) && $69d34dbf45f7b40a$exports(srcValue)) return $829b33ddd7972301$exports($d1613325077e406f$exports(path), srcValue);
    return function(object) {
        var objValue = $2b6f98500218915a$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $afe4771fa88b4ffe$exports(object, path) : $02f753f6c05b5819$exports(srcValue, objValue, $98d577a3e0133935$var$COMPARE_PARTIAL_FLAG | $98d577a3e0133935$var$COMPARE_UNORDERED_FLAG);
    };
}
$98d577a3e0133935$exports = $98d577a3e0133935$var$baseMatchesProperty;


var $e96ff4ec759e4f57$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e96ff4ec759e4f57$var$identity(value) {
    return value;
}
$e96ff4ec759e4f57$exports = $e96ff4ec759e4f57$var$identity;



var $9ddfee1b98f1d209$exports = {};
var $6530b15453943c74$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6530b15453943c74$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$6530b15453943c74$exports = $6530b15453943c74$var$baseProperty;


var $f3698f5c38c7f0d9$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $f3698f5c38c7f0d9$var$basePropertyDeep(path) {
    return function(object) {
        return $2be2112412b330f0$exports(object, path);
    };
}
$f3698f5c38c7f0d9$exports = $f3698f5c38c7f0d9$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $9ddfee1b98f1d209$var$property(path) {
    return $855700b3ec0cc0da$exports(path) ? $6530b15453943c74$exports($d1613325077e406f$exports(path)) : $f3698f5c38c7f0d9$exports(path);
}
$9ddfee1b98f1d209$exports = $9ddfee1b98f1d209$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $b835b507318041f7$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $e96ff4ec759e4f57$exports;
    if (typeof value == "object") return $d14e2831379630a0$exports(value) ? $98d577a3e0133935$exports(value[0], value[1]) : $af7cbb6bc266aaf1$exports(value);
    return $9ddfee1b98f1d209$exports(value);
}
$b835b507318041f7$exports = $b835b507318041f7$var$baseIteratee;


var $623b8d8370365fa2$exports = {};

var $562b639f8c678681$exports = {};
var $43b2d37d5c7ded37$exports = {};
var $d539bc9f633add24$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d539bc9f633add24$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$d539bc9f633add24$exports = $d539bc9f633add24$var$baseFindIndex;


var $eebf410814c98a88$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $eebf410814c98a88$var$baseIsNaN(value) {
    return value !== value;
}
$eebf410814c98a88$exports = $eebf410814c98a88$var$baseIsNaN;


var $284a36b990ca2b10$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $284a36b990ca2b10$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$284a36b990ca2b10$exports = $284a36b990ca2b10$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $43b2d37d5c7ded37$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $284a36b990ca2b10$exports(array, value, fromIndex) : $d539bc9f633add24$exports(array, $eebf410814c98a88$exports, fromIndex);
}
$43b2d37d5c7ded37$exports = $43b2d37d5c7ded37$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $562b639f8c678681$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $43b2d37d5c7ded37$exports(array, value, 0) > -1;
}
$562b639f8c678681$exports = $562b639f8c678681$var$arrayIncludes;


var $f43932db8f372868$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f43932db8f372868$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$f43932db8f372868$exports = $f43932db8f372868$var$arrayIncludesWith;



var $77cead84d70e29e9$exports = {};

var $c5cce5b74a33fe3f$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $c5cce5b74a33fe3f$var$noop() {
// No operation performed.
}
$c5cce5b74a33fe3f$exports = $c5cce5b74a33fe3f$var$noop;



/** Used as references for various `Number` constants. */ var $77cead84d70e29e9$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $77cead84d70e29e9$var$createSet = !($c0f46bc0b614f748$exports && 1 / $5df5e4704d71548c$exports(new $c0f46bc0b614f748$exports([
    ,
    -0
]))[1] == $77cead84d70e29e9$var$INFINITY) ? $c5cce5b74a33fe3f$exports : function(values) {
    return new $c0f46bc0b614f748$exports(values);
};
$77cead84d70e29e9$exports = $77cead84d70e29e9$var$createSet;



/** Used as the size to enable large array optimizations. */ var $623b8d8370365fa2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $623b8d8370365fa2$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $562b639f8c678681$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $f43932db8f372868$exports;
    } else if (length >= $623b8d8370365fa2$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $77cead84d70e29e9$exports(array);
        if (set) return $5df5e4704d71548c$exports(set);
        isCommon = false;
        includes = $bcbecafa3b02b944$exports;
        seen = new $6bf866da645ac0e6$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$623b8d8370365fa2$exports = $623b8d8370365fa2$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $7df642e092a5d65c$var$uniqBy(array, iteratee) {
    return array && array.length ? $623b8d8370365fa2$exports(array, $b835b507318041f7$exports(iteratee, 2)) : [];
}
$7df642e092a5d65c$exports = $7df642e092a5d65c$var$uniqBy;



var $6P6dz = parcelRequire("6P6dz");

var $6P6dz = parcelRequire("6P6dz");


var $6P6dz = parcelRequire("6P6dz");


var $01e8f2329e9a422e$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style"
];
function $01e8f2329e9a422e$var$_extends() {
    $01e8f2329e9a422e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01e8f2329e9a422e$var$_extends.apply(this, arguments);
}
function $01e8f2329e9a422e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $01e8f2329e9a422e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $01e8f2329e9a422e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $01e8f2329e9a422e$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $01e8f2329e9a422e$var$_objectWithoutProperties(props, $01e8f2329e9a422e$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("svg", $01e8f2329e9a422e$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("desc", null, props.desc), children);
}


var $a188cd0a1c1bcfd8$exports = {};
var $13d7ab2f94bb1e40$exports = {};
var $df832493f6e542dd$exports = {};
var $685415e82bfb9a2b$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $685415e82bfb9a2b$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$685415e82bfb9a2b$exports = $685415e82bfb9a2b$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $df832493f6e542dd$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $685415e82bfb9a2b$exports(array, start, end);
}
$df832493f6e542dd$exports = $df832493f6e542dd$var$castSlice;


var $8dc68c59801d34fd$exports = {};
/** Used to compose unicode character classes. */ var $8dc68c59801d34fd$var$rsAstralRange = "\ud800-\udfff", $8dc68c59801d34fd$var$rsComboMarksRange = "\\u0300-\\u036f", $8dc68c59801d34fd$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $8dc68c59801d34fd$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $8dc68c59801d34fd$var$rsComboRange = $8dc68c59801d34fd$var$rsComboMarksRange + $8dc68c59801d34fd$var$reComboHalfMarksRange + $8dc68c59801d34fd$var$rsComboSymbolsRange, $8dc68c59801d34fd$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $8dc68c59801d34fd$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $8dc68c59801d34fd$var$reHasUnicode = RegExp("[" + $8dc68c59801d34fd$var$rsZWJ + $8dc68c59801d34fd$var$rsAstralRange + $8dc68c59801d34fd$var$rsComboRange + $8dc68c59801d34fd$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $8dc68c59801d34fd$var$hasUnicode(string) {
    return $8dc68c59801d34fd$var$reHasUnicode.test(string);
}
$8dc68c59801d34fd$exports = $8dc68c59801d34fd$var$hasUnicode;


var $3b9bfe445063afe9$exports = {};
var $9f2ed73b6c11e37d$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9f2ed73b6c11e37d$var$asciiToArray(string) {
    return string.split("");
}
$9f2ed73b6c11e37d$exports = $9f2ed73b6c11e37d$var$asciiToArray;



var $552323779c6d5f06$exports = {};
/** Used to compose unicode character classes. */ var $552323779c6d5f06$var$rsAstralRange = "\ud800-\udfff", $552323779c6d5f06$var$rsComboMarksRange = "\\u0300-\\u036f", $552323779c6d5f06$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $552323779c6d5f06$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $552323779c6d5f06$var$rsComboRange = $552323779c6d5f06$var$rsComboMarksRange + $552323779c6d5f06$var$reComboHalfMarksRange + $552323779c6d5f06$var$rsComboSymbolsRange, $552323779c6d5f06$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $552323779c6d5f06$var$rsAstral = "[" + $552323779c6d5f06$var$rsAstralRange + "]", $552323779c6d5f06$var$rsCombo = "[" + $552323779c6d5f06$var$rsComboRange + "]", $552323779c6d5f06$var$rsFitz = "\ud83c[\udffb-\udfff]", $552323779c6d5f06$var$rsModifier = "(?:" + $552323779c6d5f06$var$rsCombo + "|" + $552323779c6d5f06$var$rsFitz + ")", $552323779c6d5f06$var$rsNonAstral = "[^" + $552323779c6d5f06$var$rsAstralRange + "]", $552323779c6d5f06$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $552323779c6d5f06$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $552323779c6d5f06$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $552323779c6d5f06$var$reOptMod = $552323779c6d5f06$var$rsModifier + "?", $552323779c6d5f06$var$rsOptVar = "[" + $552323779c6d5f06$var$rsVarRange + "]?", $552323779c6d5f06$var$rsOptJoin = "(?:" + $552323779c6d5f06$var$rsZWJ + "(?:" + [
    $552323779c6d5f06$var$rsNonAstral,
    $552323779c6d5f06$var$rsRegional,
    $552323779c6d5f06$var$rsSurrPair
].join("|") + ")" + $552323779c6d5f06$var$rsOptVar + $552323779c6d5f06$var$reOptMod + ")*", $552323779c6d5f06$var$rsSeq = $552323779c6d5f06$var$rsOptVar + $552323779c6d5f06$var$reOptMod + $552323779c6d5f06$var$rsOptJoin, $552323779c6d5f06$var$rsSymbol = "(?:" + [
    $552323779c6d5f06$var$rsNonAstral + $552323779c6d5f06$var$rsCombo + "?",
    $552323779c6d5f06$var$rsCombo,
    $552323779c6d5f06$var$rsRegional,
    $552323779c6d5f06$var$rsSurrPair,
    $552323779c6d5f06$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $552323779c6d5f06$var$reUnicode = RegExp($552323779c6d5f06$var$rsFitz + "(?=" + $552323779c6d5f06$var$rsFitz + ")|" + $552323779c6d5f06$var$rsSymbol + $552323779c6d5f06$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $552323779c6d5f06$var$unicodeToArray(string) {
    return string.match($552323779c6d5f06$var$reUnicode) || [];
}
$552323779c6d5f06$exports = $552323779c6d5f06$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3b9bfe445063afe9$var$stringToArray(string) {
    return $8dc68c59801d34fd$exports(string) ? $552323779c6d5f06$exports(string) : $9f2ed73b6c11e37d$exports(string);
}
$3b9bfe445063afe9$exports = $3b9bfe445063afe9$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $13d7ab2f94bb1e40$var$createCaseFirst(methodName) {
    return function(string) {
        string = $8d8bbe35eef48fb5$exports(string);
        var strSymbols = $8dc68c59801d34fd$exports(string) ? $3b9bfe445063afe9$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $df832493f6e542dd$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$13d7ab2f94bb1e40$exports = $13d7ab2f94bb1e40$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $a188cd0a1c1bcfd8$var$upperFirst = $13d7ab2f94bb1e40$exports("toUpperCase");
$a188cd0a1c1bcfd8$exports = $a188cd0a1c1bcfd8$var$upperFirst;



var $6P6dz = parcelRequire("6P6dz");
var $1ad6c0b91f16d41d$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$1ad6c0b91f16d41d$exports = (parcelRequire("gwXx2"));




function $a6d9235bb0fc9a40$var$_extends() {
    $a6d9235bb0fc9a40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a6d9235bb0fc9a40$var$_extends.apply(this, arguments);
}
var $a6d9235bb0fc9a40$var$symbolFactories = {
    symbolCircle: (0, $1ad6c0b91f16d41d$exports.symbolCircle),
    symbolCross: (0, $1ad6c0b91f16d41d$exports.symbolCross),
    symbolDiamond: (0, $1ad6c0b91f16d41d$exports.symbolDiamond),
    symbolSquare: (0, $1ad6c0b91f16d41d$exports.symbolSquare),
    symbolStar: (0, $1ad6c0b91f16d41d$exports.symbolStar),
    symbolTriangle: (0, $1ad6c0b91f16d41d$exports.symbolTriangle),
    symbolWye: (0, $1ad6c0b91f16d41d$exports.symbolWye)
};
var $a6d9235bb0fc9a40$var$RADIAN = Math.PI / 180;
var $a6d9235bb0fc9a40$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($a188cd0a1c1bcfd8$exports)))(type));
    return $a6d9235bb0fc9a40$var$symbolFactories[name] || (0, $1ad6c0b91f16d41d$exports.symbolCircle);
};
var $a6d9235bb0fc9a40$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $a6d9235bb0fc9a40$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $a6d9235bb0fc9a40$var$symbolsDefaultProps = {
    type: "circle",
    size: 64,
    sizeType: "area"
};
var $a6d9235bb0fc9a40$var$registerSymbol = function registerSymbol(key, factory) {
    $a6d9235bb0fc9a40$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($a188cd0a1c1bcfd8$exports)))(key))] = factory;
};
var $a6d9235bb0fc9a40$export$fa456266707bf4e4 = function Symbols(props) {
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var size = props.size, sizeType = props.sizeType, type = props.type;
        var symbolFactory = $a6d9235bb0fc9a40$var$getSymbolFactory(type);
        var symbol = (0, $1ad6c0b91f16d41d$exports.symbol)().type(symbolFactory).size($a6d9235bb0fc9a40$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy, size = props.size;
    var filteredProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $a6d9235bb0fc9a40$var$_extends({}, filteredProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$a6d9235bb0fc9a40$export$fa456266707bf4e4.defaultProps = $a6d9235bb0fc9a40$var$symbolsDefaultProps;
$a6d9235bb0fc9a40$export$fa456266707bf4e4.registerSymbol = $a6d9235bb0fc9a40$var$registerSymbol;



function $203eeb1b95a601fa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $203eeb1b95a601fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $203eeb1b95a601fa$var$_typeof(obj);
}
function $203eeb1b95a601fa$var$_extends() {
    $203eeb1b95a601fa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $203eeb1b95a601fa$var$_extends.apply(this, arguments);
}
function $203eeb1b95a601fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $203eeb1b95a601fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $203eeb1b95a601fa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $203eeb1b95a601fa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $203eeb1b95a601fa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $203eeb1b95a601fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $203eeb1b95a601fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $203eeb1b95a601fa$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $203eeb1b95a601fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $203eeb1b95a601fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $203eeb1b95a601fa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $203eeb1b95a601fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $203eeb1b95a601fa$var$_setPrototypeOf(subClass, superClass);
}
function $203eeb1b95a601fa$var$_setPrototypeOf(o, p) {
    $203eeb1b95a601fa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $203eeb1b95a601fa$var$_setPrototypeOf(o, p);
}
function $203eeb1b95a601fa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $203eeb1b95a601fa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $203eeb1b95a601fa$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $203eeb1b95a601fa$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $203eeb1b95a601fa$var$_possibleConstructorReturn(this, result);
    };
}
function $203eeb1b95a601fa$var$_possibleConstructorReturn(self, call) {
    if (call && ($203eeb1b95a601fa$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $203eeb1b95a601fa$var$_assertThisInitialized(self);
}
function $203eeb1b95a601fa$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $203eeb1b95a601fa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $203eeb1b95a601fa$var$_getPrototypeOf(o) {
    $203eeb1b95a601fa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $203eeb1b95a601fa$var$_getPrototypeOf(o);
}
function $203eeb1b95a601fa$var$_defineProperty(obj, key, value) {
    key = $203eeb1b95a601fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $203eeb1b95a601fa$var$_toPropertyKey(arg) {
    var key = $203eeb1b95a601fa$var$_toPrimitive(arg, "string");
    return $203eeb1b95a601fa$var$_typeof(key) === "symbol" ? key : String(key);
}
function $203eeb1b95a601fa$var$_toPrimitive(input, hint) {
    if ($203eeb1b95a601fa$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($203eeb1b95a601fa$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $203eeb1b95a601fa$var$SIZE = 32;
var $203eeb1b95a601fa$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $203eeb1b95a601fa$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $203eeb1b95a601fa$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $203eeb1b95a601fa$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $203eeb1b95a601fa$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $203eeb1b95a601fa$var$SIZE / 2;
                var sixthSize = $203eeb1b95a601fa$var$SIZE / 6;
                var thirdSize = $203eeb1b95a601fa$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $203eeb1b95a601fa$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($203eeb1b95a601fa$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($203eeb1b95a601fa$var$SIZE / 8, "h").concat($203eeb1b95a601fa$var$SIZE, "v").concat($203eeb1b95a601fa$var$SIZE * 3 / 4, "h").concat(-$203eeb1b95a601fa$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(data.legendIcon)) {
                    var iconProps = $203eeb1b95a601fa$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $a6d9235bb0fc9a40$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $203eeb1b95a601fa$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $203eeb1b95a601fa$var$SIZE,
                    height: $203eeb1b95a601fa$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))((_classNames = {
                        "recharts-legend-item": true
                    }, $203eeb1b95a601fa$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $203eeb1b95a601fa$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === "none") return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("li", $203eeb1b95a601fa$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f237646aefb1d4cb$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01e8f2329e9a422e$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $6P6dz.PureComponent));
$203eeb1b95a601fa$var$_defineProperty($203eeb1b95a601fa$export$99f8d96ed0cededa, "displayName", "Legend");
$203eeb1b95a601fa$var$_defineProperty($203eeb1b95a601fa$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



function $75caf721c037b42d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $75caf721c037b42d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $75caf721c037b42d$var$_typeof(obj);
}
var $75caf721c037b42d$var$_excluded = [
    "ref"
];
function $75caf721c037b42d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75caf721c037b42d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $75caf721c037b42d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $75caf721c037b42d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $75caf721c037b42d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $75caf721c037b42d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75caf721c037b42d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $75caf721c037b42d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $75caf721c037b42d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $75caf721c037b42d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $75caf721c037b42d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $75caf721c037b42d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $75caf721c037b42d$var$_setPrototypeOf(subClass, superClass);
}
function $75caf721c037b42d$var$_setPrototypeOf(o, p) {
    $75caf721c037b42d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $75caf721c037b42d$var$_setPrototypeOf(o, p);
}
function $75caf721c037b42d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75caf721c037b42d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $75caf721c037b42d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $75caf721c037b42d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $75caf721c037b42d$var$_possibleConstructorReturn(this, result);
    };
}
function $75caf721c037b42d$var$_possibleConstructorReturn(self, call) {
    if (call && ($75caf721c037b42d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $75caf721c037b42d$var$_assertThisInitialized(self);
}
function $75caf721c037b42d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $75caf721c037b42d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $75caf721c037b42d$var$_getPrototypeOf(o) {
    $75caf721c037b42d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $75caf721c037b42d$var$_getPrototypeOf(o);
}
function $75caf721c037b42d$var$_defineProperty(obj, key, value) {
    key = $75caf721c037b42d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75caf721c037b42d$var$_toPropertyKey(arg) {
    var key = $75caf721c037b42d$var$_toPrimitive(arg, "string");
    return $75caf721c037b42d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $75caf721c037b42d$var$_toPrimitive(input, hint) {
    if ($75caf721c037b42d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($75caf721c037b42d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $75caf721c037b42d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $75caf721c037b42d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $75caf721c037b42d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $75caf721c037b42d$var$defaultUniqBy(entry) {
    return entry.value;
}
function $75caf721c037b42d$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($7df642e092a5d65c$exports)))(payload, $75caf721c037b42d$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($7df642e092a5d65c$exports)))(payload, option);
    return payload;
}
function $75caf721c037b42d$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(content, props);
    var ref = props.ref, otherProps = $75caf721c037b42d$var$_objectWithoutProperties(props, $75caf721c037b42d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $203eeb1b95a601fa$export$99f8d96ed0cededa), otherProps);
}
var $75caf721c037b42d$var$EPS = 1;
var $75caf721c037b42d$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $75caf721c037b42d$var$_inherits(Legend, _PureComponent);
    var _super = $75caf721c037b42d$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $75caf721c037b42d$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $75caf721c037b42d$var$_defineProperty($75caf721c037b42d$var$_assertThisInitialized(_this), "state", {
            boxWidth: -1,
            boxHeight: -1
        });
        return _this;
    }
    $75caf721c037b42d$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $75caf721c037b42d$var$_objectSpread($75caf721c037b42d$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $75caf721c037b42d$var$EPS || Math.abs(_box3.height - boxHeight) > $75caf721c037b42d$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $75caf721c037b42d$var$_objectSpread($75caf721c037b42d$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $75caf721c037b42d$var$renderContent(content, $75caf721c037b42d$var$_objectSpread($75caf721c037b42d$var$_objectSpread({}, this.props), {}, {
                    payload: $75caf721c037b42d$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $19512e2323c12caf$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $6P6dz.PureComponent));
$75caf721c037b42d$var$_defineProperty($75caf721c037b42d$export$ed247974535929c7, "displayName", "Legend");
$75caf721c037b42d$var$_defineProperty($75caf721c037b42d$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});

var $0c1e8ce01c84240a$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0c1e8ce01c84240a$var$isEqual(value, other) {
    return $02f753f6c05b5819$exports(value, other);
}
$0c1e8ce01c84240a$exports = $0c1e8ce01c84240a$var$isEqual;





var $6P6dz = parcelRequire("6P6dz");

var $6P6dz = parcelRequire("6P6dz");

var $fmtXm = parcelRequire("fmtXm");
var $d4f8f1cd154cb518$exports = {};
(function(global, factory) {
    factory($d4f8f1cd154cb518$exports);
})($d4f8f1cd154cb518$exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $e30e793e86401a2c$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else requestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $bced0209c2fea6af$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bced0209c2fea6af$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bced0209c2fea6af$var$_typeof(obj);
}
function $bced0209c2fea6af$var$_toArray(arr) {
    return $bced0209c2fea6af$var$_arrayWithHoles(arr) || $bced0209c2fea6af$var$_iterableToArray(arr) || $bced0209c2fea6af$var$_unsupportedIterableToArray(arr) || $bced0209c2fea6af$var$_nonIterableRest();
}
function $bced0209c2fea6af$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bced0209c2fea6af$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bced0209c2fea6af$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bced0209c2fea6af$var$_arrayLikeToArray(o, minLen);
}
function $bced0209c2fea6af$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bced0209c2fea6af$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bced0209c2fea6af$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bced0209c2fea6af$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $bced0209c2fea6af$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $e30e793e86401a2c$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $e30e793e86401a2c$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($bced0209c2fea6af$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $da8ef09ddeb2aefb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $da8ef09ddeb2aefb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $da8ef09ddeb2aefb$var$_typeof(obj);
}
function $da8ef09ddeb2aefb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $da8ef09ddeb2aefb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $da8ef09ddeb2aefb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $da8ef09ddeb2aefb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $da8ef09ddeb2aefb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $da8ef09ddeb2aefb$var$_defineProperty(obj, key, value) {
    key = $da8ef09ddeb2aefb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da8ef09ddeb2aefb$var$_toPropertyKey(arg) {
    var key = $da8ef09ddeb2aefb$var$_toPrimitive(arg, "string");
    return $da8ef09ddeb2aefb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $da8ef09ddeb2aefb$var$_toPrimitive(input, hint) {
    if ($da8ef09ddeb2aefb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($da8ef09ddeb2aefb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $da8ef09ddeb2aefb$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $da8ef09ddeb2aefb$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $da8ef09ddeb2aefb$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $da8ef09ddeb2aefb$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $da8ef09ddeb2aefb$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $da8ef09ddeb2aefb$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $da8ef09ddeb2aefb$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($da8ef09ddeb2aefb$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $da8ef09ddeb2aefb$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $da8ef09ddeb2aefb$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($da8ef09ddeb2aefb$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $da8ef09ddeb2aefb$var$_objectSpread($da8ef09ddeb2aefb$var$_objectSpread({}, result), {}, $da8ef09ddeb2aefb$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $da8ef09ddeb2aefb$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $da8ef09ddeb2aefb$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $da8ef09ddeb2aefb$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $da8ef09ddeb2aefb$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $da8ef09ddeb2aefb$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $da8ef09ddeb2aefb$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $da8ef09ddeb2aefb$var$_objectSpread($da8ef09ddeb2aefb$var$_objectSpread({}, res), {}, $da8ef09ddeb2aefb$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $da8ef09ddeb2aefb$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $da8ef09ddeb2aefb$var$_objectSpread($da8ef09ddeb2aefb$var$_objectSpread({}, res), $da8ef09ddeb2aefb$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $da8ef09ddeb2aefb$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $da8ef09ddeb2aefb$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $da8ef09ddeb2aefb$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($da8ef09ddeb2aefb$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $da8ef09ddeb2aefb$var$isDev = false;
var $da8ef09ddeb2aefb$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($da8ef09ddeb2aefb$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $945cd97aae92809f$var$_slicedToArray(arr, i) {
    return $945cd97aae92809f$var$_arrayWithHoles(arr) || $945cd97aae92809f$var$_iterableToArrayLimit(arr, i) || $945cd97aae92809f$var$_unsupportedIterableToArray(arr, i) || $945cd97aae92809f$var$_nonIterableRest();
}
function $945cd97aae92809f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $945cd97aae92809f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $945cd97aae92809f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $945cd97aae92809f$var$_toConsumableArray(arr) {
    return $945cd97aae92809f$var$_arrayWithoutHoles(arr) || $945cd97aae92809f$var$_iterableToArray(arr) || $945cd97aae92809f$var$_unsupportedIterableToArray(arr) || $945cd97aae92809f$var$_nonIterableSpread();
}
function $945cd97aae92809f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $945cd97aae92809f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $945cd97aae92809f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $945cd97aae92809f$var$_arrayLikeToArray(o, minLen);
}
function $945cd97aae92809f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $945cd97aae92809f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $945cd97aae92809f$var$_arrayLikeToArray(arr);
}
function $945cd97aae92809f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $945cd97aae92809f$var$ACCURACY = 1e-4;
var $945cd97aae92809f$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $945cd97aae92809f$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $945cd97aae92809f$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $945cd97aae92809f$var$cubicBezierFactor(c1, c2);
        return $945cd97aae92809f$var$multyTime(params, t);
    };
};
var $945cd97aae92809f$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $945cd97aae92809f$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($945cd97aae92809f$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $945cd97aae92809f$var$multyTime(newParams, t);
    };
};
var $945cd97aae92809f$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $945cd97aae92809f$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $da8ef09ddeb2aefb$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $da8ef09ddeb2aefb$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $945cd97aae92809f$var$cubicBezier(x1, x2);
    var curveY = $945cd97aae92809f$var$cubicBezier(y1, y2);
    var derCurveX = $945cd97aae92809f$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $945cd97aae92809f$var$ACCURACY || derVal < $945cd97aae92809f$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $945cd97aae92809f$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $945cd97aae92809f$var$ACCURACY && Math.abs(newV) < $945cd97aae92809f$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $945cd97aae92809f$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $945cd97aae92809f$export$56c51296f72f0592(easing);
        case "spring":
            return $945cd97aae92809f$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $945cd97aae92809f$export$56c51296f72f0592(easing);
            (0, $da8ef09ddeb2aefb$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $da8ef09ddeb2aefb$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $cf0cb4820e89f865$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cf0cb4820e89f865$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cf0cb4820e89f865$var$_typeof(obj);
}
function $cf0cb4820e89f865$var$_toConsumableArray(arr) {
    return $cf0cb4820e89f865$var$_arrayWithoutHoles(arr) || $cf0cb4820e89f865$var$_iterableToArray(arr) || $cf0cb4820e89f865$var$_unsupportedIterableToArray(arr) || $cf0cb4820e89f865$var$_nonIterableSpread();
}
function $cf0cb4820e89f865$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cf0cb4820e89f865$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cf0cb4820e89f865$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cf0cb4820e89f865$var$_arrayLikeToArray(arr);
}
function $cf0cb4820e89f865$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cf0cb4820e89f865$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cf0cb4820e89f865$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cf0cb4820e89f865$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cf0cb4820e89f865$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cf0cb4820e89f865$var$_defineProperty(obj, key, value) {
    key = $cf0cb4820e89f865$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf0cb4820e89f865$var$_toPropertyKey(arg) {
    var key = $cf0cb4820e89f865$var$_toPrimitive(arg, "string");
    return $cf0cb4820e89f865$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cf0cb4820e89f865$var$_toPrimitive(input, hint) {
    if ($cf0cb4820e89f865$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cf0cb4820e89f865$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cf0cb4820e89f865$var$_slicedToArray(arr, i) {
    return $cf0cb4820e89f865$var$_arrayWithHoles(arr) || $cf0cb4820e89f865$var$_iterableToArrayLimit(arr, i) || $cf0cb4820e89f865$var$_unsupportedIterableToArray(arr, i) || $cf0cb4820e89f865$var$_nonIterableRest();
}
function $cf0cb4820e89f865$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cf0cb4820e89f865$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cf0cb4820e89f865$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cf0cb4820e89f865$var$_arrayLikeToArray(o, minLen);
}
function $cf0cb4820e89f865$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cf0cb4820e89f865$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $cf0cb4820e89f865$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $cf0cb4820e89f865$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $cf0cb4820e89f865$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $cf0cb4820e89f865$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $da8ef09ddeb2aefb$export$d6051a0f7a227332)(function(key, val) {
        if ($cf0cb4820e89f865$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $cf0cb4820e89f865$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $da8ef09ddeb2aefb$export$d6051a0f7a227332)(function(key, val) {
        if ($cf0cb4820e89f865$var$needContinue(val)) return $cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, val), {}, {
            velocity: $cf0cb4820e89f865$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $cf0cb4820e89f865$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$cf0cb4820e89f865$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $da8ef09ddeb2aefb$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, res), {}, $cf0cb4820e89f865$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, res), {}, $cf0cb4820e89f865$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $da8ef09ddeb2aefb$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($cf0cb4820e89f865$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $cf0cb4820e89f865$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $da8ef09ddeb2aefb$export$d6051a0f7a227332)(function(key, val) {
            return $cf0cb4820e89f865$var$alpha.apply(void 0, $cf0cb4820e89f865$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $da8ef09ddeb2aefb$export$d6051a0f7a227332)(function(key, val) {
                return $cf0cb4820e89f865$var$alpha.apply(void 0, $cf0cb4820e89f865$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread($cf0cb4820e89f865$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $87bf29709524a63d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $87bf29709524a63d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $87bf29709524a63d$var$_typeof(obj);
}
var $87bf29709524a63d$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $87bf29709524a63d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $87bf29709524a63d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $87bf29709524a63d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $87bf29709524a63d$var$_toConsumableArray(arr) {
    return $87bf29709524a63d$var$_arrayWithoutHoles(arr) || $87bf29709524a63d$var$_iterableToArray(arr) || $87bf29709524a63d$var$_unsupportedIterableToArray(arr) || $87bf29709524a63d$var$_nonIterableSpread();
}
function $87bf29709524a63d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $87bf29709524a63d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $87bf29709524a63d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $87bf29709524a63d$var$_arrayLikeToArray(o, minLen);
}
function $87bf29709524a63d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $87bf29709524a63d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $87bf29709524a63d$var$_arrayLikeToArray(arr);
}
function $87bf29709524a63d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $87bf29709524a63d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87bf29709524a63d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87bf29709524a63d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87bf29709524a63d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87bf29709524a63d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87bf29709524a63d$var$_defineProperty(obj, key, value) {
    key = $87bf29709524a63d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87bf29709524a63d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87bf29709524a63d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87bf29709524a63d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87bf29709524a63d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87bf29709524a63d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87bf29709524a63d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87bf29709524a63d$var$_toPropertyKey(arg) {
    var key = $87bf29709524a63d$var$_toPrimitive(arg, "string");
    return $87bf29709524a63d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $87bf29709524a63d$var$_toPrimitive(input, hint) {
    if ($87bf29709524a63d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($87bf29709524a63d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $87bf29709524a63d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $87bf29709524a63d$var$_setPrototypeOf(subClass, superClass);
}
function $87bf29709524a63d$var$_setPrototypeOf(o, p) {
    $87bf29709524a63d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $87bf29709524a63d$var$_setPrototypeOf(o, p);
}
function $87bf29709524a63d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87bf29709524a63d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $87bf29709524a63d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $87bf29709524a63d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $87bf29709524a63d$var$_possibleConstructorReturn(this, result);
    };
}
function $87bf29709524a63d$var$_possibleConstructorReturn(self, call) {
    if (call && ($87bf29709524a63d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $87bf29709524a63d$var$_assertThisInitialized(self);
}
function $87bf29709524a63d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $87bf29709524a63d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $87bf29709524a63d$var$_getPrototypeOf(o) {
    $87bf29709524a63d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $87bf29709524a63d$var$_getPrototypeOf(o);
}
var $87bf29709524a63d$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $87bf29709524a63d$var$_inherits(Animate, _PureComponent);
    var _super = $87bf29709524a63d$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $87bf29709524a63d$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($87bf29709524a63d$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($87bf29709524a63d$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $87bf29709524a63d$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $87bf29709524a63d$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $87bf29709524a63d$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $87bf29709524a63d$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $87bf29709524a63d$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $d4f8f1cd154cb518$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $87bf29709524a63d$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $cf0cb4820e89f865$export$2e2bcd8739ae039)(from, to, (0, $945cd97aae92809f$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($87bf29709524a63d$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $da8ef09ddeb2aefb$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($87bf29709524a63d$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $da8ef09ddeb2aefb$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($87bf29709524a63d$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $bced0209c2fea6af$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $87bf29709524a63d$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $da8ef09ddeb2aefb$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $87bf29709524a63d$var$_objectWithoutProperties(_this$props4, $87bf29709524a63d$var$_excluded);
                var count = (0, $6P6dz.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $da8ef09ddeb2aefb$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $6P6dz.cloneElement)(container, $87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread({}, others), {}, {
                        style: $87bf29709524a63d$var$_objectSpread($87bf29709524a63d$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $6P6dz.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", null, (0, $6P6dz.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $6P6dz.PureComponent));
$87bf29709524a63d$var$Animate.displayName = "Animate";
$87bf29709524a63d$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$87bf29709524a63d$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).func
};
var $87bf29709524a63d$export$2e2bcd8739ae039 = $87bf29709524a63d$var$Animate;





var $6P6dz = parcelRequire("6P6dz");
var $9f41a99854f160ea$exports = {};
"use strict";

var $9f41a99854f160ea$var$_CSSTransition = $9f41a99854f160ea$var$_interopRequireDefault((parcelRequire("5rB9n")));

var $9f41a99854f160ea$var$_ReplaceTransition = $9f41a99854f160ea$var$_interopRequireDefault((parcelRequire("9Uas9")));

var $9f41a99854f160ea$var$_TransitionGroup = $9f41a99854f160ea$var$_interopRequireDefault((parcelRequire("3VdpA")));

var $9f41a99854f160ea$var$_Transition = $9f41a99854f160ea$var$_interopRequireDefault((parcelRequire("9eSsp")));
function $9f41a99854f160ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9f41a99854f160ea$exports = {
    Transition: $9f41a99854f160ea$var$_Transition.default,
    TransitionGroup: $9f41a99854f160ea$var$_TransitionGroup.default,
    ReplaceTransition: $9f41a99854f160ea$var$_ReplaceTransition.default,
    CSSTransition: $9f41a99854f160ea$var$_CSSTransition.default
};



var $fmtXm = parcelRequire("fmtXm");

var $6P6dz = parcelRequire("6P6dz");


var $fmtXm = parcelRequire("fmtXm");

var $4895cf92094f512b$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $4895cf92094f512b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4895cf92094f512b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4895cf92094f512b$var$_typeof(obj);
}
function $4895cf92094f512b$var$_extends() {
    $4895cf92094f512b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4895cf92094f512b$var$_extends.apply(this, arguments);
}
function $4895cf92094f512b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4895cf92094f512b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4895cf92094f512b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4895cf92094f512b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4895cf92094f512b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4895cf92094f512b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4895cf92094f512b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4895cf92094f512b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4895cf92094f512b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4895cf92094f512b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4895cf92094f512b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4895cf92094f512b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4895cf92094f512b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4895cf92094f512b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4895cf92094f512b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4895cf92094f512b$var$_setPrototypeOf(subClass, superClass);
}
function $4895cf92094f512b$var$_setPrototypeOf(o, p) {
    $4895cf92094f512b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4895cf92094f512b$var$_setPrototypeOf(o, p);
}
function $4895cf92094f512b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4895cf92094f512b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4895cf92094f512b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4895cf92094f512b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4895cf92094f512b$var$_possibleConstructorReturn(this, result);
    };
}
function $4895cf92094f512b$var$_possibleConstructorReturn(self, call) {
    if (call && ($4895cf92094f512b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4895cf92094f512b$var$_assertThisInitialized(self);
}
function $4895cf92094f512b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4895cf92094f512b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4895cf92094f512b$var$_getPrototypeOf(o) {
    $4895cf92094f512b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4895cf92094f512b$var$_getPrototypeOf(o);
}
function $4895cf92094f512b$var$_defineProperty(obj, key, value) {
    key = $4895cf92094f512b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4895cf92094f512b$var$_toPropertyKey(arg) {
    var key = $4895cf92094f512b$var$_toPrimitive(arg, "string");
    return $4895cf92094f512b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4895cf92094f512b$var$_toPrimitive(input, hint) {
    if ($4895cf92094f512b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4895cf92094f512b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $4895cf92094f512b$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $4895cf92094f512b$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $4895cf92094f512b$var$_inherits(AnimateGroupChild, _Component);
    var _super = $4895cf92094f512b$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $4895cf92094f512b$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $4895cf92094f512b$var$_defineProperty($4895cf92094f512b$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $4895cf92094f512b$var$_defineProperty($4895cf92094f512b$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $4895cf92094f512b$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($4895cf92094f512b$var$_objectSpread($4895cf92094f512b$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $4895cf92094f512b$var$parseDurationOfSingleTransition(appearOptions) + $4895cf92094f512b$var$parseDurationOfSingleTransition(enterOptions) + $4895cf92094f512b$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $4895cf92094f512b$var$_objectWithoutProperties(_this$props3, $4895cf92094f512b$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $9f41a99854f160ea$exports.Transition), $4895cf92094f512b$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $87bf29709524a63d$export$2e2bcd8739ae039), _this2.state, (0, $6P6dz.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $6P6dz.Component));
$4895cf92094f512b$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).element
};
var $4895cf92094f512b$export$2e2bcd8739ae039 = $4895cf92094f512b$var$AnimateGroupChild;


function $a93bb58d9b6aa2e6$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $9f41a99854f160ea$exports.TransitionGroup), {
        component: component
    }, (0, $6P6dz.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $4895cf92094f512b$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$a93bb58d9b6aa2e6$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($fmtXm))).any
};
$a93bb58d9b6aa2e6$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $a93bb58d9b6aa2e6$export$2e2bcd8739ae039 = $a93bb58d9b6aa2e6$var$AnimateGroup;


var $df4da97760c8f167$export$2e2bcd8739ae039 = (0, $87bf29709524a63d$export$2e2bcd8739ae039);







var $6P6dz = parcelRequire("6P6dz");





function $45580be9bbfd5120$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $45580be9bbfd5120$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $45580be9bbfd5120$var$_typeof(obj);
}
function $45580be9bbfd5120$var$_extends() {
    $45580be9bbfd5120$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45580be9bbfd5120$var$_extends.apply(this, arguments);
}
function $45580be9bbfd5120$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $45580be9bbfd5120$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $45580be9bbfd5120$var$ownKeys(Object(source), !0).forEach(function(key) {
            $45580be9bbfd5120$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $45580be9bbfd5120$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $45580be9bbfd5120$var$_defineProperty(obj, key, value) {
    key = $45580be9bbfd5120$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $45580be9bbfd5120$var$_toPropertyKey(arg) {
    var key = $45580be9bbfd5120$var$_toPrimitive(arg, "string");
    return $45580be9bbfd5120$var$_typeof(key) === "symbol" ? key : String(key);
}
function $45580be9bbfd5120$var$_toPrimitive(input, hint) {
    if ($45580be9bbfd5120$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($45580be9bbfd5120$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $45580be9bbfd5120$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $1ad6c0b91f16d41d$exports.curveBasisClosed),
    curveBasisOpen: (0, $1ad6c0b91f16d41d$exports.curveBasisOpen),
    curveBasis: (0, $1ad6c0b91f16d41d$exports.curveBasis),
    curveBumpX: (0, $1ad6c0b91f16d41d$exports.curveBumpX),
    curveBumpY: (0, $1ad6c0b91f16d41d$exports.curveBumpY),
    curveLinearClosed: (0, $1ad6c0b91f16d41d$exports.curveLinearClosed),
    curveLinear: (0, $1ad6c0b91f16d41d$exports.curveLinear),
    curveMonotoneX: (0, $1ad6c0b91f16d41d$exports.curveMonotoneX),
    curveMonotoneY: (0, $1ad6c0b91f16d41d$exports.curveMonotoneY),
    curveNatural: (0, $1ad6c0b91f16d41d$exports.curveNatural),
    curveStep: (0, $1ad6c0b91f16d41d$exports.curveStep),
    curveStepAfter: (0, $1ad6c0b91f16d41d$exports.curveStepAfter),
    curveStepBefore: (0, $1ad6c0b91f16d41d$exports.curveStepBefore)
};
var $45580be9bbfd5120$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $45580be9bbfd5120$var$getX = function getX(p) {
    return p.x;
};
var $45580be9bbfd5120$var$getY = function getY(p) {
    return p.y;
};
var $45580be9bbfd5120$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($a188cd0a1c1bcfd8$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $45580be9bbfd5120$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $45580be9bbfd5120$var$CURVE_FACTORIES[name] || (0, $1ad6c0b91f16d41d$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $45580be9bbfd5120$var$getPath = function getPath(_ref) {
    var type = _ref.type, points = _ref.points, baseLine = _ref.baseLine, layout = _ref.layout, connectNulls = _ref.connectNulls;
    var curveFactory = $45580be9bbfd5120$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $45580be9bbfd5120$var$defined(entry);
    }) : points;
    var lineFunction;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $45580be9bbfd5120$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $45580be9bbfd5120$var$_objectSpread($45580be9bbfd5120$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $1ad6c0b91f16d41d$exports.area)().y($45580be9bbfd5120$var$getY).x1($45580be9bbfd5120$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $1ad6c0b91f16d41d$exports.area)().x($45580be9bbfd5120$var$getX).y1($45580be9bbfd5120$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($45580be9bbfd5120$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $19512e2323c12caf$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $1ad6c0b91f16d41d$exports.area)().y($45580be9bbfd5120$var$getY).x1($45580be9bbfd5120$var$getX).x0(baseLine);
    else if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $1ad6c0b91f16d41d$exports.area)().x($45580be9bbfd5120$var$getX).y1($45580be9bbfd5120$var$getY).y0(baseLine);
    else lineFunction = (0, $1ad6c0b91f16d41d$exports.line)().x($45580be9bbfd5120$var$getX).y($45580be9bbfd5120$var$getY);
    lineFunction.defined($45580be9bbfd5120$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $45580be9bbfd5120$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $45580be9bbfd5120$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $45580be9bbfd5120$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props), (0, $f237646aefb1d4cb$export$7c4c290a4a9c1b1e)(props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};
$45580be9bbfd5120$export$b0e83c3ef8d2db1.defaultProps = {
    type: "linear",
    points: [],
    connectNulls: false
};



var $6P6dz = parcelRequire("6P6dz");



function $5a9ccb48149eca10$var$_extends() {
    $5a9ccb48149eca10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a9ccb48149eca10$var$_extends.apply(this, arguments);
}
var $5a9ccb48149eca10$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("circle", $5a9ccb48149eca10$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props), (0, $f237646aefb1d4cb$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};



var $6P6dz = parcelRequire("6P6dz");


var $01d8ac5908bec9bc$var$_excluded = [
    "children",
    "className"
];
function $01d8ac5908bec9bc$var$_extends() {
    $01d8ac5908bec9bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01d8ac5908bec9bc$var$_extends.apply(this, arguments);
}
function $01d8ac5908bec9bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $01d8ac5908bec9bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $01d8ac5908bec9bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $01d8ac5908bec9bc$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $01d8ac5908bec9bc$var$_objectWithoutProperties(props, $01d8ac5908bec9bc$var$_excluded);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", $01d8ac5908bec9bc$var$_extends({
        className: layerClass
    }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});





var $6dc665014ff8a618$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $6dc665014ff8a618$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$6dc665014ff8a618$exports = $6dc665014ff8a618$var$last;




var $6P6dz = parcelRequire("6P6dz");




var $6P6dz = parcelRequire("6P6dz");



var $6P6dz = parcelRequire("6P6dz");
var $f3323d5eeb92d423$exports = {};
"use strict";
Object.defineProperty($f3323d5eeb92d423$exports, "__esModule", {
    value: true
});
var $745321b20545ab9e$exports = {};
var $c64dea71e6989807$exports = {};
var $c64dea71e6989807$var$openParentheses = "(".charCodeAt(0);
var $c64dea71e6989807$var$closeParentheses = ")".charCodeAt(0);
var $c64dea71e6989807$var$singleQuote = "'".charCodeAt(0);
var $c64dea71e6989807$var$doubleQuote = '"'.charCodeAt(0);
var $c64dea71e6989807$var$backslash = "\\".charCodeAt(0);
var $c64dea71e6989807$var$slash = "/".charCodeAt(0);
var $c64dea71e6989807$var$comma = ",".charCodeAt(0);
var $c64dea71e6989807$var$colon = ":".charCodeAt(0);
var $c64dea71e6989807$var$star = "*".charCodeAt(0);
$c64dea71e6989807$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $c64dea71e6989807$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $c64dea71e6989807$var$comma || code === $c64dea71e6989807$var$colon || code === $c64dea71e6989807$var$slash && value.charCodeAt(next + 1) !== $c64dea71e6989807$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $c64dea71e6989807$var$singleQuote || code === $c64dea71e6989807$var$doubleQuote) {
            next = pos;
            quote = code === $c64dea71e6989807$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $c64dea71e6989807$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $c64dea71e6989807$var$slash && value.charCodeAt(pos + 1) === $c64dea71e6989807$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $c64dea71e6989807$var$slash || code === $c64dea71e6989807$var$comma || code === $c64dea71e6989807$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($c64dea71e6989807$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $c64dea71e6989807$var$singleQuote && code !== $c64dea71e6989807$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $c64dea71e6989807$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($c64dea71e6989807$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $c64dea71e6989807$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $c64dea71e6989807$var$singleQuote || code === $c64dea71e6989807$var$doubleQuote || code === $c64dea71e6989807$var$comma || code === $c64dea71e6989807$var$colon || code === $c64dea71e6989807$var$slash || code === $c64dea71e6989807$var$openParentheses || code === $c64dea71e6989807$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($c64dea71e6989807$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $976deeadf4b2d1e4$exports = {};
$976deeadf4b2d1e4$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $2cb403ca59fc989e$exports = {};
function $2cb403ca59fc989e$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $2cb403ca59fc989e$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $2cb403ca59fc989e$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $2cb403ca59fc989e$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $2cb403ca59fc989e$var$stringifyNode(nodes, custom);
}
$2cb403ca59fc989e$exports = $2cb403ca59fc989e$var$stringify;


function $745321b20545ab9e$var$ValueParser(value) {
    if (this instanceof $745321b20545ab9e$var$ValueParser) {
        this.nodes = $c64dea71e6989807$exports(value);
        return this;
    }
    return new $745321b20545ab9e$var$ValueParser(value);
}
$745321b20545ab9e$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $2cb403ca59fc989e$exports(this.nodes) : "";
};
$745321b20545ab9e$var$ValueParser.prototype.walk = function(cb, bubble) {
    $976deeadf4b2d1e4$exports(this.nodes, cb, bubble);
    return this;
};

$745321b20545ab9e$var$ValueParser.unit = (parcelRequire("2FCkW"));
$745321b20545ab9e$var$ValueParser.walk = $976deeadf4b2d1e4$exports;
$745321b20545ab9e$var$ValueParser.stringify = $2cb403ca59fc989e$exports;
$745321b20545ab9e$exports = $745321b20545ab9e$var$ValueParser;


var $f3323d5eeb92d423$var$_postcssValueParser2 = $f3323d5eeb92d423$var$_interopRequireDefault($745321b20545ab9e$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $9e09fcb81082ec2e$export$8f49e4af10703ce3;
var $9e09fcb81082ec2e$export$7acfa6ed01010e37;
var $9e09fcb81082ec2e$export$98e6a39c04603d36;
var $9e09fcb81082ec2e$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, "name", {
            enumerable: false,
            writable: false,
            value: "JisonParserError"
        });
        if (msg == null) msg = "???";
        Object.defineProperty(this, "message", {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty("captureStackTrace")) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, "stack", {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = "JisonParserError";
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === "function") {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return "end of input";
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: "MathExpression",
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: "LengthValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: "AngleValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: "TimeValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: "FrequencyValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: "ResolutionValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: "EmValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "em"
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: "ExValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ex"
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: "ChValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ch"
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: "RemValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "rem"
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: "VhValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vh"
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: "VwValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vw"
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: "VminValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmin"
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: "VmaxValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmax"
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: "PercentageValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "%"
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === "function") this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === "function") this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== "function") ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error("assertion failed: " + (msg || "***"));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === "undefined" && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === "function") this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === "function") this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === "function") {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === "function") lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === "number") errStr = "Parse error on line " + (lexer.yylineno + 1) + ": ";
                            else errStr = "Parse error: ";
                            if (typeof lexer.showPosition === "function") errStr += "\n" + lexer.showPosition(69, 10) + "\n";
                            if (expected.length) errStr += "Expecting " + expected.join(", ") + ", got unexpected " + errSymbolDescr;
                            else errStr += "Unexpected " + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== "undefined") retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo("Parsing halted. No viable error recovery approach available due to internal system failure.", null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== "undefined") {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== "undefined") retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === "function" && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo("Parsing aborted due to exception.", ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== "undefined") retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, "name", {
                enumerable: false,
                writable: false,
                value: "JisonLexerError"
            });
            if (msg == null) msg = "???";
            Object.defineProperty(this, "message", {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty("captureStackTrace")) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, "stack", {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = "JisonLexerError";
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: "",
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: "",
            matched: "",
            matches: false,
            yytext: "",
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = "" + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf("\n") > 0 && msg.indexOf("^") > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === "function") {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += "\n";
                        msg += "\n  Erroneous area:\n" + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === "function") {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== "\n" && pos_str[0] !== "\n") msg += "\n" + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === "function") return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === "function") return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = "";
                if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": " + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput("", {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = "";
                this.yyleng = 0;
                this.match = "";
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === "number") rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || "";
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== "string") {
                    if (rv) this._input = "" + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === "\n") lines = true;
                else if (ch === "\r") {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === "\n") {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = "";
                    if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).", false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(-maxLines);
                past = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = "..." + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(0, maxLines);
                next = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + "...";
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, " ");
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, " ") + "\n" + c + "^";
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split("\n");
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(" ");
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ": " + line;
                    var errpfx = new Array(lineno_display_width + 1).join("^");
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join(".");
                        var mark = new Array(len).join("^");
                        rv += "\n" + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, " ");
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(" ") + "  (...continued...)";
                    intermediate_line += "\n" + new Array(lineno_display_width + 1).join("-") + "  (---------------)";
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join("\n");
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = "line " + l1 + ", ";
                    if (dc <= 1) rv += "column " + c1;
                    else rv += "columns " + c1 + " .. " + c2;
                } else rv = "lines " + l1 + "(column " + c1 + ") .. " + l2 + "(column " + c2 + ")";
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += " {String Offset: " + r1 + "}";
                    else rv += " {String Offset range: " + r1 + " .. " + r2 + "}";
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = "";
                        if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo("Internal lexer engine error" + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = "";
                    if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": Unrecognized text.", this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === "function") r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === "function" || typeof this.options.pre_lex === "function" || this.yy && typeof this.yy.pre_lex === "function" || this.yy && typeof this.yy.post_lex === "function" || typeof this.options.post_lex === "function" || typeof this.post_lex === "function") && typeof this.fastLex === "function"
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions["INITIAL"];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                "INITIAL": {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$9e09fcb81082ec2e$export$8f49e4af10703ce3 = $9e09fcb81082ec2e$var$parser;
$9e09fcb81082ec2e$export$7acfa6ed01010e37 = $9e09fcb81082ec2e$var$parser.Parser;
$9e09fcb81082ec2e$export$98e6a39c04603d36 = function() {
    return $9e09fcb81082ec2e$var$parser.parse.apply($9e09fcb81082ec2e$var$parser, arguments);
};


var $e66c68dfbbe96805$exports = {};
"use strict";
Object.defineProperty($e66c68dfbbe96805$exports, "__esModule", {
    value: true
});
$e66c68dfbbe96805$exports.flip = $e66c68dfbbe96805$var$flip;
var $b5b6aff9d53dc3d4$exports = {};
"use strict";
Object.defineProperty($b5b6aff9d53dc3d4$exports, "__esModule", {
    value: true
});
var $690897c2229157cc$exports = {};
var $690897c2229157cc$var$conversions = {
    // length
    "px": {
        "px": 1,
        "cm": 96.0 / 2.54,
        "mm": 96.0 / 25.4,
        "in": 96,
        "pt": 96.0 / 72.0,
        "pc": 16
    },
    "cm": {
        "px": 2.54 / 96.0,
        "cm": 1,
        "mm": 0.1,
        "in": 2.54,
        "pt": 2.54 / 72.0,
        "pc": 2.54 / 6.0
    },
    "mm": {
        "px": 25.4 / 96.0,
        "cm": 10,
        "mm": 1,
        "in": 25.4,
        "pt": 25.4 / 72.0,
        "pc": 25.4 / 6.0
    },
    "in": {
        "px": 1.0 / 96.0,
        "cm": 1.0 / 2.54,
        "mm": 1.0 / 25.4,
        "in": 1,
        "pt": 1.0 / 72.0,
        "pc": 1.0 / 6.0
    },
    "pt": {
        "px": 0.75,
        "cm": 72.0 / 2.54,
        "mm": 72.0 / 25.4,
        "in": 72,
        "pt": 1,
        "pc": 12
    },
    "pc": {
        "px": 0.0625,
        "cm": 6.0 / 2.54,
        "mm": 6.0 / 25.4,
        "in": 6,
        "pt": 6.0 / 72.0,
        "pc": 1
    },
    // angle
    "deg": {
        "deg": 1,
        "grad": 0.9,
        "rad": 180 / Math.PI,
        "turn": 360
    },
    "grad": {
        "deg": 400 / 360,
        "grad": 1,
        "rad": 200 / Math.PI,
        "turn": 400
    },
    "rad": {
        "deg": Math.PI / 180,
        "grad": Math.PI / 200,
        "rad": 1,
        "turn": Math.PI * 2
    },
    "turn": {
        "deg": 1 / 360,
        "grad": 1 / 400,
        "rad": 0.5 / Math.PI,
        "turn": 1
    },
    // time
    "s": {
        "s": 1,
        "ms": 0.001
    },
    "ms": {
        "s": 1000,
        "ms": 1
    },
    // frequency
    "Hz": {
        "Hz": 1,
        "kHz": 1000
    },
    "kHz": {
        "Hz": 0.001,
        "kHz": 1
    },
    // resolution
    "dpi": {
        "dpi": 1,
        "dpcm": 1.0 / 2.54,
        "dppx": 1 / 96
    },
    "dpcm": {
        "dpi": 2.54,
        "dpcm": 1,
        "dppx": 2.54 / 96.0
    },
    "dppx": {
        "dpi": 96,
        "dpcm": 96.0 / 2.54,
        "dppx": 1
    }
};
$690897c2229157cc$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$690897c2229157cc$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$690897c2229157cc$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $690897c2229157cc$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $b5b6aff9d53dc3d4$var$_cssUnitConverter2 = $b5b6aff9d53dc3d4$var$_interopRequireDefault($690897c2229157cc$exports);
function $b5b6aff9d53dc3d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5b6aff9d53dc3d4$var$convertNodes(left, right, precision) {
    switch(left.type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
            return $b5b6aff9d53dc3d4$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $b5b6aff9d53dc3d4$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $b5b6aff9d53dc3d4$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$b5b6aff9d53dc3d4$exports.default = $b5b6aff9d53dc3d4$var$convertNodes;
$b5b6aff9d53dc3d4$exports = $b5b6aff9d53dc3d4$exports["default"];


var $e66c68dfbbe96805$var$_convert2 = $e66c68dfbbe96805$var$_interopRequireDefault($b5b6aff9d53dc3d4$exports);
function $e66c68dfbbe96805$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e66c68dfbbe96805$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $e66c68dfbbe96805$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $e66c68dfbbe96805$var$reduce(node.value, precision);
    return node;
}
function $e66c68dfbbe96805$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $e66c68dfbbe96805$var$isValueType(type) {
    switch(type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
        case "EmValue":
        case "ExValue":
        case "ChValue":
        case "RemValue":
        case "VhValue":
        case "VwValue":
        case "VminValue":
        case "VmaxValue":
        case "PercentageValue":
        case "Value":
            return true;
    }
    return false;
}
function $e66c68dfbbe96805$var$convertMathExpression(node, precision) {
    var nodes = (0, $e66c68dfbbe96805$var$_convert2.default)(node.left, node.right, precision);
    var left = $e66c68dfbbe96805$var$reduce(nodes.left, precision);
    var right = $e66c68dfbbe96805$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
            if ($e66c68dfbbe96805$var$isEqual(left.right, right.right)) nodes = (0, $e66c68dfbbe96805$var$_convert2.default)(left.left, right.left, precision);
            else if ($e66c68dfbbe96805$var$isEqual(left.right, right.left)) nodes = (0, $e66c68dfbbe96805$var$_convert2.default)(left.left, right.right, precision);
            left = $e66c68dfbbe96805$var$reduce(nodes.left, precision);
            right = $e66c68dfbbe96805$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $e66c68dfbbe96805$var$flip(operator) {
    return operator === "+" ? "-" : "+";
}
function $e66c68dfbbe96805$var$flipValue(node) {
    if ($e66c68dfbbe96805$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == "MathExpression") {
        node.left = $e66c68dfbbe96805$var$flipValue(node.left);
        node.right = $e66c68dfbbe96805$var$flipValue(node.right);
    }
    return node;
}
function $e66c68dfbbe96805$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === "CssVariable" || right.type === "CssVariable") return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $e66c68dfbbe96805$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $e66c68dfbbe96805$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($e66c68dfbbe96805$var$isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $e66c68dfbbe96805$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === "-" ? $e66c68dfbbe96805$var$flip(right.operator) : right.operator;
            return $e66c68dfbbe96805$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $e66c68dfbbe96805$var$reduce({
                type: "MathExpression",
                operator: op === "-" ? $e66c68dfbbe96805$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $e66c68dfbbe96805$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && $e66c68dfbbe96805$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $e66c68dfbbe96805$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $e66c68dfbbe96805$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === "-") {
                node.right = $e66c68dfbbe96805$var$reduce({
                    type: "MathExpression",
                    operator: op === "-" ? "+" : "-",
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === "-" ? "-" : "+";
            } else node.right = $e66c68dfbbe96805$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === "-" ? "+" : "-";
            }
            return $e66c68dfbbe96805$var$reduce(node, precision);
        }
    }
    return node;
}
function $e66c68dfbbe96805$var$reduceDivisionExpression(node, precision) {
    if (!$e66c68dfbbe96805$var$isValueType(node.right.type)) return node;
    if (node.right.type !== "Value") throw new Error('Cannot divide by "' + node.right.unit + '", number expected');
    if (node.right.value === 0) throw new Error("Cannot divide by zero");
    // (expr) / value
    if (node.left.type === "MathExpression") {
        if ($e66c68dfbbe96805$var$isValueType(node.left.left.type) && $e66c68dfbbe96805$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $e66c68dfbbe96805$var$reduce(node.left, precision);
        }
        return node;
    } else if ($e66c68dfbbe96805$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $e66c68dfbbe96805$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === "MathExpression" && node.right.type === "Value") {
        if ($e66c68dfbbe96805$var$isValueType(node.left.left.type) && $e66c68dfbbe96805$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($e66c68dfbbe96805$var$isValueType(node.left.type) && node.right.type === "Value") {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === "Value" && node.right.type === "MathExpression") {
        if ($e66c68dfbbe96805$var$isValueType(node.right.left.type) && $e66c68dfbbe96805$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === "Value" && $e66c68dfbbe96805$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $e66c68dfbbe96805$var$reduceMathExpression(node, precision) {
    node = $e66c68dfbbe96805$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $e66c68dfbbe96805$var$reduceAddSubExpression(node, precision);
        case "/":
            return $e66c68dfbbe96805$var$reduceDivisionExpression(node, precision);
        case "*":
            return $e66c68dfbbe96805$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$e66c68dfbbe96805$exports.default = $e66c68dfbbe96805$var$reduce;


var $f3323d5eeb92d423$var$_reducer2 = $f3323d5eeb92d423$var$_interopRequireDefault($e66c68dfbbe96805$exports);
var $a28ecbe9189edafb$exports = {};
"use strict";
Object.defineProperty($a28ecbe9189edafb$exports, "__esModule", {
    value: true
});
$a28ecbe9189edafb$exports.default = function(calc, node, precision) {
    var str = $a28ecbe9189edafb$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $a28ecbe9189edafb$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $a28ecbe9189edafb$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $a28ecbe9189edafb$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === "MathExpression" && $a28ecbe9189edafb$var$order[op] < $a28ecbe9189edafb$var$order[left.operator]) str += "(" + $a28ecbe9189edafb$var$stringify(left, prec) + ")";
            else str += $a28ecbe9189edafb$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === "MathExpression" && $a28ecbe9189edafb$var$order[op] < $a28ecbe9189edafb$var$order[right.operator]) str += "(" + $a28ecbe9189edafb$var$stringify(right, prec) + ")";
            else if (right.type === "MathExpression" && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $e66c68dfbbe96805$exports.flip)(right.operator);
                str += $a28ecbe9189edafb$var$stringify(right, prec);
            } else str += $a28ecbe9189edafb$var$stringify(right, prec);
            return str;
        case "Value":
            return $a28ecbe9189edafb$var$round(node.value, prec);
        case "CssVariable":
            if (node.fallback) return "var(" + node.value + ", " + $a28ecbe9189edafb$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case "Calc":
            if (node.prefix) return "-" + node.prefix + "-calc(" + $a28ecbe9189edafb$var$stringify(node.value, prec) + ")";
            return "calc(" + $a28ecbe9189edafb$var$stringify(node.value, prec) + ")";
        default:
            return $a28ecbe9189edafb$var$round(node.value, prec) + node.unit;
    }
}
$a28ecbe9189edafb$exports = $a28ecbe9189edafb$exports["default"];


var $f3323d5eeb92d423$var$_stringifier2 = $f3323d5eeb92d423$var$_interopRequireDefault($a28ecbe9189edafb$exports);
function $f3323d5eeb92d423$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $f3323d5eeb92d423$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$f3323d5eeb92d423$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $f3323d5eeb92d423$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== "function" || !$f3323d5eeb92d423$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $f3323d5eeb92d423$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
        var ast = $9e09fcb81082ec2e$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $f3323d5eeb92d423$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = "word";
        node.value = (0, $f3323d5eeb92d423$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$f3323d5eeb92d423$exports = $f3323d5eeb92d423$exports["default"];




var $081f9655fb2f2af0$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $081f9655fb2f2af0$export$98f03c5d19621d70 = {
    isSsr: $081f9655fb2f2af0$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $081f9655fb2f2af0$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $081f9655fb2f2af0$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $081f9655fb2f2af0$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $34d5136d44d32c45$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $34d5136d44d32c45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $34d5136d44d32c45$var$_typeof(obj);
}
function $34d5136d44d32c45$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $34d5136d44d32c45$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $34d5136d44d32c45$var$ownKeys(Object(source), !0).forEach(function(key) {
            $34d5136d44d32c45$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $34d5136d44d32c45$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $34d5136d44d32c45$var$_defineProperty(obj, key, value) {
    key = $34d5136d44d32c45$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $34d5136d44d32c45$var$_toPropertyKey(arg) {
    var key = $34d5136d44d32c45$var$_toPrimitive(arg, "string");
    return $34d5136d44d32c45$var$_typeof(key) === "symbol" ? key : String(key);
}
function $34d5136d44d32c45$var$_toPrimitive(input, hint) {
    if ($34d5136d44d32c45$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($34d5136d44d32c45$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $34d5136d44d32c45$var$_toConsumableArray(arr) {
    return $34d5136d44d32c45$var$_arrayWithoutHoles(arr) || $34d5136d44d32c45$var$_iterableToArray(arr) || $34d5136d44d32c45$var$_unsupportedIterableToArray(arr) || $34d5136d44d32c45$var$_nonIterableSpread();
}
function $34d5136d44d32c45$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $34d5136d44d32c45$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $34d5136d44d32c45$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $34d5136d44d32c45$var$_arrayLikeToArray(o, minLen);
}
function $34d5136d44d32c45$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $34d5136d44d32c45$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $34d5136d44d32c45$var$_arrayLikeToArray(arr);
}
function $34d5136d44d32c45$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $34d5136d44d32c45$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $34d5136d44d32c45$var$MAX_CACHE_NUM = 2000;
var $34d5136d44d32c45$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $34d5136d44d32c45$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $34d5136d44d32c45$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $34d5136d44d32c45$var$autoCompleteStyle(name, value) {
    if ($34d5136d44d32c45$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $34d5136d44d32c45$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($34d5136d44d32c45$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($34d5136d44d32c45$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $34d5136d44d32c45$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($34d5136d44d32c45$var$camelToMiddleLine(s), ":").concat($34d5136d44d32c45$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
var $34d5136d44d32c45$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $34d5136d44d32c45$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($34d5136d44d32c45$var$stringCache.widthCache[cacheKey]) return $34d5136d44d32c45$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($34d5136d44d32c45$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $34d5136d44d32c45$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $34d5136d44d32c45$var$_objectSpread($34d5136d44d32c45$var$_objectSpread({}, $34d5136d44d32c45$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $34d5136d44d32c45$var$stringCache.widthCache[cacheKey] = result;
        if (++$34d5136d44d32c45$var$stringCache.cacheCount > $34d5136d44d32c45$var$MAX_CACHE_NUM) {
            $34d5136d44d32c45$var$stringCache.cacheCount = 0;
            $34d5136d44d32c45$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $34d5136d44d32c45$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    };
    // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== "undefined") box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $34d5136d44d32c45$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


var $19d8402d51c91e20$var$_excluded = [
    "dx",
    "dy",
    "textAnchor",
    "verticalAnchor",
    "scaleToFit",
    "angle",
    "lineHeight",
    "capHeight",
    "className",
    "breakAll"
];
function $19d8402d51c91e20$var$_extends() {
    $19d8402d51c91e20$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19d8402d51c91e20$var$_extends.apply(this, arguments);
}
function $19d8402d51c91e20$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $19d8402d51c91e20$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $19d8402d51c91e20$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $19d8402d51c91e20$var$_slicedToArray(arr, i) {
    return $19d8402d51c91e20$var$_arrayWithHoles(arr) || $19d8402d51c91e20$var$_iterableToArrayLimit(arr, i) || $19d8402d51c91e20$var$_unsupportedIterableToArray(arr, i) || $19d8402d51c91e20$var$_nonIterableRest();
}
function $19d8402d51c91e20$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $19d8402d51c91e20$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $19d8402d51c91e20$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $19d8402d51c91e20$var$_arrayLikeToArray(o, minLen);
}
function $19d8402d51c91e20$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $19d8402d51c91e20$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $19d8402d51c91e20$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $19d8402d51c91e20$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $19d8402d51c91e20$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($19d8402d51c91e20$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $34d5136d44d32c45$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $34d5136d44d32c45$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $19d8402d51c91e20$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $19512e2323c12caf$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "…";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $19d8402d51c91e20$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $19d8402d51c91e20$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $19d8402d51c91e20$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $19d8402d51c91e20$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(children) ? children.toString().split($19d8402d51c91e20$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $19d8402d51c91e20$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $19d8402d51c91e20$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $19d8402d51c91e20$var$getWordsWithoutCalculate(children);
        return $19d8402d51c91e20$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $19d8402d51c91e20$var$getWordsWithoutCalculate(children);
};
var $19d8402d51c91e20$var$textDefaultProps = {
    x: 0,
    y: 0,
    lineHeight: "1em",
    capHeight: "0.71em",
    // Magic number from d3
    scaleToFit: false,
    textAnchor: "start",
    verticalAnchor: "end",
    // Maintain compat with existing charts / default SVG behavior
    fill: "#808080"
};
var $19d8402d51c91e20$export$5f1af8db9871e1d6 = function Text(props) {
    var wordsByLines = (0, $6P6dz.useMemo)(function() {
        return $19d8402d51c91e20$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: props.scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        props.scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, textAnchor = props.textAnchor, verticalAnchor = props.verticalAnchor, scaleToFit = props.scaleToFit, angle = props.angle, lineHeight = props.lineHeight, capHeight = props.capHeight, className = props.className, breakAll = props.breakAll, textProps = $19d8402d51c91e20$var$_objectWithoutProperties(props, $19d8402d51c91e20$var$_excluded);
    if (!(0, $19512e2323c12caf$export$402a499e1ea44294)(textProps.x) || !(0, $19512e2323c12caf$export$402a499e1ea44294)(textProps.y)) return null;
    var x = textProps.x + ((0, $19512e2323c12caf$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = textProps.y + ((0, $19512e2323c12caf$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f3323d5eeb92d423$exports)))("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f3323d5eeb92d423$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($f3323d5eeb92d423$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $19512e2323c12caf$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("text", $19d8402d51c91e20$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-text", className),
        textAnchor: textAnchor,
        fill: textProps.fill.includes("url") ? $19d8402d51c91e20$var$textDefaultProps.fill : textProps.fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? "" : " ")));
    }));
};
$19d8402d51c91e20$export$5f1af8db9871e1d6.defaultProps = $19d8402d51c91e20$var$textDefaultProps;







var $6bc233c5107ae9f1$exports = {};
var $92dd49a302c29ed5$exports = {};

var $4b33959a0948c7ba$exports = {};



/** Built-in value references. */ var $4b33959a0948c7ba$var$spreadableSymbol = $f2f45a50d52ee367$exports ? $f2f45a50d52ee367$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $4b33959a0948c7ba$var$isFlattenable(value) {
    return $d14e2831379630a0$exports(value) || $4caa1bfd4c747bb9$exports(value) || !!($4b33959a0948c7ba$var$spreadableSymbol && value && value[$4b33959a0948c7ba$var$spreadableSymbol]);
}
$4b33959a0948c7ba$exports = $4b33959a0948c7ba$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $92dd49a302c29ed5$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $4b33959a0948c7ba$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $92dd49a302c29ed5$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $821c039cd134d3ce$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$92dd49a302c29ed5$exports = $92dd49a302c29ed5$var$baseFlatten;


var $eabbffb080133d6b$exports = {};



var $7d8e5499d44972b9$exports = {};
var $1ed335bc48f220a3$exports = {};
var $87b5830fdeb5f00b$exports = {};
var $db7e8b85f391f361$exports = {};
var $e272d61168fb8200$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e272d61168fb8200$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e272d61168fb8200$exports = $e272d61168fb8200$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $db7e8b85f391f361$var$baseFor = $e272d61168fb8200$exports();
$db7e8b85f391f361$exports = $db7e8b85f391f361$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $87b5830fdeb5f00b$var$baseForOwn(object, iteratee) {
    return object && $db7e8b85f391f361$exports(object, iteratee, $b5bd9c92554c187b$exports);
}
$87b5830fdeb5f00b$exports = $87b5830fdeb5f00b$var$baseForOwn;


var $27253a5fbfdb0ede$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $27253a5fbfdb0ede$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$940b538c55f91a86$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$27253a5fbfdb0ede$exports = $27253a5fbfdb0ede$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $1ed335bc48f220a3$var$baseEach = $27253a5fbfdb0ede$exports($87b5830fdeb5f00b$exports);
$1ed335bc48f220a3$exports = $1ed335bc48f220a3$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7d8e5499d44972b9$var$baseMap(collection, iteratee) {
    var index = -1, result = $940b538c55f91a86$exports(collection) ? Array(collection.length) : [];
    $1ed335bc48f220a3$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$7d8e5499d44972b9$exports = $7d8e5499d44972b9$var$baseMap;


var $3d38c8d103ccc875$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $3d38c8d103ccc875$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$3d38c8d103ccc875$exports = $3d38c8d103ccc875$var$baseSortBy;



var $d4d4cfbeabf581cf$exports = {};
var $db9248eb26f38123$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $db9248eb26f38123$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $1712c8f0589f33db$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $1712c8f0589f33db$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$db9248eb26f38123$exports = $db9248eb26f38123$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $d4d4cfbeabf581cf$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $db9248eb26f38123$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$d4d4cfbeabf581cf$exports = $d4d4cfbeabf581cf$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $eabbffb080133d6b$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $59ba51b67bc4c797$exports(iteratees, function(iteratee) {
        if ($d14e2831379630a0$exports(iteratee)) return function(value) {
            return $2be2112412b330f0$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $e96ff4ec759e4f57$exports
    ];
    var index = -1;
    iteratees = $59ba51b67bc4c797$exports(iteratees, $4f8937dd9e7c910b$exports($b835b507318041f7$exports));
    var result = $7d8e5499d44972b9$exports(collection, function(value, key, collection) {
        var criteria = $59ba51b67bc4c797$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $3d38c8d103ccc875$exports(result, function(object, other) {
        return $d4d4cfbeabf581cf$exports(object, other, orders);
    });
}
$eabbffb080133d6b$exports = $eabbffb080133d6b$var$baseOrderBy;


var $79a9d77dbba6c591$exports = {};

var $cbe357cc67b25bae$exports = {};
var $87b8500a0cf13251$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $87b8500a0cf13251$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$87b8500a0cf13251$exports = $87b8500a0cf13251$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cbe357cc67b25bae$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $cbe357cc67b25bae$var$overRest(func, start, transform) {
    start = $cbe357cc67b25bae$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $cbe357cc67b25bae$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $87b8500a0cf13251$exports(func, this, otherArgs);
    };
}
$cbe357cc67b25bae$exports = $cbe357cc67b25bae$var$overRest;


var $42cb4c3f4da83941$exports = {};
var $4f29d2874caff322$exports = {};
var $367fa5fbe87d066c$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $367fa5fbe87d066c$var$constant(value) {
    return function() {
        return value;
    };
}
$367fa5fbe87d066c$exports = $367fa5fbe87d066c$var$constant;


var $d1ebb473d78e30ed$exports = {};

var $d1ebb473d78e30ed$var$defineProperty = function() {
    try {
        var func = $c2a6a30872aedb5f$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$d1ebb473d78e30ed$exports = $d1ebb473d78e30ed$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4f29d2874caff322$var$baseSetToString = !$d1ebb473d78e30ed$exports ? $e96ff4ec759e4f57$exports : function(func, string) {
    return $d1ebb473d78e30ed$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $367fa5fbe87d066c$exports(string),
        "writable": true
    });
};
$4f29d2874caff322$exports = $4f29d2874caff322$var$baseSetToString;


var $b1bf74b1564c58c6$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $b1bf74b1564c58c6$var$HOT_COUNT = 800, $b1bf74b1564c58c6$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b1bf74b1564c58c6$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $b1bf74b1564c58c6$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $b1bf74b1564c58c6$var$nativeNow(), remaining = $b1bf74b1564c58c6$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $b1bf74b1564c58c6$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$b1bf74b1564c58c6$exports = $b1bf74b1564c58c6$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $42cb4c3f4da83941$var$setToString = $b1bf74b1564c58c6$exports($4f29d2874caff322$exports);
$42cb4c3f4da83941$exports = $42cb4c3f4da83941$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $79a9d77dbba6c591$var$baseRest(func, start) {
    return $42cb4c3f4da83941$exports($cbe357cc67b25bae$exports(func, start, $e96ff4ec759e4f57$exports), func + "");
}
$79a9d77dbba6c591$exports = $79a9d77dbba6c591$var$baseRest;


var $e57e5a019c44e628$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $e57e5a019c44e628$var$isIterateeCall(value, index, object) {
    if (!$3175370e2388d115$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $940b538c55f91a86$exports(object) && $34618795349fb081$exports(index, object.length) : type == "string" && index in object) return $e76c039d34e4ae95$exports(object[index], value);
    return false;
}
$e57e5a019c44e628$exports = $e57e5a019c44e628$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $6bc233c5107ae9f1$var$sortBy = $79a9d77dbba6c591$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $e57e5a019c44e628$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $e57e5a019c44e628$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $eabbffb080133d6b$exports(collection, $92dd49a302c29ed5$exports(iteratees, 1), []);
});
$6bc233c5107ae9f1$exports = $6bc233c5107ae9f1$var$sortBy;






var $9d5a2fa82ce5432d$exports = {};
var $6eda36f0a6aacf60$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $6eda36f0a6aacf60$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$1712c8f0589f33db$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$6eda36f0a6aacf60$exports = $6eda36f0a6aacf60$var$baseExtremum;


var $8c239a36586c4dc7$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $8c239a36586c4dc7$var$baseGt(value, other) {
    return value > other;
}
$8c239a36586c4dc7$exports = $8c239a36586c4dc7$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $9d5a2fa82ce5432d$var$max(array) {
    return array && array.length ? $6eda36f0a6aacf60$exports(array, $e96ff4ec759e4f57$exports, $8c239a36586c4dc7$exports) : undefined;
}
$9d5a2fa82ce5432d$exports = $9d5a2fa82ce5432d$var$max;


var $0b56757942ab138c$exports = {};

var $ebc9b2c90ad9fbf2$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $ebc9b2c90ad9fbf2$var$baseLt(value, other) {
    return value < other;
}
$ebc9b2c90ad9fbf2$exports = $ebc9b2c90ad9fbf2$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $0b56757942ab138c$var$min(array) {
    return array && array.length ? $6eda36f0a6aacf60$exports(array, $e96ff4ec759e4f57$exports, $ebc9b2c90ad9fbf2$exports) : undefined;
}
$0b56757942ab138c$exports = $0b56757942ab138c$var$min;


var $88f7376d401bbe21$exports = {};

var $9348f802d287ef84$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $9348f802d287ef84$var$map(collection, iteratee) {
    var func = $d14e2831379630a0$exports(collection) ? $59ba51b67bc4c797$exports : $7d8e5499d44972b9$exports;
    return func(collection, $b835b507318041f7$exports(iteratee, 3));
}
$9348f802d287ef84$exports = $9348f802d287ef84$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $88f7376d401bbe21$var$flatMap(collection, iteratee) {
    return $92dd49a302c29ed5$exports($9348f802d287ef84$exports(collection, iteratee), 1);
}
$88f7376d401bbe21$exports = $88f7376d401bbe21$var$flatMap;





var $94acda4d2dab3b77$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$94acda4d2dab3b77$exports = (parcelRequire("5JyUU"));



var $f3ad35d5e22c63cc$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $f3ad35d5e22c63cc$exports) $f3ad35d5e22c63cc$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($f3ad35d5e22c63cc$exports);


function $716a7d409c8f20a2$var$_toConsumableArray(arr) {
    return $716a7d409c8f20a2$var$_arrayWithoutHoles(arr) || $716a7d409c8f20a2$var$_iterableToArray(arr) || $716a7d409c8f20a2$var$_unsupportedIterableToArray(arr) || $716a7d409c8f20a2$var$_nonIterableSpread();
}
function $716a7d409c8f20a2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $716a7d409c8f20a2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $716a7d409c8f20a2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $716a7d409c8f20a2$var$_arrayLikeToArray(o, minLen);
}
function $716a7d409c8f20a2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $716a7d409c8f20a2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $716a7d409c8f20a2$var$_arrayLikeToArray(arr);
}
function $716a7d409c8f20a2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $716a7d409c8f20a2$var$identity = function identity(i) {
    return i;
};
var $716a7d409c8f20a2$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $716a7d409c8f20a2$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $716a7d409c8f20a2$export$ca73b6d700d0505;
};
var $716a7d409c8f20a2$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $716a7d409c8f20a2$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $716a7d409c8f20a2$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $716a7d409c8f20a2$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $716a7d409c8f20a2$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $716a7d409c8f20a2$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $716a7d409c8f20a2$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $716a7d409c8f20a2$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $716a7d409c8f20a2$export$c3095a23b368d1f2 = function curry(fn) {
    return $716a7d409c8f20a2$var$curryN(fn.length, fn);
};
var $716a7d409c8f20a2$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $716a7d409c8f20a2$export$871de8747c9eaa88 = $716a7d409c8f20a2$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $716a7d409c8f20a2$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $716a7d409c8f20a2$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $716a7d409c8f20a2$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $716a7d409c8f20a2$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $4ad2b67469c272c5$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $4ad2b67469c272c5$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $4ad2b67469c272c5$var$interpolateNumber = (0, $716a7d409c8f20a2$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $4ad2b67469c272c5$var$uninterpolateNumber = (0, $716a7d409c8f20a2$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $4ad2b67469c272c5$var$uninterpolateTruncation = (0, $716a7d409c8f20a2$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $4ad2b67469c272c5$export$2e2bcd8739ae039 = {
    rangeStep: $4ad2b67469c272c5$var$rangeStep,
    getDigitCount: $4ad2b67469c272c5$var$getDigitCount,
    interpolateNumber: $4ad2b67469c272c5$var$interpolateNumber,
    uninterpolateNumber: $4ad2b67469c272c5$var$uninterpolateNumber,
    uninterpolateTruncation: $4ad2b67469c272c5$var$uninterpolateTruncation
};


function $2d72ec39fc491258$var$_toConsumableArray(arr) {
    return $2d72ec39fc491258$var$_arrayWithoutHoles(arr) || $2d72ec39fc491258$var$_iterableToArray(arr) || $2d72ec39fc491258$var$_unsupportedIterableToArray(arr) || $2d72ec39fc491258$var$_nonIterableSpread();
}
function $2d72ec39fc491258$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2d72ec39fc491258$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $2d72ec39fc491258$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2d72ec39fc491258$var$_arrayLikeToArray(arr);
}
function $2d72ec39fc491258$var$_slicedToArray(arr, i) {
    return $2d72ec39fc491258$var$_arrayWithHoles(arr) || $2d72ec39fc491258$var$_iterableToArrayLimit(arr, i) || $2d72ec39fc491258$var$_unsupportedIterableToArray(arr, i) || $2d72ec39fc491258$var$_nonIterableRest();
}
function $2d72ec39fc491258$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2d72ec39fc491258$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2d72ec39fc491258$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2d72ec39fc491258$var$_arrayLikeToArray(o, minLen);
}
function $2d72ec39fc491258$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2d72ec39fc491258$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2d72ec39fc491258$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $2d72ec39fc491258$var$getValidInterval(_ref) {
    var _ref2 = $2d72ec39fc491258$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $2d72ec39fc491258$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0);
    var digitCount = (0, $4ad2b67469c272c5$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $2d72ec39fc491258$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(10).pow((0, $4ad2b67469c272c5$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $716a7d409c8f20a2$export$f672e0b6f7222cd7)((0, $716a7d409c8f20a2$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $716a7d409c8f20a2$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $2d72ec39fc491258$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $2d72ec39fc491258$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $2d72ec39fc491258$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d72ec39fc491258$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $2d72ec39fc491258$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $2d72ec39fc491258$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $2d72ec39fc491258$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($2d72ec39fc491258$var$_toConsumableArray((0, $716a7d409c8f20a2$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($2d72ec39fc491258$var$_toConsumableArray((0, $716a7d409c8f20a2$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $716a7d409c8f20a2$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $2d72ec39fc491258$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $2d72ec39fc491258$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $4ad2b67469c272c5$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $716a7d409c8f20a2$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d72ec39fc491258$var$getTickValuesFn(_ref5) {
    var _ref6 = $2d72ec39fc491258$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $2d72ec39fc491258$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $2d72ec39fc491258$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $2d72ec39fc491258$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $2d72ec39fc491258$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $716a7d409c8f20a2$export$f672e0b6f7222cd7)((0, $716a7d409c8f20a2$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(n).mul(step)).toNumber();
    }), (0, $716a7d409c8f20a2$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $716a7d409c8f20a2$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d72ec39fc491258$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $2d72ec39fc491258$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $2d72ec39fc491258$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $2d72ec39fc491258$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $2d72ec39fc491258$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($2d72ec39fc491258$var$_toConsumableArray((0, $4ad2b67469c272c5$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($f3ad35d5e22c63cc$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $716a7d409c8f20a2$export$66c1ae025e96b4bc)(values) : values;
}
var $2d72ec39fc491258$export$b84e75ccbfe6a612 = (0, $716a7d409c8f20a2$export$fc10aeed3a532e2a)($2d72ec39fc491258$var$getNiceTickValuesFn);
var $2d72ec39fc491258$export$4cc7a216492b1f53 = (0, $716a7d409c8f20a2$export$fc10aeed3a532e2a)($2d72ec39fc491258$var$getTickValuesFn);
var $2d72ec39fc491258$export$e9d28da780436e98 = (0, $716a7d409c8f20a2$export$fc10aeed3a532e2a)($2d72ec39fc491258$var$getTickValuesFixedDomainFn);





var $6P6dz = parcelRequire("6P6dz");


var $8e3ea38b9023e0e3$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $8e3ea38b9023e0e3$var$_extends() {
    $8e3ea38b9023e0e3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e3ea38b9023e0e3$var$_extends.apply(this, arguments);
}
function $8e3ea38b9023e0e3$var$_slicedToArray(arr, i) {
    return $8e3ea38b9023e0e3$var$_arrayWithHoles(arr) || $8e3ea38b9023e0e3$var$_iterableToArrayLimit(arr, i) || $8e3ea38b9023e0e3$var$_unsupportedIterableToArray(arr, i) || $8e3ea38b9023e0e3$var$_nonIterableRest();
}
function $8e3ea38b9023e0e3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e3ea38b9023e0e3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8e3ea38b9023e0e3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8e3ea38b9023e0e3$var$_arrayLikeToArray(o, minLen);
}
function $8e3ea38b9023e0e3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8e3ea38b9023e0e3$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8e3ea38b9023e0e3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8e3ea38b9023e0e3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8e3ea38b9023e0e3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8e3ea38b9023e0e3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8e3ea38b9023e0e3$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $8e3ea38b9023e0e3$var$_objectWithoutProperties(props, $8e3ea38b9023e0e3$var$_excluded);
    var svgProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $8e3ea38b9023e0e3$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $8e3ea38b9023e0e3$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", $8e3ea38b9023e0e3$var$_extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$8e3ea38b9023e0e3$export$4f4d7676bdf949e5.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
$8e3ea38b9023e0e3$export$4f4d7676bdf949e5.displayName = "ErrorBar";





function $30c733ceebebab59$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $30c733ceebebab59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $30c733ceebebab59$var$_typeof(obj);
}
function $30c733ceebebab59$var$_toConsumableArray(arr) {
    return $30c733ceebebab59$var$_arrayWithoutHoles(arr) || $30c733ceebebab59$var$_iterableToArray(arr) || $30c733ceebebab59$var$_unsupportedIterableToArray(arr) || $30c733ceebebab59$var$_nonIterableSpread();
}
function $30c733ceebebab59$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $30c733ceebebab59$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $30c733ceebebab59$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $30c733ceebebab59$var$_arrayLikeToArray(o, minLen);
}
function $30c733ceebebab59$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $30c733ceebebab59$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $30c733ceebebab59$var$_arrayLikeToArray(arr);
}
function $30c733ceebebab59$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $30c733ceebebab59$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $30c733ceebebab59$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $30c733ceebebab59$var$ownKeys(Object(source), !0).forEach(function(key) {
            $30c733ceebebab59$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $30c733ceebebab59$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $30c733ceebebab59$var$_defineProperty(obj, key, value) {
    key = $30c733ceebebab59$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $30c733ceebebab59$var$_toPropertyKey(arg) {
    var key = $30c733ceebebab59$var$_toPrimitive(arg, "string");
    return $30c733ceebebab59$var$_typeof(key) === "symbol" ? key : String(key);
}
function $30c733ceebebab59$var$_toPrimitive(input, hint) {
    if ($30c733ceebebab59$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($30c733ceebebab59$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $30c733ceebebab59$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(dataKey)) return defaultValue;
    if ((0, $19512e2323c12caf$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $30c733ceebebab59$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($88f7376d401bbe21$exports)))(data, function(entry) {
        return $30c733ceebebab59$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        var domain = flattenData.filter(function(entry) {
            return (0, $19512e2323c12caf$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($0b56757942ab138c$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry);
    }) : flattenData;
    // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $19512e2323c12caf$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $30c733ceebebab59$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $19512e2323c12caf$export$9d334328eb75e624)(cur - before) !== (0, $19512e2323c12caf$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $19512e2323c12caf$export$9d334328eb75e624)(after - cur) === (0, $19512e2323c12caf$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var min = Math.min(before, after);
                var max = Math.max(before, after);
                if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $30c733ceebebab59$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $30c733ceebebab59$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $75caf721c037b42d$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: $30c733ceebebab59$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, legendItem.props), (0, $75caf721c037b42d$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $30c733ceebebab59$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $57ab65d6d53325f9$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $30c733ceebebab59$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $19512e2323c12caf$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($30c733ceebebab59$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $19512e2323c12caf$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($30c733ceebebab59$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $30c733ceebebab59$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $30c733ceebebab59$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && (0, $19512e2323c12caf$export$7e4aa119212bc614)(offset[align])) newOffset = $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, offset), {}, $30c733ceebebab59$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && (0, $19512e2323c12caf$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, offset), {}, $30c733ceebebab59$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $30c733ceebebab59$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $30c733ceebebab59$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $8e3ea38b9023e0e3$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $30c733ceebebab59$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $30c733ceebebab59$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($0b56757942ab138c$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $30c733ceebebab59$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $30c733ceebebab59$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $30c733ceebebab59$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $30c733ceebebab59$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $30c733ceebebab59$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $30c733ceebebab59$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $30c733ceebebab59$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $30c733ceebebab59$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $30c733ceebebab59$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $30c733ceebebab59$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $19512e2323c12caf$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $30c733ceebebab59$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $30c733ceebebab59$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $94acda4d2dab3b77$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $94acda4d2dab3b77$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $94acda4d2dab3b77$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $94acda4d2dab3b77$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $94acda4d2dab3b77$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($175b703c5efe5194$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($a188cd0a1c1bcfd8$exports)))(scale));
        return {
            scale: ($94acda4d2dab3b77$exports[name] || $94acda4d2dab3b77$exports.scalePoint)(),
            realScaleType: $94acda4d2dab3b77$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $94acda4d2dab3b77$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $30c733ceebebab59$var$EPS = 1e-4;
var $30c733ceebebab59$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $30c733ceebebab59$var$EPS;
    var max = Math.max(range[0], range[1]) + $30c733ceebebab59$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $30c733ceebebab59$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $30c733ceebebab59$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(domain[0]) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $19512e2323c12caf$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $19512e2323c12caf$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $30c733ceebebab59$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $30c733ceebebab59$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $30c733ceebebab59$var$STACK_OFFSET_MAP = {
    sign: $30c733ceebebab59$export$3104c513558164c1,
    expand: (0, $1ad6c0b91f16d41d$exports.stackOffsetExpand),
    none: (0, $1ad6c0b91f16d41d$exports.stackOffsetNone),
    silhouette: (0, $1ad6c0b91f16d41d$exports.stackOffsetSilhouette),
    wiggle: (0, $1ad6c0b91f16d41d$exports.stackOffsetWiggle),
    positive: $30c733ceebebab59$export$9f2c6ead70935022
};
var $30c733ceebebab59$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $1ad6c0b91f16d41d$exports.stack)().keys(dataKeys).value(function(d, key) {
        return +$30c733ceebebab59$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $1ad6c0b91f16d41d$exports.stackOrderNone)).offset($30c733ceebebab59$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $30c733ceebebab59$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $19512e2323c12caf$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $19512e2323c12caf$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, result), {}, $30c733ceebebab59$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, res), {}, $30c733ceebebab59$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $30c733ceebebab59$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, result), {}, $30c733ceebebab59$var$_defineProperty({}, axisId, group));
    }, {});
};
var $30c733ceebebab59$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $2d72ec39fc491258$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($0b56757942ab138c$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $2d72ec39fc491258$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $30c733ceebebab59$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $19512e2323c12caf$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $30c733ceebebab59$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value) ? axis.scale(value) : null;
};
var $30c733ceebebab59$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $30c733ceebebab59$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $30c733ceebebab59$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $30c733ceebebab59$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $19512e2323c12caf$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $30c733ceebebab59$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($0b56757942ab138c$exports)))(entry.concat([
                result[0]
            ]).filter((0, $19512e2323c12caf$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(entry.concat([
                result[1]
            ]).filter((0, $19512e2323c12caf$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $30c733ceebebab59$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $30c733ceebebab59$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $30c733ceebebab59$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $30c733ceebebab59$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $30c733ceebebab59$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($30c733ceebebab59$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$30c733ceebebab59$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($30c733ceebebab59$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$30c733ceebebab59$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $30c733ceebebab59$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($6bc233c5107ae9f1$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $30c733ceebebab59$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $30c733ceebebab59$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $30c733ceebebab59$var$_objectSpread($30c733ceebebab59$var$_objectSpread({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $30c733ceebebab59$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $30c733ceebebab59$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $00f96ac211b54895$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $00f96ac211b54895$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $00f96ac211b54895$var$_typeof(obj);
}
function $00f96ac211b54895$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00f96ac211b54895$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $00f96ac211b54895$var$ownKeys(Object(source), !0).forEach(function(key) {
            $00f96ac211b54895$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $00f96ac211b54895$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $00f96ac211b54895$var$_defineProperty(obj, key, value) {
    key = $00f96ac211b54895$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $00f96ac211b54895$var$_toPropertyKey(arg) {
    var key = $00f96ac211b54895$var$_toPrimitive(arg, "string");
    return $00f96ac211b54895$var$_typeof(key) === "symbol" ? key : String(key);
}
function $00f96ac211b54895$var$_toPrimitive(input, hint) {
    if ($00f96ac211b54895$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($00f96ac211b54895$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $00f96ac211b54895$var$_slicedToArray(arr, i) {
    return $00f96ac211b54895$var$_arrayWithHoles(arr) || $00f96ac211b54895$var$_iterableToArrayLimit(arr, i) || $00f96ac211b54895$var$_unsupportedIterableToArray(arr, i) || $00f96ac211b54895$var$_nonIterableRest();
}
function $00f96ac211b54895$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $00f96ac211b54895$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $00f96ac211b54895$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $00f96ac211b54895$var$_arrayLikeToArray(o, minLen);
}
function $00f96ac211b54895$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $00f96ac211b54895$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $00f96ac211b54895$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $00f96ac211b54895$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $00f96ac211b54895$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $00f96ac211b54895$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $00f96ac211b54895$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$00f96ac211b54895$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$00f96ac211b54895$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $00f96ac211b54895$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $00f96ac211b54895$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $19512e2323c12caf$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $19512e2323c12caf$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $00f96ac211b54895$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $19512e2323c12caf$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $19512e2323c12caf$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $00f96ac211b54895$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $30c733ceebebab59$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $30c733ceebebab59$export$9d80152e23bae434)(scale);
        var ticks = (0, $30c733ceebebab59$export$ac086aaa4358d590)(scale, $00f96ac211b54895$var$_objectSpread($00f96ac211b54895$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $00f96ac211b54895$var$_objectSpread($00f96ac211b54895$var$_objectSpread($00f96ac211b54895$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $00f96ac211b54895$var$_objectSpread($00f96ac211b54895$var$_objectSpread({}, result), {}, $00f96ac211b54895$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $00f96ac211b54895$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $00f96ac211b54895$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $00f96ac211b54895$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $00f96ac211b54895$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $00f96ac211b54895$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $00f96ac211b54895$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $00f96ac211b54895$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $00f96ac211b54895$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $00f96ac211b54895$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $00f96ac211b54895$var$_objectSpread($00f96ac211b54895$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $00f96ac211b54895$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $deb3ca7225310ca3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $deb3ca7225310ca3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $deb3ca7225310ca3$var$_typeof(obj);
}
function $deb3ca7225310ca3$var$_toConsumableArray(arr) {
    return $deb3ca7225310ca3$var$_arrayWithoutHoles(arr) || $deb3ca7225310ca3$var$_iterableToArray(arr) || $deb3ca7225310ca3$var$_unsupportedIterableToArray(arr) || $deb3ca7225310ca3$var$_nonIterableSpread();
}
function $deb3ca7225310ca3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $deb3ca7225310ca3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $deb3ca7225310ca3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $deb3ca7225310ca3$var$_arrayLikeToArray(o, minLen);
}
function $deb3ca7225310ca3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $deb3ca7225310ca3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $deb3ca7225310ca3$var$_arrayLikeToArray(arr);
}
function $deb3ca7225310ca3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $deb3ca7225310ca3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $deb3ca7225310ca3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $deb3ca7225310ca3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $deb3ca7225310ca3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $deb3ca7225310ca3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $deb3ca7225310ca3$var$_defineProperty(obj, key, value) {
    key = $deb3ca7225310ca3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $deb3ca7225310ca3$var$_toPropertyKey(arg) {
    var key = $deb3ca7225310ca3$var$_toPrimitive(arg, "string");
    return $deb3ca7225310ca3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $deb3ca7225310ca3$var$_toPrimitive(input, hint) {
    if ($deb3ca7225310ca3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($deb3ca7225310ca3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $deb3ca7225310ca3$var$_extends() {
    $deb3ca7225310ca3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $deb3ca7225310ca3$var$_extends.apply(this, arguments);
}
var $deb3ca7225310ca3$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(formatter)) return formatter(label);
    return label;
};
var $deb3ca7225310ca3$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $19512e2323c12caf$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $deb3ca7225310ca3$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $deb3ca7225310ca3$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(labelProps.id) ? (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("text", $deb3ca7225310ca3$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $deb3ca7225310ca3$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $deb3ca7225310ca3$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $deb3ca7225310ca3$var$_objectSpread($deb3ca7225310ca3$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $deb3ca7225310ca3$var$_objectSpread($deb3ca7225310ca3$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $deb3ca7225310ca3$var$_objectSpread($deb3ca7225310ca3$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $deb3ca7225310ca3$var$_objectSpread($deb3ca7225310ca3$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(position) && ((0, $19512e2323c12caf$export$7e4aa119212bc614)(position.x) || (0, $19512e2323c12caf$export$e50269385c77c348)(position.x)) && ((0, $19512e2323c12caf$export$7e4aa119212bc614)(position.y) || (0, $19512e2323c12caf$export$e50269385c77c348)(position.y))) return $deb3ca7225310ca3$var$_objectSpread({
        x: x + (0, $19512e2323c12caf$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $19512e2323c12caf$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $deb3ca7225310ca3$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $deb3ca7225310ca3$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $19512e2323c12caf$export$7e4aa119212bc614)(viewBox.cx);
};
function $deb3ca7225310ca3$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(children) && !/*#__PURE__*/ (0, $6P6dz.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(content)) return /*#__PURE__*/ (0, $6P6dz.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(content)) {
        label = /*#__PURE__*/ (0, $6P6dz.createElement)(content, props);
        if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(label)) return label;
    } else label = $deb3ca7225310ca3$var$getLabel(props);
    var isPolarLabel = $deb3ca7225310ca3$var$isPolar(viewBox);
    var attrs = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $deb3ca7225310ca3$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $deb3ca7225310ca3$var$getAttrsOfPolarLabel(props) : $deb3ca7225310ca3$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $19d8402d51c91e20$export$5f1af8db9871e1d6), $deb3ca7225310ca3$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$deb3ca7225310ca3$export$b04be29aa201d4f5.displayName = "Label";
$deb3ca7225310ca3$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $deb3ca7225310ca3$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(width) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(height)) {
        if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(x) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(top) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(x) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(cx) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $deb3ca7225310ca3$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($deb3ca7225310ca3$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $19512e2323c12caf$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($deb3ca7225310ca3$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(label)) {
        if (label.type === $deb3ca7225310ca3$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $6P6dz.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($deb3ca7225310ca3$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($deb3ca7225310ca3$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($deb3ca7225310ca3$export$b04be29aa201d4f5, $deb3ca7225310ca3$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $deb3ca7225310ca3$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $deb3ca7225310ca3$var$parseViewBox(parentProps);
    var explicitChildren = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, $deb3ca7225310ca3$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $6P6dz.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $deb3ca7225310ca3$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($deb3ca7225310ca3$var$_toConsumableArray(explicitChildren));
};
$deb3ca7225310ca3$export$b04be29aa201d4f5.parseViewBox = $deb3ca7225310ca3$var$parseViewBox;
$deb3ca7225310ca3$export$b04be29aa201d4f5.renderCallByParent = $deb3ca7225310ca3$var$renderCallByParent;





function $24933d61ea3e47f1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $24933d61ea3e47f1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $24933d61ea3e47f1$var$_typeof(obj);
}
var $24933d61ea3e47f1$var$_excluded = [
    "data",
    "valueAccessor",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $24933d61ea3e47f1$var$_toConsumableArray(arr) {
    return $24933d61ea3e47f1$var$_arrayWithoutHoles(arr) || $24933d61ea3e47f1$var$_iterableToArray(arr) || $24933d61ea3e47f1$var$_unsupportedIterableToArray(arr) || $24933d61ea3e47f1$var$_nonIterableSpread();
}
function $24933d61ea3e47f1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24933d61ea3e47f1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24933d61ea3e47f1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24933d61ea3e47f1$var$_arrayLikeToArray(o, minLen);
}
function $24933d61ea3e47f1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $24933d61ea3e47f1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $24933d61ea3e47f1$var$_arrayLikeToArray(arr);
}
function $24933d61ea3e47f1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $24933d61ea3e47f1$var$_extends() {
    $24933d61ea3e47f1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24933d61ea3e47f1$var$_extends.apply(this, arguments);
}
function $24933d61ea3e47f1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $24933d61ea3e47f1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $24933d61ea3e47f1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $24933d61ea3e47f1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $24933d61ea3e47f1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $24933d61ea3e47f1$var$_defineProperty(obj, key, value) {
    key = $24933d61ea3e47f1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24933d61ea3e47f1$var$_toPropertyKey(arg) {
    var key = $24933d61ea3e47f1$var$_toPrimitive(arg, "string");
    return $24933d61ea3e47f1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $24933d61ea3e47f1$var$_toPrimitive(input, hint) {
    if ($24933d61ea3e47f1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($24933d61ea3e47f1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $24933d61ea3e47f1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $24933d61ea3e47f1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $24933d61ea3e47f1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $24933d61ea3e47f1$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($6dc665014ff8a618$exports)))(entry.value) : entry.value;
    }
};
function $24933d61ea3e47f1$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $24933d61ea3e47f1$var$_objectWithoutProperties(props, $24933d61ea3e47f1$var$_excluded);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $deb3ca7225310ca3$export$b04be29aa201d4f5), $24933d61ea3e47f1$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $deb3ca7225310ca3$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(clockWise) ? entry : $24933d61ea3e47f1$var$_objectSpread($24933d61ea3e47f1$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$24933d61ea3e47f1$export$835fcf23ab7bf88.displayName = "LabelList";
function $24933d61ea3e47f1$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($24933d61ea3e47f1$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($24933d61ea3e47f1$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3175370e2388d115$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($24933d61ea3e47f1$export$835fcf23ab7bf88, $24933d61ea3e47f1$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $24933d61ea3e47f1$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, $24933d61ea3e47f1$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $6P6dz.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $24933d61ea3e47f1$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($24933d61ea3e47f1$var$_toConsumableArray(explicitChildren));
}
$24933d61ea3e47f1$export$835fcf23ab7bf88.renderCallByParent = $24933d61ea3e47f1$var$renderCallByParent;
$24933d61ea3e47f1$export$835fcf23ab7bf88.defaultProps = $24933d61ea3e47f1$var$defaultProps;







var $bcd60d8d12bfb662$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $bcd60d8d12bfb662$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bcd60d8d12bfb662$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bcd60d8d12bfb662$var$_typeof(obj);
}
function $bcd60d8d12bfb662$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bcd60d8d12bfb662$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bcd60d8d12bfb662$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bcd60d8d12bfb662$var$_extends() {
    $bcd60d8d12bfb662$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bcd60d8d12bfb662$var$_extends.apply(this, arguments);
}
function $bcd60d8d12bfb662$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bcd60d8d12bfb662$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bcd60d8d12bfb662$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bcd60d8d12bfb662$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bcd60d8d12bfb662$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bcd60d8d12bfb662$var$_toConsumableArray(arr) {
    return $bcd60d8d12bfb662$var$_arrayWithoutHoles(arr) || $bcd60d8d12bfb662$var$_iterableToArray(arr) || $bcd60d8d12bfb662$var$_unsupportedIterableToArray(arr) || $bcd60d8d12bfb662$var$_nonIterableSpread();
}
function $bcd60d8d12bfb662$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bcd60d8d12bfb662$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bcd60d8d12bfb662$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bcd60d8d12bfb662$var$_arrayLikeToArray(o, minLen);
}
function $bcd60d8d12bfb662$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bcd60d8d12bfb662$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bcd60d8d12bfb662$var$_arrayLikeToArray(arr);
}
function $bcd60d8d12bfb662$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bcd60d8d12bfb662$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bcd60d8d12bfb662$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bcd60d8d12bfb662$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bcd60d8d12bfb662$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bcd60d8d12bfb662$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bcd60d8d12bfb662$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bcd60d8d12bfb662$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bcd60d8d12bfb662$var$_setPrototypeOf(subClass, superClass);
}
function $bcd60d8d12bfb662$var$_setPrototypeOf(o, p) {
    $bcd60d8d12bfb662$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bcd60d8d12bfb662$var$_setPrototypeOf(o, p);
}
function $bcd60d8d12bfb662$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bcd60d8d12bfb662$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bcd60d8d12bfb662$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bcd60d8d12bfb662$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bcd60d8d12bfb662$var$_possibleConstructorReturn(this, result);
    };
}
function $bcd60d8d12bfb662$var$_possibleConstructorReturn(self, call) {
    if (call && ($bcd60d8d12bfb662$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bcd60d8d12bfb662$var$_assertThisInitialized(self);
}
function $bcd60d8d12bfb662$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bcd60d8d12bfb662$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bcd60d8d12bfb662$var$_getPrototypeOf(o) {
    $bcd60d8d12bfb662$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bcd60d8d12bfb662$var$_getPrototypeOf(o);
}
function $bcd60d8d12bfb662$var$_defineProperty(obj, key, value) {
    key = $bcd60d8d12bfb662$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bcd60d8d12bfb662$var$_toPropertyKey(arg) {
    var key = $bcd60d8d12bfb662$var$_toPrimitive(arg, "string");
    return $bcd60d8d12bfb662$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bcd60d8d12bfb662$var$_toPrimitive(input, hint) {
    if ($bcd60d8d12bfb662$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bcd60d8d12bfb662$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bcd60d8d12bfb662$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $bcd60d8d12bfb662$var$_inherits(Line, _PureComponent);
    var _super = $bcd60d8d12bfb662$var$_createSuper(Line);
    function Line() {
        var _this;
        $bcd60d8d12bfb662$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0;; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($bcd60d8d12bfb662$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($bcd60d8d12bfb662$var$_toConsumableArray(Line.repeat(lines, count)), $bcd60d8d12bfb662$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(", ");
        });
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "id", (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts-line-"));
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $bcd60d8d12bfb662$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $8e3ea38b9023e0e3$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $30c733ceebebab59$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(item, {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "bar-".concat(i),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $bcd60d8d12bfb662$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps, {
                    role: "img"
                }), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $bcd60d8d12bfb662$var$_objectWithoutProperties(_this$props3, $bcd60d8d12bfb662$var$_excluded);
                var curveProps = $bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: "none",
                    className: "recharts-line-curve",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $45580be9bbfd5120$export$b0e83c3ef8d2db1), $bcd60d8d12bfb662$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $bcd60d8d12bfb662$var$_objectSpread($bcd60d8d12bfb662$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-line", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $57ab65d6d53325f9$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $24933d61ea3e47f1$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($bcd60d8d12bfb662$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($bcd60d8d12bfb662$var$_toConsumableArray(result), $bcd60d8d12bfb662$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-line-dot", option ? option.className : "");
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $5a9ccb48149eca10$export$d046b3c4a416f60d), $bcd60d8d12bfb662$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $6P6dz.PureComponent));
$bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$export$17d680238e50603e, "displayName", "Line");
$bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $bcd60d8d12bfb662$var$_defineProperty($bcd60d8d12bfb662$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === "horizontal") return {
            x: (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $bcd60d8d12bfb662$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ var $012e84436ac5b4a7$exports = {};
var $1d0c788095f82564$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $1d0c788095f82564$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$1d0c788095f82564$exports = $1d0c788095f82564$var$arrayEvery;


var $db18ed0eec3c9ba6$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $db18ed0eec3c9ba6$var$baseEvery(collection, predicate) {
    var result = true;
    $1ed335bc48f220a3$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$db18ed0eec3c9ba6$exports = $db18ed0eec3c9ba6$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $012e84436ac5b4a7$var$every(collection, predicate, guard) {
    var func = $d14e2831379630a0$exports(collection) ? $1d0c788095f82564$exports : $db18ed0eec3c9ba6$exports;
    if (guard && $e57e5a019c44e628$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $b835b507318041f7$exports(predicate, 3));
}
$012e84436ac5b4a7$exports = $012e84436ac5b4a7$var$every;


var $62770549874729df$exports = {};
var $4f2209ccb7d1bae4$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $4f2209ccb7d1bae4$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$940b538c55f91a86$exports(collection)) {
            var iteratee = $b835b507318041f7$exports(predicate, 3);
            collection = $b5bd9c92554c187b$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$4f2209ccb7d1bae4$exports = $4f2209ccb7d1bae4$var$createFind;


var $0314c0a96a2a0ff7$exports = {};


var $4b7cc3f53ec91988$exports = {};
var $aa2e505ac9b5b1f8$exports = {};
var $d948c9882c30810a$exports = {};
var $9e87ca61a338c366$exports = {};
var $d5b0d7645ff5afe8$exports = {};
/** Used to match a single whitespace character. */ var $d5b0d7645ff5afe8$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d5b0d7645ff5afe8$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d5b0d7645ff5afe8$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$d5b0d7645ff5afe8$exports = $d5b0d7645ff5afe8$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $9e87ca61a338c366$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $9e87ca61a338c366$var$baseTrim(string) {
    return string ? string.slice(0, $d5b0d7645ff5afe8$exports(string) + 1).replace($9e87ca61a338c366$var$reTrimStart, "") : string;
}
$9e87ca61a338c366$exports = $9e87ca61a338c366$var$baseTrim;




/** Used as references for various `Number` constants. */ var $d948c9882c30810a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $d948c9882c30810a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $d948c9882c30810a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $d948c9882c30810a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $d948c9882c30810a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $d948c9882c30810a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($1712c8f0589f33db$exports(value)) return $d948c9882c30810a$var$NAN;
    if ($3175370e2388d115$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $3175370e2388d115$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $9e87ca61a338c366$exports(value);
    var isBinary = $d948c9882c30810a$var$reIsBinary.test(value);
    return isBinary || $d948c9882c30810a$var$reIsOctal.test(value) ? $d948c9882c30810a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $d948c9882c30810a$var$reIsBadHex.test(value) ? $d948c9882c30810a$var$NAN : +value;
}
$d948c9882c30810a$exports = $d948c9882c30810a$var$toNumber;


/** Used as references for various `Number` constants. */ var $aa2e505ac9b5b1f8$var$INFINITY = 1 / 0, $aa2e505ac9b5b1f8$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $aa2e505ac9b5b1f8$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $d948c9882c30810a$exports(value);
    if (value === $aa2e505ac9b5b1f8$var$INFINITY || value === -$aa2e505ac9b5b1f8$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $aa2e505ac9b5b1f8$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$aa2e505ac9b5b1f8$exports = $aa2e505ac9b5b1f8$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $4b7cc3f53ec91988$var$toInteger(value) {
    var result = $aa2e505ac9b5b1f8$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$4b7cc3f53ec91988$exports = $4b7cc3f53ec91988$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0314c0a96a2a0ff7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $0314c0a96a2a0ff7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $4b7cc3f53ec91988$exports(fromIndex);
    if (index < 0) index = $0314c0a96a2a0ff7$var$nativeMax(length + index, 0);
    return $d539bc9f633add24$exports(array, $b835b507318041f7$exports(predicate, 3), index);
}
$0314c0a96a2a0ff7$exports = $0314c0a96a2a0ff7$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $62770549874729df$var$find = $4f2209ccb7d1bae4$exports($0314c0a96a2a0ff7$exports);
$62770549874729df$exports = $62770549874729df$var$find;



var $9d5a2ee795666c6b$exports = {};
var $86cb5c72cdcf443c$exports = {};

var $e5e0242a1b7501a5$exports = {};

var $lb3R3 = parcelRequire("lb3R3");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e5e0242a1b7501a5$var$now = function() {
    return $lb3R3.Date.now();
};
$e5e0242a1b7501a5$exports = $e5e0242a1b7501a5$var$now;



/** Error message constants. */ var $86cb5c72cdcf443c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $86cb5c72cdcf443c$var$nativeMax = Math.max, $86cb5c72cdcf443c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $86cb5c72cdcf443c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($86cb5c72cdcf443c$var$FUNC_ERROR_TEXT);
    wait = $d948c9882c30810a$exports(wait) || 0;
    if ($3175370e2388d115$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $86cb5c72cdcf443c$var$nativeMax($d948c9882c30810a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $86cb5c72cdcf443c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e5e0242a1b7501a5$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e5e0242a1b7501a5$exports());
    }
    function debounced() {
        var time = $e5e0242a1b7501a5$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$86cb5c72cdcf443c$exports = $86cb5c72cdcf443c$var$debounce;



/** Error message constants. */ var $9d5a2ee795666c6b$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $9d5a2ee795666c6b$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($9d5a2ee795666c6b$var$FUNC_ERROR_TEXT);
    if ($3175370e2388d115$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $86cb5c72cdcf443c$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$9d5a2ee795666c6b$exports = $9d5a2ee795666c6b$var$throttle;




var $b20779d34f7da175$exports = {};
var $8f87c0e9f1d7b7d9$exports = {};
var $1f0ae82e7c99f6fc$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1f0ae82e7c99f6fc$var$nativeCeil = Math.ceil, $1f0ae82e7c99f6fc$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $1f0ae82e7c99f6fc$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $1f0ae82e7c99f6fc$var$nativeMax($1f0ae82e7c99f6fc$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$1f0ae82e7c99f6fc$exports = $1f0ae82e7c99f6fc$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $8f87c0e9f1d7b7d9$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $e57e5a019c44e628$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $aa2e505ac9b5b1f8$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $aa2e505ac9b5b1f8$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $aa2e505ac9b5b1f8$exports(step);
        return $1f0ae82e7c99f6fc$exports(start, end, step, fromRight);
    };
}
$8f87c0e9f1d7b7d9$exports = $8f87c0e9f1d7b7d9$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b20779d34f7da175$var$range = $8f87c0e9f1d7b7d9$exports();
$b20779d34f7da175$exports = $b20779d34f7da175$var$range;



var $9dc855dc6a0fe577$exports = {};


/** `Object#toString` result references. */ var $9dc855dc6a0fe577$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $9dc855dc6a0fe577$var$isBoolean(value) {
    return value === true || value === false || $864b381dc394d8fc$exports(value) && $51a3f16199173b7d$exports(value) == $9dc855dc6a0fe577$var$boolTag;
}
$9dc855dc6a0fe577$exports = $9dc855dc6a0fe577$var$isBoolean;




var $6P6dz = parcelRequire("6P6dz");





/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $35c1af9e9adcb478$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}



var $70dd9f4cfe7f67b7$exports = {};
var $b1d40ecd76f15d93$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b1d40ecd76f15d93$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $d1ebb473d78e30ed$exports) $d1ebb473d78e30ed$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$b1d40ecd76f15d93$exports = $b1d40ecd76f15d93$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $70dd9f4cfe7f67b7$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $b835b507318041f7$exports(iteratee, 3);
    $87b5830fdeb5f00b$exports(object, function(value, key, object) {
        $b1d40ecd76f15d93$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$70dd9f4cfe7f67b7$exports = $70dd9f4cfe7f67b7$var$mapValues;










var $6P6dz = parcelRequire("6P6dz");



var $6P6dz = parcelRequire("6P6dz");



function $7521f5043c96f3a0$var$_extends() {
    $7521f5043c96f3a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7521f5043c96f3a0$var$_extends.apply(this, arguments);
}
function $7521f5043c96f3a0$var$_slicedToArray(arr, i) {
    return $7521f5043c96f3a0$var$_arrayWithHoles(arr) || $7521f5043c96f3a0$var$_iterableToArrayLimit(arr, i) || $7521f5043c96f3a0$var$_unsupportedIterableToArray(arr, i) || $7521f5043c96f3a0$var$_nonIterableRest();
}
function $7521f5043c96f3a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7521f5043c96f3a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7521f5043c96f3a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7521f5043c96f3a0$var$_arrayLikeToArray(o, minLen);
}
function $7521f5043c96f3a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7521f5043c96f3a0$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $7521f5043c96f3a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $7521f5043c96f3a0$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $7521f5043c96f3a0$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $7521f5043c96f3a0$export$4617fb02663045ef = function Rectangle(props) {
    var pathRef = (0, $6P6dz.useRef)();
    var _useState = (0, $6P6dz.useState)(-1), _useState2 = $7521f5043c96f3a0$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $6P6dz.useLayoutEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $7521f5043c96f3a0$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $7521f5043c96f3a0$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $7521f5043c96f3a0$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $7521f5043c96f3a0$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};
$7521f5043c96f3a0$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};




/**
 * @fileOverview Cross
 */ var $eb16b70c73624ca5$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$eb16b70c73624ca5$export$f6f0c3fe4ec306ea.displayName = "Cell";








var $014af52e527fc085$var$_excluded = [
    "value",
    "background"
];
function $014af52e527fc085$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $014af52e527fc085$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $014af52e527fc085$var$_typeof(obj);
}
function $014af52e527fc085$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $014af52e527fc085$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $014af52e527fc085$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $014af52e527fc085$var$_extends() {
    $014af52e527fc085$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $014af52e527fc085$var$_extends.apply(this, arguments);
}
function $014af52e527fc085$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $014af52e527fc085$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $014af52e527fc085$var$ownKeys(Object(source), !0).forEach(function(key) {
            $014af52e527fc085$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $014af52e527fc085$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $014af52e527fc085$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $014af52e527fc085$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $014af52e527fc085$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $014af52e527fc085$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $014af52e527fc085$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $014af52e527fc085$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $014af52e527fc085$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $014af52e527fc085$var$_setPrototypeOf(subClass, superClass);
}
function $014af52e527fc085$var$_setPrototypeOf(o, p) {
    $014af52e527fc085$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $014af52e527fc085$var$_setPrototypeOf(o, p);
}
function $014af52e527fc085$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $014af52e527fc085$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $014af52e527fc085$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $014af52e527fc085$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $014af52e527fc085$var$_possibleConstructorReturn(this, result);
    };
}
function $014af52e527fc085$var$_possibleConstructorReturn(self, call) {
    if (call && ($014af52e527fc085$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $014af52e527fc085$var$_assertThisInitialized(self);
}
function $014af52e527fc085$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $014af52e527fc085$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $014af52e527fc085$var$_getPrototypeOf(o) {
    $014af52e527fc085$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $014af52e527fc085$var$_getPrototypeOf(o);
}
function $014af52e527fc085$var$_defineProperty(obj, key, value) {
    key = $014af52e527fc085$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $014af52e527fc085$var$_toPropertyKey(arg) {
    var key = $014af52e527fc085$var$_toPrimitive(arg, "string");
    return $014af52e527fc085$var$_typeof(key) === "symbol" ? key : String(key);
}
function $014af52e527fc085$var$_toPrimitive(input, hint) {
    if ($014af52e527fc085$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($014af52e527fc085$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $014af52e527fc085$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $014af52e527fc085$var$_inherits(Bar, _PureComponent);
    var _super = $014af52e527fc085$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $014af52e527fc085$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $014af52e527fc085$var$_defineProperty($014af52e527fc085$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $014af52e527fc085$var$_defineProperty($014af52e527fc085$var$_assertThisInitialized(_this), "id", (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts-bar-"));
        $014af52e527fc085$var$_defineProperty($014af52e527fc085$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $014af52e527fc085$var$_defineProperty($014af52e527fc085$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $014af52e527fc085$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var shape = this.props.shape;
                var baseProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var props = $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, baseProps), entry), {}, {
                        index: i
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $014af52e527fc085$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $f237646aefb1d4cb$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), Bar.renderRectangle(shape, props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props = this.props, data = _this$props.data, layout = _this$props.layout, isAnimationActive = _this$props.isAnimationActive, animationBegin = _this$props.animationBegin, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, animationId = _this$props.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props2 = this.props, data = _this$props2.data, isAnimationActive = _this$props2.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var data = this.props.data;
                var backgroundProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $014af52e527fc085$var$_objectWithoutProperties(entry, $014af52e527fc085$var$_excluded);
                    if (!background) return null;
                    var props = $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $f237646aefb1d4cb$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return Bar.renderRectangle(_this4.props.background, props);
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props3 = this.props, data = _this$props3.data, xAxis = _this$props3.xAxis, yAxis = _this$props3.yAxis, layout = _this$props3.layout, children = _this$props3.children;
                var errorBarItems = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $8e3ea38b9023e0e3$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $30c733ceebebab59$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, hide = _this$props4.hide, data = _this$props4.data, className = _this$props4.className, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, left = _this$props4.left, top = _this$props4.top, width = _this$props4.width, height = _this$props4.height, isAnimationActive = _this$props4.isAnimationActive, background = _this$props4.background, id = _this$props4.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $24933d61ea3e47f1$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        },
        {
            key: "renderRectangle",
            value: function renderRectangle(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) rectangle = option(props);
                else rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $7521f5043c96f3a0$export$4617fb02663045ef), props);
                return rectangle;
            }
        }
    ]);
    return Bar;
}((0, $6P6dz.PureComponent));
$014af52e527fc085$var$_defineProperty($014af52e527fc085$export$bbc6c6369b38e3d1, "displayName", "Bar");
$014af52e527fc085$var$_defineProperty($014af52e527fc085$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    // data of bar
    data: [],
    layout: "vertical",
    isAnimationActive: !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $014af52e527fc085$var$_defineProperty($014af52e527fc085$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $30c733ceebebab59$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $30c733ceebebab59$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $eb16b70c73624ca5$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $30c733ceebebab59$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, dataKey);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $30c733ceebebab59$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $19512e2323c12caf$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $30c733ceebebab59$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $19512e2323c12caf$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread($014af52e527fc085$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $30c733ceebebab59$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $014af52e527fc085$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $6908f2be6e0983bb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6908f2be6e0983bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6908f2be6e0983bb$var$_typeof(obj);
}
function $6908f2be6e0983bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6908f2be6e0983bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6908f2be6e0983bb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6908f2be6e0983bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6908f2be6e0983bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6908f2be6e0983bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6908f2be6e0983bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6908f2be6e0983bb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6908f2be6e0983bb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6908f2be6e0983bb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6908f2be6e0983bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6908f2be6e0983bb$var$_defineProperty(obj, key, value) {
    key = $6908f2be6e0983bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6908f2be6e0983bb$var$_toPropertyKey(arg) {
    var key = $6908f2be6e0983bb$var$_toPrimitive(arg, "string");
    return $6908f2be6e0983bb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6908f2be6e0983bb$var$_toPrimitive(input, hint) {
    if ($6908f2be6e0983bb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6908f2be6e0983bb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6908f2be6e0983bb$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $014af52e527fc085$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $19512e2323c12caf$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $30c733ceebebab59$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $30c733ceebebab59$export$9d80152e23bae434)(scale);
        var ticks = (0, $30c733ceebebab59$export$ac086aaa4358d590)(scale, $6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $30c733ceebebab59$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread({}, result), {}, $6908f2be6e0983bb$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $6908f2be6e0983bb$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $6908f2be6e0983bb$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $6908f2be6e0983bb$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $6908f2be6e0983bb$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $6908f2be6e0983bb$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $6908f2be6e0983bb$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$6908f2be6e0983bb$var$_defineProperty($6908f2be6e0983bb$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $6908f2be6e0983bb$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread({}, res), {}, $6908f2be6e0983bb$var$_defineProperty({}, key, $6908f2be6e0983bb$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $6908f2be6e0983bb$var$_objectSpread($6908f2be6e0983bb$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($70dd9f4cfe7f67b7$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($012e84436ac5b4a7$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $6908f2be6e0983bb$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $6908f2be6e0983bb$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $6908f2be6e0983bb$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


function $ade45b8dec91087b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ade45b8dec91087b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ade45b8dec91087b$var$_typeof(obj);
}
function $ade45b8dec91087b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ade45b8dec91087b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ade45b8dec91087b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ade45b8dec91087b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ade45b8dec91087b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ade45b8dec91087b$var$_defineProperty(obj, key, value) {
    key = $ade45b8dec91087b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ade45b8dec91087b$var$_toPropertyKey(arg) {
    var key = $ade45b8dec91087b$var$_toPrimitive(arg, "string");
    return $ade45b8dec91087b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ade45b8dec91087b$var$_toPrimitive(input, hint) {
    if ($ade45b8dec91087b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ade45b8dec91087b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ade45b8dec91087b$export$8d7cd2cadfe08ccd(ticks) {
    var N = 1;
    var previous = (0, $35c1af9e9adcb478$export$41514b9f058a6886)(ticks, N, function(tickItem) {
        return tickItem.isShow;
    });
    while(N <= ticks.length){
        if (previous !== undefined) return previous;
        N++;
        previous = (0, $35c1af9e9adcb478$export$41514b9f058a6886)(ticks, N, function(tickItem) {
            return tickItem.isShow;
        });
    }
    return ticks.slice(0, 1);
}
function $ade45b8dec91087b$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $35c1af9e9adcb478$export$41514b9f058a6886)(ticks, interval + 1);
}
function $ade45b8dec91087b$var$getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $6908f2be6e0983bb$export$3ee78d51cffc2b68)(size, angle);
}
function $ade45b8dec91087b$var$getTicksEnd(_ref) {
    var angle = _ref.angle, ticks = _ref.ticks, tickFormatter = _ref.tickFormatter, viewBox = _ref.viewBox, orientation = _ref.orientation, minTickGap = _ref.minTickGap, unit = _ref.unit, fontSize = _ref.fontSize, letterSpacing = _ref.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === "width" ? (0, $34d5136d44d32c45$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? (0, $19512e2323c12caf$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === "width" ? x : y;
        end = sizeKey === "width" ? x + width : y + height;
    } else {
        start = sizeKey === "width" ? x + width : y + height;
        end = sizeKey === "width" ? x : y;
    }
    for(var i = len - 1; i >= 0; i--){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
        // Recharts only supports angles when sizeKey === 'width'
        var size = sizeKey === "width" ? $ade45b8dec91087b$var$getAngledTickWidth((0, $34d5136d44d32c45$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $34d5136d44d32c45$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * size / 2 - end);
            result[i] = entry = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            end = entry.tickCoord - sign * (size / 2 + minTickGap);
            result[i] = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $ade45b8dec91087b$var$getTicksStart(_ref2, preserveEnd) {
    var angle = _ref2.angle, ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit, fontSize = _ref2.fontSize, letterSpacing = _ref2.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var result = (ticks || []).slice();
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === "width" ? (0, $34d5136d44d32c45$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var len = result.length;
    var sign = len >= 2 ? (0, $19512e2323c12caf$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === "width" ? x : y;
        end = sizeKey === "width" ? x + width : y + height;
    } else {
        start = sizeKey === "width" ? x + width : y + height;
        end = sizeKey === "width" ? x : y;
    }
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
        // Recharts only supports angles when sizeKey === 'width'
        var tailSize = sizeKey === "width" ? $ade45b8dec91087b$var$getAngledTickWidth((0, $34d5136d44d32c45$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $34d5136d44d32c45$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    for(var i = 0; i < count; i++){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
        var size = sizeKey === "width" ? $ade45b8dec91087b$var$getAngledTickWidth((0, $34d5136d44d32c45$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $34d5136d44d32c45$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * size / 2 - start);
            result[i] = entry = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            start = entry.tickCoord + sign * (size / 2 + minTickGap);
            result[i] = $ade45b8dec91087b$var$_objectSpread($ade45b8dec91087b$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $ade45b8dec91087b$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(interval) || (0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr) return $ade45b8dec91087b$export$beeebbe3ff1b306b(ticks, typeof interval === "number" && (0, $19512e2323c12caf$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    if (interval === "equidistantPreserveStart") {
        candidates = $ade45b8dec91087b$var$getTicksStart({
            angle: angle,
            ticks: ticks,
            tickFormatter: tickFormatter,
            viewBox: viewBox,
            orientation: orientation,
            minTickGap: minTickGap,
            unit: unit,
            fontSize: fontSize,
            letterSpacing: letterSpacing
        });
        return $ade45b8dec91087b$export$8d7cd2cadfe08ccd(candidates);
    }
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $ade45b8dec91087b$var$getTicksStart({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }, interval === "preserveStartEnd");
    else candidates = $ade45b8dec91087b$var$getTicksEnd({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    });
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}








var $6P6dz = parcelRequire("6P6dz");






var $6P6dz = parcelRequire("6P6dz");


/**
 * @fileOverview Default Tooltip Content
 */ function $1ca8d629c25856b2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1ca8d629c25856b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1ca8d629c25856b2$var$_typeof(obj);
}
function $1ca8d629c25856b2$var$_slicedToArray(arr, i) {
    return $1ca8d629c25856b2$var$_arrayWithHoles(arr) || $1ca8d629c25856b2$var$_iterableToArrayLimit(arr, i) || $1ca8d629c25856b2$var$_unsupportedIterableToArray(arr, i) || $1ca8d629c25856b2$var$_nonIterableRest();
}
function $1ca8d629c25856b2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1ca8d629c25856b2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1ca8d629c25856b2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1ca8d629c25856b2$var$_arrayLikeToArray(o, minLen);
}
function $1ca8d629c25856b2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1ca8d629c25856b2$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $1ca8d629c25856b2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1ca8d629c25856b2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ca8d629c25856b2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1ca8d629c25856b2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1ca8d629c25856b2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1ca8d629c25856b2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1ca8d629c25856b2$var$_defineProperty(obj, key, value) {
    key = $1ca8d629c25856b2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ca8d629c25856b2$var$_toPropertyKey(arg) {
    var key = $1ca8d629c25856b2$var$_toPrimitive(arg, "string");
    return $1ca8d629c25856b2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1ca8d629c25856b2$var$_toPrimitive(input, hint) {
    if ($1ca8d629c25856b2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1ca8d629c25856b2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1ca8d629c25856b2$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(value) && (0, $19512e2323c12caf$export$402a499e1ea44294)(value[0]) && (0, $19512e2323c12caf$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $1ca8d629c25856b2$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($6bc233c5107ae9f1$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $1ca8d629c25856b2$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $1ca8d629c25856b2$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $1ca8d629c25856b2$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $19512e2323c12caf$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $19512e2323c12caf$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $1ca8d629c25856b2$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $1ca8d629c25856b2$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};




function $671480c5806edb80$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $671480c5806edb80$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $671480c5806edb80$var$_typeof(obj);
}
function $671480c5806edb80$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $671480c5806edb80$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $671480c5806edb80$var$ownKeys(Object(source), !0).forEach(function(key) {
            $671480c5806edb80$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $671480c5806edb80$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $671480c5806edb80$var$_defineProperty(obj, key, value) {
    key = $671480c5806edb80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $671480c5806edb80$var$_toPropertyKey(arg) {
    var key = $671480c5806edb80$var$_toPrimitive(arg, "string");
    return $671480c5806edb80$var$_typeof(key) === "symbol" ? key : String(key);
}
function $671480c5806edb80$var$_toPrimitive(input, hint) {
    if ($671480c5806edb80$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($671480c5806edb80$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $671480c5806edb80$var$_slicedToArray(arr, i) {
    return $671480c5806edb80$var$_arrayWithHoles(arr) || $671480c5806edb80$var$_iterableToArrayLimit(arr, i) || $671480c5806edb80$var$_unsupportedIterableToArray(arr, i) || $671480c5806edb80$var$_nonIterableRest();
}
function $671480c5806edb80$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $671480c5806edb80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $671480c5806edb80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $671480c5806edb80$var$_arrayLikeToArray(o, minLen);
}
function $671480c5806edb80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $671480c5806edb80$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $671480c5806edb80$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $671480c5806edb80$var$CLS_PREFIX = "recharts-tooltip-wrapper";
var $671480c5806edb80$var$EPS = 1;
function $671480c5806edb80$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $671480c5806edb80$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($7df642e092a5d65c$exports)))(payload, $671480c5806edb80$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($7df642e092a5d65c$exports)))(payload, option);
    return payload;
}
function $671480c5806edb80$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $1ca8d629c25856b2$export$6fe33945eebf9ac8), props);
}
var $671480c5806edb80$var$tooltipDefaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    reverseDirection: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    // this doesn't exist on TooltipProps
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cursorStyle: {},
    separator: " : ",
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: "hover",
    isAnimationActive: !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr,
    animationEasing: "ease",
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};
var $671480c5806edb80$export$28c660c63b792dea = function Tooltip(props) {
    var _classNames;
    var _useState = (0, $6P6dz.useState)(-1), _useState2 = $671480c5806edb80$var$_slicedToArray(_useState, 2), boxWidth = _useState2[0], setBoxWidth = _useState2[1];
    var _useState3 = (0, $6P6dz.useState)(-1), _useState4 = $671480c5806edb80$var$_slicedToArray(_useState3, 2), boxHeight = _useState4[0], setBoxHeight = _useState4[1];
    var _useState5 = (0, $6P6dz.useState)(false), _useState6 = $671480c5806edb80$var$_slicedToArray(_useState5, 2), dismissed = _useState6[0], setDismissed = _useState6[1];
    var _useState7 = (0, $6P6dz.useState)({
        x: 0,
        y: 0
    }), _useState8 = $671480c5806edb80$var$_slicedToArray(_useState7, 2), dismissedAtCoordinate = _useState8[0], setDismissedAtCoordinate = _useState8[1];
    var wrapperNode = (0, $6P6dz.useRef)();
    var allowEscapeViewBox = props.allowEscapeViewBox, reverseDirection = props.reverseDirection, coordinate = props.coordinate, offset = props.offset, position = props.position, viewBox = props.viewBox;
    var handleKeyDown = (0, $6P6dz.useCallback)(function(event) {
        if (event.key === "Escape") {
            setDismissed(true);
            setDismissedAtCoordinate(function(prev) {
                return $671480c5806edb80$var$_objectSpread($671480c5806edb80$var$_objectSpread({}, prev), {}, {
                    x: coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
                    y: coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
                });
            });
        }
    }, [
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
    ]);
    (0, $6P6dz.useEffect)(function() {
        var updateBBox = function updateBBox() {
            if (dismissed) {
                document.removeEventListener("keydown", handleKeyDown);
                if ((coordinate === null || coordinate === void 0 ? void 0 : coordinate.x) !== dismissedAtCoordinate.x || (coordinate === null || coordinate === void 0 ? void 0 : coordinate.y) !== dismissedAtCoordinate.y) setDismissed(false);
            } else document.addEventListener("keydown", handleKeyDown);
            if (wrapperNode.current && wrapperNode.current.getBoundingClientRect) {
                var box = wrapperNode.current.getBoundingClientRect();
                if (Math.abs(box.width - boxWidth) > $671480c5806edb80$var$EPS || Math.abs(box.height - boxHeight) > $671480c5806edb80$var$EPS) {
                    setBoxWidth(box.width);
                    setBoxHeight(box.height);
                }
            } else if (boxWidth !== -1 || boxHeight !== -1) {
                setBoxWidth(-1);
                setBoxHeight(-1);
            }
        };
        updateBBox();
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        boxHeight,
        boxWidth,
        coordinate,
        dismissed,
        dismissedAtCoordinate.x,
        dismissedAtCoordinate.y,
        handleKeyDown
    ]);
    var getTranslate = function getTranslate(_ref) {
        var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
        if (position && (0, $19512e2323c12caf$export$7e4aa119212bc614)(position[key])) return position[key];
        var negative = coordinate[key] - tooltipDimension - offset;
        var positive = coordinate[key] + offset;
        if (allowEscapeViewBox !== null && allowEscapeViewBox !== void 0 && allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
        if (reverseDirection !== null && reverseDirection !== void 0 && reverseDirection[key]) {
            var _tooltipBoundary = negative;
            var _viewBoxBoundary = viewBox[key];
            if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
            return Math.max(negative, viewBox[key]);
        }
        var tooltipBoundary = positive + tooltipDimension;
        var viewBoxBoundary = viewBox[key] + viewBoxDimension;
        if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
        return Math.max(positive, viewBox[key]);
    };
    var payload = props.payload, payloadUniqBy = props.payloadUniqBy, filterNull = props.filterNull, active = props.active, wrapperStyle = props.wrapperStyle, useTranslate3d = props.useTranslate3d, isAnimationActive = props.isAnimationActive, animationDuration = props.animationDuration, animationEasing = props.animationEasing;
    var finalPayload = $671480c5806edb80$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry.value);
    }) : payload);
    var hasPayload = finalPayload && finalPayload.length;
    var content = props.content;
    var outerStyle = $671480c5806edb80$var$_objectSpread({
        pointerEvents: "none",
        visibility: !dismissed && active && hasPayload ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
    }, wrapperStyle);
    var translateX, translateY;
    if (position && (0, $19512e2323c12caf$export$7e4aa119212bc614)(position.x) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(position.y)) {
        translateX = position.x;
        translateY = position.y;
    } else if (boxWidth > 0 && boxHeight > 0 && coordinate) {
        translateX = getTranslate({
            key: "x",
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
        });
        translateY = getTranslate({
            key: "y",
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
        });
    } else outerStyle.visibility = "hidden";
    outerStyle = $671480c5806edb80$var$_objectSpread($671480c5806edb80$var$_objectSpread({}, (0, $da8ef09ddeb2aefb$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    })), outerStyle);
    if (isAnimationActive && active) outerStyle = $671480c5806edb80$var$_objectSpread($671480c5806edb80$var$_objectSpread({}, (0, $da8ef09ddeb2aefb$export$ff9926a5d1daa67c)({
        transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
    })), outerStyle);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))($671480c5806edb80$var$CLS_PREFIX, (_classNames = {}, $671480c5806edb80$var$_defineProperty(_classNames, "".concat($671480c5806edb80$var$CLS_PREFIX, "-right"), (0, $19512e2323c12caf$export$7e4aa119212bc614)(translateX) && coordinate && (0, $19512e2323c12caf$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $671480c5806edb80$var$_defineProperty(_classNames, "".concat($671480c5806edb80$var$CLS_PREFIX, "-left"), (0, $19512e2323c12caf$export$7e4aa119212bc614)(translateX) && coordinate && (0, $19512e2323c12caf$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $671480c5806edb80$var$_defineProperty(_classNames, "".concat($671480c5806edb80$var$CLS_PREFIX, "-bottom"), (0, $19512e2323c12caf$export$7e4aa119212bc614)(translateY) && coordinate && (0, $19512e2323c12caf$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $671480c5806edb80$var$_defineProperty(_classNames, "".concat($671480c5806edb80$var$CLS_PREFIX, "-top"), (0, $19512e2323c12caf$export$7e4aa119212bc614)(translateY) && coordinate && (0, $19512e2323c12caf$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
    return(/*#__PURE__*/ // ESLint is disabled to allow listening to the `Escape` key. Refer to
    // https://github.com/recharts/recharts/pull/2925
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", {
        tabIndex: -1,
        role: "dialog",
        className: cls,
        style: outerStyle,
        ref: wrapperNode
    }, $671480c5806edb80$var$renderContent(content, $671480c5806edb80$var$_objectSpread($671480c5806edb80$var$_objectSpread({}, props), {}, {
        payload: finalPayload
    }))));
};
// needs to be set so that renderByOrder can find the correct handler function
$671480c5806edb80$export$28c660c63b792dea.displayName = "Tooltip";
/**
 * needs to be set so that renderByOrder can access an have default values for
 * children.props when there are no props set by the consumer
 * doesn't work if using default parameters
 */ $671480c5806edb80$export$28c660c63b792dea.defaultProps = $671480c5806edb80$var$tooltipDefaultProps;





var $6P6dz = parcelRequire("6P6dz");



function $11bc2aa07539f81d$var$_extends() {
    $11bc2aa07539f81d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $11bc2aa07539f81d$var$_extends.apply(this, arguments);
}
var $11bc2aa07539f81d$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $11bc2aa07539f81d$export$3c877bb842c36952 = function Cross(props) {
    var x = props.x, y = props.y, width = props.width, height = props.height, top = props.top, left = props.left, className = props.className;
    if (!(0, $19512e2323c12caf$export$7e4aa119212bc614)(x) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(y) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(width) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(height) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(top) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $11bc2aa07539f81d$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-cross", className),
        d: $11bc2aa07539f81d$var$getPath(x, y, width, height, top, left)
    }));
};
$11bc2aa07539f81d$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};



var $6P6dz = parcelRequire("6P6dz");




function $cd7582df0044dfd9$var$_extends() {
    $cd7582df0044dfd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd7582df0044dfd9$var$_extends.apply(this, arguments);
}
var $cd7582df0044dfd9$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $19512e2323c12caf$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $cd7582df0044dfd9$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $00f96ac211b54895$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $00f96ac211b54895$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $cd7582df0044dfd9$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $cd7582df0044dfd9$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $cd7582df0044dfd9$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $19512e2323c12caf$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $cd7582df0044dfd9$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $cd7582df0044dfd9$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $cd7582df0044dfd9$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $cd7582df0044dfd9$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $cd7582df0044dfd9$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $cd7582df0044dfd9$export$e98c2c7eb2b14f45 = function Sector(props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $19512e2323c12caf$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $cd7582df0044dfd9$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $cd7582df0044dfd9$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("path", $cd7582df0044dfd9$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};
$cd7582df0044dfd9$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};








var $6P6dz = parcelRequire("6P6dz");









var $187bf9f2a573caaf$var$_excluded = [
    "viewBox"
], $187bf9f2a573caaf$var$_excluded2 = [
    "viewBox"
], $187bf9f2a573caaf$var$_excluded3 = [
    "ticks"
];
function $187bf9f2a573caaf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $187bf9f2a573caaf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $187bf9f2a573caaf$var$_typeof(obj);
}
function $187bf9f2a573caaf$var$_extends() {
    $187bf9f2a573caaf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $187bf9f2a573caaf$var$_extends.apply(this, arguments);
}
function $187bf9f2a573caaf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $187bf9f2a573caaf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $187bf9f2a573caaf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $187bf9f2a573caaf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $187bf9f2a573caaf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $187bf9f2a573caaf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $187bf9f2a573caaf$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $187bf9f2a573caaf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $187bf9f2a573caaf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $187bf9f2a573caaf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $187bf9f2a573caaf$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $187bf9f2a573caaf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $187bf9f2a573caaf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $187bf9f2a573caaf$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $187bf9f2a573caaf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $187bf9f2a573caaf$var$_setPrototypeOf(subClass, superClass);
}
function $187bf9f2a573caaf$var$_setPrototypeOf(o, p) {
    $187bf9f2a573caaf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $187bf9f2a573caaf$var$_setPrototypeOf(o, p);
}
function $187bf9f2a573caaf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $187bf9f2a573caaf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $187bf9f2a573caaf$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $187bf9f2a573caaf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $187bf9f2a573caaf$var$_possibleConstructorReturn(this, result);
    };
}
function $187bf9f2a573caaf$var$_possibleConstructorReturn(self, call) {
    if (call && ($187bf9f2a573caaf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $187bf9f2a573caaf$var$_assertThisInitialized(self);
}
function $187bf9f2a573caaf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $187bf9f2a573caaf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $187bf9f2a573caaf$var$_getPrototypeOf(o) {
    $187bf9f2a573caaf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $187bf9f2a573caaf$var$_getPrototypeOf(o);
}
function $187bf9f2a573caaf$var$_defineProperty(obj, key, value) {
    key = $187bf9f2a573caaf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $187bf9f2a573caaf$var$_toPropertyKey(arg) {
    var key = $187bf9f2a573caaf$var$_toPrimitive(arg, "string");
    return $187bf9f2a573caaf$var$_typeof(key) === "symbol" ? key : String(key);
}
function $187bf9f2a573caaf$var$_toPrimitive(input, hint) {
    if ($187bf9f2a573caaf$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($187bf9f2a573caaf$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $187bf9f2a573caaf$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $187bf9f2a573caaf$var$_inherits(CartesianAxis, _Component);
    var _super = $187bf9f2a573caaf$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $187bf9f2a573caaf$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $187bf9f2a573caaf$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $187bf9f2a573caaf$var$_objectWithoutProperties(_ref, $187bf9f2a573caaf$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $187bf9f2a573caaf$var$_objectWithoutProperties(_this$props, $187bf9f2a573caaf$var$_excluded2);
                return !(0, $c9e23242a30afedc$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $c9e23242a30afedc$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $c9e23242a30afedc$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $19512e2323c12caf$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props)), (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", $187bf9f2a573caaf$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $ade45b8dec91087b$export$3d27d42b1034de5c)($187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(tick);
                var tickLineProps = $187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread($187bf9f2a573caaf$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $187bf9f2a573caaf$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f237646aefb1d4cb$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", $187bf9f2a573caaf$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $187bf9f2a573caaf$var$_objectWithoutProperties(_this$props8, $187bf9f2a573caaf$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $deb3ca7225310ca3$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $19d8402d51c91e20$export$5f1af8db9871e1d6), $187bf9f2a573caaf$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $6P6dz.Component));
$187bf9f2a573caaf$var$_defineProperty($187bf9f2a573caaf$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$187bf9f2a573caaf$var$_defineProperty($187bf9f2a573caaf$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});





var $6P6dz = parcelRequire("6P6dz");






function $c60032cabda859a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c60032cabda859a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c60032cabda859a7$var$_typeof(obj);
}
function $c60032cabda859a7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c60032cabda859a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c60032cabda859a7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c60032cabda859a7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c60032cabda859a7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c60032cabda859a7$var$_defineProperty(obj, key, value) {
    key = $c60032cabda859a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c60032cabda859a7$var$_toPropertyKey(arg) {
    var key = $c60032cabda859a7$var$_toPrimitive(arg, "string");
    return $c60032cabda859a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c60032cabda859a7$var$_toPrimitive(input, hint) {
    if ($c60032cabda859a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c60032cabda859a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c60032cabda859a7$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $c60032cabda859a7$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $c60032cabda859a7$var$PREFIX_LIST.reduce(function(res, entry) {
        return $c60032cabda859a7$var$_objectSpread($c60032cabda859a7$var$_objectSpread({}, res), {}, $c60032cabda859a7$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $36839eff80ac1c74$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $36839eff80ac1c74$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $36839eff80ac1c74$var$_typeof(obj);
}
function $36839eff80ac1c74$var$_extends() {
    $36839eff80ac1c74$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36839eff80ac1c74$var$_extends.apply(this, arguments);
}
function $36839eff80ac1c74$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $36839eff80ac1c74$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $36839eff80ac1c74$var$ownKeys(Object(source), !0).forEach(function(key) {
            $36839eff80ac1c74$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $36839eff80ac1c74$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $36839eff80ac1c74$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $36839eff80ac1c74$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $36839eff80ac1c74$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $36839eff80ac1c74$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $36839eff80ac1c74$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $36839eff80ac1c74$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $36839eff80ac1c74$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $36839eff80ac1c74$var$_setPrototypeOf(subClass, superClass);
}
function $36839eff80ac1c74$var$_setPrototypeOf(o, p) {
    $36839eff80ac1c74$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $36839eff80ac1c74$var$_setPrototypeOf(o, p);
}
function $36839eff80ac1c74$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $36839eff80ac1c74$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $36839eff80ac1c74$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $36839eff80ac1c74$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $36839eff80ac1c74$var$_possibleConstructorReturn(this, result);
    };
}
function $36839eff80ac1c74$var$_possibleConstructorReturn(self, call) {
    if (call && ($36839eff80ac1c74$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $36839eff80ac1c74$var$_assertThisInitialized(self);
}
function $36839eff80ac1c74$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $36839eff80ac1c74$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $36839eff80ac1c74$var$_getPrototypeOf(o) {
    $36839eff80ac1c74$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $36839eff80ac1c74$var$_getPrototypeOf(o);
}
function $36839eff80ac1c74$var$_defineProperty(obj, key, value) {
    key = $36839eff80ac1c74$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $36839eff80ac1c74$var$_toPropertyKey(arg) {
    var key = $36839eff80ac1c74$var$_toPrimitive(arg, "string");
    return $36839eff80ac1c74$var$_typeof(key) === "symbol" ? key : String(key);
}
function $36839eff80ac1c74$var$_toPrimitive(input, hint) {
    if ($36839eff80ac1c74$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($36839eff80ac1c74$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $36839eff80ac1c74$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $94acda4d2dab3b77$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($b20779d34f7da175$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $36839eff80ac1c74$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $36839eff80ac1c74$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $36839eff80ac1c74$var$_inherits(Brush, _PureComponent);
    var _super = $36839eff80ac1c74$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $36839eff80ac1c74$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $36839eff80ac1c74$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($36839eff80ac1c74$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($36839eff80ac1c74$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $36839eff80ac1c74$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $30c733ceebebab59$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $36839eff80ac1c74$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $36839eff80ac1c74$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $36839eff80ac1c74$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $6P6dz.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $36839eff80ac1c74$var$_objectSpread($36839eff80ac1c74$var$_objectSpread({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $19d8402d51c91e20$export$5f1af8db9871e1d6), $36839eff80ac1c74$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $19d8402d51c91e20$export$5f1af8db9871e1d6), $36839eff80ac1c74$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(x) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(y) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(width) || !(0, $19512e2323c12caf$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).Children.count(children) === 1;
                var style = (0, $c60032cabda859a7$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $36839eff80ac1c74$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $36839eff80ac1c74$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $6P6dz.PureComponent));
$36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$export$59bc2e3533b384a0, "displayName", "Brush");
$36839eff80ac1c74$var$_defineProperty($36839eff80ac1c74$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});







var $6P6dz = parcelRequire("6P6dz");





var $81c1df5d5a308a18$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};



/* eslint no-console: 0 */ var $7b55ee08175223e3$var$isDev = false;
var $7b55ee08175223e3$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7b55ee08175223e3$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $3adbc90f59ffd534$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3adbc90f59ffd534$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3adbc90f59ffd534$var$_typeof(obj);
}
function $3adbc90f59ffd534$var$_extends() {
    $3adbc90f59ffd534$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3adbc90f59ffd534$var$_extends.apply(this, arguments);
}
function $3adbc90f59ffd534$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3adbc90f59ffd534$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3adbc90f59ffd534$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3adbc90f59ffd534$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3adbc90f59ffd534$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3adbc90f59ffd534$var$_defineProperty(obj, key, value) {
    key = $3adbc90f59ffd534$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3adbc90f59ffd534$var$_toPropertyKey(arg) {
    var key = $3adbc90f59ffd534$var$_toPrimitive(arg, "string");
    return $3adbc90f59ffd534$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3adbc90f59ffd534$var$_toPrimitive(input, hint) {
    if ($3adbc90f59ffd534$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3adbc90f59ffd534$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3adbc90f59ffd534$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $6908f2be6e0983bb$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $3adbc90f59ffd534$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $19512e2323c12caf$export$402a499e1ea44294)(x);
    var isY = (0, $19512e2323c12caf$export$402a499e1ea44294)(y);
    (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $3adbc90f59ffd534$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $3adbc90f59ffd534$var$_objectSpread($3adbc90f59ffd534$var$_objectSpread({
        clipPath: clipPath
    }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-reference-dot", className)
    }, $3adbc90f59ffd534$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $deb3ca7225310ca3$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$3adbc90f59ffd534$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$3adbc90f59ffd534$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$3adbc90f59ffd534$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $5a9ccb48149eca10$export$d046b3c4a416f60d), $3adbc90f59ffd534$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $a9b7a0d5f276f286$exports = {};


var $06a5173edab24830$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $06a5173edab24830$var$baseSome(collection, predicate) {
    var result;
    $1ed335bc48f220a3$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$06a5173edab24830$exports = $06a5173edab24830$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $a9b7a0d5f276f286$var$some(collection, predicate, guard) {
    var func = $d14e2831379630a0$exports(collection) ? $6e4174481de3f6e1$exports : $06a5173edab24830$exports;
    if (guard && $e57e5a019c44e628$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $b835b507318041f7$exports(predicate, 3));
}
$a9b7a0d5f276f286$exports = $a9b7a0d5f276f286$var$some;




var $6P6dz = parcelRequire("6P6dz");








function $bc8cdd9bc6426677$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bc8cdd9bc6426677$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bc8cdd9bc6426677$var$_typeof(obj);
}
function $bc8cdd9bc6426677$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bc8cdd9bc6426677$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bc8cdd9bc6426677$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bc8cdd9bc6426677$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bc8cdd9bc6426677$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bc8cdd9bc6426677$var$_defineProperty(obj, key, value) {
    key = $bc8cdd9bc6426677$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc8cdd9bc6426677$var$_toPropertyKey(arg) {
    var key = $bc8cdd9bc6426677$var$_toPrimitive(arg, "string");
    return $bc8cdd9bc6426677$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bc8cdd9bc6426677$var$_toPrimitive(input, hint) {
    if ($bc8cdd9bc6426677$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bc8cdd9bc6426677$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bc8cdd9bc6426677$var$_slicedToArray(arr, i) {
    return $bc8cdd9bc6426677$var$_arrayWithHoles(arr) || $bc8cdd9bc6426677$var$_iterableToArrayLimit(arr, i) || $bc8cdd9bc6426677$var$_unsupportedIterableToArray(arr, i) || $bc8cdd9bc6426677$var$_nonIterableRest();
}
function $bc8cdd9bc6426677$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bc8cdd9bc6426677$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bc8cdd9bc6426677$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bc8cdd9bc6426677$var$_arrayLikeToArray(o, minLen);
}
function $bc8cdd9bc6426677$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bc8cdd9bc6426677$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $bc8cdd9bc6426677$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bc8cdd9bc6426677$var$_extends() {
    $bc8cdd9bc6426677$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc8cdd9bc6426677$var$_extends.apply(this, arguments);
}
var $bc8cdd9bc6426677$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("line", $bc8cdd9bc6426677$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $bc8cdd9bc6426677$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($a9b7a0d5f276f286$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $bc8cdd9bc6426677$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $6908f2be6e0983bb$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $19512e2323c12caf$export$402a499e1ea44294)(fixedX);
    var isY = (0, $19512e2323c12caf$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $bc8cdd9bc6426677$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $bc8cdd9bc6426677$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $bc8cdd9bc6426677$var$_objectSpread($bc8cdd9bc6426677$var$_objectSpread({
        clipPath: clipPath
    }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-reference-line", className)
    }, $bc8cdd9bc6426677$var$renderLine(shape, lineProps), (0, $deb3ca7225310ca3$export$b04be29aa201d4f5).renderCallByParent(props, (0, $6908f2be6e0983bb$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$bc8cdd9bc6426677$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$bc8cdd9bc6426677$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};




var $6P6dz = parcelRequire("6P6dz");









function $3b48d91c582a8a6a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3b48d91c582a8a6a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3b48d91c582a8a6a$var$_typeof(obj);
}
function $3b48d91c582a8a6a$var$_extends() {
    $3b48d91c582a8a6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b48d91c582a8a6a$var$_extends.apply(this, arguments);
}
function $3b48d91c582a8a6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b48d91c582a8a6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3b48d91c582a8a6a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3b48d91c582a8a6a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3b48d91c582a8a6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3b48d91c582a8a6a$var$_defineProperty(obj, key, value) {
    key = $3b48d91c582a8a6a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b48d91c582a8a6a$var$_toPropertyKey(arg) {
    var key = $3b48d91c582a8a6a$var$_toPrimitive(arg, "string");
    return $3b48d91c582a8a6a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3b48d91c582a8a6a$var$_toPrimitive(input, hint) {
    if ($3b48d91c582a8a6a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3b48d91c582a8a6a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3b48d91c582a8a6a$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $6908f2be6e0983bb$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $6908f2be6e0983bb$export$c7964a5b9439ae62)(p1, p2);
};
function $3b48d91c582a8a6a$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $19512e2323c12caf$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $19512e2323c12caf$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $19512e2323c12caf$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $19512e2323c12caf$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $3b48d91c582a8a6a$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $81c1df5d5a308a18$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-reference-area", className)
    }, $3b48d91c582a8a6a$export$b4ec4f050ce240b9.renderRect(shape, $3b48d91c582a8a6a$var$_objectSpread($3b48d91c582a8a6a$var$_objectSpread({
        clipPath: clipPath
    }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(props, true)), rect)), (0, $deb3ca7225310ca3$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$3b48d91c582a8a6a$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$3b48d91c582a8a6a$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$3b48d91c582a8a6a$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $7521f5043c96f3a0$export$4617fb02663045ef), $3b48d91c582a8a6a$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $addee3e36c9cf231$var$_toConsumableArray(arr) {
    return $addee3e36c9cf231$var$_arrayWithoutHoles(arr) || $addee3e36c9cf231$var$_iterableToArray(arr) || $addee3e36c9cf231$var$_unsupportedIterableToArray(arr) || $addee3e36c9cf231$var$_nonIterableSpread();
}
function $addee3e36c9cf231$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $addee3e36c9cf231$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $addee3e36c9cf231$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $addee3e36c9cf231$var$_arrayLikeToArray(o, minLen);
}
function $addee3e36c9cf231$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $addee3e36c9cf231$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $addee3e36c9cf231$var$_arrayLikeToArray(arr);
}
function $addee3e36c9cf231$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $addee3e36c9cf231$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $bc8cdd9bc6426677$export$b2f28e248e7838eb));
    var dots = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $3adbc90f59ffd534$export$aa7f0b0106bff39));
    var elements = [].concat($addee3e36c9cf231$var$_toConsumableArray(lines), $addee3e36c9cf231$var$_toConsumableArray(dots));
    var areas = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $3b48d91c582a8a6a$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $81c1df5d5a308a18$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $19512e2323c12caf$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $81c1df5d5a308a18$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $19512e2323c12caf$export$7e4aa119212bc614)(el.props[key1]) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $7fd25f3b30426e77$exports = {};
"use strict";
var $7fd25f3b30426e77$var$has = Object.prototype.hasOwnProperty, $7fd25f3b30426e77$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7fd25f3b30426e77$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7fd25f3b30426e77$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7fd25f3b30426e77$var$Events().__proto__) $7fd25f3b30426e77$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7fd25f3b30426e77$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7fd25f3b30426e77$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $7fd25f3b30426e77$var$EE(fn, context || emitter, once), evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7fd25f3b30426e77$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7fd25f3b30426e77$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7fd25f3b30426e77$var$EventEmitter() {
    this._events = new $7fd25f3b30426e77$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7fd25f3b30426e77$var$has.call(events, name)) names.push($7fd25f3b30426e77$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7fd25f3b30426e77$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7fd25f3b30426e77$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7fd25f3b30426e77$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7fd25f3b30426e77$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7fd25f3b30426e77$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7fd25f3b30426e77$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7fd25f3b30426e77$var$prefix ? $7fd25f3b30426e77$var$prefix + event : event;
        if (this._events[evt]) $7fd25f3b30426e77$var$clearEvent(this, evt);
    } else {
        this._events = new $7fd25f3b30426e77$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7fd25f3b30426e77$var$EventEmitter.prototype.off = $7fd25f3b30426e77$var$EventEmitter.prototype.removeListener;
$7fd25f3b30426e77$var$EventEmitter.prototype.addListener = $7fd25f3b30426e77$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7fd25f3b30426e77$var$EventEmitter.prefixed = $7fd25f3b30426e77$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7fd25f3b30426e77$var$EventEmitter.EventEmitter = $7fd25f3b30426e77$var$EventEmitter;
$7fd25f3b30426e77$exports = $7fd25f3b30426e77$var$EventEmitter;


var $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($7fd25f3b30426e77$exports)))();
if ($b4dd4aebd3f07fe9$export$9bcdfe5f29bb33.setMaxListeners) $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33.setMaxListeners(10);
var $b4dd4aebd3f07fe9$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $d684455a5fa09749$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d684455a5fa09749$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d684455a5fa09749$var$_typeof(obj);
}
function $d684455a5fa09749$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d684455a5fa09749$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d684455a5fa09749$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d684455a5fa09749$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d684455a5fa09749$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d684455a5fa09749$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d684455a5fa09749$var$_defineProperty(obj, key, value) {
    key = $d684455a5fa09749$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d684455a5fa09749$var$_toPropertyKey(arg) {
    var key = $d684455a5fa09749$var$_toPrimitive(arg, "string");
    return $d684455a5fa09749$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d684455a5fa09749$var$_toPrimitive(input, hint) {
    if ($d684455a5fa09749$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d684455a5fa09749$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d684455a5fa09749$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $d684455a5fa09749$var$_classCallCheck(this, AccessibilityManager);
        $d684455a5fa09749$var$_defineProperty(this, "activeIndex", 0);
        $d684455a5fa09749$var$_defineProperty(this, "coordinateList", []);
        $d684455a5fa09749$var$_defineProperty(this, "layout", "horizontal");
    }
    $d684455a5fa09749$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var pageX = x + coordinate;
                var pageY = y + this.offset.top;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();


var $d1f36bdabf648b21$var$_excluded = [
    "item"
], $d1f36bdabf648b21$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $d1f36bdabf648b21$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d1f36bdabf648b21$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d1f36bdabf648b21$var$_typeof(obj);
}
function $d1f36bdabf648b21$var$_slicedToArray(arr, i) {
    return $d1f36bdabf648b21$var$_arrayWithHoles(arr) || $d1f36bdabf648b21$var$_iterableToArrayLimit(arr, i) || $d1f36bdabf648b21$var$_unsupportedIterableToArray(arr, i) || $d1f36bdabf648b21$var$_nonIterableRest();
}
function $d1f36bdabf648b21$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d1f36bdabf648b21$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $d1f36bdabf648b21$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d1f36bdabf648b21$var$_extends() {
    $d1f36bdabf648b21$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1f36bdabf648b21$var$_extends.apply(this, arguments);
}
function $d1f36bdabf648b21$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d1f36bdabf648b21$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d1f36bdabf648b21$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d1f36bdabf648b21$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d1f36bdabf648b21$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d1f36bdabf648b21$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d1f36bdabf648b21$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d1f36bdabf648b21$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d1f36bdabf648b21$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d1f36bdabf648b21$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d1f36bdabf648b21$var$_setPrototypeOf(subClass, superClass);
}
function $d1f36bdabf648b21$var$_setPrototypeOf(o, p) {
    $d1f36bdabf648b21$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d1f36bdabf648b21$var$_setPrototypeOf(o, p);
}
function $d1f36bdabf648b21$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d1f36bdabf648b21$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d1f36bdabf648b21$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d1f36bdabf648b21$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d1f36bdabf648b21$var$_possibleConstructorReturn(this, result);
    };
}
function $d1f36bdabf648b21$var$_possibleConstructorReturn(self, call) {
    if (call && ($d1f36bdabf648b21$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d1f36bdabf648b21$var$_assertThisInitialized(self);
}
function $d1f36bdabf648b21$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d1f36bdabf648b21$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d1f36bdabf648b21$var$_getPrototypeOf(o) {
    $d1f36bdabf648b21$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d1f36bdabf648b21$var$_getPrototypeOf(o);
}
function $d1f36bdabf648b21$var$_toConsumableArray(arr) {
    return $d1f36bdabf648b21$var$_arrayWithoutHoles(arr) || $d1f36bdabf648b21$var$_iterableToArray(arr) || $d1f36bdabf648b21$var$_unsupportedIterableToArray(arr) || $d1f36bdabf648b21$var$_nonIterableSpread();
}
function $d1f36bdabf648b21$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d1f36bdabf648b21$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d1f36bdabf648b21$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d1f36bdabf648b21$var$_arrayLikeToArray(o, minLen);
}
function $d1f36bdabf648b21$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d1f36bdabf648b21$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d1f36bdabf648b21$var$_arrayLikeToArray(arr);
}
function $d1f36bdabf648b21$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d1f36bdabf648b21$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d1f36bdabf648b21$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d1f36bdabf648b21$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d1f36bdabf648b21$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d1f36bdabf648b21$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d1f36bdabf648b21$var$_defineProperty(obj, key, value) {
    key = $d1f36bdabf648b21$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d1f36bdabf648b21$var$_toPropertyKey(arg) {
    var key = $d1f36bdabf648b21$var$_toPrimitive(arg, "string");
    return $d1f36bdabf648b21$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d1f36bdabf648b21$var$_toPrimitive(input, hint) {
    if ($d1f36bdabf648b21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d1f36bdabf648b21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d1f36bdabf648b21$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $d1f36bdabf648b21$var$originCoordinate = {
    x: 0,
    y: 0
};
// use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $d1f36bdabf648b21$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $d1f36bdabf648b21$var$defer = // eslint-disable-next-line no-nested-ternary
typeof requestAnimationFrame === "function" ? requestAnimationFrame : typeof setImmediate === "function" ? setImmediate : setTimeout;
var $d1f36bdabf648b21$var$deferClear = // eslint-disable-next-line no-nested-ternary
typeof cancelAnimationFrame === "function" ? cancelAnimationFrame : typeof clearImmediate === "function" ? clearImmediate : clearTimeout;
var $d1f36bdabf648b21$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $d1f36bdabf648b21$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, rangeObj), (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, rangeObj), (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $d1f36bdabf648b21$var$originCoordinate;
};
var $d1f36bdabf648b21$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($d1f36bdabf648b21$var$_toConsumableArray(result), $d1f36bdabf648b21$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $19512e2323c12caf$export$7e4aa119212bc614)(dataStartIndex) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ function $d1f36bdabf648b21$var$isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $19512e2323c12caf$export$7e4aa119212bc614)(domainStart) && (0, $19512e2323c12caf$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}
function $d1f36bdabf648b21$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $d1f36bdabf648b21$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $d1f36bdabf648b21$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $19512e2323c12caf$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($d1f36bdabf648b21$var$_toConsumableArray(result), [
            (0, $30c733ceebebab59$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $d1f36bdabf648b21$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $d1f36bdabf648b21$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $30c733ceebebab59$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $d1f36bdabf648b21$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $d1f36bdabf648b21$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $d1f36bdabf648b21$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $30c733ceebebab59$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $d1f36bdabf648b21$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ($d1f36bdabf648b21$var$isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $30c733ceebebab59$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $30c733ceebebab59$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $d1f36bdabf648b21$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $30c733ceebebab59$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $19512e2323c12caf$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($b20779d34f7da175$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $30c733ceebebab59$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($d1f36bdabf648b21$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $30c733ceebebab59$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry) ? finalDomain : [].concat($d1f36bdabf648b21$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $30c733ceebebab59$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $30c733ceebebab59$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($b20779d34f7da175$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $30c733ceebebab59$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $30c733ceebebab59$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $addee3e36c9cf231$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $30c733ceebebab59$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, $d1f36bdabf648b21$var$_defineProperty({}, axisId, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $d1f36bdabf648b21$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $d1f36bdabf648b21$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $30c733ceebebab59$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $d1f36bdabf648b21$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($b20779d34f7da175$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $30c733ceebebab59$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $addee3e36c9cf231$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $30c733ceebebab59$export$a0bc8660980558a0)(originalDomain, (0, $30c733ceebebab59$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $addee3e36c9cf231$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, $d1f36bdabf648b21$var$_defineProperty({}, axisId, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))($d1f36bdabf648b21$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $d1f36bdabf648b21$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $d1f36bdabf648b21$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $d1f36bdabf648b21$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $d1f36bdabf648b21$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $30c733ceebebab59$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($6bc233c5107ae9f1$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $30c733ceebebab59$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $d1f36bdabf648b21$var$createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $36839eff80ac1c74$export$59bc2e3533b384a0));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $d1f36bdabf648b21$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $57ab65d6d53325f9$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $d1f36bdabf648b21$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $d1f36bdabf648b21$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $36839eff80ac1c74$export$59bc2e3533b384a0));
    var legendItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $75caf721c037b42d$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, $d1f36bdabf648b21$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, $d1f36bdabf648b21$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $36839eff80ac1c74$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $30c733ceebebab59$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $d1f36bdabf648b21$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $d1f36bdabf648b21$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $d1f36bdabf648b21$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $30c733ceebebab59$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $d1f36bdabf648b21$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $d1f36bdabf648b21$var$_defineProperty(_objectSpread6, entry.axisType, axis), $d1f36bdabf648b21$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $30c733ceebebab59$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $30c733ceebebab59$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $57ab65d6d53325f9$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $30c733ceebebab59$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $30c733ceebebab59$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $30c733ceebebab59$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, pos), {}, {
                        position: $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, composedFn($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $d1f36bdabf648b21$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $d1f36bdabf648b21$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $d1f36bdabf648b21$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $57ab65d6d53325f9$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $57ab65d6d53325f9$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $d1f36bdabf648b21$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $30c733ceebebab59$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, result), {}, $d1f36bdabf648b21$var$_defineProperty({}, name, $d1f36bdabf648b21$var$getAxisMap(props, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $d1f36bdabf648b21$var$calculateOffset($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $d1f36bdabf648b21$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $d1f36bdabf648b21$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $d1f36bdabf648b21$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _this;
            $d1f36bdabf648b21$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $d684455a5fa09749$export$a2c2de1efa8671eb)());
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "clearDeferId", function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(_this.deferId) && $d1f36bdabf648b21$var$deferClear) $d1f36bdabf648b21$var$deferClear(_this.deferId);
                _this.deferId = null;
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($d1f36bdabf648b21$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $d1f36bdabf648b21$var$defer && $d1f36bdabf648b21$var$defer(_this.applySyncEvent.bind($d1f36bdabf648b21$var$_assertThisInitialized(_this), data));
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $d1f36bdabf648b21$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $57ab65d6d53325f9$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    handler(mouse, e);
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $30c733ceebebab59$export$846dc5ac5fecff74)((0, $ade45b8dec91087b$export$3d27d42b1034de5c)($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, (0, $187bf9f2a573caaf$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $30c733ceebebab59$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $30c733ceebebab59$export$846dc5ac5fecff74)((0, $ade45b8dec91087b$export$3d27d42b1034de5c)($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, (0, $187bf9f2a573caaf$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $30c733ceebebab59$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $30c733ceebebab59$export$c829ee42daf7f66d)(axis, true);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $45580be9bbfd5120$export$b0e83c3ef8d2db1);
                if (chartName === "ScatterChart") {
                    restProps = activeCoordinate;
                    cursorComp = (0, $11bc2aa07539f81d$export$3c877bb842c36952);
                } else if (chartName === "BarChart") {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $7521f5043c96f3a0$export$4617fb02663045ef);
                } else if (layout === "radial") {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $cd7582df0044dfd9$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $45580be9bbfd5120$export$b0e83c3ef8d2db1);
                }
                var key = element.key || "_recharts-cursor";
                var cursorProps = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                    stroke: "#ccc",
                    pointerEvents: "none"
                }, offset), restProps), (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: "recharts-tooltip-cursor"
                });
                return /*#__PURE__*/ (0, $6P6dz.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $6P6dz.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $6P6dz.createElement)(cursorComp, cursorProps);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $30c733ceebebab59$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($62770549874729df$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($012e84436ac5b4a7$exports)))(axis.domain, $d1f36bdabf648b21$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $19512e2323c12caf$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $19512e2323c12caf$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $19512e2323c12caf$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $19512e2323c12caf$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $19512e2323c12caf$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(polarAngles) ? polarAngles : (0, $30c733ceebebab59$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(polarRadius) ? polarRadius : (0, $30c733ceebebab59$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $30c733ceebebab59$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $d1f36bdabf648b21$var$_objectWithoutProperties(props, $d1f36bdabf648b21$var$_excluded);
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(item, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var children = _this.props.children;
                var tooltipItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $671480c5806edb80$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(tooltipItem, {
                    viewBox: $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $30c733ceebebab59$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $19512e2323c12caf$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $19512e2323c12caf$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $19512e2323c12caf$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $d1f36bdabf648b21$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $30c733ceebebab59$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(activeDot)), (0, $f237646aefb1d4cb$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $671480c5806edb80$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $30c733ceebebab59$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $30c733ceebebab59$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $30c733ceebebab59$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $19512e2323c12caf$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $19512e2323c12caf$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($d1f36bdabf648b21$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $d1f36bdabf648b21$var$_defineProperty($d1f36bdabf648b21$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $6P6dz.cloneElement)(element, $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(_props.id) ? (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts") : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2ee795666c6b$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        $d1f36bdabf648b21$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(this.props.syncId)) this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.handleMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(this.props.syncId)) this.addListener();
                    // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === "function") this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(this.props.children, (0, $671480c5806edb80$export$28c660c63b792dea));
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($9dc855dc6a0fe577$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $34d5136d44d32c45$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $34d5136d44d32c45$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $d1f36bdabf648b21$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: "none",
                        fill: "#ccc",
                        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === "horizontal") {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === "vertical") {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(activeCoordinate.cy)) {
                        if (layout === "centric") {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $00f96ac211b54895$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $19512e2323c12caf$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $00f96ac211b54895$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $57ab65d6d53325f9$export$64c61536a2b72e0f)(children, (0, $671480c5806edb80$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $f237646aefb1d4cb$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).on((0, $b4dd4aebd3f07fe9$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).setMaxListeners && (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33)._maxListeners) (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).setMaxListeners((0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).removeListener((0, $b4dd4aebd3f07fe9$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).setMaxListeners && (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33)._maxListeners) (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).setMaxListeners((0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(syncId)) (0, $b4dd4aebd3f07fe9$export$9bcdfe5f29bb33).emit((0, $b4dd4aebd3f07fe9$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(data.dataEndIndex)) this.setState($d1f36bdabf648b21$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === "value") {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        });
                        // When a categorical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $d1f36bdabf648b21$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $d1f36bdabf648b21$var$originCoordinate;
                        this.setState($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $57ab65d6d53325f9$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $187bf9f2a573caaf$export$bdd99f2cdf352bae), $d1f36bdabf648b21$var$_extends({}, axisOptions, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $d1f36bdabf648b21$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, res), {}, $d1f36bdabf648b21$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $d1f36bdabf648b21$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, res), {}, $d1f36bdabf648b21$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $57ab65d6d53325f9$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $7521f5043c96f3a0$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $00f96ac211b54895$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $57ab65d6d53325f9$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $d1f36bdabf648b21$var$_objectWithoutProperties(_this$props6, $d1f36bdabf648b21$var$_excluded2);
                    var attrs = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    };
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01e8f2329e9a422e$export$7b92b459e668cb21), $d1f36bdabf648b21$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $57ab65d6d53325f9$export$a98d6da55570cb82)(children, map));
                    if (this.props.accessibilityLayer) {
                        var _2, _img;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_2 = 0, _2 !== void 0) ? _2 : this.props.tabIndex;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_img = "img", _img !== void 0) ? _img : this.props.role;
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", $d1f36bdabf648b21$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-wrapper", className),
                        style: $d1f36bdabf648b21$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01e8f2329e9a422e$export$7b92b459e668cb21), $d1f36bdabf648b21$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $57ab65d6d53325f9$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $6P6dz.Component)), $d1f36bdabf648b21$var$_defineProperty(_class, "displayName", chartName), $d1f36bdabf648b21$var$_defineProperty(_class, "defaultProps", $d1f36bdabf648b21$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), $d1f36bdabf648b21$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(prevState.updateId)) {
            var defaultState = $d1f36bdabf648b21$var$createDefaultState(nextProps);
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $c9e23242a30afedc$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $d1f36bdabf648b21$var$createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, $d1f36bdabf648b21$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($d1f36bdabf648b21$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $57ab65d6d53325f9$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($d1f36bdabf648b21$var$_objectSpread($d1f36bdabf648b21$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $d1f36bdabf648b21$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $6P6dz.isValidElement)(option)) dot = /*#__PURE__*/ (0, $6P6dz.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $5a9ccb48149eca10$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $73a42e140a9e1d25$export$ea77231de273b52d = function XAxis() {
    return null;
};
$73a42e140a9e1d25$export$ea77231de273b52d.displayName = "XAxis";
$73a42e140a9e1d25$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $e0b95f248e75d8a4$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$e0b95f248e75d8a4$export$f96c4024c52de8f4.displayName = "YAxis";
$e0b95f248e75d8a4$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $4a93ba87c594333d$export$54d0e8420ac838ac = (0, $d1f36bdabf648b21$export$77871aede60e6838)({
    chartName: "LineChart",
    GraphicalChild: (0, $bcd60d8d12bfb662$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $73a42e140a9e1d25$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $e0b95f248e75d8a4$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $6908f2be6e0983bb$export$ece7de1383db5ac)
});



var $6P6dz = parcelRequire("6P6dz");

var $6P6dz = parcelRequire("6P6dz");

var $e4MuM = parcelRequire("e4MuM");


/* global Reflect, Promise */ var $4b770f16b6b28ff6$var$extendStatics = function(d, b) {
    $4b770f16b6b28ff6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4b770f16b6b28ff6$var$extendStatics(d, b);
};
function $4b770f16b6b28ff6$var$__extends(d, b) {
    $4b770f16b6b28ff6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4b770f16b6b28ff6$var$__assign = function() {
    $4b770f16b6b28ff6$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4b770f16b6b28ff6$var$__assign.apply(this, arguments);
};
function $4b770f16b6b28ff6$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $4b770f16b6b28ff6$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case "debounce":
            return (0, (/*@__PURE__*/$parcel$interopDefault($86cb5c72cdcf443c$exports)))(resizeCallback, refreshRate, refreshOptions);
        case "throttle":
            return (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2ee795666c6b$exports)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $4b770f16b6b28ff6$var$isFunction = function(fn) {
    return typeof fn === "function";
};
var $4b770f16b6b28ff6$var$isSSR = function() {
    return typeof window === "undefined";
};
var $4b770f16b6b28ff6$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $4b770f16b6b28ff6$var$createNotifier = function(setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            return {
                width: width,
                height: height
            };
        });
    };
};
var $4b770f16b6b28ff6$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $4b770f16b6b28ff6$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($4b770f16b6b28ff6$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($4b770f16b6b28ff6$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $4b770f16b6b28ff6$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $4b770f16b6b28ff6$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $e4MuM.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case "renderProp":
                    return currentElement;
                case "childFunction":
                    return currentElement;
                case "child":
                    return currentElement;
                case "childArray":
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $4b770f16b6b28ff6$var$createNotifier(function(setStateFunc) {
                return _this.setState(setStateFunc, function() {
                    return onResize === null || onResize === void 0 ? void 0 : onResize(_this.state.width, _this.state.height);
                });
            }, handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$4b770f16b6b28ff6$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($4b770f16b6b28ff6$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return "renderProp";
            if ($4b770f16b6b28ff6$var$isFunction(children)) return "childFunction";
            if ((0, $6P6dz.isValidElement)(children)) return "child";
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return "childArray";
            // DEPRECATED. Use `Child Function Pattern` instead
            return "parent";
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $6P6dz.createRef)();
        _this.observableElement = null;
        if ($4b770f16b6b28ff6$var$isSSR()) return _this;
        _this.resizeHandler = $4b770f16b6b28ff6$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($4b770f16b6b28ff6$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? "div" : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        switch(renderType){
            case "renderProp":
                return render === null || render === void 0 ? void 0 : render(childProps);
            case "childFunction":
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            case "child":
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === "string") {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef;
                    var nativeProps = $4b770f16b6b28ff6$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $6P6dz.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0, $6P6dz.cloneElement)(child, childProps);
            case "childArray":
                var childArray = children;
                return childArray.map(function(el) {
                    return !!el && (0, $6P6dz.cloneElement)(el, childProps);
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $6P6dz.PureComponent));
function $4b770f16b6b28ff6$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $4b770f16b6b28ff6$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $6P6dz.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $4b770f16b6b28ff6$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement($4b770f16b6b28ff6$export$2e2bcd8739ae039, $4b770f16b6b28ff6$var$__assign({}, options, {
                targetRef: targetRef
            }), (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(ComponentInner, $4b770f16b6b28ff6$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $6P6dz.Component));
    function forwardRefWrapper(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement(ResizeDetectorHOC, $4b770f16b6b28ff6$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $6P6dz.forwardRef)(forwardRefWrapper);
}
var $4b770f16b6b28ff6$var$useEnhancedEffect = $4b770f16b6b28ff6$var$isSSR() ? (0, $6P6dz.useEffect) : (0, $6P6dz.useLayoutEffect);
function $4b770f16b6b28ff6$export$453c3d1cba18d800(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = (0, $6P6dz.useRef)(skipOnMount);
    var localRef = (0, $6P6dz.useRef)(null);
    var resizeHandler = (0, $6P6dz.useRef)();
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var _g = (0, $6P6dz.useState)({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    $4b770f16b6b28ff6$var$useEnhancedEffect(function() {
        if (!handleWidth && !handleHeight) return;
        var notifyResize = $4b770f16b6b28ff6$var$createNotifier(setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current;
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $4b770f16b6b28ff6$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) resizeObserver.observe(ref.current, observerOptions);
        return function() {
            var _a, _b;
            resizeObserver.disconnect();
            (_b = (_a = resizeHandler.current).cancel) === null || _b === void 0 || _b.call(_a);
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        observerOptions,
        ref.current
    ]);
    (0, $6P6dz.useEffect)(function() {
        onResize === null || onResize === void 0 || onResize(size.width, size.height);
    }, [
        size
    ]);
    return $4b770f16b6b28ff6$var$__assign({
        ref: ref
    }, size);
}




function $e21396ab9c556558$var$_extends() {
    $e21396ab9c556558$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e21396ab9c556558$var$_extends.apply(this, arguments);
}
function $e21396ab9c556558$var$_slicedToArray(arr, i) {
    return $e21396ab9c556558$var$_arrayWithHoles(arr) || $e21396ab9c556558$var$_iterableToArrayLimit(arr, i) || $e21396ab9c556558$var$_unsupportedIterableToArray(arr, i) || $e21396ab9c556558$var$_nonIterableRest();
}
function $e21396ab9c556558$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e21396ab9c556558$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e21396ab9c556558$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e21396ab9c556558$var$_arrayLikeToArray(o, minLen);
}
function $e21396ab9c556558$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e21396ab9c556558$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $e21396ab9c556558$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e21396ab9c556558$export$e60a4704009a0009 = /*#__PURE__*/ (0, $6P6dz.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize;
    var _useState = (0, $6P6dz.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $e21396ab9c556558$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $6P6dz.useRef)(null);
    (0, $6P6dz.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var getContainerSize = (0, $6P6dz.useCallback)(function() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    }, []);
    var updateDimensionsImmediate = (0, $6P6dz.useCallback)(function() {
        var newSize = getContainerSize();
        if (newSize) {
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (onResize) onResize(containerWidth, containerHeight);
            setSizes(function(currentSizes) {
                var oldWidth = currentSizes.containerWidth, oldHeight = currentSizes.containerHeight;
                if (containerWidth !== oldWidth || containerHeight !== oldHeight) return {
                    containerWidth: containerWidth,
                    containerHeight: containerHeight
                };
                return currentSizes;
            });
        }
    }, [
        getContainerSize,
        onResize
    ]);
    var chartContent = (0, $6P6dz.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)((0, $19512e2323c12caf$export$e50269385c77c348)(width) || (0, $19512e2323c12caf$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $19512e2323c12caf$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $19512e2323c12caf$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $7b55ee08175223e3$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $6P6dz.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    (0, $6P6dz.useEffect)(function() {
        var size = getContainerSize();
        if (size) setSizes(size);
    }, [
        getContainerSize
    ]);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $4b770f16b6b28ff6$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: updateDimensionsImmediate,
        targetRef: containerRef,
        refreshMode: debounce > 0 ? "debounce" : undefined,
        refreshRate: debounce
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("div", $e21396ab9c556558$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-responsive-container", className),
        style: style,
        ref: containerRef
    }), chartContent));
});



const $c48726348e80dbc5$var$NBSP = "\xa0";
const $c48726348e80dbc5$var$GameStats = ({ game: game })=>{
    const scoreData = (0, $6P6dz.useMemo)(()=>game.frames.map(({ score: score, outcome: outcome }, i)=>({
                name: i + 1,
                score: score,
                pins: (0, $a6962441c258f009$export$2fc09de897439556)(outcome, i === 9)
            })), [
        game
    ]);
    const stats = (0, $6P6dz.useMemo)(()=>{
        const results = {
            Pins: game.pins,
            Strikes: game.stats.strikes,
            Spares: {
                total: game.stats.spares.total,
                "single pin": game.stats.spares.single,
                "multiple pins": game.stats.spares.multiple
            }
        };
        if (game.stats.splits.total) results.Splits = `${game.stats.splits.total} ${game.stats.splits.converted ? `(${game.stats.splits.converted} converted)` : ""}`;
        if (game.stats.fouls) results.Fouls = game.stats.fouls;
        results.Misses = game.stats.misses;
        results["Avg First Ball Pinfall"] = game.stats.avgFirstBallPinfall;
        return results;
    }, [
        game
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("columns", "is-fluid"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column"),
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                    children: Object.entries(stats).map(([key, value])=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                    children: `${key}:`
                                }),
                                $c48726348e80dbc5$var$NBSP,
                                [
                                    "number",
                                    "string"
                                ].includes(typeof value) ? /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                    children: value
                                }) : /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                            children: value.total
                                        }),
                                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("ml-3", "is-size-7"),
                                            children: Object.entries(value).filter(([k])=>k !== "total").map(([k, v])=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-grey"),
                                                            children: `${k}:`
                                                        }),
                                                        $c48726348e80dbc5$var$NBSP,
                                                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                                            children: v
                                                        })
                                                    ]
                                                }, k))
                                        })
                                    ]
                                })
                            ]
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-three-fifths"),
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e21396ab9c556558$export$e60a4704009a0009), {
                    height: 175,
                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $4a93ba87c594333d$export$54d0e8420ac838ac), {
                        data: scoreData,
                        margin: {
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $b99054ee1c8100f4$export$6440e27b9f186856), {
                                strokeDasharray: "2 2"
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $73a42e140a9e1d25$export$ea77231de273b52d), {
                                dataKey: "name",
                                padding: {
                                    left: 10,
                                    right: 10
                                }
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e0b95f248e75d8a4$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Pins",
                                yAxisId: "pins",
                                orientation: "left",
                                domain: [
                                    0,
                                    10
                                ]
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e0b95f248e75d8a4$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Score",
                                yAxisId: "score",
                                orientation: "right",
                                domain: [
                                    0,
                                    30
                                ]
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $75caf721c037b42d$export$ed247974535929c7), {}),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $bcd60d8d12bfb662$export$17d680238e50603e), {
                                name: "Pins per frame",
                                type: "monotone",
                                yAxisId: "pins",
                                dataKey: "pins",
                                stroke: "#209cee"
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $bcd60d8d12bfb662$export$17d680238e50603e), {
                                name: "Score per frame",
                                type: "monotone",
                                yAxisId: "score",
                                dataKey: "score",
                                stroke: "#23d160"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $c48726348e80dbc5$export$2e2bcd8739ae039 = $c48726348e80dbc5$var$GameStats;


/* @leny/bowlstats
 *
 * /src/components/game-date.tsx
 */ 

const $f3293be3ff66996f$var$NBSP = "\xa0";
const $f3293be3ff66996f$var$GameDate = ({ date: date, showYear: showYear = false })=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mr-2"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-block", "has-background-danger", "has-text-white", "is-size-7", "px-2", "has-text-centered", "has-text-weight-semibold", "is-uppercase"),
                children: date.format("MMM")
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-block", "has-text-centered", "has-text-black", "has-text-weight-bold", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.date()
            }),
            showYear && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-block", "has-text-black", "is-size-8", "px-2", "has-text-weight-semibold", "is-uppercase", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.format("YYYY")
            })
        ]
    });
var $f3293be3ff66996f$export$2e2bcd8739ae039 = $f3293be3ff66996f$var$GameDate;



const $feb21048dd71ecac$var$NBSP = "\xa0";
const $feb21048dd71ecac$var$getBallColor = (ball)=>{
    switch(ball.slice(ball.startsWith("H") ? 1 : 0)){
        case "6":
            return "#f8362f";
        case "7":
            return "#c6c20d";
        case "8":
            return "#c81108";
        case "9":
            return "#46435a";
        case "10":
            return "#9b2527";
        case "11":
            return "#1b417d";
        case "12":
            return "#1b6626";
        case "13":
            return "#1f3c7c";
        case "14":
            return "#0aa025";
        case "15":
            return "#262b4b";
        case "16":
            return "#983d28";
        default:
            return "black";
    }
};
const $feb21048dd71ecac$var$Game = ({ game: game, isBest: isBest, isWorst: isWorst, showYear: showYear = false })=>{
    const [showDetails, setShowDetails] = (0, $6P6dz.useState)(false);
    const date = (0, $6P6dz.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6ba96707cbb0ec33$exports)))(new Date(game.date.year, game.date.month - 1, game.date.day)), [
        game
    ]);
    const toggleDetails = (0, $6P6dz.useCallback)(()=>{
        setShowDetails(!showDetails);
    }, [
        showDetails
    ]);
    const $date = /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $f3293be3ff66996f$export$2e2bcd8739ae039), {
        date: date,
        showYear: showYear
    });
    if (!showDetails) return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "is-flex", "is-justify-content-space-between", "is-align-content-center", "px-5", "is-unselectable", "is-clickable"),
        onClick: toggleDetails,
        children: [
            $date,
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames,
                compact: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "px-5"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex", "mb-3", "is-justify-content-space-between", "is-align-content-center"),
                children: [
                    $date,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex", "is-relative", "is-justify-content-center", "is-align-items-center", "has-text-weight-bold", "is-family-secondary", "is-size-5", "has-text-white"),
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: "100%",
                            backgroundColor: $feb21048dd71ecac$var$getBallColor(game.ball)
                        },
                        "data-tooltip": `Played with ${game.ball.slice(game.ball.startsWith("H") ? 1 : 0)}lbs ball ${game.ball.startsWith("H") ? "(house ball)" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-block"),
                                children: game.ball.slice(game.ball.startsWith("H") ? 1 : 0)
                            }),
                            game.ball.startsWith("H") && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-light"),
                                style: {
                                    position: "absolute",
                                    bottom: -1,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    fontSize: 9
                                },
                                children: "H"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("button", {
                        type: "button",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("delete"),
                        onClick: toggleDetails,
                        children: "(hide details)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))(game.note ? "mb-1" : "mb-3"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                        children: "Lane Oil Pattern:"
                    }),
                    $feb21048dd71ecac$var$NBSP,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-italic"),
                        children: game.oilPattern || "none/dry"
                    })
                ]
            }),
            game.note && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-3"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    $feb21048dd71ecac$var$NBSP,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-italic"),
                        children: game.note
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $c48726348e80dbc5$export$2e2bcd8739ae039), {
                game: game
            })
        ]
    });
};
var $feb21048dd71ecac$export$2e2bcd8739ae039 = $feb21048dd71ecac$var$Game;



const $02f9a7873cc13bf6$var$NBSP = "\xa0";
const $02f9a7873cc13bf6$var$Games = ()=>{
    const { games: games, filters: filters, stats: stats } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const [reverseOrder, setReverseOrder] = (0, $6P6dz.useState)(true);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "is-flex", "is-flex-direction-row", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("span", {
                        children: [
                            "Games",
                            $02f9a7873cc13bf6$var$NBSP,
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("small", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-7", "is-va-middle", "has-text-grey"),
                                children: `(${games.length})`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-7", "is-va-middle"),
                        href: "#",
                        onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                            setReverseOrder(!reverseOrder);
                        }),
                        children: "(⇅ reverse order)"
                    })
                ]
            }),
            (reverseOrder ? Array.from(games).reverse() : games).map((game, i)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $feb21048dd71ecac$export$2e2bcd8739ae039), {
                    game: game,
                    isBest: stats.avg.best === game.score,
                    isWorst: stats.avg.worst === game.score,
                    showYear: filters.year === null
                }, `${Object.values(game.date).join("-")}-${i}`))
        ]
    });
};
var $02f9a7873cc13bf6$export$2e2bcd8739ae039 = $02f9a7873cc13bf6$var$Games;


/* @leny/bowlstats
 *
 * /src/components/graphs/index.tsx
 */ 
/* @leny/bowlstats
 *
 * /src/components/graphs/score.tsx
 */ 


var $6P6dz = parcelRequire("6P6dz");
/* @leny/bowlstats
 *
 * /src/components/graphs/base.tsx
 */ 
/**
 * @fileOverview Composed Chart
 */ 








var $6P6dz = parcelRequire("6P6dz");










var $e038eac5e04b6e40$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
function $e038eac5e04b6e40$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e038eac5e04b6e40$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e038eac5e04b6e40$var$_typeof(obj);
}
function $e038eac5e04b6e40$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e038eac5e04b6e40$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e038eac5e04b6e40$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e038eac5e04b6e40$var$_extends() {
    $e038eac5e04b6e40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e038eac5e04b6e40$var$_extends.apply(this, arguments);
}
function $e038eac5e04b6e40$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e038eac5e04b6e40$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e038eac5e04b6e40$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e038eac5e04b6e40$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e038eac5e04b6e40$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e038eac5e04b6e40$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e038eac5e04b6e40$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e038eac5e04b6e40$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e038eac5e04b6e40$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e038eac5e04b6e40$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e038eac5e04b6e40$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e038eac5e04b6e40$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e038eac5e04b6e40$var$_setPrototypeOf(subClass, superClass);
}
function $e038eac5e04b6e40$var$_setPrototypeOf(o, p) {
    $e038eac5e04b6e40$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e038eac5e04b6e40$var$_setPrototypeOf(o, p);
}
function $e038eac5e04b6e40$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e038eac5e04b6e40$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e038eac5e04b6e40$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e038eac5e04b6e40$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e038eac5e04b6e40$var$_possibleConstructorReturn(this, result);
    };
}
function $e038eac5e04b6e40$var$_possibleConstructorReturn(self, call) {
    if (call && ($e038eac5e04b6e40$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e038eac5e04b6e40$var$_assertThisInitialized(self);
}
function $e038eac5e04b6e40$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e038eac5e04b6e40$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e038eac5e04b6e40$var$_getPrototypeOf(o) {
    $e038eac5e04b6e40$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e038eac5e04b6e40$var$_getPrototypeOf(o);
}
function $e038eac5e04b6e40$var$_defineProperty(obj, key, value) {
    key = $e038eac5e04b6e40$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e038eac5e04b6e40$var$_toPropertyKey(arg) {
    var key = $e038eac5e04b6e40$var$_toPrimitive(arg, "string");
    return $e038eac5e04b6e40$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e038eac5e04b6e40$var$_toPrimitive(input, hint) {
    if ($e038eac5e04b6e40$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e038eac5e04b6e40$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e038eac5e04b6e40$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $e038eac5e04b6e40$var$_inherits(Area, _PureComponent);
    var _super = $e038eac5e04b6e40$var$_createSuper(Area);
    function Area() {
        var _this;
        $e038eac5e04b6e40$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$var$_assertThisInitialized(_this), "id", (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts-area-"));
        $e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $e038eac5e04b6e40$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $e038eac5e04b6e40$var$_objectSpread($e038eac5e04b6e40$var$_objectSpread($e038eac5e04b6e40$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $e038eac5e04b6e40$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($9d5a2fa82ce5432d$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $e038eac5e04b6e40$var$_objectWithoutProperties(_this$props4, $e038eac5e04b6e40$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $45580be9bbfd5120$export$b0e83c3ef8d2db1), $e038eac5e04b6e40$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $45580be9bbfd5120$export$b0e83c3ef8d2db1), $e038eac5e04b6e40$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $45580be9bbfd5120$export$b0e83c3ef8d2db1), $e038eac5e04b6e40$var$_extends({}, (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $e038eac5e04b6e40$var$_objectSpread($e038eac5e04b6e40$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($5f1f16daeeac326f$exports)))(baseLine)) {
                            var _interpolator = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $e038eac5e04b6e40$var$_objectSpread($e038eac5e04b6e40$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-area", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $57ab65d6d53325f9$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $24933d61ea3e47f1$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $6P6dz.PureComponent));
$e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$export$ea1a111407f37557, "displayName", "Area");
$e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$export$ea1a111407f37557, "defaultProps", {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
});
$e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $19512e2323c12caf$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return min;
        if (baseValue === "dataMax") return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
});
$e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $e038eac5e04b6e40$export$ea1a111407f37557.getBaseValue(props, item, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($d14e2831379630a0$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(originalValue);
        if (layout === "horizontal") return {
            x: (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === "horizontal") return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, "value[0]")) && !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, "y")) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, "value[0]")) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, "value[0]")) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($2b6f98500218915a$exports)))(entry, "value[0]")) : null,
            y: entry.y
        };
    });
    else if (layout === "horizontal") baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $e038eac5e04b6e40$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$e038eac5e04b6e40$var$_defineProperty($e038eac5e04b6e40$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $5a9ccb48149eca10$export$d046b3c4a416f60d), $e038eac5e04b6e40$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});








var $6P6dz = parcelRequire("6P6dz");






/**
 * @fileOverview Z Axis
 */ var $8fef643809dccb91$export$2363a7fa7edfe988 = function ZAxis() {
    return null;
};
$8fef643809dccb91$export$2363a7fa7edfe988.displayName = "ZAxis";
$8fef643809dccb91$export$2363a7fa7edfe988.defaultProps = {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: "auto",
    type: "number"
};









function $7bf379cf4c6a6961$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7bf379cf4c6a6961$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7bf379cf4c6a6961$var$_typeof(obj);
}
function $7bf379cf4c6a6961$var$_extends() {
    $7bf379cf4c6a6961$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7bf379cf4c6a6961$var$_extends.apply(this, arguments);
}
function $7bf379cf4c6a6961$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7bf379cf4c6a6961$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7bf379cf4c6a6961$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7bf379cf4c6a6961$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7bf379cf4c6a6961$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7bf379cf4c6a6961$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7bf379cf4c6a6961$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7bf379cf4c6a6961$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7bf379cf4c6a6961$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7bf379cf4c6a6961$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7bf379cf4c6a6961$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7bf379cf4c6a6961$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7bf379cf4c6a6961$var$_setPrototypeOf(subClass, superClass);
}
function $7bf379cf4c6a6961$var$_setPrototypeOf(o, p) {
    $7bf379cf4c6a6961$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7bf379cf4c6a6961$var$_setPrototypeOf(o, p);
}
function $7bf379cf4c6a6961$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7bf379cf4c6a6961$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7bf379cf4c6a6961$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7bf379cf4c6a6961$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7bf379cf4c6a6961$var$_possibleConstructorReturn(this, result);
    };
}
function $7bf379cf4c6a6961$var$_possibleConstructorReturn(self, call) {
    if (call && ($7bf379cf4c6a6961$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7bf379cf4c6a6961$var$_assertThisInitialized(self);
}
function $7bf379cf4c6a6961$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7bf379cf4c6a6961$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7bf379cf4c6a6961$var$_getPrototypeOf(o) {
    $7bf379cf4c6a6961$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7bf379cf4c6a6961$var$_getPrototypeOf(o);
}
function $7bf379cf4c6a6961$var$_defineProperty(obj, key, value) {
    key = $7bf379cf4c6a6961$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7bf379cf4c6a6961$var$_toPropertyKey(arg) {
    var key = $7bf379cf4c6a6961$var$_toPrimitive(arg, "string");
    return $7bf379cf4c6a6961$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7bf379cf4c6a6961$var$_toPrimitive(input, hint) {
    if ($7bf379cf4c6a6961$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7bf379cf4c6a6961$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7bf379cf4c6a6961$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    $7bf379cf4c6a6961$var$_inherits(Scatter, _PureComponent);
    var _super = $7bf379cf4c6a6961$var$_createSuper(Scatter);
    function Scatter() {
        var _this;
        $7bf379cf4c6a6961$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$var$_assertThisInitialized(_this), "id", (0, $19512e2323c12caf$export$8b15d37bc3f197d4)("recharts-scatter-"));
        return _this;
    }
    $7bf379cf4c6a6961$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                return points.map(function(entry, i) {
                    var props = $7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread({
                        key: "symbol-".concat(i)
                    }, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), $7bf379cf4c6a6961$var$_extends({
                        className: "recharts-scatter-symbol"
                    }, (0, $f237646aefb1d4cb$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        role: "img"
                    }), Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $df4da97760c8f167$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $19512e2323c12caf$export$d871d53bd7eeb390)(0, entry.size);
                        return $7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($0c1e8ce01c84240a$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(children, (0, $8e3ea38b9023e0e3$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var direction = item.props.direction;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(item, {
                        key: i,
                        // eslint-disable-line react/no-array-index-key
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === "x" ? "vertical" : "horizontal",
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === "x" ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $30c733ceebebab59$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(this.props);
                var customLineProps = (0, $57ab65d6d53325f9$export$d697c39a2985a4c)(line);
                var linePoints, lineItem;
                if (lineType === "joint") linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === "fitting") {
                    var _getLinearRegression = (0, $19512e2323c12caf$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread({}, scatterProps), {}, {
                    fill: "none",
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $45580be9bbfd5120$export$b0e83c3ef8d2db1), $7bf379cf4c6a6961$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("recharts-scatter", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $01d8ac5908bec9bc$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $24933d61ea3e47f1$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "renderSymbolItem",
            value: function renderSymbolItem(option, props) {
                var symbol;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).isValidElement(option)) symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($781ef3fa3ce926da$exports)))(option)) symbol = option(props);
                else if (typeof option === "string") symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6P6dz))).createElement((0, $a6d9235bb0fc9a40$export$fa456266707bf4e4), $7bf379cf4c6a6961$var$_extends({}, props, {
                    type: option
                }));
                return symbol;
            }
        }
    ]);
    return Scatter;
}((0, $6P6dz.PureComponent));
$7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$export$1c460fb4285edadc, "displayName", "Scatter");
$7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: "circle",
    lineType: "joint",
    lineJointType: "linear",
    data: [],
    shape: "circle",
    hide: false,
    isAnimationActive: !(0, $081f9655fb2f2af0$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "linear"
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $7bf379cf4c6a6961$var$_defineProperty($7bf379cf4c6a6961$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $57ab65d6d53325f9$export$fdd5e64c0e8495bb)(item.props.children, (0, $eb16b70c73624ca5$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $8fef643809dccb91$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(zAxisDataKey) && (0, $30c733ceebebab59$export$f97fc4a450f29a)(entry, zAxisDataKey) || "-";
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || "",
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($20cbac382dae119e$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || "",
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== "-") tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || "",
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $30c733ceebebab59$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== "-" ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $7bf379cf4c6a6961$var$_objectSpread($7bf379cf4c6a6961$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $7bf379cf4c6a6961$var$_objectSpread({
        points: points
    }, offset);
});






var $b29b9dde3dc6509d$export$f881f4f9e4007a57 = (0, $d1f36bdabf648b21$export$77871aede60e6838)({
    chartName: "ComposedChart",
    GraphicalChild: [
        (0, $bcd60d8d12bfb662$export$17d680238e50603e),
        (0, $e038eac5e04b6e40$export$ea1a111407f37557),
        (0, $014af52e527fc085$export$bbc6c6369b38e3d1),
        (0, $7bf379cf4c6a6961$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $73a42e140a9e1d25$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $e0b95f248e75d8a4$export$f96c4024c52de8f4)
        },
        {
            axisType: "zAxis",
            AxisComp: (0, $8fef643809dccb91$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $6908f2be6e0983bb$export$ece7de1383db5ac)
});


const $ae12be518f56504e$var$BaseGraph = ({ data: data, axisId: axisId, axisLabel: axisLabel, domain: domain, padding: padding, referenceLine: referenceLine, hideBall: hideBall = false })=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e21396ab9c556558$export$e60a4704009a0009), {
        width: "100%",
        height: 350,
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $b29b9dde3dc6509d$export$f881f4f9e4007a57), {
            width: 500,
            height: 500,
            data: data,
            margin: {
                top: 10,
                right: 5,
                left: 0,
                bottom: 5
            },
            children: [
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $b99054ee1c8100f4$export$6440e27b9f186856), {
                    strokeDasharray: "2 2"
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $75caf721c037b42d$export$ed247974535929c7), {}),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $73a42e140a9e1d25$export$ea77231de273b52d), {
                    dataKey: "name",
                    padding: {
                        left: 20,
                        right: 20
                    }
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e0b95f248e75d8a4$export$f96c4024c52de8f4), {
                    yAxisId: axisId,
                    domain: domain,
                    interval: "equidistantPreserveStart",
                    orientation: "left",
                    padding: padding
                }),
                referenceLine && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $bc8cdd9bc6426677$export$b2f28e248e7838eb), {
                    yAxisId: axisId,
                    y: referenceLine,
                    stroke: "#257942"
                }),
                !hideBall && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $e0b95f248e75d8a4$export$f96c4024c52de8f4), {
                            yAxisId: "ball",
                            domain: [
                                6,
                                16
                            ],
                            orientation: "right",
                            tickCount: 6
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $014af52e527fc085$export$bbc6c6369b38e3d1), {
                            name: "Ball Weight",
                            dataKey: "ball",
                            yAxisId: "ball",
                            barSize: 20,
                            fill: "#33993366",
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $24933d61ea3e47f1$export$835fcf23ab7bf88), {
                                dataKey: "ball",
                                position: "insideBottom"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $bcd60d8d12bfb662$export$17d680238e50603e), {
                    name: "Average",
                    type: "monotone",
                    dataKey: "avg",
                    yAxisId: axisId,
                    stroke: "#ff3860",
                    dot: false
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $bcd60d8d12bfb662$export$17d680238e50603e), {
                    name: axisLabel,
                    type: "monotone",
                    dataKey: axisId,
                    yAxisId: axisId,
                    stroke: "#209cee"
                })
            ]
        })
    });
var $ae12be518f56504e$export$2e2bcd8739ae039 = $ae12be518f56504e$var$BaseGraph;



const $1326d3f4a86a8706$var$ScoreGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const { stats: { avg: { best: best, worst: worst } } } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const data = (0, $6P6dz.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                score: game.score,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.score : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle"),
                children: "Score"
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Score per game",
                axisId: "score",
                domain: [
                    Math.max(0, worst),
                    Math.min(300, best)
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $1326d3f4a86a8706$export$2e2bcd8739ae039 = $1326d3f4a86a8706$var$ScoreGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/strikes.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");


const $82ccdbc8de77544d$var$StrikesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $6P6dz.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                strikes: game.stats.strikes,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.strikes : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "mt-5"),
                children: "Strikes"
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Strikes per game",
                axisId: "strikes",
                domain: [
                    0,
                    12
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $82ccdbc8de77544d$export$2e2bcd8739ae039 = $82ccdbc8de77544d$var$StrikesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/spares.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");


const $39cce9dfb40ebdd3$var$SparesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $6P6dz.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                spares: game.stats.spares.total,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.spares.total : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "mt-5"),
                children: "Spares"
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Spares per game",
                axisId: "spares",
                domain: [
                    0,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $39cce9dfb40ebdd3$export$2e2bcd8739ae039 = $39cce9dfb40ebdd3$var$SparesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/avg-first-ball-pinfall.tsx
 */ 

var $6P6dz = parcelRequire("6P6dz");


const $7a6799eb5c22ef7d$var$AvgFirstBallPinfallGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const data = (0, $6P6dz.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                afbp: game.stats.avgFirstBallPinfall,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.avgFirstBallPinfall : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "mt-5"),
                children: "Average First Ball Pinfall"
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $ae12be518f56504e$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Avg First Ball Pinfall",
                axisId: "afbp",
                domain: [
                    3,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $7a6799eb5c22ef7d$export$2e2bcd8739ae039 = $7a6799eb5c22ef7d$var$AvgFirstBallPinfallGraph;




const $97746599f7bd9693$var$NBSP = "\xa0";
const $97746599f7bd9693$var$Graphs = ()=>{
    const { games: games } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)((0, $ff8694b5d09eadad$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $1326d3f4a86a8706$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgScorePerGame
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $7a6799eb5c22ef7d$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($d3298d1f5bb4b7c6$exports))).goals.avgFirstBallPinfall
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $82ccdbc8de77544d$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $39cce9dfb40ebdd3$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            })
        ]
    });
};
var $97746599f7bd9693$export$2e2bcd8739ae039 = $97746599f7bd9693$var$Graphs;



const $59c24c5bc192cdb1$var$GamesContainer = ()=>{
    const [year, setYear] = (0, $6P6dz.useState)(null);
    const [month, setMonth] = (0, $6P6dz.useState)(null);
    const [day, setDay] = (0, $6P6dz.useState)(null);
    const [withHouseBallGames, setWithHouseBallGames] = (0, $6P6dz.useState)(false);
    const [withDryLaneGames, setWithDryLaneGames] = (0, $6P6dz.useState)(false);
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $7b5212127b697ff5$export$b514f4c5cf6dd8e6), {
        value: (0, $7b5212127b697ff5$export$431f78a03a8ddc84)(year, month, day, withHouseBallGames, withDryLaneGames),
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero-body"),
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("title", "is-size-3"),
                                children: "Games"
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "is-size-5", "has-text-grey"),
                                children: "All the games I played, regardless of context."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("section", "pt-1"),
                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $af6a744d86cd9c4a$export$2e2bcd8739ae039), {
                        year: year,
                        month: month,
                        day: day,
                        withHouseBallGames: withHouseBallGames,
                        withDryLaneGames: withDryLaneGames,
                        onYearChange: (y)=>{
                            setYear(y);
                        },
                        onMonthChange: (m)=>{
                            setMonth(m);
                        },
                        onDayChange: (d)=>{
                            setDay(d);
                        },
                        toggleHouseBallGames: (b)=>{
                            setWithHouseBallGames(b);
                        },
                        toggleDryLaneGames: (b)=>{
                            setWithDryLaneGames(b);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("section"),
                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $d1d8966ef2294ff3$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("section", "columns"),
                    children: [
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column"),
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $02f9a7873cc13bf6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column"),
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $97746599f7bd9693$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
};
var $59c24c5bc192cdb1$export$2e2bcd8739ae039 = $59c24c5bc192cdb1$var$GamesContainer;


/* @leny/bowlstats
 *
 * /src/containers/leagues.tsx
 */ 


/* @leny/bowlstats
 *
 * /src/components/leagues.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $6P6dz = parcelRequire("6P6dz");



/* @leny/bowlstats
 *
 * /src/components/league-day.tsx
 */ 




var $6P6dz = parcelRequire("6P6dz");

const $a1bcaa7379a44d59$var$NBSP = "\xa0";
const $a1bcaa7379a44d59$var$LeagueDay = ({ day: day })=>{
    const date = (0, $6P6dz.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6ba96707cbb0ec33$exports)))(new Date(day.date.year, day.date.month - 1, day.date.day)), [
        day
    ]);
    const $date = /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $f3293be3ff66996f$export$2e2bcd8739ae039), {
        date: date,
        showYear: true
    });
    const $dayTitle = /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("columns", "mb-2"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-one-fifth"),
                children: [
                    "Day",
                    $a1bcaa7379a44d59$var$NBSP,
                    day.dayIndex
                ]
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("h5", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-flex", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                        children: day.team
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-7", "has-text-grey"),
                        children: "vs"
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                        children: day.vs
                    })
                ]
            })
        ]
    });
    if (day.bye) return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-italic", "has-text-centered", "my-5"),
                        children: "bye"
                    }),
                    day.note && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $a1bcaa7379a44d59$var$NBSP,
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ol", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-no-list"),
                        children: day.games.map((game, idx)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("li", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-2"),
                                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $9ea79497e4749eac$export$2e2bcd8739ae039), {
                                    scratch: game.scratch,
                                    handicap: game.handicap,
                                    score: game.score,
                                    frames: game.frames,
                                    hideHeader: idx > 0
                                })
                            }, game.id))
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-grey"),
                                        children: `Oil patterns (left, right):`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                        children: day.oilPatterns.join(", ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-grey"),
                                        children: `Average:`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                        children: day.avg
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-grey"),
                                        children: `Handicap:`
                                    }),
                                    $a1bcaa7379a44d59$var$NBSP,
                                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                        children: day.handicap
                                    })
                                ]
                            })
                        ]
                    }),
                    day.note && /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $a1bcaa7379a44d59$var$NBSP,
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a1bcaa7379a44d59$export$2e2bcd8739ae039 = $a1bcaa7379a44d59$var$LeagueDay;


const $0f9404ff1097dea7$var$Leagues = ()=>{
    const { leagues: leagues } = (0, $2cbc9a738009361c$export$c1cf1cf4c5d51937)();
    const [selectedLeague, setSelectedLeague] = (0, $6P6dz.useState)(leagues[0]);
    if (!leagues.length) return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("section", "py-6"),
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("has-text-centered", "has-text-grey", "my-6", "py-6"),
            children: "No leagues yet."
        })
    });
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("section", "columns", "pt-1"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-one-fifth"),
                children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("pt-6"),
                    children: leagues.map((league)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("li", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("mb-2"),
                            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("button", "is-fullwidth", selectedLeague.name === league.name && "is-primary"),
                                onClick: (0, $a6962441c258f009$export$fa3b29edae795ef4)(()=>{
                                    setSelectedLeague(league);
                                }),
                                children: league.name
                            })
                        }, league.name))
                })
            }),
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("column", "is-three-fifths"),
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h4", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("is-size-4", "mb-4"),
                        children: selectedLeague.name
                    }),
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
                        children: Array.from(selectedLeague.days).reverse().map((day, index)=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $a1bcaa7379a44d59$export$2e2bcd8739ae039), {
                                day: day
                            }, `league-${selectedLeague.name}-day-${day}-idx-${index}`))
                    })
                ]
            })
        ]
    });
};
var $0f9404ff1097dea7$export$2e2bcd8739ae039 = $0f9404ff1097dea7$var$Leagues;


const $36087b6da2c23874$var$LeaguesContainer = ()=>{
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $7b5212127b697ff5$export$b514f4c5cf6dd8e6), {
        value: (0, $7b5212127b697ff5$export$431f78a03a8ddc84)(),
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("hero-body"),
                        children: [
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h3", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("title", "is-size-3"),
                                children: "Leagues"
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("subtitle", "is-size-5", "has-text-grey"),
                                children: "Records of my league nights."
                            }),
                            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("p", {
                                children: "Those records are only my scores, and not the whole team's."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $0f9404ff1097dea7$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $36087b6da2c23874$export$2e2bcd8739ae039 = $36087b6da2c23874$var$LeaguesContainer;


/* @leny/bowlstats
 *
 * /src/components/footer.tsx
 */ 

const $a9b762fc9098935a$var$BSP = " ";
const $a9b762fc9098935a$var$Footer = ()=>/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("footer", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("footer", "mt-6", "pb-6"),
        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("content", "has-text-centered"),
            children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                        href: "https://github.com/leny/bowlstats",
                        target: "_new",
                        children: /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("strong", {
                            children: "bowlstats"
                        })
                    }),
                    $a9b762fc9098935a$var$BSP,
                    "by",
                    $a9b762fc9098935a$var$BSP,
                    /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)("a", {
                        href: "https://leny.me",
                        target: "_new",
                        children: "leny"
                    })
                ]
            })
        })
    });
var $a9b762fc9098935a$export$2e2bcd8739ae039 = $a9b762fc9098935a$var$Footer;


const $40aa2f7a1bc2f665$var$RootContainer = ()=>{
    const [mode, setMode] = (0, $6P6dz.useState)("games");
    const $content = mode === "games" ? /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $59c24c5bc192cdb1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $36087b6da2c23874$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c2acff49efc73e03$exports)))("container", "is-fluid", "px-0"),
        children: [
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $a59ed6e022fedf74$export$2e2bcd8739ae039), {
                mode: mode,
                onChangeMode: (v)=>{
                    setMode(v);
                }
            }),
            $content,
            /*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $a9b762fc9098935a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $40aa2f7a1bc2f665$export$2e2bcd8739ae039 = $40aa2f7a1bc2f665$var$RootContainer;


const $9b561ab6dfb0f536$var$container = document.querySelector("#root");
(0, $08e8df0f66738cf4$export$882461b6382ed46c)($9b561ab6dfb0f536$var$container).render(/*#__PURE__*/ (0, $ff8694b5d09eadad$exports.jsx)((0, $40aa2f7a1bc2f665$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.64a07951.js.map
